
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire59d8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire59d8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.6";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.6" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.6";

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $f0adbefb2a0719e1$var$useEvent = (callback)=>{
    const fnRef = $acw62.useRef(callback);
    fnRef.current = callback;
    const memoFn = $acw62.useCallback((...args)=>fnRef.current?.(...args), []);
    return memoFn;
};
var $f0adbefb2a0719e1$export$2e2bcd8739ae039 = $f0adbefb2a0719e1$var$useEvent;




var $acw62 = parcelRequire("acw62");
function $3c4e22d7f3adf1ca$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const $a55cdd4bafb2a6e7$var$useInternalLayoutEffect = (0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
const $a55cdd4bafb2a6e7$var$useLayoutEffect = (callback, deps)=>{
    const firstMountRef = $acw62.useRef(true);
    $a55cdd4bafb2a6e7$var$useInternalLayoutEffect(()=>{
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $a55cdd4bafb2a6e7$var$useInternalLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};
const $a55cdd4bafb2a6e7$export$9283e56bae2f7b0f = (callback, deps)=>{
    $a55cdd4bafb2a6e7$var$useLayoutEffect((firstMount)=>{
        if (!firstMount) return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
var $a55cdd4bafb2a6e7$export$2e2bcd8739ae039 = $a55cdd4bafb2a6e7$var$useLayoutEffect;



var $acw62 = parcelRequire("acw62");
/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */ const $78d8437484dce30d$var$useSafeState = (defaultValue)=>{
    const destroyRef = $acw62.useRef(false);
    const [value, setValue] = $acw62.useState(defaultValue);
    $acw62.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
};
var $78d8437484dce30d$export$2e2bcd8739ae039 = $78d8437484dce30d$var$useSafeState;


/** We only think `undefined` is empty */ function $37baa0e43717019e$var$hasValue(value) {
    return value !== undefined;
}
function $37baa0e43717019e$export$2e2bcd8739ae039(defaultStateValue, option) {
    const { defaultValue: defaultValue, value: value, onChange: onChange, postState: postState } = option || {};
    // ======================= Init =======================
    const [innerValue, setInnerValue] = (0, $78d8437484dce30d$export$2e2bcd8739ae039)(()=>{
        if ($37baa0e43717019e$var$hasValue(value)) return value;
        else if ($37baa0e43717019e$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    });
    const mergedValue = value !== undefined ? value : innerValue;
    const postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    const onChangeFn = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(onChange);
    const [prevValue, setPrevValue] = (0, $78d8437484dce30d$export$2e2bcd8739ae039)([
        mergedValue
    ]);
    (0, $a55cdd4bafb2a6e7$export$9283e56bae2f7b0f)(()=>{
        const prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $a55cdd4bafb2a6e7$export$9283e56bae2f7b0f)(()=>{
        if (!$37baa0e43717019e$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    const triggerChange = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((updater, ignoreDestroy)=>{
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



var $acw62 = parcelRequire("acw62");

function $fd8de6f917b208f4$export$2e2bcd8739ae039(defaultStateValue, value) {
    const [innerValue, setInnerValue] = (0, $acw62.useState)(defaultStateValue);
    const mergedValue = value !== undefined ? value : innerValue;
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)((mount)=>{
        if (!mount) setInnerValue(value);
    }, [
        value
    ]);
    return [
        // Value
        mergedValue,
        // Update function
        setInnerValue
    ];
}



var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));



var $acw62 = parcelRequire("acw62");
function $194bfd19ce5ffd07$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    const cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


const $027fe2ea3b0721af$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
const $027fe2ea3b0721af$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
const $027fe2ea3b0721af$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $027fe2ea3b0721af$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && typeof object === 'object' && // React Element type
    (object.$$typeof === $027fe2ea3b0721af$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $027fe2ea3b0721af$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $027fe2ea3b0721af$var$REACT_FRAGMENT_TYPE);
}


const $6c628207f5089a39$var$ReactMajorVersion = Number((0, $acw62.version).split('.')[0]);
const $6c628207f5089a39$export$f17fd18fa51dcb5b = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (typeof ref === 'object' && ref && 'current' in ref) ref.current = node;
};
const $6c628207f5089a39$export$ab452c34e8e05029 = (...refs)=>{
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return (node)=>{
        refs.forEach((ref)=>{
            $6c628207f5089a39$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
const $6c628207f5089a39$export$1d1c999670a1285d = (...refs)=>{
    return (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>$6c628207f5089a39$export$ab452c34e8e05029(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs, (prev, next)=>prev.length !== next.length || prev.every((ref, i)=>ref !== next[i]));
};
const $6c628207f5089a39$export$c1cec34af06bcf7 = (nodeOrComponent)=>{
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($6c628207f5089a39$var$isReactElement(nodeOrComponent) && $6c628207f5089a39$var$ReactMajorVersion >= 19) return true;
    const type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !type.prototype?.render && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !nodeOrComponent.prototype?.render && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $6c628207f5089a39$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $027fe2ea3b0721af$export$2e2bcd8739ae039)(node);
}
const $6c628207f5089a39$export$b51ae67c7882a242 = (node)=>{
    return $6c628207f5089a39$var$isReactElement(node) && $6c628207f5089a39$export$c1cec34af06bcf7(node);
};
const $6c628207f5089a39$export$7465e5c0bf44f19a = (node)=>{
    if (node && $6c628207f5089a39$var$isReactElement(node)) {
        const ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};


function $eb076c0d42f576f6$export$2e2bcd8739ae039(entity, path) {
    let current = entity;
    for(let i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}



function $4ee33241e7a6f41e$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    const [path, ...restPath] = paths;
    let clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = [
        ...entity
    ];
    else clone = {
        ...entity
    };
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $4ee33241e7a6f41e$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4ee33241e7a6f41e$export$2e2bcd8739ae039(entity, paths, value, removeIfUndefined = false) {
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $4ee33241e7a6f41e$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4ee33241e7a6f41e$var$isObject(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4ee33241e7a6f41e$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
const $4ee33241e7a6f41e$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $4ee33241e7a6f41e$export$2ee76fde9ffe109d(sources, config = {}) {
    const { prepareArray: prepareArray } = config;
    const finalPrepareArray = prepareArray || (()=>[]);
    let clone = $4ee33241e7a6f41e$var$createEmpty(sources[0]);
    sources.forEach((src)=>{
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(src, path);
            const isArr = Array.isArray(value);
            if (isArr || $4ee33241e7a6f41e$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4ee33241e7a6f41e$export$2e2bcd8739ae039(clone, path, finalPrepareArray(originValue, value));
                    else if (!originValue || typeof originValue !== 'object') // Init container if not exist
                    clone = $4ee33241e7a6f41e$export$2e2bcd8739ae039(clone, path, $4ee33241e7a6f41e$var$createEmpty(value));
                    $4ee33241e7a6f41e$var$keys(value).forEach((key)=>{
                        if (Object.getOwnPropertyDescriptor(value, key).enumerable) internalMerge([
                            ...path,
                            key
                        ], loopSet);
                    });
                }
            } else clone = $4ee33241e7a6f41e$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}
function $4ee33241e7a6f41e$export$4950aa0f605343fb(...sources) {
    return $4ee33241e7a6f41e$export$2ee76fde9ffe109d(sources);
}


/* eslint-disable no-console */ let $3ef2f9e39800a1a1$var$warned = {};
const $3ef2f9e39800a1a1$var$preWarningFns = [];
const $3ef2f9e39800a1a1$export$61616f168f0e5a05 = (fn)=>{
    $3ef2f9e39800a1a1$var$preWarningFns.push(fn);
};
function $3ef2f9e39800a1a1$export$491112666e282270(valid, message) {}
function $3ef2f9e39800a1a1$export$a92e4c44d367d0af(valid, message) {}
function $3ef2f9e39800a1a1$export$60eef1277fe463e4() {
    $3ef2f9e39800a1a1$var$warned = {};
}
function $3ef2f9e39800a1a1$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$3ef2f9e39800a1a1$var$warned[message]) {
        method(false, message);
        $3ef2f9e39800a1a1$var$warned[message] = true;
    }
}
function $3ef2f9e39800a1a1$export$82934adf09101657(valid, message) {
    $3ef2f9e39800a1a1$export$848feb93d8f32b9b($3ef2f9e39800a1a1$export$491112666e282270, valid, message);
}
function $3ef2f9e39800a1a1$export$89ff31684837bbbf(valid, message) {
    $3ef2f9e39800a1a1$export$848feb93d8f32b9b($3ef2f9e39800a1a1$export$a92e4c44d367d0af, valid, message);
}
$3ef2f9e39800a1a1$export$82934adf09101657.preMessage = $3ef2f9e39800a1a1$export$61616f168f0e5a05;
$3ef2f9e39800a1a1$export$82934adf09101657.resetWarned = $3ef2f9e39800a1a1$export$60eef1277fe463e4;
$3ef2f9e39800a1a1$export$82934adf09101657.noteOnce = $3ef2f9e39800a1a1$export$89ff31684837bbbf;
var $3ef2f9e39800a1a1$export$2e2bcd8739ae039 = $3ef2f9e39800a1a1$export$82934adf09101657;


function $cdfb578fac308710$export$2e2bcd8739ae039(obj, fields) {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach((key)=>{
        delete clone[key];
    });
    return clone;
}




var $acw62 = parcelRequire("acw62");
function $cab716a99a2efd5f$export$2e2bcd8739ae039(children, option = {}) {
    let ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($cab716a99a2efd5f$export$2e2bcd8739ae039(child));
        else if ((0, $027fe2ea3b0721af$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($cab716a99a2efd5f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


/**
 * Merges multiple props objects into one. Unlike `Object.assign()` or `{ ...a, ...b }`, it skips
 * properties whose value is explicitly set to `undefined`.
 */ function $209c328bcee38d6e$var$mergeProps(...items) {
    const ret = {};
    for (const item of items)if (item) {
        for (const key of Object.keys(item))if (item[key] !== undefined) ret[key] = item[key];
    }
    return ret;
}
var $209c328bcee38d6e$export$2e2bcd8739ae039 = $209c328bcee38d6e$var$mergeProps;




function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;



function $c8b027ba93bf289e$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


const $0d6d009b0876809a$var$APPEND_ORDER = 'data-rc-order';
const $0d6d009b0876809a$var$APPEND_PRIORITY = 'data-rc-priority';
const $0d6d009b0876809a$var$MARK_KEY = `rc-util-key`;
const $0d6d009b0876809a$var$containerCache = new Map();
function $0d6d009b0876809a$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $0d6d009b0876809a$var$MARK_KEY;
}
function $0d6d009b0876809a$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $0d6d009b0876809a$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $0d6d009b0876809a$var$findStyles(container) {
    return Array.from(($0d6d009b0876809a$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $0d6d009b0876809a$export$1ab5838465dbd10a(css, option = {}) {
    if (!(0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $0d6d009b0876809a$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($0d6d009b0876809a$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($0d6d009b0876809a$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = $0d6d009b0876809a$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || $0d6d009b0876809a$var$findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($0d6d009b0876809a$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute($0d6d009b0876809a$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $0d6d009b0876809a$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $0d6d009b0876809a$var$findStyles($0d6d009b0876809a$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($0d6d009b0876809a$var$getMark(option)) === key);
}
function $0d6d009b0876809a$export$2232e336aecaa80a(key, option = {}) {
    const existNode = $0d6d009b0876809a$var$findExistNode(key, option);
    if (existNode) {
        const container = $0d6d009b0876809a$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $0d6d009b0876809a$var$syncRealContainer(container, option) {
    const cachedRealContainer = $0d6d009b0876809a$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $c8b027ba93bf289e$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        const placeholderStyle = $0d6d009b0876809a$export$1ab5838465dbd10a('', option);
        const { parentNode: parentNode } = placeholderStyle;
        $0d6d009b0876809a$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $0d6d009b0876809a$export$f80df667f2f5a272() {
    $0d6d009b0876809a$var$containerCache.clear();
}
function $0d6d009b0876809a$export$4d99a2890bb989f0(css, key, originOption = {}) {
    const container = $0d6d009b0876809a$var$getContainer(originOption);
    const styles = $0d6d009b0876809a$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    // Sync real parent
    $0d6d009b0876809a$var$syncRealContainer(container, option);
    const existNode = $0d6d009b0876809a$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $0d6d009b0876809a$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($0d6d009b0876809a$var$getMark(option), key);
    return newNode;
}



var $acw62 = parcelRequire("acw62");


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $9d466ab90ba4f32d$var$isEqual(obj1, obj2, shallow = false) {
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    const refSet = new Set();
    function deepEqual(a, b, level = 1) {
        const circular = refSet.has(a);
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        const newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every((key)=>deepEqual(a[key], b[key], newLevel));
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $9d466ab90ba4f32d$export$2e2bcd8739ae039 = $9d466ab90ba4f32d$var$isEqual;



var $acw62 = parcelRequire("acw62");
// [times, realValue]
const $7399254758448c39$var$SPLIT = '%';
function $7399254758448c39$export$1d14e1d8187b9aad(keys) {
    return keys.join($7399254758448c39$var$SPLIT);
}
/** Record update id for extract static style order. */ let $7399254758448c39$var$updateId = 0;
class $7399254758448c39$var$Entity {
    instanceId;
    constructor(instanceId){
        this.instanceId = instanceId;
    }
    /** @private Internal cache map. Do not access this directly */ cache = new Map();
    /** @private Record update times for each key */ updateTimes = new Map();
    extracted = new Set();
    get(keys) {
        return this.opGet($7399254758448c39$export$1d14e1d8187b9aad(keys));
    }
    /** A fast get cache with `get` concat. */ opGet(keyPathStr) {
        return this.cache.get(keyPathStr) || null;
    }
    update(keys, valueFn) {
        return this.opUpdate($7399254758448c39$export$1d14e1d8187b9aad(keys), valueFn);
    }
    /** A fast get cache with `get` concat. */ opUpdate(keyPathStr, valueFn) {
        const prevValue = this.cache.get(keyPathStr);
        const nextValue = valueFn(prevValue);
        if (nextValue === null) {
            this.cache.delete(keyPathStr);
            this.updateTimes.delete(keyPathStr);
        } else {
            this.cache.set(keyPathStr, nextValue);
            this.updateTimes.set(keyPathStr, $7399254758448c39$var$updateId);
            $7399254758448c39$var$updateId += 1;
        }
    }
}
var $7399254758448c39$export$2e2bcd8739ae039 = $7399254758448c39$var$Entity;


const $2cce2e49b4db7773$export$3a1a912fd9fd3325 = {};
const $2cce2e49b4db7773$var$transform = $2cce2e49b4db7773$export$3a1a912fd9fd3325;
var $2cce2e49b4db7773$export$2e2bcd8739ae039 = $2cce2e49b4db7773$var$transform;


const $182b356f02bf1b9b$export$5d99297dcd5476ac = 'data-token-hash';
const $182b356f02bf1b9b$export$89ce1123b3c0bd9e = 'data-css-hash';
const $182b356f02bf1b9b$export$36f8a6c9fa24262a = 'data-cache-path';
const $182b356f02bf1b9b$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $182b356f02bf1b9b$export$cf6fa0bbcc94b912() {
    const cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        const styles = document.body.querySelectorAll(`style[${$182b356f02bf1b9b$export$89ce1123b3c0bd9e}]`) || [];
        const { firstChild: firstChild } = document.head;
        Array.from(styles).forEach((style)=>{
            style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] ||= cssinjsInstanceId;
            // Not force move if no head
            if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        const styleHash = {};
        Array.from(document.querySelectorAll(`style[${$182b356f02bf1b9b$export$89ce1123b3c0bd9e}]`)).forEach((style)=>{
            const hash = style.getAttribute($182b356f02bf1b9b$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) style.parentNode?.removeChild(style);
            } else styleHash[hash] = true;
        });
    }
    return new (0, $7399254758448c39$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
const $182b356f02bf1b9b$var$StyleContext = /*#__PURE__*/ $acw62.createContext({
    hashPriority: 'low',
    cache: $182b356f02bf1b9b$export$cf6fa0bbcc94b912(),
    defaultCache: true,
    autoPrefix: false
});
const $182b356f02bf1b9b$export$6aedb87c7b665270 = (props)=>{
    const { children: children, ...restProps } = props;
    const parentContext = $acw62.useContext($182b356f02bf1b9b$var$StyleContext);
    const context = (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>{
        const mergedContext = {
            ...parentContext
        };
        Object.keys(restProps).forEach((key)=>{
            const value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        const { cache: cache, transformers: transformers = [] } = restProps;
        mergedContext.cache = mergedContext.cache || $182b356f02bf1b9b$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        // autoPrefix
        if (transformers.includes((0, $2cce2e49b4db7773$export$3a1a912fd9fd3325))) mergedContext.autoPrefix = true;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], (prev, next)=>!(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prev[1], next[1], true));
    return /*#__PURE__*/ $acw62.createElement($182b356f02bf1b9b$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $182b356f02bf1b9b$export$2e2bcd8739ae039 = $182b356f02bf1b9b$var$StyleContext;






class $1a755235d4cd9d8d$var$AbstractCalculator {
}
var $1a755235d4cd9d8d$export$2e2bcd8739ae039 = $1a755235d4cd9d8d$var$AbstractCalculator;


const $96067c2c1122b921$var$CALC_UNIT = 'CALC_UNIT';
const $96067c2c1122b921$var$regexp = new RegExp($96067c2c1122b921$var$CALC_UNIT, 'g');
function $96067c2c1122b921$var$unit(value) {
    if (typeof value === 'number') return `${value}${$96067c2c1122b921$var$CALC_UNIT}`;
    return value;
}
class $96067c2c1122b921$export$2e2bcd8739ae039 extends (0, $1a755235d4cd9d8d$export$2e2bcd8739ae039) {
    result = '';
    unitlessCssVar;
    lowPriority;
    constructor(num, unitlessCssVar){
        super();
        const numType = typeof num;
        this.unitlessCssVar = unitlessCssVar;
        if (num instanceof $96067c2c1122b921$export$2e2bcd8739ae039) this.result = `(${num.result})`;
        else if (numType === 'number') this.result = $96067c2c1122b921$var$unit(num);
        else if (numType === 'string') this.result = num;
    }
    add(num) {
        if (num instanceof $96067c2c1122b921$export$2e2bcd8739ae039) this.result = `${this.result} + ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} + ${$96067c2c1122b921$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    sub(num) {
        if (num instanceof $96067c2c1122b921$export$2e2bcd8739ae039) this.result = `${this.result} - ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} - ${$96067c2c1122b921$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    mul(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $96067c2c1122b921$export$2e2bcd8739ae039) this.result = `${this.result} * ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} * ${num}`;
        this.lowPriority = false;
        return this;
    }
    div(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $96067c2c1122b921$export$2e2bcd8739ae039) this.result = `${this.result} / ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} / ${num}`;
        this.lowPriority = false;
        return this;
    }
    getResult(force) {
        return this.lowPriority || force ? `(${this.result})` : this.result;
    }
    equal(options) {
        const { unit: cssUnit } = options || {};
        let mergedUnit = true;
        if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
        else if (Array.from(this.unitlessCssVar).some((cssVar)=>this.result.includes(cssVar))) mergedUnit = false;
        this.result = this.result.replace($96067c2c1122b921$var$regexp, mergedUnit ? 'px' : '');
        if (typeof this.lowPriority !== 'undefined') return `calc(${this.result})`;
        return this.result;
    }
}



class $189b9ffa4e9f1d1f$export$2e2bcd8739ae039 extends (0, $1a755235d4cd9d8d$export$2e2bcd8739ae039) {
    result = 0;
    constructor(num){
        super();
        if (num instanceof $189b9ffa4e9f1d1f$export$2e2bcd8739ae039) this.result = num.result;
        else if (typeof num === 'number') this.result = num;
    }
    add(num) {
        if (num instanceof $189b9ffa4e9f1d1f$export$2e2bcd8739ae039) this.result += num.result;
        else if (typeof num === 'number') this.result += num;
        return this;
    }
    sub(num) {
        if (num instanceof $189b9ffa4e9f1d1f$export$2e2bcd8739ae039) this.result -= num.result;
        else if (typeof num === 'number') this.result -= num;
        return this;
    }
    mul(num) {
        if (num instanceof $189b9ffa4e9f1d1f$export$2e2bcd8739ae039) this.result *= num.result;
        else if (typeof num === 'number') this.result *= num;
        return this;
    }
    div(num) {
        if (num instanceof $189b9ffa4e9f1d1f$export$2e2bcd8739ae039) this.result /= num.result;
        else if (typeof num === 'number') this.result /= num;
        return this;
    }
    equal() {
        return this.result;
    }
}


const $f7688ec948540519$var$genCalc = (type, unitlessCssVar)=>{
    const Calculator = type === 'css' ? (0, $96067c2c1122b921$export$2e2bcd8739ae039) : (0, $189b9ffa4e9f1d1f$export$2e2bcd8739ae039);
    return (num)=>new Calculator(num, unitlessCssVar);
};
var $f7688ec948540519$export$2e2bcd8739ae039 = $f7688ec948540519$var$genCalc;


// ================================== Cache ==================================
function $06e75d38ebf58c74$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
class $06e75d38ebf58c74$export$2e2bcd8739ae039 {
    static MAX_CACHE_SIZE = 20;
    static MAX_CACHE_OFFSET = 5;
    cache;
    keys;
    cacheCallTimes;
    constructor(){
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    size() {
        return this.keys.length;
    }
    internalGet(derivativeOption, updateCallTimes = false) {
        let cache = {
            map: this.cache
        };
        derivativeOption.forEach((derivative)=>{
            if (!cache) cache = undefined;
            else cache = cache?.map?.get(derivative);
        });
        if (cache?.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
        return cache?.value;
    }
    get(derivativeOption) {
        return this.internalGet(derivativeOption, true)?.[0];
    }
    has(derivativeOption) {
        return !!this.internalGet(derivativeOption);
    }
    set(derivativeOption, value) {
        // New cache
        if (!this.has(derivativeOption)) {
            if (this.size() + 1 > $06e75d38ebf58c74$export$2e2bcd8739ae039.MAX_CACHE_SIZE + $06e75d38ebf58c74$export$2e2bcd8739ae039.MAX_CACHE_OFFSET) {
                const [targetKey] = this.keys.reduce((result, key)=>{
                    const [, callTimes] = result;
                    if (this.internalGet(key)[1] < callTimes) return [
                        key,
                        this.internalGet(key)[1]
                    ];
                    return result;
                }, [
                    this.keys[0],
                    this.cacheCallTimes
                ]);
                this.delete(targetKey);
            }
            this.keys.push(derivativeOption);
        }
        let cache = this.cache;
        derivativeOption.forEach((derivative, index)=>{
            if (index === derivativeOption.length - 1) cache.set(derivative, {
                value: [
                    value,
                    this.cacheCallTimes++
                ]
            });
            else {
                const cacheValue = cache.get(derivative);
                if (!cacheValue) cache.set(derivative, {
                    map: new Map()
                });
                else if (!cacheValue.map) cacheValue.map = new Map();
                cache = cache.get(derivative).map;
            }
        });
    }
    deleteByPath(currentCache, derivatives) {
        const cache = currentCache.get(derivatives[0]);
        if (derivatives.length === 1) {
            if (!cache.map) currentCache.delete(derivatives[0]);
            else currentCache.set(derivatives[0], {
                map: cache.map
            });
            return cache.value?.[0];
        }
        const result = this.deleteByPath(cache.map, derivatives.slice(1));
        if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
        return result;
    }
    delete(derivativeOption) {
        // If cache exists
        if (this.has(derivativeOption)) {
            this.keys = this.keys.filter((item)=>!$06e75d38ebf58c74$export$dd65e95e99ed0739(item, derivativeOption));
            return this.deleteByPath(this.cache, derivativeOption);
        }
        return undefined;
    }
}



let $3dd697ea901030c8$var$uuid = 0;
class $3dd697ea901030c8$export$2e2bcd8739ae039 {
    derivatives;
    id;
    constructor(derivatives){
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $3dd697ea901030c8$var$uuid;
        if (derivatives.length === 0) (0, $3ef2f9e39800a1a1$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $3dd697ea901030c8$var$uuid += 1;
    }
    getDerivativeToken(token) {
        return this.derivatives.reduce((result, derivative)=>derivative(token, result), undefined);
    }
}


const $db48c74b3367fd88$var$cacheThemes = new (0, $06e75d38ebf58c74$export$2e2bcd8739ae039)();
function $db48c74b3367fd88$export$2e2bcd8739ae039(derivatives) {
    const derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$db48c74b3367fd88$var$cacheThemes.has(derivativeArr)) $db48c74b3367fd88$var$cacheThemes.set(derivativeArr, new (0, $3dd697ea901030c8$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $db48c74b3367fd88$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
const $f97444ff16d95e90$var$resultCache = new WeakMap();
const $f97444ff16d95e90$var$RESULT_VALUE = {};
function $f97444ff16d95e90$export$6aabcc1951563d93(callback, deps) {
    let current = $f97444ff16d95e90$var$resultCache;
    for(let i = 0; i < deps.length; i += 1){
        const dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($f97444ff16d95e90$var$RESULT_VALUE)) current.set($f97444ff16d95e90$var$RESULT_VALUE, callback());
    return current.get($f97444ff16d95e90$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
const $f97444ff16d95e90$var$flattenTokenCache = new WeakMap();
function $f97444ff16d95e90$export$597374558a261efc(token) {
    let str = $f97444ff16d95e90$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach((key)=>{
            const value = token[key];
            str += key;
            if (value instanceof (0, $3dd697ea901030c8$export$2e2bcd8739ae039)) str += value.id;
            else if (value && typeof value === 'object') str += $f97444ff16d95e90$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(str);
        // Put in cache
        $f97444ff16d95e90$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $f97444ff16d95e90$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(`${salt}_${$f97444ff16d95e90$export$597374558a261efc(token)}`);
}
const $f97444ff16d95e90$var$randomSelectorKey = `random-${Date.now()}-${Math.random()}`.replace(/\./g, '');
// Magic `content` for detect selector support
const $f97444ff16d95e90$var$checkContent = '_bAmBoO_';
function $f97444ff16d95e90$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)()) {
        (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(styleStr, $f97444ff16d95e90$var$randomSelectorKey);
        const ele = document.createElement('div');
        ele.style.position = 'fixed';
        ele.style.left = '0';
        ele.style.top = '0';
        handleElement?.(ele);
        document.body.appendChild(ele);
        const support = supportCheck ? supportCheck(ele) : getComputedStyle(ele).content?.includes($f97444ff16d95e90$var$checkContent);
        ele.parentNode?.removeChild(ele);
        (0, $0d6d009b0876809a$export$2232e336aecaa80a)($f97444ff16d95e90$var$randomSelectorKey);
        return support;
    }
    return false;
}
let $f97444ff16d95e90$var$canLayer = undefined;
function $f97444ff16d95e90$export$ac8d3fd9840e20dd() {
    if ($f97444ff16d95e90$var$canLayer === undefined) $f97444ff16d95e90$var$canLayer = $f97444ff16d95e90$var$supportSelector(`@layer ${$f97444ff16d95e90$var$randomSelectorKey} { .${$f97444ff16d95e90$var$randomSelectorKey} { content: "${$f97444ff16d95e90$var$checkContent}"!important; } }`, (ele)=>{
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canLayer;
}
let $f97444ff16d95e90$var$canWhere = undefined;
function $f97444ff16d95e90$export$f51d3b8ac4ac9ed1() {
    if ($f97444ff16d95e90$var$canWhere === undefined) $f97444ff16d95e90$var$canWhere = $f97444ff16d95e90$var$supportSelector(`:where(.${$f97444ff16d95e90$var$randomSelectorKey}) { content: "${$f97444ff16d95e90$var$checkContent}"!important; }`, (ele)=>{
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canWhere;
}
let $f97444ff16d95e90$var$canLogic = undefined;
function $f97444ff16d95e90$export$64a912f57d5de48e() {
    if ($f97444ff16d95e90$var$canLogic === undefined) $f97444ff16d95e90$var$canLogic = $f97444ff16d95e90$var$supportSelector(`.${$f97444ff16d95e90$var$randomSelectorKey} { inset-block: 93px !important; }`, (ele)=>{
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    }, (ele)=>getComputedStyle(ele).bottom === '93px');
    return $f97444ff16d95e90$var$canLogic;
}
const $f97444ff16d95e90$export$9542afab8c2a5f48 = (0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)();
function $f97444ff16d95e90$export$523c0b569236b342(num) {
    if (typeof num === 'number') return `${num}px`;
    return num;
}
function $f97444ff16d95e90$export$71c98ec84f0481d3(style, tokenKey, styleId, customizeAttrs = {}, plain = false) {
    if (plain) return style;
    const attrs = {
        ...customizeAttrs,
        [(0, $182b356f02bf1b9b$export$5d99297dcd5476ac)]: tokenKey,
        [(0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e)]: styleId
    };
    const attrStr = Object.keys(attrs).map((attr)=>{
        const val = attrs[attr];
        return val ? `${attr}="${val}"` : null;
    }).filter((v)=>v).join(' ');
    return `<style ${attrStr}>${style}</style>`;
}
function $f97444ff16d95e90$export$9c59b80dda569a6e(options) {
    const { hashCls: hashCls, hashPriority: hashPriority = 'low' } = options || {};
    if (!hashCls) return '';
    const hashSelector = `.${hashCls}`;
    return hashPriority === 'low' ? `:where(${hashSelector})` : hashSelector;
}
const $f97444ff16d95e90$export$826fff653a329e83 = (val)=>{
    return val !== undefined && val !== null;
};
function $f97444ff16d95e90$export$f508583337ce246(config, nonce) {
    const nonceStr = typeof nonce === 'function' ? nonce() : nonce;
    if (nonceStr) return {
        ...config,
        csp: {
            ...config.csp,
            nonce: nonceStr
        }
    };
    return config;
}



const $5a4d26b111585357$export$309b3b095f0c7662 = (token, prefix = '')=>{
    return `--${prefix ? `${prefix}-` : ''}${token}`.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
const $5a4d26b111585357$export$a27ef1ee9bbc757e = (cssVars, hashId, options)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low', scope: scope } = options || {};
    if (!Object.keys(cssVars).length) return '';
    const baseSelector = `${(0, $f97444ff16d95e90$export$9c59b80dda569a6e)({
        hashCls: hashCls,
        hashPriority: hashPriority
    })}.${hashId}`;
    const scopes = [
        scope
    ].flat().filter(Boolean);
    const selector = scopes.length ? scopes.map((s)=>`${baseSelector}.${s}`).join(', ') : baseSelector;
    return `${selector}{${Object.entries(cssVars).map(([key, value])=>`${key}:${value};`).join('')}}`;
};
const $5a4d26b111585357$export$67858afe85bce49f = (token, themeKey, config)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low', prefix: prefix, unitless: unitless, ignore: ignore, preserve: preserve } = config || {};
    const cssVars = {};
    const result = {};
    Object.entries(token).forEach(([key, value])=>{
        if (preserve?.[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !ignore?.[key]) {
            const cssVar = $5a4d26b111585357$export$309b3b095f0c7662(key, prefix);
            cssVars[cssVar] = typeof value === 'number' && !unitless?.[key] ? `${value}px` : String(value);
            result[key] = `var(${cssVar})`;
        }
    });
    return [
        result,
        $5a4d26b111585357$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config?.scope,
            hashCls: hashCls,
            hashPriority: hashPriority
        })
    ];
};



var $acw62 = parcelRequire("acw62");


function $89824b6453bf0586$var$useProdHMR() {
    return false;
}
let $89824b6453bf0586$var$webpackHMR = false;
function $89824b6453bf0586$var$useDevHMR() {
    return $89824b6453bf0586$var$webpackHMR;
}
var $89824b6453bf0586$export$2e2bcd8739ae039 = $89824b6453bf0586$var$useProdHMR;
var $89824b6453bf0586$var$args;


const $5cf8f09379a7b7de$var$effectMap = new Map();
function $5cf8f09379a7b7de$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    const { cache: globalCache } = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039));
    const fullPath = [
        prefix,
        ...keyPath
    ];
    const fullPathStr = (0, $7399254758448c39$export$1d14e1d8187b9aad)(fullPath);
    const HMRUpdate = (0, $89824b6453bf0586$export$2e2bcd8739ae039)();
    const buildCache = (updater)=>{
        globalCache.opUpdate(fullPathStr, (prevCache)=>{
            const [times = 0, cache] = prevCache || [
                undefined,
                undefined
            ];
            // HMR should always ignore cache since developer may change it
            let tmpCache = cache;
            const mergedCache = tmpCache || cacheFn();
            const data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $acw62.useMemo(()=>{
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    let cacheEntity = globalCache.opGet(fullPathStr);
    const cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $acw62.useInsertionEffect)(()=>{
        buildCache(([times, cache])=>[
                times + 1,
                cache
            ]);
        if (!$5cf8f09379a7b7de$var$effectMap.has(fullPathStr)) {
            onCacheEffect?.(cacheContent);
            $5cf8f09379a7b7de$var$effectMap.set(fullPathStr, true);
            // 微任务清理缓存，可以认为是单次 batch render 中只触发一次 effect
            Promise.resolve().then(()=>{
                $5cf8f09379a7b7de$var$effectMap.delete(fullPathStr);
            });
        }
        return ()=>{
            globalCache.opUpdate(fullPathStr, (prevCache)=>{
                const [times = 0, cache] = prevCache || [];
                const nextCount = times - 1;
                if (nextCount === 0) {
                    onCacheRemove?.(cache, false);
                    $5cf8f09379a7b7de$var$effectMap.delete(fullPathStr);
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


const $fb047830d7776fb2$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
const $fb047830d7776fb2$var$hashPrefix = 'css';
const $fb047830d7776fb2$var$tokenKeys = new Map();
function $fb047830d7776fb2$var$recordCleanToken(tokenKey) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $fb047830d7776fb2$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        const styles = document.querySelectorAll(`style[${(0, $182b356f02bf1b9b$export$5d99297dcd5476ac)}="${key}"]`);
        styles.forEach((style)=>{
            if (style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] === instanceId) style.parentNode?.removeChild(style);
        });
    }
}
const $fb047830d7776fb2$var$TOKEN_THRESHOLD = -1;
// Remove will check current keys first
function $fb047830d7776fb2$var$cleanTokenStyle(tokenKey, instanceId) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) - 1);
    const cleanableKeyList = new Set();
    $fb047830d7776fb2$var$tokenKeys.forEach((value, key)=>{
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if ($fb047830d7776fb2$var$tokenKeys.size - cleanableKeyList.size > $fb047830d7776fb2$var$TOKEN_THRESHOLD) cleanableKeyList.forEach((key)=>{
        $fb047830d7776fb2$var$removeStyleTags(key, instanceId);
        $fb047830d7776fb2$var$tokenKeys.delete(key);
    });
}
const $fb047830d7776fb2$export$18602cb46ae80b62 = (originToken, overrideToken, theme, format)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        ...overrideToken
    };
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
const $fb047830d7776fb2$export$270fba097347f4fa = 'token';
function $fb047830d7776fb2$export$2e2bcd8739ae039(theme, tokens, option) {
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $acw62.useContext)((0, $182b356f02bf1b9b$export$2e2bcd8739ae039));
    const { salt: salt = '', override: override = $fb047830d7776fb2$var$EMPTY_OVERRIDE, formatToken: formatToken, getComputedToken: compute, cssVar: cssVar, nonce: nonce } = option;
    // Basic - We do basic cache here
    const mergedToken = (0, $f97444ff16d95e90$export$6aabcc1951563d93)(()=>Object.assign({}, ...tokens), tokens);
    const tokenStr = (0, $f97444ff16d95e90$export$597374558a261efc)(mergedToken);
    const overrideTokenStr = (0, $f97444ff16d95e90$export$597374558a261efc)(override);
    const cssVarStr = (0, $f97444ff16d95e90$export$597374558a261efc)(cssVar);
    const cachedToken = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($fb047830d7776fb2$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], ()=>{
        const mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $fb047830d7776fb2$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        const actualToken = {
            ...mergedDerivativeToken
        };
        // Optimize for `useStyleRegister` performance
        const mergedSalt = `${salt}_${cssVar.prefix}`;
        const hashId = (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(mergedSalt);
        const hashCls = `${$fb047830d7776fb2$var$hashPrefix}-${hashId}`;
        actualToken._tokenKey = (0, $f97444ff16d95e90$export$6c82d0ebe8f2ea2c)(actualToken, mergedSalt);
        // Replace token value with css variables
        const [tokenWithCssVar, cssVarsStr] = (0, $5a4d26b111585357$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
            prefix: cssVar.prefix,
            ignore: cssVar.ignore,
            unitless: cssVar.unitless,
            preserve: cssVar.preserve,
            hashPriority: hashPriority,
            hashCls: cssVar.hashed ? hashCls : undefined
        });
        tokenWithCssVar._hashId = hashId;
        $fb047830d7776fb2$var$recordCleanToken(cssVar.key);
        return [
            tokenWithCssVar,
            hashCls,
            actualToken,
            cssVarsStr,
            cssVar.key
        ];
    }, ([, , , , themeKey])=>{
        // Remove token will remove all related style
        $fb047830d7776fb2$var$cleanTokenStyle(themeKey, instanceId);
    }, ([, , , cssVarsStr, themeKey])=>{
        if (!cssVarsStr) return;
        let mergedCSSConfig = {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        };
        mergedCSSConfig = (0, $f97444ff16d95e90$export$f508583337ce246)(mergedCSSConfig, nonce);
        const style = (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(cssVarsStr, (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(`css-var-${themeKey}`), mergedCSSConfig);
        style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), themeKey);
    });
    return cachedToken;
}
const $fb047830d7776fb2$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, , realToken, styleStr, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const styleId = realToken._tokenKey;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var k = 0;
    var g = 0;
    var $ = "";
    var x = n;
    var y = s;
    var j = c;
    var z = $;
    while(w)switch(b = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) k++, z += "(";
            else z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 41:
            k--, z += ")";
            break;
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            if (k > 0) {
                z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g);
                break;
            }
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($298fb931ed4fbf8b$export$9e1725a4cfeada27(b || 1) == 5 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e() || 1) == 5) && $298fb931ed4fbf8b$export$36776f635604f274(z) && $298fb931ed4fbf8b$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            if (k > 0 && g) {
                z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g);
                break;
            }
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($298fb931ed4fbf8b$export$36776f635604f274(z) - l || h === 0)) $298fb931ed4fbf8b$export$10d8903dec122b9d(v > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, n, u, $, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, c && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, $, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, $ = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    if (k > 0) break;
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    p = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274($ = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, k = 0; w < c; ++w)for(var g = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; g < h; ++g)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? b[g] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, b[g]))) f[k++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, c, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, c), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(c, n, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(c, n)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c + (s = s[n].value), "span") ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(c) - 1 - n > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, $298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$6aad947bda0f3f46:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                c.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (c.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}



function $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03(message, info) {
    const { path: path, parentSelectors: parentSelectors } = info;
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, `[Ant Design CSS-in-JS] ${path ? `Error in ${path}: ` : ''}${message}${parentSelectors.length ? ` Selector: ${parentSelectors.join(' | ')}` : ''}`);
}


const $e6dfef8f0af50f8c$var$linter = (key, value, info)=>{
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        const contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        const contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && !value.startsWith('var(') && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${value}"'\`.`, info);
    }
};
var $e6dfef8f0af50f8c$export$2e2bcd8739ae039 = $e6dfef8f0af50f8c$var$linter;



const $ce6167d258bd4ce8$var$linter = (key, value, info)=>{
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`You seem to be using hashed animation '${value}', in which case 'animationName' with Keyframe as value is recommended.`, info);
    }
};
var $ce6167d258bd4ce8$export$2e2bcd8739ae039 = $ce6167d258bd4ce8$var$linter;



function $0f2f0342ec57fd4c$var$isConcatSelector(selector) {
    const notContent = selector.match(/:not\(([^)]*)\)/)?.[1] || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    const splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter((str)=>str);
    return splitCells.length > 1;
}
function $0f2f0342ec57fd4c$var$parsePath(info) {
    return info.parentSelectors.reduce((prev, cur)=>{
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : `${prev} ${cur}`;
    }, '');
}
const $0f2f0342ec57fd4c$var$linter = (key, value, info)=>{
    const parentSelectorPath = $0f2f0342ec57fd4c$var$parsePath(info);
    const notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($0f2f0342ec57fd4c$var$isConcatSelector)) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`Concat ':not' selector not support in legacy browsers.`, info);
};
var $0f2f0342ec57fd4c$export$2e2bcd8739ae039 = $0f2f0342ec57fd4c$var$linter;



const $dfba7bff08539c12$var$linter = (key, value, info)=>{
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`You seem to be using non-logical property '${key}' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                const valueArr = value.split(' ').map((item)=>item.trim());
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`You seem to be using '${key}' property with different left ${key} and right ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                const radiusGroups = value.split('/').map((item)=>item.trim());
                const invalid = radiusGroups.reduce((result, group)=>{
                    if (result) return result;
                    const radiusArr = group.split(' ').map((item)=>item.trim());
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        default:
    }
};
var $dfba7bff08539c12$export$2e2bcd8739ae039 = $dfba7bff08539c12$var$linter;



const $c9b112fad2a88d07$var$linter = (key, value, info)=>{
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)(`Unexpected 'NaN' in property '${key}: ${value}'.`, info);
};
var $c9b112fad2a88d07$export$2e2bcd8739ae039 = $c9b112fad2a88d07$var$linter;



const $71a97720875b4c78$var$linter = (key, value, info)=>{
    if (info.parentSelectors.some((selector)=>{
        const selectors = selector.split(',');
        return selectors.some((item)=>item.split('&').length > 2);
    })) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $71a97720875b4c78$export$2e2bcd8739ae039 = $71a97720875b4c78$var$linter;








const $535d769197131042$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
const $535d769197131042$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $535d769197131042$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map((path)=>{
        const hash = cachePathMap[path];
        return `${path}:${hash}`;
    }).join(';');
}
let $535d769197131042$var$cachePathMap;
let $535d769197131042$var$fromCSSFile = true;
function $535d769197131042$export$aad8462122ac592b(mockCache, fromFile = true) {
    $535d769197131042$var$cachePathMap = mockCache;
    $535d769197131042$var$fromCSSFile = fromFile;
}
function $535d769197131042$export$18298bb220d85216() {
    if (!$535d769197131042$var$cachePathMap) {
        $535d769197131042$var$cachePathMap = {};
        if ((0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)()) {
            const div = document.createElement('div');
            div.className = $535d769197131042$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            let content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach((item)=>{
                const [path, hash] = item.split(':');
                $535d769197131042$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            const inlineMapStyle = document.querySelector(`style[${$535d769197131042$export$1c054aa01963e47e}]`);
            if (inlineMapStyle) {
                $535d769197131042$var$fromCSSFile = false;
                inlineMapStyle.parentNode?.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $535d769197131042$export$5aa0d776d676ab98(path) {
    $535d769197131042$export$18298bb220d85216();
    return !!$535d769197131042$var$cachePathMap[path];
}
function $535d769197131042$export$d3851dfd3659b2ce(path) {
    const hash = $535d769197131042$var$cachePathMap[path];
    let styleStr = null;
    if (hash && (0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)()) {
        if ($535d769197131042$var$fromCSSFile) styleStr = $535d769197131042$export$e0a2f8ff7fc63361;
        else {
            const style = document.querySelector(`style[${(0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e)}="${$535d769197131042$var$cachePathMap[path]}"]`);
            if (style) styleStr = style.innerHTML;
            else // Clean up since not exist anymore
            delete $535d769197131042$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



const $7927865cee518bb3$var$SKIP_CHECK = '_skip_check_';
const $7927865cee518bb3$var$MULTI_VALUE = '_multi_value_';
function $7927865cee518bb3$export$8756898546458274(styleStr, autoPrefix) {
    const serialized = autoPrefix ? (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styleStr), (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)([
        (0, $298fb931ed4fbf8b$export$e08c7d021b829b7a),
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
    ])) : (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styleStr), (0, $298fb931ed4fbf8b$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $7927865cee518bb3$var$isCompoundCSSProperty(value) {
    return typeof value === 'object' && value && ($7927865cee518bb3$var$SKIP_CHECK in value || $7927865cee518bb3$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority = 'high') {
    if (!hashId) return key;
    const hashSelector = (0, $f97444ff16d95e90$export$9c59b80dda569a6e)({
        hashCls: hashId,
        hashPriority: hashPriority
    });
    // 注入 hashId
    const keys = key.split(',').map((k)=>{
        const fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        let firstPath = fullPath[0] || '';
        const htmlElement = firstPath.match(/^\w+/)?.[0] || '';
        firstPath = `${htmlElement}${hashSelector}${firstPath.slice(htmlElement.length)}`;
        return [
            firstPath,
            ...fullPath.slice(1)
        ].join(' ');
    });
    return keys.join(',');
}
const $7927865cee518bb3$export$e13dc740254f53d7 = (interpolation, config = {}, { root: root, injectHash: injectHash, parentSelectors: parentSelectors } = {
    root: true,
    parentSelectors: []
})=>{
    const { hashId: hashId, layer: layer, path: path, hashPriority: hashPriority, transformers: transformers = [], linters: linters = [] } = config;
    let styleStr = '';
    let effectStyle = {};
    function parseKeyframes(keyframes) {
        const animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            const [parsedStr] = $7927865cee518bb3$export$e13dc740254f53d7(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            });
            effectStyle[animationName] = `@keyframes ${keyframes.getName(hashId)}${parsedStr}`;
        }
    }
    function flattenList(list, fullList = []) {
        list.forEach((item)=>{
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    const flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach((originStyle)=>{
        // Only root level can use raw string
        const style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += `${style}\n`;
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            const mergedStyle = transformers.reduce((prev, trans)=>trans?.visit?.(prev) || prev, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach((key)=>{
                const value = mergedStyle[key];
                if (typeof value === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$7927865cee518bb3$var$isCompoundCSSProperty(value)) {
                    let subInjectHash = false;
                    // 当成嵌套对象来处理
                    let mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    let nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $7927865cee518bb3$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    const [parsedStr, childEffectStyle] = $7927865cee518bb3$export$e13dc740254f53d7(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [
                            ...parentSelectors,
                            mergedKey
                        ]
                    });
                    effectStyle = {
                        ...effectStyle,
                        ...childEffectStyle
                    };
                    styleStr += `${mergedKey}${parsedStr}`;
                } else {
                    function appendStyle(cssKey, cssValue) {
                        var linter;
                        // 如果是样式则直接插入
                        const styleName = cssKey.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
                        // Auto suffix with px
                        let formatValue = cssValue;
                        if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = `${formatValue}px`;
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue?._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += `${styleName}:${formatValue};`;
                    }
                    const actualValue = value?.value ?? value;
                    if (typeof value === 'object' && value?.[$7927865cee518bb3$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach((item)=>{
                        appendStyle(key, item);
                    });
                    else if ((0, $f97444ff16d95e90$export$826fff653a329e83)(actualValue)) appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = `{${styleStr}}`;
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = `@layer ${layer.name} {${styleStr}}`;
        if (layer.dependencies) effectStyle[`@layer ${layer.name}`] = layer.dependencies.map((deps)=>`@layer ${deps}, ${layer.name};`).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $7927865cee518bb3$export$412618713057f6ca(path, styleStr) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(`${path.join('%')}${styleStr}`);
}
const $7927865cee518bb3$export$1e6d9f0d06c7ec14 = 'style';
function $7927865cee518bb3$export$2e2bcd8739ae039(info, styleFn) {
    const { path: path, hashId: hashId, layer: layer, nonce: nonce, clientOnly: clientOnly, order: order = 0 } = info;
    const { mock: mock, hashPriority: hashPriority, container: container, transformers: transformers, linters: linters, cache: cache, layer: enableLayer, autoPrefix: autoPrefix } = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039));
    const fullPath = [
        hashId || ''
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push(...path);
    // Check if need insert style
    let isMergedClientSide = (0, $f97444ff16d95e90$export$9542afab8c2a5f48);
    (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($7927865cee518bb3$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    ()=>{
        const cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $535d769197131042$export$5aa0d776d676ab98)(cachePath)) {
            const [inlineCacheStyleStr, styleHash] = (0, $535d769197131042$export$d3851dfd3659b2ce)(cachePath);
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        const styleObj = styleFn();
        const [parsedStyle, effectStyle] = $7927865cee518bb3$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        });
        const styleStr = $7927865cee518bb3$export$8756898546458274(parsedStyle, autoPrefix || false);
        const styleId = $7927865cee518bb3$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    (cacheValue, fromHMR)=>{
        const [, styleId] = cacheValue;
        if (fromHMR && (0, $f97444ff16d95e90$export$9542afab8c2a5f48)) (0, $0d6d009b0876809a$export$2232e336aecaa80a)(styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, // Effect: Inject style here
    (cacheValue)=>{
        const [styleStr, styleId, effectStyle, , priority] = cacheValue;
        if (isMergedClientSide && styleStr !== (0, $535d769197131042$export$e0a2f8ff7fc63361)) {
            let mergedCSSConfig = {
                mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: priority
            };
            mergedCSSConfig = (0, $f97444ff16d95e90$export$f508583337ce246)(mergedCSSConfig, nonce);
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            const effectLayerKeys = [];
            const effectRestKeys = [];
            Object.keys(effectStyle).forEach((key)=>{
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach((effectKey)=>{
                (0, $0d6d009b0876809a$export$4d99a2890bb989f0)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_layer-${effectKey}`, {
                    ...mergedCSSConfig,
                    prepend: true
                });
            });
            // ==================== Inject Style ====================
            // Inject style
            const style = (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = cache.instanceId;
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach((effectKey)=>{
                (0, $0d6d009b0876809a$export$4d99a2890bb989f0)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_effect-${effectKey}`, mergedCSSConfig);
            });
        }
    });
}
const $7927865cee518bb3$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [styleStr, styleId, effectStyle, clientOnly, order] = cache;
    const { plain: plain, autoPrefix: autoPrefix } = options || {};
    // Skip client only style
    if (clientOnly) return null;
    let keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    // ====================== Style ======================
    keyStyleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, undefined, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach((effectKey)=>{
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            const effectStyleStr = $7927865cee518bb3$export$8756898546458274(effectStyle[effectKey], autoPrefix || false);
            const effectStyleHTML = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(effectStyleStr, undefined, `_effect-${effectKey}`, sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


const $4766d7657208f51d$export$d96c342855c5e1fc = 'cssVar';
const $4766d7657208f51d$var$useCSSVarRegister = (config, fn)=>{
    const { key: key, prefix: prefix, unitless: unitless, ignore: ignore, token: token, hashId: hashId, scope: scope, nonce: nonce } = config;
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $acw62.useContext)((0, $182b356f02bf1b9b$export$2e2bcd8739ae039));
    const { _tokenKey: tokenKey } = token;
    const scopeKey = Array.isArray(scope) ? scope.join('@@') : scope;
    const stylePath = [
        ...config.path,
        key,
        scopeKey,
        tokenKey
    ];
    const cache = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($4766d7657208f51d$export$d96c342855c5e1fc, stylePath, ()=>{
        const originToken = fn();
        const [mergedToken, cssVarsStr] = (0, $5a4d26b111585357$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope,
            hashPriority: hashPriority,
            hashCls: hashId
        });
        const styleId = (0, $7927865cee518bb3$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, ([, , styleId])=>{
        if (0, $f97444ff16d95e90$export$9542afab8c2a5f48) (0, $0d6d009b0876809a$export$2232e336aecaa80a)(styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, ([, cssVarsStr, styleId])=>{
        if (!cssVarsStr) return;
        let mergedCSSConfig = {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        };
        mergedCSSConfig = (0, $f97444ff16d95e90$export$f508583337ce246)(mergedCSSConfig, nonce);
        const style = (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(cssVarsStr, styleId, mergedCSSConfig);
        style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), key);
    });
    return cache;
};
const $4766d7657208f51d$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, styleStr, styleId, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $4766d7657208f51d$export$2e2bcd8739ae039 = $4766d7657208f51d$var$useCSSVarRegister;





const $0c1aa9cd61c22229$var$ExtractStyleFns = {
    [(0, $7927865cee518bb3$export$1e6d9f0d06c7ec14)]: (0, $7927865cee518bb3$export$f9380c9a627682d3),
    [(0, $fb047830d7776fb2$export$270fba097347f4fa)]: (0, $fb047830d7776fb2$export$f9380c9a627682d3),
    [(0, $4766d7657208f51d$export$d96c342855c5e1fc)]: (0, $4766d7657208f51d$export$f9380c9a627682d3)
};
function $0c1aa9cd61c22229$var$isNotNull(value) {
    return value !== null;
}
function $0c1aa9cd61c22229$export$2e2bcd8739ae039(cache, options) {
    const { plain: plain = false, types: types = [
        'style',
        'token',
        'cssVar'
    ], once: once = false } = typeof options === 'boolean' ? {
        plain: options
    } : options || {};
    const matchPrefixRegexp = new RegExp(`^(${(typeof types === 'string' ? [
        types
    ] : types).join('|')})%`);
    // prefix with `style` is used for `useStyleRegister` to cache style context
    const styleKeys = Array.from(cache.cache.keys()).filter((key)=>matchPrefixRegexp.test(key));
    // Common effect styles like animation
    const effectStyles = {};
    // Mapping of cachePath to style hash
    const cachePathMap = {};
    let styleText = '';
    styleKeys.map((key)=>{
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        const cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        const [prefix] = key.split('%');
        const extractFn = $0c1aa9cd61c22229$var$ExtractStyleFns[prefix];
        const extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        const updateTime = cache.updateTimes.get(key) || 0;
        const [order, styleId, styleStr] = extractedStyle;
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr,
            updateTime
        ];
    }).filter($0c1aa9cd61c22229$var$isNotNull).sort(([o1, , u1], [o2, , u2])=>{
        if (o1 !== o2) return o1 - o2;
        return u1 - u2;
    }).forEach(([, style])=>{
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(`.${(0, $535d769197131042$export$1c054aa01963e47e)}{content:"${(0, $535d769197131042$export$dfdc1655ccc5b9cb)(cachePathMap)}";}`, undefined, undefined, {
        [(0, $535d769197131042$export$1c054aa01963e47e)]: (0, $535d769197131042$export$1c054aa01963e47e)
    }, plain);
    return styleText;
}





class $cb64545ddf8f118e$var$Keyframe {
    name;
    style;
    constructor(name, style){
        this.name = name;
        this.style = style;
    }
    getName(hashId = '') {
        return hashId ? `${hashId}-${this.name}` : this.name;
    }
    _keyframe = true;
}
var $cb64545ddf8f118e$export$2e2bcd8739ae039 = $cb64545ddf8f118e$var$Keyframe;






function $c8e2e5c3988aca39$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    const rawStyle = String(value).trim();
    const importantCells = rawStyle.match(/(.*)(!important)/);
    const splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    let temp = [];
    let brackets = 0;
    return [
        splitStyle.reduce((list, item)=>{
            if (item.includes('(') || item.includes(')')) {
                const left = item.split('(').length - 1;
                const right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $c8e2e5c3988aca39$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
const $c8e2e5c3988aca39$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $c8e2e5c3988aca39$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $c8e2e5c3988aca39$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $c8e2e5c3988aca39$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $c8e2e5c3988aca39$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $c8e2e5c3988aca39$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $c8e2e5c3988aca39$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, important) {
    let parsedValue = value;
    if (important) parsedValue = `${parsedValue} !important`;
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ const $c8e2e5c3988aca39$var$transform = {
    visit: (cssObj)=>{
        const clone = {};
        Object.keys(cssObj).forEach((key)=>{
            const value = cssObj[key];
            const matchValue = $c8e2e5c3988aca39$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                const [values, important] = $c8e2e5c3988aca39$var$splitValues(value);
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach((matchKey)=>{
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(values[0], important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(values[index] ?? values[0], important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(values[index] ?? values[index - 2] ?? values[0], important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $c8e2e5c3988aca39$export$2e2bcd8739ae039 = $c8e2e5c3988aca39$var$transform;


/**
 * respect https://github.com/cuth/postcss-pxtorem
 */ // @ts-ignore

const $3d71e62b1d8dd17b$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $3d71e62b1d8dd17b$var$toFixed(number, precision) {
    const multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
const $3d71e62b1d8dd17b$var$transform = (options = {})=>{
    const { rootValue: rootValue = 16, precision: precision = 5, mediaQuery: mediaQuery = false } = options;
    const pxReplace = (m, $1)=>{
        if (!$1) return m;
        const pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        const fixedVal = $3d71e62b1d8dd17b$var$toFixed(pixels / rootValue, precision);
        return `${fixedVal}rem`;
    };
    const visit = (cssObj)=>{
        const clone = {
            ...cssObj
        };
        Object.entries(cssObj).forEach(([key, value])=>{
            if (typeof value === 'string' && value.includes('px')) {
                const newValue = value.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = `${value}px`.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
            // Media queries
            const mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                const newKey = key.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $3d71e62b1d8dd17b$export$2e2bcd8739ae039 = $3d71e62b1d8dd17b$var$transform;




const $26595656c8972ad7$export$73abaea5066f503b = {
    supportModernCSS: ()=>(0, $f97444ff16d95e90$export$f51d3b8ac4ac9ed1)() && (0, $f97444ff16d95e90$export$64a912f57d5de48e)()
};



var $acw62 = parcelRequire("acw62");
const $6bacc63174d40f3c$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6bacc63174d40f3c$export$2e2bcd8739ae039 = $6bacc63174d40f3c$var$IconContext;




const $b956dab96d0e505b$export$826fff653a329e83 = (val)=>{
    return val !== undefined && val !== null;
};
const $b956dab96d0e505b$export$7e4aa119212bc614 = (val)=>{
    return typeof val === 'number' && !Number.isNaN(val);
};
const $b956dab96d0e505b$export$844ec244b1367d54 = (val)=>{
    return typeof val === 'string';
};
const $b956dab96d0e505b$export$53b83ca8eaab0383 = (val)=>{
    return val !== null && typeof val === 'object';
};
const $b956dab96d0e505b$export$f6e2535fb5126e54 = (val)=>{
    return typeof val === 'function';
};
const $b956dab96d0e505b$export$f5b060c2914b97c8 = (val)=>{
    return $b956dab96d0e505b$export$826fff653a329e83(val) && $b956dab96d0e505b$export$f6e2535fb5126e54(val.then);
};
const $b956dab96d0e505b$export$c3825b437cbdea5c = (val)=>{
    return typeof val !== 'object' && !$b956dab96d0e505b$export$f6e2535fb5126e54(val) || val === null;
};



var $acw62 = parcelRequire("acw62");

function $5bd796dbed593bbb$export$8793edee2d425525() {}
const { resetWarned: $5bd796dbed593bbb$var$rcResetWarned } = (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039);
let $5bd796dbed593bbb$var$deprecatedWarnList = null;
function $5bd796dbed593bbb$export$60eef1277fe463e4() {
    $5bd796dbed593bbb$var$deprecatedWarnList = null;
    $5bd796dbed593bbb$var$rcResetWarned();
}
let $5bd796dbed593bbb$var$_warning = $5bd796dbed593bbb$export$8793edee2d425525;
var $5bd796dbed593bbb$var$valid, $5bd796dbed593bbb$var$component, $5bd796dbed593bbb$var$message;
const $5bd796dbed593bbb$var$warning = $5bd796dbed593bbb$var$_warning;
const $5bd796dbed593bbb$export$11b88c75b33aa1fd = /*#__PURE__*/ $acw62.createContext({});
const $5bd796dbed593bbb$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $5bd796dbed593bbb$export$8793edee2d425525;
    return noopWarning;
};
var $5bd796dbed593bbb$export$2e2bcd8739ae039 = $5bd796dbed593bbb$var$warning;



var $acw62 = parcelRequire("acw62");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-component/form`
$efabd6732f69a6da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");

const $0890f9c201430fe8$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $0890f9c201430fe8$export$2e2bcd8739ae039 = $0890f9c201430fe8$var$locale;


var $abc1f6318033b96d$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


function $bc34e6fc2122a34f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bc34e6fc2122a34f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bc34e6fc2122a34f$var$_typeof(o);
}
function $bc34e6fc2122a34f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc34e6fc2122a34f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc34e6fc2122a34f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bc34e6fc2122a34f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc34e6fc2122a34f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bc34e6fc2122a34f$var$_defineProperty(obj, key, value) {
    key = $bc34e6fc2122a34f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bc34e6fc2122a34f$var$_toPropertyKey(t) {
    var i = $bc34e6fc2122a34f$var$_toPrimitive(t, "string");
    return "symbol" == $bc34e6fc2122a34f$var$_typeof(i) ? i : String(i);
}
function $bc34e6fc2122a34f$var$_toPrimitive(t, r) {
    if ("object" != $bc34e6fc2122a34f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bc34e6fc2122a34f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bc34e6fc2122a34f$var$locale = $bc34e6fc2122a34f$var$_objectSpread($bc34e6fc2122a34f$var$_objectSpread({}, (0, $abc1f6318033b96d$export$bdd78c3fd9633c1e)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $bc34e6fc2122a34f$export$2e2bcd8739ae039 = $bc34e6fc2122a34f$var$locale;


const $594a5cf7899ad7e1$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $594a5cf7899ad7e1$export$2e2bcd8739ae039 = $594a5cf7899ad7e1$var$locale;


// Merge into a locale object
const $74a89c57a3cfafd2$var$locale = {
    lang: {
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ],
        ...(0, $bc34e6fc2122a34f$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $594a5cf7899ad7e1$export$2e2bcd8739ae039)
    }
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$74a89c57a3cfafd2$export$2e2bcd8739ae039 = $74a89c57a3cfafd2$var$locale;


var $32ded69f6ae6c615$export$2e2bcd8739ae039 = (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039);




const $c7d8dfeaf08e9faa$var$typeTemplate = '${label} is not a valid ${type}';
const $c7d8dfeaf08e9faa$var$localeValues = {
    locale: 'en',
    Pagination: $0890f9c201430fe8$export$2e2bcd8739ae039,
    DatePicker: $74a89c57a3cfafd2$export$2e2bcd8739ae039,
    TimePicker: $594a5cf7899ad7e1$export$2e2bcd8739ae039,
    Calendar: $32ded69f6ae6c615$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select',
        close: 'Close',
        sortable: 'sortable'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $c7d8dfeaf08e9faa$var$typeTemplate,
                method: $c7d8dfeaf08e9faa$var$typeTemplate,
                array: $c7d8dfeaf08e9faa$var$typeTemplate,
                object: $c7d8dfeaf08e9faa$var$typeTemplate,
                number: $c7d8dfeaf08e9faa$var$typeTemplate,
                date: $c7d8dfeaf08e9faa$var$typeTemplate,
                boolean: $c7d8dfeaf08e9faa$var$typeTemplate,
                integer: $c7d8dfeaf08e9faa$var$typeTemplate,
                float: $c7d8dfeaf08e9faa$var$typeTemplate,
                regexp: $c7d8dfeaf08e9faa$var$typeTemplate,
                email: $c7d8dfeaf08e9faa$var$typeTemplate,
                url: $c7d8dfeaf08e9faa$var$typeTemplate,
                hex: $c7d8dfeaf08e9faa$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $c7d8dfeaf08e9faa$export$2e2bcd8739ae039 = $c7d8dfeaf08e9faa$var$localeValues;


let $466e4bebfd7443ca$var$runtimeLocale = {
    ...(0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal
};
let $466e4bebfd7443ca$var$localeList = [];
const $466e4bebfd7443ca$var$generateLocale = ()=>$466e4bebfd7443ca$var$localeList.reduce((merged, locale)=>({
            ...merged,
            ...locale
        }), (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
function $466e4bebfd7443ca$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = {
            ...newLocale
        };
        $466e4bebfd7443ca$var$localeList.push(cloneLocale);
        $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        return ()=>{
            $466e4bebfd7443ca$var$localeList = $466e4bebfd7443ca$var$localeList.filter((locale)=>locale !== cloneLocale);
            $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        };
    }
    $466e4bebfd7443ca$var$runtimeLocale = {
        ...(0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal
    };
}
function $466e4bebfd7443ca$export$1b6004afda18cd51() {
    return $466e4bebfd7443ca$var$runtimeLocale;
}



var $acw62 = parcelRequire("acw62");
const $6dd9227cba6de9ce$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $6dd9227cba6de9ce$export$2e2bcd8739ae039 = $6dd9227cba6de9ce$var$LocaleContext;



var $acw62 = parcelRequire("acw62");


const $0020add6ec984361$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $acw62.useContext((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039));
    const getLocale = $acw62.useMemo(()=>{
        const locale = defaultLocale || (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...typeof locale === 'function' ? locale() : locale,
            ...localeFromContext || {}
        };
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $acw62.useMemo(()=>{
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) return (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $0020add6ec984361$export$2e2bcd8739ae039 = $0020add6ec984361$var$useLocale;


"use client";
const $766ff256ac32087c$export$b2f162cd5c15ea3e = 'internalMark';
const $766ff256ac32087c$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $acw62.useEffect(()=>{
        const clearLocale = (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)(locale?.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $acw62.useMemo(()=>({
            ...locale,
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $766ff256ac32087c$export$2e2bcd8739ae039 = $766ff256ac32087c$var$LocaleProvider;





// 36 Hex to reduce the size of the file
var $13d3254d016dc8f1$export$2e2bcd8739ae039 = {
    aliceblue: '9ehhb',
    antiquewhite: '9sgk7',
    aqua: '1ekf',
    aquamarine: '4zsno',
    azure: '9eiv3',
    beige: '9lhp8',
    bisque: '9zg04',
    black: '0',
    blanchedalmond: '9zhe5',
    blue: '73',
    blueviolet: '5e31e',
    brown: '6g016',
    burlywood: '8ouiv',
    cadetblue: '3qba8',
    chartreuse: '4zshs',
    chocolate: '87k0u',
    coral: '9yvyo',
    cornflowerblue: '3xael',
    cornsilk: '9zjz0',
    crimson: '8l4xo',
    cyan: '1ekf',
    darkblue: '3v',
    darkcyan: 'rkb',
    darkgoldenrod: '776yz',
    darkgray: '6mbhl',
    darkgreen: 'jr4',
    darkgrey: '6mbhl',
    darkkhaki: '7ehkb',
    darkmagenta: '5f91n',
    darkolivegreen: '3bzfz',
    darkorange: '9yygw',
    darkorchid: '5z6x8',
    darkred: '5f8xs',
    darksalmon: '9441m',
    darkseagreen: '5lwgf',
    darkslateblue: '2th1n',
    darkslategray: '1ugcv',
    darkslategrey: '1ugcv',
    darkturquoise: '14up',
    darkviolet: '5rw7n',
    deeppink: '9yavn',
    deepskyblue: '11xb',
    dimgray: '442g9',
    dimgrey: '442g9',
    dodgerblue: '16xof',
    firebrick: '6y7tu',
    floralwhite: '9zkds',
    forestgreen: '1cisi',
    fuchsia: '9y70f',
    gainsboro: '8m8kc',
    ghostwhite: '9pq0v',
    goldenrod: '8j4f4',
    gold: '9zda8',
    gray: '50i2o',
    green: 'pa8',
    greenyellow: '6senj',
    grey: '50i2o',
    honeydew: '9eiuo',
    hotpink: '9yrp0',
    indianred: '80gnw',
    indigo: '2xcoy',
    ivory: '9zldc',
    khaki: '9edu4',
    lavenderblush: '9ziet',
    lavender: '90c8q',
    lawngreen: '4vk74',
    lemonchiffon: '9zkct',
    lightblue: '6s73a',
    lightcoral: '9dtog',
    lightcyan: '8s1rz',
    lightgoldenrodyellow: '9sjiq',
    lightgray: '89jo3',
    lightgreen: '5nkwg',
    lightgrey: '89jo3',
    lightpink: '9z6wx',
    lightsalmon: '9z2ii',
    lightseagreen: '19xgq',
    lightskyblue: '5arju',
    lightslategray: '4nwk9',
    lightslategrey: '4nwk9',
    lightsteelblue: '6wau6',
    lightyellow: '9zlcw',
    lime: '1edc',
    limegreen: '1zcxe',
    linen: '9shk6',
    magenta: '9y70f',
    maroon: '4zsow',
    mediumaquamarine: '40eju',
    mediumblue: '5p',
    mediumorchid: '79qkz',
    mediumpurple: '5r3rv',
    mediumseagreen: '2d9ip',
    mediumslateblue: '4tcku',
    mediumspringgreen: '1di2',
    mediumturquoise: '2uabw',
    mediumvioletred: '7rn9h',
    midnightblue: 'z980',
    mintcream: '9ljp6',
    mistyrose: '9zg0x',
    moccasin: '9zfzp',
    navajowhite: '9zest',
    navy: '3k',
    oldlace: '9wq92',
    olive: '50hz4',
    olivedrab: '472ub',
    orange: '9z3eo',
    orangered: '9ykg0',
    orchid: '8iu3a',
    palegoldenrod: '9bl4a',
    palegreen: '5yw0o',
    paleturquoise: '6v4ku',
    palevioletred: '8k8lv',
    papayawhip: '9zi6t',
    peachpuff: '9ze0p',
    peru: '80oqn',
    pink: '9z8wb',
    plum: '8nba5',
    powderblue: '6wgdi',
    purple: '4zssg',
    rebeccapurple: '3zk49',
    red: '9y6tc',
    rosybrown: '7cv4f',
    royalblue: '2jvtt',
    saddlebrown: '5fmkz',
    salmon: '9rvci',
    sandybrown: '9jn1c',
    seagreen: '1tdnb',
    seashell: '9zje6',
    sienna: '6973h',
    silver: '7ir40',
    skyblue: '5arjf',
    slateblue: '45e4t',
    slategray: '4e100',
    slategrey: '4e100',
    snow: '9zke2',
    springgreen: '1egv',
    steelblue: '2r1kk',
    tan: '87yx8',
    teal: 'pds',
    thistle: '8ggk8',
    tomato: '9yqfb',
    turquoise: '2j4r4',
    violet: '9b10u',
    wheat: '9ld4j',
    white: '9zldr',
    whitesmoke: '9lhpx',
    yellow: '9zl6o',
    yellowgreen: '61fzm'
};


const $ea19b77d77fd8663$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $ea19b77d77fd8663$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $ea19b77d77fd8663$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $ea19b77d77fd8663$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $ea19b77d77fd8663$export$2c4f38d6c0ecc25a {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _hsl_s;
    _hsv_s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, $13d3254d016dc8f1$export$2e2bcd8739ae039)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, '0'));
            }
        } else if (input instanceof $ea19b77d77fd8663$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._hsl_s = input._hsl_s;
            this._hsv_s = input._hsv_s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $ea19b77d77fd8663$var$limitRange(input.r);
            this.g = $ea19b77d77fd8663$var$limitRange(input.g);
            this.b = $ea19b77d77fd8663$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $ea19b77d77fd8663$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $ea19b77d77fd8663$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    /**
   * @deprecated should use getHSVSaturation or getHSLSaturation instead
   */ getSaturation() {
        return this.getHSVSaturation();
    }
    getHSVSaturation() {
        if (typeof this._hsv_s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._hsv_s = 0;
            else this._hsv_s = delta / this.getMax();
        }
        return this._hsv_s;
    }
    getHSLSaturation() {
        if (typeof this._hsl_s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._hsl_s = 0;
            else {
                const l = this.getLightness();
                this._hsl_s = delta / 255 / (1 - Math.abs(2 * l - 1));
            }
        }
        return this._hsl_s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $ea19b77d77fd8663$var$round(calc('r')),
            g: $ea19b77d77fd8663$var$round(calc('g')),
            b: $ea19b77d77fd8663$var$round(calc('b')),
            a: $ea19b77d77fd8663$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $ea19b77d77fd8663$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $ea19b77d77fd8663$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getHSLSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $ea19b77d77fd8663$var$round(this.getHSLSaturation() * 100);
        const l = $ea19b77d77fd8663$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getHSVSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $ea19b77d77fd8663$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: _h, s: s, l: l, a: a }) {
        const h = (_h % 360 + 360) % 360;
        this._h = h;
        this._hsl_s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $ea19b77d77fd8663$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
            return;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $ea19b77d77fd8663$var$round((r + lightnessModification) * 255);
        this.g = $ea19b77d77fd8663$var$round((g + lightnessModification) * 255);
        this.b = $ea19b77d77fd8663$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: _h, s: s, v: v, a: a }) {
        const h = (_h % 360 + 360) % 360;
        this._h = h;
        this._hsv_s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $ea19b77d77fd8663$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $ea19b77d77fd8663$var$round(v * (1.0 - s) * 255);
        const q = $ea19b77d77fd8663$var$round(v * (1.0 - s * ff) * 255);
        const t = $ea19b77d77fd8663$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, $ea19b77d77fd8663$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, $ea19b77d77fd8663$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $ea19b77d77fd8663$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






const $d1dea01cb419bab7$var$hueStep = 2; // 色相阶梯
const $d1dea01cb419bab7$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
const $d1dea01cb419bab7$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const $d1dea01cb419bab7$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const $d1dea01cb419bab7$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const $d1dea01cb419bab7$var$lightColorCount = 5; // 浅色数量，主色上
const $d1dea01cb419bab7$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const $d1dea01cb419bab7$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $d1dea01cb419bab7$var$getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $d1dea01cb419bab7$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - $d1dea01cb419bab7$var$saturationStep * i;
    else if (i === $d1dea01cb419bab7$var$darkColorCount) saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep;
    else saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $d1dea01cb419bab7$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $d1dea01cb419bab7$var$getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + $d1dea01cb419bab7$var$brightnessStep1 * i;
    else value = hsv.v - $d1dea01cb419bab7$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $d1dea01cb419bab7$export$2e2bcd8739ae039(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(color);
    const hsv = pColor.toHsv();
    for(let i = $d1dea01cb419bab7$var$lightColorCount; i > 0; i -= 1){
        const c = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i, true),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i, true),
            v: $d1dea01cb419bab7$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= $d1dea01cb419bab7$var$darkColorCount; i += 1){
        const c = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i),
            v: $d1dea01cb419bab7$var$getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $d1dea01cb419bab7$var$darkColorMap.map(({ index: index, amount: amount })=>new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}


// Generated by script. Do NOT modify!
const $0b4842326956570d$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const $0b4842326956570d$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$0b4842326956570d$export$a90204d1394caf30.primary = $0b4842326956570d$export$a90204d1394caf30[5];
const $0b4842326956570d$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$0b4842326956570d$export$e63a1643b2f79b16.primary = $0b4842326956570d$export$e63a1643b2f79b16[5];
const $0b4842326956570d$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$0b4842326956570d$export$ad766f34ace1cafd.primary = $0b4842326956570d$export$ad766f34ace1cafd[5];
const $0b4842326956570d$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$0b4842326956570d$export$c24201f7fe3571d8.primary = $0b4842326956570d$export$c24201f7fe3571d8[5];
const $0b4842326956570d$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$0b4842326956570d$export$594c5a8758200c32.primary = $0b4842326956570d$export$594c5a8758200c32[5];
const $0b4842326956570d$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$0b4842326956570d$export$221d31baf2636aad.primary = $0b4842326956570d$export$221d31baf2636aad[5];
const $0b4842326956570d$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$0b4842326956570d$export$955a2ebd2fb142ae.primary = $0b4842326956570d$export$955a2ebd2fb142ae[5];
const $0b4842326956570d$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$0b4842326956570d$export$7474046f446842ee.primary = $0b4842326956570d$export$7474046f446842ee[5];
const $0b4842326956570d$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$0b4842326956570d$export$2aa0182783e7e9de.primary = $0b4842326956570d$export$2aa0182783e7e9de[5];
const $0b4842326956570d$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$0b4842326956570d$export$4138d3aeddcbf415.primary = $0b4842326956570d$export$4138d3aeddcbf415[5];
const $0b4842326956570d$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$0b4842326956570d$export$e13cce2a2d16a9d4.primary = $0b4842326956570d$export$e13cce2a2d16a9d4[5];
const $0b4842326956570d$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$0b4842326956570d$export$2a9ca2e383622e18.primary = $0b4842326956570d$export$2a9ca2e383622e18[5];
const $0b4842326956570d$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$0b4842326956570d$export$e4c89085febbc618.primary = $0b4842326956570d$export$e4c89085febbc618[5];
const $0b4842326956570d$export$3e2c219d3ab79d01 = $0b4842326956570d$export$e4c89085febbc618;
const $0b4842326956570d$export$36ad6df0f83f284d = {
    red: $0b4842326956570d$export$a90204d1394caf30,
    volcano: $0b4842326956570d$export$e63a1643b2f79b16,
    orange: $0b4842326956570d$export$ad766f34ace1cafd,
    gold: $0b4842326956570d$export$c24201f7fe3571d8,
    yellow: $0b4842326956570d$export$594c5a8758200c32,
    lime: $0b4842326956570d$export$221d31baf2636aad,
    green: $0b4842326956570d$export$955a2ebd2fb142ae,
    cyan: $0b4842326956570d$export$7474046f446842ee,
    blue: $0b4842326956570d$export$2aa0182783e7e9de,
    geekblue: $0b4842326956570d$export$4138d3aeddcbf415,
    purple: $0b4842326956570d$export$e13cce2a2d16a9d4,
    magenta: $0b4842326956570d$export$2a9ca2e383622e18,
    grey: $0b4842326956570d$export$e4c89085febbc618
};
const $0b4842326956570d$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$0b4842326956570d$export$e984d34fc144caa1.primary = $0b4842326956570d$export$e984d34fc144caa1[5];
const $0b4842326956570d$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$0b4842326956570d$export$360e10f78e17a865.primary = $0b4842326956570d$export$360e10f78e17a865[5];
const $0b4842326956570d$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$0b4842326956570d$export$d5a12c698b31fa45.primary = $0b4842326956570d$export$d5a12c698b31fa45[5];
const $0b4842326956570d$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$0b4842326956570d$export$2330427fb6a6af6f.primary = $0b4842326956570d$export$2330427fb6a6af6f[5];
const $0b4842326956570d$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$0b4842326956570d$export$67d203119f0ecec.primary = $0b4842326956570d$export$67d203119f0ecec[5];
const $0b4842326956570d$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$0b4842326956570d$export$51ed2a10d86576ed.primary = $0b4842326956570d$export$51ed2a10d86576ed[5];
const $0b4842326956570d$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$0b4842326956570d$export$76a3d804058f9b5f.primary = $0b4842326956570d$export$76a3d804058f9b5f[5];
const $0b4842326956570d$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$0b4842326956570d$export$dee6c7c6683c0d88.primary = $0b4842326956570d$export$dee6c7c6683c0d88[5];
const $0b4842326956570d$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$0b4842326956570d$export$10e0fd027e632624.primary = $0b4842326956570d$export$10e0fd027e632624[5];
const $0b4842326956570d$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$0b4842326956570d$export$abdd57ab473bba66.primary = $0b4842326956570d$export$abdd57ab473bba66[5];
const $0b4842326956570d$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$0b4842326956570d$export$7a65e68792738764.primary = $0b4842326956570d$export$7a65e68792738764[5];
const $0b4842326956570d$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$0b4842326956570d$export$d260a9321db4ab86.primary = $0b4842326956570d$export$d260a9321db4ab86[5];
const $0b4842326956570d$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$0b4842326956570d$export$515283ba400ffa6c.primary = $0b4842326956570d$export$515283ba400ffa6c[5];
const $0b4842326956570d$export$24617255e4daf647 = {
    red: $0b4842326956570d$export$e984d34fc144caa1,
    volcano: $0b4842326956570d$export$360e10f78e17a865,
    orange: $0b4842326956570d$export$d5a12c698b31fa45,
    gold: $0b4842326956570d$export$2330427fb6a6af6f,
    yellow: $0b4842326956570d$export$67d203119f0ecec,
    lime: $0b4842326956570d$export$51ed2a10d86576ed,
    green: $0b4842326956570d$export$76a3d804058f9b5f,
    cyan: $0b4842326956570d$export$dee6c7c6683c0d88,
    blue: $0b4842326956570d$export$10e0fd027e632624,
    geekblue: $0b4842326956570d$export$abdd57ab473bba66,
    purple: $0b4842326956570d$export$7a65e68792738764,
    magenta: $0b4842326956570d$export$d260a9321db4ab86,
    grey: $0b4842326956570d$export$515283ba400ffa6c
};




const $b1208bbc03407e2e$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $b1208bbc03407e2e$var$seedToken = {
    // preset color palettes
    ...$b1208bbc03407e2e$export$37e27b43af4d16eb,
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
};
var $b1208bbc03407e2e$export$2e2bcd8739ae039 = $b1208bbc03407e2e$var$seedToken;



const $8bbb48c728db3fab$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


function $f9a7789ccb5ebec2$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    const presetColorTokens = {};
    (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).forEach((colorKey)=>{
        const colorBase = seed[colorKey];
        if (colorBase) {
            const colorPalette = generateColorPalettes(colorBase);
            presetColorTokens[`${colorKey}Hover`] = colorPalette[5];
            presetColorTokens[`${colorKey}Active`] = colorPalette[7];
        }
    });
    return {
        ...neutralColors,
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        ...presetColorTokens,
        colorBgMask: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    };
}


const $74d509d83ea2ceca$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $74d509d83ea2ceca$export$2e2bcd8739ae039 = $74d509d83ea2ceca$var$genRadius;


function $17649d51225b21b7$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return {
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1,
        // radius
        ...(0, $74d509d83ea2ceca$export$2e2bcd8739ae039)(borderRadius)
    };
}


const $7163539f10d66a74$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $7163539f10d66a74$export$2e2bcd8739ae039 = $7163539f10d66a74$var$genControlHeight;


function $239826517175299d$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $239826517175299d$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.E ** (i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $239826517175299d$export$56204a27a2958a55(size)
        }));
}


const $10537aa233bce652$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $239826517175299d$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $10537aa233bce652$export$2e2bcd8739ae039 = $10537aa233bce652$var$genFontMapToken;


function $c9ee1fc436061bcb$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $4c3fbe9a4ea0d6be$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $8cc6ca3a04c40fcf$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor, shadowColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    const colorShadow = shadowColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorShadow: colorShadow,
        colorText: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderDisabled: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $11cb018871a499d7$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $0b4842326956570d$export$3968a3afc810b5f5).pink = (0, $0b4842326956570d$export$3968a3afc810b5f5).magenta;
    (0, $0b4842326956570d$export$36ad6df0f83f284d).pink = (0, $0b4842326956570d$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $b1208bbc03407e2e$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $0b4842326956570d$export$3968a3afc810b5f5)[colorKey] ? (0, $0b4842326956570d$export$36ad6df0f83f284d)[colorKey] : (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    return {
        ...token,
        ...colorPalettes,
        // Colors
        ...(0, $f9a7789ccb5ebec2$export$2e2bcd8739ae039)(token, {
            generateColorPalettes: $8cc6ca3a04c40fcf$export$da275153033f4ec1,
            generateNeutralColorPalettes: $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691
        }),
        // Font
        ...(0, $10537aa233bce652$export$2e2bcd8739ae039)(token.fontSize),
        // Size
        ...(0, $c9ee1fc436061bcb$export$2e2bcd8739ae039)(token),
        // Height
        ...(0, $7163539f10d66a74$export$2e2bcd8739ae039)(token),
        // Others
        ...(0, $17649d51225b21b7$export$2e2bcd8739ae039)(token)
    };
}


const $16712192479069fd$var$defaultTheme = (0, $db48c74b3367fd88$export$2e2bcd8739ae039)((0, $11cb018871a499d7$export$2e2bcd8739ae039));
var $16712192479069fd$export$2e2bcd8739ae039 = $16712192479069fd$var$defaultTheme;


var $acw62 = parcelRequire("acw62");


const $d6a0cd0c670c9aed$export$f84bd70098573c5c = {
    token: (0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
    override: {
        override: (0, $b1208bbc03407e2e$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $d6a0cd0c670c9aed$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($d6a0cd0c670c9aed$export$f84bd70098573c5c);




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
const $b422cebf586837cd$var$OrderContext = /*#__PURE__*/ $acw62.createContext(null);
var $b422cebf586837cd$export$2e2bcd8739ae039 = $b422cebf586837cd$var$OrderContext;


let $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = false;
function $2ccc34741b4bb73f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = nextInline;
    return $2ccc34741b4bb73f$export$18c8ad048e32c7d5;
}



var $acw62 = parcelRequire("acw62");



const $172bd5bc03f91d44$var$EMPTY_LIST = [];
function $172bd5bc03f91d44$export$2e2bcd8739ae039(render, debug) {
    const [ele] = $acw62.useState(()=>{
        if (!(0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)()) return null;
        const defaultEle = document.createElement('div');
        return defaultEle;
    });
    // ========================== Order ==========================
    const appendedRef = $acw62.useRef(false);
    const queueCreate = $acw62.useContext((0, $b422cebf586837cd$export$2e2bcd8739ae039));
    const [queue, setQueue] = $acw62.useState($172bd5bc03f91d44$var$EMPTY_LIST);
    const mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : (appendFn)=>{
        setQueue((origin)=>{
            const newQueue = [
                appendFn,
                ...origin
            ];
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        ele.parentElement?.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (queue.length) {
            queue.forEach((appendFn)=>appendFn());
            setQueue($172bd5bc03f91d44$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $acw62 = parcelRequire("acw62");


/* eslint-disable no-param-reassign */ 
let $266768ab4357c274$var$cached;
function $266768ab4357c274$var$measureScrollbarSize(ele) {
    const randomId = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`;
    const measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    const measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    let fallbackWidth;
    let fallbackHeight;
    if (ele) {
        const targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        const webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        const width = parseInt(webkitScrollbarStyle.width, 10);
        const height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            const widthStyle = width ? `width: ${webkitScrollbarStyle.width};` : '';
            const heightStyle = height ? `height: ${webkitScrollbarStyle.height};` : '';
            (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(`
#${randomId}::-webkit-scrollbar {
${widthStyle}
${heightStyle}
}`, randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    const scrollWidth = ele && fallbackWidth && !Number.isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    const scrollHeight = ele && fallbackHeight && !Number.isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $0d6d009b0876809a$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $266768ab4357c274$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $266768ab4357c274$var$cached === undefined) $266768ab4357c274$var$cached = $266768ab4357c274$var$measureScrollbarSize();
    return $266768ab4357c274$var$cached.width;
}
function $266768ab4357c274$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $266768ab4357c274$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $c9634f2c2418b2d0$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


const $66bc1eccb2a603c3$var$UNIQUE_ID = `rc-util-locker-${Date.now()}`;
let $66bc1eccb2a603c3$var$uuid = 0;
function $66bc1eccb2a603c3$export$2e2bcd8739ae039(lock) {
    const mergedLock = !!lock;
    const [id] = $acw62.useState(()=>{
        $66bc1eccb2a603c3$var$uuid += 1;
        return `${$66bc1eccb2a603c3$var$UNIQUE_ID}_${$66bc1eccb2a603c3$var$uuid}`;
    });
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (mergedLock) {
            const scrollbarSize = (0, $266768ab4357c274$export$4f3ef2310365b56a)(document.body).width;
            const isOverflow = (0, $c9634f2c2418b2d0$export$31b5c8f1131a3a52)();
            (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(`
html body {
  overflow-y: hidden;
  ${isOverflow ? `width: calc(100% - ${scrollbarSize}px);` : ''}
}`, id);
        } else (0, $0d6d009b0876809a$export$2232e336aecaa80a)(id);
        return ()=>{
            (0, $0d6d009b0876809a$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}




var $acw62 = parcelRequire("acw62");
function $bba066f19964922a$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    const fullClone = {
        ...$acw62
    };
    return fullClone.useId;
}
let $bba066f19964922a$var$uuid = 0;
function $bba066f19964922a$export$2f0435a662835942() {}
function $bba066f19964922a$export$218c8c3169c024d2(prefix, key) {
    // React.Key can be string | number, convert to string first
    const keyStr = String(key);
    // Valid id characters: letters, digits, hyphen, underscore, colon, period
    // Replace all invalid characters (including spaces) with hyphens to preserve length
    const sanitizedKey = keyStr.replace(/[^a-zA-Z0-9_.:-]/g, '-');
    return `${prefix}-${sanitizedKey}`;
}
const $bba066f19964922a$var$useOriginId = $bba066f19964922a$var$getUseId();
var $bba066f19964922a$export$2e2bcd8739ae039 = $bba066f19964922a$var$useOriginId ? // Use React `useId`
function useId(id) {
    const reactId = $bba066f19964922a$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    const [innerId, setInnerId] = $acw62.useState('ssr-id');
    $acw62.useEffect(()=>{
        const nextId = $bba066f19964922a$var$uuid;
        $bba066f19964922a$var$uuid += 1;
        setInnerId(`rc_unique_${nextId}`);
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};



var $acw62 = parcelRequire("acw62");
let $16dac3efbb23c4a5$var$stack = [];
const $16dac3efbb23c4a5$var$IME_LOCK_DURATION = 200;
let $16dac3efbb23c4a5$var$lastCompositionEndTime = 0;
const $16dac3efbb23c4a5$export$9b72c8a279453f3a = null;
// Global event handlers
const $16dac3efbb23c4a5$var$onGlobalKeyDown = (event)=>{
    if (event.key === 'Escape' && !event.isComposing) {
        const now = Date.now();
        if (now - $16dac3efbb23c4a5$var$lastCompositionEndTime < $16dac3efbb23c4a5$var$IME_LOCK_DURATION) return;
        const len = $16dac3efbb23c4a5$var$stack.length;
        for(let i = len - 1; i >= 0; i -= 1)$16dac3efbb23c4a5$var$stack[i].onEsc({
            top: i === len - 1,
            event: event
        });
    }
};
const $16dac3efbb23c4a5$var$onGlobalCompositionEnd = ()=>{
    $16dac3efbb23c4a5$var$lastCompositionEndTime = Date.now();
};
function $16dac3efbb23c4a5$var$attachGlobalEventListeners() {
    window.addEventListener('keydown', $16dac3efbb23c4a5$var$onGlobalKeyDown);
    window.addEventListener('compositionend', $16dac3efbb23c4a5$var$onGlobalCompositionEnd);
}
function $16dac3efbb23c4a5$var$detachGlobalEventListeners() {
    if ($16dac3efbb23c4a5$var$stack.length === 0) {
        window.removeEventListener('keydown', $16dac3efbb23c4a5$var$onGlobalKeyDown);
        window.removeEventListener('compositionend', $16dac3efbb23c4a5$var$onGlobalCompositionEnd);
    }
}
function $16dac3efbb23c4a5$export$2e2bcd8739ae039(open, onEsc) {
    const id = (0, $bba066f19964922a$export$2e2bcd8739ae039)();
    const onEventEsc = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(onEsc);
    const ensure = ()=>{
        if (!$16dac3efbb23c4a5$var$stack.find((item)=>item.id === id)) $16dac3efbb23c4a5$var$stack.push({
            id: id,
            onEsc: onEventEsc
        });
    };
    const clear = ()=>{
        $16dac3efbb23c4a5$var$stack = $16dac3efbb23c4a5$var$stack.filter((item)=>item.id !== id);
    };
    (0, $acw62.useMemo)(()=>{
        if (open) ensure();
        else if (!open) clear();
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            ensure();
            // Attach global event listeners
            $16dac3efbb23c4a5$var$attachGlobalEventListeners();
            return ()=>{
                clear();
                // Remove global event listeners if instances is empty
                $16dac3efbb23c4a5$var$detachGlobalEventListeners();
            };
        }
    }, [
        open
    ]);
}


const $ae492a4c7ad9d4f3$var$getPortalContainer = (getContainer)=>{
    if (getContainer === false) return false;
    if (!(0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
const $ae492a4c7ad9d4f3$var$Portal = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { open: open, autoLock: autoLock, getContainer: getContainer, debug: debug, autoDestroy: autoDestroy = true, children: children, onEsc: onEsc } = props;
    const [shouldRender, setShouldRender] = $acw62.useState(open);
    const mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $acw62.useEffect(()=>{
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    const [innerContainer, setInnerContainer] = $acw62.useState(()=>$ae492a4c7ad9d4f3$var$getPortalContainer(getContainer));
    $acw62.useEffect(()=>{
        const customizeContainer = $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(()=>// React do the state update even the value is the same,
            // Use function call to force React to compare update
            customizeContainer ?? null);
    });
    const [defaultContainer, queueCreate] = (0, $172bd5bc03f91d44$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug);
    const mergedContainer = innerContainer ?? defaultContainer;
    // ========================= Locker ==========================
    (0, $66bc1eccb2a603c3$export$2e2bcd8739ae039)(autoLock && open && (0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // ========================= Esc Keydown ==========================
    (0, $16dac3efbb23c4a5$export$2e2bcd8739ae039)(open, onEsc);
    // =========================== Ref ===========================
    let childRef = null;
    if (children && (0, $6c628207f5089a39$export$c1cec34af06bcf7)(children) && ref) childRef = (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(children);
    const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    const renderInline = mergedContainer === false || (0, $2ccc34741b4bb73f$export$121d9fd0ca615463)();
    let reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $acw62.createElement((0, $b422cebf586837cd$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $1u0KT.createPortal)(reffedChildren, mergedContainer));
});
var $ae492a4c7ad9d4f3$export$2e2bcd8739ae039 = $ae492a4c7ad9d4f3$var$Portal;



var $5b46218595a40828$export$2e2bcd8739ae039 = (0, $ae492a4c7ad9d4f3$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");


function $32e960eedc96a2ca$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $32e960eedc96a2ca$export$9aa546fdc20ae5b3(node) {
    if (node && typeof node === 'object' && $32e960eedc96a2ca$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($32e960eedc96a2ca$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $32e960eedc96a2ca$export$2e2bcd8739ae039(node) {
    const domNode = $32e960eedc96a2ca$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node && typeof node === 'object' && 'current' in node) {
        const refDomNode = $32e960eedc96a2ca$export$9aa546fdc20ae5b3(node.current);
        if (refDomNode) return refDomNode;
    }
    return null;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $41010a7d3472cc6e$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $41010a7d3472cc6e$export$fb8073518f34e6ec({ children: children, onBatchResize: onBatchResize }) {
    const resizeIdRef = $acw62.useRef(0);
    const resizeInfosRef = $acw62.useRef([]);
    const onCollectionResize = $acw62.useContext($41010a7d3472cc6e$export$db36075d98ba73d3);
    const onResize = $acw62.useCallback((size, element, data)=>{
        resizeIdRef.current += 1;
        const currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(()=>{
            if (currentId === resizeIdRef.current) {
                onBatchResize?.(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize?.(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($41010a7d3472cc6e$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}



var $acw62 = parcelRequire("acw62");
// =============================== Const ===============================
const $3d2205a8eafd83b2$var$elementListeners = new Map();
function $3d2205a8eafd83b2$var$onResize(entities) {
    entities.forEach((entity)=>{
        const { target: target } = entity;
        $3d2205a8eafd83b2$var$elementListeners.get(target)?.forEach((listener)=>listener(target));
    });
}
// Delay create ResizeObserver since it's not supported in server side
let $3d2205a8eafd83b2$var$observer;
function $3d2205a8eafd83b2$var$ensureResizeObserver() {
    if (!$3d2205a8eafd83b2$var$observer) $3d2205a8eafd83b2$var$observer = new ResizeObserver($3d2205a8eafd83b2$var$onResize);
    return $3d2205a8eafd83b2$var$observer;
}
const $3d2205a8eafd83b2$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
const $3d2205a8eafd83b2$export$524f0fd3b47831a = null; // eslint-disable-line
function $3d2205a8eafd83b2$export$d1203567a167490e(element, callback) {
    if (!$3d2205a8eafd83b2$var$elementListeners.has(element)) {
        $3d2205a8eafd83b2$var$elementListeners.set(element, new Set());
        $3d2205a8eafd83b2$var$ensureResizeObserver().observe(element);
    }
    $3d2205a8eafd83b2$var$elementListeners.get(element).add(callback);
}
function $3d2205a8eafd83b2$export$23a2283368c55ea2(element, callback) {
    if ($3d2205a8eafd83b2$var$elementListeners.has(element)) {
        $3d2205a8eafd83b2$var$elementListeners.get(element).delete(callback);
        if (!$3d2205a8eafd83b2$var$elementListeners.get(element).size) {
            $3d2205a8eafd83b2$var$ensureResizeObserver().unobserve(element);
            $3d2205a8eafd83b2$var$elementListeners.delete(element);
        }
    }
}



function $706efe6f9b37dd6c$export$2e2bcd8739ae039(enabled, getTarget, onDelayResize, onSyncResize) {
    // ============================= Size =============================
    const sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // =========================== Observe ============================
    // Handler
    const onInternalResize = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((target)=>{
        const { width: width, height: height } = target.getBoundingClientRect();
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = target;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ const fixedWidth = Math.floor(width);
        const fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            const size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            const mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            const mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            const sizeInfo = {
                ...size,
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            };
            // Call the callback immediately, let the caller decide whether to defer
            // onResize(sizeInfo, target);
            onSyncResize?.(sizeInfo, target);
            // defer the callback but not defer to next frame
            Promise.resolve().then(()=>{
                onDelayResize?.(sizeInfo, target);
            });
        }
    });
    // Dynamic observe
    const isFuncTarget = typeof getTarget === 'function';
    const funcTargetIdRef = $acw62.useRef(0);
    $acw62.useEffect(()=>{
        const target = isFuncTarget ? getTarget() : getTarget;
        if (target && enabled) (0, $3d2205a8eafd83b2$export$d1203567a167490e)(target, onInternalResize);
        else if (enabled && isFuncTarget) funcTargetIdRef.current += 1;
        return ()=>{
            if (target) (0, $3d2205a8eafd83b2$export$23a2283368c55ea2)(target, onInternalResize);
        };
    }, [
        enabled,
        // If function target resolves after a parent render, the bumped ref value
        // lets the next render re-run this effect without watching the function identity.
        isFuncTarget ? funcTargetIdRef.current : getTarget
    ]);
}


function $bdb003a0f09b1255$var$SingleObserver(props, ref) {
    const { children: children, disabled: disabled, onResize: onResize, data: data } = props;
    const elementRef = $acw62.useRef(null);
    const onCollectionResize = $acw62.useContext((0, $41010a7d3472cc6e$export$db36075d98ba73d3));
    // =========================== Children ===========================
    const isRenderProps = typeof children === 'function';
    const mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Ref ==============================
    const canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $6c628207f5089a39$export$c1cec34af06bcf7)(mergedChildren);
    const originRef = canRef ? (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(mergedChildren) : null;
    const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(originRef, elementRef);
    const getDomElement = ()=>{
        return (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(elementRef.current);
    };
    $acw62.useImperativeHandle(ref, ()=>getDomElement());
    // =========================== Observe ============================
    (0, $706efe6f9b37dd6c$export$2e2bcd8739ae039)(!disabled, getDomElement, onResize, (sizeInfo, target)=>{
        onCollectionResize?.(sizeInfo, target, data);
    });
    // ============================ Render ============================
    return canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren;
}
const $bdb003a0f09b1255$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($bdb003a0f09b1255$var$SingleObserver);
var $bdb003a0f09b1255$export$2e2bcd8739ae039 = $bdb003a0f09b1255$var$RefSingleObserver;





function $f9ee8e1a19f1de53$var$_extends() {
    $f9ee8e1a19f1de53$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f9ee8e1a19f1de53$var$_extends.apply(this, arguments);
}
const $f9ee8e1a19f1de53$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $f9ee8e1a19f1de53$var$ResizeObserver(props, ref) {
    const { children: children } = props;
    const childNodes = typeof children === 'function' ? [
        children
    ] : (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children);
    return childNodes.map((child, index)=>{
        const key = child?.key || `${$f9ee8e1a19f1de53$var$INTERNAL_PREFIX_KEY}-${index}`;
        return /*#__PURE__*/ $acw62.createElement((0, $bdb003a0f09b1255$export$2e2bcd8739ae039), $f9ee8e1a19f1de53$var$_extends({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
const $f9ee8e1a19f1de53$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($f9ee8e1a19f1de53$var$ResizeObserver);
$f9ee8e1a19f1de53$var$RefResizeObserver.Collection = (0, $41010a7d3472cc6e$export$fb8073518f34e6ec);
var $f9ee8e1a19f1de53$export$2e2bcd8739ae039 = $f9ee8e1a19f1de53$var$RefResizeObserver;



function $5cab3b9cddbc3e26$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $5cab3b9cddbc3e26$export$cca82218ea4431a(ele) {
    return $5cab3b9cddbc3e26$var$getRoot(ele) instanceof ShadowRoot;
}
function $5cab3b9cddbc3e26$export$70e8259662bb498b(ele) {
    return $5cab3b9cddbc3e26$export$cca82218ea4431a(ele) ? $5cab3b9cddbc3e26$var$getRoot(ele) : null;
}







var $acw62 = parcelRequire("acw62");

/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */ 



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $bd5d6a6d84461ef6$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
const $bd5d6a6d84461ef6$var$MotionProvider = (props)=>{
    const { children: children, ...rest } = props;
    const memoizedValue = $acw62.useMemo(()=>{
        return {
            motion: rest.motion
        };
    }, [
        rest.motion
    ]);
    return /*#__PURE__*/ $acw62.createElement($bd5d6a6d84461ef6$export$841858b892ce1f4c.Provider, {
        value: memoizedValue
    }, children);
};
var $bd5d6a6d84461ef6$export$2e2bcd8739ae039 = $bd5d6a6d84461ef6$var$MotionProvider;




var $acw62 = parcelRequire("acw62");

/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */ function $ae80486746cebf3a$var$useSyncState(defaultValue) {
    const [, forceUpdate] = $acw62.useReducer((x)=>x + 1, 0);
    const currentValueRef = $acw62.useRef(defaultValue);
    const getValue = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(()=>{
        return currentValueRef.current;
    });
    const setValue = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((updater)=>{
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}
var $ae80486746cebf3a$export$2e2bcd8739ae039 = $ae80486746cebf3a$var$useSyncState;



var $acw62 = parcelRequire("acw62");
const $bb221fad2029335a$export$de71442bbf2143da = 'none';
const $bb221fad2029335a$export$4fc3521687bcacd2 = 'appear';
const $bb221fad2029335a$export$5d6af549241fe2e8 = 'enter';
const $bb221fad2029335a$export$59b1c493d29f68e4 = 'leave';
const $bb221fad2029335a$export$40b34dd77d5522bf = 'none';
const $bb221fad2029335a$export$1b792916a5fac4fc = 'prepare';
const $bb221fad2029335a$export$9563153dd25a3ce8 = 'start';
const $bb221fad2029335a$export$e205886172277ec6 = 'active';
const $bb221fad2029335a$export$3a846c3d2fac10b8 = 'end';
const $bb221fad2029335a$export$98351fa4e6b4f204 = 'prepared';



var $acw62 = parcelRequire("acw62");

// ================= Transition =================
// Event wrapper. Copy from react source code
function $226f09c7c461dd77$var$makePrefixMap(styleProp, eventName) {
    const prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes[`Webkit${styleProp}`] = `webkit${eventName}`;
    prefixes[`Moz${styleProp}`] = `moz${eventName}`;
    prefixes[`ms${styleProp}`] = `MS${eventName}`;
    prefixes[`O${styleProp}`] = `o${eventName.toLowerCase()}`;
    return prefixes;
}
function $226f09c7c461dd77$export$6e8b350b1a8958a0(domSupport, win) {
    const prefixes = {
        animationend: $226f09c7c461dd77$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $226f09c7c461dd77$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
const $226f09c7c461dd77$var$vendorPrefixes = $226f09c7c461dd77$export$6e8b350b1a8958a0((0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
let $226f09c7c461dd77$var$style = {};
if ((0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)()) ({ style: $226f09c7c461dd77$var$style } = document.createElement('div'));
const $226f09c7c461dd77$var$prefixedEventNames = {};
function $226f09c7c461dd77$export$a032e4f39350c1d8(eventName) {
    if ($226f09c7c461dd77$var$prefixedEventNames[eventName]) return $226f09c7c461dd77$var$prefixedEventNames[eventName];
    const prefixMap = $226f09c7c461dd77$var$vendorPrefixes[eventName];
    if (prefixMap) {
        const stylePropList = Object.keys(prefixMap);
        const len = stylePropList.length;
        for(let i = 0; i < len; i += 1){
            const styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $226f09c7c461dd77$var$style) {
                $226f09c7c461dd77$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $226f09c7c461dd77$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
const $226f09c7c461dd77$var$internalAnimationEndName = $226f09c7c461dd77$export$a032e4f39350c1d8('animationend');
const $226f09c7c461dd77$var$internalTransitionEndName = $226f09c7c461dd77$export$a032e4f39350c1d8('transitionend');
const $226f09c7c461dd77$export$d28133ed3ad06c8b = !!($226f09c7c461dd77$var$internalAnimationEndName && $226f09c7c461dd77$var$internalTransitionEndName);
const $226f09c7c461dd77$export$760cc9769c51b738 = $226f09c7c461dd77$var$internalAnimationEndName || 'animationend';
const $226f09c7c461dd77$export$44baea64b8602e3c = $226f09c7c461dd77$var$internalTransitionEndName || 'transitionend';
function $226f09c7c461dd77$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if (typeof transitionName === 'object') {
        const type = transitionType.replace(/-\w/g, (match)=>match[1].toUpperCase());
        return transitionName[type];
    }
    return `${transitionName}-${transitionType}`;
}


var $5be0cec1789ff156$export$2e2bcd8739ae039 = (onInternalMotionEnd)=>{
    const cacheElementRef = (0, $acw62.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $226f09c7c461dd77$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $226f09c7c461dd77$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $226f09c7c461dd77$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $226f09c7c461dd77$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(()=>()=>{
            removeMotionEvents(cacheElementRef.current);
            cacheElementRef.current = null;
        }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
const $89b7883422bf707f$var$useIsomorphicLayoutEffect = (0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $89b7883422bf707f$export$2e2bcd8739ae039 = $89b7883422bf707f$var$useIsomorphicLayoutEffect;




var $acw62 = parcelRequire("acw62");


let $277b2a9c97081a51$var$raf = (callback)=>+setTimeout(callback, 16);
let $277b2a9c97081a51$var$caf = (num)=>clearTimeout(num);
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $277b2a9c97081a51$var$raf = (callback)=>window.requestAnimationFrame(callback);
    $277b2a9c97081a51$var$caf = (handle)=>window.cancelAnimationFrame(handle);
}
let $277b2a9c97081a51$var$rafUUID = 0;
const $277b2a9c97081a51$var$rafIds = new Map();
function $277b2a9c97081a51$var$cleanup(id) {
    $277b2a9c97081a51$var$rafIds.delete(id);
}
const $277b2a9c97081a51$var$wrapperRaf = (callback, times = 1)=>{
    $277b2a9c97081a51$var$rafUUID += 1;
    const id = $277b2a9c97081a51$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $277b2a9c97081a51$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            const realId = $277b2a9c97081a51$var$raf(()=>{
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $277b2a9c97081a51$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$277b2a9c97081a51$var$wrapperRaf.cancel = (id)=>{
    const realId = $277b2a9c97081a51$var$rafIds.get(id);
    $277b2a9c97081a51$var$cleanup(id);
    return $277b2a9c97081a51$var$caf(realId);
};
var $277b2a9c97081a51$export$2e2bcd8739ae039 = $277b2a9c97081a51$var$wrapperRaf;



var $acw62 = parcelRequire("acw62");
var $39750bd9ac1534f7$export$2e2bcd8739ae039 = ()=>{
    const nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback, delay = 2) {
        cancelNextFrame();
        const nextFrameId = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            if (delay <= 1) callback({
                isCanceled: ()=>nextFrameId !== nextFrameRef.current
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


const $c1a90818b1bedacd$var$FULL_STEP_QUEUE = [
    (0, $bb221fad2029335a$export$1b792916a5fac4fc),
    (0, $bb221fad2029335a$export$9563153dd25a3ce8),
    (0, $bb221fad2029335a$export$e205886172277ec6),
    (0, $bb221fad2029335a$export$3a846c3d2fac10b8)
];
const $c1a90818b1bedacd$var$SIMPLE_STEP_QUEUE = [
    (0, $bb221fad2029335a$export$1b792916a5fac4fc),
    (0, $bb221fad2029335a$export$98351fa4e6b4f204)
];
const $c1a90818b1bedacd$export$c2029bf6cfdbc28a = false;
const $c1a90818b1bedacd$export$dbee1e282e8c4830 = true;
function $c1a90818b1bedacd$export$39e04e72f972b885(step) {
    return step === (0, $bb221fad2029335a$export$e205886172277ec6) || step === (0, $bb221fad2029335a$export$3a846c3d2fac10b8);
}
var $c1a90818b1bedacd$export$2e2bcd8739ae039 = (status, prepareOnly, callback)=>{
    const [step, setStep] = (0, $78d8437484dce30d$export$2e2bcd8739ae039)((0, $bb221fad2029335a$export$40b34dd77d5522bf));
    const [nextFrame, cancelNextFrame] = (0, $39750bd9ac1534f7$export$2e2bcd8739ae039)();
    function startQueue() {
        setStep((0, $bb221fad2029335a$export$1b792916a5fac4fc), true);
    }
    const STEP_QUEUE = prepareOnly ? $c1a90818b1bedacd$var$SIMPLE_STEP_QUEUE : $c1a90818b1bedacd$var$FULL_STEP_QUEUE;
    (0, $89b7883422bf707f$export$2e2bcd8739ae039)(()=>{
        if (step !== (0, $bb221fad2029335a$export$40b34dd77d5522bf) && step !== (0, $bb221fad2029335a$export$3a846c3d2fac10b8)) {
            const index = STEP_QUEUE.indexOf(step);
            const nextStep = STEP_QUEUE[index + 1];
            const result = callback(step);
            if (result === $c1a90818b1bedacd$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame((info)=>{
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        startQueue,
        step
    ];
};


function $6c55cb67915745f2$export$2e2bcd8739ae039(supportMotion, visible, getElement, { motionEnter: motionEnter = true, motionAppear: motionAppear = true, motionLeave: motionLeave = true, motionDeadline: motionDeadline, motionLeaveImmediately: motionLeaveImmediately, onAppearPrepare: onAppearPrepare, onEnterPrepare: onEnterPrepare, onLeavePrepare: onLeavePrepare, onAppearStart: onAppearStart, onEnterStart: onEnterStart, onLeaveStart: onLeaveStart, onAppearActive: onAppearActive, onEnterActive: onEnterActive, onLeaveActive: onLeaveActive, onAppearEnd: onAppearEnd, onEnterEnd: onEnterEnd, onLeaveEnd: onLeaveEnd, onVisibleChanged: onVisibleChanged }) {
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    const [asyncVisible, setAsyncVisible] = $acw62.useState();
    const [getStatus, setStatus] = (0, $ae80486746cebf3a$export$2e2bcd8739ae039)((0, $bb221fad2029335a$export$de71442bbf2143da));
    const [style, setStyle] = $acw62.useState([
        null,
        null
    ]);
    const currentStatus = getStatus();
    const mountedRef = (0, $acw62.useRef)(false);
    const deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    const activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $bb221fad2029335a$export$de71442bbf2143da));
        setStyle([
            null,
            null
        ]);
    }
    const onInternalMotionEnd = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        const status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $bb221fad2029335a$export$de71442bbf2143da)) return;
        const element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        const currentActive = activeRef.current;
        let canEnd;
        if (status === (0, $bb221fad2029335a$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd?.(element, event);
        else if (status === (0, $bb221fad2029335a$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd?.(element, event);
        else if (status === (0, $bb221fad2029335a$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd?.(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    const [patchMotionEvents] = (0, $5be0cec1789ff156$export$2e2bcd8739ae039)(onInternalMotionEnd);
    // ============================= Step =============================
    const getEventHandlers = (targetStatus)=>{
        switch(targetStatus){
            case 0, $bb221fad2029335a$export$4fc3521687bcacd2:
                return {
                    [(0, $bb221fad2029335a$export$1b792916a5fac4fc)]: onAppearPrepare,
                    [(0, $bb221fad2029335a$export$9563153dd25a3ce8)]: onAppearStart,
                    [(0, $bb221fad2029335a$export$e205886172277ec6)]: onAppearActive
                };
            case 0, $bb221fad2029335a$export$5d6af549241fe2e8:
                return {
                    [(0, $bb221fad2029335a$export$1b792916a5fac4fc)]: onEnterPrepare,
                    [(0, $bb221fad2029335a$export$9563153dd25a3ce8)]: onEnterStart,
                    [(0, $bb221fad2029335a$export$e205886172277ec6)]: onEnterActive
                };
            case 0, $bb221fad2029335a$export$59b1c493d29f68e4:
                return {
                    [(0, $bb221fad2029335a$export$1b792916a5fac4fc)]: onLeavePrepare,
                    [(0, $bb221fad2029335a$export$9563153dd25a3ce8)]: onLeaveStart,
                    [(0, $bb221fad2029335a$export$e205886172277ec6)]: onLeaveActive
                };
            default:
                return {};
        }
    };
    const eventHandlers = $acw62.useMemo(()=>getEventHandlers(currentStatus), [
        currentStatus
    ]);
    const [startStep, step] = (0, $c1a90818b1bedacd$export$2e2bcd8739ae039)(currentStatus, !supportMotion, (newStep)=>{
        // Only prepare step can be skip
        if (newStep === (0, $bb221fad2029335a$export$1b792916a5fac4fc)) {
            const onPrepare = eventHandlers[0, $bb221fad2029335a$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $c1a90818b1bedacd$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (newStep in eventHandlers) setStyle([
            eventHandlers[newStep]?.(getDomElement(), null) || null,
            newStep
        ]);
        if (newStep === (0, $bb221fad2029335a$export$e205886172277ec6) && currentStatus !== (0, $bb221fad2029335a$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(()=>{
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (newStep === (0, $bb221fad2029335a$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $c1a90818b1bedacd$export$dbee1e282e8c4830;
    });
    const active = (0, $c1a90818b1bedacd$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    const visibleRef = (0, $acw62.useRef)(null);
    // Update with new status
    (0, $89b7883422bf707f$export$2e2bcd8739ae039)(()=>{
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        const isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        let nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $bb221fad2029335a$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $bb221fad2029335a$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $bb221fad2029335a$export$59b1c493d29f68e4);
        const nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $bb221fad2029335a$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $bb221fad2029335a$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(()=>{
        if (// Cancel appear
        currentStatus === (0, $bb221fad2029335a$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $bb221fad2029335a$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $bb221fad2029335a$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $bb221fad2029335a$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        }, []);
    // Trigger `onVisibleChanged`
    const firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(()=>{
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $bb221fad2029335a$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged?.(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    let mergedStyle = style[0];
    if (eventHandlers[0, $bb221fad2029335a$export$1b792916a5fac4fc] && step === (0, $bb221fad2029335a$export$9563153dd25a3ce8)) mergedStyle = {
        transition: 'none',
        ...mergedStyle
    };
    const styleStep = style[1];
    return [
        getStatus,
        step,
        mergedStyle,
        asyncVisible ?? visible,
        // Appear Check
        !mountedRef.current && currentStatus === (0, $bb221fad2029335a$export$de71442bbf2143da) && supportMotion && motionAppear ? 'NONE' : // Enter or Leave check
        step === (0, $bb221fad2029335a$export$9563153dd25a3ce8) || step === (0, $bb221fad2029335a$export$e205886172277ec6) ? styleStep === step : true
    ];
}





function $0fafd25ea86675aa$export$35eb5aa7e3b3c295(children) {
    return children?.length < 2;
}
function $0fafd25ea86675aa$export$e265d52a86a9f199(config) {
    let transitionSupport = config;
    if (typeof config === 'object') ({ transitionSupport: transitionSupport } = config);
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    const CSSMotion = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        const { visible: // Default config
        visible = true, removeOnLeave: removeOnLeave = true, forceRender: forceRender, children: children, motionName: motionName, leavedClassName: leavedClassName, eventProps: eventProps } = props;
        const { motion: contextMotion } = $acw62.useContext((0, $bd5d6a6d84461ef6$export$841858b892ce1f4c));
        const supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        const nodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            return (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(nodeRef.current);
        }
        const [getStatus, statusStep, statusStyle, mergedVisible, styleReady] = (0, $6c55cb67915745f2$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props);
        const status = getStatus();
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        const renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        const refObj = $acw62.useMemo(()=>{
            const obj = {};
            Object.defineProperties(obj, {
                nativeElement: {
                    enumerable: true,
                    get: getDomElement
                },
                inMotion: {
                    enumerable: true,
                    get: ()=>()=>getStatus() !== (0, $bb221fad2029335a$export$de71442bbf2143da)
                },
                enableMotion: {
                    enumerable: true,
                    get: ()=>()=>supportMotion
                }
            });
            return obj;
        }, []);
        // We lock `deps` here since function return object
        // will repeat trigger ref from `refConfig` -> `null` -> `refConfig`
        $acw62.useImperativeHandle(ref, ()=>refObj, []);
        // ===================== Render =====================
        // return motionChildren as React.ReactElement;
        const idRef = $acw62.useRef(0);
        if (styleReady) idRef.current += 1;
        // We should render children when motionStyle is sync with stepStatus
        const returnNode = $acw62.useMemo(()=>{
            if (styleReady === 'NONE') return null;
            let motionChildren;
            const mergedProps = {
                ...eventProps,
                visible: visible
            };
            if (!children) // No children
            motionChildren = null;
            else if (status === (0, $bb221fad2029335a$export$de71442bbf2143da)) {
                // Stable children
                if (mergedVisible) motionChildren = children({
                    ...mergedProps
                }, nodeRef);
                else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children({
                    ...mergedProps,
                    className: leavedClassName
                }, nodeRef);
                else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children({
                    ...mergedProps,
                    style: {
                        display: 'none'
                    }
                }, nodeRef);
                else motionChildren = null;
            } else {
                // In motion
                let statusSuffix;
                if (statusStep === (0, $bb221fad2029335a$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
                else if ((0, $c1a90818b1bedacd$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
                else if (statusStep === (0, $bb221fad2029335a$export$9563153dd25a3ce8)) statusSuffix = 'start';
                const motionCls = (0, $226f09c7c461dd77$export$27c72201b1d09951)(motionName, `${status}-${statusSuffix}`);
                motionChildren = children({
                    ...mergedProps,
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)((0, $226f09c7c461dd77$export$27c72201b1d09951)(motionName, status), {
                        [motionCls]: motionCls && statusSuffix,
                        [motionName]: typeof motionName === 'string'
                    }),
                    style: statusStyle
                }, nodeRef);
            }
            return motionChildren;
        }, [
            idRef.current
        ]);
        if ($0fafd25ea86675aa$export$35eb5aa7e3b3c295(children) && (0, $6c628207f5089a39$export$b51ae67c7882a242)(returnNode)) {
            const originNodeRef = (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(returnNode);
            if (originNodeRef !== nodeRef) return /*#__PURE__*/ $acw62.cloneElement(returnNode, {
                ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(originNodeRef, nodeRef)
            });
        }
        return returnNode;
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $0fafd25ea86675aa$export$2e2bcd8739ae039 = $0fafd25ea86675aa$export$e265d52a86a9f199((0, $226f09c7c461dd77$export$d28133ed3ad06c8b));



var $acw62 = parcelRequire("acw62");

const $ce901670c1ac56cf$export$3904baa009bc026e = 'add';
const $ce901670c1ac56cf$export$851162f0adad2cbc = 'keep';
const $ce901670c1ac56cf$export$c8b3fb08b68cfc85 = 'remove';
const $ce901670c1ac56cf$export$2ac1bd1808d2e43a = 'removed';
function $ce901670c1ac56cf$export$c47fd798e598c85c(key) {
    let keyObj;
    if (key && typeof key === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return {
        ...keyObj,
        key: String(keyObj.key)
    };
}
function $ce901670c1ac56cf$export$84bd7bd42ccc0f72(keys = []) {
    return keys.map($ce901670c1ac56cf$export$c47fd798e598c85c);
}
function $ce901670c1ac56cf$export$14527669107aa301(prevKeys = [], currentKeys = []) {
    let list = [];
    let currentIndex = 0;
    const currentLen = currentKeys.length;
    const prevKeyObjects = $ce901670c1ac56cf$export$84bd7bd42ccc0f72(prevKeys);
    const currentKeyObjects = $ce901670c1ac56cf$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach((keyObj)=>{
        let hit = false;
        for(let i = currentIndex; i < currentLen; i += 1){
            const currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map((obj)=>({
                            ...obj,
                            status: $ce901670c1ac56cf$export$3904baa009bc026e
                        })));
                    currentIndex = i;
                }
                list.push({
                    ...currentKeyObj,
                    status: $ce901670c1ac56cf$export$851162f0adad2cbc
                });
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push({
            ...keyObj,
            status: $ce901670c1ac56cf$export$c8b3fb08b68cfc85
        });
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map((obj)=>({
            ...obj,
            status: $ce901670c1ac56cf$export$3904baa009bc026e
        })));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ const keys = {};
    list.forEach(({ key: key })=>{
        keys[key] = (keys[key] || 0) + 1;
    });
    const duplicatedKeys = Object.keys(keys).filter((key)=>keys[key] > 1);
    duplicatedKeys.forEach((matchKey)=>{
        // Remove `STATUS_REMOVE` node.
        list = list.filter(({ key: key, status: status })=>key !== matchKey || status !== $ce901670c1ac56cf$export$c8b3fb08b68cfc85);
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach((node)=>{
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $ce901670c1ac56cf$export$851162f0adad2cbc;
        });
    });
    return list;
}



function $71116570e73e7990$var$_extends() {
    $71116570e73e7990$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71116570e73e7990$var$_extends.apply(this, arguments);
}
const $71116570e73e7990$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $71116570e73e7990$export$fcfc62c1d33d5e2e(transitionSupport, CSSMotion = (0, $0fafd25ea86675aa$export$2e2bcd8739ae039)) {
    class CSSMotionList extends $acw62.Component {
        static defaultProps = {
            component: 'div'
        };
        state = {
            keyEntities: []
        };
        static getDerivedStateFromProps({ keys: keys }, { keyEntities: keyEntities }) {
            const parsedKeyObjects = (0, $ce901670c1ac56cf$export$84bd7bd42ccc0f72)(keys);
            const mixedKeyEntities = (0, $ce901670c1ac56cf$export$14527669107aa301)(keyEntities, parsedKeyObjects);
            return {
                keyEntities: mixedKeyEntities.filter((entity)=>{
                    const prevEntity = keyEntities.find(({ key: key })=>entity.key === key);
                    // Remove if already mark as removed
                    if (prevEntity && prevEntity.status === (0, $ce901670c1ac56cf$export$2ac1bd1808d2e43a) && entity.status === (0, $ce901670c1ac56cf$export$c8b3fb08b68cfc85)) return false;
                    return true;
                })
            };
        }
        // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
        removeKey = (removeKey)=>{
            this.setState((prevState)=>{
                const nextKeyEntities = prevState.keyEntities.map((entity)=>{
                    if (entity.key !== removeKey) return entity;
                    return {
                        ...entity,
                        status: (0, $ce901670c1ac56cf$export$2ac1bd1808d2e43a)
                    };
                });
                return {
                    keyEntities: nextKeyEntities
                };
            }, ()=>{
                const { keyEntities: keyEntities } = this.state;
                const restKeysCount = keyEntities.filter(({ status: status })=>status !== (0, $ce901670c1ac56cf$export$2ac1bd1808d2e43a)).length;
                if (restKeysCount === 0 && this.props.onAllRemoved) this.props.onAllRemoved();
            });
        };
        render() {
            const { keyEntities: keyEntities } = this.state;
            const { component: component, children: children, onVisibleChanged: onVisibleChanged, onAllRemoved: onAllRemoved, ...restProps } = this.props;
            const Component = component || $acw62.Fragment;
            const motionProps = {};
            $71116570e73e7990$var$MOTION_PROP_NAMES.forEach((prop)=>{
                motionProps[prop] = restProps[prop];
                delete restProps[prop];
            });
            delete restProps.keys;
            return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(({ status: status, ...eventProps }, index)=>{
                const visible = status === (0, $ce901670c1ac56cf$export$3904baa009bc026e) || status === (0, $ce901670c1ac56cf$export$851162f0adad2cbc);
                return /*#__PURE__*/ $acw62.createElement(CSSMotion, $71116570e73e7990$var$_extends({}, motionProps, {
                    key: eventProps.key,
                    visible: visible,
                    eventProps: eventProps,
                    onVisibleChanged: (changedVisible)=>{
                        onVisibleChanged?.(changedVisible, {
                            key: eventProps.key
                        });
                        if (!changedVisible) this.removeKey(eventProps.key);
                    }
                }), (0, $0fafd25ea86675aa$export$35eb5aa7e3b3c295)(children) ? (props)=>children({
                        ...props,
                        index: index
                    }) : (props, ref)=>children({
                        ...props,
                        index: index
                    }, ref));
            }));
        }
    }
    return CSSMotionList;
}
var $71116570e73e7990$export$2e2bcd8739ae039 = $71116570e73e7990$export$fcfc62c1d33d5e2e((0, $226f09c7c461dd77$export$d28133ed3ad06c8b));



var $f302abe021ca493e$export$2e2bcd8739ae039 = (0, $0fafd25ea86675aa$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $c2c51b639b0318a5$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, align: align, arrow: arrow, arrowPos: arrowPos } = props;
    const { className: className, content: content, style: style } = arrow || {};
    const { x: x = 0, y: y = 0 } = arrowPos;
    const arrowRef = $acw62.useRef(null);
    // Skip if no align
    if (!align || !align.points) return null;
    const alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        const popupPoints = align.points[0];
        const targetPoints = align.points[1];
        const popupTB = popupPoints[0];
        const popupLR = popupPoints[1];
        const targetTB = targetPoints[0];
        const targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-arrow`, className),
        style: {
            ...alignStyle,
            ...style
        }
    }, content);
}





var $acw62 = parcelRequire("acw62");
function $c69e7bbf660984b6$var$_extends() {
    $c69e7bbf660984b6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c69e7bbf660984b6$var$_extends.apply(this, arguments);
}
function $c69e7bbf660984b6$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, open: open, zIndex: zIndex, mask: mask, motion: motion, mobile: mobile } = props;
    if (!mask) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $c69e7bbf660984b6$var$_extends({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), ({ className: className })=>/*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, mobile && `${prefixCls}-mobile-mask`, className)
        }));
}



var $acw62 = parcelRequire("acw62");
const $20a13834bc71bb31$var$PopupContent = /*#__PURE__*/ $acw62.memo(({ children: children })=>children, (_, next)=>next.cache);
var $20a13834bc71bb31$export$2e2bcd8739ae039 = $20a13834bc71bb31$var$PopupContent;


function $cd2e94c43a6b0b33$export$2e2bcd8739ae039(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY) {
    // >>>>> Offset
    const AUTO = 'auto';
    const offsetStyle = isMobile ? {} : {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (!isMobile && (ready || !open)) {
        const { points: points } = align;
        const dynamicInset = align.dynamicInset || align._experimental?.dynamicInset;
        const alignRight = dynamicInset && points[0][1] === 'r';
        const alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    return offsetStyle;
}



function $d8446137fd226eb8$var$_extends() {
    $d8446137fd226eb8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8446137fd226eb8$var$_extends.apply(this, arguments);
}
const $d8446137fd226eb8$var$Popup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { onEsc: onEsc, popup: popup, className: className, prefixCls: prefixCls, style: style, target: target, onVisibleChanged: onVisibleChanged, open: // Open
    open, keepDom: keepDom, fresh: fresh, onClick: // Click
    onClick, mask: // Mask
    mask, arrow: // Arrow
    arrow, arrowPos: arrowPos, align: align, motion: // Motion
    motion, maskMotion: maskMotion, mobile: // Mobile
    mobile, forceRender: // Portal
    forceRender, getPopupContainer: getPopupContainer, autoDestroy: autoDestroy, portal: Portal, children: children, zIndex: zIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerDownCapture: onPointerDownCapture, ready: ready, offsetX: offsetX, offsetY: offsetY, offsetR: offsetR, offsetB: offsetB, onAlign: onAlign, onPrepare: onPrepare, onResize: // Resize
    onResize, stretch: stretch, targetWidth: targetWidth, targetHeight: targetHeight } = props;
    const popupContent = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    const isNodeVisible = open || keepDom;
    // ========================= Mobile =========================
    const isMobile = !!mobile;
    // ========================== Mask ==========================
    const [mergedMask, mergedMaskMotion, mergedPopupMotion] = $acw62.useMemo(()=>{
        if (mobile) return [
            mobile.mask,
            mobile.maskMotion,
            mobile.motion
        ];
        return [
            mask,
            maskMotion,
            motion
        ];
    }, [
        mobile,
        mask,
        maskMotion,
        motion
    ]);
    // ======================= Container ========================
    const getPopupContainerNeedParams = getPopupContainer?.length > 0;
    const [show, setShow] = $acw62.useState(!getPopupContainer || !getPopupContainerNeedParams);
    // Delay to show since `getPopupContainer` need target element
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Resize =========================
    const onInternalResize = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((size, ele)=>{
        onResize?.(size, ele);
        onAlign();
    });
    // ========================= Styles =========================
    const offsetStyle = (0, $cd2e94c43a6b0b33$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Misc
    const miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $acw62.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && (()=>getPopupContainer(target)),
        autoDestroy: autoDestroy,
        onEsc: onEsc
    }, /*#__PURE__*/ $acw62.createElement((0, $c69e7bbf660984b6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mergedMask,
        motion: mergedMaskMotion,
        mobile: isMobile
    }), /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !open
    }, (resizeObserverRef)=>{
        return /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $d8446137fd226eb8$var$_extends({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: `${prefixCls}-hidden`
        }, mergedPopupMotion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: (nextVisible)=>{
                motion?.onVisibleChanged?.(nextVisible);
                onVisibleChanged(nextVisible);
            }
        }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
            const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, motionClassName, className, {
                [`${prefixCls}-mobile`]: isMobile
            });
            return /*#__PURE__*/ $acw62.createElement("div", {
                ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: {
                    '--arrow-x': `${arrowPos.x || 0}px`,
                    '--arrow-y': `${arrowPos.y || 0}px`,
                    ...offsetStyle,
                    ...miscStyle,
                    ...motionStyle,
                    boxSizing: 'border-box',
                    zIndex: zIndex,
                    ...style
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $acw62.createElement((0, $c2c51b639b0318a5$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $acw62.createElement((0, $20a13834bc71bb31$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, popupContent));
        });
    }), children);
});
var $d8446137fd226eb8$export$2e2bcd8739ae039 = $d8446137fd226eb8$var$Popup;



var $acw62 = parcelRequire("acw62");
// ===================== Nest =====================
const $f9b439e1e53d6d59$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $f9b439e1e53d6d59$export$2e2bcd8739ae039 = $f9b439e1e53d6d59$var$TriggerContext;
const $f9b439e1e53d6d59$export$14cc6d12cdc906c = /*#__PURE__*/ $acw62.createContext(null);



var $acw62 = parcelRequire("acw62");
function $65f8789299df97eb$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $65f8789299df97eb$export$2e2bcd8739ae039(action, showAction, hideAction) {
    return $acw62.useMemo(()=>{
        const mergedShowAction = $65f8789299df97eb$var$toArray(showAction ?? action);
        const mergedHideAction = $65f8789299df97eb$var$toArray(hideAction ?? action);
        const showActionSet = new Set(mergedShowAction);
        const hideActionSet = new Set(mergedHideAction);
        if (showActionSet.has('hover') && !showActionSet.has('click')) showActionSet.add('touch');
        if (hideActionSet.has('hover') && !hideActionSet.has('click')) hideActionSet.add('touch');
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        action,
        showAction,
        hideAction
    ]);
}



var $13cc53bc89b37f6a$export$2e2bcd8739ae039 = (element)=>{
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            const { width: width, height: height } = element.getBBox();
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            const { width: width, height: height } = element.getBoundingClientRect();
            if (width || height) return true;
        }
    }
    return false;
};





var $acw62 = parcelRequire("acw62");
function $140ec2a5382714e1$var$isPointsEq(a1 = [], a2 = [], isAlignPoint) {
    const getVal = (a, index)=>a[index] || '';
    if (isAlignPoint) return getVal(a1, 0) === getVal(a2, 0);
    return getVal(a1, 0) === getVal(a2, 0) && getVal(a1, 1) === getVal(a2, 1);
}
function $140ec2a5382714e1$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    const { points: points } = align;
    const placements = Object.keys(builtinPlacements);
    for(let i = 0; i < placements.length; i += 1){
        const placement = placements[i];
        if ($140ec2a5382714e1$var$isPointsEq(builtinPlacements[placement]?.points, points, isAlignPoint)) return `${prefixCls}-placement-${placement}`;
    }
    return '';
}
function $140ec2a5382714e1$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $140ec2a5382714e1$export$ba21ed9400ca485b(ele) {
    const scrollerList = [];
    let current = ele?.parentElement;
    const scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        const { overflowX: overflowX, overflowY: overflowY, overflow: overflow } = $140ec2a5382714e1$export$9c0584a7cc24d9e(current).getComputedStyle(current);
        if ([
            overflowX,
            overflowY,
            overflow
        ].some((o)=>scrollStyle.includes(o))) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $140ec2a5382714e1$export$34dfc8f73bbb64ae(num, defaultValue = 1) {
    return Number.isNaN(num) ? defaultValue : num;
}
function $140ec2a5382714e1$var$getPxValue(val) {
    return $140ec2a5382714e1$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $140ec2a5382714e1$export$94be9d7985092f2d(initArea, scrollerList) {
    const visibleArea = {
        ...initArea
    };
    (scrollerList || []).forEach((ele)=>{
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        const { overflow: overflow, overflowClipMargin: overflowClipMargin, borderTopWidth: borderTopWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth } = $140ec2a5382714e1$export$9c0584a7cc24d9e(ele).getComputedStyle(ele);
        const eleRect = ele.getBoundingClientRect();
        const { offsetHeight: eleOutHeight, clientHeight: eleInnerHeight, offsetWidth: eleOutWidth, clientWidth: eleInnerWidth } = ele;
        const borderTopNum = $140ec2a5382714e1$var$getPxValue(borderTopWidth);
        const borderBottomNum = $140ec2a5382714e1$var$getPxValue(borderBottomWidth);
        const borderLeftNum = $140ec2a5382714e1$var$getPxValue(borderLeftWidth);
        const borderRightNum = $140ec2a5382714e1$var$getPxValue(borderRightWidth);
        const scaleX = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        const scaleY = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        const eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        const eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        const scaledBorderTopWidth = borderTopNum * scaleY;
        const scaledBorderBottomWidth = borderBottomNum * scaleY;
        const scaledBorderLeftWidth = borderLeftNum * scaleX;
        const scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        let clipMarginWidth = 0;
        let clipMarginHeight = 0;
        if (overflow === 'clip') {
            const clipNum = $140ec2a5382714e1$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        const eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        const eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        const eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        const eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $a3ab468f9842aab3$var$getUnitOffset(size, offset = 0) {
    const offsetStr = `${offset}`;
    const cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $a3ab468f9842aab3$var$getNumberOffset(rect, offset) {
    const [offsetX, offsetY] = offset || [];
    return [
        $a3ab468f9842aab3$var$getUnitOffset(rect.width, offsetX),
        $a3ab468f9842aab3$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $a3ab468f9842aab3$var$splitPoints(points = '') {
    return [
        points[0],
        points[1]
    ];
}
function $a3ab468f9842aab3$var$getAlignPoint(rect, points) {
    const topBottom = points[0];
    const leftRight = points[1];
    let x;
    let y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $a3ab468f9842aab3$var$reversePoints(points, index) {
    const reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    const clone = [
        ...points
    ];
    clone[index] = reverseMap[points[index]] || 'c';
    return clone;
}
function $a3ab468f9842aab3$var$flatPoints(points) {
    return points.join('');
}
function $a3ab468f9842aab3$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign, mobile) {
    const [offsetInfo, setOffsetInfo] = $acw62.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    });
    const alignCountRef = $acw62.useRef(0);
    const scrollerList = $acw62.useMemo(()=>{
        if (!popupEle || mobile) return [];
        return (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    const prevFlipRef = $acw62.useRef({});
    const resetFlipCache = ()=>{
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    const onAlign = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(()=>{
        if (popupEle && target && open && !mobile) {
            const popupElement = popupEle;
            const doc = popupElement.ownerDocument;
            const win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            const { position: popupPosition } = win.getComputedStyle(popupElement);
            const originLeft = popupElement.style.left;
            const originTop = popupElement.style.top;
            const originRight = popupElement.style.right;
            const originBottom = popupElement.style.bottom;
            const originOverflow = popupElement.style.overflow;
            // Placement
            const placementInfo = {
                ...builtinPlacements[placement],
                ...popupAlign
            };
            // placeholder element
            const placeholderElement = doc.createElement('div');
            popupElement.parentElement?.appendChild(placeholderElement);
            placeholderElement.style.left = `${popupElement.offsetLeft}px`;
            placeholderElement.style.top = `${popupElement.offsetTop}px`;
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = `${popupElement.offsetHeight}px`;
            placeholderElement.style.width = `${popupElement.offsetWidth}px`;
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            let targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                const rect = target.getBoundingClientRect();
                rect.x = rect.x ?? rect.left;
                rect.y = rect.y ?? rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            const popupRect = popupElement.getBoundingClientRect();
            const { height: height, width: width } = win.getComputedStyle(popupElement);
            popupRect.x = popupRect.x ?? popupRect.left;
            popupRect.y = popupRect.y ?? popupRect.top;
            const { clientWidth: clientWidth, clientHeight: clientHeight, scrollWidth: scrollWidth, scrollHeight: scrollHeight, scrollTop: scrollTop, scrollLeft: scrollLeft } = doc.documentElement;
            const popupHeight = popupRect.height;
            const popupWidth = popupRect.width;
            const targetHeight = targetRect.height;
            const targetWidth = targetRect.width;
            // Get bounding of visible area
            const visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            const scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            let { htmlRegion: htmlRegion } = placementInfo;
            const VISIBLE = 'visible';
            const VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            const isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            const scrollRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            const visibleRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            const visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            const adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            const popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            popupElement.parentElement?.removeChild(placeholderElement);
            // Calculate scale
            const scaleX = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            const scaleY = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (scaleX === 0 || scaleY === 0 || (0, $32e960eedc96a2ca$export$41e30d8dd0ba7a50)(target) && !(0, $13cc53bc89b37f6a$export$2e2bcd8739ae039)(target)) return;
            // Offset
            const { offset: offset, targetOffset: targetOffset } = placementInfo;
            let [popupOffsetX, popupOffsetY] = $a3ab468f9842aab3$var$getNumberOffset(popupRect, offset);
            const [targetOffsetX, targetOffsetY] = $a3ab468f9842aab3$var$getNumberOffset(targetRect, targetOffset);
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            const [popupPoint, targetPoint] = placementInfo.points || [];
            const targetPoints = $a3ab468f9842aab3$var$splitPoints(targetPoint);
            const popupPoints = $a3ab468f9842aab3$var$splitPoints(popupPoint);
            const targetAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(targetRect, targetPoints);
            const popupAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            const nextAlignInfo = {
                ...placementInfo
            };
            let nextPoints = [
                popupPoints,
                targetPoints
            ];
            // Next Offset
            let nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            let nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY, area = visibleArea) {
                const l = popupRect.x + offsetX;
                const t = popupRect.y + offsetY;
                const r = l + popupWidth;
                const b = t + popupHeight;
                const visibleL = Math.max(l, area.left);
                const visibleT = Math.max(t, area.top);
                const visibleR = Math.min(r, area.right);
                const visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            const originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            const originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            const targetAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            const popupAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            const targetAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            const popupAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            const overflow = placementInfo.overflow || {};
            const { adjustX: adjustX, adjustY: adjustY, shiftX: shiftX, shiftY: shiftY } = overflow;
            const supportAdjust = (val)=>{
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            let nextPopupY;
            let nextPopupBottom;
            let nextPopupX;
            let nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            const needAdjustY = supportAdjust(adjustY);
            const sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[0], 0),
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY += popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[0], 0),
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            const needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            const sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[0], 1),
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX += popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[0], 1),
                        $a3ab468f9842aab3$var$reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            nextAlignInfo.points = [
                $a3ab468f9842aab3$var$flatPoints(nextPoints[0]),
                $a3ab468f9842aab3$var$flatPoints(nextPoints[1])
            ];
            // ============================ Shift ============================
            syncNextPopupPosition();
            const numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            const numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            const popupLeft = popupRect.x + nextOffsetX;
            const popupRight = popupLeft + popupWidth;
            const popupTop = popupRect.y + nextOffsetY;
            const popupBottom = popupTop + popupHeight;
            const targetLeft = targetRect.x;
            const targetRight = targetLeft + targetWidth;
            const targetTop = targetRect.y;
            const targetBottom = targetTop + targetHeight;
            /** Max left of the popup and target element */ const maxLeft = Math.max(popupLeft, targetLeft);
            /** Min right of the popup and target element */ const minRight = Math.min(popupRight, targetRight);
            /** The center X of popup & target cross area */ const xCenter = (maxLeft + minRight) / 2;
            /** Arrow X of popup offset */ const nextArrowX = xCenter - popupLeft;
            const maxTop = Math.max(popupTop, targetTop);
            const minBottom = Math.min(popupBottom, targetBottom);
            const yCenter = (maxTop + minBottom) / 2;
            const nextArrowY = yCenter - popupTop;
            onPopupAlign?.(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            let offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            let offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (scaleX === 1) {
                nextOffsetX = Math.floor(nextOffsetX);
                offsetX4Right = Math.floor(offsetX4Right);
            }
            if (scaleY === 1) {
                nextOffsetY = Math.floor(nextOffsetY);
                offsetY4Bottom = Math.floor(offsetY4Bottom);
            }
            const nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / scaleX,
                offsetY: nextOffsetY / scaleY,
                offsetR: offsetX4Right / scaleX,
                offsetB: offsetY4Bottom / scaleY,
                arrowX: nextArrowX / scaleX,
                arrowY: nextArrowY / scaleY,
                scaleX: scaleX,
                scaleY: scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    const triggerAlign = ()=>{
        alignCountRef.current += 1;
        const id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(()=>{
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    const resetReady = ()=>{
        setOffsetInfo((ori)=>({
                ...ori,
                ready: false
            }));
    };
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}



var $acw62 = parcelRequire("acw62");
function $b48804d74b076636$export$2e2bcd8739ae039() {
    const delayRef = $acw62.useRef(null);
    const clearDelay = ()=>{
        if (delayRef.current) {
            clearTimeout(delayRef.current);
            delayRef.current = null;
        }
    };
    const delayInvoke = (callback, delay)=>{
        clearDelay();
        if (delay === 0) callback();
        else delayRef.current = setTimeout(()=>{
            callback();
        }, delay * 1000);
    };
    // Clean up on unmount
    $acw62.useEffect(()=>{
        return ()=>{
            clearDelay();
        };
    }, []);
    return delayInvoke;
}




function $02923bfaa4b78dec$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (open && target && popup) {
            const targetElement = target;
            const popupElement = popup;
            const targetScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(targetElement);
            const popupScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupElement);
            const win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            const mergedList = new Set([
                win,
                ...targetScrollList,
                ...popupScrollList
            ]);
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach((scroller)=>{
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return ()=>{
                mergedList.forEach((scroller)=>{
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}





var $acw62 = parcelRequire("acw62");

function $81078b27d1014ac5$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    const openRef = $acw62.useRef(open);
    openRef.current = open;
    const popupPointerDownRef = $acw62.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $acw62.useEffect(()=>{
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            const onPointerDown = ()=>{
                popupPointerDownRef.current = false;
            };
            const onTriggerClose = (e)=>{
                if (openRef.current && !inPopupOrChild(e.composedPath?.()?.[0] || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            const win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            const targetShadowRoot = (0, $5cab3b9cddbc3e26$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            return ()=>{
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

function $3d34a068fc8afa1c$export$2e2bcd8739ae039() {
    const [options, setOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isAnimating, setIsAnimating] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const pendingOptionsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const trigger = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextOptions)=>{
        if (nextOptions === false) {
            // Clear pending options when hiding
            pendingOptionsRef.current = null;
            setOpen(false);
        } else if (isAnimating && open) // If animating (appear or enter), cache new options
        pendingOptionsRef.current = nextOptions;
        else {
            setOpen(true);
            // Set new options
            setOptions(nextOptions);
            pendingOptionsRef.current = null;
            // Only mark as animating when transitioning from closed to open
            if (!open) setIsAnimating(true);
        }
    });
    const onVisibleChanged = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((visible)=>{
        if (visible) {
            // Animation enter completed, check if there are pending options
            setIsAnimating(false);
            if (pendingOptionsRef.current) {
                // Apply pending options
                setOptions(pendingOptionsRef.current);
                pendingOptionsRef.current = null;
            }
        } else {
            // Animation leave completed
            setIsAnimating(false);
            pendingOptionsRef.current = null;
        }
    });
    return [
        trigger,
        open,
        options,
        onVisibleChanged
    ];
}




var $acw62 = parcelRequire("acw62");



function $7e3ead01c2562065$var$_extends() {
    $7e3ead01c2562065$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7e3ead01c2562065$var$_extends.apply(this, arguments);
}
const $7e3ead01c2562065$var$UniqueContainer = (props)=>{
    const { prefixCls: prefixCls, isMobile: isMobile, ready: ready, open: open, align: align, offsetR: offsetR, offsetB: offsetB, offsetX: offsetX, offsetY: offsetY, arrowPos: arrowPos, popupSize: popupSize, motion: motion, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle } = props;
    const containerCls = `${prefixCls}-unique-container`;
    const [motionVisible, setMotionVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ========================= Styles =========================
    const offsetStyle = (0, $cd2e94c43a6b0b33$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // Cache for offsetStyle when ready is true
    const cachedOffsetStyleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(offsetStyle);
    // Update cached offset style when ready is true
    if (ready) cachedOffsetStyleRef.current = offsetStyle;
    // Apply popup size if available
    const sizeStyle = {};
    if (popupSize) {
        sizeStyle.width = popupSize.width;
        sizeStyle.height = popupSize.height;
    }
    // ========================= Render =========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $7e3ead01c2562065$var$_extends({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        leavedClassName: `${containerCls}-hidden`
    }, motion, {
        visible: open,
        onVisibleChanged: (nextVisible)=>{
            setMotionVisible(nextVisible);
        }
    }), ({ className: motionClassName, style: motionStyle })=>{
        const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(containerCls, motionClassName, uniqueContainerClassName, {
            [`${containerCls}-visible`]: motionVisible
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: cls,
            style: {
                '--arrow-x': `${arrowPos?.x || 0}px`,
                '--arrow-y': `${arrowPos?.y || 0}px`,
                ...cachedOffsetStyleRef.current,
                ...sizeStyle,
                ...motionStyle,
                ...uniqueContainerStyle
            }
        });
    });
};
var $7e3ead01c2562065$export$2e2bcd8739ae039 = $7e3ead01c2562065$var$UniqueContainer;




const $227d7e98ed1ad5ac$var$UniqueProvider = ({ children: children, postTriggerProps: postTriggerProps })=>{
    const [trigger, open, options, onTargetVisibleChanged] = (0, $3d34a068fc8afa1c$export$2e2bcd8739ae039)();
    // ========================== Options ===========================
    const mergedOptions = $acw62.useMemo(()=>{
        if (!options || !postTriggerProps) return options;
        return postTriggerProps(options);
    }, [
        options,
        postTriggerProps
    ]);
    // =========================== Popup ============================
    const [popupEle, setPopupEle] = $acw62.useState(null);
    const [popupSize, setPopupSize] = $acw62.useState(null);
    // Used for forwardRef popup. Not use internal
    const externalPopupRef = $acw62.useRef(null);
    const setPopupRef = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((node)=>{
        externalPopupRef.current = node;
        if ((0, $32e960eedc96a2ca$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
    });
    // ========================== Register ==========================
    // Store the isOpen function from the latest show call
    const isOpenRef = $acw62.useRef(null);
    const delayInvoke = (0, $b48804d74b076636$export$2e2bcd8739ae039)();
    const show = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((showOptions, isOpen)=>{
        // Store the isOpen function for later use in hide
        isOpenRef.current = isOpen;
        delayInvoke(()=>{
            trigger(showOptions);
        }, showOptions.delay);
    });
    const hide = (delay)=>{
        delayInvoke(()=>{
            // Check if we should still hide by calling the isOpen function
            // If isOpen returns true, it means another trigger wants to keep it open
            if (isOpenRef.current?.()) return; // Don't hide if something else wants it open
            trigger(false);
        // Don't clear target, currentNode, options immediately, wait until animation completes
        }, delay);
    };
    // Callback after animation completes
    const onVisibleChanged = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((visible)=>{
        // Call useTargetState callback to handle animation state
        onTargetVisibleChanged(visible);
    });
    // =========================== Align ============================
    const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, , , // scaleY - not used in UniqueProvider
    alignInfo, onAlign] = (0, $a3ab468f9842aab3$export$2e2bcd8739ae039)(open, popupEle, mergedOptions?.target, mergedOptions?.popupPlacement, mergedOptions?.builtinPlacements || {}, mergedOptions?.popupAlign, undefined, // onPopupAlign
    false // isMobile
    );
    const alignedClassName = $acw62.useMemo(()=>{
        if (!mergedOptions) return '';
        const baseClassName = (0, $140ec2a5382714e1$export$faa0aa8ed2fe6432)(mergedOptions.builtinPlacements || {}, mergedOptions.prefixCls || '', alignInfo, false // alignPoint is false for UniqueProvider
        );
        return (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(baseClassName, mergedOptions.getPopupClassNameFromAlign?.(alignInfo));
    }, [
        alignInfo,
        mergedOptions?.getPopupClassNameFromAlign,
        mergedOptions?.builtinPlacements,
        mergedOptions?.prefixCls
    ]);
    const contextValue = $acw62.useMemo(()=>({
            show: show,
            hide: hide
        }), []);
    // =========================== Align ============================
    $acw62.useEffect(()=>{
        onAlign();
    }, [
        mergedOptions?.target
    ]);
    // =========================== Motion ===========================
    const onPrepare = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(()=>{
        onAlign();
        return Promise.resolve();
    });
    // ======================== Trigger Context =====================
    const subPopupElements = $acw62.useRef({});
    const parentContext = $acw62.useContext((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039));
    const triggerContextValue = $acw62.useMemo(()=>({
            registerSubPopup: (id, subPopupEle)=>{
                subPopupElements.current[id] = subPopupEle;
                parentContext?.registerSubPopup(id, subPopupEle);
            }
        }), [
        parentContext
    ]);
    // =========================== Render ===========================
    const prefixCls = mergedOptions?.prefixCls;
    return /*#__PURE__*/ $acw62.createElement((0, $f9b439e1e53d6d59$export$14cc6d12cdc906c).Provider, {
        value: contextValue
    }, children, mergedOptions && /*#__PURE__*/ $acw62.createElement((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039).Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $d8446137fd226eb8$export$2e2bcd8739ae039), {
        ref: setPopupRef,
        portal: (0, $5b46218595a40828$export$2e2bcd8739ae039),
        onEsc: mergedOptions.onEsc,
        prefixCls: prefixCls,
        popup: mergedOptions.popup,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedOptions.popupClassName, alignedClassName, `${prefixCls}-unique-controlled`),
        style: mergedOptions.popupStyle,
        target: mergedOptions.target,
        open: open,
        keepDom: true,
        fresh: true,
        autoDestroy: false,
        onVisibleChanged: onVisibleChanged,
        ready: ready,
        offsetX: offsetX,
        offsetY: offsetY,
        offsetR: offsetR,
        offsetB: offsetB,
        onAlign: onAlign,
        onPrepare: onPrepare,
        onResize: (size)=>setPopupSize({
                width: size.offsetWidth,
                height: size.offsetHeight
            }),
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        align: alignInfo,
        zIndex: mergedOptions.zIndex,
        mask: mergedOptions.mask,
        arrow: mergedOptions.arrow,
        motion: mergedOptions.popupMotion,
        maskMotion: mergedOptions.maskMotion,
        getPopupContainer: mergedOptions.getPopupContainer
    }, /*#__PURE__*/ $acw62.createElement((0, $7e3ead01c2562065$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        isMobile: false,
        ready: ready,
        open: open,
        align: alignInfo,
        offsetR: offsetR,
        offsetB: offsetB,
        offsetX: offsetX,
        offsetY: offsetY,
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        popupSize: popupSize,
        motion: mergedOptions.popupMotion,
        uniqueContainerClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedOptions.uniqueContainerClassName, alignedClassName),
        uniqueContainerStyle: mergedOptions.uniqueContainerStyle
    }))));
};
var $227d7e98ed1ad5ac$export$2e2bcd8739ae039 = $227d7e98ed1ad5ac$var$UniqueProvider;




var $1u0KT = parcelRequire("1u0KT");
function $a99c76d30a1f506f$export$55e99723d7f71b47(PortalComponent = (0, $5b46218595a40828$export$2e2bcd8739ae039)) {
    const Trigger = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        const { prefixCls: prefixCls = 'rc-trigger-popup', children: children, action: // Action
        action = 'hover', showAction: showAction, hideAction: hideAction, popupVisible: // Open
        popupVisible, defaultPopupVisible: defaultPopupVisible, onOpenChange: onOpenChange, afterOpenChange: afterOpenChange, onPopupVisibleChange: onPopupVisibleChange, afterPopupVisibleChange: afterPopupVisibleChange, mouseEnterDelay: // Delay
        mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay = 0.1, focusDelay: focusDelay, blurDelay: blurDelay, mask: // Mask
        mask, maskClosable: maskClosable = true, getPopupContainer: // Portal
        getPopupContainer, forceRender: forceRender, autoDestroy: autoDestroy, popup: // Popup
        popup, popupClassName: popupClassName, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle, popupStyle: popupStyle, popupPlacement: popupPlacement, builtinPlacements: builtinPlacements = {}, popupAlign: popupAlign, zIndex: zIndex, stretch: stretch, getPopupClassNameFromAlign: getPopupClassNameFromAlign, fresh: fresh, unique: unique, alignPoint: alignPoint, onPopupClick: onPopupClick, onPopupAlign: onPopupAlign, arrow: // Arrow
        arrow, popupMotion: // Motion
        popupMotion, maskMotion: maskMotion, mobile: // Private
        mobile, ...restProps } = props;
        const mergedAutoDestroy = autoDestroy || false;
        const openUncontrolled = popupVisible === undefined;
        // =========================== Mobile ===========================
        const isMobile = !!mobile;
        // ========================== Context ===========================
        const subPopupElements = $acw62.useRef({});
        const parentContext = $acw62.useContext((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039));
        const context = $acw62.useMemo(()=>{
            return {
                registerSubPopup: (id, subPopupEle)=>{
                    subPopupElements.current[id] = subPopupEle;
                    parentContext?.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // ======================== UniqueContext =========================
        const uniqueContext = $acw62.useContext((0, $f9b439e1e53d6d59$export$14cc6d12cdc906c));
        // =========================== Popup ============================
        const id = (0, $bba066f19964922a$export$2e2bcd8739ae039)();
        const [popupEle, setPopupEle] = $acw62.useState(null);
        // Used for forwardRef popup. Not use internal
        const externalPopupRef = $acw62.useRef(null);
        const setPopupRef = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((node)=>{
            externalPopupRef.current = node;
            if ((0, $32e960eedc96a2ca$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext?.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        const [targetEle, setTargetEle] = $acw62.useState(null);
        // Used for forwardRef target. Not use internal
        const externalForwardRef = $acw62.useRef(null);
        const setTargetRef = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((node)=>{
            const domNode = (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(node);
            if ((0, $32e960eedc96a2ca$export$41e30d8dd0ba7a50)(domNode) && targetEle !== domNode) {
                setTargetEle(domNode);
                externalForwardRef.current = domNode;
            }
        });
        const cloneProps = {};
        const inPopupOrChild = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((ele)=>{
            const childDOM = targetEle;
            return childDOM?.contains(ele) || (0, $5cab3b9cddbc3e26$export$70e8259662bb498b)(childDOM)?.host === ele || ele === childDOM || popupEle?.contains(ele) || (0, $5cab3b9cddbc3e26$export$70e8259662bb498b)(popupEle)?.host === ele || ele === popupEle || Object.values(subPopupElements.current).some((subPopupEle)=>subPopupEle?.contains(ele) || ele === subPopupEle);
        });
        // =========================== Arrow ============================
        const innerArrow = arrow ? {
            // true and Object likely
            ...arrow !== true ? arrow : {}
        } : null;
        // ============================ Open ============================
        const [internalOpen, setInternalOpen] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultPopupVisible || false, popupVisible);
        const mergedOpen = internalOpen || false;
        // ========================== Children ==========================
        const child = $acw62.useMemo(()=>{
            const nextChild = typeof children === 'function' ? children({
                open: mergedOpen
            }) : children;
            return $acw62.Children.only(nextChild);
        }, [
            children,
            mergedOpen
        ]);
        const originChildProps = child?.props || {};
        // Support ref
        const isOpen = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(()=>mergedOpen);
        // Extract common options for UniqueProvider
        const getUniqueOptions = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((delay = 0)=>({
                popup: popup,
                target: targetEle,
                delay: delay,
                prefixCls: prefixCls,
                popupClassName: popupClassName,
                uniqueContainerClassName: uniqueContainerClassName,
                uniqueContainerStyle: uniqueContainerStyle,
                popupStyle: popupStyle,
                popupPlacement: popupPlacement,
                builtinPlacements: builtinPlacements,
                popupAlign: popupAlign,
                zIndex: zIndex,
                mask: mask,
                maskClosable: maskClosable,
                popupMotion: popupMotion,
                maskMotion: maskMotion,
                arrow: innerArrow,
                getPopupContainer: getPopupContainer,
                getPopupClassNameFromAlign: getPopupClassNameFromAlign,
                id: id,
                onEsc: onEsc
            }));
        // Handle controlled state changes for UniqueProvider
        // Only sync to UniqueProvider when it's controlled mode
        // If there is a parentContext, don't call uniqueContext methods
        (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
            if (uniqueContext && unique && targetEle && !openUncontrolled && !parentContext) {
                if (mergedOpen) uniqueContext.show(getUniqueOptions(mouseEnterDelay), isOpen);
                else uniqueContext.hide(mouseLeaveDelay);
            }
        }, [
            mergedOpen,
            targetEle
        ]);
        const openRef = $acw62.useRef(mergedOpen);
        openRef.current = mergedOpen;
        const internalTriggerOpen = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextOpen)=>{
            (0, $1u0KT.flushSync)(()=>{
                if (mergedOpen !== nextOpen) {
                    setInternalOpen(nextOpen);
                    onOpenChange?.(nextOpen);
                    onPopupVisibleChange?.(nextOpen);
                }
            });
        });
        // Trigger for delay
        const delayInvoke = (0, $b48804d74b076636$export$2e2bcd8739ae039)();
        const triggerOpen = (nextOpen, delay = 0)=>{
            // If it's controlled mode, always use internal trigger logic
            // UniqueProvider will be synced through useLayoutEffect
            if (popupVisible !== undefined) {
                delayInvoke(()=>{
                    internalTriggerOpen(nextOpen);
                }, delay);
                return;
            }
            // If UniqueContext exists and not controlled, pass delay to Provider instead of handling it internally
            // If there is a parentContext, don't call uniqueContext methods
            if (uniqueContext && unique && openUncontrolled && !parentContext) {
                if (nextOpen) uniqueContext.show(getUniqueOptions(delay), isOpen);
                else uniqueContext.hide(delay);
                return;
            }
            delayInvoke(()=>{
                internalTriggerOpen(nextOpen);
            }, delay);
        };
        function onEsc({ top: top }) {
            if (top) triggerOpen(false);
        }
        // ========================== Motion ============================
        const [inMotion, setInMotion] = $acw62.useState(false);
        (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)((firstMount)=>{
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        const [motionPrepareResolve, setMotionPrepareResolve] = $acw62.useState(null);
        // =========================== Align ============================
        const [mousePos, setMousePos] = $acw62.useState(null);
        const setMousePosByEvent = (event)=>{
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, scaleX, scaleY, alignInfo, onAlign] = (0, $a3ab468f9842aab3$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign, isMobile);
        const [showActions, hideActions] = (0, $65f8789299df97eb$export$2e2bcd8739ae039)(action, showAction, hideAction);
        const clickToShow = showActions.has('click');
        const clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        const triggerAlign = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(()=>{
            if (!inMotion) onAlign();
        });
        const onScroll = ()=>{
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $02923bfaa4b78dec$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
            if (mergedOpen && !builtinPlacements?.[popupPlacement]) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        const alignedClassName = $acw62.useMemo(()=>{
            const baseClassName = (0, $140ec2a5382714e1$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(baseClassName, getPopupClassNameFromAlign?.(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $acw62.useImperativeHandle(ref, ()=>({
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            }));
        // ========================== Stretch ===========================
        const [targetWidth, setTargetWidth] = $acw62.useState(0);
        const [targetHeight, setTargetHeight] = $acw62.useState(0);
        const syncTargetSize = ()=>{
            if (stretch && targetEle) {
                const rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        const onTargetResize = ()=>{
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        const onVisibleChanged = (visible)=>{
            setInMotion(false);
            onAlign();
            afterOpenChange?.(visible);
            afterPopupVisibleChange?.(visible);
        };
        // We will trigger align when motion is in prepare
        const onPrepare = ()=>new Promise((resolve)=>{
                syncTargetSize();
                setMotionPrepareResolve(()=>resolve);
            });
        (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     * @param eventName  Listen event name
     * @param nextOpen  Next open state after trigger
     * @param delay Delay to trigger open change
     * @param callback Callback if current event need additional action
     * @param ignoreCheck  Ignore current event if check return true
     */ function wrapperAction(eventName, nextOpen, delay, callback, ignoreCheck) {
            cloneProps[eventName] = (event, ...args)=>{
                if (!ignoreCheck || !ignoreCheck()) {
                    callback?.(event);
                    triggerOpen(nextOpen, delay);
                }
                // Pass to origin
                originChildProps[eventName]?.(event, ...args);
            };
        }
        // ======================= Action: Touch ========================
        const touchToShow = showActions.has('touch');
        const touchToHide = hideActions.has('touch');
        /** Used for prevent `hover` event conflict with mobile env */ const touchedRef = $acw62.useRef(false);
        if (touchToShow || touchToHide) cloneProps.onTouchStart = (...args)=>{
            touchedRef.current = true;
            if (openRef.current && touchToHide) triggerOpen(false);
            else if (!openRef.current && touchToShow) triggerOpen(true);
            // Pass to origin
            originChildProps.onTouchStart?.(...args);
        };
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = (event, ...args)=>{
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            originChildProps.onClick?.(event, ...args);
            touchedRef.current = false;
        };
        // Click to hide is special action since click popup element should not hide
        const onPopupPointerDown = (0, $81078b27d1014ac5$export$2e2bcd8739ae039)(mergedOpen, clickToHide || touchToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        const hoverToShow = showActions.has('hover');
        const hoverToHide = hideActions.has('hover');
        let onPopupMouseEnter;
        let onPopupMouseLeave;
        const ignoreMouseTrigger = ()=>{
            return touchedRef.current;
        };
        if (hoverToShow) {
            const onMouseEnterCallback = (event)=>{
                setMousePosByEvent(event);
            };
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            wrapperAction('onPointerEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            onPopupMouseEnter = (event)=>{
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle?.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = (event)=>{
                originChildProps.onMouseMove?.(event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            onPopupMouseLeave = ()=>{
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = (event, ...args)=>{
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            originChildProps.onContextMenu?.(event, ...args);
        };
        // ============================ Perf ============================
        const rendedRef = $acw62.useRef(false);
        rendedRef.current ||= forceRender || mergedOpen || inMotion;
        // =========================== Render ===========================
        const mergedChildrenProps = {
            ...originChildProps,
            ...cloneProps
        };
        // Pass props into cloneProps for nest usage
        const passedProps = {};
        const passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach((eventName)=>{
            if (restProps[eventName]) passedProps[eventName] = (...args)=>{
                mergedChildrenProps[eventName]?.(...args);
                restProps[eventName](...args);
            };
        });
        const arrowPos = {
            x: arrowX,
            y: arrowY
        };
        // =================== Resize Observer ===================
        // Use hook to observe target element resize
        // Pass targetEle directly instead of a function so the hook will re-observe when target changes
        (0, $706efe6f9b37dd6c$export$2e2bcd8739ae039)(mergedOpen, targetEle, onTargetResize);
        // Compose refs
        const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(setTargetRef, (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(child));
        // Child Node
        const triggerNode = /*#__PURE__*/ $acw62.cloneElement(child, {
            ...mergedChildrenProps,
            ...passedProps,
            ref: mergedRef
        });
        // Render
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, triggerNode, rendedRef.current && (!uniqueContext || !unique) && /*#__PURE__*/ $acw62.createElement((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $acw62.createElement((0, $d8446137fd226eb8$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(popupClassName, !isMobile && alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: popupMotion,
            maskMotion: maskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            onEsc: onEsc,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY,
            mobile: mobile
        })));
    });
    return Trigger;
}
var $a99c76d30a1f506f$export$2e2bcd8739ae039 = $a99c76d30a1f506f$export$55e99723d7f71b47((0, $5b46218595a40828$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $30796c32f374b477$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
}
const $30796c32f374b477$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, (0, $b956dab96d0e505b$export$f6e2535fb5126e54)(props) ? props(element.props || {}) : props);
};
function $30796c32f374b477$export$e530037191fcd5d7(element, props) {
    return $30796c32f374b477$export$2dfe578f95754f6a(element, element, props);
}



var $acw62 = parcelRequire("acw62");
const $a18b2f6f56546238$export$e4ec87ea71f29b41 = 'ant';
const $a18b2f6f56546238$export$eaca8ee5ed21b4e9 = 'anticon';
const $a18b2f6f56546238$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $a18b2f6f56546238$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$a18b2f6f56546238$export$e4ec87ea71f29b41}-${suffixCls}` : $a18b2f6f56546238$export$e4ec87ea71f29b41;
};
const $a18b2f6f56546238$export$a92f85ab3e9ad68b = /*#__PURE__*/ $acw62.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a18b2f6f56546238$var$defaultGetPrefixCls,
    iconPrefixCls: $a18b2f6f56546238$export$eaca8ee5ed21b4e9
});
const { Consumer: $a18b2f6f56546238$export$cd5442f2b8da7663 } = $a18b2f6f56546238$export$a92f85ab3e9ad68b;
const $a18b2f6f56546238$var$EMPTY_OBJECT = {};
function $a18b2f6f56546238$export$46f4bd6436a25a31(propName) {
    const context = $acw62.useContext($a18b2f6f56546238$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, renderEmpty: renderEmpty } = context;
    const propValue = context[propName];
    return {
        classNames: $a18b2f6f56546238$var$EMPTY_OBJECT,
        styles: $a18b2f6f56546238$var$EMPTY_OBJECT,
        ...propValue,
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer,
        renderEmpty: renderEmpty
    };
}


"use client";
const $85fdd00f8d68f0b6$var$MotionContent = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    // This will never reach since we will not render this when no children
    /* istanbul ignore next */ if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), {
        visible: true,
        motionName: `${rootPrefixCls}-fade`,
        motionAppear: true,
        motionEnter: true,
        motionLeave: false,
        removeOnLeave: false
    }, ({ style: motionStyle, className: motionClassName })=>{
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(children, (oriProps)=>({
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(oriProps.className, motionClassName),
                style: {
                    ...oriProps.style,
                    ...motionStyle
                }
            }));
    });
};
var $85fdd00f8d68f0b6$export$2e2bcd8739ae039 = $85fdd00f8d68f0b6$var$MotionContent;


"use client";
const $01bf4fb3f56b5e64$var$cachedPlacements = [
    null,
    null
];
function $01bf4fb3f56b5e64$var$uniqueBuiltinPlacements(ori) {
    if ($01bf4fb3f56b5e64$var$cachedPlacements[0] !== ori) {
        const target = {};
        Object.keys(ori).forEach((placement)=>{
            target[placement] = {
                ...ori[placement],
                dynamicInset: false
            };
        });
        $01bf4fb3f56b5e64$var$cachedPlacements[0] = ori;
        $01bf4fb3f56b5e64$var$cachedPlacements[1] = target;
    }
    return $01bf4fb3f56b5e64$var$cachedPlacements[1];
}
const $01bf4fb3f56b5e64$var$UniqueProvider = ({ children: children })=>{
    const renderPopup = (options)=>{
        const { id: id, builtinPlacements: builtinPlacements, popup: popup } = options;
        const popupEle = typeof popup === 'function' ? popup() : popup;
        const parsedPlacements = $01bf4fb3f56b5e64$var$uniqueBuiltinPlacements(builtinPlacements);
        return {
            ...options,
            getPopupContainer: null,
            arrow: false,
            popup: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $85fdd00f8d68f0b6$export$2e2bcd8739ae039), {
                key: id
            }, popupEle),
            builtinPlacements: parsedPlacements
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $227d7e98ed1ad5ac$export$2e2bcd8739ae039), {
        postTriggerProps: renderPopup
    }, children);
};
var $01bf4fb3f56b5e64$export$2e2bcd8739ae039 = $01bf4fb3f56b5e64$var$UniqueProvider;




var $acw62 = parcelRequire("acw62");
"use client";
const $6ba6819805fb0a44$var$DisabledContext = /*#__PURE__*/ $acw62.createContext(false);
const $6ba6819805fb0a44$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $acw62.useContext($6ba6819805fb0a44$var$DisabledContext);
    return /*#__PURE__*/ $acw62.createElement($6ba6819805fb0a44$var$DisabledContext.Provider, {
        value: disabled ?? originDisabled
    }, children);
};
var $6ba6819805fb0a44$export$2e2bcd8739ae039 = $6ba6819805fb0a44$var$DisabledContext;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
const $3e100f55cf8f3689$var$SizeContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $3e100f55cf8f3689$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $acw62.useContext($3e100f55cf8f3689$var$SizeContext);
    return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $3e100f55cf8f3689$export$2e2bcd8739ae039 = $3e100f55cf8f3689$var$SizeContext;


function $1e1ca3bea54a77f7$var$useConfig() {
    const componentDisabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const componentSize = (0, $acw62.useContext)((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $1e1ca3bea54a77f7$export$2e2bcd8739ae039 = $1e1ca3bea54a77f7$var$useConfig;



var $acw62 = parcelRequire("acw62");





function $a1000671d52972e2$export$2e2bcd8739ae039(theme, parentTheme, config) {
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? {
        ...(0, $d6a0cd0c670c9aed$export$f84bd70098573c5c),
        hashed: parentTheme?.hashed ?? (0, $d6a0cd0c670c9aed$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme?.cssVar
    } : parentTheme;
    // Generate a unique key for cssVar
    const themeKey = (0, $acw62.useId)();
    return (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>{
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = {
            ...parentThemeConfig.components
        };
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = {
                ...mergedComponents[componentName],
                ...theme.components[componentName]
            };
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = {
            prefix: config?.prefixCls,
            // Same as prefixCls by default
            ...parentThemeConfig.cssVar,
            ...themeConfig.cssVar,
            key: themeConfig.cssVar?.key || cssVarKey
        };
        // Base token
        return {
            ...parentThemeConfig,
            ...themeConfig,
            token: {
                ...parentThemeConfig.token,
                ...themeConfig.token
            },
            components: mergedComponents,
            cssVar: mergedCssVar
        };
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $aadef4b21b7a3672$export$2e2bcd8739ae039 = '6.3.7';


"use client";
var $d8781535a68aa2aa$export$2e2bcd8739ae039 = (0, $aadef4b21b7a3672$export$2e2bcd8739ae039);







function $49cdc08d8072d4ba$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $49cdc08d8072d4ba$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($49cdc08d8072d4ba$var$isStableColor(r) && $49cdc08d8072d4ba$var$isStableColor(g) && $49cdc08d8072d4ba$var$isStableColor(b)) return new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $49cdc08d8072d4ba$export$2e2bcd8739ae039 = $49cdc08d8072d4ba$var$getAlphaColor;


function $e6266db79468900d$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override, ...restToken } = derivativeToken;
    const overrideTokens = {
        ...override
    };
    Object.keys((0, $b1208bbc03407e2e$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = {
        ...restToken,
        ...overrideTokens
    };
    const shadowBaseColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(mergedToken.colorShadow);
    const shadowBaseAlpha = shadowBaseColor.a;
    const getShadowColor = (alpha)=>shadowBaseColor.clone().setA(shadowBaseAlpha * alpha).toRgbString();
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    const screenXXXL = 1920;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = {
        ...mergedToken,
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowSecondary: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowTertiary: `
      0 1px 2px 0 ${getShadowColor(0.03)},
      0 1px 6px -1px ${getShadowColor(0.02)},
      0 2px 4px 0 ${getShadowColor(0.02)}
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        screenXXLMax: screenXXXL - 1,
        screenXXXL: screenXXXL,
        screenXXXLMin: screenXXXL,
        boxShadowPopoverArrow: `2px 2px 5px ${getShadowColor(0.05)}`,
        boxShadowCard: `
      0 1px 2px -2px ${getShadowColor(0.16)},
      0 3px 6px 0 ${getShadowColor(0.12)},
      0 5px 12px 4px ${getShadowColor(0.09)}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 ${getShadowColor(0.08)},
      -3px 0 6px -4px ${getShadowColor(0.12)},
      -9px 0 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 ${getShadowColor(0.08)},
      3px 0 6px -4px ${getShadowColor(0.12)},
      9px 0 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 ${getShadowColor(0.08)},
      0 -3px 6px -4px ${getShadowColor(0.12)},
      0 -9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowTabsOverflowLeft: `inset 10px 0 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowRight: `inset -10px 0 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowTop: `inset 0 10px 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowBottom: `inset 0 -10px 8px -8px ${getShadowColor(0.08)}`,
        // Override AliasToken
        ...overrideTokens
    };
    return aliasToken;
}


const $d014fefdb4420ef5$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $d014fefdb4420ef5$export$738b109e247a462c = {
    motionBase: true,
    motionUnit: true
};
const $d014fefdb4420ef5$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true,
    screenXXLMax: true,
    screenXXXL: true,
    screenXXXLMin: true
};
const $d014fefdb4420ef5$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override, ...components } = overrideToken;
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        override: override
    };
    // Format if needed
    mergedDerivativeToken = (0, $e6266db79468900d$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme, ...componentTokens } = value;
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $d014fefdb4420ef5$export$18602cb46ae80b62({
            ...mergedDerivativeToken,
            ...componentTokens
        }, {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $d014fefdb4420ef5$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: ctxCssVar, zeroRuntime: zeroRuntime } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $d6a0cd0c670c9aed$export$69b0ebb9efcddb30));
    const { csp: csp } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const cssVar = {
        prefix: ctxCssVar?.prefix ?? 'ant',
        key: ctxCssVar?.key ?? 'css-var-root'
    };
    const salt = `${(0, $d8781535a68aa2aa$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $16712192479069fd$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $fb047830d7776fb2$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $d014fefdb4420ef5$export$18602cb46ae80b62,
        cssVar: {
            ...cssVar,
            unitless: $d014fefdb4420ef5$export$c6b9faa6b723d31a,
            ignore: $d014fefdb4420ef5$export$738b109e247a462c,
            preserve: $d014fefdb4420ef5$var$preserve
        },
        nonce: csp?.nonce
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar,
        !!zeroRuntime
    ];
}


"use client";
const $57278e23ed3ca8fa$var$MotionCacheContext = /*#__PURE__*/ $acw62.createContext(true);
function $57278e23ed3ca8fa$export$2e2bcd8739ae039(props) {
    const parentMotion = $acw62.useContext($57278e23ed3ca8fa$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $acw62.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $acw62.createElement($57278e23ed3ca8fa$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $acw62.createElement((0, $bd5d6a6d84461ef6$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $acw62 = parcelRequire("acw62");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $a098b6503d6d9fdd$var$PropWarning = /*#__PURE__*/ $acw62.memo((props)=>{
    const { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = props;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $a098b6503d6d9fdd$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $4733a3b3eb18f80d$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $4733a3b3eb18f80d$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $4733a3b3eb18f80d$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $4733a3b3eb18f80d$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $4733a3b3eb18f80d$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset ?? 1,
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(', ')
    });
const $4733a3b3eb18f80d$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': $4733a3b3eb18f80d$export$6539948f0a737e39(token, offset)
    });
const $4733a3b3eb18f80d$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            ...$4733a3b3eb18f80d$export$a44db842bcb28231(token),
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $4733a3b3eb18f80d$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: {
            ...resetFontStyle,
            ...resetStyle,
            [prefixSelector]: resetStyle
        }
    };
};
const $4733a3b3eb18f80d$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: {
            ...$4733a3b3eb18f80d$export$171ccda7bc085e59(),
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        }
    });
const $4733a3b3eb18f80d$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none',
        ...$4733a3b3eb18f80d$export$a44db842bcb28231(token),
        '&:hover': {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        '&:focus': {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        '&:active': {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });



const $af55bb63f7325a53$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $7927865cee518bb3$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp?.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>(0, $4733a3b3eb18f80d$export$f1a0b31dfb234e7e)(iconPrefixCls));
};
var $af55bb63f7325a53$export$2e2bcd8739ae039 = $af55bb63f7325a53$var$useResetIconStyle;


"use client";
/**
 * This component registers icon styles inside the DesignTokenContext.Provider
 * so that CSS variables use the correct cssVar key from the theme config.
 */ const $7ed5e10e08c170f8$var$IconStyle = ({ iconPrefixCls: iconPrefixCls, csp: csp })=>{
    (0, $af55bb63f7325a53$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    return null;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $7ed5e10e08c170f8$var$existThemeConfig = false;
const $7ed5e10e08c170f8$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $7ed5e10e08c170f8$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $7ed5e10e08c170f8$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $7ed5e10e08c170f8$var$globalPrefixCls;
let $7ed5e10e08c170f8$var$globalIconPrefixCls;
let $7ed5e10e08c170f8$var$globalTheme;
let $7ed5e10e08c170f8$var$globalHolderRender;
function $7ed5e10e08c170f8$var$getGlobalPrefixCls() {
    return $7ed5e10e08c170f8$var$globalPrefixCls || (0, $a18b2f6f56546238$export$e4ec87ea71f29b41);
}
function $7ed5e10e08c170f8$var$getGlobalIconPrefixCls() {
    return $7ed5e10e08c170f8$var$globalIconPrefixCls || (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
}
const $7ed5e10e08c170f8$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $7ed5e10e08c170f8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $7ed5e10e08c170f8$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $7ed5e10e08c170f8$var$globalHolderRender = holderRender;
    if (theme) $7ed5e10e08c170f8$var$globalTheme = theme;
};
const $7ed5e10e08c170f8$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$7ed5e10e08c170f8$var$getGlobalPrefixCls()}-${suffixCls}` : $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $7ed5e10e08c170f8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($7ed5e10e08c170f8$var$globalPrefixCls) return $7ed5e10e08c170f8$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$7ed5e10e08c170f8$var$globalTheme,
        holderRender: $7ed5e10e08c170f8$var$globalHolderRender
    });
const $7ed5e10e08c170f8$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, affix: affix, anchor: anchor, app: app, form: form, locale: rawLocale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, masonry: masonry, menu: menu, pagination: pagination, input: input, textArea: textArea, otp: otp, empty: empty, badge: badge, radio: radio, rate: rate, ribbon: ribbon, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, cardMeta: cardMeta, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, qrcode: qrcode, floatButton: floatButton, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect, watermark: watermark } = props;
    // https://github.com/ant-design/ant-design/issues/57295
    const locale = $acw62.useMemo(()=>{
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(rawLocale) && Object.prototype.hasOwnProperty.call(rawLocale, 'default') && rawLocale.default?.locale) return rawLocale.default;
        return rawLocale;
    }, [
        rawLocale
    ]);
    // =================================== Context ===================================
    const getPrefixCls = $acw62.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    const mergedTheme = (0, $a1000671d52972e2$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        affix: affix,
        anchor: anchor,
        app: app,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth ?? dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        otp: otp,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        masonry: masonry,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        ribbon: ribbon,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        cardMeta: cardMeta,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        qrcode: qrcode,
        floatButton: floatButton,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect,
        watermark: watermark
    };
    const config = {
        ...parentContext
    };
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $7ed5e10e08c170f8$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = {
        autoInsertSpace: autoInsertSpaceInButton,
        ...config.button
    };
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039));
    const memoIconContextValue = $acw62.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$IconStyle, {
        iconPrefixCls: iconPrefixCls,
        csp: csp
    }), /*#__PURE__*/ $acw62.createElement((0, $a098b6503d6d9fdd$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $acw62.useMemo(()=>(0, $4ee33241e7a6f41e$export$4950aa0f605343fb)((0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Form?.defaultValidateMessages || {}, memoedConfig.locale?.Form?.defaultValidateMessages || {}, memoedConfig.form?.validateMessages || {}, form?.validateMessages || {}), [
        memoedConfig,
        form?.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $acw62.createElement((0, $efabd6732f69a6da$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $acw62.createElement((0, $766ff256ac32087c$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $766ff256ac32087c$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $acw62.createElement((0, $6bacc63174d40f3c$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $acw62.createElement((0, $57278e23ed3ca8fa$export$2e2bcd8739ae039), null, childNode);
    // ================================ Tooltip Unique ===============================
    if (tooltip?.unique) childNode = /*#__PURE__*/ $acw62.createElement((0, $01bf4fb3f56b5e64$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $acw62.useMemo(()=>{
        const { algorithm: algorithm, token: token, components: components, cssVar: cssVar, ...rest } = mergedTheme || {};
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(algorithm) : (0, $16712192479069fd$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = {
                ...componentToken
            };
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = {
            ...(0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
            ...token
        };
        return {
            ...rest,
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: {
                override: mergedToken,
                ...parsedComponents
            },
            cssVar: cssVar
        };
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $acw62.createElement((0, $d6a0cd0c670c9aed$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $acw62.createElement((0, $5bd796dbed593bbb$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $7ed5e10e08c170f8$var$ConfigProvider = (props)=>{
    const context = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const antLocale = $acw62.useContext((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$ProviderChildren, {
        parentContext: context,
        legacyLocale: antLocale,
        ...props
    });
};
$7ed5e10e08c170f8$var$ConfigProvider.ConfigContext = (0, $a18b2f6f56546238$export$a92f85ab3e9ad68b);
$7ed5e10e08c170f8$var$ConfigProvider.SizeContext = (0, $3e100f55cf8f3689$export$2e2bcd8739ae039);
$7ed5e10e08c170f8$var$ConfigProvider.config = $7ed5e10e08c170f8$var$setGlobalConfig;
$7ed5e10e08c170f8$var$ConfigProvider.useConfig = (0, $1e1ca3bea54a77f7$export$2e2bcd8739ae039);
Object.defineProperty($7ed5e10e08c170f8$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $3e100f55cf8f3689$export$2e2bcd8739ae039;
    }
});
var $7ed5e10e08c170f8$export$2e2bcd8739ae039 = $7ed5e10e08c170f8$var$ConfigProvider;




var $acw62 = parcelRequire("acw62");
const $368377cf0f14dd00$export$964282a2c3979546 = /*#__PURE__*/ $acw62.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b54d53674fa39ea0$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $b54d53674fa39ea0$export$2e2bcd8739ae039 = $b54d53674fa39ea0$var$BarsOutlined;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $1beccdf56290315b$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $1beccdf56290315b$export$491112666e282270(valid, message) {
    (0, $3ef2f9e39800a1a1$export$82934adf09101657)(valid, `[@ant-design/icons] ${message}`);
}
function $1beccdf56290315b$export$ab652842c37578f4(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function $1beccdf56290315b$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$1beccdf56290315b$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1beccdf56290315b$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, {
        key: key,
        ...$1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$1beccdf56290315b$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, {
        key: key,
        ...$1beccdf56290315b$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$1beccdf56290315b$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
function $1beccdf56290315b$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $1beccdf56290315b$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
const $1beccdf56290315b$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const $1beccdf56290315b$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin {
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $1beccdf56290315b$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer } = (0, $acw62.useContext)((0, $6bacc63174d40f3c$export$2e2bcd8739ae039));
    let mergedStyleStr = $1beccdf56290315b$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $acw62.useEffect)(()=>{
        const ele = eleRef.current;
        const shadowRoot = (0, $5cab3b9cddbc3e26$export$70e8259662bb498b)(ele);
        (0, $0d6d009b0876809a$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $c52e7cd4d4f30fad$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $c52e7cd4d4f30fad$var$setTwoToneColors({ primaryColor: primaryColor, secondaryColor: secondaryColor }) {
    $c52e7cd4d4f30fad$var$twoToneColorPalette.primaryColor = primaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor);
    $c52e7cd4d4f30fad$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $c52e7cd4d4f30fad$var$getTwoToneColors() {
    return {
        ...$c52e7cd4d4f30fad$var$twoToneColorPalette
    };
}
const $c52e7cd4d4f30fad$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: primaryColor, secondaryColor: secondaryColor, ...restProps } = props;
    const svgRef = $acw62.useRef(null);
    let colors = $c52e7cd4d4f30fad$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor)
    };
    (0, $1beccdf56290315b$export$938b1f86b61613d0)(svgRef);
    (0, $1beccdf56290315b$export$491112666e282270)((0, $1beccdf56290315b$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, $1beccdf56290315b$export$ab652842c37578f4)(icon)) return null;
    let target = icon;
    if (target && typeof target.icon === 'function') target = {
        ...target,
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
    return (0, $1beccdf56290315b$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$c52e7cd4d4f30fad$var$IconBase.displayName = 'IconReact';
$c52e7cd4d4f30fad$var$IconBase.getTwoToneColors = $c52e7cd4d4f30fad$var$getTwoToneColors;
$c52e7cd4d4f30fad$var$IconBase.setTwoToneColors = $c52e7cd4d4f30fad$var$setTwoToneColors;
var $c52e7cd4d4f30fad$export$2e2bcd8739ae039 = $c52e7cd4d4f30fad$var$IconBase;




function $27dd37ce58e7c6e8$export$8a145f34580ff02b(twoToneColor) {
    const [primaryColor, secondaryColor] = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor);
    return (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $27dd37ce58e7c6e8$export$abc7c554784cb4a7() {
    const colors = (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
function $7714637e9c1f1f3f$var$_extends() {
    $7714637e9c1f1f3f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7714637e9c1f1f3f$var$_extends.apply(this, arguments);
}
// Initial setting
// should move it to antd main repo?
(0, $27dd37ce58e7c6e8$export$8a145f34580ff02b)((0, $0b4842326956570d$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
const $7714637e9c1f1f3f$var$Icon = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: // other
    twoToneColor, ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $acw62.useContext((0, $6bacc63174d40f3c$export$2e2bcd8739ae039));
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor);
    return /*#__PURE__*/ $acw62.createElement("span", $7714637e9c1f1f3f$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$7714637e9c1f1f3f$var$Icon.getTwoToneColor = (0, $27dd37ce58e7c6e8$export$abc7c554784cb4a7);
$7714637e9c1f1f3f$var$Icon.setTwoToneColor = (0, $27dd37ce58e7c6e8$export$8a145f34580ff02b);
var $7714637e9c1f1f3f$export$2e2bcd8739ae039 = $7714637e9c1f1f3f$var$Icon;


function $8b88bbac7ec7b356$var$_extends() {
    $8b88bbac7ec7b356$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b88bbac7ec7b356$var$_extends.apply(this, arguments);
}
const $8b88bbac7ec7b356$var$BarsOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $8b88bbac7ec7b356$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b54d53674fa39ea0$export$2e2bcd8739ae039)
    }));
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const $8b88bbac7ec7b356$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($8b88bbac7ec7b356$var$BarsOutlined);
var $8b88bbac7ec7b356$export$2e2bcd8739ae039 = $8b88bbac7ec7b356$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $766a51baf3f136aa$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $766a51baf3f136aa$export$2e2bcd8739ae039 = $766a51baf3f136aa$var$LeftOutlined;



function $1e62197f718e4845$var$_extends() {
    $1e62197f718e4845$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e62197f718e4845$var$_extends.apply(this, arguments);
}
const $1e62197f718e4845$var$LeftOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1e62197f718e4845$var$_extends({}, props, {
        ref: ref,
        icon: (0, $766a51baf3f136aa$export$2e2bcd8739ae039)
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const $1e62197f718e4845$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1e62197f718e4845$var$LeftOutlined);
var $1e62197f718e4845$export$2e2bcd8739ae039 = $1e62197f718e4845$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $73624b371df38195$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $73624b371df38195$export$2e2bcd8739ae039 = $73624b371df38195$var$RightOutlined;



function $ae197ef38b34eab8$var$_extends() {
    $ae197ef38b34eab8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae197ef38b34eab8$var$_extends.apply(this, arguments);
}
const $ae197ef38b34eab8$var$RightOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $ae197ef38b34eab8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $73624b371df38195$export$2e2bcd8739ae039)
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const $ae197ef38b34eab8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ae197ef38b34eab8$var$RightOutlined);
var $ae197ef38b34eab8$export$2e2bcd8739ae039 = $ae197ef38b34eab8$var$RefIcon;









var $acw62 = parcelRequire("acw62");
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}


function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}





function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}



var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}





var $a7862c0e3a5a168d$var$AbstractCalculator = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $a7862c0e3a5a168d$export$2e2bcd8739ae039 = $a7862c0e3a5a168d$var$AbstractCalculator;


var $2a874be19a32c8c7$var$CALC_UNIT = 'CALC_UNIT';
var $2a874be19a32c8c7$var$regexp = new RegExp($2a874be19a32c8c7$var$CALC_UNIT, 'g');
function $2a874be19a32c8c7$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($2a874be19a32c8c7$var$CALC_UNIT);
    return value;
}
var $2a874be19a32c8c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $2a874be19a32c8c7$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($2a874be19a32c8c7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($2a874be19a32c8c7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($2a874be19a32c8c7$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $a7862c0e3a5a168d$export$2e2bcd8739ae039));









var $5e6928769c8bf532$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $a7862c0e3a5a168d$export$2e2bcd8739ae039));
var $5e6928769c8bf532$export$2e2bcd8739ae039 = $5e6928769c8bf532$var$NumCalculator;


var $dc9da9f8a3dae284$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $2a874be19a32c8c7$export$2e2bcd8739ae039) : (0, $5e6928769c8bf532$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $dc9da9f8a3dae284$export$2e2bcd8739ae039 = $dc9da9f8a3dae284$var$genCalc;


var $cea91e68076a573d$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $cea91e68076a573d$export$2e2bcd8739ae039 = $cea91e68076a573d$var$getCompVarPrefix;





function $e6f0d963e7f65a73$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $e6f0d963e7f65a73$export$2e2bcd8739ae039 = $e6f0d963e7f65a73$var$getComponentToken;




var $6f8035da4ba7a5b0$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $6f8035da4ba7a5b0$var$recording = true;
function $6f8035da4ba7a5b0$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$6f8035da4ba7a5b0$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $6f8035da4ba7a5b0$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $6f8035da4ba7a5b0$var$recording = true;
    return ret;
}
var $6f8035da4ba7a5b0$export$754a5e2d36c5fa7a = {};
var $6f8035da4ba7a5b0$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $6f8035da4ba7a5b0$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $6f8035da4ba7a5b0$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $6f8035da4ba7a5b0$var$noop;
    if ($6f8035da4ba7a5b0$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($6f8035da4ba7a5b0$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $6f8035da4ba7a5b0$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (_statistic$componentN = $6f8035da4ba7a5b0$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $6f8035da4ba7a5b0$export$2e2bcd8739ae039 = $6f8035da4ba7a5b0$var$statisticToken;


function $0b5032654026988b$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $0b5032654026988b$export$2e2bcd8739ae039 = $0b5032654026988b$var$getDefaultComponentToken;



function $60c98148595dbf83$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $f97444ff16d95e90$export$523c0b569236b342)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $f97444ff16d95e90$export$523c0b569236b342)(value);
            }).join(','), ")");
        }
    };
}
var $60c98148595dbf83$export$2e2bcd8739ae039 = $60c98148595dbf83$var$genMaxMin;








var $acw62 = parcelRequire("acw62");
var $270f255e5d3fe4f5$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $270f255e5d3fe4f5$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $b8f57191916382d3$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $270f255e5d3fe4f5$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $270f255e5d3fe4f5$var$uniqueMap = new $270f255e5d3fe4f5$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $270f255e5d3fe4f5$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var cachedValue = $270f255e5d3fe4f5$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $270f255e5d3fe4f5$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $270f255e5d3fe4f5$export$2e2bcd8739ae039 = $270f255e5d3fe4f5$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $21b691332eabc800$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $21b691332eabc800$export$2e2bcd8739ae039 = $21b691332eabc800$var$useDefaultCSP;


function $b5ac6ed04e4484e1$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $21b691332eabc800$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var hashId = useStyle(prefixCls, rootCls);
            // Resolve function type to get dynamic extra prefix
            var extraPrefixCls = options === null || options === void 0 ? void 0 : options.extraCssVarPrefixCls;
            var resolvedExtraPrefixCls = typeof extraPrefixCls === 'function' ? extraPrefixCls({
                prefixCls: prefixCls,
                rootCls: rootCls
            }) : extraPrefixCls;
            var cssVarCls = useCSSVar(resolvedExtraPrefixCls !== null && resolvedExtraPrefixCls !== void 0 && resolvedExtraPrefixCls.length ? [
                rootCls
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(resolvedExtraPrefixCls)) : rootCls);
            return [
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, prefixToken = options.prefixToken, ignore = options.ignore;
        return function(rootCls) {
            var _useToken = useToken(), cssVar = _useToken.cssVar, realToken = _useToken.realToken;
            var csp = useCSP();
            (0, $4766d7657208f51d$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls,
                nonce: function nonce() {
                    return csp.nonce;
                }
            }, function() {
                var defaultToken = (0, $0b5032654026988b$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $e6f0d963e7f65a73$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                if (defaultToken) Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return cssVar === null || cssVar === void 0 ? void 0 : cssVar.key;
        };
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken2 = useToken(), theme = _useToken2.theme, realToken = _useToken2.realToken, hashId = _useToken2.hashId, token = _useToken2.token, cssVar = _useToken2.cssVar, zeroRuntime = _useToken2.zeroRuntime;
            // Update of `disabledRuntimeStyle` would cause React hook error, so memoized it and never update.
            var memoizedZeroRuntime = (0, $acw62.useMemo)(function() {
                return zeroRuntime;
            }, []);
            if (memoizedZeroRuntime) return hashId;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = 'css';
            // Use unique memo to share the result across all instances
            var calc = (0, $270f255e5d3fe4f5$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $5a4d26b111585357$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $5a4d26b111585357$export$309b3b095f0c7662)(key, (0, $cea91e68076a573d$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $dc9da9f8a3dae284$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $60c98148595dbf83$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $7927865cee518bb3$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            (0, $7927865cee518bb3$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $6f8035da4ba7a5b0$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $0b5032654026988b$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $e6f0d963e7f65a73$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (defaultComponentToken && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $5a4d26b111585357$export$309b3b095f0c7662)(key, (0, $cea91e68076a573d$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    max: max,
                    min: min
                }, defaultComponentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return hashId;
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref) {
            var prefixCls = _ref.prefixCls, _ref$rootCls = _ref.rootCls, rootCls = _ref$rootCls === void 0 ? prefixCls : _ref$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $b5ac6ed04e4484e1$export$2e2bcd8739ae039 = $b5ac6ed04e4484e1$var$genStyleUtils;









const { genStyleHooks: $0f84270bd7498f9c$export$51ec95de45185b42, genComponentStyleHook: $0f84270bd7498f9c$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $0f84270bd7498f9c$export$1537386bc155ea56 } = (0, $b5ac6ed04e4484e1$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar, zeroRuntime] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar,
            zeroRuntime: zeroRuntime
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        return csp ?? {};
    },
    getResetStyles: (token, config)=>{
        const linkStyle = (0, $4733a3b3eb18f80d$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $4733a3b3eb18f80d$export$f1a0b31dfb234e7e)(config?.prefix.iconPrefixCls ?? (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $4733a3b3eb18f80d$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $d014fefdb4420ef5$export$c6b9faa6b723d31a)
});
const $0f84270bd7498f9c$export$d82b8f66c5649e14 = (antCls, component)=>{
    const cssPrefix = `--${antCls.replace(/\./g, '')}-${component}-`;
    const varName = (name)=>{
        return `${cssPrefix}${name}`;
    };
    const varRef = (name, fallback)=>{
        return fallback ? `var(${cssPrefix}${name}, ${fallback})` : `var(${cssPrefix}${name})`;
    };
    return [
        varName,
        varRef
    ];
};


const $cac338994a0b926f$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $cac338994a0b926f$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $cac338994a0b926f$export$da0be9ab56e785fc = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
var $cac338994a0b926f$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Layout', $cac338994a0b926f$var$genLayoutStyle, $cac338994a0b926f$export$9ca1be8807fe0675, {
    deprecatedTokens: $cac338994a0b926f$export$da0be9ab56e785fc
});



const $43e40a2764aee753$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: 'hidden'
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: 'absolute',
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: siderBg,
                borderRadius: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusLG)} 0`,
                cursor: 'pointer',
                transition: `background-color ${motionDurationSlow} ease`,
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    background: 'transparent',
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                '&:hover::after': {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                '&-right': {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusLG)} 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusLG)}`
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `1px solid ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $43e40a2764aee753$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Layout',
    'Sider'
], $43e40a2764aee753$var$genSiderStyle, (0, $cac338994a0b926f$export$9ca1be8807fe0675), {
    deprecatedTokens: (0, $cac338994a0b926f$export$da0be9ab56e785fc)
});


"use client";
const $f4e67dbf2453f541$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px',
    xxxl: `1839.98px`
};
const $f4e67dbf2453f541$var$isNumeric = (val)=>!Number.isNaN(Number.parseFloat(val)) && Number.isFinite(Number(val));
const $f4e67dbf2453f541$export$63554aebd2a6d54c = /*#__PURE__*/ $acw62.createContext({});
const $f4e67dbf2453f541$var$generateId = (()=>{
    let i = 0;
    return (prefix = '')=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $f4e67dbf2453f541$var$Sider = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = 'dark', style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint, ...otherProps } = props;
    const { siderHook: siderHook } = (0, $acw62.useContext)((0, $368377cf0f14dd00$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $acw62.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse?.(value, type);
    };
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $43e40a2764aee753$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $acw62.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint?.(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $acw62.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current?.(mql);
        }
        let mql;
        if (typeof window?.matchMedia !== 'undefined' && breakpoint && breakpoint in $f4e67dbf2453f541$var$dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${$f4e67dbf2453f541$var$dimensionMaxMap[breakpoint]})`);
            if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            if (typeof mql?.removeEventListener === 'function') mql.removeEventListener('change', responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $acw62.useEffect)(()=>{
        const uniqueId = $f4e67dbf2453f541$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $f4e67dbf2453f541$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = Number.parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $acw62.createElement("span", {
        onClick: toggle,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $acw62.createElement((0, $8b88bbac7ec7b356$export$2e2bcd8739ae039), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = {
        ...style,
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        // Fix width transition bug in IE11
        minWidth: siderWidth,
        // https://github.com/ant-design/ant-design/issues/6349
        width: siderWidth
    };
    const siderCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: Number.parseFloat(siderWidth) === 0
    }, className, hashId, cssVarCls);
    const contextValue = $acw62.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ $acw62.createElement($f4e67dbf2453f541$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement("aside", {
        className: siderCls,
        ...divProps,
        style: divStyle,
        ref: ref
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-children`
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null));
});
var $f4e67dbf2453f541$export$2e2bcd8739ae039 = $f4e67dbf2453f541$var$Sider;


function $a27b05490eb06301$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === 'boolean') return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children);
    return childNodes.some((node)=>node.type === (0, $f4e67dbf2453f541$export$2e2bcd8739ae039));
}



"use client";
const $ea0a526399f02a88$var$generator = ({ suffixCls: suffixCls, tagName: tagName, displayName: displayName })=>{
    return (Component)=>{
        const Adapter = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement(Component, {
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName,
                ...props
            }));
        return Adapter;
    };
};
const $ea0a526399f02a88$var$Basic = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName, ...others } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const [hashId] = (0, $cac338994a0b926f$export$2e2bcd8739ae039)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return /*#__PURE__*/ $acw62.createElement(TagName, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(customizePrefixCls || prefixWithSuffixCls, className, hashId),
        ref: ref,
        ...others
    });
});
const $ea0a526399f02a88$var$BasicLayout = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [siders, setSiders] = $acw62.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style, ...others } = props;
    const passedProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(others, [
        'suffixCls'
    ]);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('layout');
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const mergedHasSider = (0, $a27b05490eb06301$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [hashId, cssVarCls] = (0, $cac338994a0b926f$export$2e2bcd8739ae039)(prefixCls);
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const contextValue = $acw62.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return /*#__PURE__*/ $acw62.createElement((0, $368377cf0f14dd00$export$964282a2c3979546).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement(Tag, {
        ref: ref,
        className: classString,
        style: {
            ...contextStyle,
            ...style
        },
        ...passedProps
    }, children));
});
const $ea0a526399f02a88$var$Layout = $ea0a526399f02a88$var$generator({
    tagName: 'div',
    displayName: 'Layout'
})($ea0a526399f02a88$var$BasicLayout);
const $ea0a526399f02a88$export$8b251419efc915eb = $ea0a526399f02a88$var$generator({
    suffixCls: 'header',
    tagName: 'header',
    displayName: 'Header'
})($ea0a526399f02a88$var$Basic);
const $ea0a526399f02a88$export$a06f1c675e846f6f = $ea0a526399f02a88$var$generator({
    suffixCls: 'footer',
    tagName: 'footer',
    displayName: 'Footer'
})($ea0a526399f02a88$var$Basic);
const $ea0a526399f02a88$export$7c6e2c02157bb7d2 = $ea0a526399f02a88$var$generator({
    suffixCls: 'content',
    tagName: 'main',
    displayName: 'Content'
})($ea0a526399f02a88$var$Basic);
var $ea0a526399f02a88$export$2e2bcd8739ae039 = $ea0a526399f02a88$var$Layout;



"use client";
const $49639f13efb591ba$var$Layout = (0, $ea0a526399f02a88$export$2e2bcd8739ae039);
$49639f13efb591ba$var$Layout.Header = (0, $ea0a526399f02a88$export$8b251419efc915eb);
$49639f13efb591ba$var$Layout.Footer = (0, $ea0a526399f02a88$export$a06f1c675e846f6f);
$49639f13efb591ba$var$Layout.Content = (0, $ea0a526399f02a88$export$7c6e2c02157bb7d2);
$49639f13efb591ba$var$Layout.Sider = (0, $f4e67dbf2453f541$export$2e2bcd8739ae039);
$49639f13efb591ba$var$Layout._InternalSiderContext = (0, $f4e67dbf2453f541$export$63554aebd2a6d54c);
var $49639f13efb591ba$export$2e2bcd8739ae039 = $49639f13efb591ba$var$Layout;


var $acw62 = parcelRequire("acw62");

function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


// Use shared variable to save bundle size
const $c4c808c8cede6427$var$UNDEFINED = undefined;
function $c4c808c8cede6427$var$InternalItem(props, ref) {
    const { prefixCls: prefixCls, invalidate: invalidate, item: item, renderItem: renderItem, responsive: responsive, responsiveDisabled: responsiveDisabled, registerSize: registerSize, itemKey: itemKey, className: className, style: style, children: children, display: display, order: order, component: Component = 'div', ...restProps } = props;
    const mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $acw62.useEffect(()=>()=>{
            internalRegisterSize(null);
        }, []);
    // ================================ Render ================================
    const childNode = renderItem && item !== $c4c808c8cede6427$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    let overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $c4c808c8cede6427$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $c4c808c8cede6427$var$UNDEFINED,
        order: responsive ? order : $c4c808c8cede6427$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $c4c808c8cede6427$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $c4c808c8cede6427$var$UNDEFINED
    };
    const overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    let itemNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(!invalidate && prefixCls, className),
        style: {
            ...overflowStyle,
            ...style
        }
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>{
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
const $c4c808c8cede6427$var$Item = /*#__PURE__*/ $acw62.forwardRef($c4c808c8cede6427$var$InternalItem);
var $c4c808c8cede6427$export$2e2bcd8739ae039 = $c4c808c8cede6427$var$Item;




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

function $4245de17fec6456f$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(callback);
    else {
        const channel = new MessageChannel();
        channel.port1.onmessage = ()=>callback();
        channel.port2.postMessage(undefined);
    }
}


function $468f7b3c8e533fa9$export$eedf51fe9d751c7a() {
    // Updater Trigger
    const updateFuncRef = $acw62.useRef(null);
    // Notify update
    const notifyEffectUpdate = (callback)=>{
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $4245de17fec6456f$export$2e2bcd8739ae039)(()=>{
                (0, $1u0KT.unstable_batchedUpdates)(()=>{
                    updateFuncRef.current.forEach((fn)=>{
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $468f7b3c8e533fa9$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    const [stateValue, setStateValue] = $acw62.useState(defaultValue);
    // Set State
    const setEffectVal = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextValue)=>{
        notifyEffectUpdate(()=>{
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $c5d498e471705caa$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


const $5495cafea751a14b$var$InternalRawItem = (props, ref)=>{
    const context = $acw62.useContext((0, $c5d498e471705caa$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        const { component: Component = 'div', ...restProps } = props;
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
            ref: ref
        }));
    }
    const { className: contextClassName, ...restContext } = context;
    const { className: className, ...restProps } = props;
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $acw62.createElement((0, $c5d498e471705caa$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $c4c808c8cede6427$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(contextClassName, className)
    }, restContext, restProps)));
};
const $5495cafea751a14b$var$RawItem = /*#__PURE__*/ $acw62.forwardRef($5495cafea751a14b$var$InternalRawItem);
var $5495cafea751a14b$export$2e2bcd8739ae039 = $5495cafea751a14b$var$RawItem;



const $2e2b5c74f926d2de$var$RESPONSIVE = 'responsive';
const $2e2b5c74f926d2de$var$INVALIDATE = 'invalidate';
function $2e2b5c74f926d2de$var$defaultRenderRest(omittedItems) {
    return `+ ${omittedItems.length} ...`;
}
function $2e2b5c74f926d2de$var$Overflow(props, ref) {
    const { prefixCls: prefixCls = 'rc-overflow', data: data = [], renderItem: renderItem, renderRawItem: renderRawItem, itemKey: itemKey, itemWidth: itemWidth = 10, ssr: ssr, style: style, className: className, maxCount: maxCount, renderRest: renderRest, renderRawRest: renderRawRest, prefix: prefix, suffix: suffix, component: Component = 'div', itemComponent: itemComponent, onVisibleChange: onVisibleChange, ...restProps } = props;
    const fullySSR = ssr === 'full';
    const notifyEffectUpdate = (0, $468f7b3c8e533fa9$export$eedf51fe9d751c7a)();
    const [containerWidth, setContainerWidth] = (0, $468f7b3c8e533fa9$export$2e2bcd8739ae039)(notifyEffectUpdate, null);
    const mergedContainerWidth = containerWidth || 0;
    const [itemWidths, setItemWidths] = (0, $468f7b3c8e533fa9$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map());
    const [prevRestWidth, setPrevRestWidth] = (0, $468f7b3c8e533fa9$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [restWidth, setRestWidth] = (0, $468f7b3c8e533fa9$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [prefixWidth, setPrefixWidth] = (0, $468f7b3c8e533fa9$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [suffixWidth, setSuffixWidth] = (0, $468f7b3c8e533fa9$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [suffixFixedStart, setSuffixFixedStart] = (0, $acw62.useState)(null);
    const [displayCount, setDisplayCount] = (0, $acw62.useState)(null);
    const mergedDisplayCount = $acw62.useMemo(()=>{
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    const [restReady, setRestReady] = (0, $acw62.useState)(false);
    const itemPrefixCls = `${prefixCls}-item`;
    // Always use the max width to avoid blink
    const mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    const isResponsive = maxCount === $2e2b5c74f926d2de$var$RESPONSIVE;
    const shouldResponsive = data.length && isResponsive;
    const invalidate = maxCount === $2e2b5c74f926d2de$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ const showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    const mergedData = (0, $acw62.useMemo)(()=>{
        let items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    const omittedItems = (0, $acw62.useMemo)(()=>{
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    const getKey = (0, $acw62.useCallback)((item, index)=>{
        if (typeof itemKey === 'function') return itemKey(item);
        return (itemKey && item?.[itemKey]) ?? index;
    }, [
        itemKey
    ]);
    const mergedRenderItem = (0, $acw62.useCallback)(renderItem || ((item)=>item), [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange?.(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths((origin)=>{
            const clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerPrefixSize(_, width) {
        setPrefixWidth(width);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            let totalWidth = prefixWidth + suffixWidth;
            const len = mergedData.length;
            const lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(let i = 0; i < len; i += 1){
                let currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        prefixWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    const displayRest = restReady && !!omittedItems.length;
    let suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        top: 0,
        insetInlineStart: suffixFixedStart
    };
    const itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    const internalRenderItemNode = renderRawItem ? (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $c5d498e471705caa$export$79f16dd643143c25).Provider, {
            key: key,
            value: {
                ...itemSharedProps,
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            }
        }, renderRawItem(item, index));
    } : (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $c4c808c8cede6427$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    const restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: `${itemPrefixCls}-rest`,
        registerSize: registerOverflowSize,
        display: displayRest
    };
    const mergedRenderRest = renderRest || $2e2b5c74f926d2de$var$defaultRenderRest;
    const restNode = renderRawRest ? /*#__PURE__*/ $acw62.createElement((0, $c5d498e471705caa$export$79f16dd643143c25).Provider, {
        value: {
            ...itemSharedProps,
            ...restContextProps
        }
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $acw62.createElement((0, $c4c808c8cede6427$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    const overflowNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), prefix && /*#__PURE__*/ $acw62.createElement((0, $c4c808c8cede6427$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: -1,
        className: `${itemPrefixCls}-prefix`,
        registerSize: registerPrefixSize,
        display: true
    }), prefix), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $acw62.createElement((0, $c4c808c8cede6427$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: `${itemPrefixCls}-suffix`,
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
const $2e2b5c74f926d2de$var$ForwardOverflow = /*#__PURE__*/ $acw62.forwardRef($2e2b5c74f926d2de$var$Overflow);
$2e2b5c74f926d2de$var$ForwardOverflow.Item = (0, $5495cafea751a14b$export$2e2bcd8739ae039);
$2e2b5c74f926d2de$var$ForwardOverflow.RESPONSIVE = $2e2b5c74f926d2de$var$RESPONSIVE;
$2e2b5c74f926d2de$var$ForwardOverflow.INVALIDATE = $2e2b5c74f926d2de$var$INVALIDATE;
var // Convert to generic type
$2e2b5c74f926d2de$export$2e2bcd8739ae039 = $2e2b5c74f926d2de$var$ForwardOverflow;


var $99393f3768089249$export$2e2bcd8739ae039 = (0, $2e2b5c74f926d2de$export$2e2bcd8739ae039);







var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
const $e9368d03ee07580a$export$26537912ea160acd = /*#__PURE__*/ $acw62.createContext(null);
function $e9368d03ee07580a$export$80c871fe8d6b896(uuid, eventKey) {
    return `${uuid}-${eventKey}`;
}
function $e9368d03ee07580a$export$a276eb4e9be640f8(eventKey) {
    const id = $acw62.useContext($e9368d03ee07580a$export$26537912ea160acd);
    return $e9368d03ee07580a$export$80c871fe8d6b896(id, eventKey);
}



var $acw62 = parcelRequire("acw62");


const $626c1ba689347bd7$export$c7e742effb1c51e2 = /*#__PURE__*/ $acw62.createContext(null);
function $626c1ba689347bd7$var$mergeProps(origin, target) {
    const clone = {
        ...origin
    };
    Object.keys(target).forEach((key)=>{
        const value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $626c1ba689347bd7$export$2e2bcd8739ae039({ children: children, locked: locked, ...restProps }) {
    const context = $acw62.useContext($626c1ba689347bd7$export$c7e742effb1c51e2);
    const inheritableContext = (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>$626c1ba689347bd7$var$mergeProps(context, restProps), [
        context,
        restProps
    ], (prev, next)=>!locked && (prev[0] !== next[0] || !(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prev[1], next[1], true)));
    return /*#__PURE__*/ $acw62.createElement($626c1ba689347bd7$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}



var $acw62 = parcelRequire("acw62");
const $43c59d964a3094e1$var$EmptyList = [];
const $43c59d964a3094e1$export$d9ffb5bfd108b003 = /*#__PURE__*/ $acw62.createContext(null);
function $43c59d964a3094e1$export$e295b0c537d32d7d() {
    return $acw62.useContext($43c59d964a3094e1$export$d9ffb5bfd108b003);
}
const $43c59d964a3094e1$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $acw62.createContext($43c59d964a3094e1$var$EmptyList);
function $43c59d964a3094e1$export$d3d2d0a05677870a(eventKey) {
    const parentKeyPath = $acw62.useContext($43c59d964a3094e1$export$54d9e16aa4c8a7fa);
    return $acw62.useMemo(()=>eventKey !== undefined ? [
            ...parentKeyPath,
            eventKey
        ] : parentKeyPath, [
        parentKeyPath,
        eventKey
    ]);
}
const $43c59d964a3094e1$export$f0b9e0db98edfa53 = /*#__PURE__*/ $acw62.createContext(null);



var $acw62 = parcelRequire("acw62");
const $60c4d7ed0dacae66$var$PrivateContext = /*#__PURE__*/ $acw62.createContext({});
var $60c4d7ed0dacae66$export$2e2bcd8739ae039 = $60c4d7ed0dacae66$var$PrivateContext;



var $acw62 = parcelRequire("acw62");


function $09560f6ea64963fd$var$focusable(node, includePositive = false) {
    if ((0, $13cc53bc89b37f6a$export$2e2bcd8739ae039)(node)) {
        const nodeName = node.nodeName.toLowerCase();
        const isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        const tabIndexAttr = node.getAttribute('tabindex');
        const tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        let tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $09560f6ea64963fd$export$bbc7b5f11aba534b(node, includePositive = false) {
    const res = [
        ...node.querySelectorAll('*')
    ].filter((child)=>{
        return $09560f6ea64963fd$var$focusable(child, includePositive);
    });
    if ($09560f6ea64963fd$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
function $09560f6ea64963fd$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        const len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
// ======================================================
// ==                    Lock Focus                    ==
// ======================================================
let $09560f6ea64963fd$var$lastFocusElement = null;
let $09560f6ea64963fd$var$focusElements = [];
// Map stable ID to lock element
const $09560f6ea64963fd$var$idToElementMap = new Map();
// Map stable ID to ignored element
const $09560f6ea64963fd$var$ignoredElementMap = new Map();
function $09560f6ea64963fd$var$getLastElement() {
    return $09560f6ea64963fd$var$focusElements[$09560f6ea64963fd$var$focusElements.length - 1];
}
function $09560f6ea64963fd$var$isIgnoredElement(element) {
    const lastElement = $09560f6ea64963fd$var$getLastElement();
    if (element && lastElement) {
        // Find the ID that maps to the last element
        let lockId;
        for (const [id, ele] of $09560f6ea64963fd$var$idToElementMap.entries())if (ele === lastElement) {
            lockId = id;
            break;
        }
        const ignoredEle = $09560f6ea64963fd$var$ignoredElementMap.get(lockId);
        return !!ignoredEle && (ignoredEle === element || ignoredEle.contains(element));
    }
    return false;
}
function $09560f6ea64963fd$var$hasFocus(element) {
    const { activeElement: activeElement } = document;
    return element === activeElement || element.contains(activeElement);
}
function $09560f6ea64963fd$var$syncFocus() {
    const lastElement = $09560f6ea64963fd$var$getLastElement();
    const { activeElement: activeElement } = document;
    // If current focus is on an ignored element, don't force it back
    if ($09560f6ea64963fd$var$isIgnoredElement(activeElement)) return;
    if (lastElement && !$09560f6ea64963fd$var$hasFocus(lastElement)) {
        const focusableList = $09560f6ea64963fd$export$bbc7b5f11aba534b(lastElement);
        const matchElement = focusableList.includes($09560f6ea64963fd$var$lastFocusElement) ? $09560f6ea64963fd$var$lastFocusElement : focusableList[0];
        matchElement?.focus({
            preventScroll: true
        });
    } else $09560f6ea64963fd$var$lastFocusElement = activeElement;
}
function $09560f6ea64963fd$var$onWindowKeyDown(e) {
    if (e.key === 'Tab') {
        const { activeElement: activeElement } = document;
        const lastElement = $09560f6ea64963fd$var$getLastElement();
        const focusableList = $09560f6ea64963fd$export$bbc7b5f11aba534b(lastElement);
        const last = focusableList[focusableList.length - 1];
        if (e.shiftKey && activeElement === focusableList[0]) // Tab backward on first focusable element
        $09560f6ea64963fd$var$lastFocusElement = last;
        else if (!e.shiftKey && activeElement === last) // Tab forward on last focusable element
        $09560f6ea64963fd$var$lastFocusElement = focusableList[0];
    }
}
function $09560f6ea64963fd$export$a71918e269a02274(element, id) {
    if (element) {
        // Store the mapping between ID and element
        $09560f6ea64963fd$var$idToElementMap.set(id, element);
        // Refresh focus elements
        $09560f6ea64963fd$var$focusElements = $09560f6ea64963fd$var$focusElements.filter((ele)=>ele !== element);
        $09560f6ea64963fd$var$focusElements.push(element);
        // Just add event since it will de-duplicate
        window.addEventListener('focusin', $09560f6ea64963fd$var$syncFocus);
        window.addEventListener('keydown', $09560f6ea64963fd$var$onWindowKeyDown, true);
        $09560f6ea64963fd$var$syncFocus();
    }
    // Always return unregister function
    return ()=>{
        $09560f6ea64963fd$var$lastFocusElement = null;
        $09560f6ea64963fd$var$focusElements = $09560f6ea64963fd$var$focusElements.filter((ele)=>ele !== element);
        $09560f6ea64963fd$var$idToElementMap.delete(id);
        $09560f6ea64963fd$var$ignoredElementMap.delete(id);
        if ($09560f6ea64963fd$var$focusElements.length === 0) {
            window.removeEventListener('focusin', $09560f6ea64963fd$var$syncFocus);
            window.removeEventListener('keydown', $09560f6ea64963fd$var$onWindowKeyDown, true);
        }
    };
}
/**
 * Retry an effect until it reports ready.
 * When `ready` is `false`, it will schedule one more effect cycle and call `func` again
 * with the next `retryTimes`.
 */ function $09560f6ea64963fd$var$useRetryEffect(func, deps) {
    /* eslint-disable react-hooks/exhaustive-deps */ const retryTimesRef = (0, $acw62.useRef)(0);
    const [retryMark, setRetryMark] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        retryTimesRef.current = 0;
    }, deps);
    (0, $acw62.useEffect)(()=>{
        const [clearFn, ready] = func(retryTimesRef.current);
        if (!ready) {
            retryTimesRef.current += 1;
            setRetryMark((count)=>count + 1);
        }
        return clearFn;
    }, [
        ...deps,
        retryMark
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }
function $09560f6ea64963fd$export$9e3bf6f439c42dc9(lock, getElement) {
    const id = (0, $bba066f19964922a$export$2e2bcd8739ae039)();
    const getElementRef = (0, $acw62.useRef)(getElement);
    getElementRef.current = getElement;
    const lockEffect = (retryTimes)=>{
        if (!lock) return [
            undefined,
            true
        ];
        const element = getElementRef.current();
        if (element) return [
            $09560f6ea64963fd$export$a71918e269a02274(element, id),
            true
        ];
        return [
            undefined,
            retryTimes >= 1
        ];
    };
    $09560f6ea64963fd$var$useRetryEffect(lockEffect, [
        id,
        lock
    ]);
    const ignoreElement = (ele)=>{
        if (ele) // Set the ignored element using stable ID
        $09560f6ea64963fd$var$ignoredElementMap.set(id, ele);
    };
    return [
        ignoreElement
    ];
}


/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ const $d5b4e9a9adce0110$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        const { keyCode: keyCode } = e;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d5b4e9a9adce0110$var$KeyCode.F1 && keyCode <= $d5b4e9a9adce0110$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d5b4e9a9adce0110$var$KeyCode.ALT:
            case $d5b4e9a9adce0110$var$KeyCode.CAPS_LOCK:
            case $d5b4e9a9adce0110$var$KeyCode.CONTEXT_MENU:
            case $d5b4e9a9adce0110$var$KeyCode.CTRL:
            case $d5b4e9a9adce0110$var$KeyCode.DOWN:
            case $d5b4e9a9adce0110$var$KeyCode.END:
            case $d5b4e9a9adce0110$var$KeyCode.ESC:
            case $d5b4e9a9adce0110$var$KeyCode.HOME:
            case $d5b4e9a9adce0110$var$KeyCode.INSERT:
            case $d5b4e9a9adce0110$var$KeyCode.LEFT:
            case $d5b4e9a9adce0110$var$KeyCode.MAC_FF_META:
            case $d5b4e9a9adce0110$var$KeyCode.META:
            case $d5b4e9a9adce0110$var$KeyCode.NUMLOCK:
            case $d5b4e9a9adce0110$var$KeyCode.NUM_CENTER:
            case $d5b4e9a9adce0110$var$KeyCode.PAGE_DOWN:
            case $d5b4e9a9adce0110$var$KeyCode.PAGE_UP:
            case $d5b4e9a9adce0110$var$KeyCode.PAUSE:
            case $d5b4e9a9adce0110$var$KeyCode.PRINT_SCREEN:
            case $d5b4e9a9adce0110$var$KeyCode.RIGHT:
            case $d5b4e9a9adce0110$var$KeyCode.SHIFT:
            case $d5b4e9a9adce0110$var$KeyCode.UP:
            case $d5b4e9a9adce0110$var$KeyCode.WIN_KEY:
            case $d5b4e9a9adce0110$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d5b4e9a9adce0110$var$KeyCode.ZERO && keyCode <= $d5b4e9a9adce0110$var$KeyCode.NINE) return true;
        if (keyCode >= $d5b4e9a9adce0110$var$KeyCode.NUM_ZERO && keyCode <= $d5b4e9a9adce0110$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d5b4e9a9adce0110$var$KeyCode.A && keyCode <= $d5b4e9a9adce0110$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d5b4e9a9adce0110$var$KeyCode.SPACE:
            case $d5b4e9a9adce0110$var$KeyCode.QUESTION_MARK:
            case $d5b4e9a9adce0110$var$KeyCode.NUM_PLUS:
            case $d5b4e9a9adce0110$var$KeyCode.NUM_MINUS:
            case $d5b4e9a9adce0110$var$KeyCode.NUM_PERIOD:
            case $d5b4e9a9adce0110$var$KeyCode.NUM_DIVISION:
            case $d5b4e9a9adce0110$var$KeyCode.SEMICOLON:
            case $d5b4e9a9adce0110$var$KeyCode.DASH:
            case $d5b4e9a9adce0110$var$KeyCode.EQUALS:
            case $d5b4e9a9adce0110$var$KeyCode.COMMA:
            case $d5b4e9a9adce0110$var$KeyCode.PERIOD:
            case $d5b4e9a9adce0110$var$KeyCode.SLASH:
            case $d5b4e9a9adce0110$var$KeyCode.APOSTROPHE:
            case $d5b4e9a9adce0110$var$KeyCode.SINGLE_QUOTE:
            case $d5b4e9a9adce0110$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d5b4e9a9adce0110$var$KeyCode.BACKSLASH:
            case $d5b4e9a9adce0110$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    },
    isEditableTarget: function isEditableTarget(e) {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return false;
        const tagName = target.tagName;
        if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT' || target.isContentEditable) return true;
        return false;
    }
};
var $d5b4e9a9adce0110$export$2e2bcd8739ae039 = $d5b4e9a9adce0110$var$KeyCode;




var $acw62 = parcelRequire("acw62");

// destruct to reduce minify size
const { LEFT: $531c784ba119bbfb$var$LEFT, RIGHT: $531c784ba119bbfb$var$RIGHT, UP: $531c784ba119bbfb$var$UP, DOWN: $531c784ba119bbfb$var$DOWN, ENTER: $531c784ba119bbfb$var$ENTER, ESC: $531c784ba119bbfb$var$ESC, HOME: $531c784ba119bbfb$var$HOME, END: $531c784ba119bbfb$var$END } = (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039);
const $531c784ba119bbfb$var$ArrowKeys = [
    $531c784ba119bbfb$var$UP,
    $531c784ba119bbfb$var$DOWN,
    $531c784ba119bbfb$var$LEFT,
    $531c784ba119bbfb$var$RIGHT
];
function $531c784ba119bbfb$var$getOffset(mode, isRootLevel, isRtl, which) {
    const prev = 'prev';
    const next = 'next';
    const children = 'children';
    const parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $531c784ba119bbfb$var$ENTER) return {
        inlineTrigger: true
    };
    const inline = {
        [$531c784ba119bbfb$var$UP]: prev,
        [$531c784ba119bbfb$var$DOWN]: next
    };
    const horizontal = {
        [$531c784ba119bbfb$var$LEFT]: isRtl ? next : prev,
        [$531c784ba119bbfb$var$RIGHT]: isRtl ? prev : next,
        [$531c784ba119bbfb$var$DOWN]: children,
        [$531c784ba119bbfb$var$ENTER]: children
    };
    const vertical = {
        [$531c784ba119bbfb$var$UP]: prev,
        [$531c784ba119bbfb$var$DOWN]: next,
        [$531c784ba119bbfb$var$ENTER]: children,
        [$531c784ba119bbfb$var$ESC]: parent,
        [$531c784ba119bbfb$var$LEFT]: isRtl ? children : parent,
        [$531c784ba119bbfb$var$RIGHT]: isRtl ? parent : children
    };
    const offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    const type = offsets[`${mode}${isRootLevel ? '' : 'Sub'}`]?.[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $531c784ba119bbfb$var$findContainerUL(element) {
    let current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $531c784ba119bbfb$var$getFocusElement(activeElement, elements) {
    let current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $531c784ba119bbfb$export$433aaa1f216cf32d(container, elements) {
    const list = (0, $09560f6ea64963fd$export$bbc7b5f11aba534b)(container, true);
    return list.filter((ele)=>elements.has(ele));
}
function $531c784ba119bbfb$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offset = 1) {
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    const sameLevelFocusableMenuElementList = $531c784ba119bbfb$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    const count = sameLevelFocusableMenuElementList.length;
    let focusIndex = sameLevelFocusableMenuElementList.findIndex((ele)=>focusMenuElement === ele);
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
const $531c784ba119bbfb$export$20827b68c762d23 = (keys, id)=>{
    const elements = new Set();
    const key2element = new Map();
    const element2key = new Map();
    keys.forEach((key)=>{
        const element = document.querySelector(`[data-menu-id='${(0, $e9368d03ee07580a$export$80c871fe8d6b896)(id, key)}']`);
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $531c784ba119bbfb$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    const rafRef = $acw62.useRef();
    const activeRef = $acw62.useRef();
    activeRef.current = activeKey;
    const cleanRaf = ()=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $acw62.useEffect(()=>()=>{
            cleanRaf();
        }, []);
    return (e)=>{
        const { which: which } = e;
        if ([
            ...$531c784ba119bbfb$var$ArrowKeys,
            $531c784ba119bbfb$var$ENTER,
            $531c784ba119bbfb$var$ESC,
            $531c784ba119bbfb$var$HOME,
            $531c784ba119bbfb$var$END
        ].includes(which)) {
            const keys = getKeys();
            let refreshedElements = $531c784ba119bbfb$export$20827b68c762d23(keys, id);
            const { elements: elements, key2element: key2element, element2key: element2key } = refreshedElements;
            // First we should find current focused MenuItem/SubMenu element
            const activeElement = key2element.get(activeKey);
            const focusMenuElement = $531c784ba119bbfb$var$getFocusElement(activeElement, elements);
            const focusMenuKey = element2key.get(focusMenuElement);
            const offsetObj = $531c784ba119bbfb$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $531c784ba119bbfb$var$HOME && which !== $531c784ba119bbfb$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($531c784ba119bbfb$var$ArrowKeys.includes(which) || [
                $531c784ba119bbfb$var$HOME,
                $531c784ba119bbfb$var$END
            ].includes(which)) e.preventDefault();
            const tryFocus = (menuElement)=>{
                if (menuElement) {
                    let focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    const link = menuElement.querySelector('a');
                    if (link?.getAttribute('href')) focusTargetElement = link;
                    const targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $531c784ba119bbfb$var$HOME,
                $531c784ba119bbfb$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                let parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $531c784ba119bbfb$var$findContainerUL(focusMenuElement);
                // Get next focus element
                let targetElement;
                const focusableElements = $531c784ba119bbfb$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $531c784ba119bbfb$var$HOME) targetElement = focusableElements[0];
                else if (which === $531c784ba119bbfb$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $531c784ba119bbfb$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                    // Async should resync elements
                    refreshedElements = $531c784ba119bbfb$export$20827b68c762d23(keys, id);
                    const controlId = focusMenuElement.getAttribute('aria-controls');
                    const subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    const targetElement = $531c784ba119bbfb$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                const keyPath = getKeyPath(focusMenuKey, true);
                const parentKey = keyPath[keyPath.length - 2];
                const parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown?.(e);
    };
}



var $acw62 = parcelRequire("acw62");

function $4d193c5e7caf85df$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


const $48bd66e0031dd3e1$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
const $48bd66e0031dd3e1$var$getPathStr = (keyPath)=>keyPath.join($48bd66e0031dd3e1$var$PATH_SPLIT);
const $48bd66e0031dd3e1$var$getPathKeys = (keyPathStr)=>keyPathStr.split($48bd66e0031dd3e1$var$PATH_SPLIT);
const $48bd66e0031dd3e1$export$20a0132c46ce5b04 = 'rc-menu-more';
function $48bd66e0031dd3e1$export$2e2bcd8739ae039() {
    const [, internalForceUpdate] = $acw62.useState({});
    const key2pathRef = (0, $acw62.useRef)(new Map());
    const path2keyRef = (0, $acw62.useRef)(new Map());
    const [overflowKeys, setOverflowKeys] = $acw62.useState([]);
    const updateRef = (0, $acw62.useRef)(0);
    const destroyRef = (0, $acw62.useRef)(false);
    const forceUpdate = ()=>{
        if (!destroyRef.current) internalForceUpdate({});
    };
    const registerPath = (0, $acw62.useCallback)((key, keyPath)=>{
        // Fill map
        const connectedPath = $48bd66e0031dd3e1$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        const id = updateRef.current;
        (0, $4d193c5e7caf85df$export$7693db51ef834b40)(()=>{
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    const unregisterPath = (0, $acw62.useCallback)((key, keyPath)=>{
        const connectedPath = $48bd66e0031dd3e1$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    const refreshOverflowKeys = (0, $acw62.useCallback)((keys)=>{
        setOverflowKeys(keys);
    }, []);
    const getKeyPath = (0, $acw62.useCallback)((eventKey, includeOverflow)=>{
        const fullPath = key2pathRef.current.get(eventKey) || '';
        const keys = $48bd66e0031dd3e1$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($48bd66e0031dd3e1$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    const isSubPathKey = (0, $acw62.useCallback)((pathKeys, eventKey)=>pathKeys.filter((item)=>item !== undefined).some((pathKey)=>{
            const pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        }), [
        getKeyPath
    ]);
    const getKeys = ()=>{
        const keys = [
            ...key2pathRef.current.keys()
        ];
        if (overflowKeys.length) keys.push($48bd66e0031dd3e1$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ const getSubPathKeys = (0, $acw62.useCallback)((key)=>{
        const connectedPath = `${key2pathRef.current.get(key)}${$48bd66e0031dd3e1$var$PATH_SPLIT}`;
        const pathKeys = new Set();
        [
            ...path2keyRef.current.keys()
        ].forEach((pathKey)=>{
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $acw62.useEffect(()=>()=>{
            destroyRef.current = true;
        }, []);
    return {
        registerPath: // Register
        registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        isSubPathKey: // Util
        isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $acw62 = parcelRequire("acw62");
function $b14f10147b58129a$export$2e2bcd8739ae039(func) {
    const funRef = $acw62.useRef(func);
    funRef.current = func;
    const callback = $acw62.useCallback((...args)=>funRef.current?.(...args), []);
    return func ? callback : undefined;
}









var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $50ac98fea1130fb3$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    const { activeKey: // Active
    activeKey, onActive: onActive, onInactive: onInactive } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    const ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = (domEvent)=>{
            onMouseEnter?.({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = (domEvent)=>{
            onMouseLeave?.({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $acw62 = parcelRequire("acw62");

function $8c19ab471667ff77$export$2e2bcd8739ae039(level) {
    const { mode: mode, rtl: rtl, inlineIndent: inlineIndent } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    if (mode !== 'inline') return null;
    const len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}



var $acw62 = parcelRequire("acw62");
function $98e7a39a7002f55f$export$2e2bcd8739ae039({ icon: icon, props: props, children: children }) {
    let iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $acw62.createElement(icon, {
        ...props
    });
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



function $6992ee8159aa33da$export$e189bcd94b66c1db({ item: item, ...restInfo }) {
    Object.defineProperty(restInfo, 'item', {
        get: ()=>{
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}


function $d72dbaba5a7dd149$var$_extends() {
    $d72dbaba5a7dd149$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d72dbaba5a7dd149$var$_extends.apply(this, arguments);
}
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
class $d72dbaba5a7dd149$var$LegacyMenuItem extends $acw62.Component {
    render() {
        const { title: title, attribute: attribute, elementRef: elementRef, ...restProps } = this.props;
        // Here the props are eventually passed to the DOM element.
        // React does not recognize non-standard attributes.
        // Therefore, remove the props that is not used here.
        // ref: https://github.com/ant-design/ant-design/issues/41395
        const passedProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, [
            'eventKey',
            'popupClassName',
            'popupOffset',
            'onTitleClick'
        ]);
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
        return /*#__PURE__*/ $acw62.createElement((0, $99393f3768089249$export$2e2bcd8739ae039).Item, $d72dbaba5a7dd149$var$_extends({}, attribute, {
            title: typeof title === 'string' ? title : undefined
        }, passedProps, {
            ref: elementRef
        }));
    }
}
/**
 * Real Menu Item component
 */ const $d72dbaba5a7dd149$var$InternalMenuItem = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { style: style, className: className, eventKey: eventKey, warnKey: warnKey, disabled: disabled, itemIcon: itemIcon, children: children, role: // Aria
    role, onMouseEnter: // Active
    onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, ...restProps } = props;
    const domDataId = (0, $e9368d03ee07580a$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, onItemClick: onItemClick, disabled: contextDisabled, overflowDisabled: overflowDisabled, // Icon
    itemIcon: contextItemIcon, selectedKeys: // Select
    selectedKeys, onActive: // Active
    onActive } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    const { _internalRenderMenuItem: _internalRenderMenuItem } = $acw62.useContext((0, $60c4d7ed0dacae66$export$2e2bcd8739ae039));
    const itemCls = `${prefixCls}-item`;
    const legacyMenuItemRef = $acw62.useRef();
    const elementRef = $acw62.useRef();
    const mergedDisabled = contextDisabled || disabled;
    const mergedEleRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(ref, elementRef);
    const connectedKeys = (0, $43c59d964a3094e1$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    const getEventInfo = (e)=>{
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: [
                ...connectedKeys
            ].reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    const mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    const { active: active, ...activeProps } = (0, $50ac98fea1130fb3$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave);
    // ============================ Select ============================
    const selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    const directionStyle = (0, $8c19ab471667ff77$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    const onInternalClick = (e)=>{
        if (mergedDisabled) return;
        const info = getEventInfo(e);
        onClick?.((0, $6992ee8159aa33da$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    const onInternalKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) {
            const info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick?.((0, $6992ee8159aa33da$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = (e)=>{
        onActive(eventKey);
        onFocus?.(e);
    };
    // ============================ Render ============================
    const optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    let renderNode = /*#__PURE__*/ $acw62.createElement($d72dbaba5a7dd149$var$LegacyMenuItem, $d72dbaba5a7dd149$var$_extends({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: {
            ...directionStyle,
            ...style
        },
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(itemCls, {
            [`${itemCls}-active`]: active,
            [`${itemCls}-selected`]: selected,
            [`${itemCls}-disabled`]: mergedDisabled
        }, className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $acw62.createElement((0, $98e7a39a7002f55f$export$2e2bcd8739ae039), {
        props: {
            ...props,
            isSelected: selected
        },
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $d72dbaba5a7dd149$var$MenuItem(props, ref) {
    const { eventKey: eventKey } = props;
    // ==================== Record KeyPath ====================
    const measure = (0, $43c59d964a3094e1$export$e295b0c537d32d7d)();
    const connectedKeyPath = (0, $43c59d964a3094e1$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $acw62.createElement($d72dbaba5a7dd149$var$InternalMenuItem, $d72dbaba5a7dd149$var$_extends({}, props, {
        ref: ref
    }));
}
var $d72dbaba5a7dd149$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($d72dbaba5a7dd149$var$MenuItem);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


function $926298de130fbde4$var$_extends() {
    $926298de130fbde4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $926298de130fbde4$var$_extends.apply(this, arguments);
}
const $926298de130fbde4$var$InternalSubMenuList = ({ className: className, children: children, ...restProps }, ref)=>{
    const { prefixCls: prefixCls, mode: mode, rtl: rtl } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    return /*#__PURE__*/ $acw62.createElement("ul", $926298de130fbde4$var$_extends({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, rtl && `${prefixCls}-rtl`, `${prefixCls}-sub`, `${prefixCls}-${mode === 'inline' ? 'inline' : 'vertical'}`, className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
const $926298de130fbde4$var$SubMenuList = /*#__PURE__*/ $acw62.forwardRef($926298de130fbde4$var$InternalSubMenuList);
var $926298de130fbde4$export$2e2bcd8739ae039 = $926298de130fbde4$var$SubMenuList;




var $acw62 = parcelRequire("acw62");
function $b1d87c6a18f4d735$export$cd230e97e668be9(children, keyPath) {
    return (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children).map((child, index)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) {
            const { key: key } = child;
            let eventKey = child.props?.eventKey ?? key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = `tmp_key-${[
                ...keyPath,
                index
            ].join('-')}`;
            const cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $acw62.cloneElement(child, cloneProps);
        }
        return child;
    });
}





var $acw62 = parcelRequire("acw62");




const $fae64f7f3cc34764$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $fae64f7f3cc34764$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    }
};
const $fae64f7f3cc34764$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $fae64f7f3cc34764$var$autoAdjustOverflow
    }
};
var $fae64f7f3cc34764$export$2e2bcd8739ae039 = $fae64f7f3cc34764$export$803cd8101b6c182b;


function $1a5755afaa8f794b$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


const $5f7be8b92760572b$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $5f7be8b92760572b$export$2e2bcd8739ae039({ prefixCls: prefixCls, visible: visible, children: children, popup: popup, popupStyle: popupStyle, popupClassName: popupClassName, popupOffset: popupOffset, disabled: disabled, mode: mode, onVisibleChange: onVisibleChange }) {
    const { getPopupContainer: getPopupContainer, rtl: rtl, subMenuOpenDelay: subMenuOpenDelay, subMenuCloseDelay: subMenuCloseDelay, builtinPlacements: builtinPlacements, triggerSubMenuAction: triggerSubMenuAction, forceSubMenuRender: forceSubMenuRender, rootClassName: rootClassName, motion: // Motion
    motion, defaultMotions: defaultMotions } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    const [innerVisible, setInnerVisible] = $acw62.useState(false);
    const placement = rtl ? {
        ...(0, $fae64f7f3cc34764$export$e2b3f69b0a16e1f),
        ...builtinPlacements
    } : {
        ...(0, $fae64f7f3cc34764$export$803cd8101b6c182b),
        ...builtinPlacements
    };
    const popupPlacement = $5f7be8b92760572b$var$popupPlacementMap[mode];
    const targetMotion = (0, $1a5755afaa8f794b$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    const targetMotionRef = $acw62.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    const mergedMotion = {
        ...targetMotionRef.current,
        leavedClassName: `${prefixCls}-hidden`,
        removeOnLeave: false,
        motionAppear: true
    };
    // Delay to change visible
    const visibleRef = $acw62.useRef();
    $acw62.useEffect(()=>{
        visibleRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            setInnerVisible(visible);
        });
        return ()=>{
            (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}







var $acw62 = parcelRequire("acw62");




function $d8db21347d397624$var$_extends() {
    $d8db21347d397624$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8db21347d397624$var$_extends.apply(this, arguments);
}
function $d8db21347d397624$export$2e2bcd8739ae039({ id: id, open: open, keyPath: keyPath, children: children }) {
    const fixedMode = 'inline';
    const { prefixCls: prefixCls, forceSubMenuRender: forceSubMenuRender, motion: motion, defaultMotions: defaultMotions, mode: mode } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    // Always use latest mode check
    const sameModeRef = $acw62.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    const [destroy, setDestroy] = $acw62.useState(!sameModeRef.current);
    const mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $acw62.useEffect(()=>{
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    const mergedMotion = {
        ...(0, $1a5755afaa8f794b$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions)
    };
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    const originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = (newVisible)=>{
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged?.(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $626c1ba689347bd7$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $d8db21347d397624$var$_extends({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-hidden`
    }), ({ className: motionClassName, style: motionStyle })=>{
        return /*#__PURE__*/ $acw62.createElement((0, $926298de130fbde4$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





function $b61e1d68050bda86$var$_extends() {
    $b61e1d68050bda86$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b61e1d68050bda86$var$_extends.apply(this, arguments);
}
const $b61e1d68050bda86$var$InternalSubMenu = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { style: style, className: className, styles: styles, classNames: menuClassNames, title: title, eventKey: eventKey, warnKey: warnKey, disabled: disabled, internalPopupClose: internalPopupClose, children: children, itemIcon: // Icons
    itemIcon, expandIcon: expandIcon, popupClassName: // Popup
    popupClassName, popupOffset: popupOffset, popupStyle: popupStyle, onClick: // Events
    onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTitleClick: onTitleClick, onTitleMouseEnter: onTitleMouseEnter, onTitleMouseLeave: onTitleMouseLeave, popupRender: propsPopupRender, ...restProps } = props;
    const domDataId = (0, $e9368d03ee07580a$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, mode: mode, openKeys: openKeys, // Disabled
    disabled: contextDisabled, overflowDisabled: overflowDisabled, activeKey: // ActiveKey
    activeKey, selectedKeys: // SelectKey
    selectedKeys, // Icon
    itemIcon: contextItemIcon, expandIcon: contextExpandIcon, onItemClick: // Events
    onItemClick, onOpenChange: onOpenChange, onActive: onActive, popupRender: contextPopupRender } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    const { _internalRenderSubMenuItem: _internalRenderSubMenuItem } = $acw62.useContext((0, $60c4d7ed0dacae66$export$2e2bcd8739ae039));
    const { isSubPathKey: isSubPathKey } = $acw62.useContext((0, $43c59d964a3094e1$export$f0b9e0db98edfa53));
    const connectedPath = (0, $43c59d964a3094e1$export$d3d2d0a05677870a)();
    const subMenuPrefixCls = `${prefixCls}-submenu`;
    const mergedDisabled = contextDisabled || disabled;
    const elementRef = $acw62.useRef();
    const popupRef = $acw62.useRef();
    // ================================ Icon ================================
    const mergedItemIcon = itemIcon ?? contextItemIcon;
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    // ================================ Open ================================
    const originOpen = openKeys.includes(eventKey);
    const open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    const childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    const { active: active, ...activeProps } = (0, $50ac98fea1130fb3$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave);
    // Fallback of active check to avoid hover on menu title or disabled item
    const [childrenActive, setChildrenActive] = $acw62.useState(false);
    const triggerChildrenActive = (newActive)=>{
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    const onInternalMouseEnter = (domEvent)=>{
        triggerChildrenActive(true);
        onMouseEnter?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const onInternalMouseLeave = (domEvent)=>{
        triggerChildrenActive(false);
        onMouseLeave?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const mergedActive = $acw62.useMemo(()=>{
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    const directionStyle = (0, $8c19ab471667ff77$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    const onInternalTitleClick = (e)=>{
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick?.({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    const onMergedItemClick = (0, $b14f10147b58129a$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $6992ee8159aa33da$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    const onPopupVisibleChange = (newVisible)=>{
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = ()=>{
        onActive(eventKey);
    };
    // =============================== Render ===============================
    const popupId = domDataId && `${domDataId}-popup`;
    const expandIconNode = $acw62.useMemo(()=>/*#__PURE__*/ $acw62.createElement((0, $98e7a39a7002f55f$export$2e2bcd8739ae039), {
            icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
            props: {
                ...props,
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            }
        }, /*#__PURE__*/ $acw62.createElement("i", {
            className: `${subMenuPrefixCls}-arrow`
        })), [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    let titleNode = /*#__PURE__*/ $acw62.createElement("div", $b61e1d68050bda86$var$_extends({
        role: "menuitem",
        style: directionStyle,
        className: `${subMenuPrefixCls}-title`,
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    const triggerModeRef = $acw62.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    const popupContentTriggerMode = triggerModeRef.current;
    const renderPopupContent = $acw62.useMemo(()=>{
        const originNode = /*#__PURE__*/ $acw62.createElement((0, $626c1ba689347bd7$export$2e2bcd8739ae039), {
            classNames: menuClassNames,
            styles: styles,
            mode: popupContentTriggerMode === 'horizontal' ? 'vertical' : popupContentTriggerMode
        }, /*#__PURE__*/ $acw62.createElement((0, $926298de130fbde4$export$2e2bcd8739ae039), {
            id: popupId,
            ref: popupRef
        }, children));
        const mergedPopupRender = propsPopupRender || contextPopupRender;
        if (mergedPopupRender) {
            const node = mergedPopupRender(originNode, {
                item: props,
                keys: connectedPath
            });
            return node;
        }
        return originNode;
    }, [
        propsPopupRender,
        contextPopupRender,
        connectedPath,
        popupId,
        children,
        props,
        popupContentTriggerMode
    ]);
    if (!overflowDisabled) {
        const triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $acw62.createElement((0, $5f7be8b92760572b$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: renderPopupContent,
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    let listNode = /*#__PURE__*/ $acw62.createElement((0, $99393f3768089249$export$2e2bcd8739ae039).Item, $b61e1d68050bda86$var$_extends({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(subMenuPrefixCls, `${subMenuPrefixCls}-${mode}`, className, {
            [`${subMenuPrefixCls}-open`]: open,
            [`${subMenuPrefixCls}-active`]: mergedActive,
            [`${subMenuPrefixCls}-selected`]: childrenSelected,
            [`${subMenuPrefixCls}-disabled`]: mergedDisabled
        }),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $acw62.createElement((0, $d8db21347d397624$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $626c1ba689347bd7$export$2e2bcd8739ae039), {
        classNames: menuClassNames,
        styles: styles,
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
const $b61e1d68050bda86$var$SubMenu = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $43c59d964a3094e1$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $b1d87c6a18f4d735$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    const measure = (0, $43c59d964a3094e1$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    let renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $acw62.createElement($b61e1d68050bda86$var$InternalSubMenu, $b61e1d68050bda86$var$_extends({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $acw62.createElement((0, $43c59d964a3094e1$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $b61e1d68050bda86$export$2e2bcd8739ae039 = $b61e1d68050bda86$var$SubMenu;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



function $5c65d4c9df1720b6$export$2e2bcd8739ae039({ className: className, style: style }) {
    const { prefixCls: prefixCls } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    const measure = (0, $43c59d964a3094e1$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $acw62.createElement("li", {
        role: "separator",
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-item-divider`, className),
        style: style
    });
}






var $acw62 = parcelRequire("acw62");



function $6f1a929f0a4933a1$var$_extends() {
    $6f1a929f0a4933a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f1a929f0a4933a1$var$_extends.apply(this, arguments);
}
const $6f1a929f0a4933a1$var$InternalMenuItemGroup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: className, title: title, eventKey: eventKey, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: menuClassNames, styles: styles } = $acw62.useContext((0, $626c1ba689347bd7$export$c7e742effb1c51e2));
    const groupPrefixCls = `${prefixCls}-item-group`;
    return /*#__PURE__*/ $acw62.createElement("li", $6f1a929f0a4933a1$var$_extends({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: (e)=>e.stopPropagation(),
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(groupPrefixCls, className)
    }), /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${groupPrefixCls}-title`, menuClassNames?.listTitle),
        style: styles?.listTitle,
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $acw62.createElement("ul", {
        role: "group",
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${groupPrefixCls}-list`, menuClassNames?.list),
        style: styles?.list
    }, children));
});
const $6f1a929f0a4933a1$var$MenuItemGroup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $43c59d964a3094e1$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $b1d87c6a18f4d735$export$cd230e97e668be9)(children, connectedKeyPath);
    const measure = (0, $43c59d964a3094e1$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $acw62.createElement($6f1a929f0a4933a1$var$InternalMenuItemGroup, $6f1a929f0a4933a1$var$_extends({
        ref: ref
    }, (0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
        'warnKey'
    ])), childList);
});
var $6f1a929f0a4933a1$export$2e2bcd8739ae039 = $6f1a929f0a4933a1$var$MenuItemGroup;




function $794de9f9a0472f75$var$_extends() {
    $794de9f9a0472f75$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $794de9f9a0472f75$var$_extends.apply(this, arguments);
}
function $794de9f9a0472f75$var$convertItemsToNodes(list, components, prefixCls) {
    const { item: MergedMenuItem, group: MergedMenuItemGroup, submenu: MergedSubMenu, divider: MergedDivider } = components;
    return (list || []).map((opt, index)=>{
        if (opt && typeof opt === 'object') {
            const { label: label, children: children, key: key, type: type, extra: extra, ...restProps } = opt;
            const mergedKey = key ?? `tmp-${index}`;
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $acw62.createElement(MergedMenuItemGroup, $794de9f9a0472f75$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $794de9f9a0472f75$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ $acw62.createElement(MergedSubMenu, $794de9f9a0472f75$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $794de9f9a0472f75$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $acw62.createElement(MergedDivider, $794de9f9a0472f75$var$_extends({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $acw62.createElement(MergedMenuItem, $794de9f9a0472f75$var$_extends({
                key: mergedKey
            }, restProps, {
                extra: extra
            }), label, (!!extra || extra === 0) && /*#__PURE__*/ $acw62.createElement("span", {
                className: `${prefixCls}-item-extra`
            }, extra));
        }
        return null;
    }).filter((opt)=>opt);
}
function $794de9f9a0472f75$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    let childNodes = children;
    const mergedComponents = {
        divider: (0, $5c65d4c9df1720b6$export$2e2bcd8739ae039),
        item: (0, $d72dbaba5a7dd149$export$2e2bcd8739ae039),
        group: (0, $6f1a929f0a4933a1$export$2e2bcd8739ae039),
        submenu: (0, $b61e1d68050bda86$export$2e2bcd8739ae039),
        ...components
    };
    if (items) childNodes = $794de9f9a0472f75$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $b1d87c6a18f4d735$export$cd230e97e668be9)(childNodes, keyPath);
}



function $df6c16a2d2423e49$var$_extends() {
    $df6c16a2d2423e49$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $df6c16a2d2423e49$var$_extends.apply(this, arguments);
}
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
const $df6c16a2d2423e49$var$EMPTY_LIST = [];
const $df6c16a2d2423e49$var$Menu = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-menu', rootClassName: rootClassName, style: style, className: className, styles: styles, classNames: menuClassNames, tabIndex: tabIndex = 0, items: items, children: children, direction: direction, id: id, mode: // Mode
    mode = 'vertical', inlineCollapsed: inlineCollapsed, disabled: // Disabled
    disabled, disabledOverflow: disabledOverflow, subMenuOpenDelay: // Open
    subMenuOpenDelay = 0.1, subMenuCloseDelay: subMenuCloseDelay = 0.1, forceSubMenuRender: forceSubMenuRender, defaultOpenKeys: defaultOpenKeys, openKeys: openKeys, activeKey: // Active
    activeKey, defaultActiveFirst: defaultActiveFirst, selectable: // Selection
    selectable = true, multiple: multiple = false, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, onSelect: onSelect, onDeselect: onDeselect, inlineIndent: // Level
    inlineIndent = 24, motion: // Motion
    motion, defaultMotions: defaultMotions, triggerSubMenuAction: // Popup
    triggerSubMenuAction = 'hover', builtinPlacements: builtinPlacements, itemIcon: // Icon
    itemIcon, expandIcon: expandIcon, overflowedIndicator: overflowedIndicator = '...', overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, getPopupContainer: // Function
    getPopupContainer, onClick: // Events
    onClick, onOpenChange: onOpenChange, onKeyDown: onKeyDown, openAnimation: // Deprecated
    openAnimation, openTransitionName: openTransitionName, _internalRenderMenuItem: // Internal
    _internalRenderMenuItem, _internalRenderSubMenuItem: _internalRenderSubMenuItem, _internalComponents: _internalComponents, popupRender: popupRender, ...restProps } = props;
    const [childList, measureChildList] = $acw62.useMemo(()=>[
            (0, $794de9f9a0472f75$export$50458dc1a9a0f894)(children, items, $df6c16a2d2423e49$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $794de9f9a0472f75$export$50458dc1a9a0f894)(children, items, $df6c16a2d2423e49$var$EMPTY_LIST, {}, prefixCls)
        ], [
        children,
        items,
        _internalComponents
    ]);
    const [mounted, setMounted] = $acw62.useState(false);
    const containerRef = $acw62.useRef();
    const uuid = (0, $bba066f19964922a$export$2e2bcd8739ae039)(id ? `rc-menu-uuid-${id}` : 'rc-menu-uuid');
    const isRtl = direction === 'rtl';
    // ========================= Open =========================
    const [innerOpenKeys, setMergedOpenKeys] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultOpenKeys, openKeys);
    const mergedOpenKeys = innerOpenKeys || $df6c16a2d2423e49$var$EMPTY_LIST;
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    const triggerOpenKeys = (keys, forceFlush = false)=>{
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange?.(keys);
        }
        if (forceFlush) (0, $1u0KT.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    const [inlineCacheOpenKeys, setInlineCacheOpenKeys] = $acw62.useState(mergedOpenKeys);
    const mountRef = $acw62.useRef(false);
    // ========================= Mode =========================
    const [mergedMode, mergedInlineCollapsed] = $acw62.useMemo(()=>{
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]);
    const isInlineMode = mergedMode === 'inline';
    const [internalMode, setInternalMode] = $acw62.useState(mergedMode);
    const [internalInlineCollapsed, setInternalInlineCollapsed] = $acw62.useState(mergedInlineCollapsed);
    $acw62.useEffect(()=>{
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($df6c16a2d2423e49$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    const [lastVisibleIndex, setLastVisibleIndex] = $acw62.useState(0);
    const allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $acw62.useEffect(()=>{
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $acw62.useEffect(()=>{
        mountRef.current = true;
        return ()=>{
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    const { registerPath: registerPath, unregisterPath: unregisterPath, refreshOverflowKeys: refreshOverflowKeys, isSubPathKey: isSubPathKey, getKeyPath: getKeyPath, getKeys: getKeys, getSubPathKeys: getSubPathKeys } = (0, $48bd66e0031dd3e1$export$2e2bcd8739ae039)();
    const registerPathContext = $acw62.useMemo(()=>({
            registerPath: registerPath,
            unregisterPath: unregisterPath
        }), [
        registerPath,
        unregisterPath
    ]);
    const pathUserContext = $acw62.useMemo(()=>({
            isSubPathKey: isSubPathKey
        }), [
        isSubPathKey
    ]);
    $acw62.useEffect(()=>{
        refreshOverflowKeys(allVisible ? $df6c16a2d2423e49$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map((child)=>child.key));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    const [mergedActiveKey, setMergedActiveKey] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && childList[0]?.key, activeKey);
    const onActive = (0, $b14f10147b58129a$export$2e2bcd8739ae039)((key)=>{
        setMergedActiveKey(key);
    });
    const onInactive = (0, $b14f10147b58129a$export$2e2bcd8739ae039)(()=>{
        setMergedActiveKey(undefined);
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            list: containerRef.current,
            focus: (options)=>{
                const keys = getKeys();
                const { elements: elements, key2element: key2element, element2key: element2key } = (0, $531c784ba119bbfb$export$20827b68c762d23)(keys, uuid);
                const focusableElements = (0, $531c784ba119bbfb$export$433aaa1f216cf32d)(containerRef.current, elements);
                let shouldFocusKey;
                if (mergedActiveKey && keys.includes(mergedActiveKey)) shouldFocusKey = mergedActiveKey;
                else shouldFocusKey = focusableElements[0] ? element2key.get(focusableElements[0]) : childList.find((node)=>!node.props.disabled)?.key;
                const elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) elementToFocus?.focus?.(options);
            },
            findItem: ({ key: itemKey })=>{
                const keys = getKeys();
                const { key2element: key2element } = (0, $531c784ba119bbfb$export$20827b68c762d23)(keys, uuid);
                return key2element.get(itemKey) || null;
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    const [internalSelectKeys, setMergedSelectKeys] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultSelectedKeys || [], selectedKeys);
    const mergedSelectKeys = $acw62.useMemo(()=>{
        if (Array.isArray(internalSelectKeys)) return internalSelectKeys;
        if (internalSelectKeys === null || internalSelectKeys === undefined) return $df6c16a2d2423e49$var$EMPTY_LIST;
        return [
            internalSelectKeys
        ];
    }, [
        internalSelectKeys
    ]);
    // >>>>> Trigger select
    const triggerSelection = (info)=>{
        if (selectable) {
            // Insert or Remove
            const { key: targetKey } = info;
            const exist = mergedSelectKeys.includes(targetKey);
            let newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter((key)=>key !== targetKey);
                else newSelectKeys = [
                    ...mergedSelectKeys,
                    targetKey
                ];
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            const selectInfo = {
                ...info,
                selectedKeys: newSelectKeys
            };
            if (exist) onDeselect?.(selectInfo);
            else onSelect?.(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($df6c16a2d2423e49$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ const onInternalClick = (0, $b14f10147b58129a$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $6992ee8159aa33da$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    const onInternalOpenChange = (0, $b14f10147b58129a$export$2e2bcd8739ae039)((key, open)=>{
        let newOpenKeys = mergedOpenKeys.filter((k)=>k !== key);
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            const subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter((k)=>!subPathKeys.has(k));
        }
        if (!(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    const triggerAccessibilityOpen = (key, open)=>{
        const nextOpen = open ?? !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    const onInternalKeyDown = (0, $531c784ba119bbfb$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    // ======================= Context ========================
    const privateContext = $acw62.useMemo(()=>({
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        }), [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    const wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map((child, index)=>/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $acw62.createElement((0, $626c1ba689347bd7$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex,
            classNames: menuClassNames,
            styles: styles
        }, child));
    // >>>>> Container
    const container = /*#__PURE__*/ $acw62.createElement((0, $99393f3768089249$export$2e2bcd8739ae039), $df6c16a2d2423e49$var$_extends({
        id: id,
        ref: containerRef,
        prefixCls: `${prefixCls}-overflow`,
        component: "ul",
        itemComponent: (0, $d72dbaba5a7dd149$export$2e2bcd8739ae039),
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-root`, `${prefixCls}-${internalMode}`, className, {
            [`${prefixCls}-inline-collapsed`]: internalInlineCollapsed,
            [`${prefixCls}-rtl`]: isRtl
        }, rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: (node)=>node,
        renderRawRest: (omitItems)=>{
            // We use origin list since wrapped list use context to prevent open
            const len = omitItems.length;
            const originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $acw62.createElement((0, $b61e1d68050bda86$export$2e2bcd8739ae039), {
                eventKey: (0, $48bd66e0031dd3e1$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $99393f3768089249$export$2e2bcd8739ae039).INVALIDATE : (0, $99393f3768089249$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: (newLastIndex)=>{
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $60c4d7ed0dacae66$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $acw62.createElement((0, $e9368d03ee07580a$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $acw62.createElement((0, $626c1ba689347bd7$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        classNames: menuClassNames,
        styles: styles,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange,
        popupRender: popupRender
    }, /*#__PURE__*/ $acw62.createElement((0, $43c59d964a3094e1$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $acw62.createElement((0, $43c59d964a3094e1$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $df6c16a2d2423e49$export$2e2bcd8739ae039 = $df6c16a2d2423e49$var$Menu;







const $4fda38e69f71e3cd$var$ExportMenu = (0, $df6c16a2d2423e49$export$2e2bcd8739ae039);
$4fda38e69f71e3cd$var$ExportMenu.Item = (0, $d72dbaba5a7dd149$export$2e2bcd8739ae039);
$4fda38e69f71e3cd$var$ExportMenu.SubMenu = (0, $b61e1d68050bda86$export$2e2bcd8739ae039);
$4fda38e69f71e3cd$var$ExportMenu.ItemGroup = (0, $6f1a929f0a4933a1$export$2e2bcd8739ae039);
$4fda38e69f71e3cd$var$ExportMenu.Divider = (0, $5c65d4c9df1720b6$export$2e2bcd8739ae039);
var $4fda38e69f71e3cd$export$2e2bcd8739ae039 = $4fda38e69f71e3cd$var$ExportMenu;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $bf122e88db242cab$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $bf122e88db242cab$export$2e2bcd8739ae039 = $bf122e88db242cab$var$EllipsisOutlined;



function $18b92a77e6b0d38f$var$_extends() {
    $18b92a77e6b0d38f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18b92a77e6b0d38f$var$_extends.apply(this, arguments);
}
const $18b92a77e6b0d38f$var$EllipsisOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $18b92a77e6b0d38f$var$_extends({}, props, {
        ref: ref,
        icon: (0, $bf122e88db242cab$export$2e2bcd8739ae039)
    }));
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const $18b92a77e6b0d38f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($18b92a77e6b0d38f$var$EllipsisOutlined);
var $18b92a77e6b0d38f$export$2e2bcd8739ae039 = $18b92a77e6b0d38f$var$RefIcon;







var $acw62 = parcelRequire("acw62");


const $f5b1737011872d72$export$8bf64cd1c29a1310 = (schema, ...classNames)=>{
    const mergedSchema = schema || {};
    return classNames.filter(Boolean).reduce((acc, cur)=>{
        // Loop keys of the current classNames
        Object.keys(cur || {}).forEach((key)=>{
            const keySchema = mergedSchema[key];
            const curVal = cur[key];
            if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(keySchema)) {
                if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(curVal)) // Loop fill
                acc[key] = $f5b1737011872d72$export$8bf64cd1c29a1310(keySchema, acc[key], curVal);
                else {
                    // Covert string to object structure
                    const { _default: defaultField } = keySchema;
                    if (defaultField) {
                        acc[key] = acc[key] || {};
                        acc[key][defaultField] = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(acc[key][defaultField], curVal);
                    }
                }
            } else // Flatten fill
            acc[key] = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(acc[key], curVal);
        });
        return acc;
    }, {});
};
const $f5b1737011872d72$var$useSemanticClassNames = (schema, ...classNames)=>{
    return $acw62.useMemo(()=>$f5b1737011872d72$export$8bf64cd1c29a1310.apply(void 0, [
            schema
        ].concat(classNames)), [
        schema
    ].concat(classNames));
};
const $f5b1737011872d72$export$e618dc39ac9ad607 = (...styles)=>{
    return styles.filter(Boolean).reduce((acc, cur = {})=>{
        Object.keys(cur).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...cur[key]
            };
        });
        return acc;
    }, {});
};
const $f5b1737011872d72$var$useSemanticStyles = (...styles)=>{
    return $acw62.useMemo(()=>$f5b1737011872d72$export$e618dc39ac9ad607.apply(void 0, styles), [].concat(styles));
};
// =========================== Export ===========================
const $f5b1737011872d72$var$fillObjectBySchema = (obj, schema)=>{
    const newObj = {
        ...obj
    };
    Object.keys(schema).forEach((key)=>{
        if (key !== '_default') {
            const nestSchema = schema[key];
            const nextValue = newObj[key] || {};
            newObj[key] = nestSchema ? $f5b1737011872d72$var$fillObjectBySchema(nextValue, nestSchema) : nextValue;
        }
    });
    return newObj;
};
const $f5b1737011872d72$export$ccd424010a24474f = (value, info)=>{
    return typeof value === 'function' ? value(info) : value;
};
const $f5b1737011872d72$export$648566b068f28737 = (classNamesList, stylesList, info, schema)=>{
    const resolvedClassNamesList = classNamesList.map((classNames)=>classNames ? $f5b1737011872d72$export$ccd424010a24474f(classNames, info) : undefined);
    const resolvedStylesList = stylesList.map((styles)=>styles ? $f5b1737011872d72$export$ccd424010a24474f(styles, info) : undefined);
    const mergedClassNames = $f5b1737011872d72$var$useSemanticClassNames.apply(void 0, [
        schema
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(resolvedClassNamesList)));
    const mergedStyles = $f5b1737011872d72$var$useSemanticStyles.apply(void 0, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(resolvedStylesList));
    return $acw62.useMemo(()=>{
        if (!schema) return [
            mergedClassNames,
            mergedStyles
        ];
        return [
            $f5b1737011872d72$var$fillObjectBySchema(mergedClassNames, schema),
            $f5b1737011872d72$var$fillObjectBySchema(mergedStyles, schema)
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        schema
    ]);
};




// ================== Collapse Motion ==================
const $2efb522a5615f01e$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $2efb522a5615f01e$var$getRealHeight = (node)=>({
        height: node?.scrollHeight ?? 0,
        opacity: node ? 1 : 0
    });
const $2efb522a5615f01e$var$getCurrentHeight = (node)=>({
        height: node?.offsetHeight ?? 0
    });
const $2efb522a5615f01e$var$isTransitionEvent = (event)=>{
    return (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(event) && 'propertyName' in event;
};
const $2efb522a5615f01e$var$skipOpacityTransition = (_, event)=>{
    return event?.deadline === true || ($2efb522a5615f01e$var$isTransitionEvent(event) ? event.propertyName === 'height' : false);
};
const $2efb522a5615f01e$var$initCollapseMotion = (rootCls = (0, $a18b2f6f56546238$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onEnterStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearActive: $2efb522a5615f01e$var$getRealHeight,
        onEnterActive: $2efb522a5615f01e$var$getRealHeight,
        onLeaveStart: $2efb522a5615f01e$var$getCurrentHeight,
        onLeaveActive: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onEnterEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onLeaveEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $2efb522a5615f01e$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $2efb522a5615f01e$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $2efb522a5615f01e$export$2e2bcd8739ae039 = $2efb522a5615f01e$var$initCollapseMotion;






/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $9be8217fdbca7dca$var$useCSSVarCls = (prefixCls)=>`${prefixCls}-css-var`;
var $9be8217fdbca7dca$export$2e2bcd8739ae039 = $9be8217fdbca7dca$var$useCSSVarCls;



var $acw62 = parcelRequire("acw62");
"use client";
const $f1be9e89e34926b1$var$MenuContext = /*#__PURE__*/ (0, $acw62.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null
});
var $f1be9e89e34926b1$export$2e2bcd8739ae039 = $f1be9e89e34926b1$var$MenuContext;



var $acw62 = parcelRequire("acw62");



"use client";
const $d26f09d6992ff5d8$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $5c65d4c9df1720b6$export$2e2bcd8739ae039), {
        className: classString,
        ...restProps
    });
};
var $d26f09d6992ff5d8$export$2e2bcd8739ae039 = $d26f09d6992ff5d8$var$MenuDivider;



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $6caa44062abe67c3$var$Popup = (props)=>{
    const { children: children, prefixCls: prefixCls, id: id, classNames: classNames, styles: styles, className: className, style: style } = props;
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: id,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.container, className),
        style: {
            ...styles?.container,
            ...style
        },
        role: "tooltip"
    }, typeof children === 'function' ? children() : children);
};
var $6caa44062abe67c3$export$2e2bcd8739ae039 = $6caa44062abe67c3$var$Popup;






var $acw62 = parcelRequire("acw62");
const $a651125de3fedff7$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
const $a651125de3fedff7$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
const $a651125de3fedff7$var$targetOffset = [
    0,
    0
];
const $a651125de3fedff7$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $a651125de3fedff7$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $a651125de3fedff7$var$targetOffset
    }
};
var $a651125de3fedff7$export$2e2bcd8739ae039 = $a651125de3fedff7$export$803cd8101b6c182b;



function $a7e27eb595dabcc5$var$_extends() {
    $a7e27eb595dabcc5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a7e27eb595dabcc5$var$_extends.apply(this, arguments);
}
const $a7e27eb595dabcc5$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { trigger: trigger = [
        'hover'
    ], mouseEnterDelay: mouseEnterDelay = 0, mouseLeaveDelay: mouseLeaveDelay = 0.1, prefixCls: prefixCls = 'rc-tooltip', children: children, onVisibleChange: onVisibleChange, afterVisibleChange: afterVisibleChange, motion: motion, placement: placement = 'right', align: align = {}, destroyOnHidden: destroyOnHidden = false, defaultVisible: defaultVisible, getTooltipContainer: getTooltipContainer, arrowContent: arrowContent, overlay: overlay, id: id, showArrow: showArrow = true, classNames: classNames, styles: styles, ...restProps } = props;
    const mergedId = (0, $bba066f19964922a$export$2e2bcd8739ae039)(id);
    const triggerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>triggerRef.current);
    const extraProps = {
        ...restProps
    };
    if ('visible' in props) extraProps.popupVisible = props.visible;
    // ========================= Arrow ==========================
    // Process arrow configuration
    const mergedArrow = $acw62.useMemo(()=>{
        if (!showArrow) return false;
        // Convert true to object for unified processing
        const arrowConfig = showArrow === true ? {} : showArrow;
        // Apply semantic styles with unified logic
        return {
            ...arrowConfig,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(arrowConfig.className, classNames?.arrow),
            style: {
                ...arrowConfig.style,
                ...styles?.arrow
            },
            content: arrowConfig.content ?? arrowContent
        };
    }, [
        showArrow,
        classNames?.arrow,
        styles?.arrow,
        arrowContent
    ]);
    // ======================== Children ========================
    const getChildren = ({ open: open })=>{
        const child = $acw62.Children.only(children);
        const ariaProps = {
            'aria-describedby': overlay && open ? mergedId : undefined
        };
        return /*#__PURE__*/ $acw62.cloneElement(child, ariaProps);
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), $a7e27eb595dabcc5$var$_extends({
        popupClassName: classNames?.root,
        prefixCls: prefixCls,
        popup: /*#__PURE__*/ $acw62.createElement((0, $6caa44062abe67c3$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            classNames: classNames,
            styles: styles
        }, overlay),
        action: trigger,
        builtinPlacements: (0, $a651125de3fedff7$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onOpenChange: onVisibleChange,
        afterOpenChange: afterVisibleChange,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyOnHidden,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: styles?.root,
        mouseEnterDelay: mouseEnterDelay,
        arrow: mergedArrow,
        uniqueContainerClassName: classNames?.uniqueContainer,
        uniqueContainerStyle: styles?.uniqueContainer
    }, extraProps), getChildren);
});
var $a7e27eb595dabcc5$export$2e2bcd8739ae039 = $a7e27eb595dabcc5$var$Tooltip;


var $bc39d45433aa644b$export$2e2bcd8739ae039 = (0, $a7e27eb595dabcc5$export$2e2bcd8739ae039);





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $1af3680bf0b051ba$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1af3680bf0b051ba$var$warningFunc = ()=>{
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
const $1af3680bf0b051ba$var$Context = /*#__PURE__*/ $acw62.createContext({
    getFieldValue: $1af3680bf0b051ba$var$warningFunc,
    getFieldsValue: $1af3680bf0b051ba$var$warningFunc,
    getFieldError: $1af3680bf0b051ba$var$warningFunc,
    getFieldWarning: $1af3680bf0b051ba$var$warningFunc,
    getFieldsError: $1af3680bf0b051ba$var$warningFunc,
    isFieldsTouched: $1af3680bf0b051ba$var$warningFunc,
    isFieldTouched: $1af3680bf0b051ba$var$warningFunc,
    isFieldValidating: $1af3680bf0b051ba$var$warningFunc,
    isFieldsValidating: $1af3680bf0b051ba$var$warningFunc,
    resetFields: $1af3680bf0b051ba$var$warningFunc,
    setFields: $1af3680bf0b051ba$var$warningFunc,
    setFieldValue: $1af3680bf0b051ba$var$warningFunc,
    setFieldsValue: $1af3680bf0b051ba$var$warningFunc,
    validateFields: $1af3680bf0b051ba$var$warningFunc,
    submit: $1af3680bf0b051ba$var$warningFunc,
    getInternalHooks: ()=>{
        $1af3680bf0b051ba$var$warningFunc();
        return {
            dispatch: $1af3680bf0b051ba$var$warningFunc,
            initEntityValue: $1af3680bf0b051ba$var$warningFunc,
            registerField: $1af3680bf0b051ba$var$warningFunc,
            useSubscribe: $1af3680bf0b051ba$var$warningFunc,
            setInitialValues: $1af3680bf0b051ba$var$warningFunc,
            destroyForm: $1af3680bf0b051ba$var$warningFunc,
            setCallbacks: $1af3680bf0b051ba$var$warningFunc,
            registerWatch: $1af3680bf0b051ba$var$warningFunc,
            getFields: $1af3680bf0b051ba$var$warningFunc,
            setValidateMessages: $1af3680bf0b051ba$var$warningFunc,
            setPreserve: $1af3680bf0b051ba$var$warningFunc,
            getInitialValue: $1af3680bf0b051ba$var$warningFunc
        };
    }
});
var $1af3680bf0b051ba$export$2e2bcd8739ae039 = $1af3680bf0b051ba$var$Context;



var $acw62 = parcelRequire("acw62");
const $417fab7cc2fd8514$var$ListContext = /*#__PURE__*/ $acw62.createContext(null);
var $417fab7cc2fd8514$export$2e2bcd8739ae039 = $417fab7cc2fd8514$var$ListContext;


function $818c2eda4ba0a65a$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $818c2eda4ba0a65a$export$717b316e73068e8d(form) {
    return form && !!form._init;
}








function $561ee5dfc4dc516a$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            tel: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $561ee5dfc4dc516a$export$defe85febe8b728c = $561ee5dfc4dc516a$export$f77fd0c3b25d8534();











function $7fc69e80a314c4c3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}




function $a01f1d6c8bd49d36$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $b2099f49db83e2df$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $b6acf1c5cac9dbb2$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $7fc69e80a314c4c3$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $a01f1d6c8bd49d36$export$2e2bcd8739ae039)(t, arguments, (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(Wrapper, t);
    }, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t);
}




/* eslint no-console:0 */ var $5666056929fa6d0a$var$formatRegExp = /%[sdj%]/g;
var $5666056929fa6d0a$export$491112666e282270 = function warning() {};
function $5666056929fa6d0a$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $5666056929fa6d0a$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($5666056929fa6d0a$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $5666056929fa6d0a$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern' || type === 'tel';
}
function $5666056929fa6d0a$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($5666056929fa6d0a$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $5666056929fa6d0a$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $5666056929fa6d0a$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $5666056929fa6d0a$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $5666056929fa6d0a$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(objArr[k] || []));
    });
    return ret;
}
var $5666056929fa6d0a$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AsyncValidationError, _Error);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "errors", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AsyncValidationError);
}(/*#__PURE__*/ (0, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039)(Error));
function $5666056929fa6d0a$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $5666056929fa6d0a$export$188f48b73534b6f0(errors, $5666056929fa6d0a$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $5666056929fa6d0a$var$flattenObjArr(objArr);
            $5666056929fa6d0a$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $5666056929fa6d0a$export$188f48b73534b6f0(results, $5666056929fa6d0a$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $5666056929fa6d0a$var$asyncSerialArray(arr, func, next);
            else $5666056929fa6d0a$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $5666056929fa6d0a$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $5666056929fa6d0a$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $5666056929fa6d0a$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $5666056929fa6d0a$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($5666056929fa6d0a$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $5666056929fa6d0a$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target[s]) === 'object') target[s] = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}



var $488acc05b055d7b8$var$ENUM = 'enum';
var $488acc05b055d7b8$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$488acc05b055d7b8$var$ENUM] = Array.isArray(rule[$488acc05b055d7b8$var$ENUM]) ? rule[$488acc05b055d7b8$var$ENUM] : [];
    if (rule[$488acc05b055d7b8$var$ENUM].indexOf(value) === -1) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[$488acc05b055d7b8$var$ENUM], rule.fullField, rule[$488acc05b055d7b8$var$ENUM].join(', ')));
};
var $488acc05b055d7b8$export$2e2bcd8739ae039 = $488acc05b055d7b8$var$enumerable;



var $a35cdee3e4b23caa$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $a35cdee3e4b23caa$export$2e2bcd8739ae039 = $a35cdee3e4b23caa$var$pattern;



var $0c32d438c85e52c5$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $0c32d438c85e52c5$export$2e2bcd8739ae039 = $0c32d438c85e52c5$var$range;



var $367d23b7d6b626de$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $367d23b7d6b626de$export$2e2bcd8739ae039 = $367d23b7d6b626de$var$required;





// https://github.com/kevva/url-regex/blob/master/index.js
var $717e29c17bb36fc4$var$urlReg;
var $717e29c17bb36fc4$export$2e2bcd8739ae039 = function() {
    if ($717e29c17bb36fc4$var$urlReg) return $717e29c17bb36fc4$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $717e29c17bb36fc4$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $717e29c17bb36fc4$var$urlReg;
};


/* eslint max-len:0 */ var $a5d3e25a95ca0fb0$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    /**
   * Phone number regex, support country code, brackets, spaces, and dashes (or non-breaking hyphen \u2011).
   * @see https://regexr.com/3c53v
   * @see https://ihateregex.io/expr/phone/
   * @see https://developers.google.com/style/phone-numbers using non-breaking hyphen \u2011
   */ tel: /^(\+[0-9]{1,3}[-\s\u2011]?)?(\([0-9]{1,4}\)[-\s\u2011]?)?([0-9]+[-\s\u2011]?)*[0-9]+$/,
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $a5d3e25a95ca0fb0$var$types = {
    integer: function integer(value) {
        return $a5d3e25a95ca0fb0$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $a5d3e25a95ca0fb0$var$types.number(value) && !$a5d3e25a95ca0fb0$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && !$a5d3e25a95ca0fb0$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($a5d3e25a95ca0fb0$var$pattern.email);
    },
    tel: function tel(value) {
        return typeof value === 'string' && value.length <= 32 && !!value.match($a5d3e25a95ca0fb0$var$pattern.tel);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $717e29c17bb36fc4$export$2e2bcd8739ae039)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($a5d3e25a95ca0fb0$var$pattern.hex);
    }
};
var $a5d3e25a95ca0fb0$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $367d23b7d6b626de$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'tel',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$a5d3e25a95ca0fb0$var$types[ruleType](value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) !== rule.type) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $a5d3e25a95ca0fb0$export$2e2bcd8739ae039 = $a5d3e25a95ca0fb0$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $14b0862e76234af4$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $14b0862e76234af4$export$2e2bcd8739ae039 = $14b0862e76234af4$var$whitespace;


var $0347bc150d6f2e32$export$2e2bcd8739ae039 = {
    required: (0, $367d23b7d6b626de$export$2e2bcd8739ae039),
    whitespace: (0, $14b0862e76234af4$export$2e2bcd8739ae039),
    type: (0, $a5d3e25a95ca0fb0$export$2e2bcd8739ae039),
    range: (0, $0c32d438c85e52c5$export$2e2bcd8739ae039),
    enum: (0, $488acc05b055d7b8$export$2e2bcd8739ae039),
    pattern: (0, $a35cdee3e4b23caa$export$2e2bcd8739ae039)
};



var $857fca5fb1675ca6$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $857fca5fb1675ca6$export$2e2bcd8739ae039 = $857fca5fb1675ca6$var$any;



var $e1df68b6ecc210d4$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $e1df68b6ecc210d4$export$2e2bcd8739ae039 = $e1df68b6ecc210d4$var$array;




var $02baf34e66bc03aa$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $02baf34e66bc03aa$export$2e2bcd8739ae039 = $02baf34e66bc03aa$var$boolean;




var $1138e96dc48b4fc5$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'date') && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $1138e96dc48b4fc5$export$2e2bcd8739ae039 = $1138e96dc48b4fc5$var$date;




var $a22ed5dbeaeb8c02$var$ENUM = 'enum';
var $a22ed5dbeaeb8c02$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039)[$a22ed5dbeaeb8c02$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $a22ed5dbeaeb8c02$export$2e2bcd8739ae039 = $a22ed5dbeaeb8c02$var$enumerable;




var $4b57481f55e2d7bb$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $4b57481f55e2d7bb$export$2e2bcd8739ae039 = $4b57481f55e2d7bb$var$floatFn;




var $64c62bbb3fde492f$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $64c62bbb3fde492f$export$2e2bcd8739ae039 = $64c62bbb3fde492f$var$integer;




var $eb8f17d9362978d2$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $eb8f17d9362978d2$export$2e2bcd8739ae039 = $eb8f17d9362978d2$var$method;




var $c0807ef45346ad43$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $c0807ef45346ad43$export$2e2bcd8739ae039 = $c0807ef45346ad43$var$number;




var $04bb6b410c7a206f$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $04bb6b410c7a206f$export$2e2bcd8739ae039 = $04bb6b410c7a206f$var$object;




var $51bdf3a9527552af$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string')) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $51bdf3a9527552af$export$2e2bcd8739ae039 = $51bdf3a9527552af$var$pattern;




var $81e7b9249a6aadc4$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value)) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $81e7b9249a6aadc4$export$2e2bcd8739ae039 = $81e7b9249a6aadc4$var$regexp;




var $9f32c5d072c41c33$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value);
    (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $9f32c5d072c41c33$export$2e2bcd8739ae039 = $9f32c5d072c41c33$var$required;




var $b12128c8b08da777$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'string');
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string')) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b12128c8b08da777$export$2e2bcd8739ae039 = $b12128c8b08da777$var$string;




var $a937786d6e0818eb$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, ruleType)) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $a937786d6e0818eb$export$2e2bcd8739ae039 = $a937786d6e0818eb$var$type;


var $562afa29da428a80$export$2e2bcd8739ae039 = {
    string: (0, $b12128c8b08da777$export$2e2bcd8739ae039),
    method: (0, $eb8f17d9362978d2$export$2e2bcd8739ae039),
    number: (0, $c0807ef45346ad43$export$2e2bcd8739ae039),
    boolean: (0, $02baf34e66bc03aa$export$2e2bcd8739ae039),
    regexp: (0, $81e7b9249a6aadc4$export$2e2bcd8739ae039),
    integer: (0, $64c62bbb3fde492f$export$2e2bcd8739ae039),
    float: (0, $4b57481f55e2d7bb$export$2e2bcd8739ae039),
    array: (0, $e1df68b6ecc210d4$export$2e2bcd8739ae039),
    object: (0, $04bb6b410c7a206f$export$2e2bcd8739ae039),
    enum: (0, $a22ed5dbeaeb8c02$export$2e2bcd8739ae039),
    pattern: (0, $51bdf3a9527552af$export$2e2bcd8739ae039),
    date: (0, $1138e96dc48b4fc5$export$2e2bcd8739ae039),
    url: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    hex: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    email: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    tel: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    required: (0, $9f32c5d072c41c33$export$2e2bcd8739ae039),
    any: (0, $857fca5fb1675ca6$export$2e2bcd8739ae039)
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $4b94184ce2afa17e$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Schema);
        // ======================== Instance ========================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "rules", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_messages", (0, $561ee5dfc4dc516a$export$defe85febe8b728c));
        this.define(descriptor);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $5666056929fa6d0a$export$6969335ea1e4e77c)((0, $561ee5dfc4dc516a$export$f77fd0c3b25d8534)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $5666056929fa6d0a$export$e85887f5ceeacced)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $561ee5dfc4dc516a$export$defe85febe8b728c)) messages = (0, $561ee5dfc4dc516a$export$f77fd0c3b25d8534)();
                    (0, $5666056929fa6d0a$export$6969335ea1e4e77c)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $5666056929fa6d0a$export$707ee4c4c95d39e3)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(rule.fields) === 'object' || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined && rule.message !== null) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $5666056929fa6d0a$export$34d5fe50d2616cee)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $5666056929fa6d0a$export$34d5fe50d2616cee)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $562afa29da428a80$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $5666056929fa6d0a$export$d9468344d3651243)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $562afa29da428a80$export$2e2bcd8739ae039).required;
                return (0, $562afa29da428a80$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $562afa29da428a80$export$2e2bcd8739ae039)[type] = validator;
});
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "warning", (0, $5666056929fa6d0a$export$491112666e282270));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "messages", (0, $561ee5dfc4dc516a$export$defe85febe8b728c));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "validators", (0, $562afa29da428a80$export$2e2bcd8739ae039));
var $4b94184ce2afa17e$export$2e2bcd8739ae039 = $4b94184ce2afa17e$var$Schema;



var $acw62 = parcelRequire("acw62");

const $6e820d951131e2e2$var$typeTemplate = "'${name}' is not a valid ${type}";
const $6e820d951131e2e2$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $6e820d951131e2e2$var$typeTemplate,
        method: $6e820d951131e2e2$var$typeTemplate,
        array: $6e820d951131e2e2$var$typeTemplate,
        object: $6e820d951131e2e2$var$typeTemplate,
        number: $6e820d951131e2e2$var$typeTemplate,
        date: $6e820d951131e2e2$var$typeTemplate,
        boolean: $6e820d951131e2e2$var$typeTemplate,
        integer: $6e820d951131e2e2$var$typeTemplate,
        float: $6e820d951131e2e2$var$typeTemplate,
        regexp: $6e820d951131e2e2$var$typeTemplate,
        email: $6e820d951131e2e2$var$typeTemplate,
        tel: $6e820d951131e2e2$var$typeTemplate,
        url: $6e820d951131e2e2$var$typeTemplate,
        hex: $6e820d951131e2e2$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
const $c6886a71ba909f1e$var$AsyncValidator = (0, $4b94184ce2afa17e$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $c6886a71ba909f1e$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, (str)=>{
        if (str.startsWith('\\')) return str.slice(1);
        const key = str.slice(2, -1);
        return kv[key];
    });
}
const $c6886a71ba909f1e$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
async function $c6886a71ba909f1e$var$validateRule(name, value, rule, options, messageVariables) {
    const cloneRule = {
        ...rule
    };
    // Bug of `async-validator`
    // https://github.com/react-component/field-form/issues/316
    // https://github.com/react-component/field-form/issues/313
    delete cloneRule.ruleIndex;
    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
    $c6886a71ba909f1e$var$AsyncValidator.warning = ()=>void 0;
    if (cloneRule.validator) {
        const originValidator = cloneRule.validator;
        cloneRule.validator = (...args)=>{
            try {
                return originValidator(...args);
            } catch (error) {
                console.error(error);
                return Promise.reject($c6886a71ba909f1e$var$CODE_LOGIC_ERROR);
            }
        };
    }
    // We should special handle array validate
    let subRuleField = null;
    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
        subRuleField = cloneRule.defaultField;
        delete cloneRule.defaultField;
    }
    const validator = new $c6886a71ba909f1e$var$AsyncValidator({
        [name]: [
            cloneRule
        ]
    });
    const messages = (0, $4ee33241e7a6f41e$export$4950aa0f605343fb)((0, $6e820d951131e2e2$export$c86b939816b8fbf8), options.validateMessages);
    validator.messages(messages);
    let result = [];
    try {
        await Promise.resolve(validator.validate({
            [name]: value
        }, {
            ...options
        }));
    } catch (errObj) {
        if (errObj.errors) result = errObj.errors.map(({ message: message }, index)=>{
            const mergedMessage = message === $c6886a71ba909f1e$var$CODE_LOGIC_ERROR ? messages.default : message;
            return /*#__PURE__*/ $acw62.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
            $acw62.cloneElement(mergedMessage, {
                key: `error_${index}`
            }) : mergedMessage;
        });
    }
    if (!result.length && subRuleField && Array.isArray(value) && value.length > 0) {
        const subResults = await Promise.all(value.map((subValue, i)=>$c6886a71ba909f1e$var$validateRule(`${name}.${i}`, subValue, subRuleField, options, messageVariables)));
        return subResults.reduce((prev, errors)=>[
                ...prev,
                ...errors
            ], []);
    }
    // Replace message with variables
    const kv = {
        ...rule,
        name: name,
        enum: (rule.enum || []).join(', '),
        ...messageVariables
    };
    const fillVariableResult = result.map((error)=>{
        if (typeof error === 'string') return $c6886a71ba909f1e$var$replaceMessage(error, kv);
        return error;
    });
    return fillVariableResult;
}
function $c6886a71ba909f1e$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    const name = namePath.join('.');
    // Fill rule with context
    const filledRules = rules.map((currentRule, ruleIndex)=>{
        const originValidatorFunc = currentRule.validator;
        const cloneRule = {
            ...currentRule,
            ruleIndex: ruleIndex
        };
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = (rule, val, callback)=>{
            let hasPromise = false;
            // Wrap callback only accept when promise not provided
            const wrappedCallback = (...args)=>{
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(()=>{
                    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback(...args);
                });
            };
            // Get promise
            const promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(()=>{
                callback();
            }).catch((err)=>{
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(({ warningOnly: w1, ruleIndex: i1 }, { warningOnly: w2, ruleIndex: i2 })=>{
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    let summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(async (resolve, reject)=>{
        /* eslint-disable no-await-in-loop */ for(let i = 0; i < filledRules.length; i += 1){
            const rule = filledRules[i];
            const errors = await $c6886a71ba909f1e$var$validateRule(name, value, rule, options, messageVariables);
            if (errors.length) {
                reject([
                    {
                        errors: errors,
                        rule: rule
                    }
                ]);
                return;
            }
        }
        /* eslint-enable */ resolve([]);
    });
    else {
        // >>>>> Validate by parallel
        const rulePromises = filledRules.map((rule)=>$c6886a71ba909f1e$var$validateRule(name, value, rule, options, messageVariables).then((errors)=>({
                    errors: errors,
                    rule: rule
                })));
        summaryPromise = (validateFirst ? $c6886a71ba909f1e$var$finishOnFirstFailed(rulePromises) : $c6886a71ba909f1e$var$finishOnAllFailed(rulePromises)).then((errors)=>{
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch((e)=>e);
    return summaryPromise;
}
async function $c6886a71ba909f1e$var$finishOnAllFailed(rulePromises) {
    return Promise.all(rulePromises).then((errorsList)=>{
        const errors = [].concat(...errorsList);
        return errors;
    });
}
async function $c6886a71ba909f1e$var$finishOnFirstFailed(rulePromises) {
    let count = 0;
    return new Promise((resolve)=>{
        rulePromises.forEach((promise)=>{
            promise.then((ruleError)=>{
                if (ruleError.errors.length) resolve([
                    ruleError
                ]);
                count += 1;
                if (count === rulePromises.length) resolve([]);
            });
        });
    });
}





function $06fb2ac41280cd60$export$f877b3cb4cb4ccf9(path) {
    return (0, $818c2eda4ba0a65a$export$45b10814cc054894)(path);
}
function $06fb2ac41280cd60$export$f5be6dfb30403c59(store, namePathList) {
    let newStore = {};
    namePathList.forEach((namePath)=>{
        const value = (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $06fb2ac41280cd60$export$646d5504364ae55b(namePathList, namePath, partialMatch = false) {
    return namePathList && namePathList.some((path)=>$06fb2ac41280cd60$export$325a4bd0e71bdc3a(namePath, path, partialMatch));
}
function $06fb2ac41280cd60$export$325a4bd0e71bdc3a(namePath, subNamePath, partialMatch = false) {
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every((nameUnit, i)=>namePath[i] === nameUnit);
}
function $06fb2ac41280cd60$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || typeof source !== 'object' || typeof target !== 'object') return false;
    const sourceKeys = Object.keys(source);
    const targetKeys = Object.keys(target);
    const keys = new Set([
        ...sourceKeys,
        ...targetKeys
    ]);
    return [
        ...keys
    ].every((key)=>{
        const sourceValue = source[key];
        const targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $06fb2ac41280cd60$export$6eeac3c5b406fb30(valuePropName, ...args) {
    const event = args[0];
    if (event && event.target && typeof event.target === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $06fb2ac41280cd60$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    const { length: length } = array;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    const item = array[moveIndex];
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...array.slice(0, toIndex),
        item,
        ...array.slice(toIndex, moveIndex),
        ...array.slice(moveIndex + 1, length)
    ];
    if (diff < 0) // move right
    return [
        ...array.slice(0, moveIndex),
        ...array.slice(moveIndex + 1, toIndex + 1),
        item,
        ...array.slice(toIndex + 1, length)
    ];
    return array;
}



const $33e8a00a9e924f2f$export$f1309b2412c6fa89 = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
class $33e8a00a9e924f2f$export$2e2bcd8739ae039 {
    namePathList = [];
    taskId = 0;
    watcherList = new Set();
    form;
    constructor(form){
        this.form = form;
    }
    register(callback) {
        this.watcherList.add(callback);
        return ()=>{
            this.watcherList.delete(callback);
        };
    }
    notify(namePath) {
        // Insert with deduplication
        namePath.forEach((path)=>{
            if (this.namePathList.every((exist)=>!(0, $06fb2ac41280cd60$export$325a4bd0e71bdc3a)(exist, path))) this.namePathList.push(path);
        });
        this.doBatch();
    }
    doBatch() {
        this.taskId += 1;
        const currentId = this.taskId;
        $33e8a00a9e924f2f$export$f1309b2412c6fa89(()=>{
            if (currentId === this.taskId && this.watcherList.size) {
                const formInst = this.form.getForm();
                const values = formInst.getFieldsValue();
                const allValues = formInst.getFieldsValue(true);
                this.watcherList.forEach((callback)=>{
                    callback(values, allValues, this.namePathList);
                });
                this.namePathList = [];
            }
        });
    }
}



async function $aee064bf4769c950$export$2e2bcd8739ae039() {
    return new Promise((resolve)=>{
        (0, $33e8a00a9e924f2f$export$f1309b2412c6fa89)(()=>{
            (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                resolve();
            });
        });
    });
}


function $c47f394f570329ce$var$_extends() {
    $c47f394f570329ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c47f394f570329ce$var$_extends.apply(this, arguments);
}
const $c47f394f570329ce$var$EMPTY_ERRORS = [];
const $c47f394f570329ce$var$EMPTY_WARNINGS = [];
function $c47f394f570329ce$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
class $c47f394f570329ce$var$Field extends $acw62.Component {
    static contextType = (0, $1af3680bf0b051ba$export$2e2bcd8739ae039);
    state = {
        resetCount: 0
    };
    cancelRegisterFunc = null;
    mounted = false;
    /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */ touched = false;
    /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */ dirty = false;
    validatePromise;
    prevValidating;
    errors = $c47f394f570329ce$var$EMPTY_ERRORS;
    warnings = $c47f394f570329ce$var$EMPTY_WARNINGS;
    // ============================== Subscriptions ==============================
    constructor(props){
        super(props);
        // Register on init
        if (props.fieldContext) {
            const { getInternalHooks: getInternalHooks } = props.fieldContext;
            const { initEntityValue: initEntityValue } = getInternalHooks((0, $1af3680bf0b051ba$export$24829b7c0e49e9f7));
            initEntityValue(this);
        }
    }
    componentDidMount() {
        const { shouldUpdate: shouldUpdate, fieldContext: fieldContext } = this.props;
        this.mounted = true;
        // Register on init
        if (fieldContext) {
            const { getInternalHooks: getInternalHooks } = fieldContext;
            const { registerField: registerField } = getInternalHooks((0, $1af3680bf0b051ba$export$24829b7c0e49e9f7));
            this.cancelRegisterFunc = registerField(this);
        }
        // One more render for component in case fields not ready
        if (shouldUpdate === true) this.reRender();
    }
    componentWillUnmount() {
        this.cancelRegister();
        this.triggerMetaEvent(true);
        this.mounted = false;
    }
    cancelRegister = ()=>{
        const { preserve: preserve, isListField: isListField, name: name } = this.props;
        if (this.cancelRegisterFunc) this.cancelRegisterFunc(isListField, preserve, (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name));
        this.cancelRegisterFunc = null;
    };
    // ================================== Utils ==================================
    getNamePath = ()=>{
        const { name: name, fieldContext: fieldContext } = this.props;
        const { prefixName: prefixName = [] } = fieldContext;
        return name !== undefined ? [
            ...prefixName,
            ...name
        ] : [];
    };
    getRules = ()=>{
        const { rules: rules = [], fieldContext: fieldContext } = this.props;
        return rules.map((rule)=>{
            if (typeof rule === 'function') return rule(fieldContext);
            return rule;
        });
    };
    reRender() {
        if (!this.mounted) return;
        this.forceUpdate();
    }
    refresh = ()=>{
        if (!this.mounted) return;
        /**
     * Clean up current node.
     */ this.setState(({ resetCount: resetCount })=>({
                resetCount: resetCount + 1
            }));
    };
    // Event should only trigger when meta changed
    metaCache = null;
    triggerMetaEvent = (destroy)=>{
        const { onMetaChange: onMetaChange } = this.props;
        if (onMetaChange) {
            const meta = {
                ...this.getMeta(),
                destroy: destroy
            };
            if (!(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(this.metaCache, meta)) onMetaChange(meta);
            this.metaCache = meta;
        } else this.metaCache = null;
    };
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    onStoreChange = (prevStore, namePathList, info)=>{
        const { shouldUpdate: shouldUpdate, dependencies: dependencies = [], onReset: onReset } = this.props;
        const { store: store } = info;
        const namePath = this.getNamePath();
        const prevValue = this.getValue(prevStore);
        const curValue = this.getValue(store);
        const namePathMatch = namePathList && (0, $06fb2ac41280cd60$export$646d5504364ae55b)(namePathList, namePath);
        // `setFieldsValue` is a quick access to update related status
        if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prevValue, curValue)) {
            this.touched = true;
            this.dirty = true;
            this.validatePromise = null;
            this.errors = $c47f394f570329ce$var$EMPTY_ERRORS;
            this.warnings = $c47f394f570329ce$var$EMPTY_WARNINGS;
            this.triggerMetaEvent();
        }
        switch(info.type){
            case 'reset':
                if (!namePathList || namePathMatch) {
                    // Clean up state
                    this.touched = false;
                    this.dirty = false;
                    this.validatePromise = undefined;
                    this.errors = $c47f394f570329ce$var$EMPTY_ERRORS;
                    this.warnings = $c47f394f570329ce$var$EMPTY_WARNINGS;
                    this.triggerMetaEvent();
                    onReset?.();
                    this.refresh();
                    return;
                }
                break;
            /**
       * In case field with `preserve = false` nest deps like:
       * - A = 1 => show B
       * - B = 1 => show C
       * - Reset A, need clean B, C
       */ case 'remove':
                if (shouldUpdate && $c47f394f570329ce$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
            case 'setField':
                {
                    const { data: data } = info;
                    if (namePathMatch) {
                        if ('touched' in data) this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) this.errors = data.errors || $c47f394f570329ce$var$EMPTY_ERRORS;
                        if ('warnings' in data) this.warnings = data.warnings || $c47f394f570329ce$var$EMPTY_WARNINGS;
                        this.dirty = true;
                        this.triggerMetaEvent();
                        this.reRender();
                        return;
                    } else if ('value' in data && (0, $06fb2ac41280cd60$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $c47f394f570329ce$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            case 'dependenciesUpdate':
                {
                    /**
           * Trigger when marked `dependencies` updated. Related fields will all update
           */ const dependencyList = dependencies.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some((dependency)=>(0, $06fb2ac41280cd60$export$646d5504364ae55b)(info.relatedFields, dependency))) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            default:
                // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                //      For example <List name="list"><Field name={['list', 0]}></List>
                //      If `namePathList` is [['list']] (List value update), Field should be updated
                //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                // 2.
                //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                //       is not provided
                //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                //       else to check if value changed
                if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $c47f394f570329ce$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
        }
        if (shouldUpdate === true) this.reRender();
    };
    validateRules = (options)=>{
        // We should fixed namePath & value to avoid developer change then by form function
        const namePath = this.getNamePath();
        const currentValue = this.getValue();
        const { triggerName: triggerName, validateOnly: validateOnly = false, delayFrame: showDelayFrame } = options || {};
        // Force change to async to avoid rule OOD under renderProps field
        const rootPromise = Promise.resolve().then(async ()=>{
            if (!this.mounted) return [];
            const { validateFirst: validateFirst = false, messageVariables: messageVariables, validateDebounce: validateDebounce } = this.props;
            // Should wait for the frame render,
            // since developer may `useWatch` value in the rules.
            if (showDelayFrame) await (0, $aee064bf4769c950$export$2e2bcd8739ae039)();
            // Start validate
            let filteredRules = this.getRules();
            if (triggerName) filteredRules = filteredRules.filter((rule)=>rule).filter((rule)=>{
                const { validateTrigger: validateTrigger } = rule;
                if (!validateTrigger) return true;
                const triggerList = (0, $818c2eda4ba0a65a$export$45b10814cc054894)(validateTrigger);
                return triggerList.includes(triggerName);
            });
            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
            if (validateDebounce && triggerName) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, validateDebounce);
                });
                // Skip since out of date
                if (this.validatePromise !== rootPromise) return [];
            }
            const promise = (0, $c6886a71ba909f1e$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
            promise.catch((e)=>e).then((ruleErrors = $c47f394f570329ce$var$EMPTY_ERRORS)=>{
                if (this.validatePromise === rootPromise) {
                    this.validatePromise = null;
                    // Get errors & warnings
                    const nextErrors = [];
                    const nextWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors = $c47f394f570329ce$var$EMPTY_ERRORS })=>{
                        if (warningOnly) nextWarnings.push(...errors);
                        else nextErrors.push(...errors);
                    });
                    this.errors = nextErrors;
                    this.warnings = nextWarnings;
                    this.triggerMetaEvent();
                    this.reRender();
                }
            });
            return promise;
        });
        if (validateOnly) return rootPromise;
        this.validatePromise = rootPromise;
        this.dirty = true;
        this.errors = $c47f394f570329ce$var$EMPTY_ERRORS;
        this.warnings = $c47f394f570329ce$var$EMPTY_WARNINGS;
        this.triggerMetaEvent();
        // Force trigger re-render since we need sync renderProps with new meta
        this.reRender();
        return rootPromise;
    };
    isFieldValidating = ()=>!!this.validatePromise;
    isFieldTouched = ()=>this.touched;
    isFieldDirty = ()=>{
        // Touched or validate or has initialValue
        if (this.dirty || this.props.initialValue !== undefined) return true;
        // Form set initialValue
        const { fieldContext: fieldContext } = this.props;
        const { getInitialValue: getInitialValue } = fieldContext.getInternalHooks((0, $1af3680bf0b051ba$export$24829b7c0e49e9f7));
        if (getInitialValue(this.getNamePath()) !== undefined) return true;
        return false;
    };
    getErrors = ()=>this.errors;
    getWarnings = ()=>this.warnings;
    isListField = ()=>this.props.isListField;
    isList = ()=>this.props.isList;
    isPreserve = ()=>this.props.preserve;
    // ============================= Child Component =============================
    getMeta = ()=>{
        // Make error & validating in cache to save perf
        this.prevValidating = this.isFieldValidating();
        const meta = {
            touched: this.isFieldTouched(),
            validating: this.prevValidating,
            errors: this.errors,
            warnings: this.warnings,
            name: this.getNamePath(),
            validated: this.validatePromise === null
        };
        return meta;
    };
    // Only return validate child node. If invalidate, will do nothing about field.
    getOnlyChild = (children)=>{
        // Support render props
        if (typeof children === 'function') {
            const meta = this.getMeta();
            return {
                ...this.getOnlyChild(children(this.getControlled(), meta, this.props.fieldContext)),
                isFunction: true
            };
        }
        // Filed element only
        const childList = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children);
        if (childList.length !== 1 || !/*#__PURE__*/ $acw62.isValidElement(childList[0])) return {
            child: childList,
            isFunction: false
        };
        return {
            child: childList[0],
            isFunction: false
        };
    };
    // ============================== Field Control ==============================
    getValue = (store)=>{
        const { getFieldsValue: getFieldsValue } = this.props.fieldContext;
        const namePath = this.getNamePath();
        return (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
    };
    getControlled = (childProps = {})=>{
        const { name: name, trigger: trigger = 'onChange', validateTrigger: validateTrigger, getValueFromEvent: getValueFromEvent, normalize: normalize, valuePropName: valuePropName = 'value', getValueProps: getValueProps, fieldContext: fieldContext } = this.props;
        const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
        const namePath = this.getNamePath();
        const { getInternalHooks: getInternalHooks, getFieldsValue: getFieldsValue } = fieldContext;
        const { dispatch: dispatch } = getInternalHooks((0, $1af3680bf0b051ba$export$24829b7c0e49e9f7));
        const value = this.getValue();
        const mergedGetValueProps = getValueProps || ((val)=>({
                [valuePropName]: val
            }));
        const originTriggerFunc = childProps[trigger];
        const valueProps = name !== undefined ? mergedGetValueProps(value) : {};
        var key;
        const control = {
            ...childProps,
            ...valueProps
        };
        // Add trigger
        control[trigger] = (...args)=>{
            // Mark as touched
            this.touched = true;
            this.dirty = true;
            this.triggerMetaEvent();
            let newValue;
            if (getValueFromEvent) newValue = getValueFromEvent(...args);
            else newValue = (0, $06fb2ac41280cd60$export$6eeac3c5b406fb30)(valuePropName, ...args);
            if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
            if (newValue !== value) dispatch({
                type: 'updateValue',
                namePath: namePath,
                value: newValue
            });
            if (originTriggerFunc) originTriggerFunc(...args);
        };
        // Add validateTrigger
        const validateTriggerList = (0, $818c2eda4ba0a65a$export$45b10814cc054894)(mergedValidateTrigger || []);
        validateTriggerList.forEach((triggerName)=>{
            // Wrap additional function of component, so that we can get latest value from store
            const originTrigger = control[triggerName];
            control[triggerName] = (...args)=>{
                if (originTrigger) originTrigger(...args);
                // Always use latest rules
                const { rules: rules } = this.props;
                if (rules && rules.length) // We dispatch validate to root,
                // since it will update related data with other field with same name
                dispatch({
                    type: 'validateField',
                    namePath: namePath,
                    triggerName: triggerName
                });
            };
        });
        return control;
    };
    render() {
        const { resetCount: resetCount } = this.state;
        const { children: children } = this.props;
        const { child: child, isFunction: isFunction } = this.getOnlyChild(children);
        // Not need to `cloneElement` since user can handle this in render function self
        let returnChildNode;
        if (isFunction) returnChildNode = child;
        else if (/*#__PURE__*/ $acw62.isValidElement(child)) returnChildNode = /*#__PURE__*/ $acw62.cloneElement(child, this.getControlled(child.props));
        else {
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!child, '`children` of Field is not validate ReactElement.');
            returnChildNode = child;
        }
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: resetCount
        }, returnChildNode);
    }
}
function $c47f394f570329ce$var$WrapperField({ name: name, ...restProps }) {
    const fieldContext = $acw62.useContext((0, $1af3680bf0b051ba$export$2e2bcd8739ae039));
    const listContext = $acw62.useContext((0, $417fab7cc2fd8514$export$2e2bcd8739ae039));
    const namePath = name !== undefined ? (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name) : undefined;
    const isMergedListField = restProps.isListField ?? !!listContext;
    let key = 'keep';
    if (!isMergedListField) key = `_${(namePath || []).join('_')}`;
    return /*#__PURE__*/ $acw62.createElement($c47f394f570329ce$var$Field, $c47f394f570329ce$var$_extends({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $c47f394f570329ce$export$2e2bcd8739ae039 = $c47f394f570329ce$var$WrapperField;



var $acw62 = parcelRequire("acw62");





function $0ce22dbb12321eeb$var$List({ name: name, initialValue: initialValue, children: children, rules: rules, validateTrigger: validateTrigger, isListField: isListField }) {
    const context = $acw62.useContext((0, $1af3680bf0b051ba$export$2e2bcd8739ae039));
    const wrapperListContext = $acw62.useContext((0, $417fab7cc2fd8514$export$2e2bcd8739ae039));
    const keyRef = $acw62.useRef({
        keys: [],
        id: 0
    });
    const keyManager = keyRef.current;
    const prefixName = $acw62.useMemo(()=>{
        const parentPrefixName = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [
            ...parentPrefixName,
            ...(0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name)
        ];
    }, [
        context.prefixName,
        name
    ]);
    const fieldContext = $acw62.useMemo(()=>({
            ...context,
            prefixName: prefixName
        }), [
        context,
        prefixName
    ]);
    // List context
    const listContext = $acw62.useMemo(()=>({
            getKey: (namePath)=>{
                const len = prefixName.length;
                const pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        }), [
        keyManager,
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, 'Form.List only accepts function as children.');
        return null;
    }
    const shouldUpdate = (prevValue, nextValue, { source: source })=>{
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $417fab7cc2fd8514$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $acw62.createElement((0, $1af3680bf0b051ba$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $acw62.createElement((0, $c47f394f570329ce$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField ?? !!wrapperListContext
    }, ({ value: value = [], onChange: onChange }, meta)=>{
        const { getFieldValue: getFieldValue } = context;
        const getNewValue = ()=>{
            const values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ const operations = {
            add: (defaultValue, index)=>{
                // Mapping keys
                const newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [
                        ...keyManager.keys.slice(0, index),
                        keyManager.id,
                        ...keyManager.keys.slice(index)
                    ];
                    onChange([
                        ...newValue.slice(0, index),
                        defaultValue,
                        ...newValue.slice(index)
                    ]);
                } else {
                    keyManager.keys = [
                        ...keyManager.keys,
                        keyManager.id
                    ];
                    onChange([
                        ...newValue,
                        defaultValue
                    ]);
                }
                keyManager.id += 1;
            },
            remove: (index)=>{
                const newValue = getNewValue();
                const indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter((_, keysIndex)=>!indexSet.has(keysIndex));
                // Trigger store change
                onChange(newValue.filter((_, valueIndex)=>!indexSet.has(valueIndex)));
            },
            move (from, to) {
                if (from === to) return;
                const newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $06fb2ac41280cd60$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $06fb2ac41280cd60$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        let listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map((__, index)=>{
            let key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $0ce22dbb12321eeb$export$2e2bcd8739ae039 = $0ce22dbb12321eeb$var$List;





var $acw62 = parcelRequire("acw62");

function $04ec273222a5c3bd$export$6152adfdcc6be2b5(promiseList) {
    let hasError = false;
    let count = promiseList.length;
    const results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise((resolve, reject)=>{
        promiseList.forEach((promise, index)=>{
            promise.catch((e)=>{
                hasError = true;
                return e;
            }).then((result)=>{
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}



const $7a05f203afb68537$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $7a05f203afb68537$var$normalize(namePath) {
    return namePath.map((cell)=>`${typeof cell}:${cell}`)// Magic split
    .join($7a05f203afb68537$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ class $7a05f203afb68537$var$NameMap {
    kvs = new Map();
    set(key, value) {
        this.kvs.set($7a05f203afb68537$var$normalize(key), value);
    }
    get(key) {
        return this.kvs.get($7a05f203afb68537$var$normalize(key));
    }
    getAsPrefix(key) {
        const normalizedKey = $7a05f203afb68537$var$normalize(key);
        const normalizedPrefix = normalizedKey + $7a05f203afb68537$var$SPLIT;
        const results = [];
        const current = this.kvs.get(normalizedKey);
        if (current !== undefined) results.push(current);
        this.kvs.forEach((value, itemNormalizedKey)=>{
            if (itemNormalizedKey.startsWith(normalizedPrefix)) results.push(value);
        });
        return results;
    }
    update(key, updater) {
        const origin = this.get(key);
        const next = updater(origin);
        if (!next) this.delete(key);
        else this.set(key, next);
    }
    delete(key) {
        this.kvs.delete($7a05f203afb68537$var$normalize(key));
    }
    // Since we only use this in test, let simply realize this
    map(callback) {
        return [
            ...this.kvs.entries()
        ].map(([key, value])=>{
            const cells = key.split($7a05f203afb68537$var$SPLIT);
            return callback({
                key: cells.map((cell)=>{
                    const [, type, unit] = cell.match(/^([^:]*):(.*)$/);
                    return type === 'number' ? Number(unit) : unit;
                }),
                value: value
            });
        });
    }
    toJSON() {
        const json = {};
        this.map(({ key: key, value: value })=>{
            json[key.join('.')] = value;
            return null;
        });
        return json;
    }
}
var $7a05f203afb68537$export$2e2bcd8739ae039 = $7a05f203afb68537$var$NameMap;




class $f7890240d56e6600$export$75ff1ab1187e691 {
    formHooked = false;
    forceRootUpdate;
    subscribable = true;
    store = {};
    fieldEntities = [];
    initialValues = {};
    callbacks = {};
    validateMessages = null;
    preserve = null;
    lastValidatePromise = null;
    watcherCenter = new (0, $33e8a00a9e924f2f$export$2e2bcd8739ae039)(this);
    constructor(forceRootUpdate){
        this.forceRootUpdate = forceRootUpdate;
    }
    getForm = ()=>({
            getFieldValue: this.getFieldValue,
            getFieldsValue: this.getFieldsValue,
            getFieldError: this.getFieldError,
            getFieldWarning: this.getFieldWarning,
            getFieldsError: this.getFieldsError,
            isFieldsTouched: this.isFieldsTouched,
            isFieldTouched: this.isFieldTouched,
            isFieldValidating: this.isFieldValidating,
            isFieldsValidating: this.isFieldsValidating,
            resetFields: this.resetFields,
            setFields: this.setFields,
            setFieldValue: this.setFieldValue,
            setFieldsValue: this.setFieldsValue,
            validateFields: this.validateFields,
            submit: this.submit,
            _init: true,
            getInternalHooks: this.getInternalHooks
        });
    // ======================== Internal Hooks ========================
    getInternalHooks = (key)=>{
        if (key === (0, $1af3680bf0b051ba$export$24829b7c0e49e9f7)) {
            this.formHooked = true;
            return {
                dispatch: this.dispatch,
                initEntityValue: this.initEntityValue,
                registerField: this.registerField,
                useSubscribe: this.useSubscribe,
                setInitialValues: this.setInitialValues,
                destroyForm: this.destroyForm,
                setCallbacks: this.setCallbacks,
                setValidateMessages: this.setValidateMessages,
                getFields: this.getFields,
                setPreserve: this.setPreserve,
                getInitialValue: this.getInitialValue,
                registerWatch: this.registerWatch
            };
        }
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    };
    useSubscribe = (subscribable)=>{
        this.subscribable = subscribable;
    };
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ prevWithoutPreserves = null;
    /**
   * First time `setInitialValues` should update store with initial value
   */ setInitialValues = (initialValues, init)=>{
        this.initialValues = initialValues || {};
        if (init) {
            let nextStore = (0, $4ee33241e7a6f41e$export$4950aa0f605343fb)(initialValues, this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            this.prevWithoutPreserves?.map(({ key: namePath })=>{
                nextStore = (0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(nextStore, namePath, (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            this.prevWithoutPreserves = null;
            this.updateStore(nextStore);
        }
    };
    destroyForm = (clearOnDestroy)=>{
        if (clearOnDestroy) // destroy form reset store
        this.updateStore({});
        else {
            // Fill preserve fields
            const prevWithoutPreserves = new (0, $7a05f203afb68537$export$2e2bcd8739ae039)();
            this.getFieldEntities(true).forEach((entity)=>{
                if (!this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            this.prevWithoutPreserves = prevWithoutPreserves;
        }
    };
    getInitialValue = (namePath)=>{
        const initValue = (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $4ee33241e7a6f41e$export$4950aa0f605343fb)(initValue) : initValue;
    };
    setCallbacks = (callbacks)=>{
        this.callbacks = callbacks;
    };
    setValidateMessages = (validateMessages)=>{
        this.validateMessages = validateMessages;
    };
    setPreserve = (preserve)=>{
        this.preserve = preserve;
    };
    // ============================= Watch ============================
    registerWatch = (callback)=>{
        return this.watcherCenter.register(callback);
    };
    notifyWatch = (namePath = [])=>{
        this.watcherCenter.notify(namePath);
    };
    // ========================== Dev Warning =========================
    timeoutId = null;
    warningUnhooked = ()=>{};
    // ============================ Store =============================
    updateStore = (nextStore)=>{
        this.store = nextStore;
    };
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ getFieldEntities = (pure = false)=>{
        if (!pure) return this.fieldEntities;
        return this.fieldEntities.filter((field)=>field.getNamePath().length);
    };
    /**
   * Get a map of registered field entities with their name path as the key.
   * @param pure Only include fields which have a `name`. Default: false
   * @returns A NameMap containing field entities indexed by their name paths
   */ getFieldsMap = (pure = false)=>{
        const cache = new (0, $7a05f203afb68537$export$2e2bcd8739ae039)();
        this.getFieldEntities(pure).forEach((field)=>{
            const namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    };
    /**
   * Get field entities based on a list of name paths.
   * @param nameList - Array of name paths to search for. If not provided, returns all field entities with names.
   * @param includesSubNamePath - Whether to include fields that have the given name path as a prefix.
   */ getFieldEntitiesForNamePathList = (nameList, includesSubNamePath = false)=>{
        if (!nameList) return this.getFieldEntities(true);
        const cache = this.getFieldsMap(true);
        if (!includesSubNamePath) return nameList.map((name)=>{
            const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name)
            };
        });
        return nameList.flatMap((name)=>{
            const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
            const fields = cache.getAsPrefix(namePath);
            if (fields.length) return fields;
            return [
                {
                    INVALIDATE_NAME_PATH: namePath
                }
            ];
        });
    };
    getFieldsValue = (nameList, filterFunc)=>{
        this.warningUnhooked();
        // Fill args
        let mergedNameList;
        let mergedFilterFunc;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && typeof nameList === 'object') mergedFilterFunc = nameList.filter;
        if (mergedNameList === true && !mergedFilterFunc) return this.store;
        const fieldEntities = this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null, true);
        const filteredNameList = [];
        const listNamePaths = [];
        fieldEntities.forEach((entity)=>{
            const namePath = entity.INVALIDATE_NAME_PATH || entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (entity.isList?.()) {
                listNamePaths.push(namePath);
                return;
            }
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                const meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        let mergedValues = (0, $06fb2ac41280cd60$export$f5be6dfb30403c59)(this.store, filteredNameList.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)));
        // We need fill the list as [] if Form.List is empty
        listNamePaths.forEach((namePath)=>{
            if (!(0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(mergedValues, namePath)) mergedValues = (0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(mergedValues, namePath, []);
        });
        return mergedValues;
    };
    getFieldValue = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
        return (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(this.store, namePath);
    };
    getFieldsError = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map((entity, index)=>{
            if (entity && !entity.INVALIDATE_NAME_PATH) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    };
    getFieldError = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    };
    getFieldWarning = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    };
    isFieldsTouched = (...args)=>{
        this.warningUnhooked();
        const [arg0, arg1] = args;
        let namePathList;
        let isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        const fieldEntities = this.getFieldEntities(true);
        const isFieldTouched = (field)=>field.isFieldTouched();
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every((entity)=>isFieldTouched(entity) || entity.isList()) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        const map = new (0, $7a05f203afb68537$export$2e2bcd8739ae039)();
        namePathList.forEach((shortNamePath)=>{
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach((shortNamePath)=>{
                if (shortNamePath.every((nameUnit, i)=>fieldNamePath[i] === nameUnit)) map.update(shortNamePath, (list)=>[
                        ...list,
                        field
                    ]);
            });
        });
        // Check if NameMap value is touched
        const isNamePathListTouched = (entities)=>entities.some(isFieldTouched);
        const namePathListEntities = map.map(({ value: value })=>value);
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    };
    isFieldTouched = (name)=>{
        this.warningUnhooked();
        return this.isFieldsTouched([
            name
        ]);
    };
    isFieldsValidating = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntities();
        if (!nameList) return fieldEntities.some((testField)=>testField.isFieldValidating());
        const namePathList = nameList.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9));
        return fieldEntities.some((testField)=>{
            const fieldNamePath = testField.getNamePath();
            return (0, $06fb2ac41280cd60$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    };
    isFieldValidating = (name)=>{
        this.warningUnhooked();
        return this.isFieldsValidating([
            name
        ]);
    };
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ resetWithFieldInitialValue = (info = {})=>{
        // Create cache
        const cache = new (0, $7a05f203afb68537$export$2e2bcd8739ae039)();
        const fieldEntities = this.getFieldEntities(true);
        fieldEntities.forEach((field)=>{
            const { initialValue: initialValue } = field.props;
            const namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                const records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        const resetWithFields = (entities)=>{
            entities.forEach((field)=>{
                const { initialValue: initialValue } = field.props;
                if (initialValue !== undefined) {
                    const namePath = field.getNamePath();
                    const formInitialValue = this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, `Form already set 'initialValues' with path '${namePath.join('.')}'. Field can not overwrite it.`);
                    else {
                        const records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, `Multiple Field with path '${namePath.join('.')}' set 'initialValue'. Can not decide which one to pick.`);
                        else if (records) {
                            const originValue = this.getFieldValue(namePath);
                            const isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) this.updateStore((0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(this.store, namePath, [
                                ...records
                            ][0].value));
                        }
                    }
                }
            });
        };
        let requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach((namePath)=>{
                const records = cache.get(namePath);
                if (records) requiredFieldEntities.push(...[
                    ...records
                ].map((r)=>r.entity));
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    };
    resetFields = (nameList)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (!nameList) {
            this.updateStore((0, $4ee33241e7a6f41e$export$4950aa0f605343fb)(this.initialValues));
            this.resetWithFieldInitialValue();
            this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        const namePathList = nameList.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9));
        namePathList.forEach((namePath)=>{
            const initialValue = this.getInitialValue(namePath);
            this.updateStore((0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        });
        this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        this.notifyWatch(namePathList);
    };
    setFields = (fields)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        const namePathList = [];
        fields.forEach((fieldData)=>{
            const { name: name, ...data } = fieldData;
            const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) this.updateStore((0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(this.store, namePath, data.value));
            this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        this.notifyWatch(namePathList);
    };
    getFields = ()=>{
        const entities = this.getFieldEntities(true);
        const fields = entities.map((field)=>{
            const namePath = field.getNamePath();
            const meta = field.getMeta();
            const fieldData = {
                ...meta,
                name: namePath,
                value: this.getFieldValue(namePath)
            };
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    };
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ initEntityValue = (entity)=>{
        const { initialValue: initialValue } = entity.props;
        if (initialValue !== undefined) {
            const namePath = entity.getNamePath();
            const prevValue = (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(this.store, namePath);
            if (prevValue === undefined) this.updateStore((0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        }
    };
    isMergedPreserve = (fieldPreserve)=>{
        const mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : this.preserve;
        return mergedPreserve ?? true;
    };
    registerField = (entity)=>{
        this.fieldEntities.push(entity);
        const namePath = entity.getNamePath();
        this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            const prevStore = this.store;
            this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return (isListField, preserve, subNamePath = [])=>{
            this.fieldEntities = this.fieldEntities.filter((item)=>item !== entity);
            // Clean up store value if not preserve
            if (!this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                const defaultValue = isListField ? undefined : this.getInitialValue(namePath);
                if (namePath.length && this.getFieldValue(namePath) !== defaultValue && this.fieldEntities.every((field)=>// Only reset when no namePath exist
                    !(0, $06fb2ac41280cd60$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath))) {
                    const prevStore = this.store;
                    this.updateStore((0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    this.notifyObservers(prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    this.triggerDependenciesUpdate(prevStore, namePath);
                }
            }
            this.notifyWatch([
                namePath
            ]);
        };
    };
    dispatch = (action)=>{
        switch(action.type){
            case 'updateValue':
                {
                    const { namePath: namePath, value: value } = action;
                    this.updateValue(namePath, value);
                    break;
                }
            case 'validateField':
                {
                    const { namePath: namePath, triggerName: triggerName } = action;
                    this.validateFields([
                        namePath
                    ], {
                        triggerName: triggerName
                    });
                    break;
                }
            default:
        }
    };
    notifyObservers = (prevStore, namePathList, info)=>{
        if (this.subscribable) {
            const mergedInfo = {
                ...info,
                store: this.getFieldsValue(true)
            };
            this.getFieldEntities().forEach(({ onStoreChange: onStoreChange })=>{
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else this.forceRootUpdate();
    };
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ triggerDependenciesUpdate = (prevStore, namePath)=>{
        const childrenFields = this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) this.validateFields(childrenFields, {
            // Delay to avoid `useWatch` dynamic adjust rules that deps not get latest one
            delayFrame: true
        });
        this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath,
                ...childrenFields
            ]
        });
        return childrenFields;
    };
    updateValue = (name, value)=>{
        const namePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(name);
        const prevStore = this.store;
        this.updateStore((0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(this.store, namePath, value));
        this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        const childrenFields = this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        const { onValuesChange: onValuesChange } = this.callbacks;
        if (onValuesChange) {
            const changedValues = (0, $06fb2ac41280cd60$export$f5be6dfb30403c59)(this.store, [
                namePath
            ]);
            const allValues = this.getFieldsValue();
            const mergedAllValues = (0, $4ee33241e7a6f41e$export$2e2bcd8739ae039)(allValues, namePath, (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(changedValues, namePath));
            onValuesChange(changedValues, mergedAllValues);
        }
        this.triggerOnFieldsChange([
            namePath,
            ...childrenFields
        ]);
    };
    // Let all child Field get update.
    setFieldsValue = (store)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (store) {
            const nextStore = (0, $4ee33241e7a6f41e$export$4950aa0f605343fb)(this.store, store);
            this.updateStore(nextStore);
        }
        this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        this.notifyWatch();
    };
    setFieldValue = (name, value)=>{
        this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: [],
                touched: true
            }
        ]);
    };
    getDependencyChildrenFields = (rootNamePath)=>{
        const children = new Set();
        const childrenFields = [];
        const dependencies2fields = new (0, $7a05f203afb68537$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ this.getFieldEntities().forEach((field)=>{
            const { dependencies: dependencies } = field.props;
            (dependencies || []).forEach((dependency)=>{
                const dependencyNamePath = (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, (fields = new Set())=>{
                    fields.add(field);
                    return fields;
                });
            });
        });
        const fillChildren = (namePath)=>{
            const fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach((field)=>{
                if (!children.has(field)) {
                    children.add(field);
                    const fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    };
    triggerOnFieldsChange = (namePathList, filedErrors)=>{
        const { onFieldsChange: onFieldsChange } = this.callbacks;
        if (onFieldsChange) {
            const fields = this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                const cache = new (0, $7a05f203afb68537$export$2e2bcd8739ae039)();
                filedErrors.forEach(({ name: name, errors: errors })=>{
                    cache.set(name, errors);
                });
                fields.forEach((field)=>{
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            const changedFields = fields.filter(({ name: fieldName })=>(0, $06fb2ac41280cd60$export$646d5504364ae55b)(namePathList, fieldName));
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    };
    // =========================== Validate ===========================
    validateFields = (arg1, arg2)=>{
        this.warningUnhooked();
        let nameList;
        let options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        const provideNameList = !!nameList;
        const namePathList = provideNameList ? nameList.map((0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)) : [];
        // Same namePathList, but does not include Form.List name
        const finalValueNamePathList = [
            ...namePathList
        ];
        // Collect result in promise list
        const promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        const TMP_SPLIT = String(Date.now());
        const validateNamePathList = new Set();
        const { recursive: recursive, dirty: dirty } = options || {};
        this.getFieldEntities(true).forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Add field if not provide `nameList`
            if (!provideNameList) {
                if (// If is field, pass directly
                !field.isList() || // If is list, do not add if already exist sub field in the namePathList
                !namePathList.some((name)=>(0, $06fb2ac41280cd60$export$325a4bd0e71bdc3a)(name, fieldNamePath, true))) finalValueNamePathList.push(fieldNamePath);
                namePathList.push(fieldNamePath);
            }
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $06fb2ac41280cd60$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                const promise = field.validateRules({
                    validateMessages: {
                        ...(0, $6e820d951131e2e2$export$c86b939816b8fbf8),
                        ...this.validateMessages
                    },
                    ...options
                });
                // Wrap promise with field
                promiseList.push(promise.then(()=>({
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    })).catch((ruleErrors)=>{
                    const mergedErrors = [];
                    const mergedWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors })=>{
                        if (warningOnly) mergedWarnings.push(...errors);
                        else mergedErrors.push(...errors);
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        const summaryPromise = (0, $04ec273222a5c3bd$export$6152adfdcc6be2b5)(promiseList);
        this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch((results)=>results).then((results)=>{
            const resultNamePathList = results.map(({ name: name })=>name);
            this.notifyObservers(this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            this.triggerOnFieldsChange(resultNamePathList, results);
        });
        const returnPromise = summaryPromise.then(()=>{
            if (this.lastValidatePromise === summaryPromise) return Promise.resolve(this.getFieldsValue(finalValueNamePathList));
            return Promise.reject([]);
        }).catch((results)=>{
            const errorList = results.filter((result)=>result && result.errors.length);
            const errorMessage = errorList[0]?.errors?.[0];
            return Promise.reject({
                message: errorMessage,
                values: this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch((e)=>e);
        // `validating` changed. Trigger `onFieldsChange`
        const triggerNamePathList = namePathList.filter((namePath)=>validateNamePathList.has(namePath.join(TMP_SPLIT)));
        this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    };
    // ============================ Submit ============================
    submit = ()=>{
        this.warningUnhooked();
        this.validateFields().then((values)=>{
            const { onFinish: onFinish } = this.callbacks;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch((e)=>{
            const { onFinishFailed: onFinishFailed } = this.callbacks;
            if (onFinishFailed) onFinishFailed(e);
        });
    };
}
function $f7890240d56e6600$var$useForm(form) {
    const formRef = $acw62.useRef(null);
    const [, forceUpdate] = $acw62.useState({});
    // Create singleton FormStore
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            const forceReRender = ()=>{
                forceUpdate({});
            };
            const formStore = new $f7890240d56e6600$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $f7890240d56e6600$export$2e2bcd8739ae039 = $f7890240d56e6600$var$useForm;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $2da3a2c8287a65f4$var$FormContext = /*#__PURE__*/ $acw62.createContext({
    triggerFormChange: ()=>{},
    triggerFormFinish: ()=>{},
    registerForm: ()=>{},
    unregisterForm: ()=>{}
});
const $2da3a2c8287a65f4$export$8ce1ff4f94d08846 = ({ validateMessages: validateMessages, onFormChange: onFormChange, onFormFinish: onFormFinish, children: children })=>{
    const formContext = $acw62.useContext($2da3a2c8287a65f4$var$FormContext);
    const formsRef = $acw62.useRef({});
    return /*#__PURE__*/ $acw62.createElement($2da3a2c8287a65f4$var$FormContext.Provider, {
        value: {
            ...formContext,
            validateMessages: {
                ...formContext.validateMessages,
                ...validateMessages
            },
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: (name, changedFields)=>{
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: (name, values)=>{
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: (name, form)=>{
                if (name) formsRef.current = {
                    ...formsRef.current,
                    [name]: form
                };
                formContext.registerForm(name, form);
            },
            unregisterForm: (name)=>{
                const newForms = {
                    ...formsRef.current
                };
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        }
    }, children);
};
var $2da3a2c8287a65f4$export$2e2bcd8739ae039 = $2da3a2c8287a65f4$var$FormContext;




function $87c1c4a77eec20c7$var$_extends() {
    $87c1c4a77eec20c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87c1c4a77eec20c7$var$_extends.apply(this, arguments);
}
const $87c1c4a77eec20c7$var$Form = ({ name: name, initialValues: initialValues, fields: fields, form: form, preserve: preserve, children: children, component: Component = 'form', validateMessages: validateMessages, validateTrigger: validateTrigger = 'onChange', onValuesChange: onValuesChange, onFieldsChange: onFieldsChange, onFinish: onFinish, onFinishFailed: onFinishFailed, clearOnDestroy: clearOnDestroy, ...restProps }, ref)=>{
    const nativeElementRef = $acw62.useRef(null);
    const formContext = $acw62.useContext((0, $2da3a2c8287a65f4$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    const [formInstance] = (0, $f7890240d56e6600$export$2e2bcd8739ae039)(form);
    const { useSubscribe: useSubscribe, setInitialValues: setInitialValues, setCallbacks: setCallbacks, setValidateMessages: setValidateMessages, setPreserve: setPreserve, destroyForm: destroyForm } = formInstance.getInternalHooks((0, $1af3680bf0b051ba$export$24829b7c0e49e9f7));
    // Pass ref with form instance
    $acw62.useImperativeHandle(ref, ()=>({
            ...formInstance,
            nativeElement: nativeElementRef.current
        }));
    // Register form into Context
    $acw62.useEffect(()=>{
        formContext.registerForm(name, formInstance);
        return ()=>{
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages({
        ...formContext.validateMessages,
        ...validateMessages
    });
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: (changedFields, ...rest)=>{
            formContext.triggerFormChange(name, changedFields);
            if (onFieldsChange) onFieldsChange(changedFields, ...rest);
        },
        onFinish: (values)=>{
            formContext.triggerFormFinish(name, values);
            if (onFinish) onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    const mountRef = $acw62.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    // ========================== Unmount ===========================
    $acw62.useEffect(()=>()=>destroyForm(clearOnDestroy), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    let childrenNode;
    const childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        const values = formInstance.getFieldsValue(true);
        childrenNode = children(values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    const prevFieldsRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!(0, $06fb2ac41280cd60$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    // =========================== Render ===========================
    const formContextValue = $acw62.useMemo(()=>({
            ...formInstance,
            validateTrigger: validateTrigger
        }), [
        formInstance,
        validateTrigger
    ]);
    const wrapperNode = /*#__PURE__*/ $acw62.createElement((0, $417fab7cc2fd8514$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $1af3680bf0b051ba$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $acw62.createElement(Component, $87c1c4a77eec20c7$var$_extends({}, restProps, {
        ref: nativeElementRef,
        onSubmit: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: (event)=>{
            event.preventDefault();
            formInstance.resetFields();
            restProps.onReset?.(event);
        }
    }), wrapperNode);
};
var $87c1c4a77eec20c7$export$2e2bcd8739ae039 = $87c1c4a77eec20c7$var$Form;







var $acw62 = parcelRequire("acw62");




function $16b4835102e9ee60$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch  {
        return Math.random();
    }
}
// ------- selector type -------
// ------- selector type end -------
function $16b4835102e9ee60$var$useWatch(...args) {
    const [dependencies, _form = {}] = args;
    const options = (0, $818c2eda4ba0a65a$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    const form = options.form;
    const [value, setValue] = (0, $acw62.useState)(()=>typeof dependencies === 'function' ? dependencies({}) : undefined);
    const valueStr = (0, $acw62.useMemo)(()=>$16b4835102e9ee60$export$fac44ee5b035f737(value), [
        value
    ]);
    const valueStrRef = (0, $acw62.useRef)(valueStr);
    valueStrRef.current = valueStr;
    const fieldContext = (0, $acw62.useContext)((0, $1af3680bf0b051ba$export$2e2bcd8739ae039));
    const formInstance = form || fieldContext;
    const isValidForm = formInstance && formInstance._init;
    // ============================== Form ==============================
    const { getFieldsValue: getFieldsValue, getInternalHooks: getInternalHooks } = formInstance;
    const { registerWatch: registerWatch } = getInternalHooks((0, $1af3680bf0b051ba$export$24829b7c0e49e9f7));
    // ============================= Update =============================
    const triggerUpdate = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((values, allValues)=>{
        const watchValue = options.preserve ? allValues ?? getFieldsValue(true) : values ?? getFieldsValue();
        const nextValue = typeof dependencies === 'function' ? dependencies(watchValue) : (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(watchValue, (0, $06fb2ac41280cd60$export$f877b3cb4cb4ccf9)(dependencies));
        if ($16b4835102e9ee60$export$fac44ee5b035f737(value) !== $16b4835102e9ee60$export$fac44ee5b035f737(nextValue)) setValue(nextValue);
    });
    // ============================= Effect =============================
    const flattenDeps = typeof dependencies === 'function' ? dependencies : JSON.stringify(dependencies);
    // Deps changed
    (0, $acw62.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm,
        flattenDeps
    ]);
    // Value changed
    (0, $acw62.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        const cancelRegister = registerWatch((values, allValues)=>{
            triggerUpdate(values, allValues);
        });
        return cancelRegister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm
    ]);
    return value;
}
var $16b4835102e9ee60$export$2e2bcd8739ae039 = $16b4835102e9ee60$var$useWatch;


const $7573c7bebabccb33$var$InternalForm = /*#__PURE__*/ $acw62.forwardRef((0, $87c1c4a77eec20c7$export$2e2bcd8739ae039));
const $7573c7bebabccb33$var$RefForm = $7573c7bebabccb33$var$InternalForm;
$7573c7bebabccb33$var$RefForm.FormProvider = (0, $2da3a2c8287a65f4$export$8ce1ff4f94d08846);
$7573c7bebabccb33$var$RefForm.Field = (0, $c47f394f570329ce$export$2e2bcd8739ae039);
$7573c7bebabccb33$var$RefForm.List = (0, $0ce22dbb12321eeb$export$2e2bcd8739ae039);
$7573c7bebabccb33$var$RefForm.useForm = (0, $f7890240d56e6600$export$2e2bcd8739ae039);
$7573c7bebabccb33$var$RefForm.useWatch = (0, $16b4835102e9ee60$export$2e2bcd8739ae039);
var $7573c7bebabccb33$export$2e2bcd8739ae039 = $7573c7bebabccb33$var$RefForm;



"use client";
const $ad5d550b51ac8abd$export$c24727297075ec6a = /*#__PURE__*/ $acw62.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: ()=>{}
});
const $ad5d550b51ac8abd$export$d718247e9f9b0b9e = /*#__PURE__*/ $acw62.createContext(null);
const $ad5d550b51ac8abd$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $2da3a2c8287a65f4$export$8ce1ff4f94d08846), {
        ...providerProps
    });
};
const $ad5d550b51ac8abd$export$fb6582d3042cc879 = /*#__PURE__*/ $acw62.createContext({
    prefixCls: ''
});
const $ad5d550b51ac8abd$export$bbb5553c6c7a14ed = /*#__PURE__*/ $acw62.createContext({});
const $ad5d550b51ac8abd$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $acw62.useContext($ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $acw62.useMemo(()=>{
        const newContext = {
            ...formItemInputContext
        };
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $acw62.createElement($ad5d550b51ac8abd$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $ad5d550b51ac8abd$export$6f0555dad42725fb = /*#__PURE__*/ $acw62.createContext(undefined);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $1507d62a9a84d168$var$isValidOrientation = (orientation)=>{
    return orientation === 'horizontal' || orientation === 'vertical';
};
const $1507d62a9a84d168$export$550084c67147f6c4 = (orientation, vertical, legacyDirection)=>{
    return (0, $acw62.useMemo)(()=>{
        const validOrientation = $1507d62a9a84d168$var$isValidOrientation(orientation);
        let mergedOrientation;
        if (validOrientation) mergedOrientation = orientation;
        else if (typeof vertical === 'boolean') mergedOrientation = vertical ? 'vertical' : 'horizontal';
        else {
            const validLegacyDirection = $1507d62a9a84d168$var$isValidOrientation(legacyDirection);
            mergedOrientation = validLegacyDirection ? legacyDirection : 'horizontal';
        }
        return [
            mergedOrientation,
            mergedOrientation === 'vertical'
        ];
    }, [
        legacyDirection,
        orientation,
        vertical
    ]);
};





var $acw62 = parcelRequire("acw62");

const $086416f743106ac8$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize ?? size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $086416f743106ac8$export$2e2bcd8739ae039 = $086416f743106ac8$var$useSize;



const $987474def15ea51b$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$987474def15ea51b$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Space',
    'Compact'
], $987474def15ea51b$var$genSpaceCompactStyle, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $26050ef76e24a749$export$8d1c486ac0db0a7d = /*#__PURE__*/ $acw62.createContext(null);
const $26050ef76e24a749$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $acw62.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext?.compactSize,
        compactDirection: compactItemContext?.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $26050ef76e24a749$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $26050ef76e24a749$var$CompactItem = (props)=>{
    const { children: children, ...others } = props;
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: $acw62.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $26050ef76e24a749$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, orientation: orientation, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, vertical: vertical, ...restProps } = props;
    const [mergedOrientation, mergedVertical] = (0, $1507d62a9a84d168$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [hashId] = (0, $987474def15ea51b$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: mergedVertical
    }, className, rootClassName);
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const childNodes = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children);
    const nodes = $acw62.useMemo(()=>childNodes.map((child, i)=>{
            const key = child?.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: mergedOrientation,
                isFirstItem: i === 0 && (!compactItemContext || compactItemContext?.isFirstItem),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || compactItemContext?.isLastItem)
            }, child);
        }), [
        childNodes,
        compactItemContext,
        mergedOrientation,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: clx,
        ...restProps
    }, nodes);
};
var $26050ef76e24a749$export$2e2bcd8739ae039 = $26050ef76e24a749$var$Compact;



"use client";
const $894cbe2fb0245b19$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (!(0, $b956dab96d0e505b$export$826fff653a329e83)(children)) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad5d550b51ac8abd$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, result);
    return result;
};
var $894cbe2fb0245b19$export$2e2bcd8739ae039 = $894cbe2fb0245b19$var$ContextIsolator;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $2adf0f811816efa6$var$ZIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $2adf0f811816efa6$export$2e2bcd8739ae039 = $2adf0f811816efa6$var$ZIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET = 100;
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $8552b358f1d5b0a4$export$33ada7d8845f7e5 = $8552b358f1d5b0a4$var$CONTAINER_OFFSET * $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $8552b358f1d5b0a4$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $8552b358f1d5b0a4$export$33ada7d8845f7e5 + $8552b358f1d5b0a4$var$CONTAINER_OFFSET;
const $8552b358f1d5b0a4$export$1658852af8bb2a55 = {
    Modal: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Drawer: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popover: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popconfirm: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tooltip: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tour: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    FloatButton: $8552b358f1d5b0a4$var$CONTAINER_OFFSET
};
const $8552b358f1d5b0a4$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
const $8552b358f1d5b0a4$var$isContainerType = (type)=>{
    return type in $8552b358f1d5b0a4$export$1658852af8bb2a55;
};
const $8552b358f1d5b0a4$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $2adf0f811816efa6$export$2e2bcd8739ae039));
    const isContainer = $8552b358f1d5b0a4$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex ?? 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $8552b358f1d5b0a4$export$1658852af8bb2a55[componentType];
        else zIndex += $8552b358f1d5b0a4$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};






function $0c0596420865f622$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $0c0596420865f622$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow: boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};


const $13cd8c878b3c9176$export$de6e4ffc9ec3c089 = 8;
function $13cd8c878b3c9176$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $13cd8c878b3c9176$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $13cd8c878b3c9176$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
const $13cd8c878b3c9176$var$getArrowStyle = (token, colorBg, options)=>{
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal, antCls: antCls } = token;
    const [varName] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'tooltip');
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: {
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                {
                    position: 'absolute',
                    zIndex: 1,
                    // lift it up so the menu wouldn't cask shadow on it
                    display: 'block',
                    ...(0, $0c0596420865f622$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow),
                    '&:before': {
                        background: colorBg
                    }
                }
            ],
            // ========================== Placement ==========================
            // Here handle the arrow position and rotate stuff
            // >>>>> Top
            ...$13cd8c878b3c9176$var$isInject(!!arrowPlacement.top, {
                [[
                    `&-placement-top > ${componentCls}-arrow`,
                    `&-placement-topLeft > ${componentCls}-arrow`,
                    `&-placement-topRight > ${componentCls}-arrow`
                ].join(',')]: {
                    bottom: arrowDistance,
                    transform: 'translateY(100%) rotate(180deg)'
                },
                [`&-placement-top > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
                },
                '&-placement-topLeft': {
                    [varName('arrow-offset-x')]: arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-topRight': {
                    [varName('arrow-offset-x')]: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Bottom
            ...$13cd8c878b3c9176$var$isInject(!!arrowPlacement.bottom, {
                [[
                    `&-placement-bottom > ${componentCls}-arrow`,
                    `&-placement-bottomLeft > ${componentCls}-arrow`,
                    `&-placement-bottomRight > ${componentCls}-arrow`
                ].join(',')]: {
                    top: arrowDistance,
                    transform: `translateY(-100%)`
                },
                [`&-placement-bottom > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: `translateX(-50%) translateY(-100%)`
                },
                '&-placement-bottomLeft': {
                    [varName('arrow-offset-x')]: arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-bottomRight': {
                    [varName('arrow-offset-x')]: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Left
            ...$13cd8c878b3c9176$var$isInject(!!arrowPlacement.left, {
                [[
                    `&-placement-left > ${componentCls}-arrow`,
                    `&-placement-leftTop > ${componentCls}-arrow`,
                    `&-placement-leftBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    right: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(100%) rotate(90deg)'
                },
                [`&-placement-left > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
                },
                [`&-placement-leftTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            }),
            // >>>>> Right
            ...$13cd8c878b3c9176$var$isInject(!!arrowPlacement.right, {
                [[
                    `&-placement-right > ${componentCls}-arrow`,
                    `&-placement-rightTop > ${componentCls}-arrow`,
                    `&-placement-rightBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    left: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-right > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-rightTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            })
        }
    };
};
var $13cd8c878b3c9176$export$2e2bcd8739ae039 = $13cd8c878b3c9176$var$getArrowStyle;



function $aa2151c32cec40fb$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(autoAdjustOverflow) ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = {
        ...baseOverflow,
        ...overflow
    };
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $aa2151c32cec40fb$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $aa2151c32cec40fb$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $aa2151c32cec40fb$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys($aa2151c32cec40fb$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap[key] || $aa2151c32cec40fb$var$PlacementAlignMap[key];
        const placementInfo = {
            ...template,
            offset: [
                0,
                0
            ],
            dynamicInset: true
        };
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($aa2151c32cec40fb$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $aa2151c32cec40fb$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}








var $acw62 = parcelRequire("acw62");
const $0294edcb7fd2dbc1$var$TableMeasureRowContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
var $0294edcb7fd2dbc1$export$2e2bcd8739ae039 = $0294edcb7fd2dbc1$var$TableMeasureRowContext;




var $acw62 = parcelRequire("acw62");
const $133bb1dfe37f3fc0$var$useMergedArrow = (providedArrow, providedContextArrow)=>{
    const toConfig = (arrow)=>typeof arrow === 'boolean' ? {
            show: arrow
        } : arrow || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const arrowConfig = toConfig(providedArrow);
        const contextArrowConfig = toConfig(providedContextArrow);
        return {
            ...contextArrowConfig,
            ...arrowConfig,
            show: arrowConfig.show ?? contextArrowConfig.show ?? true
        };
    }, [
        providedArrow,
        providedContextArrow
    ]);
};
var $133bb1dfe37f3fc0$export$2e2bcd8739ae039 = $133bb1dfe37f3fc0$var$useMergedArrow;



var $acw62 = parcelRequire("acw62");








const $c05a1428f4a08fb2$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $c05a1428f4a08fb2$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: {
            ...$c05a1428f4a08fb2$var$initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`${sameLevelPrefix}${motionCls}-leave`]: {
            ...$c05a1428f4a08fb2$var$initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $cfaac789ec22cce1$export$82e6205b15e6c637 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $cfaac789ec22cce1$export$c091916f1530334c = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $cfaac789ec22cce1$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, $cfaac789ec22cce1$export$82e6205b15e6c637, $cfaac789ec22cce1$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};



const $d2082114d5952afb$export$3b71758b3ed5255f = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $d2082114d5952afb$export$9fdb0a49c6b4b521 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $d2082114d5952afb$export$be061d573c42e33a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $d2082114d5952afb$export$582d93d613303da3 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $d2082114d5952afb$export$45eddd18c599b827 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $d2082114d5952afb$export$a85c97750adaa37a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $d2082114d5952afb$export$bd2378f7814f5f1a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $d2082114d5952afb$export$e58f88c751c4f04e = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $d2082114d5952afb$export$fee1456954aef331 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $d2082114d5952afb$export$811ba6d3e2adb730 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $d2082114d5952afb$export$633a68aa72dec21c = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $d2082114d5952afb$export$1cf46a906e8dede4 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $d2082114d5952afb$var$zoomMotion = {
    zoom: {
        inKeyframes: $d2082114d5952afb$export$3b71758b3ed5255f,
        outKeyframes: $d2082114d5952afb$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $d2082114d5952afb$export$bd2378f7814f5f1a,
        outKeyframes: $d2082114d5952afb$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $d2082114d5952afb$export$fee1456954aef331,
        outKeyframes: $d2082114d5952afb$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $d2082114d5952afb$export$45eddd18c599b827,
        outKeyframes: $d2082114d5952afb$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $d2082114d5952afb$export$633a68aa72dec21c,
        outKeyframes: $d2082114d5952afb$export$1cf46a906e8dede4
    }
};
const $d2082114d5952afb$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $d2082114d5952afb$var$zoomMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





function $69386722b4e8be32$export$2e2bcd8739ae039(token, genCss) {
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return {
            ...prev,
            ...genCss(colorKey, {
                lightColor: lightColor,
                lightBorderColor: lightBorderColor,
                darkColor: darkColor,
                textColor: textColor
            })
        };
    }, {});
}



const $8bcca9e8f96db88a$var$FALL_BACK_ORIGIN = '50%';
const $8bcca9e8f96db88a$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow, antCls: antCls } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'tooltip');
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    const sharedBodyStyle = {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)}`,
        color: varRef('overlay-color', tooltipColor),
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxShadow: boxShadowSecondary,
        boxSizing: 'border-box'
    };
    const sharedTransformOrigin = {
        // When use `autoArrow`, origin will follow the arrow position
        [varName('valid-offset-x')]: varRef('arrow-offset-x', 'var(--arrow-x)'),
        transformOrigin: [
            varRef('valid-offset-x', $8bcca9e8f96db88a$var$FALL_BACK_ORIGIN),
            `var(--arrow-y, ${$8bcca9e8f96db88a$var$FALL_BACK_ORIGIN})`
        ].join(' ')
    };
    return [
        {
            [componentCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                ...sharedTransformOrigin,
                '&-hidden': {
                    display: 'none'
                },
                [varName('arrow-background-color')]: tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-container`]: [
                    sharedBodyStyle,
                    (0, $cfaac789ec22cce1$export$2909268c8354a12)(token, true)
                ],
                [`&:has(~ ${componentCls}-unique-container)`]: {
                    [`${componentCls}-container`]: {
                        border: 'none',
                        background: 'transparent',
                        boxShadow: 'none'
                    }
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $13cd8c878b3c9176$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                // generator for preset color
                ...(0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
                        [`&${componentCls}-${colorKey}`]: {
                            [`${componentCls}-container`]: {
                                backgroundColor: darkColor
                            },
                            [`${componentCls}-arrow`]: {
                                [varName('arrow-background-color')]: darkColor
                            }
                        }
                    })),
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Arrow Style
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, varRef('arrow-background-color')),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        },
        // Unique Body
        {
            [`${componentCls}-unique-container`]: {
                ...sharedBodyStyle,
                ...sharedTransformOrigin,
                position: 'absolute',
                zIndex: calc(zIndexPopup).sub(1).equal(),
                '&-hidden': {
                    display: 'none'
                },
                '&-visible': {
                    transition: `all ${token.motionDurationSlow}`
                }
            }
        }
    ];
};
const $8bcca9e8f96db88a$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        maxWidth: 250,
        ...(0, $13cd8c878b3c9176$export$bddc192327bb9823)({
            contentRadius: token.borderRadius,
            limitVerticalRadius: true
        }),
        ...(0, $0c0596420865f622$export$87e38ee403661ccc)((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
        }))
    });
var $8bcca9e8f96db88a$export$2e2bcd8739ae039 = (prefixCls, rootCls, injectStyle = true)=>{
    const useStyle = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight, maxWidth: maxWidth } = token;
        const TooltipToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: maxWidth,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $8bcca9e8f96db88a$var$genTooltipStyle(TooltipToken),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(token, 'zoom-big-fast')
        ];
    }, $8bcca9e8f96db88a$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls, rootCls);
};





const $1513ceb924eda9b6$var$inverseColors = (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $1513ceb924eda9b6$export$2c43cb57a48fae33 = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $1513ceb924eda9b6$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($1513ceb924eda9b6$var$inverseColors), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).includes(color);
}
function $1513ceb924eda9b6$export$88a0ba1f7d1ea40e(color) {
    return $1513ceb924eda9b6$export$2c43cb57a48fae33.includes(color);
}




var $acw62 = parcelRequire("acw62");

const $af3cb82f75f48284$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $af3cb82f75f48284$var$convertHsb2Hsv = (color)=>{
    if (color instanceof (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)) return color;
    if (color && typeof color === 'object' && 'h' in color && 'b' in color) {
        const { b: b, ...resets } = color;
        return {
            ...resets,
            v: b
        };
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
class $af3cb82f75f48284$export$892596cec99bc70e extends (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a) {
    constructor(color){
        super($af3cb82f75f48284$var$convertHsb2Hsv(color));
    }
    toHsbString() {
        const hsb = this.toHsb();
        const saturation = $af3cb82f75f48284$export$8d6531175688484b(hsb.s * 100);
        const lightness = $af3cb82f75f48284$export$8d6531175688484b(hsb.b * 100);
        const hue = $af3cb82f75f48284$export$8d6531175688484b(hsb.h);
        const alpha = hsb.a;
        const hsbString = `hsb(${hue}, ${saturation}%, ${lightness}%)`;
        const hsbaString = `hsba(${hue}, ${saturation}%, ${lightness}%, ${alpha.toFixed(alpha === 0 ? 0 : 2)})`;
        return alpha === 1 ? hsbString : hsbaString;
    }
    toHsb() {
        const { v: v, ...resets } = this.toHsv();
        return {
            ...resets,
            b: v,
            a: this.a
        };
    }
}


const $de94e2fd9370c2d3$export$90004e2badfbdf1f = 'rc-color-picker';
const $de94e2fd9370c2d3$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $af3cb82f75f48284$export$892596cec99bc70e)) return color;
    return new (0, $af3cb82f75f48284$export$892596cec99bc70e)(color);
};
const $de94e2fd9370c2d3$export$f705f0fde43a55a = $de94e2fd9370c2d3$export$c844f5d21427d1ab('#1677ff');
const $de94e2fd9370c2d3$export$3a7095e9fd85a71d = (props)=>{
    const { offset: offset, targetRef: targetRef, containerRef: containerRef, color: color, type: type } = props;
    const { width: width, height: height } = containerRef.current.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
    const centerOffsetX = targetWidth / 2;
    const centerOffsetY = targetHeight / 2;
    const saturation = (offset.x + centerOffsetX) / width;
    const bright = 1 - (offset.y + centerOffsetY) / height;
    const hsb = color.toHsb();
    const alphaOffset = saturation;
    const hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $de94e2fd9370c2d3$export$c844f5d21427d1ab({
                ...hsb,
                h: hueOffset <= 0 ? 0 : hueOffset
            });
        case 'alpha':
            return $de94e2fd9370c2d3$export$c844f5d21427d1ab({
                ...hsb,
                a: alphaOffset <= 0 ? 0 : alphaOffset
            });
    }
    return $de94e2fd9370c2d3$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
const $de94e2fd9370c2d3$export$20165527867cbf14 = (color, type)=>{
    const hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $acw62 = parcelRequire("acw62");
const $f5d5fed38984894d$var$ColorBlock = ({ color: color, prefixCls: prefixCls, className: className, style: style, innerClassName: innerClassName, innerStyle: innerStyle, onClick: onClick })=>{
    const colorBlockCls = `${prefixCls}-color-block`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${colorBlockCls}-inner`, innerClassName),
        style: {
            background: color,
            ...innerStyle
        }
    }));
};
var $f5d5fed38984894d$export$2e2bcd8739ae039 = $f5d5fed38984894d$var$ColorBlock;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $c9dd3e79e6416b90$var$getPosition(e) {
    const obj = 'touches' in e ? e.touches[0] : e;
    const scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    const scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $c9dd3e79e6416b90$var$useColorDrag(props) {
    const { targetRef: targetRef, containerRef: containerRef, direction: direction, onDragChange: onDragChange, onDragChangeComplete: onDragChangeComplete, calculate: calculate, color: color, disabledDrag: disabledDrag } = props;
    const [offsetValue, setOffsetValue] = (0, $acw62.useState)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, $acw62.useRef)(null);
    const mouseUpRef = (0, $acw62.useRef)(null);
    // Always get position from `color`
    (0, $acw62.useEffect)(()=>{
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        }, []);
    const updateOffset = (e)=>{
        const { pageX: pageX, pageY: pageY } = $c9dd3e79e6416b90$var$getPosition(e);
        const { x: rectX, y: rectY, width: width, height: height } = containerRef.current.getBoundingClientRect();
        const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
        const centerOffsetX = targetWidth / 2;
        const centerOffsetY = targetHeight / 2;
        const offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        const offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        const calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange?.(calcOffset);
    };
    const onDragMove = (e)=>{
        e.preventDefault();
        updateOffset(e);
    };
    const onDragStop = (e)=>{
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete?.();
    };
    const onDragStart = (e)=>{
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $c9dd3e79e6416b90$export$2e2bcd8739ae039 = $c9dd3e79e6416b90$var$useColorDrag;






var $acw62 = parcelRequire("acw62");
const $059db1141305b3dc$var$Handler = ({ size: size = 'default', color: color, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-handler`, {
            [`${prefixCls}-handler-sm`]: size === 'small'
        }),
        style: {
            backgroundColor: color
        }
    });
};
var $059db1141305b3dc$export$2e2bcd8739ae039 = $059db1141305b3dc$var$Handler;



var $acw62 = parcelRequire("acw62");
const $24032ee754712889$var$Palette = ({ children: children, style: style, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-palette`,
        style: {
            position: 'relative',
            ...style
        }
    }, children);
};
var $24032ee754712889$export$2e2bcd8739ae039 = $24032ee754712889$var$Palette;



var $acw62 = parcelRequire("acw62");
const $d8cc625bd7d7a2b3$var$Transform = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { children: children, x: x, y: y } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: `${x}%`,
            top: `${y}%`,
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $d8cc625bd7d7a2b3$export$2e2bcd8739ae039 = $d8cc625bd7d7a2b3$var$Transform;


const $a9cc94252844d50e$var$Picker = ({ color: color, onChange: onChange, prefixCls: prefixCls, onChangeComplete: onChangeComplete, disabled: disabled })=>{
    const pickerRef = (0, $acw62.useRef)();
    const transformRef = (0, $acw62.useRef)();
    const colorRef = (0, $acw62.useRef)(color);
    const onDragChange = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $de94e2fd9370c2d3$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    const [offset, dragStartHandle] = (0, $c9dd3e79e6416b90$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: ()=>(0, $de94e2fd9370c2d3$export$20165527867cbf14)(color),
        onDragChange: onDragChange,
        onDragChangeComplete: ()=>onChangeComplete?.(colorRef.current),
        disabledDrag: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: pickerRef,
        className: `${prefixCls}-select`,
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24032ee754712889$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8cc625bd7d7a2b3$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $059db1141305b3dc$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-saturation`,
        style: {
            backgroundColor: `hsl(${color.toHsb().h},100%, 50%)`,
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $a9cc94252844d50e$export$2e2bcd8739ae039 = $a9cc94252844d50e$var$Picker;




var $acw62 = parcelRequire("acw62");

const $095453fdc9330f5b$var$useColorState = (defaultValue, value)=>{
    const [mergedValue, setValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultValue, value);
    const color = (0, $acw62.useMemo)(()=>(0, $de94e2fd9370c2d3$export$c844f5d21427d1ab)(mergedValue), [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $095453fdc9330f5b$export$2e2bcd8739ae039 = $095453fdc9330f5b$var$useColorState;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


const $779ea332dfaf89e2$var$Gradient = ({ colors: colors, children: children, direction: direction = 'to right', type: type, prefixCls: prefixCls })=>{
    const gradientColors = (0, $acw62.useMemo)(()=>colors.map((color, idx)=>{
            let result = (0, $de94e2fd9370c2d3$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(','), [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-gradient`,
        style: {
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(${direction}, ${gradientColors})`
        }
    }, children);
};
var $779ea332dfaf89e2$export$2e2bcd8739ae039 = $779ea332dfaf89e2$var$Gradient;




const $9b76597d540edf8a$var$Slider = (props)=>{
    const { prefixCls: prefixCls, colors: colors, disabled: disabled, onChange: onChange, onChangeComplete: onChangeComplete, color: color, type: type } = props;
    const sliderRef = (0, $acw62.useRef)(null);
    const transformRef = (0, $acw62.useRef)(null);
    const colorRef = (0, $acw62.useRef)(color);
    const getValue = (c)=>{
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    const onDragChange = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $de94e2fd9370c2d3$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    const [offset, dragStartHandle] = (0, $c9dd3e79e6416b90$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: ()=>(0, $de94e2fd9370c2d3$export$20165527867cbf14)(color, type),
        onDragChange: onDragChange,
        onDragChangeComplete () {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    });
    const handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (type === 'hue') {
            const hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            const lightColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    const gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>colors.map((info)=>`${info.color} ${info.percent}%`), [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: sliderRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-slider`, `${prefixCls}-slider-${type}`),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24032ee754712889$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8cc625bd7d7a2b3$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $059db1141305b3dc$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $779ea332dfaf89e2$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $9b76597d540edf8a$export$2e2bcd8739ae039 = $9b76597d540edf8a$var$Slider;


function $730e0f8c893accac$export$2e2bcd8739ae039(components) {
    return $acw62.useMemo(()=>{
        const { slider: slider } = components || {};
        return [
            slider || (0, $9b76597d540edf8a$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


function $af5eb4327ab367e9$var$_extends() {
    $af5eb4327ab367e9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af5eb4327ab367e9$var$_extends.apply(this, arguments);
}
const $af5eb4327ab367e9$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
const $af5eb4327ab367e9$var$ColorPicker = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { value: value, defaultValue: defaultValue, prefixCls: prefixCls = (0, $de94e2fd9370c2d3$export$90004e2badfbdf1f), onChange: onChange, onChangeComplete: onChangeComplete, className: className, style: style, panelRender: panelRender, disabledAlpha: disabledAlpha = false, disabled: disabled = false, components: components } = props;
    // ========================== Components ==========================
    const [Slider] = (0, $730e0f8c893accac$export$2e2bcd8739ae039)(components);
    // ============================ Color =============================
    const [colorValue, setColorValue] = (0, $095453fdc9330f5b$export$2e2bcd8739ae039)(defaultValue || (0, $de94e2fd9370c2d3$export$f705f0fde43a55a), value);
    const alphaColor = (0, $acw62.useMemo)(()=>colorValue.setA(1).toRgbString(), [
        colorValue
    ]);
    // ============================ Events ============================
    const handleChange = (data, type)=>{
        if (!value) setColorValue(data);
        onChange?.(data, type);
    };
    // Convert
    const getHueColor = (hue)=>new (0, $af3cb82f75f48284$export$892596cec99bc70e)(colorValue.setHue(hue));
    const getAlphaColor = (alpha)=>new (0, $af3cb82f75f48284$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    // Slider change
    const onHueChange = (hue)=>{
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    const onAlphaChange = (alpha)=>{
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    const onHueChangeComplete = (hue)=>{
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    const onAlphaChangeComplete = (alpha)=>{
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    const mergeCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, className, {
        [`${prefixCls}-panel-disabled`]: disabled
    });
    const sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    const defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a9cc94252844d50e$export$2e2bcd8739ae039), $af5eb4327ab367e9$var$_extends({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-slider-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-slider-group`, {
            [`${prefixCls}-slider-group-disabled-alpha`]: disabledAlpha
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Slider, $af5eb4327ab367e9$var$_extends({}, sharedSliderProps, {
        type: "hue",
        colors: $af5eb4327ab367e9$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Slider, $af5eb4327ab367e9$var$_extends({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5d5fed38984894d$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $af5eb4327ab367e9$export$2e2bcd8739ae039 = $af5eb4327ab367e9$var$ColorPicker;






var $5639bde50d53abf9$export$2e2bcd8739ae039 = (0, $af5eb4327ab367e9$export$2e2bcd8739ae039);





const $078cdd44fbbd27df$export$d0aa8b5e56c9af06 = (value, alpha)=>value?.replace(/[^0-9a-f]/gi, '').slice(0, alpha ? 8 : 6) || '';
const $078cdd44fbbd27df$export$6c90ef703dcfba25 = (value, alpha)=>value ? $078cdd44fbbd27df$export$d0aa8b5e56c9af06(value, alpha) : '';
let $078cdd44fbbd27df$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AggregationColor);
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = color.colors?.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $078cdd44fbbd27df$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();


const $6a06b7fa031c80c1$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)) return color;
    return new (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)(color);
};
const $6a06b7fa031c80c1$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $6a06b7fa031c80c1$export$3c8ae3c73ab0e52a = (color)=>$6a06b7fa031c80c1$export$8d6531175688484b(color.toHsb().a * 100);
const $6a06b7fa031c80c1$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $6a06b7fa031c80c1$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $6a06b7fa031c80c1$export$c844f5d21427d1ab(rgba);
};
const $6a06b7fa031c80c1$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};



const $080c438853985df7$export$6e865ea70d7724f = (rootPrefixCls, prefixCls, color)=>{
    const isInternalColor = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color);
    const [varName] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(rootPrefixCls, 'tooltip');
    const className = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    const rgb = (0, $6a06b7fa031c80c1$export$c844f5d21427d1ab)(color).toRgb();
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    const textColor = luminance < 0.5 ? '#FFF' : '#000';
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        overlayStyle[varName('overlay-color')] = textColor;
        arrowStyle[varName('arrow-background-color')] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
};


"use client";
/** @private Internal Component. Do not use in your production. */ const $e604628db2f2c0d3$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $8bcca9e8f96db88a$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // Color
    const colorInfo = (0, $080c438853985df7$export$6e865ea70d7724f)(rootPrefixCls, prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const innerStyles = $acw62.useMemo(()=>{
        const mergedStyle = {
            ...overlayInnerStyle,
            ...colorInfo.overlayStyle
        };
        return {
            container: mergedStyle
        };
    }, [
        overlayInnerStyle,
        colorInfo.overlayStyle
    ]);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        classNames
    ], [
        innerStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: rootClassName,
        style: arrowContentStyle
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $6caa44062abe67c3$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, title));
};
var $e604628db2f2c0d3$export$2e2bcd8739ae039 = $e604628db2f2c0d3$var$PurePanel;





"use client";
const $0ac88bf86814a6e5$var$InternalTooltip = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, children: children, afterOpenChange: afterOpenChange, arrow: tooltipArrow, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, title: title, overlay: overlay, trigger: trigger, builtinPlacements: builtinPlacements, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, rootClassName: rootClassName, styles: styles, classNames: classNames, onOpenChange: onOpenChange, overlayInnerStyle: // Legacy
    overlayInnerStyle, overlayStyle: overlayStyle, overlayClassName: overlayClassName, ...restProps } = props;
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const injectFromPopover = props['data-popover-inject'];
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, ...semanticConfig } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('tooltip');
    // When injected from Popover/Popconfirm, skip tooltip-specific semantic config
    // to prevent ConfigProvider tooltip config from leaking into those components
    const { className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger } = injectFromPopover ? {} : semanticConfig;
    const mergedArrow = (0, $133bb1dfe37f3fc0$export$2e2bcd8739ae039)(tooltipArrow, contextArrow);
    const mergedShowArrow = mergedArrow.show;
    const mergedTrigger = trigger || contextTrigger || 'hover';
    const mergedGetPopupContainer = getPopupContainer || getContextPopupContainer;
    const mergedDestroyOnHidden = destroyOnHidden ?? !!destroyTooltipOnHide;
    const inTableMeasureRow = $acw62.useContext((0, $0294edcb7fd2dbc1$export$2e2bcd8739ae039));
    // ============================== Ref ===============================
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Tooltip');
    const tooltipRef = $acw62.useRef(null);
    const forceAlign = ()=>{
        tooltipRef.current?.forceAlign();
    };
    $acw62.useImperativeHandle(ref, ()=>({
            forceAlign: forceAlign,
            nativeElement: tooltipRef.current?.nativeElement,
            popupElement: tooltipRef.current?.popupElement
        }));
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onInternalOpenChange = (vis)=>{
        setOpen(noTitle ? false : vis);
        if (!noTitle && onOpenChange) onOpenChange(vis);
    };
    const tooltipPlacements = $acw62.useMemo(()=>{
        return builtinPlacements || (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrow?.pointAtCenter ?? false,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        mergedArrow,
        builtinPlacements,
        token,
        mergedShowArrow,
        autoAdjustOverflow
    ]);
    const memoOverlay = $acw62.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        space: true,
        form: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        trigger: mergedTrigger,
        builtinPlacements: tooltipPlacements,
        getPopupContainer: mergedGetPopupContainer,
        destroyOnHidden: mergedDestroyOnHidden
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    let tempOpen = open;
    // Hide tooltip when there is no title or in table measure row
    if (!('open' in props) && noTitle || inTableMeasureRow) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $acw62.isValidElement(children) && !(0, $30796c32f374b477$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $8bcca9e8f96db88a$export$2e2bcd8739ae039)(prefixCls, rootCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $080c438853985df7$export$6e865ea70d7724f)(rootPrefixCls, prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const themeCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls);
    const rootClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, themeCls, contextClassName, mergedClassNames.root);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('Tooltip', restProps.zIndex);
    const containerStyle = {
        ...mergedStyles.container,
        ...overlayInnerStyle,
        ...colorInfo.overlayStyle
    };
    const content = /*#__PURE__*/ $acw62.createElement((0, $bc39d45433aa644b$export$2e2bcd8739ae039), {
        unique: true,
        ...restProps,
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow,
            uniqueContainer: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(themeCls, mergedClassNames.container)
        },
        styles: {
            root: {
                ...arrowContentStyle,
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: containerStyle,
            uniqueContainer: containerStyle,
            arrow: mergedStyles.arrow
        },
        ref: tooltipRef,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onInternalOpenChange,
        afterVisibleChange: afterOpenChange,
        arrowContent: /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', typeof motion?.motionName === 'string' ? motion?.motionName : undefined),
            motionDeadline: 1000
        },
        trigger: mergedTrigger,
        builtinPlacements: tooltipPlacements,
        getTooltipContainer: mergedGetPopupContainer,
        destroyOnHidden: mergedDestroyOnHidden
    }, tempOpen ? (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return /*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content);
});
const $0ac88bf86814a6e5$var$Tooltip = $0ac88bf86814a6e5$var$InternalTooltip;
$0ac88bf86814a6e5$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $e604628db2f2c0d3$export$2e2bcd8739ae039);
$0ac88bf86814a6e5$var$Tooltip.UniqueProvider = (0, $01bf4fb3f56b5e64$export$2e2bcd8739ae039);
var $0ac88bf86814a6e5$export$2e2bcd8739ae039 = $0ac88bf86814a6e5$var$Tooltip;



"use client";
const $8955a62aec0d8484$var$MenuItem = (props)=>{
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, tooltip: tooltip, inlineCollapsed: isInlineCollapsed, styles: styles, classNames: classNames } = $acw62.useContext((0, $f1be9e89e34926b1$export$2e2bcd8739ae039));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children?.[0];
        const wrapNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-title-content`, firstLevel ? classNames?.itemContent : classNames?.subMenu?.itemContent, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            }),
            style: firstLevel ? styles?.itemContent : styles?.subMenu?.itemContent
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $acw62.useContext((0, $f4e67dbf2453f541$export$63554aebd2a6d54c));
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipConfig = tooltip === false ? undefined : tooltip;
    const mergedTooltipTitle = tooltipConfig && tooltipConfig.title !== undefined ? tooltipConfig.title : tooltipTitle;
    const tooltipProps = {
        ...tooltipConfig ?? null,
        title: mergedTooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children).length;
    let returnNode = /*#__PURE__*/ $acw62.createElement((0, $d72dbaba5a7dd149$export$2e2bcd8739ae039), {
        ...(0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
            'title',
            'icon',
            'danger'
        ]),
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(firstLevel ? classNames?.item : classNames?.subMenu?.item, {
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        style: {
            ...firstLevel ? styles?.item : styles?.subMenu?.item,
            ...props.style
        },
        title: typeof title === 'string' ? title : undefined
    }, (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, (oriProps)=>({
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-item-icon`, firstLevel ? classNames?.itemIcon : classNames?.subMenu?.itemIcon, oriProps.className),
            style: {
                ...firstLevel ? styles?.itemIcon : styles?.subMenu?.itemIcon,
                ...oriProps.style
            }
        })), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip && tooltip !== false) {
        const mergedTooltipPlacement = tooltipConfig && tooltipConfig.placement ? tooltipConfig.placement : direction === 'rtl' ? 'left' : 'right';
        const baseTooltipClassName = `${prefixCls}-inline-collapsed-tooltip`;
        const mergeTooltipRootClassName = (classNames)=>({
                ...classNames,
                root: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(baseTooltipClassName, classNames?.root)
            });
        const mergedTooltipClassNames = tooltipConfig && typeof tooltipConfig.classNames === 'function' ? (info)=>{
            const resolvedClassNames = tooltipConfig.classNames(info);
            return mergeTooltipRootClassName(resolvedClassNames);
        } : mergeTooltipRootClassName(tooltipConfig?.classNames);
        returnNode = /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
            ...tooltipProps,
            placement: mergedTooltipPlacement,
            classNames: mergedTooltipClassNames
        }, returnNode);
    }
    return returnNode;
};
var $8955a62aec0d8484$export$2e2bcd8739ae039 = $8955a62aec0d8484$var$MenuItem;



var $acw62 = parcelRequire("acw62");


"use client";
const $798e9781cc841bf2$var$OverrideContext = /*#__PURE__*/ $acw62.createContext(null);
const $798e9781cc841bf2$export$9bd434816b0530d0 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    const override = $acw62.useContext($798e9781cc841bf2$var$OverrideContext);
    const context = $acw62.useMemo(()=>({
            ...override,
            ...restProps
        }), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $6c628207f5089a39$export$b51ae67c7882a242)(children);
    const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(ref, canRef ? (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(children) : null);
    return /*#__PURE__*/ $acw62.createElement($798e9781cc841bf2$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $798e9781cc841bf2$export$2e2bcd8739ae039 = $798e9781cc841bf2$var$OverrideContext;





const $8eae2cab6b8e600b$var$genCollapseMotion = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    return {
        [componentCls]: {
            // For common/openAnimation
            [`${antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `${[
                        'height',
                        'opacity'
                    ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(', ')} !important`
                }
            },
            [`${antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `${[
                    'height',
                    'opacity'
                ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(', ')} !important`
            }
        }
    };
};
var $8eae2cab6b8e600b$export$2e2bcd8739ae039 = $8eae2cab6b8e600b$var$genCollapseMotion;



const $f8b44896cb986807$export$e801b802b037de6a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$f40f41df328ebc38 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd9f089fa5e819fe = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$f7243fdb9c27c3b7 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $f8b44896cb986807$export$2ad3a07c3513a54 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$486fbda27512d5a9 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd03ad46dbbcd7e0 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$db8e3c9b93664f34 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $f8b44896cb986807$var$slideMotion = {
    'slide-up': {
        inKeyframes: $f8b44896cb986807$export$e801b802b037de6a,
        outKeyframes: $f8b44896cb986807$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $f8b44896cb986807$export$dd9f089fa5e819fe,
        outKeyframes: $f8b44896cb986807$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $f8b44896cb986807$export$2ad3a07c3513a54,
        outKeyframes: $f8b44896cb986807$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $f8b44896cb986807$export$dd03ad46dbbcd7e0,
        outKeyframes: $f8b44896cb986807$export$db8e3c9b93664f34
    }
};
const $f8b44896cb986807$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $f8b44896cb986807$var$slideMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};




const $538c6177909b715a$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color`,
                    `background-color`
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
var $538c6177909b715a$export$2e2bcd8739ae039 = $538c6177909b715a$var$getHorizontalStyle;



const $99ca4130ddbe9d7a$var$getRTLStyle = ({ componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc })=>({
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    });
var $99ca4130ddbe9d7a$export$2e2bcd8739ae039 = $99ca4130ddbe9d7a$var$getRTLStyle;




const $e091dfcd5daa8c55$var$accessibilityFocus = (token)=>(0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token);
const $e091dfcd5daa8c55$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: {
                ...$e091dfcd5daa8c55$var$accessibilityFocus(token)
            },
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: {
                    ...$e091dfcd5daa8c55$var$accessibilityFocus(token)
                }
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            // SubMenu active (when hover on parent menu item)
            [`${componentCls}-submenu:not(${componentCls}-submenu-selected)`]: {
                [`> ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: {
                ...themeSuffix === 'dark' ? {
                    borderBottom: 0
                } : {},
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            },
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform`,
                            `opacity`
                        ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseOut}`).join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform`,
                            `opacity`
                        ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(',')
                    }
                }
            }
        }
    };
};
var $e091dfcd5daa8c55$export$2e2bcd8739ae039 = $e091dfcd5daa8c55$var$getThemeStyle;




const $d9c44872a0498ed5$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $d9c44872a0498ed5$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionEaseOut: motionEaseOut, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationFast: motionDurationFast, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': {
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    },
                    ...$d9c44872a0498ed5$var$getVerticalInlineStyle(token)
                }
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: {
                    ...$d9c44872a0498ed5$var$getVerticalInlineStyle(token),
                    boxShadow: boxShadowSecondary
                }
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background-color ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`> ${componentCls}-title-content`]: {
                        width: 0,
                        opacity: 0,
                        overflow: 'hidden'
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            width: 0,
                            opacity: 0,
                            overflow: 'hidden',
                            marginInlineStart: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: {
                    ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                    paddingInline: paddingXS
                }
            }
        }
    ];
};
var $d9c44872a0498ed5$export$2e2bcd8739ae039 = $d9c44872a0498ed5$var$getVerticalStyle;


const $8b02c8fb9659c94e$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background-color ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: {
                ...(0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()
            },
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const $8b02c8fb9659c94e$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: [
                    'transform',
                    'opacity'
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(',')
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius: borderRadius,
                    transition: [
                        `background-color`,
                        `transform`,
                        `top`,
                        `color`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $8b02c8fb9659c94e$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize } = token;
    return [
        // Misc
        {
            '': {
                [componentCls]: {
                    ...(0, $4733a3b3eb18f80d$export$8c467e8859fdef13)(),
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                }
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                ...(0, $4733a3b3eb18f80d$export$8c467e8859fdef13)(),
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                // Fix display inline-block gap
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color`,
                        `background-color`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow}`,
                        `background-color ${motionDurationSlow}`,
                        `padding ${motionDurationMid}`
                    ].map((prop)=>`${prop} ${motionEaseInOut}`).join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background-color`,
                        `padding`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%'
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                },
                // Item
                ...$8b02c8fb9659c94e$var$genMenuItemStyle(token),
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: {
                            borderRadius: borderRadiusLG,
                            ...$8b02c8fb9659c94e$var$genMenuItemStyle(token),
                            ...$8b02c8fb9659c94e$var$genSubMenuArrowStyle(token),
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        }
                    },
                    '&-placement-leftTop, &-placement-bottomRight': {
                        transformOrigin: '100% 0'
                    },
                    '&-placement-leftBottom, &-placement-topRight': {
                        transformOrigin: '100% 100%'
                    },
                    '&-placement-rightBottom, &-placement-topLeft': {
                        transformOrigin: '0 100%'
                    },
                    '&-placement-bottomLeft, &-placement-rightTop': {
                        transformOrigin: '0 0'
                    },
                    '&-placement-leftTop, &-placement-leftBottom': {
                        paddingInlineEnd: token.paddingXS
                    },
                    '&-placement-rightTop, &-placement-rightBottom': {
                        paddingInlineStart: token.paddingXS
                    },
                    '&-placement-topRight, &-placement-topLeft': {
                        paddingBottom: token.paddingXS
                    },
                    '&-placement-bottomRight, &-placement-bottomLeft': {
                        paddingTop: token.paddingXS
                    }
                },
                ...$8b02c8fb9659c94e$var$genSubMenuArrowStyle(token),
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                    }
                }
            }
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const $8b02c8fb9659c94e$export$9ca1be8807fe0675 = (token)=>{
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = token.activeBarWidth ?? 0;
    const activeBarBorderWidth = token.activeBarBorderWidth ?? lineWidth;
    const itemMarginInline = token.itemMarginInline ?? token.marginXXS;
    const colorTextDark = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$8b02c8fb9659c94e$export$2e2bcd8739ae039 = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Menu', (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $8b02c8fb9659c94e$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $538c6177909b715a$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $d9c44872a0498ed5$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $e091dfcd5daa8c55$export$2e2bcd8739ae039)(menuToken, 'light'),
            (0, $e091dfcd5daa8c55$export$2e2bcd8739ae039)(menuDarkToken, 'dark'),
            // RTL
            (0, $99ca4130ddbe9d7a$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(menuToken),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(menuToken, 'slide-up'),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(menuToken, 'slide-down'),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(menuToken, 'zoom-big')
        ];
    }, $8b02c8fb9659c94e$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



var $acw62 = parcelRequire("acw62");






"use client";
const $14bdbe2126091cad$var$SubMenu = (props)=>{
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $acw62.useContext((0, $f1be9e89e34926b1$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme, classNames: classNames, styles: styles } = context;
    const parentPath = (0, $43c59d964a3094e1$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $acw62.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, classNames?.itemIcon),
                style: {
                    ...oriProps.style,
                    ...styles?.itemIcon
                }
            })), titleIsSpan ? title : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $acw62.useMemo(()=>({
            ...context,
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('Menu');
    return /*#__PURE__*/ $acw62.createElement((0, $f1be9e89e34926b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $b61e1d68050bda86$export$2e2bcd8739ae039), {
        ...(0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
            'icon'
        ]),
        title: titleNode,
        classNames: {
            list: classNames?.subMenu?.list,
            listTitle: classNames?.subMenu?.itemTitle
        },
        styles: {
            list: styles?.subMenu?.list,
            listTitle: styles?.subMenu?.itemTitle
        },
        popupClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, popupClassName, classNames?.popup?.root, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex: zIndex,
            // fix: https://github.com/ant-design/ant-design/issues/47826#issuecomment-2360737237
            ...props.popupStyle,
            ...styles?.popup?.root
        }
    }));
};
var $14bdbe2126091cad$export$2e2bcd8739ae039 = $14bdbe2126091cad$var$SubMenu;


"use client";
function $b245b5b99d4f95a5$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $b245b5b99d4f95a5$var$MENU_COMPONENTS = {
    item: (0, $8955a62aec0d8484$export$2e2bcd8739ae039),
    submenu: (0, $14bdbe2126091cad$export$2e2bcd8739ae039),
    divider: (0, $d26f09d6992ff5d8$export$2e2bcd8739ae039)
};
const $b245b5b99d4f95a5$var$InternalMenu = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const override = $acw62.useContext((0, $798e9781cc841bf2$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = 'light', expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, tooltip: tooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, classNames: classNames, styles: styles, ...restProps } = props;
    const { menu: menu } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('menu');
    const rootPrefixCls = getPrefixCls();
    const passedProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, [
        'collapsedWidth'
    ]);
    overrideObj.validator?.({
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((...args)=>{
        onClick?.(...args);
        overrideObj.onClick?.();
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable ?? overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed ?? siderCollapsed;
    // ================ Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        mode: mergedMode,
        inlineCollapsed: mergedInlineCollapsed,
        selectable: mergedSelectable,
        theme: theme
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        },
        subMenu: {
            _default: 'item'
        }
    });
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $8b02c8fb9659c94e$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-${theme}`, contextClassName, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $acw62.useMemo(()=>{
        if (typeof expandIcon === 'function' || $b245b5b99d4f95a5$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === 'function' || $b245b5b99d4f95a5$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof menu?.expandIcon === 'function' || $b245b5b99d4f95a5$var$isEmptyIcon(menu?.expandIcon)) return menu?.expandIcon || null;
        const mergedIcon = expandIcon ?? overrideObj?.expandIcon ?? menu?.expandIcon;
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $acw62.isValidElement(mergedIcon) ? mergedIcon.props?.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj?.expandIcon,
        menu?.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $acw62.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip,
            tooltip: tooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme,
        mergedMode,
        mergedClassNames,
        mergedStyles,
        tooltip
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $f1be9e89e34926b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $4fda38e69f71e3cd$export$2e2bcd8739ae039), {
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $acw62.createElement((0, $18b92a77e6b0d38f$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        classNames: {
            list: mergedClassNames.list,
            listTitle: mergedClassNames.itemTitle
        },
        styles: {
            list: mergedStyles.list,
            listTitle: mergedStyles.itemTitle
        },
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick,
        ...passedProps,
        inlineCollapsed: mergedInlineCollapsed,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        _internalComponents: $b245b5b99d4f95a5$var$MENU_COMPONENTS
    })));
});
var $b245b5b99d4f95a5$export$2e2bcd8739ae039 = $b245b5b99d4f95a5$var$InternalMenu;





"use client";
const $47077f34c49bbd52$var$Menu = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const menuRef = (0, $acw62.useRef)(null);
    const context = $acw62.useContext((0, $f4e67dbf2453f541$export$63554aebd2a6d54c));
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                menuRef.current?.focus(options);
            }
        }));
    return /*#__PURE__*/ $acw62.createElement((0, $b245b5b99d4f95a5$export$2e2bcd8739ae039), {
        ref: menuRef,
        ...props,
        ...context
    });
});
$47077f34c49bbd52$var$Menu.Item = (0, $8955a62aec0d8484$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.SubMenu = (0, $14bdbe2126091cad$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.Divider = (0, $d26f09d6992ff5d8$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.ItemGroup = (0, $6f1a929f0a4933a1$export$2e2bcd8739ae039);
var $47077f34c49bbd52$export$2e2bcd8739ae039 = $47077f34c49bbd52$var$Menu;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $86af1367b2b71ab8$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $86af1367b2b71ab8$export$2e2bcd8739ae039 = $86af1367b2b71ab8$var$SearchOutlined;



function $f7392a88184334dd$var$_extends() {
    $f7392a88184334dd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7392a88184334dd$var$_extends.apply(this, arguments);
}
const $f7392a88184334dd$var$SearchOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f7392a88184334dd$var$_extends({}, props, {
        ref: ref,
        icon: (0, $86af1367b2b71ab8$export$2e2bcd8739ae039)
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const $f7392a88184334dd$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f7392a88184334dd$var$SearchOutlined);
var $f7392a88184334dd$export$2e2bcd8739ae039 = $f7392a88184334dd$var$RefIcon;



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");







const $92631131e38a19f0$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOutCirc: motionEaseOutCirc, antCls: antCls } = token;
    const [, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'wave');
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: varRef('color', colorPrimary),
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s`,
                    `opacity 2s`
                ].map((prop)=>`${prop} ${motionEaseOutCirc}`).join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow`,
                        `opacity`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
                }
            }
        }
    };
};
var $92631131e38a19f0$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$b8cc4ee2ee8cfbc8)('Wave', $92631131e38a19f0$var$genWaveStyle);



var $acw62 = parcelRequire("acw62");





const $ede16c18199d1556$export$23466a5792b7a5d3 = `${(0, $a18b2f6f56546238$export$e4ec87ea71f29b41)}-wave-target`;



var $acw62 = parcelRequire("acw62");



const $1960195940222379$var$MARK = '__rc_react_root__';
function $1960195940222379$export$b3890eb0ae9dca99(node, container) {
    const root = container[$1960195940222379$var$MARK] || (0, $7e96a608cb33bf79$exports.createRoot)(container);
    root.render(node);
    container[$1960195940222379$var$MARK] = root;
}
async function $1960195940222379$export$121e2d597d222bad(container) {
    // Delay to unmount to avoid React 18 sync warning
    return Promise.resolve().then(()=>{
        container[$1960195940222379$var$MARK]?.unmount();
        delete container[$1960195940222379$var$MARK];
    });
}







function $fc14acdc17dc0f28$export$9d61ea039e87eb91(color) {
    return color && typeof color === 'string' && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent' && color !== 'canvastext';
}
function $fc14acdc17dc0f28$export$651d8e9c80304fc8(node, colorSource = null) {
    const style = getComputedStyle(node);
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = style;
    if (colorSource && $fc14acdc17dc0f28$export$9d61ea039e87eb91(style[colorSource])) return style[colorSource];
    return [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find($fc14acdc17dc0f28$export$9d61ea039e87eb91) ?? null;
}


"use client";
function $1267f32cdb4173c5$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $1267f32cdb4173c5$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, colorSource: colorSource } = props;
    const divRef = $acw62.useRef(null);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const [varName] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(rootPrefixCls, 'wave');
    // ===================== Effect =====================
    const [waveColor, setWaveColor] = $acw62.useState(null);
    const [borderRadius, setBorderRadius] = $acw62.useState([]);
    const [left, setLeft] = $acw62.useState(0);
    const [top, setTop] = $acw62.useState(0);
    const [width, setWidth] = $acw62.useState(0);
    const [height, setHeight] = $acw62.useState(0);
    const [enabled, setEnabled] = $acw62.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (waveColor) waveStyle[varName('color')] = waveColor;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $fc14acdc17dc0f28$export$651d8e9c80304fc8)(target, colorSource));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $1267f32cdb4173c5$var$validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $1267f32cdb4173c5$var$validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$1267f32cdb4173c5$var$validateNum(Number.parseFloat(radius))));
    }
    $acw62.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(id);
                resizeObserver?.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && target?.classList.contains((0, $ede16c18199d1556$export$23466a5792b7a5d3));
    return /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = divRef.current?.parentElement;
                (0, $1960195940222379$export$121e2d597d222bad)(holder).then(()=>{
                    holder?.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $acw62.createElement("div", {
            ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(divRef, ref),
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $1267f32cdb4173c5$var$showWaveEffect = (target, info)=>{
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !target.querySelector('input')?.checked) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target?.insertBefore(holder, target?.firstChild);
    (0, $1960195940222379$export$b3890eb0ae9dca99)(/*#__PURE__*/ $acw62.createElement($1267f32cdb4173c5$var$WaveEffect, {
        ...info,
        target: target
    }), holder);
};
var $1267f32cdb4173c5$export$2e2bcd8739ae039 = $1267f32cdb4173c5$var$showWaveEffect;


const $20c8c8dba0bc4c2d$var$useWave = (nodeRef, className, component, colorSource)=>{
    const { wave: wave } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const showWave = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if (wave?.disabled || !node) return;
        const targetNode = node.querySelector(`.${(0, $ede16c18199d1556$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $1267f32cdb4173c5$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId,
            colorSource: colorSource
        });
    });
    const rafIdRef = $acw62.useRef(null);
    // Clean up RAF on unmount to prevent memory leaks and stale callbacks
    $acw62.useEffect(()=>()=>{
            (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafIdRef.current);
        }, []);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafIdRef.current);
        rafIdRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $20c8c8dba0bc4c2d$export$2e2bcd8739ae039 = $20c8c8dba0bc4c2d$var$useWave;


const $37e027257ee01609$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component, colorSource: colorSource } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const containerRef = (0, $acw62.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const hashId = (0, $92631131e38a19f0$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $20c8c8dba0bc4c2d$export$2e2bcd8739ae039)(containerRef, (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, hashId), component, colorSource);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $13cc53bc89b37f6a$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') && !node.className.includes('disabled:') || node.getAttribute('aria-disabled') === 'true' || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children)) return children ?? null;
    const ref = (0, $6c628207f5089a39$export$c1cec34af06bcf7)(children) ? (0, $6c628207f5089a39$export$ab452c34e8e05029)((0, $6c628207f5089a39$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $30796c32f374b477$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $37e027257ee01609$export$2e2bcd8739ae039 = $37e027257ee01609$var$Wave;







var $acw62 = parcelRequire("acw62");




"use client";
const $5d973a23e560af94$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $acw62.createContext(undefined);
const $5d973a23e560af94$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className, ...others } = props;
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const sizeCls = $acw62.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $acw62.createElement($5d973a23e560af94$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ...others,
        className: classes
    }));
};
var $5d973a23e560af94$export$2e2bcd8739ae039 = $5d973a23e560af94$var$ButtonGroup;




var $acw62 = parcelRequire("acw62");




"use client";
const $891d27b465b97c91$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $891d27b465b97c91$export$c5dca2bf412dea0d = $891d27b465b97c91$var$rxTwoCNChar.test.bind($891d27b465b97c91$var$rxTwoCNChar);
function $891d27b465b97c91$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $891d27b465b97c91$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted, style, className) {
    if (!(0, $b956dab96d0e505b$export$826fff653a329e83)(child) || child === '') return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && (0, $b956dab96d0e505b$export$844ec244b1367d54)(child.type) && $891d27b465b97c91$export$c5dca2bf412dea0d(child.props.children)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(child, (oriProps)=>{
        const mergedCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined;
        const mergedStyle = {
            ...style,
            ...oriProps.style
        };
        return {
            ...oriProps,
            children: oriProps.children.split('').join(SPACE),
            className: mergedCls,
            style: mergedStyle
        };
    });
    if ((0, $b956dab96d0e505b$export$844ec244b1367d54)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: className,
        style: style
    }, $891d27b465b97c91$export$c5dca2bf412dea0d(child) ? child.split('').join(SPACE) : child);
    if ((0, $30796c32f374b477$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: className,
        style: style
    }, child);
    return (0, $30796c32f374b477$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined,
            style: {
                ...oriProps.style,
                ...style
            }
        }));
}
function $891d27b465b97c91$export$b6ee00a7e7908bc(children, needInserted, style, className) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(childList, (child)=>$891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted, style, className));
}
const $891d27b465b97c91$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $891d27b465b97c91$var$_ButtonShapes = [
    'default',
    'circle',
    'round',
    'square'
];
const $891d27b465b97c91$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $891d27b465b97c91$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $891d27b465b97c91$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad)));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2b0f3084756e08d0$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $2b0f3084756e08d0$export$2e2bcd8739ae039 = $2b0f3084756e08d0$var$LoadingOutlined;



function $d8d56e1090f62915$var$_extends() {
    $d8d56e1090f62915$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8d56e1090f62915$var$_extends.apply(this, arguments);
}
const $d8d56e1090f62915$var$LoadingOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $d8d56e1090f62915$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2b0f3084756e08d0$export$2e2bcd8739ae039)
    }));
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ const $d8d56e1090f62915$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8d56e1090f62915$var$LoadingOutlined);
var $d8d56e1090f62915$export$2e2bcd8739ae039 = $d8d56e1090f62915$var$RefIcon;





var $acw62 = parcelRequire("acw62");

"use client";
const $19bf9f13d1d4a6e4$var$IconWrapper = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $19bf9f13d1d4a6e4$export$2e2bcd8739ae039 = $19bf9f13d1d4a6e4$var$IconWrapper;


"use client";
const $bfeeb2467aaa0581$var$InnerLoadingIcon = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $bfeeb2467aaa0581$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $bfeeb2467aaa0581$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $bfeeb2467aaa0581$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bfeeb2467aaa0581$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $bfeeb2467aaa0581$var$getCollapsedWidth,
        onAppearActive: $bfeeb2467aaa0581$var$getRealWidth,
        onEnterStart: $bfeeb2467aaa0581$var$getCollapsedWidth,
        onEnterActive: $bfeeb2467aaa0581$var$getRealWidth,
        onLeaveStart: $bfeeb2467aaa0581$var$getRealWidth,
        onLeaveActive: $bfeeb2467aaa0581$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bfeeb2467aaa0581$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $bfeeb2467aaa0581$export$2e2bcd8739ae039 = $bfeeb2467aaa0581$var$DefaultLoadingIcon;





const $ab57165ca056af8c$export$c5b4e7cabb00fc99 = ()=>{
    return {
        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            animation: 'none'
        }
    };
};



const $9b1a8aea1f437a60$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $9b1a8aea1f437a60$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $9b1a8aea1f437a60$export$2e2bcd8739ae039 = $9b1a8aea1f437a60$var$genGroupStyle;





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $ff78bf97e6b9662b$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, forceRender: forceRender, className: className, style: style, children: children, isActive: isActive, role: role, classNames: customizeClassNames, styles: styles } = props;
    const [rendered, setRendered] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isActive || forceRender);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, {
            [`${prefixCls}-panel-active`]: isActive,
            [`${prefixCls}-panel-inactive`]: !isActive
        }, className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-body`, customizeClassNames?.body),
        style: styles?.body
    }, children));
});
var $ff78bf97e6b9662b$export$2e2bcd8739ae039 = $ff78bf97e6b9662b$var$PanelContent;


const $e5686afcba130ca6$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { showArrow: showArrow = true, headerClass: headerClass, isActive: isActive, onItemClick: onItemClick, forceRender: forceRender, className: className, classNames: customizeClassNames = {}, styles: styles = {}, prefixCls: prefixCls, collapsible: collapsible, accordion: accordion, panelKey: panelKey, extra: extra, header: header, expandIcon: expandIcon, openMotion: openMotion, destroyOnHidden: destroyOnHidden, children: children, ...resetProps } = props;
    const disabled = collapsible === 'disabled';
    const ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    const collapsibleProps = {
        onClick: ()=>{
            onItemClick?.(panelKey);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER || e.which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) onItemClick?.(panelKey);
        },
        role: accordion ? 'tab' : 'button',
        ['aria-expanded']: isActive,
        ['aria-disabled']: disabled,
        tabIndex: disabled ? -1 : 0
    };
    // ======================== Icon ========================
    const iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "arrow"
    });
    const iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-expand-icon`, customizeClassNames?.icon),
        style: styles?.icon
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    const collapsePanelClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-item`, {
        [`${prefixCls}-item-active`]: isActive,
        [`${prefixCls}-item-disabled`]: disabled
    }, className);
    const headerClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(headerClass, `${prefixCls}-header`, {
        [`${prefixCls}-collapsible-${collapsible}`]: !!collapsible
    }, customizeClassNames?.header);
    // ======================== HeaderProps ========================
    const headerProps = {
        className: headerClassName,
        style: styles?.header,
        ...[
            'header',
            'icon'
        ].includes(collapsible) ? {} : collapsibleProps
    };
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-title`, customizeClassNames?.title),
        style: styles?.title
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        visible: isActive,
        leavedClassName: `${prefixCls}-panel-hidden`
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyOnHidden
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff78bf97e6b9662b$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : undefined
        }, children);
    }));
});
var $e5686afcba130ca6$export$2e2bcd8739ae039 = $e5686afcba130ca6$var$CollapsePanel;



function $35cc391d48bf345b$var$mergeSemantic(src, tgt, mergeFn) {
    if (!src || !tgt) return src || tgt;
    const keys = Array.from(new Set([
        ...Object.keys(src),
        ...Object.keys(tgt)
    ]));
    const result = {};
    keys.forEach((key)=>{
        result[key] = mergeFn(src[key], tgt[key]);
    });
    return result;
}
function $35cc391d48bf345b$var$mergeSemanticClassNames(src, tgt) {
    return $35cc391d48bf345b$var$mergeSemantic(src, tgt, (a, b)=>(0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(a, b));
}
function $35cc391d48bf345b$var$mergeSemanticStyles(src, tgt) {
    return $35cc391d48bf345b$var$mergeSemantic(src, tgt, (a, b)=>({
            ...a,
            ...b
        }));
}
const $35cc391d48bf345b$var$convertItemsToNodes = (items, props)=>{
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: collapseStyles } = props;
    return items.map((item, index)=>{
        const { children: children, label: label, key: rawKey, collapsible: rawCollapsible, onItemClick: rawOnItemClick, destroyOnHidden: rawDestroyOnHidden, classNames: classNames, styles: styles, ...restProps } = item;
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        const key = String(rawKey ?? index);
        const mergeCollapsible = rawCollapsible ?? collapsible;
        const mergedDestroyOnHidden = rawDestroyOnHidden ?? destroyOnHidden;
        const handleItemClick = (value)=>{
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick?.(value);
        };
        let isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5686afcba130ca6$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
            classNames: $35cc391d48bf345b$var$mergeSemanticClassNames(collapseClassNames, classNames),
            styles: $35cc391d48bf345b$var$mergeSemanticStyles(collapseStyles, styles),
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyOnHidden: mergedDestroyOnHidden
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ const $35cc391d48bf345b$var$getNewChild = (child, index, props)=>{
    if (!child) return null;
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    const key = child.key || String(index);
    const { header: header, headerClass: headerClass, destroyOnHidden: childDestroyOnHidden, collapsible: childCollapsible, onItemClick: childOnItemClick } = child.props;
    let isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    const mergeCollapsible = childCollapsible ?? collapsible;
    const handleItemClick = (value)=>{
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick?.(value);
    };
    const childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        classNames: collapseClassNames,
        styles: styles,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyOnHidden: childDestroyOnHidden ?? destroyOnHidden,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach((propName)=>{
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, childProps);
};
function $35cc391d48bf345b$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $35cc391d48bf345b$var$convertItemsToNodes(items, props);
    return (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(rawChildren).map((child, index)=>$35cc391d48bf345b$var$getNewChild(child, index, props));
}
var $35cc391d48bf345b$export$2e2bcd8739ae039 = $35cc391d48bf345b$var$useItems;



const $613e269121c63c71$var$attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`;
const $613e269121c63c71$var$eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`;
const $613e269121c63c71$var$propList = `${$613e269121c63c71$var$attributes} ${$613e269121c63c71$var$eventsName}`.split(/[\s\n]+/);
/* eslint-enable max-len */ const $613e269121c63c71$var$ariaPrefix = 'aria-';
const $613e269121c63c71$var$dataPrefix = 'data-';
function $613e269121c63c71$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $613e269121c63c71$export$2e2bcd8739ae039(props, ariaOnly = false) {
    let mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = {
        ...ariaOnly
    };
    const attrs = {};
    Object.keys(props).forEach((key)=>{
        if (// Aria
        mergedConfig.aria && (key === 'role' || $613e269121c63c71$var$match(key, $613e269121c63c71$var$ariaPrefix)) || // Data
        mergedConfig.data && $613e269121c63c71$var$match(key, $613e269121c63c71$var$dataPrefix) || // Attr
        mergedConfig.attr && $613e269121c63c71$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


function $c6bc702f85f2aaf6$var$getActiveKeysArray(activeKey) {
    let currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        const activeKeyType = typeof currentActiveKey;
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map((key)=>String(key));
}
const $c6bc702f85f2aaf6$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-collapse', destroyOnHidden: destroyOnHidden = false, style: style, accordion: accordion, className: className, children: children, collapsible: collapsible, openMotion: openMotion, expandIcon: expandIcon, activeKey: rawActiveKey, defaultActiveKey: defaultActiveKey, onChange: onChange, items: items, classNames: customizeClassNames, styles: styles } = props;
    const collapseClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className);
    const [internalActiveKey, setActiveKey] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultActiveKey, rawActiveKey);
    const activeKey = $c6bc702f85f2aaf6$var$getActiveKeysArray(internalActiveKey);
    const triggerActiveKey = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((next)=>{
        const nextKeys = $c6bc702f85f2aaf6$var$getActiveKeysArray(next);
        setActiveKey(nextKeys);
        onChange?.(nextKeys);
    });
    const onItemClick = (key)=>{
        if (accordion) triggerActiveKey(activeKey[0] === key ? [] : [
            key
        ]);
        else triggerActiveKey(activeKey.includes(key) ? activeKey.filter((item)=>item !== key) : [
            ...activeKey,
            key
        ]);
    };
    // ======================== Children ========================
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    const mergedChildren = (0, $35cc391d48bf345b$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyOnHidden: destroyOnHidden,
        onItemClick: onItemClick,
        activeKey: activeKey,
        classNames: customizeClassNames,
        styles: styles
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $c6bc702f85f2aaf6$export$2e2bcd8739ae039 = Object.assign($c6bc702f85f2aaf6$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $e5686afcba130ca6$export$2e2bcd8739ae039)
});


var $498d6a750d6587b4$export$2e2bcd8739ae039 = (0, $c6bc702f85f2aaf6$export$2e2bcd8739ae039);
const { Panel: $498d6a750d6587b4$export$2ddb90ad54e5f587 } = (0, $c6bc702f85f2aaf6$export$2e2bcd8739ae039);











var $acw62 = parcelRequire("acw62");




"use client";
const $8247f3cd58331054$var$CollapsePanel = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $498d6a750d6587b4$export$2e2bcd8739ae039).Panel, {
        ref: ref,
        ...props,
        prefixCls: prefixCls,
        className: collapsePanelClassName
    });
});
var $8247f3cd58331054$export$2e2bcd8739ae039 = $8247f3cd58331054$var$CollapsePanel;






const $f3a8b55181e5e7fb$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: 'relative',
                    // Compatible with old version of antd, should remove in next version
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    ...(0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token),
                    [`> ${componentCls}-title`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        marginInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: {
                        ...(0, $4733a3b3eb18f80d$export$171ccda7bc085e59)(),
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    },
                    // >>>>> Text
                    [`${componentCls}-title`]: {
                        marginInlineEnd: 'auto'
                    }
                },
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-title`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-panel`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-body`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                '&, & > .arrow': {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Placement ==========================
            [`&${componentCls}-icon-placement-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            marginInlineEnd: 0,
                            marginInlineStart: marginSM
                        }
                    }
                }
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel > ${componentCls}-body`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-body`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $f3a8b55181e5e7fb$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
var $f3a8b55181e5e7fb$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        collapseHeaderPaddingSM: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $f3a8b55181e5e7fb$export$5ca74f7be820a85(collapseToken),
        $f3a8b55181e5e7fb$var$genBorderlessStyle(collapseToken),
        $f3a8b55181e5e7fb$var$genGhostStyle(collapseToken),
        $f3a8b55181e5e7fb$var$genArrowStyle(collapseToken),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $f3a8b55181e5e7fb$export$9ca1be8807fe0675);


"use client";
const $f9834ac36ee4cc31$var$Collapse = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPlacement: expandIconPlacement, expandIconPosition: expandIconPosition, children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon, classNames: classNames, styles: styles } = props;
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? ctx ?? 'middle');
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $f3a8b55181e5e7fb$export$2e2bcd8739ae039)(prefixCls);
    const mergedPlacement = expandIconPlacement ?? expandIconPosition ?? 'start';
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered,
        expandIconPlacement: mergedPlacement
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    var deprecatedName, newName;
    const renderExpandIcon = $acw62.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-arrow`)
            }));
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-icon-placement-${mergedPlacement}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-large`]: mergedSize === 'large',
        [`${prefixCls}-small`]: mergedSize === 'small'
    }, contextClassName, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const openMotion = $acw62.useMemo(()=>({
            ...(0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls),
            motionAppear: false,
            leavedClassName: `${prefixCls}-panel-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $acw62.useMemo(()=>{
        if (children) return (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children).map((child)=>child);
        return null;
    }, [
        children
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $498d6a750d6587b4$export$2e2bcd8739ae039), {
        ref: ref,
        openMotion: openMotion,
        ...(0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
            'rootClassName'
        ]),
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        classNames: mergedClassNames,
        styles: mergedStyles,
        destroyOnHidden: destroyOnHidden ?? destroyInactivePanel
    }, items);
});
var $f9834ac36ee4cc31$export$2e2bcd8739ae039 = Object.assign($f9834ac36ee4cc31$var$Collapse, {
    Panel: (0, $8247f3cd58331054$export$2e2bcd8739ae039)
});


"use client";
var $87069059c399a8f7$export$2e2bcd8739ae039 = (0, $f9834ac36ee4cc31$export$2e2bcd8739ae039);





"use client";
const $d5221672d26ff0b4$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $6a06b7fa031c80c1$export$c844f5d21427d1ab));
        return value;
    });
const $d5221672d26ff0b4$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $d5221672d26ff0b4$var$genCollapsePanelKey = (preset, index)=>{
    const mergedKey = preset.key ?? index;
    return `panel-${mergedKey}`;
};
const $d5221672d26ff0b4$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const presetsValue = (0, $acw62.useMemo)(()=>$d5221672d26ff0b4$var$genPresetColor(presets), [
        presets
    ]);
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $acw62.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($d5221672d26ff0b4$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange?.(colorValue);
    };
    const items = presetsValue.map((preset, index)=>({
            key: $d5221672d26ff0b4$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset?.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset?.colors) && preset.colors?.length > 0 ? preset.colors.map((presetColor, index)=>{
                const colorInst = (0, $6a06b7fa031c80c1$export$c844f5d21427d1ab)(presetColor);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5d5fed38984894d$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: colorInst.toCssString(),
                    prefixCls: prefixCls,
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toCssString() === color?.toCssString(),
                        [`${colorPresetsPrefixCls}-color-bright`]: $d5221672d26ff0b4$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                });
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87069059c399a8f7$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $d5221672d26ff0b4$export$2e2bcd8739ae039 = $d5221672d26ff0b4$var$ColorPresets;





const $528e850af07e6ac9$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, borderColorDisabled: borderColorDisabled } = token;
    const buttonToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize,
        colorBorderDisabled: borderColorDisabled
    });
    return buttonToken;
};
const $528e850af07e6ac9$export$9ca1be8807fe0675 = (token)=>{
    const contentFontSize = token.contentFontSize ?? token.fontSize;
    const contentFontSizeSM = token.contentFontSizeSM ?? token.fontSize;
    const contentFontSizeLG = token.contentFontSizeLG ?? token.fontSizeLG;
    const contentLineHeight = token.contentLineHeight ?? (0, $239826517175299d$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = token.contentLineHeightSM ?? (0, $239826517175299d$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = token.contentLineHeightLG ?? (0, $239826517175299d$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $d5221672d26ff0b4$export$6341b37cb79161da)(new (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>({
            ...prev,
            [`${colorKey}ShadowColor`]: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    const defaultBgDisabled = token.colorBgContainerDisabled;
    const dashedBgDisabled = token.colorBgContainerDisabled;
    return {
        ...shadowColorTokens,
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorderDisabled,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0),
        defaultBgDisabled: defaultBgDisabled,
        dashedBgDisabled: dashedBgDisabled
    };
};




const $44bd5cea3efacb77$var$genVariantStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, lineWidth: lineWidth } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'btn');
    return {
        [componentCls]: [
            // ==============================================================
            // ==                         Variable                         ==
            // ==============================================================
            {
                // Border
                [varName('border-width')]: lineWidth,
                [varName('border-color')]: '#000',
                [varName('border-color-hover')]: varRef('border-color'),
                [varName('border-color-active')]: varRef('border-color'),
                [varName('border-color-disabled')]: varRef('border-color'),
                [varName('border-style')]: 'solid',
                // Text
                [varName('text-color')]: '#000',
                [varName('text-color-hover')]: varRef('text-color'),
                [varName('text-color-active')]: varRef('text-color'),
                [varName('text-color-disabled')]: varRef('text-color'),
                // Background
                [varName('bg-color')]: '#ddd',
                [varName('bg-color-hover')]: varRef('bg-color'),
                [varName('bg-color-active')]: varRef('bg-color'),
                [varName('bg-color-disabled')]: token.colorBgContainerDisabled,
                [varName('bg-color-container')]: token.colorBgContainer,
                // Shadow
                [varName('shadow')]: 'none'
            },
            // ==============================================================
            // ==                         Template                         ==
            // ==============================================================
            {
                // Basic
                border: [
                    varRef('border-width'),
                    varRef('border-style'),
                    varRef('border-color')
                ].join(' '),
                color: varRef('text-color'),
                backgroundColor: varRef('bg-color'),
                // Status
                [`&:not(:disabled):not(${componentCls}-disabled)`]: {
                    // Hover
                    '&:hover': {
                        border: [
                            varRef('border-width'),
                            varRef('border-style'),
                            varRef('border-color-hover')
                        ].join(' '),
                        color: varRef('text-color-hover'),
                        backgroundColor: varRef('bg-color-hover')
                    },
                    // Active
                    '&:active': {
                        border: [
                            varRef('border-width'),
                            varRef('border-style'),
                            varRef('border-color-active')
                        ].join(' '),
                        color: varRef('text-color-active'),
                        backgroundColor: varRef('bg-color-active')
                    }
                }
            },
            // ==============================================================
            // ==                         Variants                         ==
            // ==============================================================
            {
                // >>>>> Solid
                [`&${componentCls}-variant-solid`]: {
                    // Solid Variables
                    [varName('solid-bg-color')]: varRef('color-base'),
                    [varName('solid-bg-color-hover')]: varRef('color-hover'),
                    [varName('solid-bg-color-active')]: varRef('color-active'),
                    // Variables
                    [varName('border-color')]: 'transparent',
                    [varName('text-color')]: token.colorTextLightSolid,
                    [varName('bg-color')]: varRef('solid-bg-color'),
                    [varName('bg-color-hover')]: varRef('solid-bg-color-hover'),
                    [varName('bg-color-active')]: varRef('solid-bg-color-active'),
                    // Box Shadow
                    boxShadow: varRef('shadow')
                },
                // >>>>> Outlined & Dashed
                [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                    [varName('border-color')]: varRef('color-base'),
                    [varName('border-color-hover')]: varRef('color-hover'),
                    [varName('border-color-active')]: varRef('color-active'),
                    [varName('bg-color')]: varRef('bg-color-container'),
                    [varName('text-color')]: varRef('color-base'),
                    [varName('text-color-hover')]: varRef('color-hover'),
                    [varName('text-color-active')]: varRef('color-active'),
                    // Box Shadow
                    boxShadow: varRef('shadow')
                },
                // >>>>> Dashed
                [`&${componentCls}-variant-dashed`]: {
                    [varName('border-style')]: 'dashed',
                    [varName('bg-color-disabled')]: token.dashedBgDisabled
                },
                // >>>>> Filled
                [`&${componentCls}-variant-filled`]: {
                    [varName('border-color')]: 'transparent',
                    [varName('text-color')]: varRef('color-base'),
                    [varName('bg-color')]: varRef('color-light'),
                    [varName('bg-color-hover')]: varRef('color-light-hover'),
                    [varName('bg-color-active')]: varRef('color-light-active')
                },
                // >>>>> Text & Link
                [`&${componentCls}-variant-text, &${componentCls}-variant-link`]: {
                    [varName('border-color')]: 'transparent',
                    [varName('text-color')]: varRef('color-base'),
                    [varName('text-color-hover')]: varRef('color-hover'),
                    [varName('text-color-active')]: varRef('color-active'),
                    [varName('bg-color')]: 'transparent',
                    [varName('bg-color-hover')]: 'transparent',
                    [varName('bg-color-active')]: 'transparent',
                    [`&:disabled, &${token.componentCls}-disabled`]: {
                        background: 'transparent',
                        borderColor: 'transparent'
                    }
                },
                // >>>>> Text
                [`&${componentCls}-variant-text`]: {
                    [varName('bg-color-hover')]: varRef('color-light'),
                    [varName('bg-color-active')]: varRef('color-light-active')
                }
            },
            // ==============================================================
            // ==                          Colors                          ==
            // ==============================================================
            {
                // ======================== By Default ========================
                // >>>>> Link
                [`&${componentCls}-variant-link`]: {
                    [varName('color-base')]: token.colorLink,
                    [varName('color-hover')]: token.colorLinkHover,
                    [varName('color-active')]: token.colorLinkActive,
                    [varName('bg-color-hover')]: token.linkHoverBg
                },
                // ======================== Compatible ========================
                // >>>>> Primary
                [`&${componentCls}-color-primary`]: {
                    [varName('color-base')]: token.colorPrimary,
                    [varName('color-hover')]: token.colorPrimaryHover,
                    [varName('color-active')]: token.colorPrimaryActive,
                    [varName('color-light')]: token.colorPrimaryBg,
                    [varName('color-light-hover')]: token.colorPrimaryBgHover,
                    [varName('color-light-active')]: token.colorPrimaryBorder,
                    [varName('shadow')]: token.primaryShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [varName('text-color')]: token.primaryColor,
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    }
                },
                // >>>>> Danger
                [`&${componentCls}-color-dangerous`]: {
                    [varName('color-base')]: token.colorError,
                    [varName('color-hover')]: token.colorErrorHover,
                    [varName('color-active')]: token.colorErrorActive,
                    [varName('color-light')]: token.colorErrorBg,
                    [varName('color-light-hover')]: token.colorErrorBgFilledHover,
                    [varName('color-light-active')]: token.colorErrorBgActive,
                    [varName('shadow')]: token.dangerShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [varName('text-color')]: token.dangerColor,
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    }
                },
                // >>>>> Default
                [`&${componentCls}-color-default`]: {
                    [varName('solid-bg-color')]: token.colorBgSolid,
                    [varName('solid-bg-color-hover')]: token.colorBgSolidHover,
                    [varName('solid-bg-color-active')]: token.colorBgSolidActive,
                    [varName('color-base')]: token.defaultBorderColor,
                    [varName('color-hover')]: token.defaultHoverBorderColor,
                    [varName('color-active')]: token.defaultActiveBorderColor,
                    [varName('color-light')]: token.colorFillTertiary,
                    [varName('color-light-hover')]: token.colorFillSecondary,
                    [varName('color-light-active')]: token.colorFill,
                    [varName('text-color')]: token.defaultColor,
                    [varName('text-color-hover')]: token.defaultHoverColor,
                    [varName('text-color-active')]: token.defaultActiveColor,
                    [varName('shadow')]: token.defaultShadow,
                    [`&${componentCls}-variant-outlined`]: {
                        [varName('bg-color-disabled')]: token.defaultBgDisabled
                    },
                    [`&${componentCls}-variant-solid`]: {
                        [varName('text-color')]: token.solidTextColor,
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    },
                    [`&${componentCls}-variant-filled, &${componentCls}-variant-text`]: {
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    },
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [varName('text-color')]: token.defaultColor,
                        [varName('text-color-hover')]: token.defaultHoverColor,
                        [varName('text-color-active')]: token.defaultActiveColor,
                        [varName('bg-color-container')]: token.defaultBg,
                        [varName('bg-color-hover')]: token.defaultHoverBg,
                        [varName('bg-color-active')]: token.defaultActiveBg
                    },
                    [`&${componentCls}-variant-text`]: {
                        [varName('text-color')]: token.textTextColor,
                        [varName('text-color-hover')]: token.textTextHoverColor,
                        [varName('text-color-active')]: token.textTextActiveColor,
                        [varName('bg-color-hover')]: token.textHoverBg
                    },
                    [`&${componentCls}-background-ghost`]: {
                        [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                            [varName('text-color')]: token.defaultGhostColor,
                            [varName('border-color')]: token.defaultGhostBorderColor
                        }
                    }
                }
            },
            // >>>>> Preset Colors
            (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).map((colorKey)=>{
                const darkColor = token[`${colorKey}6`];
                const lightColor = token[`${colorKey}1`];
                const hoverColor = token[`${colorKey}Hover`];
                const lightHoverColor = token[`${colorKey}2`];
                const lightActiveColor = token[`${colorKey}3`];
                const activeColor = token[`${colorKey}Active`];
                const shadowColor = token[`${colorKey}ShadowColor`];
                return {
                    [`&${componentCls}-color-${colorKey}`]: {
                        [varName('color-base')]: darkColor,
                        [varName('color-hover')]: hoverColor,
                        [varName('color-active')]: activeColor,
                        [varName('color-light')]: lightColor,
                        [varName('color-light-hover')]: lightHoverColor,
                        [varName('color-light-active')]: lightActiveColor,
                        [varName('shadow')]: shadowColor
                    }
                };
            }),
            // ==============================================================
            // ==                         Disabled                         ==
            // ==============================================================
            {
                // Disabled
                [`&:disabled, &${token.componentCls}-disabled`]: {
                    cursor: 'not-allowed',
                    borderColor: token.colorBorderDisabled,
                    background: varRef('bg-color-disabled'),
                    color: token.colorTextDisabled,
                    boxShadow: 'none'
                }
            },
            // ==============================================================
            // ==                          Ghost                           ==
            // ==============================================================
            {
                // Ghost
                [`&${componentCls}-background-ghost`]: {
                    [varName('bg-color')]: token.ghostBg,
                    [varName('bg-color-hover')]: token.ghostBg,
                    [varName('bg-color-active')]: token.ghostBg,
                    [varName('shadow')]: 'none',
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [varName('bg-color-hover')]: token.ghostBg,
                        [varName('bg-color-active')]: token.ghostBg
                    }
                }
            }
        ]
    };
};
var $44bd5cea3efacb77$export$2e2bcd8739ae039 = $44bd5cea3efacb77$var$genVariantStyle;


// ============================== Shared ==============================
const $3fa444975abc8ac9$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, iconGap: iconGap, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: iconGap,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            ...(0, $ab57165ca056af8c$export$c5b4e7cabb00fc99)(),
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPlacement
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
// ============================== Shape ===============================
const $3fa444975abc8ac9$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: '50%'
    });
// =============================== Size ===============================
const $3fa444975abc8ac9$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $3fa444975abc8ac9$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const $3fa444975abc8ac9$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $3fa444975abc8ac9$var$genButtonStyle(baseToken, token.componentCls);
};
const $3fa444975abc8ac9$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $3fa444975abc8ac9$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $3fa444975abc8ac9$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $3fa444975abc8ac9$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $3fa444975abc8ac9$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$3fa444975abc8ac9$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $528e850af07e6ac9$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $3fa444975abc8ac9$var$genSharedButtonStyle(buttonToken),
        // Size
        $3fa444975abc8ac9$var$genSizeBaseButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeSmallButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $3fa444975abc8ac9$var$genBlockButtonStyle(buttonToken),
        // Variant
        (0, $44bd5cea3efacb77$export$2e2bcd8739ae039)(buttonToken),
        // Button Group
        (0, $9b1a8aea1f437a60$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $528e850af07e6ac9$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $0eabbafc4673511e$var$compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            [hoverEffects]: {
                zIndex: 3
            },
            ...focusElCls ? {
                [`&${focusElCls}`]: {
                    zIndex: 3
                }
            } : {},
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        }
    };
}
// handle border-radius
function $0eabbafc4673511e$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $0eabbafc4673511e$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: {
            ...$0eabbafc4673511e$var$compactItemBorder(token, compactCls, options, mergedComponentCls),
            ...$0eabbafc4673511e$var$compactItemBorderRadius(mergedComponentCls, compactCls, options)
        }
    };
}


function $6ef3f73594535ba5$var$compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 3
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $6ef3f73594535ba5$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...$6ef3f73594535ba5$var$compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...$6ef3f73594535ba5$var$compactItemBorderVerticalRadius(token.componentCls, compactCls)
        }
    };
}





const $3971683be64d7459$var$genButtonCompactStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, lineWidth: lineWidth, calc: calc, colorBgContainer: colorBgContainer } = token;
    const solidSelector = `${componentCls}-variant-solid:not([disabled])`;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'btn');
    const getCompactBorderStyle = (vertical)=>{
        const itemCls = `${componentCls}-compact${vertical ? '-vertical' : ''}-item`;
        return {
            // TODO: Border color transition should be not cover when has color.
            [itemCls]: {
                [varName('compact-connect-border-color')]: varRef('bg-color-hover'),
                [`&${solidSelector}`]: {
                    transition: `none`,
                    [`& + ${solidSelector}:before`]: [
                        {
                            position: 'absolute',
                            backgroundColor: varRef('compact-connect-border-color'),
                            content: '""'
                        },
                        vertical ? {
                            top: insetOffset,
                            insetInline: insetOffset,
                            height: lineWidth
                        } : {
                            insetBlock: insetOffset,
                            insetInlineStart: insetOffset,
                            width: lineWidth
                        }
                    ],
                    '&:hover:before': {
                        display: 'none'
                    }
                }
            }
        };
    };
    // Special styles for solid Button
    return [
        getCompactBorderStyle(),
        getCompactBorderStyle(true),
        {
            [`${solidSelector}${componentCls}-color-default`]: {
                [varName('compact-connect-border-color')]: `color-mix(in srgb, ${varRef('bg-color-hover')} 75%, ${colorBgContainer})`
            }
        }
    ];
};
var // ============================== Export ==============================
$3971683be64d7459$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $528e850af07e6ac9$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(buttonToken),
        (0, $6ef3f73594535ba5$export$4dc87cb8ebf78ac6)(buttonToken),
        $3971683be64d7459$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $528e850af07e6ac9$export$9ca1be8807fe0675));


"use client";
function $6b70efe984f9bc5b$var$getLoadingConfig(loading) {
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(loading)) {
        let delay = loading?.delay;
        delay = (0, $b956dab96d0e505b$export$7e4aa119212bc614)(delay) ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $6b70efe984f9bc5b$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $6b70efe984f9bc5b$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { _skipSemantic: _skipSemantic, loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: customizeShape, size: customizeSize, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition, iconPlacement: iconPlacement, ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: classNames, styles: styles, style: style, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus, ...rest } = props;
    const childNodes = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, loadingIcon: contextLoadingIcon, shape: contextShape, color: contextColor, variant: contextVariant } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('button');
    const mergedShape = customizeShape || contextShape || 'default';
    const [parsedColor, parsedVariant] = (0, $acw62.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $6b70efe984f9bc5b$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if (contextColor && contextVariant) return [
            contextColor,
            contextVariant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        color,
        variant,
        type,
        danger,
        contextColor,
        contextVariant,
        mergedType
    ]);
    const [mergedColor, mergedVariant] = (0, $acw62.useMemo)(()=>{
        if (ghost && parsedVariant === 'solid') return [
            parsedColor,
            'outlined'
        ];
        return [
            parsedColor,
            parsedVariant
        ];
    }, [
        parsedColor,
        parsedVariant,
        ghost
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const mergedInsertSpace = autoInsertSpace ?? contextAutoInsertSpace ?? true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $3fa444975abc8ac9$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const groupSize = (0, $acw62.useContext)((0, $5d973a23e560af94$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $acw62.useMemo)(()=>$6b70efe984f9bc5b$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setInnerLoading] = (0, $acw62.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $acw62.useState)(false);
    const buttonRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = childNodes.length === 1 && !icon && !(0, $891d27b465b97c91$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $acw62.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setInnerLoading(true);
        }, loadingOrDelay.delay);
        else setInnerLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $acw62.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $891d27b465b97c91$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $acw62.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        props.onClick?.('href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeFullName = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctxSize)=>customizeSize ?? compactSize ?? groupSize ?? ctxSize);
    const iconType = innerLoading ? 'loading' : icon;
    const mergedIconPlacement = iconPlacement ?? iconPosition ?? 'start';
    const linkButtonRestProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        type: mergedType,
        color: mergedColor,
        variant: mergedVariant,
        danger: isDanger,
        shape: mergedShape,
        size: sizeFullName,
        disabled: mergedDisabled,
        loading: innerLoading,
        iconPlacement: mergedIconPlacement
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        _skipSemantic ? undefined : contextClassNames,
        classNames
    ], [
        _skipSemantic ? undefined : contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ========================= Render =========================
    const classes = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${mergedShape}`]: mergedShape !== 'default' && mergedShape !== 'square' && mergedShape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-lg`]: sizeFullName === 'large',
        [`${prefixCls}-sm`]: sizeFullName === 'small',
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $891d27b465b97c91$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: mergedIconPlacement === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName, mergedClassNames.root);
    const fullStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const iconSharedProps = {
        className: mergedClassNames.icon,
        style: mergedStyles.icon
    };
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            ...iconSharedProps
        }, child);
    const defaultLoadingIconElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfeeb2467aaa0581$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current,
        ...iconSharedProps
    });
    const mergedLoadingIcon = (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(loading) ? loading.icon || contextLoadingIcon : contextLoadingIcon;
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (loading && mergedLoadingIcon) iconNode = iconWrapperElement(mergedLoadingIcon);
    else iconNode = defaultLoadingIconElement;
    const contentNode = (0, $b956dab96d0e505b$export$826fff653a329e83)(children) ? (0, $891d27b465b97c91$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace, mergedStyles.content, mergedClassNames.content) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...linkButtonRestProps,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }, iconNode, contentNode);
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...rest,
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }, iconNode, contentNode, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3971683be64d7459$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $891d27b465b97c91$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return buttonNode;
});
const $6b70efe984f9bc5b$var$Button = $6b70efe984f9bc5b$var$InternalCompoundedButton;
$6b70efe984f9bc5b$var$Button.Group = (0, $5d973a23e560af94$export$2e2bcd8739ae039);
$6b70efe984f9bc5b$var$Button.__ANT_BUTTON = true;
var $6b70efe984f9bc5b$export$2e2bcd8739ae039 = $6b70efe984f9bc5b$var$Button;



"use client";
var $3929aafb948ac62c$export$2e2bcd8739ae039 = (0, $6b70efe984f9bc5b$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



function $cf0f554ddf4da10f$export$f5153c3888a6824e(size) {
    return [
        'small',
        'middle',
        'medium',
        'large'
    ].includes(size);
}
function $cf0f554ddf4da10f$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return (0, $b956dab96d0e505b$export$7e4aa119212bc614)(size);
}







var $acw62 = parcelRequire("acw62");


const $67f89d06f52454a6$var$_InputStatuses = [
    'warning',
    'error',
    '',
    'success',
    'validating'
];
const $67f89d06f52454a6$export$b08e7b47149942a2 = (prefixCls, status, hasFeedback)=>{
    return (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
};
const $67f89d06f52454a6$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;







const $6be38eadb6c17ec4$var$genSpaceAddonStyle = (token)=>{
    const { componentCls: componentCls, borderRadius: borderRadius, paddingSM: paddingSM, colorBorder: colorBorder, paddingXS: paddingXS, fontSizeLG: fontSizeLG, fontSizeSM: fontSizeSM, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, colorBgContainerDisabled: colorBgContainerDisabled, lineWidth: lineWidth, antCls: antCls } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'space');
    return {
        [componentCls]: [
            // ==========================================================
            // ==                         Base                         ==
            // ==========================================================
            {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0,
                whiteSpace: 'nowrap',
                paddingInline: paddingSM,
                margin: 0,
                borderWidth: lineWidth,
                borderStyle: 'solid',
                borderRadius: borderRadius,
                '&:hover': {
                    zIndex: 0
                },
                [`&${componentCls}-disabled`]: {
                    color: token.colorTextDisabled
                },
                '&-large': {
                    fontSize: fontSizeLG,
                    borderRadius: borderRadiusLG
                },
                '&-small': {
                    paddingInline: paddingXS,
                    borderRadius: borderRadiusSM,
                    fontSize: fontSizeSM
                },
                '&-compact-last-item': {
                    borderEndStartRadius: 0,
                    borderStartStartRadius: 0
                },
                '&-compact-first-item': {
                    borderEndEndRadius: 0,
                    borderStartEndRadius: 0
                },
                '&-compact-item:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                },
                '&-compact-item:not(:last-child)': {
                    borderInlineEndWidth: 0
                },
                '&-compact-item:not(:first-child)': {
                    borderInlineStartWidth: 0
                }
            },
            // ==========================================================
            // ==                       Variants                       ==
            // ==========================================================
            {
                [varName('addon-border-color')]: colorBorder,
                [varName('addon-background')]: colorBgContainerDisabled,
                // Filled
                [varName('addon-border-color-outlined')]: colorBorder,
                [varName('addon-background-filled')]: colorBgContainerDisabled,
                borderColor: varRef('addon-border-color'),
                background: varRef('addon-background'),
                // ======================= Outlined =======================
                '&-variant-outlined': {
                    [varName('addon-border-color')]: varRef('addon-border-color-outlined')
                },
                // ======================== Filled ========================
                '&-variant-filled': {
                    [varName('addon-border-color')]: 'transparent',
                    [varName('addon-background')]: varRef('addon-background-filled'),
                    // Disabled
                    [`&${componentCls}-disabled`]: {
                        [varName('addon-border-color')]: colorBorder,
                        [varName('addon-background')]: colorBgContainerDisabled
                    }
                },
                // ====================== Borderless ======================
                '&-variant-borderless': {
                    border: 'none',
                    background: 'transparent'
                },
                // ====================== Underlined ======================
                '&-variant-underlined': {
                    border: 'none',
                    background: 'transparent'
                }
            },
            // ==========================================================
            // ==                        Status                        ==
            // ==========================================================
            {
                '&-status-error': {
                    [varName('addon-border-color-outlined')]: token.colorError,
                    [varName('addon-background-filled')]: token.colorErrorBg,
                    color: token.colorError
                },
                '&-status-warning': {
                    [varName('addon-border-color-outlined')]: token.colorWarning,
                    [varName('addon-background-filled')]: token.colorWarningBg,
                    color: token.colorWarning
                }
            }
        ]
    };
};
var // ============================== Export ==============================
$6be38eadb6c17ec4$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Space',
    'Addon'
], (token)=>[
        $6be38eadb6c17ec4$var$genSpaceAddonStyle(token),
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(token, {
            focus: false
        })
    ]);


"use client";
const $643b81d74c4d73a2$var$SpaceAddon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { className: className, children: children, style: style, prefixCls: customizePrefixCls, variant: variant = 'outlined', disabled: disabled, status: status, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('space-addon', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $6be38eadb6c17ec4$export$2e2bcd8739ae039)(prefixCls);
    const { compactItemClassnames: compactItemClassnames, compactSize: compactSize } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, directionConfig);
    const statusCls = (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, status);
    const classes = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, hashId, compactItemClassnames, cssVarCls, `${prefixCls}-variant-${variant}`, statusCls, {
        [`${prefixCls}-${compactSize}`]: compactSize,
        [`${prefixCls}-disabled`]: disabled
    }, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: classes,
        style: style,
        ...restProps
    }, children);
});
var $643b81d74c4d73a2$export$2e2bcd8739ae039 = $643b81d74c4d73a2$var$SpaceAddon;




var $acw62 = parcelRequire("acw62");
const $68baed55ab318008$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    latestIndex: 0
});
const $68baed55ab318008$export$2bbf36e6e96e17f9 = $68baed55ab318008$export$853f607fd5cc208b.Provider;



var $acw62 = parcelRequire("acw62");



"use client";
const $a9129d7ad0e59df6$var$Item = (props)=>{
    const { className: className, prefix: prefix, index: index, children: children, separator: separator, style: style, classNames: classNames, styles: styles } = props;
    const { latestIndex: latestIndex } = $acw62.useContext((0, $68baed55ab318008$export$853f607fd5cc208b));
    if (!(0, $b956dab96d0e505b$export$826fff653a329e83)(children)) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && separator && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefix}-item-separator`, classNames?.separator),
        style: styles?.separator
    }, separator));
};
var $a9129d7ad0e59df6$export$2e2bcd8739ae039 = $a9129d7ad0e59df6$var$Item;



const $8c6cd68a6974f2d0$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $8c6cd68a6974f2d0$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-medium, &-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-medium, &-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $8c6cd68a6974f2d0$export$9ca1be8807fe0675 = ()=>({});
var $8c6cd68a6974f2d0$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Space', (token)=>{
    const spaceToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $8c6cd68a6974f2d0$var$genSpaceStyle(spaceToken),
        $8c6cd68a6974f2d0$var$genSpaceGapStyle(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $8f666b0c5cd58c95$var$InternalSpace = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('space');
    const { size: size = contextSize ?? 'small', align: align, className: className, rootClassName: rootClassName, children: children, direction: direction, orientation: orientation, prefixCls: customizePrefixCls, split: split, separator: separator, style: style, vertical: vertical, wrap: wrap = false, classNames: classNames, styles: styles, ...restProps } = props;
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $cf0f554ddf4da10f$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $cf0f554ddf4da10f$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const [mergedOrientation, mergedVertical] = (0, $1507d62a9a84d168$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedAlign = align === undefined && !mergedVertical ? 'center' : align;
    const mergedSeparator = separator ?? split;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $8c6cd68a6974f2d0$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: size,
        orientation: mergedOrientation,
        align: mergedAlign
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls, mergedClassNames.root);
    const itemClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-item`, mergedClassNames.item);
    // Calculate latest one
    const renderedItems = childNodes.map((child, i)=>{
        const key = child?.key || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $acw62.createElement((0, $a9129d7ad0e59df6$export$2e2bcd8739ae039), {
            prefix: prefixCls,
            classNames: mergedClassNames,
            styles: mergedStyles,
            className: itemClassName,
            key: key,
            index: i,
            separator: mergedSeparator,
            style: mergedStyles.item
        }, child);
    });
    var deprecatedName, newName;
    const memoizedSpaceContext = $acw62.useMemo(()=>{
        const calcLatestIndex = childNodes.reduce((latest, child, i)=>(0, $b956dab96d0e505b$export$826fff653a329e83)(child) ? i : latest, 0);
        return {
            latestIndex: calcLatestIndex
        };
    }, [
        childNodes
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        className: rootClassNames,
        style: {
            ...gapStyle,
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ $acw62.createElement((0, $68baed55ab318008$export$2bbf36e6e96e17f9), {
        value: memoizedSpaceContext
    }, renderedItems));
});
const $8f666b0c5cd58c95$var$Space = $8f666b0c5cd58c95$var$InternalSpace;
$8f666b0c5cd58c95$var$Space.Compact = (0, $26050ef76e24a749$export$2e2bcd8739ae039);
$8f666b0c5cd58c95$var$Space.Addon = (0, $643b81d74c4d73a2$export$2e2bcd8739ae039);
var $8f666b0c5cd58c95$export$2e2bcd8739ae039 = $8f666b0c5cd58c95$var$Space;







function $500d0ae39d0ead62$export$a157d95850191a12(token) {
    return (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $500d0ae39d0ead62$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
};




const $26df503c9b7ea2eb$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $26df503c9b7ea2eb$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorderDisabled,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': {
            ...$26df503c9b7ea2eb$export$bf820fba296f2fd8((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
                hoverBorderColor: token.colorBorderDisabled,
                hoverBg: token.colorBgContainerDisabled
            }))
        }
    });
const $26df503c9b7ea2eb$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$26df503c9b7ea2eb$export$8c569e4cc3fd115f(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $26df503c9b7ea2eb$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': {
            ...$26df503c9b7ea2eb$export$8c569e4cc3fd115f(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$26df503c9b7ea2eb$export$12789f962d420a93(token)
            },
            ...$26df503c9b7ea2eb$var$genOutlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...$26df503c9b7ea2eb$var$genOutlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $26df503c9b7ea2eb$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': {
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            },
            ...$26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle(token, {
                status: 'error',
                addonBorderColor: token.colorError,
                addonColor: token.colorErrorText
            }),
            ...$26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle(token, {
                status: 'warning',
                addonBorderColor: token.colorWarning,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: {
                    ...$26df503c9b7ea2eb$export$12789f962d420a93(token)
                }
            }
        }
    });
const $26df503c9b7ea2eb$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': {
            background: 'transparent',
            border: 'none',
            // Compensate for the removed border to maintain consistent height with other components
            // (e.g. Select borderless) that keep a transparent border.
            paddingBlock: token.calc(token.paddingBlock).add(token.lineWidth).equal(),
            [`&${componentCls}-sm, &${componentCls}-affix-wrapper-sm`]: {
                paddingBlock: token.calc(token.paddingBlockSM).add(token.lineWidth).equal()
            },
            [`&${componentCls}-lg, &${componentCls}-affix-wrapper-lg`]: {
                paddingBlock: token.calc(token.paddingBlockLG).add(token.lineWidth).equal()
            },
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            },
            ...extraStyles
        }
    };
};
/* ============== Filled ============== */ const $26df503c9b7ea2eb$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options?.inputColor ?? 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$26df503c9b7ea2eb$var$genBaseFilledStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }
    });
const $26df503c9b7ea2eb$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': {
            ...$26df503c9b7ea2eb$var$genBaseFilledStyle(token, {
                bg: token.colorFillTertiary,
                hoverBg: token.colorFillSecondary,
                activeBorderColor: token.activeBorderColor,
                inputColor: token.colorText
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$26df503c9b7ea2eb$export$12789f962d420a93(token)
            },
            ...$26df503c9b7ea2eb$var$genFilledStatusStyle(token, {
                status: 'error',
                bg: token.colorErrorBg,
                hoverBg: token.colorErrorBgHover,
                activeBorderColor: token.colorError,
                inputColor: token.colorErrorText,
                affixColor: token.colorError
            }),
            ...$26df503c9b7ea2eb$var$genFilledStatusStyle(token, {
                status: 'warning',
                bg: token.colorWarningBg,
                hoverBg: token.colorWarningBgHover,
                activeBorderColor: token.colorWarning,
                inputColor: token.colorWarningText,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const $26df503c9b7ea2eb$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $26df503c9b7ea2eb$export$542c0fce51b1d515 = (token)=>({
        '&-filled': {
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            },
            ...$26df503c9b7ea2eb$var$genFilledGroupStatusStyle(token, {
                status: 'error',
                addonBg: token.colorErrorBg,
                addonColor: token.colorErrorText
            }),
            ...$26df503c9b7ea2eb$var$genFilledGroupStatusStyle(token, {
                status: 'warning',
                addonBg: token.colorWarningBg,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        }
    });
const $26df503c9b7ea2eb$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.hoverBorderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$26df503c9b7ea2eb$export$7617a11352d704b9(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $26df503c9b7ea2eb$export$34771e60e0439351 = (token, extraStyles)=>({
        '&-underlined': {
            ...$26df503c9b7ea2eb$export$7617a11352d704b9(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            },
            ...$26df503c9b7ea2eb$var$genUnderlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...$26df503c9b7ea2eb$var$genUnderlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });


const $232788b5c0fca573$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $232788b5c0fca573$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $232788b5c0fca573$export$88e04420bb2dc003 = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $232788b5c0fca573$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $232788b5c0fca573$export$8c9a381315f3ebcd = (token, option = {})=>({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`,
        ...$232788b5c0fca573$export$92095d0f4c77bd56(token.colorTextPlaceholder),
        // Size
        '&-lg': {
            ...$232788b5c0fca573$export$88e04420bb2dc003(token),
            ...option.largeStyle
        },
        '&-sm': {
            ...$232788b5c0fca573$export$bb047f62c5a56f90(token),
            ...option.smallStyle
        },
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $232788b5c0fca573$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: {
            ...$232788b5c0fca573$export$88e04420bb2dc003(token)
        },
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: {
            ...$232788b5c0fca573$export$bb047f62c5a56f90(token)
        },
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        backgroundColor: 'inherit',
                        border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                        boxShadow: 'none'
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            },
            '&:not(:first-child)': {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: {
            display: 'block',
            ...(0, $4733a3b3eb18f80d$export$8c467e8859fdef13)(),
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                }
            }
        }
    };
};
const $232788b5c0fca573$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            ...$232788b5c0fca573$export$8c9a381315f3ebcd(token),
            // Variants
            ...(0, $26df503c9b7ea2eb$export$53795bafd774ce02)(token),
            ...(0, $26df503c9b7ea2eb$export$b8365cd7e6671d79)(token),
            ...(0, $26df503c9b7ea2eb$export$b6de5da7f39edfcb)(token),
            ...(0, $26df503c9b7ea2eb$export$34771e60e0439351)(token),
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        }
    };
};
const $232788b5c0fca573$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:focus-visible': {
                color: token.colorIcon,
                borderRadius: token.borderRadiusSM,
                ...(0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $232788b5c0fca573$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: {
            ...$232788b5c0fca573$export$8c9a381315f3ebcd(token),
            display: 'inline-flex',
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            },
            ...$232788b5c0fca573$var$genAllowClearStyle(token),
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        },
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $232788b5c0fca573$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: {
            // Style for input-group: input with label, with button or dropdown...
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            ...$232788b5c0fca573$export$ffe8b2a9bd2e5cfe(token),
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': {
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design/issues/6403
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Variants
                ...(0, $26df503c9b7ea2eb$export$8f88f32c046ff727)(token),
                ...(0, $26df503c9b7ea2eb$export$542c0fce51b1d515)(token),
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $232788b5c0fca573$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $232788b5c0fca573$export$de732caeaad5f68e = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $232788b5c0fca573$export$9a752c3888370836(inputToken),
        $232788b5c0fca573$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});
var $232788b5c0fca573$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $232788b5c0fca573$var$genGroupStyle(inputToken),
        $232788b5c0fca573$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(inputToken, {
            focus: true,
            focusElCls: `${inputToken.componentCls}-affix-wrapper-focused`
        })
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
/** @deprecated Please use `Space.Compact` */ const $ae15c91e7f32cbed$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [hashId, cssVarCls] = (0, $232788b5c0fca573$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $acw62.useMemo)(()=>({
            ...formItemContext,
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, /*#__PURE__*/ $acw62.createElement((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039).Compact, {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, props.children));
};
var $ae15c91e7f32cbed$export$2e2bcd8739ae039 = $ae15c91e7f32cbed$var$Group;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $df2a3a3963b787b8$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $df2a3a3963b787b8$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $df2a3a3963b787b8$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    const currentTarget = target.cloneNode(true);
    // click clear icon
    const newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = (...args)=>{
        target.setSelectionRange(...args);
    };
    return newEvent;
}
function $df2a3a3963b787b8$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    let event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $df2a3a3963b787b8$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $df2a3a3963b787b8$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}


function $7a97490f531fc7f3$var$_extends() {
    $7a97490f531fc7f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a97490f531fc7f3$var$_extends.apply(this, arguments);
}
const $7a97490f531fc7f3$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { inputElement: inputEl, children: children, prefixCls: prefixCls, prefix: prefix, suffix: suffix, addonBefore: addonBefore, addonAfter: addonAfter, className: className, style: style, disabled: disabled, readOnly: readOnly, focused: focused, triggerFocus: triggerFocus, allowClear: allowClear, value: value, handleReset: handleReset, hidden: hidden, classes: classes, classNames: classNames, dataAttrs: dataAttrs, styles: styles, components: components, onClear: onClear } = props;
    const inputElement = children ?? inputEl;
    const AffixWrapperComponent = components?.affixWrapper || 'span';
    const GroupWrapperComponent = components?.groupWrapper || 'span';
    const WrapperComponent = components?.wrapper || 'span';
    const GroupAddonComponent = components?.groupAddon || 'span';
    const containerRef = (0, $acw62.useRef)(null);
    const onInputClick = (e)=>{
        if (containerRef.current?.contains(e.target)) triggerFocus?.();
    };
    const hasAffix = (0, $df2a3a3963b787b8$export$a19010aeeaa0c7a)(props);
    let element = /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
        value: value,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(inputElement.props?.className, !hasAffix && classNames?.variant) || null
    });
    // ======================== Ref ======================== //
    const groupRef = (0, $acw62.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            nativeElement: groupRef.current || containerRef.current
        }));
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && value;
            const clearIconCls = `${prefixCls}-clear-icon`;
            const iconNode = typeof allowClear === 'object' && allowClear?.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                tabIndex: -1,
                onClick: (event)=>{
                    handleReset?.(event);
                    onClear?.();
                },
                onMouseDown: (e)=>e.preventDefault(),
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix
                })
            }, iconNode);
        }
        const affixWrapperPrefixCls = `${prefixCls}-affix-wrapper`;
        const affixWrapperCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(affixWrapperPrefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [`${affixWrapperPrefixCls}-disabled`]: disabled,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-focused`]: focused,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-readonly`]: readOnly,
            [`${affixWrapperPrefixCls}-input-with-clear-btn`]: suffix && allowClear && value
        }, classes?.affixWrapper, classNames?.affixWrapper, classNames?.variant);
        const suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
            style: styles?.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AffixWrapperComponent, $7a97490f531fc7f3$var$_extends({
            className: affixWrapperCls,
            style: styles?.affixWrapper,
            onClick: onInputClick
        }, dataAttrs?.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
            style: styles?.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $df2a3a3963b787b8$export$ae6255aa850a31d1)(props)) {
        const wrapperCls = `${prefixCls}-group`;
        const addonCls = `${wrapperCls}-addon`;
        const groupWrapperCls = `${wrapperCls}-wrapper`;
        const mergedWrapperClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, wrapperCls, classes?.wrapper, classNames?.wrapper);
        const mergedGroupClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(groupWrapperCls, {
            [`${groupWrapperCls}-disabled`]: disabled
        }, classes?.group, classNames?.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(element.props?.className, className) || null,
        style: {
            ...element.props?.style,
            ...style
        },
        hidden: hidden
    });
});
var $7a97490f531fc7f3$export$2e2bcd8739ae039 = $7a97490f531fc7f3$var$BaseInput;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $cf3f8acce514b63d$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    const count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $cf3f8acce514b63d$export$2e2bcd8739ae039(count, showCount) {
    return $acw62.useMemo(()=>{
        let mergedConfig = {};
        if (showCount) mergedConfig.show = typeof showCount === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = {
            ...mergedConfig,
            ...count
        };
        const { show: show, ...rest } = mergedConfig;
        return {
            ...rest,
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || ((value)=>value.length)
        };
    }, [
        count,
        showCount
    ]);
}




function $68b424d199ec5420$var$_extends() {
    $68b424d199ec5420$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68b424d199ec5420$var$_extends.apply(this, arguments);
}
const $68b424d199ec5420$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { autoComplete: autoComplete, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onPressEnter: onPressEnter, onKeyDown: onKeyDown, onKeyUp: onKeyUp, prefixCls: prefixCls = 'rc-input', disabled: disabled, htmlSize: htmlSize, className: className, maxLength: maxLength, suffix: suffix, showCount: showCount, count: count, type: type = 'text', classes: classes, classNames: classNames, styles: styles, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest } = props;
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const compositionRef = (0, $acw62.useRef)(false);
    const keyLockRef = (0, $acw62.useRef)(false);
    const inputRef = (0, $acw62.useRef)(null);
    const holderRef = (0, $acw62.useRef)(null);
    const focus = (option)=>{
        if (inputRef.current) (0, $09560f6ea64963fd$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    const [value, setValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(props.defaultValue, props.value);
    const formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    const [selection, setSelection] = (0, $acw62.useState)(null);
    // ====================== Count =======================
    const countConfig = (0, $cf3f8acce514b63d$export$2e2bcd8739ae039)(count, showCount);
    const mergedMax = countConfig.max || maxLength;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: focus,
            blur: ()=>{
                inputRef.current?.blur();
            },
            setSelectionRange: (start, end, direction)=>{
                inputRef.current?.setSelectionRange(start, end, direction);
            },
            select: ()=>{
                inputRef.current?.select();
            },
            input: inputRef.current,
            nativeElement: holderRef.current?.nativeElement || inputRef.current
        }));
    (0, $acw62.useEffect)(()=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused((prev)=>prev && disabled ? false : prev);
    }, [
        disabled
    ]);
    const triggerChange = (e, currentValue, info)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                inputRef.current?.selectionStart || 0,
                inputRef.current?.selectionEnd || 0
            ]);
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $df2a3a3963b787b8$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    (0, $acw62.useEffect)(()=>{
        if (selection) inputRef.current?.setSelectionRange(...selection);
    }, [
        selection
    ]);
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd?.(e);
    };
    const handleKeyDown = (e)=>{
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current && !e.nativeEvent.isComposing) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur?.(e);
    };
    const handleReset = (e)=>{
        setValue('');
        focus();
        if (inputRef.current) (0, $df2a3a3963b787b8$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    const outOfRangeCls = isOutOfRange && `${prefixCls}-out-of-range`;
    const getInputElement = ()=>{
        // Fix https://fb.me/react-unknown-prop
        const otherProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $68b424d199ec5420$var$_extends({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, {
                [`${prefixCls}-disabled`]: disabled
            }, classNames?.input),
            style: styles?.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: (e)=>{
                compositionRef.current = true;
                onCompositionStart?.(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    const getSuffix = ()=>{
        // Max length value
        const hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            const dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-show-count-suffix`, {
                    [`${prefixCls}-show-count-has-suffix`]: !!suffix
                }, classNames?.count),
                style: {
                    ...styles?.count
                }
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a97490f531fc7f3$export$2e2bcd8739ae039), $68b424d199ec5420$var$_extends({}, rest, {
        prefixCls: prefixCls,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $68b424d199ec5420$export$2e2bcd8739ae039 = $68b424d199ec5420$var$Input;


var $01e5e3e577ce5432$export$2e2bcd8739ae039 = (0, $68b424d199ec5420$export$2e2bcd8739ae039);







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0c349e8b6d22460f$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $0c349e8b6d22460f$export$2e2bcd8739ae039 = $0c349e8b6d22460f$var$CloseCircleFilled;



function $81ff9dc68eb84eda$var$_extends() {
    $81ff9dc68eb84eda$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $81ff9dc68eb84eda$var$_extends.apply(this, arguments);
}
const $81ff9dc68eb84eda$var$CloseCircleFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $81ff9dc68eb84eda$var$_extends({}, props, {
        ref: ref,
        icon: (0, $0c349e8b6d22460f$export$2e2bcd8739ae039)
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ const $81ff9dc68eb84eda$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($81ff9dc68eb84eda$var$CloseCircleFilled);
var $81ff9dc68eb84eda$export$2e2bcd8739ae039 = $81ff9dc68eb84eda$var$RefIcon;



"use client";
const $f9fe093fa4df8f6d$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(allowClear) && allowClear?.clearIcon) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null)
    };
    return mergedAllowClear;
};
var $f9fe093fa4df8f6d$export$2e2bcd8739ae039 = $f9fe093fa4df8f6d$var$getAllowClear;











var $acw62 = parcelRequire("acw62");


/**
 * Compatible for legacy `bordered` prop.
 */ const $ce4103032ab2fd5e$var$useVariant = (component, variant, legacyBordered)=>{
    const { variant: configVariant, [component]: componentConfig } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const ctxVariant = $acw62.useContext((0, $ad5d550b51ac8abd$export$6f0555dad42725fb));
    const configComponentVariant = componentConfig?.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = ctxVariant ?? configComponentVariant ?? configVariant ?? 'outlined';
    const enableVariantCls = (0, $a18b2f6f56546238$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $ce4103032ab2fd5e$export$2e2bcd8739ae039 = $ce4103032ab2fd5e$var$useVariant;




var $acw62 = parcelRequire("acw62");
function $e424ea760f35b51a$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $acw62.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            if (inputRef.current?.input && inputRef.current?.input.getAttribute('type') === 'password' && inputRef.current?.input.hasAttribute('value')) inputRef.current?.input.removeAttribute('value');
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}



function $23144ccd376634c7$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
const $538df197b854e6d1$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classNames, variant: customVariant, ...rest } = props;
    var prop, newProp;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $acw62.useRef)(null);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $232788b5c0fca573$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $232788b5c0fca573$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $23144ccd376634c7$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffixRef = (0, $acw62.useRef)(inputHasPrefixSuffix);
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur?.(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus?.(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange?.(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $f9fe093fa4df8f6d$export$2e2bcd8739ae039)(allowClear ?? contextAllowClear);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)('input', customVariant, bordered);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01e5e3e577ce5432$export$2e2bcd8739ae039), {
        ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete,
        ...rest,
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName, mergedClassNames.root),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            ...mergedClassNames,
            input: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, mergedClassNames.input, hashId),
            variant: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    });
});
var $538df197b854e6d1$export$2e2bcd8739ae039 = $538df197b854e6d1$var$Input;




var $acw62 = parcelRequire("acw62");











// =============================== OTP ================================
const $342237063413aff3$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: token.colorText,
                    '&::selection': {
                        color: 'transparent'
                    }
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$342237063413aff3$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return $342237063413aff3$var$genOTPStyle(inputToken);
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781));



var $acw62 = parcelRequire("acw62");




"use client";
const $f02194bc3f3a92de$var$OTPInput = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask, onFocus: onFocus, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : value;
    // ========================== Ref ===========================
    const inputRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            const inputEle = inputRef.current?.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e);
        syncSelection();
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        else if (key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), {
        "aria-label": `OTP Input ${index + 1}`,
        type: mask === true ? 'password' : 'text',
        ...restProps,
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: onInternalFocus,
        onKeyDown: onInternalKeyDown,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    }));
});
var $f02194bc3f3a92de$export$2e2bcd8739ae039 = $f02194bc3f3a92de$var$OTPInput;


"use client";
function $a41c5ef9ac79dcae$var$strToArr(str) {
    return (str || '').split('');
}
const $a41c5ef9ac79dcae$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator, className: semanticClassName, style: semanticStyle } = props;
    const separatorNode = typeof separator === 'function' ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-separator`, semanticClassName),
        style: semanticStyle
    }, separatorNode);
};
const $a41c5ef9ac79dcae$var$OTP = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, autoComplete: autoComplete, onInput: onInput, onFocus: onFocus, inputMode: inputMode, classNames: classNames, styles: styles, className: className, style: style, ...restProps } = props;
    const { classNames: contextClassNames, styles: contextStyles, getPrefixCls: getPrefixCls, direction: direction, style: contextStyle, className: contextClassName } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('otp');
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const mergedProps = {
        ...props,
        length: length
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const domAttrs = (0, $613e269121c63c71$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [hashId, cssVarCls] = (0, $342237063413aff3$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    // ======================== Status ========================
    const formContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $acw62.useMemo(()=>({
            ...formContext,
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $acw62.useRef(null);
    const inputsRef = $acw62.useRef({});
    $acw62.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                inputsRef.current[0]?.focus();
            },
            blur: ()=>{
                for(let i = 0; i < length; i += 1)inputsRef.current[i]?.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $acw62.useState(()=>$a41c5ef9ac79dcae$var$strToArr(internalFormatter(defaultValue || '')));
    $acw62.useEffect(()=>{
        if (value !== undefined) setValueCells($a41c5ef9ac79dcae$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($a41c5ef9ac79dcae$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $a41c5ef9ac79dcae$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) inputsRef.current[nextIndex]?.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        inputsRef.current[nextIndex]?.focus();
    };
    // ======================== Focus ========================
    const onInputFocus = (event, index)=>{
        // keep focus on the first empty cell
        for(let i = 0; i < index; i += 1)if (!inputsRef.current[i]?.input?.value) {
            inputsRef.current[i]?.focus();
            break;
        }
        onFocus?.(event);
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode,
        autoComplete: autoComplete
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        ...domAttrs,
        ref: containerRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId, contextClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        role: "group"
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: key
        }, /*#__PURE__*/ $acw62.createElement((0, $f02194bc3f3a92de$export$2e2bcd8739ae039), {
            ref: (inputEle)=>{
                inputsRef.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.input, `${prefixCls}-input`),
            style: mergedStyles.input,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus,
            onFocus: (event)=>onInputFocus(event, index),
            ...inputSharedProps
        }), index < length - 1 && /*#__PURE__*/ $acw62.createElement($a41c5ef9ac79dcae$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.separator),
            style: mergedStyles.separator
        }));
    })));
});
var $a41c5ef9ac79dcae$export$2e2bcd8739ae039 = $a41c5ef9ac79dcae$var$OTP;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $70c4e92fea0b3f8a$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $70c4e92fea0b3f8a$export$2e2bcd8739ae039 = $70c4e92fea0b3f8a$var$EyeInvisibleOutlined;



function $48f4fe50ff6ca9c8$var$_extends() {
    $48f4fe50ff6ca9c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f4fe50ff6ca9c8$var$_extends.apply(this, arguments);
}
const $48f4fe50ff6ca9c8$var$EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $48f4fe50ff6ca9c8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $70c4e92fea0b3f8a$export$2e2bcd8739ae039)
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const $48f4fe50ff6ca9c8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($48f4fe50ff6ca9c8$var$EyeInvisibleOutlined);
var $48f4fe50ff6ca9c8$export$2e2bcd8739ae039 = $48f4fe50ff6ca9c8$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b7bc758130af6b02$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $b7bc758130af6b02$export$2e2bcd8739ae039 = $b7bc758130af6b02$var$EyeOutlined;



function $d8a9efd7a074f5f5$var$_extends() {
    $d8a9efd7a074f5f5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8a9efd7a074f5f5$var$_extends.apply(this, arguments);
}
const $d8a9efd7a074f5f5$var$EyeOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $d8a9efd7a074f5f5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b7bc758130af6b02$export$2e2bcd8739ae039)
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const $d8a9efd7a074f5f5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8a9efd7a074f5f5$var$EyeOutlined);
var $d8a9efd7a074f5f5$export$2e2bcd8739ae039 = $d8a9efd7a074f5f5$var$RefIcon;










"use client";
const $27b11b4fcd97a00b$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $acw62.createElement((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), null);
const $27b11b4fcd97a00b$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $27b11b4fcd97a00b$var$Password = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender = $27b11b4fcd97a00b$var$defaultIconRender, suffix: suffix } = props;
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const visibilityControlled = (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(visibilityToggle) && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $acw62.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $acw62.useRef)(null);
    $acw62.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(visibilityToggle)) visibilityToggle.onVisibleChange?.(nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $27b11b4fcd97a00b$var$actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $acw62.cloneElement(/*#__PURE__*/ $acw62.isValidElement(icon) ? icon : /*#__PURE__*/ $acw62.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = {
        ...(0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ]),
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, suffixIcon, suffix)
    };
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), {
        ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(ref, inputRef),
        ...omittedProps
    });
});
var $27b11b4fcd97a00b$export$2e2bcd8739ae039 = $27b11b4fcd97a00b$var$Password;



var $acw62 = parcelRequire("acw62");













const $49ebef65d1ecf677$var$genSearchStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const btnCls = `${componentCls}-btn`;
    return {
        [componentCls]: {
            width: '100%',
            // =========================== Button ===========================
            [btnCls]: {
                '&-filled': {
                    background: token.colorFillTertiary,
                    '&:not(:disabled)': {
                        '&:hover': {
                            background: token.colorFillSecondary
                        },
                        '&:active': {
                            background: token.colorFill
                        }
                    }
                }
            }
        }
    };
};
var $49ebef65d1ecf677$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'Search'
], $49ebef65d1ecf677$var$genSearchStyle);


"use client";
const $22717f99dfeb0b1a$var$Search = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, style: style, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: variant, onPressEnter: customOnPressEnter, classNames: classNames, styles: styles, hidden: hidden, ...restProps } = props;
    const { direction: direction, getPrefixCls: getPrefixCls, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('inputSearch');
    const mergedProps = {
        ...props,
        enterButton: enterButton
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        button: {
            _default: 'root'
        }
    });
    const composedRef = $acw62.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const [hashId, cssVarCls] = (0, $49ebef65d1ecf677$export$2e2bcd8739ae039)(prefixCls);
    const { compactSize: compactSize } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const inputRef = $acw62.useRef(null);
    const onChange = (e)=>{
        if (e?.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange?.(e);
    };
    const onMouseDown = (e)=>{
        if (document.activeElement === inputRef.current?.input) e.preventDefault();
    };
    const onSearch = (e)=>{
        if (customOnSearch) customOnSearch(inputRef.current?.input?.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter?.(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), null) : null;
    const btnPrefixCls = `${prefixCls}-btn`;
    const btnClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(btnPrefixCls, {
        [`${btnPrefixCls}-${variant}`]: variant
    });
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $30796c32f374b477$export$e530037191fcd5d7)(enterButtonAsElement, {
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            enterButtonAsElement?.props?.onClick?.(e);
            onSearch(e);
        },
        key: 'enterButton',
        ...isAntdButton ? {
            className: btnClassName,
            size: size
        } : {}
    });
    else button = /*#__PURE__*/ $acw62.createElement((0, $6b70efe984f9bc5b$export$2e2bcd8739ae039), {
        classNames: mergedClassNames.button,
        styles: mergedStyles.button,
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $30796c32f374b477$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const mergedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className, hashId, mergedClassNames.root);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart?.(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd?.(e);
    };
    // ========================== Render ==========================
    // >>> Root Props
    const rootProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(restProps, {
        data: true
    });
    const inputProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)({
        ...restProps,
        classNames: (0, $cdfb578fac308710$export$2e2bcd8739ae039)(mergedClassNames, [
            'button',
            'root'
        ]),
        styles: (0, $cdfb578fac308710$export$2e2bcd8739ae039)(mergedStyles, [
            'button',
            'root'
        ]),
        prefixCls: inputPrefixCls,
        type: 'search',
        size: size,
        variant: variant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        onChange: onChange,
        disabled: disabled
    }, Object.keys(rootProps));
    return /*#__PURE__*/ $acw62.createElement((0, $26050ef76e24a749$export$2e2bcd8739ae039), {
        className: mergedClassName,
        style: {
            ...style,
            ...mergedStyles.root
        },
        ...rootProps,
        hidden: hidden
    }, /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), {
        ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(inputRef, ref),
        ...inputProps
    }), button);
});
var $22717f99dfeb0b1a$export$2e2bcd8739ae039 = $22717f99dfeb0b1a$var$Search;



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ const $fa431633ee236242$var$HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;
const $fa431633ee236242$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
const $fa431633ee236242$var$computedStyleCache = {};
let $fa431633ee236242$var$hiddenTextarea;
function $fa431633ee236242$export$1a56dc6a39385a18(node, useCache = false) {
    const nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $fa431633ee236242$var$computedStyleCache[nodeRef]) return $fa431633ee236242$var$computedStyleCache[nodeRef];
    const style = window.getComputedStyle(node);
    const boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    const paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    const borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    const sizingStyle = $fa431633ee236242$var$SIZING_STYLE.map((name)=>`${name}:${style.getPropertyValue(name)}`).join(';');
    const nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $fa431633ee236242$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $fa431633ee236242$export$2e2bcd8739ae039(uiTextNode, useCache = false, minRows = null, maxRows = null) {
    if (!$fa431633ee236242$var$hiddenTextarea) {
        $fa431633ee236242$var$hiddenTextarea = document.createElement('textarea');
        $fa431633ee236242$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $fa431633ee236242$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $fa431633ee236242$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($fa431633ee236242$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $fa431633ee236242$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $fa431633ee236242$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    const { paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing, sizingStyle: sizingStyle } = $fa431633ee236242$export$1a56dc6a39385a18(uiTextNode, useCache);
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $fa431633ee236242$var$hiddenTextarea.setAttribute('style', `${sizingStyle};${$fa431633ee236242$var$HIDDEN_TEXTAREA_STYLE}`);
    $fa431633ee236242$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    let minHeight = undefined;
    let maxHeight = undefined;
    let overflowY;
    let height = $fa431633ee236242$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $fa431633ee236242$var$hiddenTextarea.value = ' ';
        const singleRowHeight = $fa431633ee236242$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    const style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


function $d3d857b5ddd3947b$var$_extends() {
    $d3d857b5ddd3947b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3d857b5ddd3947b$var$_extends.apply(this, arguments);
}
const $d3d857b5ddd3947b$var$RESIZE_START = 0;
const $d3d857b5ddd3947b$var$RESIZE_MEASURING = 1;
const $d3d857b5ddd3947b$var$RESIZE_STABLE = 2;
const $d3d857b5ddd3947b$var$ResizableTextArea = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, defaultValue: defaultValue, value: value, autoSize: autoSize, onResize: onResize, className: className, style: style, disabled: disabled, onChange: onChange, onInternalAutoSize: // Test only
    onInternalAutoSize, ...restProps } = props;
    // =============================== Value ================================
    const [internalValue, setMergedValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = internalValue ?? '';
    const onInternalChange = (event)=>{
        setMergedValue(event.target.value);
        onChange?.(event);
    };
    // ================================ Ref =================================
    const textareaRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, ()=>({
            textArea: textareaRef.current
        }));
    // ============================== AutoSize ==============================
    const [minRows, maxRows] = $acw62.useMemo(()=>{
        if (autoSize && typeof autoSize === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]);
    const needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    const [resizeState, setResizeState] = $acw62.useState($d3d857b5ddd3947b$var$RESIZE_STABLE);
    const [autoSizeStyle, setAutoSizeStyle] = $acw62.useState();
    const startResize = ()=>{
        setResizeState($d3d857b5ddd3947b$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (resizeState === $d3d857b5ddd3947b$var$RESIZE_START) setResizeState($d3d857b5ddd3947b$var$RESIZE_MEASURING);
        else if (resizeState === $d3d857b5ddd3947b$var$RESIZE_MEASURING) {
            const textareaStyles = (0, $fa431633ee236242$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($d3d857b5ddd3947b$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    const resizeRafRef = $acw62.useRef();
    const cleanRaf = ()=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    const onInternalResize = (size)=>{
        if (resizeState === $d3d857b5ddd3947b$var$RESIZE_STABLE) {
            onResize?.(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                    startResize();
                });
            }
        }
    };
    $acw62.useEffect(()=>cleanRaf, []);
    // =============================== Render ===============================
    const mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    const mergedStyle = {
        ...style,
        ...mergedAutoSizeStyle
    };
    if (resizeState === $d3d857b5ddd3947b$var$RESIZE_START || resizeState === $d3d857b5ddd3947b$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $acw62.createElement("textarea", $d3d857b5ddd3947b$var$_extends({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled
        }),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $d3d857b5ddd3947b$export$2e2bcd8739ae039 = $d3d857b5ddd3947b$var$ResizableTextArea;


function $83fdb4305db3ac74$var$_extends() {
    $83fdb4305db3ac74$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $83fdb4305db3ac74$var$_extends.apply(this, arguments);
}
const $83fdb4305db3ac74$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ defaultValue: defaultValue, value: customValue, onFocus: onFocus, onBlur: onBlur, onChange: onChange, allowClear: allowClear, maxLength: maxLength, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, suffix: suffix, prefixCls: prefixCls = 'rc-textarea', showCount: showCount, count: count, className: className, style: style, disabled: disabled, hidden: hidden, classNames: classNames, styles: styles, onResize: onResize, onClear: onClear, onPressEnter: onPressEnter, readOnly: readOnly, autoSize: autoSize, onKeyDown: onKeyDown, ...rest }, ref)=>{
    const [value, setValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultValue, customValue);
    const formatValue = value === undefined || value === null ? '' : String(value);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const [textareaResized, setTextareaResized] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // =============================== Ref ================================
    const holderRef = (0, $acw62.useRef)(null);
    const resizableTextAreaRef = (0, $acw62.useRef)(null);
    const getTextArea = ()=>resizableTextAreaRef.current?.textArea;
    const focus = ()=>{
        getTextArea().focus();
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: ()=>{
                getTextArea().blur();
            },
            nativeElement: holderRef.current?.nativeElement || getTextArea()
        }));
    (0, $acw62.useEffect)(()=>{
        setFocused((prev)=>!disabled && prev);
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    const [selection, setSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (selection) getTextArea().setSelectionRange(...selection);
    }, [
        selection
    ]);
    // ============================== Count ===============================
    const countConfig = (0, $cf3f8acce514b63d$export$2e2bcd8739ae039)(count, showCount);
    const mergedMax = countConfig.max ?? maxLength;
    // Max length value
    const hasMaxLength = Number(mergedMax) > 0;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    const triggerChange = (e, currentValue)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $df2a3a3963b787b8$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    const onInternalCompositionStart = (e)=>{
        compositionRef.current = true;
        onCompositionStart?.(e);
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd?.(e);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && onPressEnter && !e.nativeEvent.isComposing) onPressEnter(e);
        onKeyDown?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        setFocused(false);
        onBlur?.(e);
    };
    // ============================== Reset ===============================
    const handleReset = (e)=>{
        setValue('');
        focus();
        (0, $df2a3a3963b787b8$export$c28984794956ddc0)(getTextArea(), e, onChange);
    };
    let suffixNode = suffix;
    let dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-data-count`, classNames?.count),
            style: styles?.count
        }, dataCount));
    }
    const handleResize = (size)=>{
        onResize?.(size);
        if (getTextArea()?.style.height) setTextareaResized(true);
    };
    const isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a97490f531fc7f3$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: {
            ...classNames,
            affixWrapper: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(classNames?.affixWrapper, {
                [`${prefixCls}-show-count`]: showCount,
                [`${prefixCls}-textarea-allow-clear`]: allowClear
            })
        },
        disabled: disabled,
        focused: focused,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, isOutOfRange && `${prefixCls}-out-of-range`),
        style: {
            ...style,
            ...textareaResized && !isPureTextArea ? {
                height: 'auto'
            } : {}
        },
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3d857b5ddd3947b$export$2e2bcd8739ae039), $83fdb4305db3ac74$var$_extends({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(classNames?.textarea),
        style: {
            resize: style?.resize,
            ...styles?.textarea
        },
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $83fdb4305db3ac74$export$2e2bcd8739ae039 = $83fdb4305db3ac74$var$TextArea;



var $b743f272edcef2c2$export$2e2bcd8739ae039 = (0, $83fdb4305db3ac74$export$2e2bcd8739ae039);


















const $7d6cde41567351b1$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$7d6cde41567351b1$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return $7d6cde41567351b1$var$genTextAreaStyle(inputToken);
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
const $fc29eec8796e8593$var$TextArea = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classNames, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('textArea');
    // =================== Disabled ===================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    // ===================== Ref ======================
    const innerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>({
            resizableTextArea: innerRef.current?.resizableTextArea,
            focus: (option)=>{
                (0, $09560f6ea64963fd$export$2b92016deb0b7aad)(innerRef.current?.resizableTextArea?.textArea, option);
            },
            blur: ()=>innerRef.current?.blur(),
            nativeElement: innerRef.current?.nativeElement || null
        }));
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $232788b5c0fca573$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $7d6cde41567351b1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $f9fe093fa4df8f6d$export$2e2bcd8739ae039)(allowClear ?? contextAllowClear);
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $acw62.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $acw62.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown?.(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        onResize?.(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && typeof getComputedStyle === 'function') {
            const ele = innerRef.current?.nativeElement?.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return /*#__PURE__*/ $acw62.createElement((0, $b743f272edcef2c2$export$2e2bcd8739ae039), {
        autoComplete: contextAutoComplete,
        ...rest,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, mergedClassNames.root, // Only for wrapper
        {
            [`${prefixCls}-textarea-affix-wrapper-resize-dirty`]: resizeDirty
        }),
        classNames: {
            ...mergedClassNames,
            textarea: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, mergedClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || props.count?.show
            }, hashId)
        },
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    });
});
var $fc29eec8796e8593$export$2e2bcd8739ae039 = $fc29eec8796e8593$var$TextArea;


"use client";
const $ad70426818bb52aa$var$Input = (0, $538df197b854e6d1$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Group = (0, $ae15c91e7f32cbed$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Search = (0, $22717f99dfeb0b1a$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.TextArea = (0, $fc29eec8796e8593$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Password = (0, $27b11b4fcd97a00b$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.OTP = (0, $a41c5ef9ac79dcae$export$2e2bcd8739ae039);
var $ad70426818bb52aa$export$2e2bcd8739ae039 = $ad70426818bb52aa$var$Input;


var $acw62 = parcelRequire("acw62");
const $3b2a2eb42115b4e5$export$e1053575ddfcb301 = {};
const $3b2a2eb42115b4e5$export$91b75cf262680225 = 'rc-table-internal-hook';






var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $2b6e94889042e439$export$fd42f52fd3ae1109(defaultValue) {
    const Context = /*#__PURE__*/ $acw62.createContext(undefined);
    const Provider = ({ value: value, children: children })=>{
        const valueRef = $acw62.useRef(value);
        valueRef.current = value;
        const [context] = $acw62.useState(()=>({
                getValue: ()=>valueRef.current,
                listeners: new Set()
            }));
        (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
            (0, $1u0KT.unstable_batchedUpdates)(()=>{
                context.listeners.forEach((listener)=>{
                    listener(value);
                });
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider,
        defaultValue: defaultValue
    };
}
function $2b6e94889042e439$export$fae74005e78b1a27(holder, selector) {
    const eventSelector = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(typeof selector === 'function' ? selector : (ctx)=>{
        if (selector === undefined) return ctx;
        if (!Array.isArray(selector)) return ctx[selector];
        const obj = {};
        selector.forEach((key)=>{
            obj[key] = ctx[key];
        });
        return obj;
    });
    const context = $acw62.useContext(holder?.Context);
    const { listeners: listeners, getValue: getValue } = context || {};
    const valueRef = $acw62.useRef();
    valueRef.current = eventSelector(context ? getValue() : holder?.defaultValue);
    const [, forceUpdate] = $acw62.useState({});
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (!context) return;
        function trigger(nextValue) {
            const nextSelectorValue = eventSelector(nextValue);
            if (!(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(valueRef.current, nextSelectorValue, true)) forceUpdate({});
        }
        listeners.add(trigger);
        return ()=>{
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return valueRef.current;
}




var $acw62 = parcelRequire("acw62");
function $a6c6008fe53487e1$var$_extends() {
    $a6c6008fe53487e1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a6c6008fe53487e1$var$_extends.apply(this, arguments);
}
function $a6c6008fe53487e1$export$2e2bcd8739ae039() {
    const ImmutableContext = /*#__PURE__*/ $acw62.createContext(null);
    /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */ function useImmutableMark() {
        return $acw62.useContext(ImmutableContext);
    }
    /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */ function makeImmutable(Component, shouldTriggerRender) {
        const refAble = (0, $6c628207f5089a39$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            const renderTimesRef = $acw62.useRef(0);
            const prevProps = $acw62.useRef(props);
            // If parent has the context, we do not wrap it
            const mark = useImmutableMark();
            if (mark !== null) return /*#__PURE__*/ $acw62.createElement(Component, $a6c6008fe53487e1$var$_extends({}, props, refProps));
            if (// Always trigger re-render if `shouldTriggerRender` is not provided
            !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) renderTimesRef.current += 1;
            prevProps.current = props;
            return /*#__PURE__*/ $acw62.createElement(ImmutableContext.Provider, {
                value: renderTimesRef.current
            }, /*#__PURE__*/ $acw62.createElement(Component, $a6c6008fe53487e1$var$_extends({}, props, refProps)));
        };
        return refAble ? /*#__PURE__*/ $acw62.forwardRef(ImmutableComponent) : ImmutableComponent;
    }
    /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */ function responseImmutable(Component, propsAreEqual) {
        const refAble = (0, $6c628207f5089a39$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            useImmutableMark();
            return /*#__PURE__*/ $acw62.createElement(Component, $a6c6008fe53487e1$var$_extends({}, props, refProps));
        };
        return /*#__PURE__*/ $acw62.memo(refAble ? /*#__PURE__*/ $acw62.forwardRef(ImmutableComponent) : ImmutableComponent, propsAreEqual);
    }
    return {
        makeImmutable: makeImmutable,
        responseImmutable: responseImmutable,
        useImmutableMark: useImmutableMark
    };
}


// For legacy usage, we export it directly
const { makeImmutable: $ecc5eb53c8c5a4f3$export$ffd6d5bef5eaf0a4, responseImmutable: $ecc5eb53c8c5a4f3$export$e9e4cb9eb9e2b4c4, useImmutableMark: $ecc5eb53c8c5a4f3$export$c5d829a463bd3201 } = (0, $a6c6008fe53487e1$export$2e2bcd8739ae039)();



var $acw62 = parcelRequire("acw62");

const { makeImmutable: $395c79e6e08309bc$export$ffd6d5bef5eaf0a4, responseImmutable: $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4, useImmutableMark: $395c79e6e08309bc$export$c5d829a463bd3201 } = (0, $a6c6008fe53487e1$export$2e2bcd8739ae039)();
const $395c79e6e08309bc$var$TableContext = (0, $2b6e94889042e439$export$fd42f52fd3ae1109)();
var $395c79e6e08309bc$export$2e2bcd8739ae039 = $395c79e6e08309bc$var$TableContext;


/* istanbul ignore file */ 
var $acw62 = parcelRequire("acw62");
function $b0fd0b97efa32870$var$useRenderTimes(props, debug) {
    // Render times
    const timesRef = $acw62.useRef(0);
    timesRef.current += 1;
    // Props changed
    const propsRef = $acw62.useRef(props);
    const keys = [];
    Object.keys(props || {}).map((key)=>{
        if (props?.[key] !== propsRef.current?.[key]) keys.push(key);
    });
    propsRef.current = props;
    // Cache keys since React rerender may cause it lost
    const keysRef = $acw62.useRef([]);
    if (keys.length) keysRef.current = keys;
    $acw62.useDebugValue(timesRef.current);
    $acw62.useDebugValue(keysRef.current.join(', '));
    if (debug) console.log(`${debug}:`, timesRef.current, keysRef.current);
    return timesRef.current;
}
var $b0fd0b97efa32870$export$2e2bcd8739ae039 = ()=>{};
const $b0fd0b97efa32870$export$e57c788cafefed4f = /*#__PURE__*/ $acw62.memo(()=>{
    const times = $b0fd0b97efa32870$var$useRenderTimes();
    return /*#__PURE__*/ $acw62.createElement("h1", null, "Render Times: ", times);
});



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// TODO: Remove when use `responsiveImmutable`
const $a223648a798edd29$var$PerfContext = /*#__PURE__*/ $acw62.createContext({
    renderWithProps: false
});
var $a223648a798edd29$export$2e2bcd8739ae039 = $a223648a798edd29$var$PerfContext;


const $52967433957611b9$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $52967433957611b9$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $52967433957611b9$export$fd2ca5407d9be470(columns) {
    const columnKeys = [];
    const keys = {};
    columns.forEach((column)=>{
        const { key: key, dataIndex: dataIndex } = column || {};
        let mergedKey = key || $52967433957611b9$var$toArray(dataIndex).join('-') || $52967433957611b9$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = `${mergedKey}_next`;
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $52967433957611b9$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}
function $52967433957611b9$export$b1cd2bdabe361feb(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}



function $3f6cb9e5988373e6$var$isRenderCell(data) {
    return data && typeof data === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $acw62.isValidElement(data);
}
function $3f6cb9e5988373e6$export$2e2bcd8739ae039(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
    // TODO: Remove this after next major version
    const perfRecord = $acw62.useContext((0, $a223648a798edd29$export$2e2bcd8739ae039));
    const mark = (0, $395c79e6e08309bc$export$c5d829a463bd3201)();
    // ======================== Render ========================
    const retData = (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>{
        if ((0, $52967433957611b9$export$b76e9316566cc26e)(children)) return [
            children
        ];
        const path = dataIndex === null || dataIndex === undefined || dataIndex === '' ? [] : Array.isArray(dataIndex) ? dataIndex : [
            dataIndex
        ];
        const value = (0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(record, path);
        // Customize render node
        let returnChildNode = value;
        let returnCellProps = undefined;
        if (render) {
            const renderData = render(value, record, renderIndex);
            if ($3f6cb9e5988373e6$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        // Force update deps
        mark,
        // Normal deps
        record,
        children,
        dataIndex,
        render,
        renderIndex
    ], (prev, next)=>{
        if (shouldCellUpdate) {
            const [, prevRecord] = prev;
            const [, nextRecord] = next;
            return shouldCellUpdate(nextRecord, prevRecord);
        }
        // Legacy mode should always update
        if (perfRecord.renderWithProps) return true;
        return !(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prev, next, true);
    });
    return retData;
}




/** Check if cell is in hover range */ function $d84de2915b646bb3$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    const cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $d84de2915b646bb3$export$2e2bcd8739ae039(rowIndex, rowSpan) {
    return (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), (ctx)=>{
        const hovering = $d84de2915b646bb3$var$inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
        return [
            hovering,
            ctx.onHover
        ];
    });
}



function $c0d89061538bab98$var$_extends() {
    $c0d89061538bab98$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0d89061538bab98$var$_extends.apply(this, arguments);
}
const $c0d89061538bab98$var$getTitleFromCellRenderChildren = ({ ellipsis: ellipsis, rowType: rowType, children: children })=>{
    let title;
    const ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $acw62.isValidElement(children) && typeof children.props?.children === 'string') title = children.props?.children;
    }
    return title;
};
const $c0d89061538bab98$var$Cell = (props)=>{
    const { component: Component, children: children, ellipsis: ellipsis, scope: scope, prefixCls: // Style
    prefixCls, className: className, style: style, align: align, record: // Value
    record, render: render, dataIndex: dataIndex, renderIndex: renderIndex, shouldCellUpdate: shouldCellUpdate, index: // Row
    index, rowType: rowType, colSpan: // Span
    colSpan, rowSpan: rowSpan, fixStart: // Fixed
    fixStart, fixEnd: fixEnd, fixedStartShadow: fixedStartShadow, fixedEndShadow: fixedEndShadow, offsetFixedStartShadow: offsetFixedStartShadow, offsetFixedEndShadow: offsetFixedEndShadow, zIndex: zIndex, zIndexReverse: zIndexReverse, appendNode: // Private
    appendNode, additionalProps: additionalProps = {}, isSticky: isSticky } = props;
    const cellPrefixCls = `${prefixCls}-cell`;
    const { allColumnsFixedLeft: allColumnsFixedLeft, rowHoverable: rowHoverable } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'allColumnsFixedLeft',
        'rowHoverable'
    ]);
    // ====================== Value =======================
    const [childNode, legacyCellProps] = (0, $3f6cb9e5988373e6$export$2e2bcd8739ae039)(record, dataIndex, renderIndex, children, render, shouldCellUpdate);
    // ====================== Fixed =======================
    const fixedStyle = {};
    const isFixStart = typeof fixStart === 'number' && !allColumnsFixedLeft;
    const isFixEnd = typeof fixEnd === 'number' && !allColumnsFixedLeft;
    const [showFixStartShadow, showFixEndShadow] = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), ({ scrollInfo: scrollInfo })=>{
        if (!isFixStart && !isFixEnd) return [
            false,
            false
        ];
        const [absScroll, scrollWidth] = scrollInfo;
        const showStartShadow = (isFixStart && fixedStartShadow && absScroll) - // For precision, we not show shadow by default which has better user experience.
        offsetFixedStartShadow >= 1;
        const showEndShadow = (isFixEnd && fixedEndShadow && scrollWidth - absScroll) - // Same as above
        offsetFixedEndShadow > 1;
        return [
            showStartShadow,
            showEndShadow
        ];
    });
    if (isFixStart) {
        fixedStyle.insetInlineStart = fixStart;
        fixedStyle['--z-offset'] = zIndex;
        fixedStyle['--z-offset-reverse'] = zIndexReverse;
    }
    if (isFixEnd) {
        fixedStyle.insetInlineEnd = fixEnd;
        fixedStyle['--z-offset'] = zIndex;
        fixedStyle['--z-offset-reverse'] = zIndexReverse;
    }
    // ================ RowSpan & ColSpan =================
    const mergedColSpan = legacyCellProps?.colSpan ?? additionalProps.colSpan ?? colSpan ?? 1;
    const mergedRowSpan = legacyCellProps?.rowSpan ?? additionalProps.rowSpan ?? rowSpan ?? 1;
    // ====================== Hover =======================
    const [hovering, onHover] = (0, $d84de2915b646bb3$export$2e2bcd8739ae039)(index, mergedRowSpan);
    const onMouseEnter = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps?.onMouseEnter?.(event);
    });
    const onMouseLeave = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(-1, -1);
        additionalProps?.onMouseLeave?.(event);
    });
    // ====================== Render ======================
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
    // >>>>> Title
    const title = additionalProps.title ?? $c0d89061538bab98$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    // >>>>> ClassName
    const mergedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(cellPrefixCls, className, {
        // Fixed
        [`${cellPrefixCls}-fix`]: isFixStart || isFixEnd,
        [`${cellPrefixCls}-fix-start`]: isFixStart,
        [`${cellPrefixCls}-fix-end`]: isFixEnd,
        // Fixed shadow
        [`${cellPrefixCls}-fix-start-shadow`]: fixedStartShadow,
        [`${cellPrefixCls}-fix-start-shadow-show`]: fixedStartShadow && showFixStartShadow,
        [`${cellPrefixCls}-fix-end-shadow`]: fixedEndShadow,
        [`${cellPrefixCls}-fix-end-shadow-show`]: fixedEndShadow && showFixEndShadow,
        [`${cellPrefixCls}-ellipsis`]: ellipsis,
        [`${cellPrefixCls}-with-append`]: appendNode,
        [`${cellPrefixCls}-fix-sticky`]: (isFixStart || isFixEnd) && isSticky,
        [`${cellPrefixCls}-row-hover`]: !legacyCellProps && hovering
    }, additionalProps.className, legacyCellProps?.className);
    // >>>>> Style
    const alignStyle = {};
    if (align) alignStyle.textAlign = align;
    // The order is important since user can overwrite style.
    // For example ant-design/ant-design#51763
    const mergedStyle = {
        ...legacyCellProps?.style,
        ...fixedStyle,
        ...alignStyle,
        ...additionalProps.style,
        ...style
    };
    // >>>>> Children Node
    let mergedChildNode = childNode;
    // Not crash if final `childNode` is not validate ReactNode
    if (typeof mergedChildNode === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $acw62.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (fixedStartShadow || fixedEndShadow)) mergedChildNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: `${cellPrefixCls}-content`
    }, mergedChildNode);
    return /*#__PURE__*/ $acw62.createElement(Component, $c0d89061538bab98$var$_extends({}, legacyCellProps, additionalProps, {
        className: mergedClassName,
        style: mergedStyle,
        title: title,
        scope: scope,
        onMouseEnter: rowHoverable ? onMouseEnter : undefined,
        onMouseLeave: rowHoverable ? onMouseLeave : undefined,
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
    }), appendNode, mergedChildNode);
};
var $c0d89061538bab98$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($c0d89061538bab98$var$Cell);




function $ba55d3f8e077d6a8$var$isFixedStart(column) {
    return column.fixed === 'start';
}
function $ba55d3f8e077d6a8$var$isFixedEnd(column) {
    return column.fixed === 'end';
}
function $ba55d3f8e077d6a8$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets) {
    const startColumn = columns[colStart] || {};
    const endColumn = columns[colEnd] || {};
    let fixStart = null;
    let fixEnd = null;
    if ($ba55d3f8e077d6a8$var$isFixedStart(startColumn) && $ba55d3f8e077d6a8$var$isFixedStart(endColumn)) fixStart = stickyOffsets.start[colStart];
    else if ($ba55d3f8e077d6a8$var$isFixedEnd(endColumn) && $ba55d3f8e077d6a8$var$isFixedEnd(startColumn)) fixEnd = stickyOffsets.end[colEnd];
    // check if need to add shadow
    let fixedStartShadow = false;
    let fixedEndShadow = false;
    // Calc `zIndex`.
    // first fixed start (start -> end) column `zIndex` should be greater than next column.
    // first fixed end (end -> start) column `zIndex` should be greater than next column.
    let zIndex = 0;
    let zIndexReverse = 0;
    if (fixStart !== null) {
        fixedStartShadow = !columns[colEnd + 1] || !$ba55d3f8e077d6a8$var$isFixedStart(columns[colEnd + 1]);
        zIndex = columns.length * 2 - colStart; // Fix start always overlay fix end
        zIndexReverse = columns.length + colStart;
    }
    if (fixEnd !== null) {
        fixedEndShadow = !columns[colStart - 1] || !$ba55d3f8e077d6a8$var$isFixedEnd(columns[colStart - 1]);
        zIndex = colEnd;
        zIndexReverse = columns.length - colEnd; // Fix end always overlay fix start
    }
    // Check if scrollLeft will show the shadow
    let offsetFixedStartShadow = 0;
    let offsetFixedEndShadow = 0;
    if (fixedStartShadow) {
        for(let i = 0; i < colStart; i += 1)if (!$ba55d3f8e077d6a8$var$isFixedStart(columns[i])) offsetFixedStartShadow += stickyOffsets.widths[i] || 0;
    }
    if (fixedEndShadow) {
        for(let i = columns.length - 1; i > colEnd; i -= 1)if (!$ba55d3f8e077d6a8$var$isFixedEnd(columns[i])) offsetFixedEndShadow += stickyOffsets.widths[i] || 0;
    }
    return {
        fixStart: fixStart,
        fixEnd: fixEnd,
        fixedStartShadow: fixedStartShadow,
        fixedEndShadow: fixedEndShadow,
        offsetFixedStartShadow: offsetFixedStartShadow,
        offsetFixedEndShadow: offsetFixedEndShadow,
        isSticky: stickyOffsets.isSticky,
        zIndex: zIndex,
        zIndexReverse: zIndexReverse
    };
}



var $acw62 = parcelRequire("acw62");
const $f1c6e30d1d115a0a$var$SummaryContext = /*#__PURE__*/ $acw62.createContext({});
var $f1c6e30d1d115a0a$export$2e2bcd8739ae039 = $f1c6e30d1d115a0a$var$SummaryContext;


function $7ff2442b864b3646$var$_extends() {
    $7ff2442b864b3646$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7ff2442b864b3646$var$_extends.apply(this, arguments);
}
const $7ff2442b864b3646$var$SummaryCell = (props)=>{
    const { className: className, index: index, children: children, colSpan: colSpan = 1, rowSpan: rowSpan, align: align } = props;
    const { prefixCls: prefixCls } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls'
    ]);
    const { scrollColumnIndex: scrollColumnIndex, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = $acw62.useContext((0, $f1c6e30d1d115a0a$export$2e2bcd8739ae039));
    const lastIndex = index + colSpan - 1;
    const mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    const fixedInfo = $acw62.useMemo(()=>(0, $ba55d3f8e077d6a8$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets), [
        index,
        mergedColSpan,
        flattenColumns,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $c0d89061538bab98$export$2e2bcd8739ae039), $7ff2442b864b3646$var$_extends({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: ()=>children
    }, fixedInfo));
};
var $7ff2442b864b3646$export$2e2bcd8739ae039 = $7ff2442b864b3646$var$SummaryCell;



var $acw62 = parcelRequire("acw62");
const $0b9c26fe93c535f8$var$FooterRow = (props)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $acw62.createElement("tr", restProps, children);
};
var $0b9c26fe93c535f8$export$2e2bcd8739ae039 = $0b9c26fe93c535f8$var$FooterRow;


/**
 * Syntactic sugar. Do not support HOC.
 */ const $e071a9f3ba14b969$var$Summary = (props)=>{
    const { children: children } = props;
    return children;
};
$e071a9f3ba14b969$var$Summary.Row = (0, $0b9c26fe93c535f8$export$2e2bcd8739ae039);
$e071a9f3ba14b969$var$Summary.Cell = (0, $7ff2442b864b3646$export$2e2bcd8739ae039);
var $e071a9f3ba14b969$export$2e2bcd8739ae039 = $e071a9f3ba14b969$var$Summary;



const $40f6b4085cce6d6d$var$Footer = (props)=>{
    const { children: children, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = props;
    const prefixCls = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), 'prefixCls');
    const lastColumnIndex = flattenColumns.length - 1;
    const scrollColumn = flattenColumns[lastColumnIndex];
    const summaryContext = $acw62.useMemo(()=>({
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: scrollColumn?.scrollbar ? lastColumnIndex : null
        }), [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $f1c6e30d1d115a0a$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $acw62.createElement("tfoot", {
        className: `${prefixCls}-summary`
    }, children));
};
var $40f6b4085cce6d6d$export$2e2bcd8739ae039 = (0, $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4)($40f6b4085cce6d6d$var$Footer);
const $40f6b4085cce6d6d$export$d605f3af09eef683 = (0, $e071a9f3ba14b969$export$2e2bcd8739ae039);


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $d0280dd7944801c3$var$Column(_) {
    return null;
}
var $d0280dd7944801c3$export$2e2bcd8739ae039 = $d0280dd7944801c3$var$Column;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $98287771cdc4caae$var$ColumnGroup(_) {
    return null;
}
var $98287771cdc4caae$export$2e2bcd8739ae039 = $98287771cdc4caae$var$ColumnGroup;










var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
// recursion (flat tree structure)
function $cf4b9058de3376db$var$fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    const key = getRowKey(record, index);
    list.push({
        record: record,
        indent: indent,
        index: index,
        rowKey: key
    });
    const expanded = expandedKeys?.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(let i = 0; i < record[childrenColumnName].length; i += 1)$cf4b9058de3376db$var$fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
}
function $cf4b9058de3376db$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    const arr = $acw62.useMemo(()=>{
        if (expandedKeys?.size) {
            const list = [];
            // collect flattened record
            for(let i = 0; i < data?.length; i += 1){
                const record = data[i];
                // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
                $cf4b9058de3376db$var$fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
            }
            return list;
        }
        return data?.map((item, index)=>{
            return {
                record: item,
                indent: 0,
                index: index,
                rowKey: getRowKey(item, index)
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}






var $acw62 = parcelRequire("acw62");








function $636bab8066a7a0e3$export$2e2bcd8739ae039(record, rowKey, recordIndex, indent) {
    const context = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls',
        'fixedInfoList',
        'flattenColumns',
        'expandableType',
        'expandRowByClick',
        'onTriggerExpand',
        'rowClassName',
        'expandedRowClassName',
        'indentSize',
        'expandIcon',
        'expandedRowRender',
        'expandIconColumnIndex',
        'expandedKeys',
        'childrenColumnName',
        'rowExpandable',
        'onRow'
    ]);
    const { flattenColumns: flattenColumns, expandableType: expandableType, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, onTriggerExpand: onTriggerExpand, rowExpandable: rowExpandable, onRow: onRow, expandRowByClick: expandRowByClick, rowClassName: rowClassName } = context;
    // ======================= Expandable =======================
    // Only when row is not expandable and `children` exist in record
    const nestExpandable = expandableType === 'nest';
    const rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record));
    const mergedExpandable = rowSupportExpand || nestExpandable;
    const expanded = expandedKeys && expandedKeys.has(rowKey);
    const hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    const onInternalTriggerExpand = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(onTriggerExpand);
    // ========================= onRow ==========================
    const rowProps = onRow?.(record, recordIndex);
    const onRowClick = rowProps?.onClick;
    const onClick = (event, ...args)=>{
        if (expandRowByClick && mergedExpandable) onTriggerExpand(record, event);
        onRowClick?.(event, ...args);
    };
    // ====================== RowClassName ======================
    let computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, recordIndex, indent);
    // ========================= Column =========================
    const columnsKey = (0, $52967433957611b9$export$fd2ca5407d9be470)(flattenColumns);
    return {
        ...context,
        columnsKey: columnsKey,
        nestExpandable: nestExpandable,
        expanded: expanded,
        hasNestChildren: hasNestChildren,
        record: record,
        onTriggerExpand: onInternalTriggerExpand,
        rowSupportExpand: rowSupportExpand,
        expandable: mergedExpandable,
        rowProps: {
            ...rowProps,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(computeRowClassName, rowProps?.className),
            onClick: onClick
        }
    };
}




var $acw62 = parcelRequire("acw62");



const $53f9a40902260edb$var$ExpandedRow = (props)=>{
    const { prefixCls: prefixCls, children: children, component: Component, cellComponent: cellComponent, className: className, expanded: expanded, colSpan: colSpan, isEmpty: isEmpty, stickyOffset: stickyOffset = 0 } = props;
    const { scrollbarSize: scrollbarSize, fixHeader: fixHeader, fixColumn: fixColumn, componentWidth: componentWidth, horizonScroll: horizonScroll } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'scrollbarSize',
        'fixHeader',
        'fixColumn',
        'componentWidth',
        'horizonScroll'
    ]);
    // Cache render node
    let contentNode = children;
    if (isEmpty ? horizonScroll && componentWidth : fixColumn) contentNode = /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            width: componentWidth - stickyOffset - (fixHeader && !isEmpty ? scrollbarSize : 0),
            position: 'sticky',
            left: stickyOffset,
            overflow: 'hidden'
        },
        className: `${prefixCls}-expanded-row-fixed`
    }, contentNode);
    return /*#__PURE__*/ $acw62.createElement(Component, {
        className: className,
        style: {
            display: expanded ? null : 'none'
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $c0d89061538bab98$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls,
        colSpan: colSpan
    }, contentNode));
};
var $53f9a40902260edb$export$2e2bcd8739ae039 = $53f9a40902260edb$var$ExpandedRow;



var $acw62 = parcelRequire("acw62");

function $1cb6e00772e4d36d$export$ae14373a7f810e33({ prefixCls: prefixCls, record: record, onExpand: onExpand, expanded: expanded, expandable: expandable }) {
    const expandClassName = `${prefixCls}-row-expand-icon`;
    if (!expandable) return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(expandClassName, `${prefixCls}-row-spaced`)
    });
    const onClick = (event)=>{
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(expandClassName, {
            [`${prefixCls}-row-expanded`]: expanded,
            [`${prefixCls}-row-collapsed`]: !expanded
        }),
        onClick: onClick
    });
}
function $1cb6e00772e4d36d$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    const keys = [];
    function dig(list) {
        (list || []).forEach((item, index)=>{
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}
function $1cb6e00772e4d36d$export$c5c465afb98f57b6(cls, record, index, indent) {
    if (typeof cls === 'string') return cls;
    if (typeof cls === 'function') return cls(record, index, indent);
    return '';
}


function $478ffbb5030e2c55$var$_extends() {
    $478ffbb5030e2c55$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $478ffbb5030e2c55$var$_extends.apply(this, arguments);
}
function $478ffbb5030e2c55$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys = [], expandedRowOffset = 0) {
    const { record: record, prefixCls: prefixCls, columnsKey: columnsKey, fixedInfoList: fixedInfoList, expandIconColumnIndex: expandIconColumnIndex, nestExpandable: nestExpandable, indentSize: indentSize, expandIcon: expandIcon, expanded: expanded, hasNestChildren: hasNestChildren, onTriggerExpand: onTriggerExpand, expandable: expandable, expandedKeys: expandedKeys } = rowInfo;
    const key = columnsKey[colIndex];
    const fixedInfo = fixedInfoList[colIndex];
    // ============= Used for nest expandable =============
    let appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            paddingLeft: `${indentSize * indent}px`
        },
        className: `${prefixCls}-row-indent indent-level-${indent}`
    }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
    }));
    const additionalCellProps = column.onCell?.(record, index) || {};
    // Expandable row has offset
    if (expandedRowOffset) {
        const { rowSpan: rowSpan = 1 } = additionalCellProps;
        // For expandable row with rowSpan,
        // We should increase the rowSpan if the row is expanded
        if (expandable && rowSpan && colIndex < expandedRowOffset) {
            let currentRowSpan = rowSpan;
            for(let i = index; i < index + rowSpan; i += 1){
                const rowKey = rowKeys[i];
                if (expandedKeys.has(rowKey)) currentRowSpan += 1;
            }
            additionalCellProps.rowSpan = currentRowSpan;
        }
    }
    return {
        key: key,
        fixedInfo: fixedInfo,
        appendCellNode: appendCellNode,
        additionalCellProps: additionalCellProps
    };
}
// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
const $478ffbb5030e2c55$var$BodyRow = (props)=>{
    const { className: className, style: style, classNames: classNames, styles: styles, record: record, index: index, renderIndex: renderIndex, rowKey: rowKey, rowKeys: rowKeys, indent: indent = 0, rowComponent: RowComponent, cellComponent: cellComponent, scopeCellComponent: scopeCellComponent, expandedRowInfo: expandedRowInfo } = props;
    const rowInfo = (0, $636bab8066a7a0e3$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const { prefixCls: prefixCls, flattenColumns: flattenColumns, expandedRowClassName: expandedRowClassName, expandedRowRender: expandedRowRender, rowProps: rowProps, expanded: // Misc
    expanded, rowSupportExpand: rowSupportExpand } = rowInfo;
    // Force render expand row if expanded before
    const expandedRef = $acw62.useRef(false);
    expandedRef.current ||= expanded;
    // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
    // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
    const expandedClsName = (0, $1cb6e00772e4d36d$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
    // ======================== Base tr row ========================
    const baseRowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, $478ffbb5030e2c55$var$_extends({}, rowProps, {
        "data-row-key": rowKey,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, `${prefixCls}-row-level-${indent}`, rowProps?.className, classNames.row, {
            [expandedClsName]: indent >= 1
        }),
        style: {
            ...style,
            ...rowProps?.style,
            ...styles.row
        }
    }), flattenColumns.map((column, colIndex)=>{
        const { render: render, dataIndex: dataIndex, className: columnClassName } = column;
        const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps } = $478ffbb5030e2c55$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys, expandedRowInfo?.offset);
        return /*#__PURE__*/ $acw62.createElement((0, $c0d89061538bab98$export$2e2bcd8739ae039), $478ffbb5030e2c55$var$_extends({
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(columnClassName, classNames.cell),
            style: styles.cell,
            ellipsis: column.ellipsis,
            align: column.align,
            scope: column.rowScope,
            component: column.rowScope ? scopeCellComponent : cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    }));
    // ======================== Expand Row =========================
    let expandRowNode;
    if (rowSupportExpand && (expandedRef.current || expanded)) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        expandRowNode = /*#__PURE__*/ $acw62.createElement((0, $53f9a40902260edb$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: expandedRowInfo ? expandedRowInfo.colSpan : flattenColumns.length,
            isEmpty: false,
            stickyOffset: expandedRowInfo?.sticky
        }, expandContent);
    }
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, baseRowNode, expandRowNode);
};
var $478ffbb5030e2c55$export$2e2bcd8739ae039 = (0, $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4)($478ffbb5030e2c55$var$BodyRow);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $71a0e57d40660649$var$MeasureCell = (props)=>{
    const { columnKey: columnKey, onColumnResize: onColumnResize, title: title } = props;
    const cellRef = $acw62.useRef(null);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        data: columnKey
    }, /*#__PURE__*/ $acw62.createElement("td", {
        ref: cellRef,
        style: {
            paddingTop: 0,
            paddingBottom: 0,
            borderTop: 0,
            borderBottom: 0,
            height: 0
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden',
            fontWeight: 'bold'
        }
    }, title || '\xa0')));
};
var $71a0e57d40660649$export$2e2bcd8739ae039 = $71a0e57d40660649$var$MeasureCell;





const $abc6ea5ffe6a1637$var$MeasureRow = ({ prefixCls: prefixCls, columnsKey: columnsKey, onColumnResize: onColumnResize, columns: columns })=>{
    const ref = $acw62.useRef(null);
    const { measureRowRender: measureRowRender } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'measureRowRender'
    ]);
    const measureRow = /*#__PURE__*/ $acw62.createElement("tr", {
        "aria-hidden": "true",
        className: `${prefixCls}-measure-row`,
        style: {
            height: 0
        },
        ref: ref
    }, /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039).Collection, {
        onBatchResize: (infoList)=>{
            if ((0, $13cc53bc89b37f6a$export$2e2bcd8739ae039)(ref.current)) infoList.forEach(({ data: columnKey, size: size })=>{
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map((columnKey)=>{
        const column = columns.find((col)=>col.key === columnKey);
        const rawTitle = column?.title;
        const titleForMeasure = /*#__PURE__*/ $acw62.isValidElement(rawTitle) ? /*#__PURE__*/ $acw62.cloneElement(rawTitle, {
            ref: null
        }) : rawTitle;
        return /*#__PURE__*/ $acw62.createElement((0, $71a0e57d40660649$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize,
            title: titleForMeasure
        });
    })));
    return typeof measureRowRender === 'function' ? measureRowRender(measureRow) : measureRow;
};
var $abc6ea5ffe6a1637$export$2e2bcd8739ae039 = $abc6ea5ffe6a1637$var$MeasureRow;


const $69380ab8a0250e3a$var$Body = (props)=>{
    const { data: data, measureColumnWidth: measureColumnWidth } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, onColumnResize: onColumnResize, flattenColumns: flattenColumns, getRowKey: getRowKey, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, emptyNode: emptyNode, classNames: classNames, styles: styles, expandedRowOffset: expandedRowOffset = 0, colWidths: colWidths } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'onColumnResize',
        'flattenColumns',
        'getRowKey',
        'expandedKeys',
        'childrenColumnName',
        'emptyNode',
        'classNames',
        'styles',
        'expandedRowOffset',
        'fixedInfoList',
        'colWidths'
    ]);
    const { body: bodyCls = {} } = classNames || {};
    const { body: bodyStyles = {} } = styles || {};
    const flattenData = (0, $cf4b9058de3376db$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    const rowKeys = $acw62.useMemo(()=>flattenData.map((item)=>item.rowKey), [
        flattenData
    ]);
    // =================== Performance ====================
    const perfRef = $acw62.useRef({
        renderWithProps: false
    });
    // ===================== Expanded =====================
    // `expandedRowOffset` data is same for all the rows.
    // Let's calc on Body side to save performance.
    const expandedRowInfo = $acw62.useMemo(()=>{
        const expandedColSpan = flattenColumns.length - expandedRowOffset;
        let expandedStickyStart = 0;
        for(let i = 0; i < expandedRowOffset; i += 1)expandedStickyStart += colWidths[i] || 0;
        return {
            offset: expandedRowOffset,
            colSpan: expandedColSpan,
            sticky: expandedStickyStart
        };
    }, [
        flattenColumns.length,
        expandedRowOffset,
        colWidths
    ]);
    // ====================== Render ======================
    const WrapperComponent = getComponent([
        'body',
        'wrapper'
    ], 'tbody');
    const trComponent = getComponent([
        'body',
        'row'
    ], 'tr');
    const tdComponent = getComponent([
        'body',
        'cell'
    ], 'td');
    const thComponent = getComponent([
        'body',
        'cell'
    ], 'th');
    let rows;
    if (data.length) rows = flattenData.map((item, idx)=>{
        const { record: record, indent: indent, index: renderIndex, rowKey: rowKey } = item;
        return /*#__PURE__*/ $acw62.createElement((0, $478ffbb5030e2c55$export$2e2bcd8739ae039), {
            classNames: bodyCls,
            styles: bodyStyles,
            key: rowKey,
            rowKey: rowKey,
            rowKeys: rowKeys,
            record: record,
            index: idx,
            renderIndex: renderIndex,
            rowComponent: trComponent,
            cellComponent: tdComponent,
            scopeCellComponent: thComponent,
            indent: indent,
            expandedRowInfo: expandedRowInfo
        });
    });
    else rows = /*#__PURE__*/ $acw62.createElement((0, $53f9a40902260edb$export$2e2bcd8739ae039), {
        expanded: true,
        className: `${prefixCls}-placeholder`,
        prefixCls: prefixCls,
        component: trComponent,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length,
        isEmpty: true
    }, emptyNode);
    const columnsKey = (0, $52967433957611b9$export$fd2ca5407d9be470)(flattenColumns);
    return /*#__PURE__*/ $acw62.createElement((0, $a223648a798edd29$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $acw62.createElement(WrapperComponent, {
        style: bodyStyles.wrapper,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-tbody`, bodyCls.wrapper)
    }, measureColumnWidth && /*#__PURE__*/ $acw62.createElement((0, $abc6ea5ffe6a1637$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        columnsKey: columnsKey,
        onColumnResize: onColumnResize,
        columns: flattenColumns
    }), rows));
};
var $69380ab8a0250e3a$export$2e2bcd8739ae039 = (0, $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4)($69380ab8a0250e3a$var$Body);



var $acw62 = parcelRequire("acw62");

const $4cc7e0683884ce83$export$f8dba99c0d5b6b87 = 'RC_TABLE_INTERNAL_COL_DEFINE';
function $4cc7e0683884ce83$export$e215b9806eacdfb5(props) {
    const { expandable: expandable, ...legacyExpandableConfig } = props;
    let config;
    if ('expandable' in props) config = {
        ...legacyExpandableConfig,
        ...expandable
    };
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}




function $e4f6ee82ad2c6f25$var$_extends() {
    $e4f6ee82ad2c6f25$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e4f6ee82ad2c6f25$var$_extends.apply(this, arguments);
}
const $e4f6ee82ad2c6f25$var$ColGroup = (props)=>{
    const { colWidths: colWidths, columns: columns, columCount: columCount } = props;
    const { tableLayout: tableLayout } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'tableLayout'
    ]);
    const cols = [];
    const len = columCount || columns.length;
    // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    let mustInsert = false;
    for(let i = len - 1; i >= 0; i -= 1){
        const width = colWidths[i];
        const column = columns && columns[i];
        let additionalProps;
        let minWidth;
        if (column) {
            additionalProps = column[0, $4cc7e0683884ce83$export$f8dba99c0d5b6b87];
            // fixed will cause layout problems
            if (tableLayout === 'auto') minWidth = column.minWidth;
        }
        if (width || minWidth || additionalProps || mustInsert) {
            const { columnType: columnType, ...restAdditionalProps } = additionalProps || {};
            cols.unshift(/*#__PURE__*/ $acw62.createElement("col", $e4f6ee82ad2c6f25$var$_extends({
                key: i,
                style: {
                    width: width,
                    minWidth: minWidth
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return cols.length > 0 ? /*#__PURE__*/ $acw62.createElement("colgroup", null, cols) : null;
};
var $e4f6ee82ad2c6f25$export$2e2bcd8739ae039 = $e4f6ee82ad2c6f25$var$ColGroup;








var $acw62 = parcelRequire("acw62");



function $ffe0e4d1aa6fd687$var$useColumnWidth(colWidths, columCount) {
    return (0, $acw62.useMemo)(()=>{
        const cloneColumns = [];
        for(let i = 0; i < columCount; i += 1){
            const val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
const $ffe0e4d1aa6fd687$var$FixedHolder = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: className, style: style, noData: noData, columns: columns, flattenColumns: flattenColumns, colWidths: colWidths, colGroup: colGroup, columCount: columCount, stickyOffsets: stickyOffsets, direction: direction, fixHeader: fixHeader, stickyTopOffset: stickyTopOffset, stickyBottomOffset: stickyBottomOffset, stickyClassName: stickyClassName, scrollX: scrollX, tableLayout: tableLayout = 'fixed', onScroll: onScroll, maxContentScroll: maxContentScroll, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, scrollbarSize: scrollbarSize, isSticky: isSticky, getComponent: getComponent } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls',
        'scrollbarSize',
        'isSticky',
        'getComponent'
    ]);
    const TableComponent = getComponent([
        'header',
        'table'
    ], 'table');
    const combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
    // Pass wheel to scroll event
    const scrollRef = $acw62.useRef(null);
    const setScrollRef = $acw62.useCallback((element)=>{
        (0, $6c628207f5089a39$export$f17fd18fa51dcb5b)(ref, element);
        (0, $6c628207f5089a39$export$f17fd18fa51dcb5b)(scrollRef, element);
    }, []);
    $acw62.useEffect(()=>{
        function onWheel(e) {
            const { currentTarget: currentTarget, deltaX: deltaX } = e;
            if (deltaX) {
                const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = currentTarget;
                const maxScrollWidth = scrollWidth - clientWidth;
                let nextScroll = scrollLeft + deltaX;
                if (direction === 'rtl') {
                    nextScroll = Math.max(-maxScrollWidth, nextScroll);
                    nextScroll = Math.min(0, nextScroll);
                } else {
                    nextScroll = Math.min(maxScrollWidth, nextScroll);
                    nextScroll = Math.max(0, nextScroll);
                }
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: nextScroll
                });
                e.preventDefault();
            }
        }
        const scrollEle = scrollRef.current;
        scrollEle?.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>{
            scrollEle?.removeEventListener('wheel', onWheel);
        };
    }, []);
    // Add scrollbar column
    const lastColumn = flattenColumns[flattenColumns.length - 1];
    const ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: ()=>({
                className: `${prefixCls}-cell-scrollbar`
            })
    };
    const columnsWithScrollbar = (0, $acw62.useMemo)(()=>combinationScrollBarSize ? [
            ...columns,
            ScrollBarColumn
        ] : columns, [
        combinationScrollBarSize,
        columns
    ]);
    const flattenColumnsWithScrollbar = (0, $acw62.useMemo)(()=>combinationScrollBarSize ? [
            ...flattenColumns,
            ScrollBarColumn
        ] : flattenColumns, [
        combinationScrollBarSize,
        flattenColumns
    ]);
    // Calculate the sticky offsets
    const headerStickyOffsets = (0, $acw62.useMemo)(()=>{
        const { start: start, end: end } = stickyOffsets;
        return {
            ...stickyOffsets,
            // left:
            //   direction === 'rtl' ? [...left.map(width => width + combinationScrollBarSize), 0] : left,
            // right:
            //   direction === 'rtl' ? right : [...right.map(width => width + combinationScrollBarSize), 0],
            start: start,
            end: [
                ...end.map((width)=>width + combinationScrollBarSize),
                0
            ],
            isSticky: isSticky
        };
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    const mergedColumnWidth = $ffe0e4d1aa6fd687$var$useColumnWidth(colWidths, columCount);
    const isColGroupEmpty = (0, $acw62.useMemo)(()=>{
        // use original ColGroup if no data or no calculated column width, otherwise use calculated column width
        // Return original colGroup if no data, or mergedColumnWidth is empty, or all widths are falsy
        const noWidth = !mergedColumnWidth || !mergedColumnWidth.length || mergedColumnWidth.every((w)=>!w);
        return noData || noWidth;
    }, [
        noData,
        mergedColumnWidth
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            overflow: 'hidden',
            ...isSticky ? {
                top: stickyTopOffset,
                bottom: stickyBottomOffset
            } : {},
            ...style
        },
        ref: setScrollRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, {
            [stickyClassName]: !!stickyClassName
        })
    }, /*#__PURE__*/ $acw62.createElement(TableComponent, {
        style: {
            tableLayout: tableLayout,
            minWidth: '100%',
            // https://github.com/ant-design/ant-design/issues/54894
            width: scrollX
        }
    }, isColGroupEmpty ? colGroup : /*#__PURE__*/ $acw62.createElement((0, $e4f6ee82ad2c6f25$export$2e2bcd8739ae039), {
        colWidths: [
            ...mergedColumnWidth,
            combinationScrollBarSize
        ],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children({
        ...restProps,
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    })));
});
var /** Return a table in div as fixed element which contains sticky info */ // export default responseImmutable(FixedHolder);
$ffe0e4d1aa6fd687$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($ffe0e4d1aa6fd687$var$FixedHolder);





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");





function $b470088e93618c83$var$_extends() {
    $b470088e93618c83$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b470088e93618c83$var$_extends.apply(this, arguments);
}
const $b470088e93618c83$var$HeaderRow = (props)=>{
    const { cells: cells, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns, rowComponent: RowComponent, cellComponent: CellComponent, onHeaderRow: onHeaderRow, index: index, classNames: classNames, styles: styles } = props;
    const { prefixCls: prefixCls } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls'
    ]);
    let rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map((cell)=>cell.column), index);
    const columnsKey = (0, $52967433957611b9$export$fd2ca5407d9be470)(cells.map((cell)=>cell.column));
    return /*#__PURE__*/ $acw62.createElement(RowComponent, $b470088e93618c83$var$_extends({}, rowProps, {
        className: classNames.row,
        style: styles.row
    }), cells.map((cell, cellIndex)=>{
        const { column: column, colStart: colStart, colEnd: colEnd, colSpan: colSpan } = cell;
        const fixedInfo = (0, $ba55d3f8e077d6a8$export$695db918331141f3)(colStart, colEnd, flattenColumns, stickyOffsets);
        const additionalProps = column?.onHeaderCell?.(column) || {};
        return /*#__PURE__*/ $acw62.createElement((0, $c0d89061538bab98$export$2e2bcd8739ae039), $b470088e93618c83$var$_extends({}, cell, {
            scope: column.title ? colSpan > 1 ? 'colgroup' : 'col' : null,
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
};
var $b470088e93618c83$export$2e2bcd8739ae039 = $b470088e93618c83$var$HeaderRow;


function $2e8a0b64694d99ac$var$parseHeaderRows(rootColumns, classNames, styles) {
    const rows = [];
    function fillRowCells(columns, colIndex, rowIndex = 0) {
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        let currentColIndex = colIndex;
        const colSpans = columns.filter(Boolean).map((column)=>{
            const cell = {
                key: column.key,
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(column.className, classNames.cell) || '',
                style: styles.cell,
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            let colSpan = 1;
            const subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce((total, count)=>total + count, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) ({ colSpan: colSpan } = column);
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    }
    // Generate `rows` cell data
    fillRowCells(rootColumns, 0);
    // Handle `rowSpan`
    const rowCount = rows.length;
    for(let rowIndex = 0; rowIndex < rowCount; rowIndex += 1)rows[rowIndex].forEach((cell)=>{
        if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
    });
    return rows;
}
const $2e8a0b64694d99ac$var$Header = (props)=>{
    const { stickyOffsets: stickyOffsets, columns: columns, flattenColumns: flattenColumns, onHeaderRow: onHeaderRow } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, classNames: classNames, styles: styles } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'classNames',
        'styles'
    ]);
    const { header: headerCls = {} } = classNames || {};
    const { header: headerStyles = {} } = styles || {};
    const rows = $acw62.useMemo(()=>$2e8a0b64694d99ac$var$parseHeaderRows(columns, headerCls, headerStyles), [
        columns,
        headerCls,
        headerStyles
    ]);
    const WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    const trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    const thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $acw62.createElement(WrapperComponent, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-thead`, headerCls.wrapper),
        style: headerStyles.wrapper
    }, rows.map((row, rowIndex)=>{
        const rowNode = /*#__PURE__*/ $acw62.createElement((0, $b470088e93618c83$export$2e2bcd8739ae039), {
            classNames: headerCls,
            styles: headerStyles,
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
};
var $2e8a0b64694d99ac$export$2e2bcd8739ae039 = (0, $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4)($2e8a0b64694d99ac$var$Header);





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $48a01328098e87d3$var$parseColWidth(totalWidth, width = '') {
    if (typeof width === 'number') return width;
    if (width.endsWith('%')) return totalWidth * parseFloat(width) / 100;
    return null;
}
function $48a01328098e87d3$export$2e2bcd8739ae039(flattenColumns, scrollWidth, clientWidth) {
    return $acw62.useMemo(()=>{
        // Fill width if needed
        if (scrollWidth && scrollWidth > 0) {
            let totalWidth = 0;
            let missWidthCount = 0;
            // collect not given width column
            flattenColumns.forEach((col)=>{
                const colWidth = $48a01328098e87d3$var$parseColWidth(scrollWidth, col.width);
                if (colWidth) totalWidth += colWidth;
                else missWidthCount += 1;
            });
            // Fill width
            const maxFitWidth = Math.max(scrollWidth, clientWidth);
            let restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
            let restCount = missWidthCount;
            const avgWidth = restWidth / missWidthCount;
            let realTotal = 0;
            const filledColumns = flattenColumns.map((col)=>{
                const clone = {
                    ...col
                };
                const colWidth = $48a01328098e87d3$var$parseColWidth(scrollWidth, clone.width);
                if (colWidth) clone.width = colWidth;
                else {
                    const colAvgWidth = Math.floor(avgWidth);
                    clone.width = restCount === 1 ? restWidth : colAvgWidth;
                    restWidth -= colAvgWidth;
                    restCount -= 1;
                }
                realTotal += clone.width;
                return clone;
            });
            // If realTotal is less than clientWidth,
            // We need extend column width
            if (realTotal < maxFitWidth) {
                const scale = maxFitWidth / realTotal;
                restWidth = maxFitWidth;
                filledColumns.forEach((col, index)=>{
                    const colWidth = Math.floor(col.width * scale);
                    col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
                    restWidth -= colWidth;
                });
            }
            return [
                filledColumns,
                Math.max(realTotal, maxFitWidth)
            ];
        }
        return [
            flattenColumns,
            scrollWidth
        ];
    }, [
        flattenColumns,
        scrollWidth,
        clientWidth
    ]);
}


function $93048120da69385c$export$d87a97eba44e0f9c(children) {
    return (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children).filter((node)=>/*#__PURE__*/ $acw62.isValidElement(node)).map((node)=>{
        const { key: key, props: props } = node;
        const { children: nodeChildren, ...restProps } = props;
        const column = {
            key: key,
            ...restProps
        };
        if (nodeChildren) column.children = $93048120da69385c$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $93048120da69385c$var$filterHiddenColumns(columns) {
    return columns.filter((column)=>column && typeof column === 'object' && !column.hidden).map((column)=>{
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return {
            ...column,
            children: $93048120da69385c$var$filterHiddenColumns(subColumns)
        };
        return column;
    });
}
function $93048120da69385c$var$flatColumns(columns, parentKey = 'key') {
    return columns.filter((column)=>column && typeof column === 'object').reduce((list, column, index)=>{
        const { fixed: fixed } = column;
        const parsedFixed = fixed === true || fixed === 'left' ? 'start' : fixed === 'right' ? 'end' : fixed;
        const mergedKey = `${parentKey}-${index}`;
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [
            ...list,
            ...$93048120da69385c$var$flatColumns(subColumns, mergedKey).map((subColum)=>({
                    ...subColum,
                    fixed: subColum.fixed ?? parsedFixed
                }))
        ];
        return [
            ...list,
            {
                key: mergedKey,
                ...column,
                fixed: parsedFixed
            }
        ];
    }, []);
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $93048120da69385c$var$useColumns({ prefixCls: prefixCls, columns: columns, children: children, expandable: expandable, expandedKeys: expandedKeys, columnTitle: columnTitle, getRowKey: getRowKey, onTriggerExpand: onTriggerExpand, expandIcon: expandIcon, rowExpandable: rowExpandable, expandIconColumnIndex: expandIconColumnIndex, expandedRowOffset: expandedRowOffset = 0, direction: direction, expandRowByClick: expandRowByClick, columnWidth: columnWidth, fixed: fixed, scrollWidth: scrollWidth, clientWidth: clientWidth }, transformColumns) {
    const baseColumns = $acw62.useMemo(()=>{
        const newColumns = columns || $93048120da69385c$export$d87a97eba44e0f9c(children) || [];
        return $93048120da69385c$var$filterHiddenColumns(newColumns.slice());
    }, [
        columns,
        children
    ]);
    // ========================== Expand ==========================
    const withExpandColumns = $acw62.useMemo(()=>{
        if (expandable) {
            let cloneColumns = baseColumns.slice();
            // >>> Insert expand column if not exist
            if (!cloneColumns.includes((0, $3b2a2eb42115b4e5$export$e1053575ddfcb301))) {
                const expandColIndex = expandIconColumnIndex || 0;
                const insertIndex = expandColIndex === 0 && (fixed === 'right' || fixed === 'end') ? baseColumns.length : expandColIndex;
                if (insertIndex >= 0) cloneColumns.splice(insertIndex, 0, (0, $3b2a2eb42115b4e5$export$e1053575ddfcb301));
            }
            const expandColumnIndex = cloneColumns.indexOf((0, $3b2a2eb42115b4e5$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter((column, index)=>column !== (0, $3b2a2eb42115b4e5$export$e1053575ddfcb301) || index === expandColumnIndex);
            // >>> Check if expand column need to fixed
            const prevColumn = baseColumns[expandColumnIndex];
            let fixedColumn;
            if (fixed) fixedColumn = fixed;
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
            // >>> Create expandable column
            const expandColumn = {
                [(0, $4cc7e0683884ce83$export$f8dba99c0d5b6b87)]: {
                    className: `${prefixCls}-expand-icon-col`,
                    columnType: 'EXPAND_COLUMN'
                },
                title: columnTitle,
                fixed: fixedColumn,
                className: `${prefixCls}-row-expand-icon-cell`,
                width: columnWidth,
                render: (_, record, index)=>{
                    const rowKey = getRowKey(record, index);
                    const expanded = expandedKeys.has(rowKey);
                    const recordExpandable = rowExpandable ? rowExpandable(record) : true;
                    const icon = expandIcon({
                        prefixCls: prefixCls,
                        expanded: expanded,
                        expandable: recordExpandable,
                        record: record,
                        onExpand: onTriggerExpand
                    });
                    if (expandRowByClick) return /*#__PURE__*/ $acw62.createElement("span", {
                        onClick: (e)=>e.stopPropagation()
                    }, icon);
                    return icon;
                }
            };
            return cloneColumns.map((col, index)=>{
                const column = col === (0, $3b2a2eb42115b4e5$export$e1053575ddfcb301) ? expandColumn : col;
                if (index < expandedRowOffset) return {
                    ...column,
                    fixed: column.fixed || 'start'
                };
                return column;
            });
        }
        return baseColumns.filter((col)=>col !== (0, $3b2a2eb42115b4e5$export$e1053575ddfcb301));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction,
        expandedRowOffset
    ]);
    // ========================= Transform ========================
    const mergedColumns = $acw62.useMemo(()=>{
        let finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
        // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: ()=>null
            }
        ];
        return finalColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]);
    // ========================== Flatten =========================
    const flattenColumns = $acw62.useMemo(()=>$93048120da69385c$var$flatColumns(mergedColumns), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mergedColumns,
        direction,
        scrollWidth
    ]);
    // ========================= FillWidth ========================
    const [filledColumns, realScrollWidth] = (0, $48a01328098e87d3$export$2e2bcd8739ae039)(flattenColumns, scrollWidth, clientWidth);
    return [
        mergedColumns,
        filledColumns,
        realScrollWidth
    ];
}
var $93048120da69385c$export$2e2bcd8739ae039 = $93048120da69385c$var$useColumns;




var $acw62 = parcelRequire("acw62");



function $8a03a48890c27360$export$2e2bcd8739ae039(props, mergedData, getRowKey) {
    const expandableConfig = (0, $4cc7e0683884ce83$export$e215b9806eacdfb5)(props);
    const { expandIcon: expandIcon, expandedRowKeys: expandedRowKeys, defaultExpandedRowKeys: defaultExpandedRowKeys, defaultExpandAllRows: defaultExpandAllRows, expandedRowRender: expandedRowRender, onExpand: onExpand, onExpandedRowsChange: onExpandedRowsChange, childrenColumnName: childrenColumnName } = expandableConfig;
    const mergedExpandIcon = expandIcon || (0, $1cb6e00772e4d36d$export$ae14373a7f810e33);
    const mergedChildrenColumnName = childrenColumnName || 'children';
    const expandableType = $acw62.useMemo(()=>{
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && props.internalHooks === (0, $3b2a2eb42115b4e5$export$91b75cf262680225) && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some((record)=>record && typeof record === 'object' && record[mergedChildrenColumnName])) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    const [innerExpandedKeys, setInnerExpandedKeys] = $acw62.useState(()=>{
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $1cb6e00772e4d36d$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    });
    const mergedExpandedKeys = $acw62.useMemo(()=>new Set(expandedRowKeys || innerExpandedKeys || []), [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    const onTriggerExpand = $acw62.useCallback((record)=>{
        const key = getRowKey(record, mergedData.indexOf(record));
        let newExpandedKeys;
        const hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = [
                ...mergedExpandedKeys
            ];
        } else newExpandedKeys = [
            ...mergedExpandedKeys,
            key
        ];
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]);
    return [
        expandableConfig,
        expandableType,
        mergedExpandedKeys,
        mergedExpandIcon,
        mergedChildrenColumnName,
        onTriggerExpand
    ];
}






var $acw62 = parcelRequire("acw62");
function $69e1af9b2a43422e$export$2e2bcd8739ae039(flattenColumns, stickyOffsets) {
    const fixedInfoList = $acw62.useMemo(()=>flattenColumns.map((_, colIndex)=>(0, $ba55d3f8e077d6a8$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets)), [
        flattenColumns,
        stickyOffsets
    ]);
    return (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>fixedInfoList, [
        fixedInfoList
    ], (prev, next)=>!(0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(prev, next));
}



var $acw62 = parcelRequire("acw62");
function $f0fd129f9ee30d06$export$510e4dd13e0b67dd(defaultState) {
    const stateRef = (0, $acw62.useRef)(defaultState);
    const [, forceUpdate] = (0, $acw62.useState)({});
    const lastPromiseRef = (0, $acw62.useRef)(null);
    const updateBatchRef = (0, $acw62.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        const promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(()=>{
            if (lastPromiseRef.current === promise) {
                const prevBatch = updateBatchRef.current;
                const prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach((batchUpdater)=>{
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $acw62.useEffect)(()=>()=>{
            lastPromiseRef.current = null;
        }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $f0fd129f9ee30d06$export$d63c72d5e6d02249(defaultState) {
    const frameRef = (0, $acw62.useRef)(defaultState || null);
    const timeoutRef = (0, $acw62.useRef)(null);
    function cleanUp() {
        clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = setTimeout(()=>{
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $acw62.useEffect)(()=>cleanUp, []);
    return [
        setState,
        getState
    ];
}



var $acw62 = parcelRequire("acw62");
function $3a3e60cb4319903c$export$2e2bcd8739ae039() {
    const [startRow, setStartRow] = $acw62.useState(-1);
    const [endRow, setEndRow] = $acw62.useState(-1);
    const onHover = $acw62.useCallback((start, end)=>{
        setStartRow(start);
        setEndRow(end);
    }, []);
    return [
        startRow,
        endRow,
        onHover
    ];
}



var $acw62 = parcelRequire("acw62");

// fix ssr render
const $839b569c5500075b$var$defaultContainer = (0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() ? window : null;
function $839b569c5500075b$export$2e2bcd8739ae039(sticky, prefixCls) {
    const { offsetHeader: offsetHeader = 0, offsetSummary: offsetSummary = 0, offsetScroll: offsetScroll = 0, getContainer: getContainer = ()=>$839b569c5500075b$var$defaultContainer } = typeof sticky === 'object' ? sticky : {};
    const container = getContainer() || $839b569c5500075b$var$defaultContainer;
    const isSticky = !!sticky;
    return $acw62.useMemo(()=>{
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? `${prefixCls}-sticky-holder` : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        isSticky,
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}



var $acw62 = parcelRequire("acw62");
/**
 * Get sticky column offset width
 */ function $fb9070694ef3ad1a$var$useStickyOffsets(colWidths, flattenColumns) {
    const stickyOffsets = (0, $acw62.useMemo)(()=>{
        const columnCount = flattenColumns.length;
        const getOffsets = (startIndex, endIndex, offset)=>{
            const offsets = [];
            let total = 0;
            for(let i = startIndex; i !== endIndex; i += offset){
                offsets.push(total);
                if (flattenColumns[i].fixed) total += colWidths[i] || 0;
            }
            return offsets;
        };
        const startOffsets = getOffsets(0, columnCount, 1);
        const endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
        return {
            start: startOffsets,
            end: endOffsets,
            widths: colWidths
        };
    }, [
        colWidths,
        flattenColumns
    ]);
    return stickyOffsets;
}
var $fb9070694ef3ad1a$export$2e2bcd8739ae039 = $fb9070694ef3ad1a$var$useStickyOffsets;



var $acw62 = parcelRequire("acw62");
const $b99cca23e5432c3e$var$Panel = (props)=>{
    const { children: children, className: className, style: style } = props;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, children);
};
var $b99cca23e5432c3e$export$2e2bcd8739ae039 = $b99cca23e5432c3e$var$Panel;






var $acw62 = parcelRequire("acw62");




function $a7d225f8494ea768$export$622cea445a1c5b7d(node) {
    const element = (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(node);
    const box = element.getBoundingClientRect();
    const docElem = document.documentElement;
    // < ie8 not support win.pageXOffset, use docElem.scrollLeft instead
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}



const $45b6c77af3cf7120$var$MOUSEUP_EVENT = 'mouseup';
const $45b6c77af3cf7120$var$MOUSEMOVE_EVENT = 'mousemove';
const $45b6c77af3cf7120$var$SCROLL_EVENT = 'scroll';
const $45b6c77af3cf7120$var$RESIZE_EVENT = 'resize';
const $45b6c77af3cf7120$var$StickyScrollBar = (props, ref)=>{
    const { scrollBodyRef: scrollBodyRef, onScroll: onScroll, offsetScroll: offsetScroll, container: container, direction: direction } = props;
    const prefixCls = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), 'prefixCls');
    const bodyScrollWidth = scrollBodyRef.current?.scrollWidth || 0;
    const bodyWidth = scrollBodyRef.current?.clientWidth || 0;
    const scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    const scrollBarRef = $acw62.useRef(null);
    const [scrollState, setScrollState] = (0, $f0fd129f9ee30d06$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: true
    });
    const refState = $acw62.useRef({
        delta: 0,
        x: 0
    });
    const [isActive, setActive] = $acw62.useState(false);
    const rafRef = $acw62.useRef(null);
    $acw62.useEffect(()=>()=>{
            (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafRef.current);
        }, []);
    const onMouseUp = ()=>{
        setActive(false);
    };
    const onMouseDown = (event)=>{
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    const onMouseMove = (event)=>{
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        const { buttons: buttons } = event || window?.event;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        let left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        const isRTL = direction === 'rtl';
        // Limit scroll range
        left = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left));
        // Calculate the scroll position and update
        const shouldScroll = !isRTL || Math.abs(left) + Math.abs(scrollBarWidth) < bodyWidth;
        if (shouldScroll) {
            onScroll({
                scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
            });
            refState.current.x = event.pageX;
        }
    };
    const checkScrollBarVisible = ()=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            if (!scrollBodyRef.current) return;
            const tableOffsetTop = (0, $a7d225f8494ea768$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
            const tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
            const currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $a7d225f8494ea768$export$622cea445a1c5b7d)(container).top + container.clientHeight;
            if (tableBottomOffset - (0, $266768ab4357c274$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: true
                }));
            else setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: false
                }));
        });
    };
    const setScrollLeft = (left)=>{
        setScrollState((state)=>{
            return {
                ...state,
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            };
        });
    };
    $acw62.useImperativeHandle(ref, ()=>({
            setScrollLeft: setScrollLeft,
            checkScrollBarVisible: checkScrollBarVisible
        }));
    $acw62.useEffect(()=>{
        document.body.addEventListener($45b6c77af3cf7120$var$MOUSEUP_EVENT, onMouseUp, false);
        document.body.addEventListener($45b6c77af3cf7120$var$MOUSEMOVE_EVENT, onMouseMove, false);
        checkScrollBarVisible();
        return ()=>{
            document.body.removeEventListener($45b6c77af3cf7120$var$MOUSEUP_EVENT, onMouseUp);
            document.body.removeEventListener($45b6c77af3cf7120$var$MOUSEMOVE_EVENT, onMouseMove);
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    // Loop for scroll event check
    $acw62.useEffect(()=>{
        if (scrollBodyRef.current) {
            const scrollParents = [];
            let parent = (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(scrollBodyRef.current);
            while(parent){
                scrollParents.push(parent);
                parent = parent.parentElement;
            }
            scrollParents.forEach((p)=>{
                p.addEventListener($45b6c77af3cf7120$var$SCROLL_EVENT, checkScrollBarVisible, false);
            });
            window.addEventListener($45b6c77af3cf7120$var$RESIZE_EVENT, checkScrollBarVisible, false);
            window.addEventListener($45b6c77af3cf7120$var$SCROLL_EVENT, checkScrollBarVisible, false);
            container.addEventListener($45b6c77af3cf7120$var$SCROLL_EVENT, checkScrollBarVisible, false);
            return ()=>{
                scrollParents.forEach((p)=>{
                    p.removeEventListener($45b6c77af3cf7120$var$SCROLL_EVENT, checkScrollBarVisible);
                });
                window.removeEventListener($45b6c77af3cf7120$var$RESIZE_EVENT, checkScrollBarVisible);
                window.removeEventListener($45b6c77af3cf7120$var$SCROLL_EVENT, checkScrollBarVisible);
                container.removeEventListener($45b6c77af3cf7120$var$SCROLL_EVENT, checkScrollBarVisible);
            };
        }
    }, [
        container
    ]);
    $acw62.useEffect(()=>{
        if (!scrollState.isHiddenScrollBar) setScrollState((state)=>{
            const bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return {
                ...state,
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            height: (0, $266768ab4357c274$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: `${prefixCls}-sticky-scroll`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-sticky-scroll-bar`, {
            [`${prefixCls}-sticky-scroll-bar-active`]: isActive
        }),
        style: {
            width: `${scrollBarWidth}px`,
            transform: `translate3d(${scrollState.scrollLeft}px, 0, 0)`
        }
    }));
};
var $45b6c77af3cf7120$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($45b6c77af3cf7120$var$StickyScrollBar);








function $dfb65e8e39c1bbc2$var$_extends() {
    $dfb65e8e39c1bbc2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dfb65e8e39c1bbc2$var$_extends.apply(this, arguments);
}
const $dfb65e8e39c1bbc2$export$c42ed95a478b1ec5 = 'rc-table';
// Used for conditions cache
const $dfb65e8e39c1bbc2$var$EMPTY_DATA = [];
// Used for customize scroll
const $dfb65e8e39c1bbc2$var$EMPTY_SCROLL_TARGET = {};
function $dfb65e8e39c1bbc2$var$defaultEmpty() {
    return 'No Data';
}
const $dfb65e8e39c1bbc2$var$Table = (tableProps, ref)=>{
    const props = {
        rowKey: 'key',
        prefixCls: $dfb65e8e39c1bbc2$export$c42ed95a478b1ec5,
        emptyText: $dfb65e8e39c1bbc2$var$defaultEmpty,
        ...tableProps
    };
    const { prefixCls: prefixCls, className: className, rowClassName: rowClassName, style: style, classNames: classNames, styles: styles, data: data, rowKey: rowKey, scroll: scroll, tableLayout: tableLayout, direction: direction, title: // Additional Part
    title, footer: footer, summary: summary, caption: caption, id: // Customize
    id, showHeader: showHeader, components: components, emptyText: emptyText, onRow: onRow, onHeaderRow: onHeaderRow, measureRowRender: // Measure Row
    measureRowRender, onScroll: // Events
    onScroll, internalHooks: // Internal
    internalHooks, transformColumns: transformColumns, internalRefs: internalRefs, tailor: tailor, getContainerWidth: getContainerWidth, sticky: sticky, rowHoverable: rowHoverable = true } = props;
    const mergedData = data || $dfb65e8e39c1bbc2$var$EMPTY_DATA;
    const hasData = !!mergedData.length;
    const useInternalHooks = internalHooks === (0, $3b2a2eb42115b4e5$export$91b75cf262680225);
    var name;
    // ==================== Customize =====================
    const getComponent = $acw62.useCallback((path, defaultComponent)=>(0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(components, path) || defaultComponent, [
        components
    ]);
    const getRowKey = $acw62.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>{
            const key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]);
    const customizeScrollBody = getComponent([
        'body'
    ]);
    // ====================== Hover =======================
    const [startRow, endRow, onHover] = (0, $3a3e60cb4319903c$export$2e2bcd8739ae039)();
    // ====================== Expand ======================
    const [expandableConfig, expandableType, mergedExpandedKeys, mergedExpandIcon, mergedChildrenColumnName, onTriggerExpand] = (0, $8a03a48890c27360$export$2e2bcd8739ae039)(props, mergedData, getRowKey);
    // ====================== Column ======================
    const scrollX = scroll?.x;
    const [componentWidth, setComponentWidth] = $acw62.useState(0);
    const [columns, flattenColumns, flattenScrollX] = (0, $93048120da69385c$export$2e2bcd8739ae039)({
        ...props,
        ...expandableConfig,
        expandable: !!expandableConfig.expandedRowRender,
        columnTitle: expandableConfig.columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        onTriggerExpand: // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
        direction: direction,
        scrollWidth: useInternalHooks && tailor && typeof scrollX === 'number' ? scrollX : null,
        clientWidth: componentWidth
    }, useInternalHooks ? transformColumns : null);
    const mergedScrollX = flattenScrollX ?? scrollX;
    const columnContext = $acw62.useMemo(()=>({
            columns: columns,
            flattenColumns: flattenColumns
        }), [
        columns,
        flattenColumns
    ]);
    // ======================= Refs =======================
    const fullTableRef = $acw62.useRef(null);
    const scrollHeaderRef = $acw62.useRef(null);
    const scrollBodyRef = $acw62.useRef(null);
    const scrollBodyContainerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>{
        return {
            nativeElement: fullTableRef.current,
            scrollTo: (config)=>{
                if (scrollBodyRef.current instanceof HTMLElement) {
                    // Native scroll
                    const { index: index, top: top, key: key, offset: offset } = config;
                    if ((0, $52967433957611b9$export$b1cd2bdabe361feb)(top)) // In top mode, offset is ignored
                    scrollBodyRef.current?.scrollTo({
                        top: top
                    });
                    else {
                        const mergedKey = key ?? getRowKey(mergedData[index]);
                        const targetElement = scrollBodyRef.current.querySelector(`[data-row-key="${mergedKey}"]`);
                        if (targetElement) {
                            if (!offset) // No offset, use scrollIntoView for default behavior
                            targetElement.scrollIntoView();
                            else {
                                // With offset, use element's offsetTop + offset
                                const elementTop = targetElement.offsetTop;
                                scrollBodyRef.current.scrollTo({
                                    top: elementTop + offset
                                });
                            }
                        }
                    }
                } else if (scrollBodyRef.current?.scrollTo) // Pass to proxy
                scrollBodyRef.current.scrollTo(config);
            }
        };
    });
    // ====================== Scroll ======================
    const scrollSummaryRef = $acw62.useRef(null);
    const [shadowStart, setShadowStart] = $acw62.useState(false);
    const [shadowEnd, setShadowEnd] = $acw62.useState(false);
    const [colsWidths, updateColsWidths] = $acw62.useState(new Map());
    // Convert map to number width
    const colsKeys = (0, $52967433957611b9$export$fd2ca5407d9be470)(flattenColumns);
    const pureColWidths = colsKeys.map((columnKey)=>colsWidths.get(columnKey));
    const colWidths = $acw62.useMemo(()=>pureColWidths, [
        pureColWidths.join('_')
    ]);
    const stickyOffsets = (0, $fb9070694ef3ad1a$export$2e2bcd8739ae039)(colWidths, flattenColumns);
    const fixHeader = scroll && (0, $52967433957611b9$export$b76e9316566cc26e)(scroll.y);
    const horizonScroll = scroll && (0, $52967433957611b9$export$b76e9316566cc26e)(mergedScrollX) || Boolean(expandableConfig.fixed);
    const fixColumn = horizonScroll && flattenColumns.some(({ fixed: fixed })=>fixed);
    // Sticky
    const stickyRef = $acw62.useRef(null);
    const { isSticky: isSticky, offsetHeader: offsetHeader, offsetSummary: offsetSummary, offsetScroll: offsetScroll, stickyClassName: stickyClassName, container: container } = (0, $839b569c5500075b$export$2e2bcd8739ae039)(sticky, prefixCls);
    // Footer (Fix footer must fixed header)
    const summaryNode = $acw62.useMemo(()=>summary?.(mergedData), [
        summary,
        mergedData
    ]);
    const fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $acw62.isValidElement(summaryNode) && summaryNode.type === (0, $e071a9f3ba14b969$export$2e2bcd8739ae039) && summaryNode.props.fixed;
    // Scroll
    let scrollXStyle;
    let scrollYStyle;
    let scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: hasData ? 'scroll' : 'auto',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        };
        // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: mergedScrollX === true ? 'auto' : mergedScrollX,
            minWidth: '100%'
        };
    }
    const onColumnResize = $acw62.useCallback((columnKey, width)=>{
        updateColsWidths((widths)=>{
            if (widths.get(columnKey) !== width) {
                const newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    const [setScrollTarget, getScrollTarget] = (0, $f0fd129f9ee30d06$export$d63c72d5e6d02249)(null);
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) {
            target.scrollLeft = scrollLeft;
            // Delay to force scroll position if not sync
            // ref: https://github.com/ant-design/ant-design/issues/37179
            if (target.scrollLeft !== scrollLeft) setTimeout(()=>{
                target.scrollLeft = scrollLeft;
            }, 0);
        }
    }
    const [scrollInfo, setScrollInfo] = $acw62.useState([
        0,
        0
    ]);
    const onInternalScroll = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(({ currentTarget: currentTarget, scrollLeft: scrollLeft })=>{
        const mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        const compareTarget = currentTarget || $dfb65e8e39c1bbc2$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, stickyRef.current?.setScrollLeft);
        }
        const measureTarget = currentTarget || scrollHeaderRef.current;
        if (measureTarget) {
            const scrollWidth = // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
            useInternalHooks && tailor && typeof mergedScrollX === 'number' ? mergedScrollX : measureTarget.scrollWidth;
            const clientWidth = measureTarget.clientWidth;
            const absScrollStart = Math.abs(mergedScrollLeft);
            setScrollInfo((ori)=>{
                const nextScrollInfo = [
                    absScrollStart,
                    scrollWidth - clientWidth
                ];
                return (0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(ori, nextScrollInfo) ? ori : nextScrollInfo;
            });
            // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setShadowStart(false);
                setShadowEnd(false);
                return;
            }
            setShadowStart(absScrollStart > 0);
            setShadowEnd(absScrollStart < scrollWidth - clientWidth - 1);
        }
    });
    const onBodyScroll = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((e)=>{
        onInternalScroll(e);
        onScroll?.(e);
    });
    const triggerOnScroll = ()=>{
        if (horizonScroll && scrollBodyRef.current) onInternalScroll({
            currentTarget: (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(scrollBodyRef.current),
            scrollLeft: scrollBodyRef.current?.scrollLeft
        });
        else {
            setShadowStart(false);
            setShadowEnd(false);
        }
    };
    const onFullTableResize = (offsetWidth)=>{
        stickyRef.current?.checkScrollBarVisible();
        let mergedWidth = offsetWidth ?? fullTableRef.current?.offsetWidth ?? 0;
        if (useInternalHooks && getContainerWidth && fullTableRef.current) mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
        if (mergedWidth !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(mergedWidth);
        }
    };
    // fix https://github.com/ant-design/ant-design/issues/49279
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (horizonScroll) onFullTableResize();
    }, [
        horizonScroll
    ]);
    // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    // ===================== Effects ======================
    const [scrollbarSize, setScrollbarSize] = $acw62.useState(0);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (!tailor || !useInternalHooks) {
            if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $266768ab4357c274$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
            else setScrollbarSize((0, $266768ab4357c274$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        }
    }, []);
    // ================== INTERNAL HOOKS ==================
    $acw62.useEffect(()=>{
        if (useInternalHooks && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    });
    // ========================================================================
    // ==                               Render                               ==
    // ========================================================================
    // =================== Render: Func ===================
    const renderFixedHeaderTable = $acw62.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $2e8a0b64694d99ac$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $acw62.createElement((0, $40f6b4085cce6d6d$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode)), [
        fixFooter,
        summaryNode
    ]);
    const renderFixedFooterTable = $acw62.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $acw62.createElement((0, $40f6b4085cce6d6d$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode), [
        summaryNode
    ]);
    // =================== Render: Node ===================
    const TableComponent = getComponent([
        'table'
    ], 'table');
    // Table layout
    const mergedTableLayout = $acw62.useMemo(()=>{
        if (tableLayout) return tableLayout;
        // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return mergedScrollX === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(({ ellipsis: ellipsis })=>ellipsis)) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    let groupTableNode;
    // Header props
    const headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    };
    // Empty
    const emptyNode = $acw62.useMemo(()=>{
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]);
    // Body
    const bodyTable = /*#__PURE__*/ $acw62.createElement((0, $69380ab8a0250e3a$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky
    });
    const bodyColGroup = /*#__PURE__*/ $acw62.createElement((0, $e4f6ee82ad2c6f25$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(({ width: width })=>width),
        columns: flattenColumns
    });
    const captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/ $acw62.createElement("caption", {
        className: `${prefixCls}-caption`
    }, caption) : undefined;
    const dataProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
        data: true
    });
    const ariaProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
        aria: true
    });
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        let bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onInternalScroll
            });
            headerProps.colWidths = flattenColumns.map(({ width: width }, index)=>{
                const colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                ...scrollXStyle,
                ...scrollYStyle
            },
            onScroll: onBodyScroll,
            ref: scrollBodyRef,
            className: `${prefixCls}-body`
        }, /*#__PURE__*/ $acw62.createElement(TableComponent, $dfb65e8e39c1bbc2$var$_extends({
            style: {
                ...scrollTableStyle,
                tableLayout: mergedTableLayout
            }
        }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $acw62.createElement((0, $40f6b4085cce6d6d$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
        // Fixed holder share the props
        const fixedHolderProps = {
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && mergedScrollX === 'max-content',
            ...headerProps,
            ...columnContext,
            direction: direction,
            stickyClassName: stickyClassName,
            scrollX: mergedScrollX,
            tableLayout: mergedTableLayout,
            onScroll: onInternalScroll
        };
        groupTableNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showHeader !== false && /*#__PURE__*/ $acw62.createElement((0, $ffe0e4d1aa6fd687$export$2e2bcd8739ae039), $dfb65e8e39c1bbc2$var$_extends({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: `${prefixCls}-header`,
            ref: scrollHeaderRef,
            colGroup: bodyColGroup
        }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $acw62.createElement((0, $ffe0e4d1aa6fd687$export$2e2bcd8739ae039), $dfb65e8e39c1bbc2$var$_extends({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: `${prefixCls}-summary`,
            ref: scrollSummaryRef,
            colGroup: bodyColGroup
        }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/ $acw62.createElement((0, $45b6c77af3cf7120$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onInternalScroll,
            container: container,
            direction: direction
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            ...scrollXStyle,
            ...scrollYStyle,
            ...styles?.content
        },
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        onScroll: onInternalScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $acw62.createElement(TableComponent, $dfb65e8e39c1bbc2$var$_extends({
        style: {
            ...scrollTableStyle,
            tableLayout: mergedTableLayout
        }
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/ $acw62.createElement((0, $2e8a0b64694d99ac$export$2e2bcd8739ae039), $dfb65e8e39c1bbc2$var$_extends({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $acw62.createElement((0, $40f6b4085cce6d6d$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    const tableStyle = {
        ...style
    };
    // Add css var for sticky header `zIndex` calc
    if (isSticky) tableStyle['--columns-count'] = flattenColumns.length;
    let fullTable = /*#__PURE__*/ $acw62.createElement("div", $dfb65e8e39c1bbc2$var$_extends({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-fix-start-shadow`]: horizonScroll,
            [`${prefixCls}-fix-end-shadow`]: horizonScroll,
            [`${prefixCls}-fix-start-shadow-show`]: horizonScroll && shadowStart,
            [`${prefixCls}-fix-end-shadow-show`]: horizonScroll && shadowEnd,
            [`${prefixCls}-layout-fixed`]: tableLayout === 'fixed',
            [`${prefixCls}-fixed-header`]: fixHeader,
            /** No used but for compatible */ [`${prefixCls}-fixed-column`]: fixColumn,
            [`${prefixCls}-scroll-horizontal`]: horizonScroll,
            [`${prefixCls}-has-fix-start`]: flattenColumns[0]?.fixed,
            [`${prefixCls}-has-fix-end`]: flattenColumns[flattenColumns.length - 1]?.fixed === 'end'
        }),
        style: tableStyle,
        id: id,
        ref: fullTableRef
    }, dataProps), title && /*#__PURE__*/ $acw62.createElement((0, $b99cca23e5432c3e$export$2e2bcd8739ae039), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title(mergedData)), /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollBodyContainerRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.section),
        style: styles?.section
    }, groupTableNode), footer && /*#__PURE__*/ $acw62.createElement((0, $b99cca23e5432c3e$export$2e2bcd8739ae039), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames?.footer),
        style: styles?.footer
    }, footer(mergedData)));
    if (horizonScroll) fullTable = /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>onFullTableResize(offsetWidth)
    }, fullTable);
    const fixedInfoList = (0, $69e1af9b2a43422e$export$2e2bcd8739ae039)(flattenColumns, stickyOffsets);
    const TableContextValue = $acw62.useMemo(()=>({
            // Scroll
            scrollX: mergedScrollX,
            scrollInfo: scrollInfo,
            classNames: classNames,
            styles: styles,
            prefixCls: // Table
            prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: fixedInfoList,
            isSticky: isSticky,
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll,
            // Body
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandableConfig.expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandableConfig.expandRowByClick,
            expandedRowRender: expandableConfig.expandedRowRender,
            expandedRowOffset: expandableConfig.expandedRowOffset,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
            indentSize: expandableConfig.indentSize,
            allColumnsFixedLeft: flattenColumns.every((col)=>col.fixed === 'start'),
            emptyNode: emptyNode,
            columns: // Column
            columns,
            flattenColumns: flattenColumns,
            onColumnResize: onColumnResize,
            colWidths: colWidths,
            // Row
            hoverStartRow: startRow,
            hoverEndRow: endRow,
            onHover: onHover,
            rowExpandable: expandableConfig.rowExpandable,
            onRow: onRow,
            getRowKey: getRowKey,
            expandedKeys: mergedExpandedKeys,
            childrenColumnName: mergedChildrenColumnName,
            rowHoverable: rowHoverable,
            measureRowRender: // Measure Row
            measureRowRender
        }), [
        // Scroll
        mergedScrollX,
        scrollInfo,
        classNames,
        styles,
        // Table
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        fixedInfoList,
        isSticky,
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll,
        // Body
        mergedTableLayout,
        rowClassName,
        expandableConfig.expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandableConfig.expandRowByClick,
        expandableConfig.expandedRowRender,
        expandableConfig.expandedRowOffset,
        onTriggerExpand,
        expandableConfig.expandIconColumnIndex,
        expandableConfig.indentSize,
        emptyNode,
        // Column
        columns,
        flattenColumns,
        onColumnResize,
        colWidths,
        // Row
        startRow,
        endRow,
        onHover,
        expandableConfig.rowExpandable,
        onRow,
        getRowKey,
        mergedExpandedKeys,
        mergedChildrenColumnName,
        rowHoverable,
        measureRowRender
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $395c79e6e08309bc$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, fullTable);
};
const $dfb65e8e39c1bbc2$var$RefTable = /*#__PURE__*/ $acw62.forwardRef($dfb65e8e39c1bbc2$var$Table);
const $dfb65e8e39c1bbc2$export$13da147d1fdf3e3c = (shouldTriggerRender)=>{
    return (0, $395c79e6e08309bc$export$ffd6d5bef5eaf0a4)($dfb65e8e39c1bbc2$var$RefTable, shouldTriggerRender);
};
const $dfb65e8e39c1bbc2$var$ImmutableTable = $dfb65e8e39c1bbc2$export$13da147d1fdf3e3c();
$dfb65e8e39c1bbc2$var$ImmutableTable.EXPAND_COLUMN = (0, $3b2a2eb42115b4e5$export$e1053575ddfcb301);
$dfb65e8e39c1bbc2$var$ImmutableTable.INTERNAL_HOOKS = (0, $3b2a2eb42115b4e5$export$91b75cf262680225);
$dfb65e8e39c1bbc2$var$ImmutableTable.Column = (0, $d0280dd7944801c3$export$2e2bcd8739ae039);
$dfb65e8e39c1bbc2$var$ImmutableTable.ColumnGroup = (0, $98287771cdc4caae$export$2e2bcd8739ae039);
$dfb65e8e39c1bbc2$var$ImmutableTable.Summary = (0, $40f6b4085cce6d6d$export$d605f3af09eef683);
var $dfb65e8e39c1bbc2$export$2e2bcd8739ae039 = $dfb65e8e39c1bbc2$var$ImmutableTable;






var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");


/**
 * Fill component to provided the scroll content real height.
 */ const $f5dd9a1d5da06cfe$var$Filler = /*#__PURE__*/ $acw62.forwardRef(({ height: height, offsetY: offsetY, offsetX: offsetX, children: children, prefixCls: prefixCls, onInnerResize: onInnerResize, innerProps: innerProps, rtl: rtl, extra: extra }, ref)=>{
    let outerStyle = {};
    let innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = {
            ...innerStyle,
            transform: `translateY(${offsetY}px)`,
            [rtl ? 'marginRight' : 'marginLeft']: -offsetX,
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0
        };
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: ({ offsetHeight: offsetHeight })=>{
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        style: innerStyle,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
            [`${prefixCls}-holder-inner`]: prefixCls
        }),
        ref: ref
    }, innerProps), children, extra)));
});
$f5dd9a1d5da06cfe$var$Filler.displayName = 'Filler';
var $f5dd9a1d5da06cfe$export$2e2bcd8739ae039 = $f5dd9a1d5da06cfe$var$Filler;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $a1f4e7e39999e366$export$6d08773d2e66f8f2({ children: children, setRef: setRef }) {
    const refFunc = $acw62.useCallback((node)=>{
        setRef(node);
    }, []);
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: refFunc
    });
}


function $5dcd5ea2c8339153$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, { getKey: getKey }) {
    return list.slice(startIndex, endIndex + 1).map((item, index)=>{
        const eleIndex = startIndex + index;
        const node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        const key = getKey(item);
        return /*#__PURE__*/ $acw62.createElement((0, $a1f4e7e39999e366$export$6d08773d2e66f8f2), {
            key: key,
            setRef: (ele)=>setNodeRef(item, ele)
        }, node);
    });
}



var $acw62 = parcelRequire("acw62");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $01c1f44b98beee9b$export$38f9023d45dd4a23(min, max, start, index) {
    const beforeCount = start - min;
    const afterCount = max - start;
    const balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        const stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $01c1f44b98beee9b$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    const originLen = originList.length;
    const targetLen = targetList.length;
    let shortList;
    let longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    const notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    let diffIndex = null;
    let multiple = Math.abs(originLen - targetLen) !== 1;
    for(let i = 0; i < longList.length; i += 1){
        const shortKey = getItemKey(shortList[i]);
        const longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $3daa44bd5c5535e5$export$2e2bcd8739ae039(data, getKey, onDiff) {
    const [prevData, setPrevData] = $acw62.useState(data);
    const [diffItem, setDiffItem] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        const diff = (0, $01c1f44b98beee9b$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if (diff?.index !== undefined) {
            onDiff?.(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}




var $acw62 = parcelRequire("acw62");
const $917d32484d625512$var$isFF = typeof navigator === 'object' && /Firefox/i.test(navigator.userAgent);
var $917d32484d625512$export$2e2bcd8739ae039 = $917d32484d625512$var$isFF;



var $acw62 = parcelRequire("acw62");
var $add979d7d6ac645e$export$2e2bcd8739ae039 = (isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight)=>{
    // Do lock for a wheel when scrolling
    const lockRef = (0, $acw62.useRef)(false);
    const lockTimeoutRef = (0, $acw62.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(()=>{
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    const scrollPingRef = (0, $acw62.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return (isHorizontal, delta, smoothOffset = false)=>{
        const originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $3876c13d66690783$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    const offsetRef = (0, $acw62.useRef)(0);
    const nextFrameRef = (0, $acw62.useRef)(null);
    // Firefox patch
    const wheelValueRef = (0, $acw62.useRef)(null);
    const isMouseScrollRef = (0, $acw62.useRef)(false);
    // Scroll status sync
    const originScroll = (0, $add979d7d6ac645e$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        const event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $917d32484d625512$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            const patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $917d32484d625512$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    const wheelDirectionRef = (0, $acw62.useRef)(null);
    const wheelDirectionCleanRef = (0, $acw62.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            wheelDirectionRef.current = null;
        }, 2);
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = event;
        let mergedDeltaX = deltaX;
        let mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        const absX = Math.abs(mergedDeltaX);
        const absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $acw62 = parcelRequire("acw62");
function $2e11be995f2b48ca$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    const [key2Index, bottomList] = $acw62.useMemo(()=>[
            new Map(),
            []
        ], [
        mergedData,
        heights.id,
        itemHeight
    ]);
    const getSize = (startKey, endKey = startKey)=>{
        // Get from cache first
        let startIndex = key2Index.get(startKey);
        let endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            const dataLen = mergedData.length;
            for(let i = bottomList.length; i < dataLen; i += 1){
                const item = mergedData[i];
                const key = getKey(item);
                key2Index.set(key, i);
                const cacheHeight = heights.get(key) ?? itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}



var $acw62 = parcelRequire("acw62");
// Firefox has low performance of map.
class $9031886f49ecca50$var$CacheMap {
    maps;
    // Used for cache key
    // `useMemo` no need to update if `id` not change
    id = 0;
    diffRecords = new Map();
    constructor(){
        this.maps = Object.create(null);
    }
    set(key, value) {
        // Record prev value
        this.diffRecords.set(key, this.maps[key]);
        this.maps[key] = value;
        this.id += 1;
    }
    get(key) {
        return this.maps[key];
    }
    /**
   * CacheMap will record the key changed.
   * To help to know what's update in the next render.
   */ resetRecord() {
        this.diffRecords.clear();
    }
    getRecord() {
        return this.diffRecords;
    }
}
var $9031886f49ecca50$export$2e2bcd8739ae039 = $9031886f49ecca50$var$CacheMap;


function $e3ad579990defff8$var$parseNumber(value) {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $e3ad579990defff8$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    const [updatedMark, setUpdatedMark] = $acw62.useState(0);
    const instanceRef = (0, $acw62.useRef)(new Map());
    const heightsRef = (0, $acw62.useRef)(new (0, $9031886f49ecca50$export$2e2bcd8739ae039)());
    const promiseIdRef = (0, $acw62.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight(sync = false) {
        cancelRaf();
        const doCollect = ()=>{
            let changed = false;
            instanceRef.current.forEach((element, key)=>{
                if (element && element.offsetParent) {
                    const { offsetHeight: offsetHeight } = element;
                    const { marginTop: marginTop, marginBottom: marginBottom } = getComputedStyle(element);
                    const marginTopNum = $e3ad579990defff8$var$parseNumber(marginTop);
                    const marginBottomNum = $e3ad579990defff8$var$parseNumber(marginBottom);
                    const totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark((c)=>c + 1);
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            const id = promiseIdRef.current;
            Promise.resolve().then(()=>{
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        const key = getKey(item);
        const origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd?.(item);
            else onItemRemove?.(item);
        }
    }
    (0, $acw62.useEffect)(()=>{
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}




var $acw62 = parcelRequire("acw62");
const $a764f2fbca13a344$var$SMOOTH_PTG = 14 / 15;
function $a764f2fbca13a344$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    const touchedRef = (0, $acw62.useRef)(false);
    const touchXRef = (0, $acw62.useRef)(0);
    const touchYRef = (0, $acw62.useRef)(0);
    const elementRef = (0, $acw62.useRef)(null);
    // Smooth scroll
    const intervalRef = (0, $acw62.useRef)(null);
    /* eslint-disable prefer-const */ let cleanUpEvents;
    const onTouchMove = (e)=>{
        if (touchedRef.current) {
            const currentX = Math.ceil(e.touches[0].pageX);
            const currentY = Math.ceil(e.touches[0].pageY);
            let offsetX = touchXRef.current - currentX;
            let offsetY = touchYRef.current - currentY;
            const isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            const scrollHandled = callback(isHorizontal, isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(()=>{
                if (isHorizontal) offsetX *= $a764f2fbca13a344$var$SMOOTH_PTG;
                else offsetY *= $a764f2fbca13a344$var$SMOOTH_PTG;
                const offset = Math.floor(isHorizontal ? offsetX : offsetY);
                if (!callback(isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    const onTouchEnd = ()=>{
        touchedRef.current = false;
        cleanUpEvents();
    };
    const onTouchStart = (e)=>{
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = ()=>{
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return ()=>{
            listRef.current?.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}





var $acw62 = parcelRequire("acw62");
function $022bb5c149d8f0e4$var$smoothScrollOffset(offset) {
    return Math.floor(offset ** 0.5);
}
function $022bb5c149d8f0e4$export$dbd0143e191dc2e5(e, horizontal) {
    const obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function $022bb5c149d8f0e4$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $acw62.useEffect(()=>{
        const ele = componentRef.current;
        if (inVirtual && ele) {
            let mouseDownLock = false;
            let rafId;
            let offset;
            const stopScroll = ()=>{
                (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafId);
            };
            const continueScroll = ()=>{
                stopScroll();
                rafId = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                    onScrollOffset(offset);
                    continueScroll();
                });
            };
            const clearDragState = ()=>{
                mouseDownLock = false;
                stopScroll();
            };
            const onMouseDown = (e)=>{
                // Skip if element set draggable
                if (e.target.draggable || e.button !== 0) return;
                // Skip if nest List has handled this event
                const event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            const onMouseMove = (e)=>{
                if (mouseDownLock) {
                    const mouseY = $022bb5c149d8f0e4$export$dbd0143e191dc2e5(e, false);
                    const { top: top, bottom: bottom } = ele.getBoundingClientRect();
                    if (mouseY <= top) {
                        const diff = top - mouseY;
                        offset = -$022bb5c149d8f0e4$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        const diff = mouseY - bottom;
                        offset = $022bb5c149d8f0e4$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', clearDragState);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            ele.ownerDocument.addEventListener('dragend', clearDragState);
            return ()=>{
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', clearDragState);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                ele.ownerDocument.removeEventListener('dragend', clearDragState);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}


/* eslint-disable no-param-reassign */ 
var $acw62 = parcelRequire("acw62");



const $5b5e577e531b64d6$var$MAX_TIMES = 10;
function $5b5e577e531b64d6$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    const scrollRef = $acw62.useRef();
    const [syncState, setSyncState] = $acw62.useState(null);
    // ========================== Sync Scroll ==========================
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (syncState && syncState.times < $5b5e577e531b64d6$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState((ori)=>({
                        ...ori
                    }));
                return;
            }
            collectHeight();
            const { targetAlign: targetAlign, originAlign: originAlign, index: index, offset: offset } = syncState;
            const height = containerRef.current.clientHeight;
            let needCollectHeight = false;
            let newTargetAlign = targetAlign;
            let targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                const mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                let stackTop = 0;
                let itemTop = 0;
                let itemBottom = 0;
                const maxLen = Math.min(data.length - 1, index);
                for(let i = 0; i <= maxLen; i += 1){
                    const key = getKey(data[i]);
                    itemTop = stackTop;
                    const cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                let leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(let i = maxLen; i >= 0; i -= 1){
                    const key = getKey(data[i]);
                    const cacheHeight = heights.get(key);
                    if (cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        {
                            const { scrollTop: scrollTop } = containerRef.current;
                            const scrollBottom = scrollTop + height;
                            if (itemTop < scrollTop) newTargetAlign = 'top';
                            else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                        }
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState({
                ...syncState,
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            });
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return (arg)=>{
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && typeof arg === 'object') {
            let index;
            const { align: align } = arg;
            if ('index' in arg) ({ index: index } = arg);
            else index = data.findIndex((item)=>getKey(item) === arg.key);
            const { offset: offset = 0 } = arg;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}





var $acw62 = parcelRequire("acw62");

const $e0f81c2a4ffff139$var$ScrollBar = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, rtl: rtl, scrollOffset: scrollOffset, scrollRange: scrollRange, onStartMove: onStartMove, onStopMove: onStopMove, onScroll: onScroll, horizontal: horizontal, spinSize: spinSize, containerSize: containerSize, style: style, thumbStyle: propsThumbStyle, showScrollBar: showScrollBar } = props;
    const [dragging, setDragging] = $acw62.useState(false);
    const [pageXY, setPageXY] = $acw62.useState(null);
    const [startTop, setStartTop] = $acw62.useState(null);
    const isLTR = !rtl;
    // ========================= Refs =========================
    const scrollbarRef = $acw62.useRef();
    const thumbRef = $acw62.useRef();
    // ======================= Visible ========================
    const [visible, setVisible] = $acw62.useState(showScrollBar);
    const visibleTimeoutRef = $acw62.useRef();
    const delayHidden = ()=>{
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(()=>{
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    const enableScrollRange = scrollRange - containerSize || 0;
    const enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    const top = $acw62.useMemo(()=>{
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        const ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    const onContainerMouseDown = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    const stateRef = $acw62.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    const onThumbMouseDown = (e)=>{
        setDragging(true);
        setPageXY((0, $022bb5c149d8f0e4$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $acw62.useEffect(()=>{
        const onScrollbarTouchStart = (e)=>{
            e.preventDefault();
        };
        const scrollbarEle = scrollbarRef.current;
        const thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return ()=>{
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    const enableScrollRangeRef = $acw62.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    const enableOffsetRangeRef = $acw62.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $acw62.useEffect(()=>{
        if (dragging) {
            let moveRafId;
            const onMouseMove = (e)=>{
                const { dragging: stateDragging, pageY: statePageY, startTop: stateStartTop } = stateRef.current;
                (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(moveRafId);
                const rect = scrollbarRef.current.getBoundingClientRect();
                const scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    const offset = ((0, $022bb5c149d8f0e4$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    let newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    const tmpEnableScrollRange = enableScrollRangeRef.current;
                    const tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    const ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    let newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            const onMouseUp = ()=>{
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return ()=>{
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $acw62.useEffect(()=>{
        delayHidden();
        return ()=>{
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $acw62.useImperativeHandle(ref, ()=>({
            delayHidden: delayHidden
        }));
    // ======================== Render ========================
    const scrollbarPrefixCls = `${prefixCls}-scrollbar`;
    const containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    const thumbStyle = {
        position: 'absolute',
        borderRadius: 99,
        background: 'var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))',
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        Object.assign(containerStyle, {
            height: 8,
            left: 0,
            right: 0,
            bottom: 0
        });
        Object.assign(thumbStyle, {
            height: '100%',
            width: spinSize,
            [isLTR ? 'left' : 'right']: top
        });
    } else {
        Object.assign(containerStyle, {
            width: 8,
            top: 0,
            bottom: 0,
            [isLTR ? 'right' : 'left']: 0
        });
        Object.assign(thumbStyle, {
            width: '100%',
            height: spinSize,
            top: top
        });
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollbarRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(scrollbarPrefixCls, {
            [`${scrollbarPrefixCls}-horizontal`]: horizontal,
            [`${scrollbarPrefixCls}-vertical`]: !horizontal,
            [`${scrollbarPrefixCls}-visible`]: visible
        }),
        style: {
            ...containerStyle,
            ...style
        },
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: thumbRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${scrollbarPrefixCls}-thumb`, {
            [`${scrollbarPrefixCls}-thumb-moving`]: dragging
        }),
        style: {
            ...thumbStyle,
            ...propsThumbStyle
        },
        onMouseDown: onThumbMouseDown
    }));
});
var $e0f81c2a4ffff139$export$2e2bcd8739ae039 = $e0f81c2a4ffff139$var$ScrollBar;


const $bafa1bc538d2cbb2$var$MIN_SIZE = 20;
function $bafa1bc538d2cbb2$export$f2ca68955ab35ace(containerSize = 0, scrollRange = 0) {
    let baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $bafa1bc538d2cbb2$var$MIN_SIZE);
    return Math.floor(baseSize);
}


const $f9098bd2e2f531dc$var$EMPTY_DATA = [];
const $f9098bd2e2f531dc$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $f9098bd2e2f531dc$export$cc3be4e46e8486ed(props, ref) {
    const { prefixCls: prefixCls = 'rc-virtual-list', className: className, height: height, itemHeight: itemHeight, fullHeight: fullHeight = true, style: style, data: data, children: children, itemKey: itemKey, virtual: virtual, direction: direction, scrollWidth: scrollWidth, component: Component = 'div', onScroll: onScroll, onVirtualScroll: onVirtualScroll, onVisibleChange: onVisibleChange, innerProps: innerProps, extraRender: extraRender, styles: styles, showScrollBar: showScrollBar = 'optional', ...restProps } = props;
    // =============================== Item Key ===============================
    const getKey = $acw62.useCallback((item)=>{
        if (typeof itemKey === 'function') return itemKey(item);
        return item?.[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    const [setInstanceRef, collectHeight, heights, heightUpdatedMark] = (0, $e3ad579990defff8$export$2e2bcd8739ae039)(getKey, null, null);
    // ================================= MISC =================================
    const useVirtual = !!(virtual !== false && height && itemHeight);
    const containerHeight = $acw62.useMemo(()=>Object.values(heights.maps).reduce((total, curr)=>total + curr, 0), [
        heights.id,
        heights.maps
    ]);
    const inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    const isRTL = direction === 'rtl';
    const mergedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: isRTL
    }, className);
    const mergedData = data || $f9098bd2e2f531dc$var$EMPTY_DATA;
    const componentRef = (0, $acw62.useRef)();
    const fillerInnerRef = (0, $acw62.useRef)();
    const containerRef = (0, $acw62.useRef)();
    // =============================== Item Key ===============================
    const [offsetTop, setOffsetTop] = (0, $acw62.useState)(0);
    const [offsetLeft, setOffsetLeft] = (0, $acw62.useState)(0);
    const [scrollMoving, setScrollMoving] = (0, $acw62.useState)(false);
    const onScrollbarStartMove = ()=>{
        setScrollMoving(true);
    };
    const onScrollbarStopMove = ()=>{
        setScrollMoving(false);
    };
    const sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop((origin)=>{
            let value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            const alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    const rangeRef = (0, $acw62.useRef)({
        start: 0,
        end: mergedData.length
    });
    const diffItemRef = (0, $acw62.useRef)();
    const [diffItem] = (0, $3daa44bd5c5535e5$export$2e2bcd8739ae039)(mergedData, getKey);
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    const { scrollHeight: scrollHeight, start: start, end: end, offset: fillerOffset } = $acw62.useMemo(()=>{
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) return {
            scrollHeight: fillerInnerRef.current?.offsetHeight || 0,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        let itemTop = 0;
        let startIndex;
        let startOffset;
        let endIndex;
        const dataLen = mergedData.length;
        for(let i = 0; i < dataLen; i += 1){
            const item = mergedData[i];
            const key = getKey(item);
            const cacheHeight = heights.get(key);
            const currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]);
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $acw62.useLayoutEffect(()=>{
        const changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            const recordKey = Array.from(changedRecord.keys())[0];
            const prevCacheHeight = changedRecord.get(recordKey);
            // Quick switch data may cause `start` not in `mergedData` anymore
            const startItem = mergedData[start];
            if (startItem && prevCacheHeight === undefined) {
                const startIndexKey = getKey(startItem);
                if (startIndexKey === recordKey) {
                    const realStartHeight = heights.get(recordKey);
                    const diffHeight = realStartHeight - itemHeight;
                    syncScrollTop((ori)=>{
                        return ori + diffHeight;
                    });
                }
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    const [size, setSize] = $acw62.useState({
        width: 0,
        height: height
    });
    const onHolderResize = (sizeInfo)=>{
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    const verticalScrollBarRef = (0, $acw62.useRef)();
    const horizontalScrollBarRef = (0, $acw62.useRef)();
    const horizontalScrollBarSpinSize = $acw62.useMemo(()=>(0, $bafa1bc538d2cbb2$export$f2ca68955ab35ace)(size.width, scrollWidth), [
        size.width,
        scrollWidth
    ]);
    const verticalScrollBarSpinSize = $acw62.useMemo(()=>(0, $bafa1bc538d2cbb2$export$f2ca68955ab35ace)(size.height, scrollHeight), [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    const maxScrollHeight = scrollHeight - height;
    const maxScrollHeightRef = (0, $acw62.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        let newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    const isScrollAtTop = offsetTop <= 0;
    const isScrollAtBottom = offsetTop >= maxScrollHeight;
    const isScrollAtLeft = offsetLeft <= 0;
    const isScrollAtRight = offsetLeft >= scrollWidth;
    const originScroll = (0, $add979d7d6ac645e$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    const getVirtualScrollInfo = ()=>({
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        });
    const lastVirtualScrollInfoRef = (0, $acw62.useRef)(getVirtualScrollInfo());
    const triggerScroll = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((params)=>{
        if (onVirtualScroll) {
            const nextInfo = {
                ...getVirtualScrollInfo(),
                ...params
            };
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        const newOffset = newScrollOffset;
        if (horizontal) {
            (0, $1u0KT.flushSync)(()=>{
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        const { scrollTop: newScrollTop } = e.currentTarget;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll?.(e);
        triggerScroll();
    }
    const keepInHorizontalRange = (nextOffsetLeft)=>{
        let tmpOffsetLeft = nextOffsetLeft;
        const max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    const onWheelDelta = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((offsetXY, fromHorizontal)=>{
        if (fromHorizontal) {
            (0, $1u0KT.flushSync)(()=>{
                setOffsetLeft((left)=>{
                    const nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop((top)=>{
            const newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    const [onRawWheel, onFireFoxScroll] = (0, $3876c13d66690783$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta);
    // Mobile touch move
    (0, $a764f2fbca13a344$export$2e2bcd8739ae039)(useVirtual, componentRef, (isHorizontal, delta, smoothOffset, e)=>{
        const event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault () {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $022bb5c149d8f0e4$export$2e2bcd8739ae039)(inVirtual, componentRef, (offset)=>{
        syncScrollTop((top)=>top + offset);
    });
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            const scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            const scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        const componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return ()=>{
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (scrollWidth) {
            const newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    const delayHideScrollBar = ()=>{
        verticalScrollBarRef.current?.delayHidden();
        horizontalScrollBarRef.current?.delayHidden();
    };
    const scrollTo = (0, $5b5e577e531b64d6$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, ()=>collectHeight(true), syncScrollTop, delayHideScrollBar);
    $acw62.useImperativeHandle(ref, ()=>({
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: (config)=>{
                function isPosScroll(arg) {
                    return arg && typeof arg === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    scrollTo(config.top);
                } else scrollTo(config);
            }
        }));
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (onVisibleChange) {
            const renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    const getSize = (0, $2e11be995f2b48ca$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    const extraContent = extraRender?.({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    const listChildren = (0, $5dcd5ea2c8339153$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    let componentStyle = null;
    if (height) {
        componentStyle = {
            [fullHeight ? 'height' : 'maxHeight']: height,
            ...$f9098bd2e2f531dc$var$ScrollStyle
        };
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    const containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: containerRef,
        style: {
            ...style,
            position: 'relative'
        },
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $acw62.createElement(Component, {
        className: `${prefixCls}-holder`,
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $acw62.createElement((0, $f5dd9a1d5da06cfe$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $acw62.createElement((0, $e0f81c2a4ffff139$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles?.verticalScrollBar,
        thumbStyle: styles?.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $acw62.createElement((0, $e0f81c2a4ffff139$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles?.horizontalScrollBar,
        thumbStyle: styles?.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
const $f9098bd2e2f531dc$var$List = /*#__PURE__*/ $acw62.forwardRef($f9098bd2e2f531dc$export$cc3be4e46e8486ed);
$f9098bd2e2f531dc$var$List.displayName = 'List';
var $f9098bd2e2f531dc$export$2e2bcd8739ae039 = $f9098bd2e2f531dc$var$List;


var $164934b9257bae32$export$2e2bcd8739ae039 = (0, $f9098bd2e2f531dc$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



const $2252aba586ca1f30$export$fbb76fda59aa02a2 = (0, $2b6e94889042e439$export$fd42f52fd3ae1109)(null);
const $2252aba586ca1f30$export$11cae3e04ab99fae = (0, $2b6e94889042e439$export$fd42f52fd3ae1109)(null);


function $772f44826f8cfb65$var$_extends() {
    $772f44826f8cfb65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $772f44826f8cfb65$var$_extends.apply(this, arguments);
}
function $772f44826f8cfb65$export$dfa11a34ceba822(colIndex, colSpan, columnsOffset) {
    const mergedColSpan = colSpan || 1;
    return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
const $772f44826f8cfb65$var$VirtualCell = (props)=>{
    const { rowInfo: rowInfo, column: column, colIndex: colIndex, indent: indent, index: index, component: component, renderIndex: renderIndex, record: record, style: style, className: className, inverse: inverse, getHeight: getHeight } = props;
    const { render: render, dataIndex: dataIndex, className: columnClassName, width: colWidth } = column;
    const { columnsOffset: columnsOffset } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $2252aba586ca1f30$export$11cae3e04ab99fae), [
        'columnsOffset'
    ]);
    // TODO: support `expandableRowOffset`
    const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps } = (0, $478ffbb5030e2c55$export$16400ac709c56616)(rowInfo, column, colIndex, indent, index);
    const { style: cellStyle, colSpan: colSpan = 1, rowSpan: rowSpan = 1 } = additionalCellProps;
    // ========================= ColWidth =========================
    // column width
    const startColIndex = colIndex - 1;
    const concatColWidth = $772f44826f8cfb65$export$dfa11a34ceba822(startColIndex, colSpan, columnsOffset);
    // margin offset
    const marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
    // ========================== Style ===========================
    const mergedStyle = {
        ...cellStyle,
        ...style,
        flex: `0 0 ${concatColWidth}px`,
        width: `${concatColWidth}px`,
        marginRight: marginOffset,
        pointerEvents: 'auto'
    };
    // When `colSpan` or `rowSpan` is `0`, should skip render.
    const needHide = $acw62.useMemo(()=>{
        if (inverse) return rowSpan <= 1;
        else return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }, [
        rowSpan,
        colSpan,
        inverse
    ]);
    // 0 rowSpan or colSpan should not render
    if (needHide) mergedStyle.visibility = 'hidden';
    else if (inverse) mergedStyle.height = getHeight?.(rowSpan);
    const mergedRender = needHide ? ()=>null : render;
    // ========================== Render ==========================
    const cellSpan = {};
    // Virtual should reset `colSpan` & `rowSpan`
    if (rowSpan === 0 || colSpan === 0) {
        cellSpan.rowSpan = 1;
        cellSpan.colSpan = 1;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $c0d89061538bab98$export$2e2bcd8739ae039), $772f44826f8cfb65$var$_extends({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(columnClassName, className),
        ellipsis: column.ellipsis,
        align: column.align,
        scope: column.rowScope,
        component: component,
        prefixCls: rowInfo.prefixCls,
        key: key,
        record: record,
        index: index,
        renderIndex: renderIndex,
        dataIndex: dataIndex,
        render: mergedRender,
        shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
        appendNode: appendCellNode,
        additionalProps: {
            ...additionalCellProps,
            style: mergedStyle,
            ...cellSpan
        }
    }));
};
var $772f44826f8cfb65$export$2e2bcd8739ae039 = $772f44826f8cfb65$var$VirtualCell;




function $c4e23b30983eb52d$var$_extends() {
    $c4e23b30983eb52d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c4e23b30983eb52d$var$_extends.apply(this, arguments);
}
const $c4e23b30983eb52d$var$BodyLine = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { data: data, index: index, className: className, rowKey: rowKey, style: style, extra: extra, getHeight: getHeight, ...restProps } = props;
    const { record: record, indent: indent, index: renderIndex } = data;
    const { scrollX: scrollX, flattenColumns: flattenColumns, prefixCls: prefixCls, fixColumn: fixColumn, componentWidth: componentWidth } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'prefixCls',
        'flattenColumns',
        'fixColumn',
        'componentWidth',
        'scrollX'
    ]);
    const { getComponent: getComponent } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $2252aba586ca1f30$export$fbb76fda59aa02a2), [
        'getComponent'
    ]);
    const rowInfo = (0, $636bab8066a7a0e3$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const RowComponent = getComponent([
        'body',
        'row'
    ], 'div');
    const cellComponent = getComponent([
        'body',
        'cell'
    ], 'div');
    // ========================== Expand ==========================
    const { rowSupportExpand: rowSupportExpand, expanded: expanded, rowProps: rowProps, expandedRowRender: expandedRowRender, expandedRowClassName: expandedRowClassName } = rowInfo;
    let expandRowNode;
    if (rowSupportExpand && expanded) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        const expandedClsName = (0, $1cb6e00772e4d36d$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
        let additionalProps = {};
        if (fixColumn) additionalProps = {
            style: {
                ['--virtual-width']: `${componentWidth}px`
            }
        };
        const rowCellCls = `${prefixCls}-expanded-row-cell`;
        expandRowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName)
        }, /*#__PURE__*/ $acw62.createElement((0, $c0d89061538bab98$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rowCellCls, {
                [`${rowCellCls}-fixed`]: fixColumn
            }),
            additionalProps: additionalProps
        }, expandContent));
    }
    // ========================== Render ==========================
    const rowStyle = {
        ...style,
        width: scrollX
    };
    if (extra) {
        rowStyle.position = 'absolute';
        rowStyle.pointerEvents = 'none';
    }
    const rowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, $c4e23b30983eb52d$var$_extends({}, rowProps, restProps, {
        "data-row-key": rowKey,
        ref: rowSupportExpand ? null : ref,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, rowProps?.className, {
            [`${prefixCls}-row-extra`]: extra
        }),
        style: {
            ...rowStyle,
            ...rowProps?.style
        }
    }), flattenColumns.map((column, colIndex)=>{
        return /*#__PURE__*/ $acw62.createElement((0, $772f44826f8cfb65$export$2e2bcd8739ae039), {
            key: colIndex,
            component: cellComponent,
            rowInfo: rowInfo,
            column: column,
            colIndex: colIndex,
            indent: indent,
            index: index,
            renderIndex: renderIndex,
            record: record,
            inverse: extra,
            getHeight: getHeight
        });
    }));
    if (rowSupportExpand) return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref
    }, rowNode, expandRowNode);
    return rowNode;
});
const $c4e23b30983eb52d$var$ResponseBodyLine = (0, $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4)($c4e23b30983eb52d$var$BodyLine);
var $c4e23b30983eb52d$export$2e2bcd8739ae039 = $c4e23b30983eb52d$var$ResponseBodyLine;



const $cd131f15e0294f24$var$Grid = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { data: data, onScroll: onScroll } = props;
    const { flattenColumns: flattenColumns, onColumnResize: onColumnResize, getRowKey: getRowKey, expandedKeys: expandedKeys, prefixCls: prefixCls, childrenColumnName: childrenColumnName, scrollX: scrollX, direction: direction } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $395c79e6e08309bc$export$2e2bcd8739ae039), [
        'flattenColumns',
        'onColumnResize',
        'getRowKey',
        'prefixCls',
        'expandedKeys',
        'childrenColumnName',
        'scrollX',
        'direction'
    ]);
    const { sticky: sticky, scrollY: scrollY, listItemHeight: listItemHeight, getComponent: getComponent, onScroll: onTablePropScroll } = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $2252aba586ca1f30$export$fbb76fda59aa02a2));
    // =========================== Ref ============================
    const listRef = $acw62.useRef(null);
    // =========================== Data ===========================
    const flattenData = (0, $cf4b9058de3376db$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // ========================== Column ==========================
    const columnsWidth = $acw62.useMemo(()=>{
        let total = 0;
        return flattenColumns.map(({ width: width, minWidth: minWidth, key: key })=>{
            const finalWidth = Math.max(width || 0, minWidth || 0);
            total += finalWidth;
            return [
                key,
                finalWidth,
                total
            ];
        });
    }, [
        flattenColumns
    ]);
    const columnsOffset = $acw62.useMemo(()=>columnsWidth.map((colWidth)=>colWidth[2]), [
        columnsWidth
    ]);
    $acw62.useEffect(()=>{
        columnsWidth.forEach(([key, width])=>{
            onColumnResize(key, width);
        });
    }, [
        columnsWidth
    ]);
    // =========================== Ref ============================
    $acw62.useImperativeHandle(ref, ()=>{
        const obj = {
            scrollTo: (config)=>{
                const { offset: offset, ...restConfig } = config;
                // If offset is provided, force align to 'top' for consistent behavior
                if (offset) listRef.current?.scrollTo({
                    ...restConfig,
                    offset: offset,
                    align: 'top'
                });
                else listRef.current?.scrollTo(config);
            },
            nativeElement: listRef.current?.nativeElement
        };
        Object.defineProperty(obj, 'scrollLeft', {
            get: ()=>listRef.current?.getScrollInfo().x || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    left: value
                });
            }
        });
        // https://github.com/ant-design/ant-design/issues/54734
        Object.defineProperty(obj, 'scrollTop', {
            get: ()=>listRef.current?.getScrollInfo().y || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    top: value
                });
            }
        });
        return obj;
    });
    // ======================= Col/Row Span =======================
    const getRowSpan = (column, index)=>{
        const record = flattenData[index]?.record;
        const { onCell: onCell } = column;
        if (onCell) {
            const cellProps = onCell(record, index);
            return cellProps?.rowSpan ?? 1;
        }
        return 1;
    };
    const extraRender = (info)=>{
        const { start: start, end: end, getSize: getSize, offsetY: offsetY } = info;
        // Do nothing if no data
        if (end < 0) return null;
        // Find first rowSpan column
        let firstRowSpanColumns = flattenColumns.filter(// rowSpan is 0
        (column)=>getRowSpan(column, start) === 0);
        let startIndex = start;
        for(let i = start; i >= 0; i -= 1){
            firstRowSpanColumns = firstRowSpanColumns.filter((column)=>getRowSpan(column, i) === 0);
            if (!firstRowSpanColumns.length) {
                startIndex = i;
                break;
            }
        }
        // Find last rowSpan column
        let lastRowSpanColumns = flattenColumns.filter(// rowSpan is not 1
        (column)=>getRowSpan(column, end) !== 1);
        let endIndex = end;
        for(let i = end; i < flattenData.length; i += 1){
            lastRowSpanColumns = lastRowSpanColumns.filter((column)=>getRowSpan(column, i) !== 1);
            if (!lastRowSpanColumns.length) {
                endIndex = Math.max(i - 1, end);
                break;
            }
        }
        // Collect the line who has rowSpan
        const spanLines = [];
        for(let i = startIndex; i <= endIndex; i += 1){
            const item = flattenData[i];
            // This code will never reach, just incase
            if (!item) continue;
            if (flattenColumns.some((column)=>getRowSpan(column, i) > 1)) spanLines.push(i);
        }
        // Patch extra line on the page
        const nodes = spanLines.map((index)=>{
            const item = flattenData[index];
            const rowKey = getRowKey(item.record, index);
            const getHeight = (rowSpan)=>{
                const endItemIndex = index + rowSpan - 1;
                const endItem = flattenData[endItemIndex];
                if (!endItem || !endItem.record) {
                    // clamp 到当前可用的最后一行，或退化为默认高度
                    const safeEndIndex = Math.min(endItemIndex, flattenData.length - 1);
                    const safeEndItem = flattenData[safeEndIndex];
                    const endItemKey = getRowKey(safeEndItem.record, safeEndIndex);
                    const sizeInfo = getSize(rowKey, endItemKey);
                    return sizeInfo.bottom - sizeInfo.top;
                }
                const endItemKey = getRowKey(endItem.record, endItemIndex);
                const sizeInfo = getSize(rowKey, endItemKey);
                return sizeInfo.bottom - sizeInfo.top;
            };
            const sizeInfo = getSize(rowKey);
            return /*#__PURE__*/ $acw62.createElement((0, $c4e23b30983eb52d$export$2e2bcd8739ae039), {
                key: index,
                data: item,
                rowKey: rowKey,
                index: index,
                style: {
                    top: -offsetY + sizeInfo.top
                },
                extra: true,
                getHeight: getHeight
            });
        });
        return nodes;
    };
    // ========================= Context ==========================
    const gridContext = $acw62.useMemo(()=>({
            columnsOffset: columnsOffset
        }), [
        columnsOffset
    ]);
    // ========================== Render ==========================
    const tblPrefixCls = `${prefixCls}-tbody`;
    // default 'div' in @rc-component/virtual-list
    const wrapperComponent = getComponent([
        'body',
        'wrapper'
    ]);
    // ========================== Sticky Scroll Bar ==========================
    const horizontalScrollBarStyle = {};
    if (sticky) {
        horizontalScrollBarStyle.position = 'sticky';
        horizontalScrollBarStyle.bottom = 0;
        if (typeof sticky === 'object' && sticky.offsetScroll) horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $2252aba586ca1f30$export$11cae3e04ab99fae).Provider, {
        value: gridContext
    }, /*#__PURE__*/ $acw62.createElement((0, $164934b9257bae32$export$2e2bcd8739ae039), {
        fullHeight: false,
        ref: listRef,
        prefixCls: `${tblPrefixCls}-virtual`,
        styles: {
            horizontalScrollBar: horizontalScrollBarStyle
        },
        className: tblPrefixCls,
        height: scrollY,
        itemHeight: listItemHeight || 24,
        data: flattenData,
        itemKey: (item)=>getRowKey(item.record),
        component: wrapperComponent,
        scrollWidth: scrollX,
        direction: direction,
        onVirtualScroll: ({ x: x })=>{
            onScroll({
                currentTarget: listRef.current?.nativeElement,
                scrollLeft: x
            });
        },
        onScroll: onTablePropScroll,
        extraRender: extraRender
    }, (item, index, itemProps)=>{
        const rowKey = getRowKey(item.record, index);
        return /*#__PURE__*/ $acw62.createElement((0, $c4e23b30983eb52d$export$2e2bcd8739ae039), {
            data: item,
            rowKey: rowKey,
            index: index,
            style: itemProps.style
        });
    }));
});
const $cd131f15e0294f24$var$ResponseGrid = (0, $395c79e6e08309bc$export$e9e4cb9eb9e2b4c4)($cd131f15e0294f24$var$Grid);
var $cd131f15e0294f24$export$2e2bcd8739ae039 = $cd131f15e0294f24$var$ResponseGrid;




function $d6570e86aa37195f$var$_extends() {
    $d6570e86aa37195f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d6570e86aa37195f$var$_extends.apply(this, arguments);
}
const $d6570e86aa37195f$var$renderBody = (rawData, props)=>{
    const { ref: ref, onScroll: onScroll } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $cd131f15e0294f24$export$2e2bcd8739ae039), {
        ref: ref,
        data: rawData,
        onScroll: onScroll
    });
};
const $d6570e86aa37195f$var$VirtualTable = (props, ref)=>{
    const { data: data, columns: columns, scroll: scroll, sticky: sticky, prefixCls: prefixCls = (0, $dfb65e8e39c1bbc2$export$c42ed95a478b1ec5), className: className, listItemHeight: listItemHeight, components: components, onScroll: onScroll } = props;
    let { x: scrollX, y: scrollY } = scroll || {};
    // Fill scrollX
    if (typeof scrollX !== 'number') scrollX = 1;
    // Fill scrollY
    if (typeof scrollY !== 'number') scrollY = 500;
    const getComponent = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((path, defaultComponent)=>(0, $eb076c0d42f576f6$export$2e2bcd8739ae039)(components, path) || defaultComponent);
    // Memo this
    const onInternalScroll = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(onScroll);
    // ========================= Context ==========================
    const context = $acw62.useMemo(()=>({
            sticky: sticky,
            scrollY: scrollY,
            listItemHeight: listItemHeight,
            getComponent: getComponent,
            onScroll: onInternalScroll
        }), [
        sticky,
        scrollY,
        listItemHeight,
        getComponent,
        onInternalScroll
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $acw62.createElement((0, $2252aba586ca1f30$export$fbb76fda59aa02a2).Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement((0, $dfb65e8e39c1bbc2$export$2e2bcd8739ae039), $d6570e86aa37195f$var$_extends({}, props, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, `${prefixCls}-virtual`),
        scroll: {
            ...scroll,
            x: scrollX
        },
        components: {
            ...components,
            // fix https://github.com/ant-design/ant-design/issues/48991
            body: data?.length ? $d6570e86aa37195f$var$renderBody : undefined
        },
        columns: columns,
        internalHooks: (0, $3b2a2eb42115b4e5$export$91b75cf262680225),
        tailor: true,
        ref: ref
    })));
};
const $d6570e86aa37195f$var$RefVirtualTable = /*#__PURE__*/ $acw62.forwardRef($d6570e86aa37195f$var$VirtualTable);
const $d6570e86aa37195f$export$4747b79b36862360 = (shouldTriggerRender)=>{
    return (0, $395c79e6e08309bc$export$ffd6d5bef5eaf0a4)($d6570e86aa37195f$var$RefVirtualTable, shouldTriggerRender);
};
var $d6570e86aa37195f$export$2e2bcd8739ae039 = $d6570e86aa37195f$export$4747b79b36862360();


var $977e8e671af415ac$export$2e2bcd8739ae039 = (0, $dfb65e8e39c1bbc2$export$2e2bcd8739ae039);


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $fad2a96b4c8bbab5$var$Column = (_)=>null;
var $fad2a96b4c8bbab5$export$2e2bcd8739ae039 = $fad2a96b4c8bbab5$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $836a2b733f2d0243$var$ColumnGroup = (_)=>null;
var $836a2b733f2d0243$export$2e2bcd8739ae039 = $836a2b733f2d0243$var$ColumnGroup;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4785c2fd6b878d9a$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $4785c2fd6b878d9a$export$2e2bcd8739ae039 = $4785c2fd6b878d9a$var$DownOutlined;



function $9387210f6c0d2379$var$_extends() {
    $9387210f6c0d2379$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9387210f6c0d2379$var$_extends.apply(this, arguments);
}
const $9387210f6c0d2379$var$DownOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $9387210f6c0d2379$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4785c2fd6b878d9a$export$2e2bcd8739ae039)
    }));
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ const $9387210f6c0d2379$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9387210f6c0d2379$var$DownOutlined);
var $9387210f6c0d2379$export$2e2bcd8739ae039 = $9387210f6c0d2379$var$RefIcon;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $acw62 = parcelRequire("acw62");
const $ea57aee73349ae60$export$dfae7d399eea2568 = /*#__PURE__*/ $acw62.createContext(null);
const $ea57aee73349ae60$export$e508d6f1a100e5dd = /*#__PURE__*/ $acw62.createContext({});




var $acw62 = parcelRequire("acw62");
const $cfa97f20ebed3808$var$Indent = ({ prefixCls: prefixCls, level: level, isStart: isStart, isEnd: isEnd })=>{
    const baseClassName = `${prefixCls}-indent-unit`;
    const list = [];
    for(let i = 0; i < level; i += 1)list.push(/*#__PURE__*/ $acw62.createElement("span", {
        key: i,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(baseClassName, {
            [`${baseClassName}-start`]: isStart[i],
            [`${baseClassName}-end`]: isEnd[i]
        })
    }));
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        className: `${prefixCls}-indent`
    }, list);
};
var $cfa97f20ebed3808$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($cfa97f20ebed3808$var$Indent);


function $7cb092bcfa0f8903$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}






function $a4a4b11aebc073d4$export$1690e12b840569b9(level, index) {
    return `${level}-${index}`;
}
function $a4a4b11aebc073d4$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $a4a4b11aebc073d4$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $a4a4b11aebc073d4$export$6c519d302dced239(fieldNames) {
    const { title: title, _title: _title, key: key, children: children } = fieldNames || {};
    const mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
function $a4a4b11aebc073d4$export$702780ec64d148df(treeData, fieldNames) {
    const keys = new Map();
    function dig(list, path = '') {
        (list || []).forEach((treeNode)=>{
            const key = treeNode[fieldNames.key];
            const children = treeNode[fieldNames.children];
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(key !== null && key !== undefined, `Tree node must have a certain key: [${path}${key}]`);
            const recordKey = String(key);
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!keys.has(recordKey) || key === null || key === undefined, `Same 'key' exist in the Tree: ${recordKey}`);
            keys.set(recordKey, true);
            dig(children, `${path}${recordKey} > `);
        });
    }
    dig(treeData);
}
function $a4a4b11aebc073d4$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        const treeNodes = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(node);
        return treeNodes.map((treeNode)=>{
            // Filter invalidate node
            if (!$a4a4b11aebc073d4$export$1c189858aa1437d7(treeNode)) {
                (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            const { key: key } = treeNode;
            const { children: children, ...rest } = treeNode.props;
            const dataNode = {
                key: key,
                ...rest
            };
            const parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter((dataNode)=>dataNode);
    }
    return dig(rootNodes);
}
function $a4a4b11aebc073d4$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    const { _title: fieldTitles, key: fieldKey, children: fieldChildren } = $a4a4b11aebc073d4$export$6c519d302dced239(fieldNames);
    const expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    const flattenList = [];
    function dig(list, parent = null) {
        return list.map((treeNode, index)=>{
            const pos = $a4a4b11aebc073d4$export$1690e12b840569b9(parent ? parent.pos : '0', index);
            const mergedKey = $a4a4b11aebc073d4$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            let mergedTitle;
            for(let i = 0; i < fieldTitles.length; i += 1){
                const fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
            const flattenNode = Object.assign((0, $cdfb578fac308710$export$2e2bcd8739ae039)(treeNode, [
                ...fieldTitles,
                fieldKey,
                fieldChildren
            ]), {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [
                    ...parent ? parent.isStart : [],
                    index === 0
                ],
                isEnd: [
                    ...parent ? parent.isEnd : [],
                    index === list.length - 1
                ]
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $a4a4b11aebc073d4$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    let mergedConfig = {};
    if (typeof config === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    const { childrenPropName: childrenPropName, externalGetKey: externalGetKey, fieldNames: fieldNames } = mergedConfig;
    const { key: fieldKey, children: fieldChildren } = $a4a4b11aebc073d4$export$6c519d302dced239(fieldNames);
    const mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    let syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = (node)=>node[externalGetKey];
        else if (typeof externalGetKey === 'function') syntheticGetKey = (node)=>externalGetKey(node);
    } else syntheticGetKey = (node, pos)=>$a4a4b11aebc073d4$export$a47fb462a08de82f(node[fieldKey], pos);
    // Process
    function processNode(node, index, parent, pathNodes) {
        const children = node ? node[mergeChildrenPropName] : dataNodes;
        const pos = node ? $a4a4b11aebc073d4$export$1690e12b840569b9(parent.pos, index) : '0';
        const connectNodes = node ? [
            ...pathNodes,
            node
        ] : [];
        // Process node if is not root
        if (node) {
            const key = syntheticGetKey(node, pos);
            const data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach((subNode, subIndex)=>{
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $a4a4b11aebc073d4$export$e5d831ce033a4615(dataNodes, { initWrapper: initWrapper, processEntity: processEntity, onProcessFinished: onProcessFinished, externalGetKey: externalGetKey, childrenPropName: childrenPropName, fieldNames: fieldNames } = {}, /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey) {
    // Init config
    const mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    const posEntities = {};
    const keyEntities = {};
    let wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $a4a4b11aebc073d4$export$4b2e27469b557f9d(dataNodes, (item)=>{
        const { node: node, index: index, pos: pos, key: key, parentPos: parentPos, level: level, nodes: nodes } = item;
        const entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        const mergedKey = $a4a4b11aebc073d4$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $a4a4b11aebc073d4$export$335db82b86111fd1(isLeaf, loadData, hasChildren, loaded) {
    if (isLeaf === false) return false;
    return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
}
function $a4a4b11aebc073d4$export$d961fd523a514db5(key, { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities }) {
    const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, key);
    const treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b(props) {
    const { data: data, expanded: expanded, selected: selected, checked: checked, loaded: loaded, loading: loading, halfChecked: halfChecked, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, pos: pos, active: active, eventKey: eventKey } = props;
    const eventData = {
        ...data,
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    };
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get () {
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}


function $00996a3f5b641670$var$_extends() {
    $00996a3f5b641670$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $00996a3f5b641670$var$_extends.apply(this, arguments);
}
const $00996a3f5b641670$var$ICON_OPEN = 'open';
const $00996a3f5b641670$var$ICON_CLOSE = 'close';
const $00996a3f5b641670$var$defaultTitle = '---';
const $00996a3f5b641670$var$TreeNode = (props)=>{
    const { eventKey: eventKey, className: className, style: style, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, isLeaf: isLeaf, isStart: isStart, isEnd: isEnd, expanded: expanded, selected: selected, checked: checked, halfChecked: halfChecked, loading: loading, domRef: domRef, active: active, data: data, onMouseMove: onMouseMove, selectable: selectable, treeId: treeId, ...otherProps } = props;
    const nodeId = (0, $bba066f19964922a$export$218c8c3169c024d2)(treeId, eventKey);
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $ea57aee73349ae60$export$dfae7d399eea2568));
    const { classNames: treeClassNames, styles: styles } = context || {};
    const unstableContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $ea57aee73349ae60$export$e508d6f1a100e5dd));
    const selectHandleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [dragNodeHighlight, setDragNodeHighlight] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ======= State: Disabled State =======
    const isDisabled = !!(context.disabled || props.disabled || unstableContext.nodeDisabled?.(data));
    const isCheckable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Return false if tree or treeNode is not checkable
        if (!context.checkable || props.checkable === false) return false;
        return context.checkable;
    }, [
        context.checkable,
        props.checkable
    ]);
    // ======= Event Handlers: Selection and Check =======
    const onSelect = (e)=>{
        if (isDisabled) return;
        context.onNodeSelect(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    };
    const onCheck = (e)=>{
        if (isDisabled) return;
        if (!isCheckable || props.disableCheckbox) return;
        context.onNodeCheck(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props), !checked);
    };
    // ======= State: Selectable Check =======
    const isSelectable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Ignore when selectable is undefined or null
        if (typeof selectable === 'boolean') return selectable;
        return context.selectable;
    }, [
        selectable,
        context.selectable
    ]);
    const onSelectorClick = (e)=>{
        // Click trigger before select/check operation
        context.onNodeClick(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
        if (isSelectable) onSelect(e);
        else onCheck(e);
    };
    const onSelectorDoubleClick = (e)=>{
        context.onNodeDoubleClick(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseEnter = (e)=>{
        context.onNodeMouseEnter(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseLeave = (e)=>{
        context.onNodeMouseLeave(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    };
    const onContextMenu = (e)=>{
        context.onNodeContextMenu(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= Drag: Drag Enabled =======
    const isDraggable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data)));
    }, [
        context.draggable,
        data
    ]);
    // ======= Drag: Drag Event Handlers =======
    const onDragStart = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(true);
        context.onNodeDragStart(e, props);
        try {
            // ie throw error
            // firefox-need-it
            e.dataTransfer.setData('text/plain', '');
        } catch  {
        // empty
        }
    };
    const onDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragEnter(e, props);
    };
    const onDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragOver(e, props);
    };
    const onDragLeave = (e)=>{
        e.stopPropagation();
        context.onNodeDragLeave(e, props);
    };
    const onDragEnd = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDragEnd(e, props);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDrop(e, props);
    };
    // ======= Expand: Node Expansion =======
    const onExpand = (e)=>{
        if (loading) return;
        context.onNodeExpand(e, (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= State: Has Children =======
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const { children: children } = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
        return Boolean((children || []).length);
    }, [
        context.keyEntities,
        eventKey
    ]);
    // ======= State: Leaf Check =======
    const memoizedIsLeaf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return (0, $a4a4b11aebc073d4$export$335db82b86111fd1)(isLeaf, context.loadData, hasChildren, props.loaded);
    }, [
        isLeaf,
        context.loadData,
        hasChildren,
        props.loaded
    ]);
    // ============== Effect ==============
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Load data to avoid default expanded tree without data
        if (loading) return;
        // read from state to avoid loadData at same time
        if (typeof context.loadData === 'function' && expanded && !memoizedIsLeaf && !props.loaded) // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        context.onNodeLoad((0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props));
    }, [
        loading,
        context.loadData,
        context.onNodeLoad,
        expanded,
        memoizedIsLeaf,
        props
    ]);
    // ==================== Render: Drag Handler ====================
    const dragHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!context.draggable?.icon) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: `${context.prefixCls}-draggable-icon`
        }, context.draggable.icon);
    }, [
        context.draggable
    ]);
    // ====================== Render: Switcher ======================
    const renderSwitcherIconDom = (isInternalLeaf)=>{
        const switcherIcon = props.switcherIcon || context.switcherIcon;
        // if switcherIconDom is null, no render switcher span
        if (typeof switcherIcon === 'function') return switcherIcon({
            ...props,
            isLeaf: isInternalLeaf
        });
        return switcherIcon;
    };
    // Switcher
    const renderSwitcher = ()=>{
        if (memoizedIsLeaf) {
            // if switcherIconDom is null, no render switcher span
            const switcherIconDom = renderSwitcherIconDom(true);
            return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher-noop`)
            }, switcherIconDom) : null;
        }
        const switcherIconDom = renderSwitcherIconDom(false);
        return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            onClick: onExpand,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher_${expanded ? $00996a3f5b641670$var$ICON_OPEN : $00996a3f5b641670$var$ICON_CLOSE}`)
        }, switcherIconDom) : null;
    };
    // ====================== Checkbox ======================
    const checkboxNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!isCheckable) return null;
        // [Legacy] Custom element should be separate with `checkable` in future
        const $custom = typeof isCheckable !== 'boolean' ? isCheckable : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${context.prefixCls}-checkbox`, {
                [`${context.prefixCls}-checkbox-checked`]: checked,
                [`${context.prefixCls}-checkbox-indeterminate`]: !checked && halfChecked,
                [`${context.prefixCls}-checkbox-disabled`]: isDisabled || props.disableCheckbox
            }),
            onClick: onCheck,
            role: "checkbox",
            "aria-checked": halfChecked ? 'mixed' : checked,
            "aria-disabled": isDisabled || props.disableCheckbox,
            "aria-labelledby": nodeId
        }, $custom);
    }, [
        isCheckable,
        checked,
        halfChecked,
        isDisabled,
        props.disableCheckbox,
        nodeId
    ]);
    // ============== State: Node State (Open/Close) ==============
    const nodeState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (memoizedIsLeaf) return null;
        return expanded ? $00996a3f5b641670$var$ICON_OPEN : $00996a3f5b641670$var$ICON_CLOSE;
    }, [
        memoizedIsLeaf,
        expanded
    ]);
    // ==================== Render: Title + Icon ====================
    const iconNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__${nodeState || 'docu'}`, {
                [`${context.prefixCls}-icon_loading`]: loading
            }),
            style: styles?.itemIcon
        });
    }, [
        context.prefixCls,
        nodeState,
        loading
    ]);
    // =================== Drop Indicator ===================
    const dropIndicatorNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rootDraggable = Boolean(context.draggable);
        // allowDrop is calculated in Tree.tsx, there is no need for calc it here
        const showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
        if (!showIndicator) return null;
        return context.dropIndicatorRender({
            dropPosition: context.dropPosition,
            dropLevelOffset: context.dropLevelOffset,
            indent: context.indent,
            prefixCls: context.prefixCls,
            direction: context.direction
        });
    }, [
        context.dropPosition,
        context.dropLevelOffset,
        context.indent,
        context.prefixCls,
        context.direction,
        context.draggable,
        context.dragOverNodeKey,
        context.dropIndicatorRender
    ]);
    // Icon + Title
    const selectorNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const { title: title = $00996a3f5b641670$var$defaultTitle } = props;
        const wrapClass = `${context.prefixCls}-node-content-wrapper`;
        // Icon - Still show loading icon when loading without showIcon
        let $icon;
        if (context.showIcon) {
            const currentIcon = props.icon || context.icon;
            $icon = currentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__customize`),
                style: styles?.itemIcon
            }, typeof currentIcon === 'function' ? currentIcon(props) : currentIcon) : iconNode;
        } else if (context.loadData && loading) $icon = iconNode;
        // Title
        let titleNode;
        if (typeof title === 'function') titleNode = title(data);
        else if (context.titleRender) titleNode = context.titleRender(data);
        else titleNode = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            ref: selectHandleRef,
            title: typeof title === 'string' ? title : '',
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(wrapClass, `${wrapClass}-${nodeState || 'normal'}`, {
                [`${context.prefixCls}-node-selected`]: !isDisabled && (selected || dragNodeHighlight)
            }),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onContextMenu: onContextMenu,
            onClick: onSelectorClick,
            onDoubleClick: onSelectorDoubleClick
        }, $icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${context.prefixCls}-title`, treeClassNames?.itemTitle),
            style: styles?.itemTitle
        }, titleNode), dropIndicatorNode);
    }, [
        context.prefixCls,
        context.showIcon,
        props,
        context.icon,
        iconNode,
        context.titleRender,
        data,
        nodeState,
        onMouseEnter,
        onMouseLeave,
        onContextMenu,
        onSelectorClick,
        onSelectorDoubleClick
    ]);
    const dataOrAriaAttributeProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const { level: level } = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
    const isEndNode = isEnd[isEnd.length - 1];
    const draggableWithoutDisabled = !isDisabled && isDraggable;
    const dragging = context.draggingNodeKey === eventKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $00996a3f5b641670$var$_extends({
        ref: domRef,
        role: "treeitem",
        id: nodeId,
        "aria-expanded": memoizedIsLeaf ? undefined : expanded,
        "aria-selected": isSelectable && !isDisabled ? selected : undefined,
        "aria-checked": isCheckable && !isDisabled ? halfChecked ? 'mixed' : checked : undefined,
        "aria-disabled": isDisabled,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, `${context.prefixCls}-treenode`, treeClassNames?.item, {
            [`${context.prefixCls}-treenode-disabled`]: isDisabled,
            [`${context.prefixCls}-treenode-switcher-${expanded ? 'open' : 'close'}`]: !isLeaf,
            [`${context.prefixCls}-treenode-checkbox-checked`]: checked,
            [`${context.prefixCls}-treenode-checkbox-indeterminate`]: halfChecked,
            [`${context.prefixCls}-treenode-selected`]: selected,
            [`${context.prefixCls}-treenode-loading`]: loading,
            [`${context.prefixCls}-treenode-active`]: active,
            [`${context.prefixCls}-treenode-leaf-last`]: isEndNode,
            [`${context.prefixCls}-treenode-draggable`]: isDraggable,
            dragging: dragging,
            'drop-target': context.dropTargetKey === eventKey,
            'drop-container': context.dropContainerKey === eventKey,
            'drag-over': !isDisabled && dragOver,
            'drag-over-gap-top': !isDisabled && dragOverGapTop,
            'drag-over-gap-bottom': !isDisabled && dragOverGapBottom,
            'filter-node': context.filterTreeNode?.((0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(props)),
            [`${context.prefixCls}-treenode-leaf`]: memoizedIsLeaf
        }),
        style: {
            ...style,
            ...styles?.item
        },
        draggable: draggableWithoutDisabled,
        onDragStart: draggableWithoutDisabled ? onDragStart : undefined,
        onDragEnter: isDraggable ? onDragEnter : undefined,
        onDragOver: isDraggable ? onDragOver : undefined,
        onDragLeave: isDraggable ? onDragLeave : undefined,
        onDrop: isDraggable ? onDrop : undefined,
        onDragEnd: isDraggable ? onDragEnd : undefined,
        onMouseMove: onMouseMove
    }, dataOrAriaAttributeProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfa97f20ebed3808$export$2e2bcd8739ae039), {
        prefixCls: context.prefixCls,
        level: level,
        isStart: isStart,
        isEnd: isEnd
    }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
$00996a3f5b641670$var$TreeNode.isTreeNode = 1;
var $00996a3f5b641670$export$2e2bcd8739ae039 = $00996a3f5b641670$var$TreeNode;




function $6290ecf480ea1bbd$var$_extends() {
    $6290ecf480ea1bbd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6290ecf480ea1bbd$var$_extends.apply(this, arguments);
}
function $6290ecf480ea1bbd$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    const clone = list.slice();
    const index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $6290ecf480ea1bbd$export$10663f6bbd2fd717(list, value) {
    const clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $6290ecf480ea1bbd$export$ddaee97dc8907312(pos) {
    return pos.split('-');
}
function $6290ecf480ea1bbd$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    const dragChildrenKeys = [];
    const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig(list = []) {
        list.forEach(({ key: key, children: children })=>{
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $6290ecf480ea1bbd$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        const posArr = $6290ecf480ea1bbd$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $6290ecf480ea1bbd$export$b823688e4155eb8d(treeNodeEntity) {
    const posArr = $6290ecf480ea1bbd$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $6290ecf480ea1bbd$export$78a5519d0fb779c3(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    const { clientX: clientX, clientY: clientY } = event;
    const { top: top, height: height } = event.target.getBoundingClientRect();
    // optional chain for testing
    const horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * ((startMousePosition?.x || 0) - clientX);
    const rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
    const filteredExpandKeys = expandKeys.filter((key)=>keyEntities[key]?.children?.length);
    // find abstract drop node by horizontal offset
    let abstractDropNodeEntity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, targetNodeProps.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        const nodeIndex = flattenedNodes.findIndex((flattenedNode)=>flattenedNode.key === abstractDropNodeEntity.key);
        const prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        const prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    const initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    const abstractDragOverEntity = abstractDropNodeEntity;
    const dragOverNodeKey = abstractDropNodeEntity.key;
    let dropPosition = 0;
    let dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) for(let i = 0; i < rawDropLevelOffset; i += 1){
        if ($6290ecf480ea1bbd$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    const abstractDragDataNode = dragNodeProps.data;
    const abstractDropDataNode = abstractDropNodeEntity.node;
    let dropAllowed = true;
    if ($6290ecf480ea1bbd$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : abstractDropNodeEntity.parent?.key || null,
        dropAllowed: dropAllowed
    };
}
function $6290ecf480ea1bbd$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    const { multiple: multiple } = props;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
const $6290ecf480ea1bbd$var$internalProcessProps = (props)=>props;
function $6290ecf480ea1bbd$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    const { processProps: processProps = $6290ecf480ea1bbd$var$internalProcessProps } = processor || {};
    const list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(({ children: children, ...props })=>{
        const childrenNodes = $6290ecf480ea1bbd$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00996a3f5b641670$export$2e2bcd8739ae039), $6290ecf480ea1bbd$var$_extends({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $6290ecf480ea1bbd$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    let keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if (typeof keys === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
function $6290ecf480ea1bbd$export$fac4a40c345ccd80(keyList, keyEntities) {
    const expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        const { parent: parent, node: node } = entity;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach((key)=>{
        conductUp(key);
    });
    return [
        ...expandedKeys
    ];
}




function $a76a7570d4fe3ae6$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    const filteredKeys = new Set();
    halfCheckedKeys.forEach((key)=>{
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $a76a7570d4fe3ae6$export$ab01c86170b1dea0(node) {
    const { disabled: disabled, disableCheckbox: disableCheckbox, checkable: checkable } = node || {};
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $a76a7570d4fe3ae6$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    const halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($a76a7570d4fe3ae6$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $a76a7570d4fe3ae6$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    let halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($a76a7570d4fe3ae6$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $a76a7570d4fe3ae6$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    const warningMissKeys = [];
    let syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $a76a7570d4fe3ae6$export$ab01c86170b1dea0;
    // We only handle exist keys
    const keys = new Set(keyList.filter((key)=>{
        const hasEntity = !!(0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    const levelEntities = new Map();
    let maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach((key)=>{
        const entity = keyEntities[key];
        const { level: level } = entity;
        let levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!warningMissKeys.length, `Tree missing follow keys: ${warningMissKeys.slice(0, 100).map((key)=>`'${key}'`).join(', ')}`);
    let result;
    if (checked === true) result = $a76a7570d4fe3ae6$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $a76a7570d4fe3ae6$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}






var $acw62 = parcelRequire("acw62");
const $220d9bc86e982cbe$export$3f339a531a4f3fb4 = (getKey)=>{
    const [prevSelectedIndex, setPrevSelectedIndex] = (0, $acw62.useState)(null);
    const multipleSelect = (0, $acw62.useCallback)((currentSelectedIndex, data, selectedKeys)=>{
        const configPrevSelectedIndex = prevSelectedIndex ?? currentSelectedIndex;
        // add/delete the selected range
        const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
        const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
        const rangeKeys = data.slice(startIndex, endIndex + 1).map(getKey);
        const shouldSelected = rangeKeys.some((rangeKey)=>!selectedKeys.has(rangeKey));
        const changedKeys = [];
        rangeKeys.forEach((item)=>{
            if (shouldSelected) {
                if (!selectedKeys.has(item)) changedKeys.push(item);
                selectedKeys.add(item);
            } else {
                selectedKeys.delete(item);
                changedKeys.push(item);
            }
        });
        setPrevSelectedIndex(shouldSelected ? endIndex : null);
        return changedKeys;
    }, [
        prevSelectedIndex
    ]);
    return [
        multipleSelect,
        setPrevSelectedIndex
    ];
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $37a273268aa78566$var$_extends() {
    $37a273268aa78566$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $37a273268aa78566$var$_extends.apply(this, arguments);
}
const $37a273268aa78566$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-checkbox', className: className, style: style, checked: checked, disabled: disabled, defaultChecked: defaultChecked = false, type: type = 'checkbox', title: title, onChange: onChange, ...inputProps } = props;
    const inputRef = (0, $acw62.useRef)(null);
    const holderRef = (0, $acw62.useRef)(null);
    const [rawValue, setRawValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultChecked, checked);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        }));
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled
    });
    const handleChange = (e)=>{
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange?.({
            target: {
                ...props,
                type: type,
                checked: e.target.checked
            },
            stopPropagation () {
                e.stopPropagation();
            },
            preventDefault () {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $acw62.createElement("input", $37a273268aa78566$var$_extends({}, inputProps, {
        className: `${prefixCls}-input`,
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })));
});
var $37a273268aa78566$export$2e2bcd8739ae039 = $37a273268aa78566$export$48513f6b9f8ce62d;















var $acw62 = parcelRequire("acw62");
const $73625a15de7a6c87$var$GroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $73625a15de7a6c87$export$2e2bcd8739ae039 = $73625a15de7a6c87$var$GroupContext;






const $04e90e571fcd1828$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls, checkboxSize: checkboxSize, lineWidth: lineWidth } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                flexWrap: 'wrap',
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            },
            // Wrapper
            [wrapperCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                alignItems: 'baseline',
                cursor: 'pointer',
                // Fix checkbox & radio in flex align #30260
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    overflow: 'hidden',
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                },
                [`&${wrapperCls}-in-form-item`]: {
                    'input[type="checkbox"]': {
                        width: 14,
                        // FIXME: magic
                        height: 14 // FIXME: magic
                    }
                }
            },
            // Wrapper > Checkbox
            [checkboxCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: 'center',
                // Styles moved from inner
                boxSizing: 'border-box',
                display: 'block',
                width: checkboxSize,
                height: checkboxSize,
                direction: 'ltr',
                backgroundColor: token.colorBgContainer,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${token.colorBorder}`,
                borderRadius: token.borderRadiusSM,
                borderCollapse: 'separate',
                transition: `all ${token.motionDurationSlow}`,
                flex: 'none',
                ...(0, $ab57165ca056af8c$export$c5b4e7cabb00fc99)(),
                // Checkmark
                '&:after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    top: `calc(${checkboxSize} / 2 - ${lineWidth})`,
                    insetInlineStart: `calc(${checkboxSize} / 4 - ${lineWidth})`,
                    display: 'table',
                    width: token.calc(checkboxSize).div(14).mul(5).equal(),
                    height: token.calc(checkboxSize).div(14).mul(8).equal(),
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorWhite}`,
                    borderTop: 0,
                    borderInlineStart: 0,
                    transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
                    opacity: 0,
                    content: '""',
                    transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`,
                    ...(0, $ab57165ca056af8c$export$c5b4e7cabb00fc99)()
                },
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: 'absolute',
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: `calc(-1 * (${lineWidth}))`,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0
                },
                // Focus outline on checkbox when input is focus-visible
                [`&:has(${checkboxCls}-input:focus-visible)`]: (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token),
                // Wrapper > Checkbox + Text
                '& + span': {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            }
        },
        // ===================== Hover =====================
        {
            // Wrapper & Wrapper > Checkbox
            [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}`]: {
                    borderColor: token.colorPrimary
                }
            },
            [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled)`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                backgroundColor: token.colorPrimary,
                borderColor: token.colorPrimary,
                '&:after': {
                    opacity: 1,
                    transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                    transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`,
                    ...(0, $ab57165ca056af8c$export$c5b4e7cabb00fc99)()
                },
                // Hover on checked checkbox directly
                [`&:not(${checkboxCls}-disabled):hover`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                '&-indeterminate': {
                    backgroundColor: token.colorBgContainer,
                    borderColor: token.colorBorder,
                    '&:after': {
                        top: '50%',
                        insetInlineStart: '50%',
                        width: token.calc(token.fontSizeLG).div(2).equal(),
                        height: token.calc(token.fontSizeLG).div(2).equal(),
                        backgroundColor: token.colorPrimary,
                        border: 0,
                        transform: 'translate(-50%, -50%) scale(1)',
                        opacity: 1,
                        content: '""'
                    },
                    // https://github.com/ant-design/ant-design/issues/50074
                    '&:hover': {
                        backgroundColor: token.colorBgContainer,
                        borderColor: token.colorPrimary
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: 'not-allowed'
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: 'none'
                },
                // Disabled checkbox styles
                background: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                '&:after': {
                    borderColor: token.colorTextDisabled
                },
                '& + span': {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $04e90e571fcd1828$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return $04e90e571fcd1828$export$92a97fe1d1148438(checkboxToken);
}
var $04e90e571fcd1828$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Checkbox', (token, { prefixCls: prefixCls })=>[
        $04e90e571fcd1828$export$3d2f074408bd1b82(prefixCls, token)
    ]);



var $acw62 = parcelRequire("acw62");

function $31d745f9760ef9bd$export$2e2bcd8739ae039(onOriginInputClick) {
    const labelClickLockRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clearLock = ()=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick?.(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}


"use client";
const $04e12b22f131287e$var$InternalCheckbox = (props, ref)=>{
    const { prefixCls: customizePrefixCls, children: children, indeterminate: indeterminate = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled, rootClassName: // Style
    rootClassName, className: className, style: style, classNames: classNames, styles: styles, name: // Name
    name, value: // Value
    value, checked: // Checked
    checked, defaultChecked: defaultChecked, onChange: onChange, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('checkbox');
    const checkboxGroup = $acw62.useContext((0, $73625a15de7a6c87$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const contextDisabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = (checkboxGroup?.disabled || disabled) ?? contextDisabled;
    // ============================= Checked ==============================
    const [innerChecked, setInnerChecked] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultChecked, checked);
    let mergedChecked = innerChecked;
    const onInternalChange = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        setInnerChecked(event.target.checked);
        onChange?.(event);
        if (!skipGroup && checkboxGroup?.toggleOption) checkboxGroup.toggleOption({
            label: children,
            value: value
        });
    });
    // ============================== Group ===============================
    if (checkboxGroup && !skipGroup) mergedChecked = checkboxGroup.value.includes(value);
    const checkboxRef = $acw62.useRef(null);
    const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(ref, checkboxRef);
    $acw62.useEffect(()=>{
        if (skipGroup || !checkboxGroup) return;
        checkboxGroup.registerValue(value);
        return ()=>{
            checkboxGroup.cancelValue(value);
        };
    }, [
        value,
        skipGroup
    ]);
    // ========================== Indeterminate ===========================
    $acw62.useEffect(()=>{
        if (checkboxRef.current?.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $04e90e571fcd1828$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = {
        ...restProps
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        indeterminate: indeterminate,
        disabled: mergedDisabled,
        checked: mergedChecked
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-checked`]: mergedChecked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $ede16c18199d1556$export$23466a5792b7a5d3), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $31d745f9760ef9bd$export$2e2bcd8739ae039)(checkboxProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $acw62.createElement("label", {
        className: classString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ $acw62.createElement((0, $37a273268aa78566$export$2e2bcd8739ae039), {
        ...checkboxProps,
        name: !skipGroup && checkboxGroup ? checkboxGroup.name : name,
        checked: mergedChecked,
        onClick: onInputClick,
        onChange: onInternalChange,
        prefixCls: prefixCls,
        className: checkboxClass,
        style: mergedStyles.icon,
        disabled: mergedDisabled,
        ref: mergedRef,
        value: value
    }), (0, $b956dab96d0e505b$export$826fff653a329e83)(children) && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children)));
};
const $04e12b22f131287e$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef($04e12b22f131287e$var$InternalCheckbox);
var $04e12b22f131287e$export$2e2bcd8739ae039 = $04e12b22f131287e$var$Checkbox;




var $acw62 = parcelRequire("acw62");








"use client";
const $727f72b27c7ab10d$var$CheckboxGroup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange, role: role = 'group', ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [value, setValue] = $acw62.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoizedOptions = $acw62.useMemo(()=>options.map((option)=>{
            if (typeof option === 'string' || (0, $b956dab96d0e505b$export$7e4aa119212bc614)(option)) return {
                label: option,
                value: option
            };
            return option;
        }), [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        onChange?.(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoizedOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoizedOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $04e90e571fcd1828$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, [
        'value',
        'disabled'
    ]);
    const childrenNode = options.length ? memoizedOptions.map((option)=>/*#__PURE__*/ $acw62.createElement((0, $04e12b22f131287e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, option.className),
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const memoizedContext = $acw62.useMemo(()=>({
            toggleOption: toggleOption,
            value: value,
            disabled: restProps.disabled,
            name: restProps.name,
            registerValue: // https://github.com/ant-design/ant-design/issues/16376
            registerValue,
            cancelValue: cancelValue
        }), [
        toggleOption,
        value,
        restProps.disabled,
        restProps.name,
        registerValue,
        cancelValue
    ]);
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: classString,
        style: style,
        role: role,
        ...domProps,
        ref: ref
    }, /*#__PURE__*/ $acw62.createElement((0, $73625a15de7a6c87$export$2e2bcd8739ae039).Provider, {
        value: memoizedContext
    }, childrenNode));
});
var $727f72b27c7ab10d$export$2e2bcd8739ae039 = $727f72b27c7ab10d$var$CheckboxGroup;


"use client";
const $da237ba92f78ed9a$var$Checkbox = (0, $04e12b22f131287e$export$2e2bcd8739ae039);
$da237ba92f78ed9a$var$Checkbox.Group = (0, $727f72b27c7ab10d$export$2e2bcd8739ae039);
$da237ba92f78ed9a$var$Checkbox.__ANT_CHECKBOX = true;
var $da237ba92f78ed9a$export$2e2bcd8739ae039 = $da237ba92f78ed9a$var$Checkbox;



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const { ESC: $5ba68aceec0e348b$var$ESC, TAB: $5ba68aceec0e348b$var$TAB } = (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039);
function $5ba68aceec0e348b$export$2e2bcd8739ae039({ visible: visible, triggerRef: triggerRef, onVisibleChange: onVisibleChange, autoFocus: autoFocus, overlayRef: overlayRef }) {
    const focusMenuRef = $acw62.useRef(false);
    const handleCloseMenuAndReturnFocus = ()=>{
        if (visible) {
            triggerRef.current?.focus?.();
            onVisibleChange?.(false);
        }
    };
    const focusMenu = ()=>{
        if (overlayRef.current?.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    const handleKeyDown = (event)=>{
        switch(event.keyCode){
            case $5ba68aceec0e348b$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $5ba68aceec0e348b$var$TAB:
                {
                    let focusResult = false;
                    if (!focusMenuRef.current) focusResult = focusMenu();
                    if (focusResult) event.preventDefault();
                    else handleCloseMenuAndReturnFocus();
                    break;
                }
        }
    };
    $acw62.useEffect(()=>{
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(focusMenu, 3);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return ()=>{
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}




var $acw62 = parcelRequire("acw62");
const $268e0e2d5be037c8$var$Overlay = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { overlay: overlay, arrow: arrow, prefixCls: prefixCls } = props;
    const overlayNode = (0, $acw62.useMemo)(()=>{
        let overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    const composedRef = (0, $6c628207f5089a39$export$ab452c34e8e05029)(ref, (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(overlayNode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(overlayNode, {
        ref: (0, $6c628207f5089a39$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $268e0e2d5be037c8$export$2e2bcd8739ae039 = $268e0e2d5be037c8$var$Overlay;


const $1409c7b8eafb5d21$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $1409c7b8eafb5d21$var$targetOffset = [
    0,
    0
];
const $1409c7b8eafb5d21$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $1409c7b8eafb5d21$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $1409c7b8eafb5d21$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $1409c7b8eafb5d21$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $1409c7b8eafb5d21$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $1409c7b8eafb5d21$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $1409c7b8eafb5d21$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $1409c7b8eafb5d21$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $1409c7b8eafb5d21$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $1409c7b8eafb5d21$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $1409c7b8eafb5d21$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $1409c7b8eafb5d21$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $1409c7b8eafb5d21$var$targetOffset
    }
};
var $1409c7b8eafb5d21$export$2e2bcd8739ae039 = $1409c7b8eafb5d21$var$placements;


function $69af79895d1d6f5d$var$_extends() {
    $69af79895d1d6f5d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69af79895d1d6f5d$var$_extends.apply(this, arguments);
}
const $69af79895d1d6f5d$var$Dropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { arrow: arrow = false, prefixCls: prefixCls = 'rc-dropdown', transitionName: transitionName, animation: animation, align: align, placement: placement = 'bottomLeft', placements: placements = (0, $1409c7b8eafb5d21$export$2e2bcd8739ae039), getPopupContainer: getPopupContainer, showAction: showAction, hideAction: hideAction, overlayClassName: overlayClassName, overlayStyle: overlayStyle, visible: visible, trigger: trigger = [
        'hover'
    ], autoFocus: autoFocus, overlay: overlay, children: children, onVisibleChange: onVisibleChange, ...otherProps } = props;
    const [triggerVisible, setTriggerVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const mergedVisible = 'visible' in props ? visible : triggerVisible;
    const mergedMotionName = animation ? `${prefixCls}-${animation}` : transitionName;
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const childRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>triggerRef.current);
    const handleVisibleChange = (newVisible)=>{
        setTriggerVisible(newVisible);
        onVisibleChange?.(newVisible);
    };
    (0, $5ba68aceec0e348b$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    const onClick = (e)=>{
        const { onOverlayClick: onOverlayClick } = props;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    const getMenuElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $268e0e2d5be037c8$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    const getMenuElementOrLambda = ()=>{
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = ()=>{
        const { minOverlayWidthMatchTrigger: minOverlayWidthMatchTrigger, alignPoint: alignPoint } = props;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    const getOpenClassName = ()=>{
        const { openClassName: openClassName } = props;
        if (openClassName !== undefined) return openClassName;
        return `${prefixCls}-open`;
    };
    const childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(children.props?.className, mergedVisible && getOpenClassName()),
        ref: (0, $6c628207f5089a39$export$c1cec34af06bcf7)(children) ? (0, $6c628207f5089a39$export$ab452c34e8e05029)(childRef, (0, $6c628207f5089a39$export$7465e5c0bf44f19a)(children)) : undefined
    });
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), $69af79895d1d6f5d$var$_extends({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        }),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupMotion: {
            motionName: mergedMotionName
        },
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onOpenChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
});
var $69af79895d1d6f5d$export$2e2bcd8739ae039 = $69af79895d1d6f5d$var$Dropdown;


var $7027a4f5eab04175$export$2e2bcd8739ae039 = (0, $69af79895d1d6f5d$export$2e2bcd8739ae039);








var $acw62 = parcelRequire("acw62");


"use client";
function $91653a8941ab7768$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $acw62.createElement(Component, {
            ...props
        }));
}
/* istanbul ignore next */ const $91653a8941ab7768$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $acw62.useRef(null);
        const [popupHeight, setPopupHeight] = $acw62.useState(0);
        const [popupWidth, setPopupWidth] = $acw62.useState(0);
        const [open, setOpen] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(false, props.open);
        const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $acw62.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = holderRef.current?.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = {
            ...props,
            style: {
                ...style,
                margin: 0
            },
            open: open,
            getPopupContainer: ()=>holderRef.current
        };
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) mergedProps = {
            ...mergedProps,
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        };
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $acw62.createElement(Component, {
            ...mergedProps
        }));
    };
    return $91653a8941ab7768$export$29e2a8c3cdb34b03(PurePanel);
};
var $91653a8941ab7768$export$2e2bcd8739ae039 = $91653a8941ab7768$var$genPurePanel;














const $103c380d878d9852$export$c81b62e088da1305 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$6c1eca72ac4f6672 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$export$8dd54688d033571 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$be161c4e647bea9b = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$export$a984c43131c7d145 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$e141ac6798b476df = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$export$ab676201eaaca05 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$ec1b91b8ec2f6331 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$var$moveMotion = {
    'move-up': {
        inKeyframes: $103c380d878d9852$export$ab676201eaaca05,
        outKeyframes: $103c380d878d9852$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $103c380d878d9852$export$c81b62e088da1305,
        outKeyframes: $103c380d878d9852$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $103c380d878d9852$export$8dd54688d033571,
        outKeyframes: $103c380d878d9852$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $103c380d878d9852$export$a984c43131c7d145,
        outKeyframes: $103c380d878d9852$export$e141ac6798b476df
    }
};
const $103c380d878d9852$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $103c380d878d9852$var$moveMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





const $40b8ffab092920b4$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $40b8ffab092920b4$export$2e2bcd8739ae039 = $40b8ffab092920b4$var$genStatusStyle;


// =============================== Base ===============================
const $df81a0a68f1a30be$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                '&-menu-vertical': {
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                '&-hidden, &-menu-hidden, &-menu-submenu-hidden': {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $f8b44896cb986807$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $f8b44896cb986807$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $f8b44896cb986807$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $f8b44896cb986807$export$f7243fdb9c27c3b7)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                [menuCls]: {
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary,
                    ...(0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token),
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        '> a': {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: {
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 'normal',
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        },
                        ...(0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token),
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    },
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, 'slide-down'),
            (0, $103c380d878d9852$export$913b1b7e3288c319)(token, 'move-up'),
            (0, $103c380d878d9852$export$913b1b7e3288c319)(token, 'move-down'),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(token, 'zoom-big')
        ]
    ];
};
const $df81a0a68f1a30be$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2,
        ...(0, $13cd8c878b3c9176$export$bddc192327bb9823)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, $0c0596420865f622$export$87e38ee403661ccc)(token)
    });
var $df81a0a68f1a30be$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Dropdown', (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $df81a0a68f1a30be$var$genBaseStyle(dropdownToken),
        (0, $40b8ffab092920b4$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $df81a0a68f1a30be$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $c311d16d3fa9262a$var$_Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom'
];
const $c311d16d3fa9262a$var$Dropdown = (props)=>{
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, popupRender: popupRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = '', transitionName: transitionName, classNames: classNames, styles: styles, destroyPopupOnHide: destroyPopupOnHide, destroyOnHidden: destroyOnHidden } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('dropdown');
    const mergedProps = {
        ...props,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        autoAdjustOverflow: autoAdjustOverflow
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedRootStyles = {
        ...contextStyle,
        ...overlayStyle,
        ...mergedStyles.root
    };
    const mergedPopupRender = popupRender || dropdownRender;
    // =================== Warning =====================
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Dropdown');
    var deprecatedName, newName;
    const memoTransitionName = $acw62.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $acw62.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $df81a0a68f1a30be$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const child = $acw62.Children.only((0, $b956dab96d0e505b$export$c3825b437cbdea5c)(children) ? /*#__PURE__*/ $acw62.createElement("span", null, children) : children);
    const popupTrigger = (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: child.props.disabled ?? disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!triggerActions?.includes('contextMenu');
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(false, open);
    const onInnerOpenChange = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextOpen)=>{
        onOpenChange?.(nextOpen, {
            source: 'trigger'
        });
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
        arrowPointAtCenter: (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(arrow) && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(()=>{
        if (menu?.selectable && menu?.multiple) return;
        onOpenChange?.(false, {
            source: 'menu'
        });
        setOpen(false);
    });
    const renderOverlay = ()=>{
        // @rc-component/dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to @rc-component/dropdown.
        const menuClassNames = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(mergedClassNames, [
            'root'
        ]);
        const menuStyles = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(mergedStyles, [
            'root'
        ]);
        let overlayNode;
        if (menu?.items) overlayNode = /*#__PURE__*/ $acw62.createElement((0, $47077f34c49bbd52$export$2e2bcd8739ae039), {
            ...menu,
            classNames: {
                ...menuClassNames,
                subMenu: {
                    ...menuClassNames
                }
            },
            styles: {
                ...menuStyles,
                subMenu: {
                    ...menuStyles
                }
            }
        });
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        overlayNode = $acw62.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $acw62.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $acw62.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === 'rtl' ? /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode: mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('Dropdown', mergedRootStyles.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $acw62.createElement((0, $7027a4f5eab04175$export$2e2bcd8739ae039), {
        alignPoint: alignPoint,
        ...(0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
            'rootClassName',
            'onOpenChange'
        ]),
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: {
            ...mergedRootStyles,
            zIndex: zIndex
        },
        autoDestroy: destroyOnHidden ?? destroyPopupOnHide
    }, popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return renderNode;
};
// We don't care debug panel
const $c311d16d3fa9262a$var$PurePanel = (0, $91653a8941ab7768$export$2e2bcd8739ae039)($c311d16d3fa9262a$var$Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $c311d16d3fa9262a$var$WrapPurePanel = (props)=>/*#__PURE__*/ $acw62.createElement($c311d16d3fa9262a$var$PurePanel, {
        ...props
    }, /*#__PURE__*/ $acw62.createElement("span", null));
$c311d16d3fa9262a$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $c311d16d3fa9262a$var$WrapPurePanel;
var $c311d16d3fa9262a$export$2e2bcd8739ae039 = $c311d16d3fa9262a$var$Dropdown;



var $acw62 = parcelRequire("acw62");








"use client";
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ const $87bdca50cc18044d$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = 'default', danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $acw62.createElement((0, $18b92a77e6b0d38f$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyOnHidden: destroyOnHidden, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender, popupRender: popupRender, ...restProps } = props;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const mergedPopupRender = popupRender || dropdownRender;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        classNames: {
            root: overlayClassName
        },
        styles: {
            root: overlayStyle
        },
        destroyOnHidden: destroyOnHidden,
        popupRender: mergedPopupRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(buttonPrefixCls, compactItemClassnames, className);
    if ('destroyPopupOnHide' in props) dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
    if ('open' in props) dropdownProps.open = open;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    const leftButton = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039).Compact, {
        className: classes,
        size: compactSize,
        block: true,
        ...restProps
    }, leftButtonToRender, /*#__PURE__*/ $acw62.createElement((0, $c311d16d3fa9262a$export$2e2bcd8739ae039), {
        ...dropdownProps
    }, rightButtonToRender));
};
$87bdca50cc18044d$var$DropdownButton.__ANT_BUTTON = true;
var $87bdca50cc18044d$export$2e2bcd8739ae039 = $87bdca50cc18044d$var$DropdownButton;


"use client";
const $9df091eb5002c0d1$var$Dropdown = (0, $c311d16d3fa9262a$export$2e2bcd8739ae039);
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ $9df091eb5002c0d1$var$Dropdown.Button = (0, $87bdca50cc18044d$export$2e2bcd8739ae039);
var $9df091eb5002c0d1$export$2e2bcd8739ae039 = $9df091eb5002c0d1$var$Dropdown;



var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");


const $a135099456a3a66d$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $a135099456a3a66d$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $a135099456a3a66d$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $a135099456a3a66d$var$e(o.overflowY, n) || $a135099456a3a66d$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $a135099456a3a66d$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $a135099456a3a66d$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $a135099456a3a66d$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$a135099456a3a66d$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $a135099456a3a66d$var$t(W) && p(W);){
        if (W = $a135099456a3a66d$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $a135099456a3a66d$var$n(W) && !$a135099456a3a66d$var$n(document.documentElement) || null != W && $a135099456a3a66d$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$a135099456a3a66d$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $a135099456a3a66d$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $a135099456a3a66d$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $a135099456a3a66d$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $a135099456a3a66d$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $b26c6e29c94de039$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $b26c6e29c94de039$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $a135099456a3a66d$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $a135099456a3a66d$export$3b12cb22b12b954b)(e, $b26c6e29c94de039$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $43291396832d20f3$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $43291396832d20f3$var$defaultItemNamePrefixCls = 'form_item';
function $43291396832d20f3$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $43291396832d20f3$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $43291396832d20f3$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$43291396832d20f3$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $43291396832d20f3$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}


function $4c36311913591211$export$368b682c15953eea(name) {
    const namePath = (0, $43291396832d20f3$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $4c36311913591211$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)((0, $43291396832d20f3$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $4c36311913591211$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $f7890240d56e6600$export$2e2bcd8739ae039)();
    const itemsRef = $acw62.useRef({});
    const wrapForm = $acw62.useMemo(()=>form ?? {
            ...rcForm,
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $4c36311913591211$export$368b682c15953eea(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus, ...restOpt } = options;
                const node = $4c36311913591211$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $b26c6e29c94de039$export$2e2bcd8739ae039)(node, {
                        scrollMode: 'if-needed',
                        block: 'nearest',
                        ...restOpt
                    });
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                const itemRef = wrapForm.getFieldInstance(name);
                if (typeof itemRef?.focus === 'function') itemRef.focus();
                else $4c36311913591211$var$getFieldDOMNode(name, wrapForm)?.focus?.();
            },
            getFieldInstance: (name)=>{
                const namePathStr = $4c36311913591211$export$368b682c15953eea(name);
                return itemsRef.current[namePathStr];
            }
        }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}



var $acw62 = parcelRequire("acw62");
const $5d2deff95d42cf3f$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $5d2deff95d42cf3f$export$67d4730aee04efd2 = $5d2deff95d42cf3f$var$RadioGroupContext.Provider;
var $5d2deff95d42cf3f$export$2e2bcd8739ae039 = $5d2deff95d42cf3f$var$RadioGroupContext;
const $5d2deff95d42cf3f$export$4fbd9581b41e971f = /*#__PURE__*/ $acw62.createContext(undefined);
const $5d2deff95d42cf3f$export$1b5d1f64a577990e = $5d2deff95d42cf3f$export$4fbd9581b41e971f.Provider;



var $acw62 = parcelRequire("acw62");
















// ============================== Styles ==============================
// styles from RadioGroup only
const $3ada146bee73c6aa$var$getGroupRadioStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: 'rtl'
            },
            [`&${groupPrefixCls}-block`]: {
                display: 'flex'
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: 'none'
            },
            '&-vertical': {
                display: 'flex',
                flexDirection: 'column',
                rowGap: token.marginXS,
                [`${componentCls}-wrapper`]: {
                    marginInlineEnd: 0
                }
            }
        }
    };
};
// Styles from radio-wrapper
const $3ada146bee73c6aa$var$getRadioBasicStyle = (token)=>{
    const { componentCls: componentCls, wrapperMarginInlineEnd: wrapperMarginInlineEnd, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, radioSize: radioSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOutCirc: motionEaseInOutCirc, colorBgContainer: colorBgContainer, colorBorder: colorBorder, lineWidth: lineWidth, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, paddingXS: paddingXS, dotColorDisabled: dotColorDisabled, dotSize: dotSize, lineType: lineType, radioColor: radioColor, radioBgColor: radioBgColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            display: 'inline-flex',
            alignItems: 'baseline',
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: 'pointer',
            '&:last-child': {
                marginInlineEnd: 0
            },
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: 'rtl'
            },
            '&-disabled': {
                cursor: 'not-allowed',
                color: token.colorTextDisabled
            },
            '&::after': {
                display: 'inline-block',
                width: 0,
                overflow: 'hidden',
                content: '"\\a0"'
            },
            '&-block': {
                flex: 1,
                justifyContent: 'center'
            },
            // ===================== Radio =====================
            [componentCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                alignSelf: 'center',
                // Styles moved from inner
                boxSizing: 'border-box',
                display: 'block',
                width: `calc(${radioSize} * 1px)`,
                height: `calc(${radioSize} * 1px)`,
                backgroundColor: colorBgContainer,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderRadius: '50%',
                transition: `all ${motionDurationMid}`,
                flex: 'none',
                // Dot
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) scale(0)',
                    width: `calc(${dotSize} * 1px)`,
                    height: `calc(${dotSize} * 1px)`,
                    backgroundColor: radioColor,
                    borderRadius: '50%',
                    transformOrigin: '50% 50%',
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                },
                // Wrapper > Radio > input
                [`${componentCls}-input`]: {
                    position: 'absolute',
                    inset: 0,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0
                },
                // Focus outline on radio when input is focus-visible
                [`&:has(${componentCls}-input:focus-visible)`]: (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)
            },
            // ===================== Hover =====================
            [`&:hover:not(${componentCls}-wrapper-disabled) ${componentCls}`]: {
                borderColor: colorPrimary
            },
            [`&:hover ${componentCls}-checked:not(${componentCls}-disabled)`]: {
                backgroundColor: colorPrimaryHover,
                borderColor: 'transparent'
            },
            // ==================== Checked ====================
            [`${componentCls}-checked`]: {
                backgroundColor: radioBgColor,
                borderColor: colorPrimary,
                '&::after': {
                    transform: `translate(-50%, -50%)`,
                    opacity: 1
                }
            },
            // ==================== Disable ====================
            [`${componentCls}-disabled`]: {
                // Wrapper > Radio > input
                [`&, ${componentCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    pointerEvents: 'none'
                },
                // Disabled radio styles
                background: colorBgContainerDisabled,
                borderColor: colorBorder,
                '&::after': {
                    backgroundColor: dotColorDisabled
                }
            },
            [`${componentCls}-disabled + span`]: {
                color: colorTextDisabled,
                cursor: 'not-allowed'
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        }
    };
};
// Styles from radio-button
const $3ada146bee73c6aa$var$getRadioButtonStyle = (token)=>{
    const { buttonColor: buttonColor, controlHeight: controlHeight, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, motionDurationMid: motionDurationMid, buttonPaddingInline: buttonPaddingInline, fontSize: fontSize, buttonBg: buttonBg, fontSizeLG: fontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, buttonCheckedBg: buttonCheckedBg, buttonSolidCheckedColor: buttonSolidCheckedColor, colorTextDisabled: colorTextDisabled, colorBgContainerDisabled: colorBgContainerDisabled, buttonCheckedBgDisabled: buttonCheckedBgDisabled, buttonCheckedColorDisabled: buttonCheckedColorDisabled, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, buttonSolidCheckedBg: buttonSolidCheckedBg, buttonSolidCheckedHoverBg: buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg: buttonSolidCheckedActiveBg, calc: calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: 'relative',
            display: 'inline-block',
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize: fontSize,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineEndWidth: lineWidth,
            cursor: 'pointer',
            transition: [
                `color`,
                `background-color`,
                `box-shadow`
            ].map((prop)=>`${prop} ${motionDurationMid}`).join(','),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: '100%',
                height: '100%'
            },
            '&:not(:last-child)': {
                marginInlineEnd: calc(lineWidth).mul(-1).equal()
            },
            '&:first-child': {
                borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            '&:last-child': {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            '&:first-child:last-child': {
                borderRadius: borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            '&:hover': {
                position: 'relative',
                color: colorPrimary
            },
            '&:has(:focus-visible)': (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token),
            [`${componentCls}, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: 'none'
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                '&::before': {
                    backgroundColor: colorPrimary
                },
                '&:first-child': {
                    borderColor: colorPrimary
                },
                '&:hover': {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    '&::before': {
                        backgroundColor: colorPrimaryHover
                    }
                },
                '&:active': {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    '&::before': {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                '&:hover': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                '&:active': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            '&-disabled': {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: 'not-allowed',
                '&:first-child, &:hover': {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: 'none'
            },
            '&-block': {
                flex: 1,
                textAlign: 'center'
            }
        }
    };
};
const $3ada146bee73c6aa$export$9ca1be8807fe0675 = (token)=>{
    const { wireframe: wireframe, padding: padding, marginXS: marginXS, lineWidth: lineWidth, fontSizeLG: fontSizeLG, colorText: colorText, colorBgContainer: colorBgContainer, colorTextDisabled: colorTextDisabled, controlItemBgActiveDisabled: controlItemBgActiveDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, colorWhite: colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        radioSize: // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
var $3ada146bee73c6aa$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Radio', (token)=>{
    const { controlOutline: controlOutline, controlOutlineWidth: controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        radioFocusShadow: radioFocusShadow,
        radioButtonFocusShadow: radioButtonFocusShadow
    });
    return [
        $3ada146bee73c6aa$var$getGroupRadioStyle(radioToken),
        $3ada146bee73c6aa$var$getRadioBasicStyle(radioToken),
        $3ada146bee73c6aa$var$getRadioButtonStyle(radioToken)
    ];
}, $3ada146bee73c6aa$export$9ca1be8807fe0675, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});


"use client";
const $9248626bdf467aa3$var$InternalRadio = (props, ref)=>{
    const groupContext = $acw62.useContext((0, $5d2deff95d42cf3f$export$2e2bcd8739ae039));
    const radioOptionTypeContext = $acw62.useContext((0, $5d2deff95d42cf3f$export$4fbd9581b41e971f));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('radio');
    const innerRef = $acw62.useRef(null);
    const mergedRef = (0, $6c628207f5089a39$export$ab452c34e8e05029)(ref, innerRef);
    const { isFormItemInput: isFormItemInput } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const onChange = (e)=>{
        props.onChange?.(e);
        groupContext?.onChange?.(e);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, style: style, title: title, classNames: classNames, styles: styles, ...restProps } = props;
    const radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    const isButtonType = (groupContext?.optionType || radioOptionTypeContext) === 'button';
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(radioPrefixCls);
    const [hashId, cssVarCls] = (0, $3ada146bee73c6aa$export$2e2bcd8739ae039)(radioPrefixCls, rootCls);
    const radioProps = {
        ...restProps
    };
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    // ====================== Checked ======================
    let mergedChecked = radioProps.checked;
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        mergedChecked = props.value === groupContext.value;
        radioProps.disabled = radioProps.disabled ?? groupContext.disabled;
    }
    radioProps.disabled = radioProps.disabled ?? disabled;
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        ...radioProps,
        checked: mergedChecked
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const wrapperClassString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: mergedChecked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
        [`${prefixCls}-wrapper-block`]: !!groupContext?.block
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $31d745f9760ef9bd$export$2e2bcd8739ae039)(radioProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ $acw62.createElement("label", {
        className: wrapperClassString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title,
        onClick: onLabelClick
    }, /*#__PURE__*/ $acw62.createElement((0, $37a273268aa78566$export$2e2bcd8739ae039), {
        ...radioProps,
        checked: mergedChecked,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
            [(0, $ede16c18199d1556$export$23466a5792b7a5d3)]: !isButtonType
        }),
        style: mergedStyles.icon,
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef,
        onClick: onInputClick
    }), children !== undefined ? /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children) : null));
};
const $9248626bdf467aa3$var$Radio = /*#__PURE__*/ $acw62.forwardRef($9248626bdf467aa3$var$InternalRadio);
var $9248626bdf467aa3$export$2e2bcd8739ae039 = $9248626bdf467aa3$var$Radio;



"use client";
const $61a2b39e6d97013d$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { name: formItemName } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const defaultName = (0, $bba066f19964922a$export$2e2bcd8739ae039)((0, $4c36311913591211$export$368b682c15953eea)(formItemName));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, options: options, buttonStyle: buttonStyle = 'outline', disabled: disabled, children: children, size: customizeSize, style: style, id: id, optionType: optionType, name: name = defaultName, defaultValue: defaultValue, value: customizedValue, block: block = false, onChange: onChange, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, orientation: orientation, vertical: vertical, role: role = 'radiogroup' } = props;
    const [value, setValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultValue, customizedValue);
    const onRadioChange = $acw62.useCallback((event)=>{
        const lastValue = value;
        const val = event.target.value;
        if (!('value' in props)) setValue(val);
        if (val !== lastValue) onChange?.(event);
    }, [
        value,
        setValue,
        onChange
    ]);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3ada146bee73c6aa$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === 'string' || (0, $b956dab96d0e505b$export$7e4aa119212bc614)(option)) // 此处类型自动推导为 string
        return /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            className: option.className,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const [, mergedVertical] = (0, $1507d62a9a84d168$export$550084c67147f6c4)(orientation, vertical);
    const classString = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-large`]: mergedSize === 'large',
        [`${groupPrefixCls}-small`]: mergedSize === 'small',
        [`${groupPrefixCls}-rtl`]: direction === 'rtl',
        [`${groupPrefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    const memoizedValue = $acw62.useMemo(()=>({
            onChange: onRadioChange,
            value: value,
            disabled: disabled,
            name: name,
            optionType: optionType,
            block: block
        }), [
        onRadioChange,
        value,
        disabled,
        name,
        optionType,
        block
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", {
        ...(0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
            aria: true,
            data: true
        }),
        role: role,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(classString, {
            [`${prefixCls}-group-vertical`]: mergedVertical
        }),
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }, /*#__PURE__*/ $acw62.createElement((0, $5d2deff95d42cf3f$export$67d4730aee04efd2), {
        value: memoizedValue
    }, childrenToRender));
});
var $61a2b39e6d97013d$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($61a2b39e6d97013d$var$RadioGroup);




var $acw62 = parcelRequire("acw62");



"use client";
const $26603fe9919115f7$var$RadioButton = (props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, ...radioProps } = props;
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $acw62.createElement((0, $5d2deff95d42cf3f$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        ...radioProps,
        type: "radio",
        ref: ref
    }));
};
var $26603fe9919115f7$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($26603fe9919115f7$var$RadioButton);


"use client";
const $c1fe26c11c01fc5f$var$Radio = (0, $9248626bdf467aa3$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.Button = (0, $26603fe9919115f7$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.Group = (0, $61a2b39e6d97013d$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.__ANT_RADIO = true;
var $c1fe26c11c01fc5f$export$2e2bcd8739ae039 = $c1fe26c11c01fc5f$var$Radio;


"use client";
const $e201eb08b7050f4b$export$ed10248435b8f218 = {};
const $e201eb08b7050f4b$export$14159cd9e2a500c8 = 'SELECT_ALL';
const $e201eb08b7050f4b$export$625c4f68eaaf8cfd = 'SELECT_INVERT';
const $e201eb08b7050f4b$export$c1a725540f5a63bd = 'SELECT_NONE';
const $e201eb08b7050f4b$var$EMPTY_LIST = [];
const $e201eb08b7050f4b$var$flattenData = (childrenColumnName, data, list = [])=>{
    (data || []).forEach((record)=>{
        list.push(record);
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(record) && childrenColumnName in record) $e201eb08b7050f4b$var$flattenData(childrenColumnName, record[childrenColumnName], list);
    });
    return list;
};
const $e201eb08b7050f4b$var$useSelection = (config, rowSelection)=>{
    const { preserveSelectedRowKeys: preserveSelectedRowKeys, selectedRowKeys: selectedRowKeys, defaultSelectedRowKeys: defaultSelectedRowKeys, getCheckboxProps: getCheckboxProps, getTitleCheckboxProps: getTitleCheckboxProps, onChange: onSelectionChange, onSelect: onSelect, onSelectAll: onSelectAll, onSelectInvert: onSelectInvert, onSelectNone: onSelectNone, onSelectMultiple: onSelectMultiple, columnWidth: selectionColWidth, type: selectionType, selections: selections, fixed: fixed, renderCell: customizeRenderCell, hideSelectAll: hideSelectAll, checkStrictly: checkStrictly = true } = rowSelection || {};
    const { prefixCls: prefixCls, data: data, pageData: pageData, getRecordByKey: getRecordByKey, getRowKey: getRowKey, expandType: expandType, childrenColumnName: childrenColumnName, locale: tableLocale, getPopupContainer: getPopupContainer } = config;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Table');
    // ========================= MultipleSelect =========================
    const [multipleSelect, updatePrevSelectedIndex] = (0, $220d9bc86e982cbe$export$3f339a531a4f3fb4)((item)=>item);
    // ========================= Keys =========================
    const [mergedSelectedKeys, setMergedSelectedKeys] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultSelectedRowKeys || $e201eb08b7050f4b$var$EMPTY_LIST, selectedRowKeys);
    const mergedSelectedKeyList = mergedSelectedKeys ?? $e201eb08b7050f4b$var$EMPTY_LIST;
    // ======================== Caches ========================
    const preserveRecordsRef = $acw62.useRef(new Map());
    const updatePreserveRecordsCache = (0, $acw62.useCallback)((keys)=>{
        if (preserveSelectedRowKeys) {
            const newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach((key)=>{
                let record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $acw62.useEffect(()=>{
        updatePreserveRecordsCache(mergedSelectedKeyList);
    }, [
        mergedSelectedKeyList,
        updatePreserveRecordsCache
    ]);
    // Get flatten data
    const flattedData = (0, $acw62.useMemo)(()=>$e201eb08b7050f4b$var$flattenData(childrenColumnName, pageData), [
        childrenColumnName,
        pageData
    ]);
    const { keyEntities: keyEntities } = (0, $acw62.useMemo)(()=>{
        if (checkStrictly) return {
            keyEntities: null
        };
        let convertData = data;
        if (preserveSelectedRowKeys) {
            // use flattedData keys
            const keysSet = new Set(flattedData.map(getRowKey));
            // remove preserveRecords that duplicate data
            const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, [key, value])=>keysSet.has(key) ? total : total.concat(value), []);
            convertData = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(convertData), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(preserveRecords));
        }
        return (0, $a4a4b11aebc073d4$export$e5d831ce033a4615)(convertData, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName,
        preserveSelectedRowKeys,
        flattedData
    ]);
    // Get all checkbox props
    const checkboxPropsMap = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        flattedData.forEach((record, index)=>{
            const key = getRowKey(record, index);
            const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    const isCheckboxDisabled = (0, $acw62.useCallback)((r)=>{
        const rowKey = getRowKey(r);
        let checkboxProps;
        if (checkboxPropsMap.has(rowKey)) checkboxProps = checkboxPropsMap.get(getRowKey(r));
        else checkboxProps = getCheckboxProps ? getCheckboxProps(r) : undefined;
        return !!checkboxProps?.disabled;
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, $acw62.useMemo)(()=>{
        if (checkStrictly) return [
            mergedSelectedKeyList,
            []
        ];
        const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $a76a7570d4fe3ae6$export$43adf2c483e3e633)(mergedSelectedKeyList, true, keyEntities, isCheckboxDisabled);
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeyList,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]);
    const derivedSelectedKeySet = (0, $acw62.useMemo)(()=>{
        const keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    const derivedHalfSelectedKeySet = (0, $acw62.useMemo)(()=>selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys), [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Reset if rowSelection reset
    $acw62.useEffect(()=>{
        if (!rowSelection) setMergedSelectedKeys($e201eb08b7050f4b$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    const setSelectedKeys = (0, $acw62.useCallback)((keys, method)=>{
        let availableKeys;
        let records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map((key)=>preserveRecordsRef.current.get(key));
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach((key)=>{
                const record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange?.(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    const triggerSingleSelection = (0, $acw62.useCallback)((key, selected, keys, event)=>{
        if (onSelect) {
            const rows = keys.map(getRecordByKey);
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    const mergedSelections = (0, $acw62.useMemo)(()=>{
        if (!selections || hideSelectAll) return null;
        const selectionList = selections === true ? [
            $e201eb08b7050f4b$export$14159cd9e2a500c8,
            $e201eb08b7050f4b$export$625c4f68eaaf8cfd,
            $e201eb08b7050f4b$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map((selection)=>{
            if (selection === $e201eb08b7050f4b$export$14159cd9e2a500c8) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect () {
                    setSelectedKeys(data.map((record, index)=>getRowKey(record, index)).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return !checkProps?.disabled || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $e201eb08b7050f4b$export$625c4f68eaaf8cfd) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect () {
                    const keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach((record, index)=>{
                        const key = getRowKey(record, index);
                        const checkProps = checkboxPropsMap.get(key);
                        if (!checkProps?.disabled) {
                            if (keySet.has(key)) keySet.delete(key);
                            else keySet.add(key);
                        }
                    });
                    const keys = Array.from(keySet);
                    if (onSelectInvert) {
                        warning.deprecated(false, 'onSelectInvert', 'onChange');
                        onSelectInvert(keys);
                    }
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $e201eb08b7050f4b$export$c1a725540f5a63bd) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect () {
                    onSelectNone?.();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return checkProps?.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map((selection)=>({
                ...selection,
                onSelect: (...rest)=>{
                    selection.onSelect?.(...rest);
                    updatePrevSelectedIndex(null);
                }
            }));
    }, [
        selections,
        hideSelectAll,
        tableLocale.selectionAll,
        tableLocale.selectInvert,
        tableLocale.selectNone,
        checkboxPropsMap,
        derivedSelectedKeySet,
        data,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    const transformColumns = (0, $acw62.useCallback)((columns)=>{
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter((col)=>col !== $e201eb08b7050f4b$export$ed10248435b8f218);
        // >>>>>>>>>>> Support selection
        let cloneColumns = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(columns);
        const keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        const recordKeys = flattedData.map(getRowKey).filter((key)=>!checkboxPropsMap.get(key).disabled);
        const checkedCurrentAll = recordKeys.every((key)=>keySet.has(key));
        const checkedCurrentSome = recordKeys.some((key)=>keySet.has(key));
        const onSelectAllChange = ()=>{
            const changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach((key)=>{
                keySet.delete(key);
                changeKeys.push(key);
            });
            else recordKeys.forEach((key)=>{
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            const keys = Array.from(keySet);
            onSelectAll?.(!checkedCurrentAll, keys.map(getRecordByKey), changeKeys.map(getRecordByKey));
            setSelectedKeys(keys, 'all');
            updatePrevSelectedIndex(null);
        };
        // ===================== Render =====================
        // Title Cell
        let title;
        let columnTitleCheckbox;
        if (selectionType !== 'radio') {
            let customizeSelections;
            if (mergedSelections) {
                const menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map((selection, index)=>{
                        const { key: key, text: text, onSelect: onSelectionClick } = selection;
                        return {
                            key: key ?? index,
                            onClick: ()=>{
                                onSelectionClick?.(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $acw62.createElement("div", {
                    className: `${prefixCls}-selection-extra`
                }, /*#__PURE__*/ $acw62.createElement((0, $9df091eb5002c0d1$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $acw62.createElement("span", null, /*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), null))));
            }
            const allDisabledData = flattedData.map((record, index)=>{
                const key = getRowKey(record, index);
                const checkboxProps = checkboxPropsMap.get(key) || {};
                return {
                    checked: keySet.has(key),
                    ...checkboxProps
                };
            }).filter(({ disabled: disabled })=>disabled);
            const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            const allDisabledAndChecked = allDisabled && allDisabledData.every(({ checked: checked })=>checked);
            const allDisabledSomeChecked = allDisabled && allDisabledData.some(({ checked: checked })=>checked);
            const customCheckboxProps = getTitleCheckboxProps?.() || {};
            const { onChange: onChange, disabled: disabled } = customCheckboxProps;
            columnTitleCheckbox = /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                ...customCheckboxProps,
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: (e)=>{
                    onSelectAllChange();
                    onChange?.(e);
                },
                disabled: disabled ?? (flattedData.length === 0 || allDisabled),
                skipGroup: true
            });
            title = !hideSelectAll && /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-selection`
            }, columnTitleCheckbox, customizeSelections);
        }
        // Body Cell
        let renderCell;
        if (selectionType === 'radio') renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            return {
                node: /*#__PURE__*/ $acw62.createElement((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                    ...checkboxProps,
                    checked: checked,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        else renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const indeterminate = derivedHalfSelectedKeySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            let mergedIndeterminate;
            if (expandType === 'nest') mergedIndeterminate = indeterminate;
            else mergedIndeterminate = checkboxProps?.indeterminate ?? indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                    ...checkboxProps,
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        const { nativeEvent: nativeEvent } = event;
                        const { shiftKey: shiftKey } = nativeEvent;
                        const currentSelectedIndex = recordKeys.indexOf(key);
                        const isMultiple = derivedSelectedKeys.some((item)=>recordKeys.includes(item));
                        if (shiftKey && checkStrictly && isMultiple) {
                            const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                            const keys = Array.from(keySet);
                            onSelectMultiple?.(!checked, keys.map(getRecordByKey), changedKeys.map(getRecordByKey));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            const originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                const checkedKeys = checked ? (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                const result = (0, $a76a7570d4fe3ae6$export$43adf2c483e3e633)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = result;
                                let nextCheckedKeys = checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    const tempKeySet = new Set(checkedKeys);
                                    tempKeySet.delete(key);
                                    nextCheckedKeys = (0, $a76a7570d4fe3ae6$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) updatePrevSelectedIndex(null);
                        else updatePrevSelectedIndex(currentSelectedIndex);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        const renderSelectionCell = (_, record, index)=>{
            const { node: node, checked: checked } = renderCell(_, record, index);
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($e201eb08b7050f4b$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex((col)=>col[0, $4cc7e0683884ce83$export$f8dba99c0d5b6b87]?.columnType === 'EXPAND_COLUMN') === 0) {
                const [expandColumn, ...restColumns] = cloneColumns;
                cloneColumns = [
                    expandColumn,
                    $e201eb08b7050f4b$export$ed10248435b8f218
                ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $e201eb08b7050f4b$export$ed10248435b8f218
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cloneColumns));
        }
        // Deduplicate selection column
        const selectionColumnIndex = cloneColumns.indexOf($e201eb08b7050f4b$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter((column, index)=>column !== $e201eb08b7050f4b$export$ed10248435b8f218 || index === selectionColumnIndex);
        // Fixed column logic
        const prevCol = cloneColumns[selectionColumnIndex - 1];
        const nextCol = cloneColumns[selectionColumnIndex + 1];
        let mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if (nextCol?.fixed !== undefined) mergedFixed = nextCol.fixed;
            else if (prevCol?.fixed !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && prevCol[0, $4cc7e0683884ce83$export$f8dba99c0d5b6b87]?.columnType === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        const columnCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-selection-col`, {
            [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === 'checkbox'
        });
        const renderColumnTitle = ()=>{
            if (!rowSelection?.columnTitle) return title;
            if (typeof rowSelection.columnTitle === 'function') return rowSelection.columnTitle(columnTitleCheckbox);
            return rowSelection.columnTitle;
        };
        // Replace with real selection column
        const selectionColumn = {
            fixed: mergedFixed,
            width: selectionColWidth,
            className: `${prefixCls}-selection-column`,
            title: renderColumnTitle(),
            render: renderSelectionCell,
            onCell: rowSelection.onCell,
            align: rowSelection.align,
            [(0, $4cc7e0683884ce83$export$f8dba99c0d5b6b87)]: {
                className: columnCls
            }
        };
        return cloneColumns.map((col)=>col === $e201eb08b7050f4b$export$ed10248435b8f218 ? selectionColumn : col);
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
};
var $e201eb08b7050f4b$export$2e2bcd8739ae039 = $e201eb08b7050f4b$var$useSelection;



var $acw62 = parcelRequire("acw62");




// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242

var $acw62 = parcelRequire("acw62");
const $f0212a5d02e19b33$var$fillProxy = (element, handler)=>{
    element._antProxy = element._antProxy || {};
    Object.keys(handler).forEach((key)=>{
        if (!(key in element._antProxy)) {
            const ori = element[key];
            element._antProxy[key] = ori;
            element[key] = handler[key];
        }
    });
    return element;
};
const $f0212a5d02e19b33$export$8edbe0145ad77a36 = (ref, init)=>{
    return (0, $acw62.useImperativeHandle)(ref, ()=>{
        const refObj = init();
        const { nativeElement: nativeElement } = refObj;
        if (typeof Proxy !== 'undefined') return new Proxy(nativeElement, {
            get (obj, prop) {
                if (refObj[prop]) return refObj[prop];
                return Reflect.get(obj, prop);
            }
        });
        // Fallback of IE
        return $f0212a5d02e19b33$var$fillProxy(nativeElement, refObj);
    });
};




function $a8ca81d24930dc06$export$24656b269d8df7d6(t, b, c, d) {
    const cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // biome-ignore lint: it is a common easing function
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}



const $bf032ca2c6c444c9$export$5a096129d439f843 = (obj)=>{
    return (0, $b956dab96d0e505b$export$826fff653a329e83)(obj) && obj === obj.window;
};
const $bf032ca2c6c444c9$var$getScroll = (target)=>{
    if (typeof window === 'undefined') /* istanbul ignore next */ return 0;
    let result = 0;
    if ($bf032ca2c6c444c9$export$5a096129d439f843(target)) result = target.pageYOffset;
    else if (target instanceof Document) result = target.documentElement.scrollTop;
    else if (target instanceof HTMLElement) result = target.scrollTop;
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */ result = target['scrollTop'];
    if (target && !$bf032ca2c6c444c9$export$5a096129d439f843(target) && typeof result !== 'number') result = (target.ownerDocument ?? target).documentElement?.scrollTop;
    return result;
};
var $bf032ca2c6c444c9$export$2e2bcd8739ae039 = $bf032ca2c6c444c9$var$getScroll;


function $4262b79604674a3c$export$2e2bcd8739ae039(y, options = {}) {
    const { getContainer: getContainer = ()=>window, callback: callback, duration: duration = 450 } = options;
    const container = getContainer();
    const scrollTop = (0, $bf032ca2c6c444c9$export$2e2bcd8739ae039)(container);
    const startTime = Date.now();
    let rafId;
    const frameFunc = ()=>{
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScrollTop = (0, $a8ca81d24930dc06$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $bf032ca2c6c444c9$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) rafId = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    rafId = (0, $277b2a9c97081a51$export$2e2bcd8739ae039)(frameFunc);
    return ()=>{
        (0, $277b2a9c97081a51$export$2e2bcd8739ae039).cancel(rafId);
    };
}






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



"use client";
const $148bd952cb1a5a76$var$Empty = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Empty');
    const bgColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $acw62.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(24 31.7)"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.8",
        cy: "106.9",
        rx: "67.8",
        ry: "12.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#aeb8c2",
        d: "M122 69.7 98.1 40.2a6 6 0 0 0-4.6-2.2H42.1a6 6 0 0 0-4.6 2.2l-24 29.5V85H122z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#f5f5f7",
        d: "M33.8 0h68a4 4 0 0 1 4 4v93.3a4 4 0 0 1-4 4h-68a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#dce0e6",
        d: "M42.7 10h50.2a2 2 0 0 1 2 2v25a2 2 0 0 1-2 2H42.7a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2m.2 39.8h49.8a2.3 2.3 0 1 1 0 4.5H42.9a2.3 2.3 0 0 1 0-4.5m0 11.7h49.8a2.3 2.3 0 1 1 0 4.6H42.9a2.3 2.3 0 0 1 0-4.6m79 43.5a7 7 0 0 1-6.8 5.4H20.5a7 7 0 0 1-6.7-5.4l-.2-1.8V69.7h26.3c2.9 0 5.2 2.4 5.2 5.4s2.4 5.4 5.3 5.4h34.8c2.9 0 5.3-2.4 5.3-5.4s2.3-5.4 5.2-5.4H122v33.5q0 1-.2 1.8"
    })), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#dce0e6",
        d: "m149.1 33.3-6.8 2.6a1 1 0 0 1-1.3-1.2l2-6.2q-4.1-4.5-4.2-10.4c0-10 10.1-18.1 22.6-18.1S184 8.1 184 18.1s-10.1 18-22.6 18q-6.8 0-12.3-2.8"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "#fff",
        transform: "translate(149.7 15.4)"
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "20.7",
        cy: "3.2",
        r: "2.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.7 5.6H0L2.9.7zM9.3.7h5v5h-5z"
    }))));
};
var $148bd952cb1a5a76$export$2e2bcd8739ae039 = $148bd952cb1a5a76$var$Empty;



var $acw62 = parcelRequire("acw62");



"use client";
const $ae7f97f0fd68830c$var$Simple = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $acw62.useMemo)(()=>({
            borderColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFill).onBackground(colorBgContainer).toHexString(),
            shadowColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
            contentColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M55 12.8 44.9 1.3Q44 0 42.9 0H21.1q-1.2 0-2 1.3L9 12.8V22h46z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M41.6 16c0-1.7 1-3 2.2-3H55v18.1c0 2.2-1.3 3.9-3 3.9H12c-1.7 0-3-1.7-3-3.9V13h11.2c1.2 0 2.2 1.3 2.2 3s1 2.9 2.2 2.9h14.8c1.2 0 2.2-1.4 2.2-3",
        fill: contentColor
    }))));
};
var $ae7f97f0fd68830c$export$2e2bcd8739ae039 = $ae7f97f0fd68830c$var$Simple;



// ============================== Shared ==============================
const $ee15fc052b6837a1$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$ee15fc052b6837a1$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return $ee15fc052b6837a1$var$genSharedEmptyStyle(emptyToken);
});


"use client";
const $ec66348328372da5$var$defaultEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $148bd952cb1a5a76$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$simpleEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $ae7f97f0fd68830c$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$Empty = (props)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image, description: description, children: children, imageStyle: imageStyle, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, image: contextImage } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('empty');
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ee15fc052b6837a1$export$2e2bcd8739ae039)(prefixCls);
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Empty');
    const des = typeof description !== 'undefined' ? description : locale?.description;
    const alt = typeof des === 'string' ? des : 'empty';
    const mergedImage = image ?? contextImage ?? $ec66348328372da5$var$defaultEmptyImg;
    let imageNode = null;
    if (typeof mergedImage === 'string') imageNode = /*#__PURE__*/ $acw62.createElement("img", {
        draggable: false,
        alt: alt,
        src: mergedImage
    });
    else imageNode = mergedImage;
    var deprecatedName, newName;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: mergedImage === $ec66348328372da5$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-image`, mergedClassNames.image),
        style: {
            ...imageStyle,
            ...mergedStyles.image
        }
    }, imageNode), des && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
        style: mergedStyles.description
    }, des), children && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
        style: mergedStyles.footer
    }, children));
};
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_DEFAULT = $ec66348328372da5$var$defaultEmptyImg;
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_SIMPLE = $ec66348328372da5$var$simpleEmptyImg;
var $ec66348328372da5$export$2e2bcd8739ae039 = $ec66348328372da5$var$Empty;


"use client";
const $3feb83783705e448$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('empty');
    switch(componentName){
        case 'Table':
        case 'List':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case 'Table.filter':
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), null);
    }
};
var $3feb83783705e448$export$2e2bcd8739ae039 = $3feb83783705e448$var$DefaultRenderEmpty;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $dcbb6d0bd42650d6$export$91db9bc4f8ac944a = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((ori)=>ori + 1, 0);
};



var $acw62 = parcelRequire("acw62");

const $36689cb123f552b0$export$74c1bf8296b1541f = [
    'xxxl',
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $36689cb123f552b0$export$9af3fe7b7131195 = [].concat($36689cb123f552b0$export$74c1bf8296b1541f).reverse();
const $36689cb123f552b0$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`,
        xxxl: `(min-width: ${token.screenXXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $36689cb123f552b0$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($36689cb123f552b0$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $36689cb123f552b0$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $36689cb123f552b0$export$74c1bf8296b1541f){
        if (screens[breakpoint] && screenSizes?.[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};
const $36689cb123f552b0$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const responsiveMap = $36689cb123f552b0$var$getResponsiveMap($36689cb123f552b0$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>{
                    func(screens);
                });
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch({
                            ...screens,
                            [screen]: matches
                        });
                    };
                    const mql = window.matchMedia(mediaQuery);
                    if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    if (typeof handler?.mql?.removeEventListener === 'function') handler.mql.removeEventListener('change', handler?.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        responsiveMap
    ]);
};
var $36689cb123f552b0$export$2e2bcd8739ae039 = $36689cb123f552b0$var$useResponsiveObserver;


"use client";
function $b8c04e47cb65d6a9$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $acw62.useRef)(defaultScreens);
    const [, forceUpdate] = (0, $dcbb6d0bd42650d6$export$91db9bc4f8ac944a)();
    const responsiveObserver = (0, $36689cb123f552b0$export$2e2bcd8739ae039)();
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $b8c04e47cb65d6a9$export$2e2bcd8739ae039 = $b8c04e47cb65d6a9$var$useBreakpoint;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $50e767e4968fb94a$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $50e767e4968fb94a$export$2e2bcd8739ae039 = $50e767e4968fb94a$var$DoubleLeftOutlined;



function $fbba0865720ca5de$var$_extends() {
    $fbba0865720ca5de$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fbba0865720ca5de$var$_extends.apply(this, arguments);
}
const $fbba0865720ca5de$var$DoubleLeftOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $fbba0865720ca5de$var$_extends({}, props, {
        ref: ref,
        icon: (0, $50e767e4968fb94a$export$2e2bcd8739ae039)
    }));
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ const $fbba0865720ca5de$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($fbba0865720ca5de$var$DoubleLeftOutlined);
var $fbba0865720ca5de$export$2e2bcd8739ae039 = $fbba0865720ca5de$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $6ce95b223b6e0f50$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $6ce95b223b6e0f50$export$2e2bcd8739ae039 = $6ce95b223b6e0f50$var$DoubleRightOutlined;



function $a7afd88ad369b46e$var$_extends() {
    $a7afd88ad369b46e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a7afd88ad369b46e$var$_extends.apply(this, arguments);
}
const $a7afd88ad369b46e$var$DoubleRightOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $a7afd88ad369b46e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $6ce95b223b6e0f50$export$2e2bcd8739ae039)
    }));
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ const $a7afd88ad369b46e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($a7afd88ad369b46e$var$DoubleRightOutlined);
var $a7afd88ad369b46e$export$2e2bcd8739ae039 = $a7afd88ad369b46e$var$RefIcon;










var $acw62 = parcelRequire("acw62");
const $56fe2fbeb8f381b9$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $56fe2fbeb8f381b9$export$2e2bcd8739ae039 = $56fe2fbeb8f381b9$var$locale;




var $acw62 = parcelRequire("acw62");
const $34ef882dd932172e$var$defaultPageSizeOptions = [
    10,
    20,
    50,
    100
];
const $34ef882dd932172e$var$Options = (props)=>{
    const { pageSizeOptions: pageSizeOptions = $34ef882dd932172e$var$defaultPageSizeOptions, locale: locale, changeSize: changeSize, pageSize: pageSize, goButton: goButton, quickGo: quickGo, rootPrefixCls: rootPrefixCls, disabled: disabled, buildOptionText: buildOptionText, showSizeChanger: showSizeChanger, sizeChangerRender: sizeChangerRender } = props;
    const [goInputText, setGoInputText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const getValidValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    }, [
        goInputText
    ]);
    const mergeBuildOptionText = typeof buildOptionText === 'function' ? buildOptionText : (value)=>`${value} ${locale.items_per_page}`;
    const handleChange = (e)=>{
        const value = e.target.value;
        if (/^\d*$/.test(value)) setGoInputText(value);
    };
    const handleBlur = (e)=>{
        if (goButton || goInputText === '') return;
        setGoInputText('');
        if (e.relatedTarget && (e.relatedTarget.className.includes(`${rootPrefixCls}-item-link`) || e.relatedTarget.className.includes(`${rootPrefixCls}-item`))) return;
        quickGo?.(getValidValue);
    };
    const go = (e)=>{
        if (goInputText === '') return;
        if (e.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER || e.type === 'click') {
            setGoInputText('');
            quickGo?.(getValidValue);
        }
    };
    const getPageSizeOptions = ()=>{
        if (pageSizeOptions.some((option)=>option.toString() === pageSize.toString())) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize
        ]).sort((a, b)=>{
            const numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            const numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    const prefixCls = `${rootPrefixCls}-options`;
    // ============== render ==============
    if (!showSizeChanger && !quickGo) return null;
    let changeSelect = null;
    let goInput = null;
    let gotoButton = null;
    // >>>>> Size Changer
    if (showSizeChanger && sizeChangerRender) changeSelect = sizeChangerRender({
        disabled: disabled,
        size: pageSize,
        onSizeChange: (nextValue)=>{
            changeSize?.(Number(nextValue));
        },
        'aria-label': locale.page_size,
        className: `${prefixCls}-size-changer`,
        options: getPageSizeOptions().map((opt)=>({
                label: mergeBuildOptionText(opt),
                value: opt
            }))
    });
    // >>>>> Quick Go
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: `${prefixCls}-quick-jumper-button`
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `${prefixCls}-quick-jumper`
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $34ef882dd932172e$export$2e2bcd8739ae039 = $34ef882dd932172e$var$Options;


/* eslint react/prop-types: 0 */ 

var $acw62 = parcelRequire("acw62");
const $ff69719bb536ac81$var$Pager = (props)=>{
    const { rootPrefixCls: rootPrefixCls, page: page, active: active, className: className, style: style, showTitle: showTitle, onClick: onClick, onKeyPress: onKeyPress, itemRender: itemRender } = props;
    const prefixCls = `${rootPrefixCls}-item`;
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${page}`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-disabled`]: !page
    }, className);
    const handleClick = ()=>{
        onClick(page);
    };
    const handleKeyPress = (e)=>{
        onKeyPress(e, onClick, page);
    };
    const pager = itemRender(page, 'page', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        style: style,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $ff69719bb536ac81$export$2e2bcd8739ae039 = $ff69719bb536ac81$var$Pager;


function $c2bd458455237c3e$var$_extends() {
    $c2bd458455237c3e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c2bd458455237c3e$var$_extends.apply(this, arguments);
}
const $c2bd458455237c3e$var$defaultItemRender = (_, __, element)=>element;
function $c2bd458455237c3e$var$noop() {}
function $c2bd458455237c3e$var$isInteger(v) {
    const value = Number(v);
    return typeof value === 'number' && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $c2bd458455237c3e$var$calculatePage(p, pageSize, total) {
    const _pageSize = typeof p === 'undefined' ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
const $c2bd458455237c3e$var$Pagination = (props)=>{
    const { prefixCls: // cls
    prefixCls = 'rc-pagination', selectPrefixCls: selectPrefixCls = 'rc-select', className: className, classNames: paginationClassNames, styles: styles, // control
    current: currentProp, defaultCurrent: defaultCurrent = 1, total: total = 0, pageSize: pageSizeProp, defaultPageSize: defaultPageSize = 10, onChange: onChange = $c2bd458455237c3e$var$noop, hideOnSinglePage: // config
    hideOnSinglePage, align: align, showPrevNextJumpers: showPrevNextJumpers = true, showQuickJumper: showQuickJumper, showLessItems: showLessItems, showTitle: showTitle = true, onShowSizeChange: onShowSizeChange = $c2bd458455237c3e$var$noop, locale: locale = (0, $56fe2fbeb8f381b9$export$2e2bcd8739ae039), style: style, totalBoundaryShowSizeChanger: totalBoundaryShowSizeChanger = 50, disabled: disabled, simple: simple, showTotal: showTotal, showSizeChanger: showSizeChanger = total > totalBoundaryShowSizeChanger, sizeChangerRender: sizeChangerRender, pageSizeOptions: pageSizeOptions, itemRender: // render
    itemRender = $c2bd458455237c3e$var$defaultItemRender, jumpPrevIcon: jumpPrevIcon, jumpNextIcon: jumpNextIcon, prevIcon: prevIcon, nextIcon: nextIcon } = props;
    const paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [pageSize, setPageSize] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultPageSize, pageSizeProp);
    const [internalCurrent, setCurrent] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultCurrent, currentProp);
    const current = Math.max(1, Math.min(internalCurrent, $c2bd458455237c3e$var$calculatePage(undefined, pageSize, total)));
    const [internalInputVal, setInternalInputVal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(current);
    (0, $acw62.useEffect)(()=>{
        setInternalInputVal(current);
    }, [
        current
    ]);
    const hasOnChange = onChange !== $c2bd458455237c3e$var$noop;
    const hasCurrent = 'current' in props;
    const jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    const jumpNextPage = Math.min($c2bd458455237c3e$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        let iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: `${prefixCls}-item-link`
        });
        if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(icon, props);
        return iconNode;
    }
    function getValidValue(e) {
        const inputValue = e.target.value;
        const allPages = $c2bd458455237c3e$var$calculatePage(undefined, pageSize, total);
        let value;
        if (inputValue === '') value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $c2bd458455237c3e$var$isInteger(page) && page !== current && $c2bd458455237c3e$var$isInteger(total) && total > 0;
    }
    const shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP || event.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        const value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        const newCurrent = $c2bd458455237c3e$var$calculatePage(size, pageSize, total);
        const nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange?.(current, size);
        setCurrent(nextCurrent);
        onChange?.(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            const currentPage = $c2bd458455237c3e$var$calculatePage(undefined, pageSize, total);
            let newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange?.(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    const hasPrev = current > 1;
    const hasNext = current < $c2bd458455237c3e$var$calculatePage(undefined, pageSize, total);
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback, ...restParams) {
        if (event.key === 'Enter' || event.charCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) callback(...restParams);
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        const prevButton = itemRender(prevPage, 'prev', getItemIcon(prevIcon, 'prev page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        const nextButton = itemRender(nextPage, 'next', getItemIcon(nextIcon, 'next page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === 'click' || event.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    let jumpPrev = null;
    const dataOrAriaAttributeProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    const totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: `${prefixCls}-total-text`
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    let jumpNext = null;
    const allPages = $c2bd458455237c3e$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    const pagerList = [];
    const pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1,
        className: paginationClassNames?.item,
        style: styles?.item
    };
    const prevPage = current - 1 > 0 ? current - 1 : 0;
    const nextPage = current + 1 < allPages ? current + 1 : allPages;
    const goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    const isReadOnly = typeof simple === 'object' ? simple.readOnly : !simple;
    let gotoButton = goButton;
    let simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                title: showTitle ? `${locale.jump_to}${current}/${allPages}` : null,
                className: `${prefixCls}-simple-pager`
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            title: showTitle ? `${current}/${allPages}` : null,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-simple-pager`, paginationClassNames?.item),
            style: styles?.item
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "text",
            "aria-label": locale.jump_to,
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: `${prefixCls}-slash`
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    const pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff69719bb536ac81$export$2e2bcd8739ae039), $c2bd458455237c3e$var$_extends({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: `${prefixCls}-item-disabled`
        })));
        for(let i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff69719bb536ac81$export$2e2bcd8739ae039), $c2bd458455237c3e$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        const prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        const nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        const jumpPrevContent = itemRender(jumpPrevPage, 'jump-prev', getItemIcon(jumpPrevIcon, 'prev page'));
        const jumpNextContent = itemRender(jumpNextPage, 'jump-next', getItemIcon(jumpNextIcon, 'next page'));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-jump-prev`, {
                    [`${prefixCls}-jump-prev-custom-icon`]: !!jumpPrevIcon
                })
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-jump-next`, {
                    [`${prefixCls}-jump-next-custom-icon`]: !!jumpNextIcon
                })
            }, jumpNextContent) : null;
        }
        let left = Math.max(1, current - pageBufferSize);
        let right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        for(let i = left; i <= right; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff69719bb536ac81$export$2e2bcd8739ae039), $c2bd458455237c3e$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
        if (current - 1 >= pageBufferSize * 2 && current !== 3) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(pagerList[0], {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-item-after-jump-prev`, pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
            const lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(lastOne, {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-item-before-jump-next`, lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff69719bb536ac81$export$2e2bcd8739ae039), $c2bd458455237c3e$var$_extends({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff69719bb536ac81$export$2e2bcd8739ae039), $c2bd458455237c3e$var$_extends({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    let prev = renderPrev(prevPage);
    if (prev) {
        const prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-prev`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: prevDisabled
            }),
            style: styles?.item,
            "aria-disabled": prevDisabled
        }, prev);
    }
    let next = renderNext(nextPage);
    if (next) {
        let nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-next`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: nextDisabled
            }),
            style: styles?.item,
            "aria-disabled": nextDisabled
        }, next);
    }
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-start`]: align === 'start',
        [`${prefixCls}-center`]: align === 'center',
        [`${prefixCls}-end`]: align === 'end',
        [`${prefixCls}-simple`]: simple,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", $c2bd458455237c3e$var$_extends({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34ef882dd932172e$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectPrefixCls: selectPrefixCls,
        changeSize: changePageSize,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton,
        showSizeChanger: showSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $c2bd458455237c3e$export$2e2bcd8739ae039 = $c2bd458455237c3e$var$Pagination;













var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $da5aec9a0cde9f50$export$9ea6397a890aa3e5 = (prefixCls, displayValues, allowClear, clearIcon, disabled = false, mergedSearchValue, mode)=>{
    // Convert boolean to object first
    const allowClearConfig = (0, $acw62.useMemo)(()=>{
        if (typeof allowClear === 'boolean') return {
            allowClear: allowClear
        };
        if (allowClear && typeof allowClear === 'object') return allowClear;
        return {
            allowClear: false
        };
    }, [
        allowClear
    ]);
    return (0, $acw62.useMemo)(()=>{
        const mergedAllowClear = !disabled && allowClearConfig.allowClear !== false && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '');
        return {
            allowClear: mergedAllowClear,
            clearIcon: mergedAllowClear ? allowClearConfig.clearIcon || clearIcon || "\xd7" : null
        };
    }, [
        allowClearConfig,
        clearIcon,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $acw62 = parcelRequire("acw62");
const $b814b04c35134918$export$8234047c0aea33cf = /*#__PURE__*/ $acw62.createContext(null);
function $b814b04c35134918$export$2e2bcd8739ae039() {
    return $acw62.useContext($b814b04c35134918$export$8234047c0aea33cf);
}



var $acw62 = parcelRequire("acw62");
function $ce67f070ade5c772$export$2e2bcd8739ae039(duration = 250) {
    const lockRef = $acw62.useRef(null);
    const timeoutRef = $acw62.useRef(null);
    // Clean up
    $acw62.useEffect(()=>()=>{
            window.clearTimeout(timeoutRef.current);
        }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            lockRef.current = null;
        }, duration);
    }
    return [
        ()=>lockRef.current,
        doLock
    ];
}



var $acw62 = parcelRequire("acw62");

function $7ac4acf13acc2978$export$4ac6a1c95deee4c5(elements, target) {
    return elements.filter((element)=>element).some((element)=>element.contains(target) || element === target);
}
function $7ac4acf13acc2978$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    const onGlobalMouseDown = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        // If trigger is customized, Trigger will take control of popupVisible
        if (customizedTrigger) return;
        let target = event.target;
        if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
        if (event._ori_target) target = event._ori_target;
        if (open && // Marked by SelectInput mouseDown event
        !$7ac4acf13acc2978$export$4ac6a1c95deee4c5(elements(), target)) // Should trigger close
        triggerOpen(false);
    });
    $acw62.useEffect(()=>{
        window.addEventListener('mousedown', onGlobalMouseDown);
        return ()=>window.removeEventListener('mousedown', onGlobalMouseDown);
    }, [
        onGlobalMouseDown
    ]);
}





var $acw62 = parcelRequire("acw62");
function $58624638ffe21192$var$_extends() {
    $58624638ffe21192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $58624638ffe21192$var$_extends.apply(this, arguments);
}
const $58624638ffe21192$var$getBuiltInPlacements = (popupMatchSelectWidth)=>{
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    const adjustX = popupMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        }
    };
};
const $58624638ffe21192$var$SelectTrigger = (props, ref)=>{
    const { prefixCls: prefixCls, disabled: disabled, visible: visible, children: children, popupElement: popupElement, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, direction: direction = 'ltr', placement: placement, builtinPlacements: builtinPlacements, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, getPopupContainer: getPopupContainer, empty: empty, onPopupVisibleChange: onPopupVisibleChange, onPopupMouseEnter: onPopupMouseEnter, onPopupMouseDown: onPopupMouseDown, onPopupBlur: onPopupBlur, ...restProps } = props;
    // We still use `dropdown` className to keep compatibility
    // This is used for:
    // 1. Styles
    // 2. Animation
    // 3. Theme customization
    // Please do not modify this since it's a breaking change
    const popupPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (popupRender) popupNode = popupRender(popupElement);
    const mergedBuiltinPlacements = $acw62.useMemo(()=>builtinPlacements || $58624638ffe21192$var$getBuiltInPlacements(popupMatchSelectWidth), [
        builtinPlacements,
        popupMatchSelectWidth
    ]);
    // ===================== Motion ======================
    const mergedTransitionName = animation ? `${popupPrefixCls}-${animation}` : transitionName;
    // =================== Popup Width ===================
    const isNumberPopupWidth = typeof popupMatchSelectWidth === 'number';
    const stretch = $acw62.useMemo(()=>{
        if (isNumberPopupWidth) return null;
        return popupMatchSelectWidth === false ? 'minWidth' : 'width';
    }, [
        popupMatchSelectWidth,
        isNumberPopupWidth
    ]);
    let mergedPopupStyle = popupStyle;
    if (isNumberPopupWidth) mergedPopupStyle = {
        ...popupStyle,
        width: popupMatchSelectWidth
    };
    // ======================= Ref =======================
    const triggerPopupRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>({
            getPopupElement: ()=>triggerPopupRef.current?.popupElement
        }));
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), $58624638ffe21192$var$_extends({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: popupPrefixCls,
        popupMotion: {
            motionName: mergedTransitionName
        },
        popup: /*#__PURE__*/ $acw62.createElement("div", {
            onMouseEnter: onPopupMouseEnter,
            onMouseDown: onPopupMouseDown,
            onBlur: onPopupBlur
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: popupAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(popupClassName, {
            [`${popupPrefixCls}-empty`]: empty
        }),
        popupStyle: mergedPopupStyle,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
const $58624638ffe21192$var$RefSelectTrigger = /*#__PURE__*/ $acw62.forwardRef($58624638ffe21192$var$SelectTrigger);
var $58624638ffe21192$export$2e2bcd8739ae039 = $58624638ffe21192$var$RefSelectTrigger;



function $1e969b06a3fde7cb$var$getKey(data, index) {
    const { key: key } = data;
    let value;
    if ('value' in data) ({ value: value } = data);
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return `rc-index-key-${index}`;
}
function $1e969b06a3fde7cb$export$be48fd776273e509(value) {
    return typeof value !== 'undefined' && !Number.isNaN(value);
}
function $1e969b06a3fde7cb$export$6c519d302dced239(fieldNames, childrenAsData) {
    const { label: label, value: value, options: options, groupLabel: groupLabel } = fieldNames || {};
    const mergedLabel = label || (childrenAsData ? 'children' : 'label');
    return {
        label: mergedLabel,
        value: value || 'value',
        options: options || 'options',
        groupLabel: groupLabel || mergedLabel
    };
}
function $1e969b06a3fde7cb$export$7baa7c13b358b002(options, { fieldNames: fieldNames, childrenAsData: childrenAsData } = {}) {
    const flattenList = [];
    const { label: fieldLabel, value: fieldValue, options: fieldOptions, groupLabel: groupLabel } = $1e969b06a3fde7cb$export$6c519d302dced239(fieldNames, false);
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach((data)=>{
            if (isGroupOption || !(fieldOptions in data)) {
                const value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $1e969b06a3fde7cb$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                let grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $1e969b06a3fde7cb$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $1e969b06a3fde7cb$export$d0b21b213c8c013c(option) {
    const newOption = {
        ...option
    };
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get () {
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
const $1e969b06a3fde7cb$export$a09ca2a89e052b14 = (text, tokens, end)=>{
    if (!tokens || !tokens.length) return null;
    let match = false;
    const separate = (str, [token, ...restTokens])=>{
        if (!token) return [
            str
        ];
        const list = str.split(token);
        match = match || list.length > 1;
        return list.reduce((prevList, unitStr)=>[
                ...prevList,
                ...separate(unitStr, restTokens)
            ], []).filter(Boolean);
    };
    const list = separate(text, tokens);
    if (match) return typeof end !== 'undefined' ? list.slice(0, end) : list;
    else return null;
};



var $acw62 = parcelRequire("acw62");
function $d6ed507c3ffa674e$export$2e2bcd8739ae039(props) {
    const { visible: visible, values: values } = props;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    const MAX_COUNT = 50;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `${values.slice(0, MAX_COUNT).map(({ label: label, value: value })=>[
            'number',
            'string'
        ].includes(typeof label) ? label : value).join(', ')}`, values.length > MAX_COUNT ? ', ...' : null);
}




var $acw62 = parcelRequire("acw62");
const $436e386d6ba83c06$var$internalMacroTask = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
const $436e386d6ba83c06$export$f1309b2412c6fa89 = (fn, times = 1)=>{
    if (times <= 0) {
        fn();
        return;
    }
    $436e386d6ba83c06$var$internalMacroTask(()=>{
        $436e386d6ba83c06$export$f1309b2412c6fa89(fn, times - 1);
    });
};
function $436e386d6ba83c06$export$2e2bcd8739ae039(defaultOpen, propOpen, onOpen, postOpen) {
    // SSR not support Portal which means we need delay `open` for the first time render
    const [rendered, setRendered] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setRendered(true);
    }, []);
    const [stateOpen, internalSetOpen] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultOpen, propOpen);
    // Lock for options update
    const [lock, setLock] = (0, $acw62.useState)(false);
    // During SSR, always return false for open state
    const ssrSafeOpen = rendered ? stateOpen : false;
    const mergedOpen = postOpen(ssrSafeOpen);
    const taskIdRef = (0, $acw62.useRef)(0);
    const triggerEvent = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextOpen)=>{
        if (onOpen && mergedOpen !== nextOpen) onOpen(nextOpen);
        internalSetOpen(nextOpen);
    });
    const toggleOpen = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((nextOpen, config = {})=>{
        const { cancelFun: cancelFun } = config;
        taskIdRef.current += 1;
        const id = taskIdRef.current;
        const nextOpenVal = typeof nextOpen === 'boolean' ? nextOpen : !mergedOpen;
        setLock(!nextOpenVal);
        function triggerUpdate() {
            if (// Always check if id is match
            id === taskIdRef.current && // Check if need to cancel
            !cancelFun?.()) {
                triggerEvent(nextOpenVal);
                setLock(false);
            }
        }
        // Weak update can be ignored
        if (nextOpenVal) triggerUpdate();
        else $436e386d6ba83c06$export$f1309b2412c6fa89(()=>{
            triggerUpdate();
        });
    });
    return [
        ssrSafeOpen,
        mergedOpen,
        toggleOpen,
        lock
    ];
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $388b26a679f69cbb$export$2e2bcd8739ae039(props) {
    const { children: children, ...restProps } = props;
    if (!children) return null;
    return /*#__PURE__*/ $acw62.createElement("div", restProps, children);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $78b1d98bdf4e652d$var$SelectInputContext = /*#__PURE__*/ $acw62.createContext(null);
function $78b1d98bdf4e652d$export$7785dec5a5aec756() {
    return $acw62.useContext($78b1d98bdf4e652d$var$SelectInputContext);
}
var $78b1d98bdf4e652d$export$2e2bcd8739ae039 = $78b1d98bdf4e652d$var$SelectInputContext;





const $5d5007118c176409$var$Input = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { onChange: onChange, onKeyDown: onKeyDown, onBlur: onBlur, style: style, syncWidth: syncWidth, value: value, className: className, autoComplete: autoComplete, ...restProps } = props;
    const { prefixCls: prefixCls, mode: mode, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, autoFocus: autoFocus, tokenWithEnter: tokenWithEnter, placeholder: placeholder, components: { input: InputComponent = 'input' } } = (0, $78b1d98bdf4e652d$export$7785dec5a5aec756)();
    const { id: id, classNames: classNames, styles: styles, open: open, activeDescendantId: activeDescendantId, role: role, disabled: disabled } = (0, $b814b04c35134918$export$2e2bcd8739ae039)() || {};
    const inputCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input, className);
    // Used to handle input method composition status
    const compositionStatusRef = $acw62.useRef(false);
    // Used to handle paste content, similar to original Selector implementation
    const pastedTextRef = $acw62.useRef(null);
    // ============================== Refs ==============================
    const inputRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>inputRef.current);
    // ============================== Data ==============================
    // Handle input changes
    const handleChange = (event)=>{
        let { value: nextVal } = event.target;
        // Handle pasted text with tokenWithEnter, similar to original Selector implementation
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            const replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            nextVal = nextVal.replace(replacedText, pastedTextRef.current);
        }
        // Reset pasted text reference
        pastedTextRef.current = null;
        // Call onSearch callback
        if (onSearch) onSearch(nextVal, true, compositionStatusRef.current);
        // Call original onChange callback
        onChange?.(event);
    };
    // ============================ Keyboard ============================
    // Handle keyboard events
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        const { value: nextVal } = event.currentTarget;
        // Handle Enter key submission - referencing Selector implementation
        if (key === 'Enter' && mode === 'tags' && !open && !compositionStatusRef.current && onSearchSubmit) onSearchSubmit(nextVal);
        // Call original onKeyDown callback
        onKeyDown?.(event);
    };
    // Handle blur events
    const handleBlur = (event)=>{
        // Call onInputBlur callback
        onInputBlur?.();
        // Call original onBlur callback
        onBlur?.(event);
    };
    // Handle input method composition start
    const handleCompositionStart = ()=>{
        compositionStatusRef.current = true;
    };
    // Handle input method composition end
    const handleCompositionEnd = (event)=>{
        compositionStatusRef.current = false;
        // Trigger search when input method composition ends, similar to original Selector
        if (mode !== 'combobox') {
            const { value: nextVal } = event.currentTarget;
            onSearch?.(nextVal, true, false);
        }
    };
    // Handle paste events to track pasted content
    const handlePaste = (event)=>{
        const { clipboardData: clipboardData } = event;
        const pastedValue = clipboardData?.getData('text');
        pastedTextRef.current = pastedValue || '';
    };
    // ============================= Width ==============================
    const [widthCssVar, setWidthCssVar] = $acw62.useState(undefined);
    // When syncWidth is enabled, adjust input width based on content
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        const input = inputRef.current;
        if (syncWidth && input) {
            input.style.width = '0px';
            const scrollWidth = input.scrollWidth;
            setWidthCssVar(scrollWidth);
            // Reset input style
            input.style.width = '';
        }
    }, [
        syncWidth,
        value
    ]);
    // ============================= Render =============================
    // Extract shared input props
    const sharedInputProps = {
        id: id,
        type: mode === 'combobox' ? 'text' : 'search',
        ...restProps,
        ref: inputRef,
        style: {
            ...styles?.input,
            ...style,
            '--select-input-width': widthCssVar
        },
        autoFocus: autoFocus,
        autoComplete: autoComplete || 'off',
        className: inputCls,
        disabled: disabled,
        value: value || '',
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onPaste: handlePaste,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd,
        // Accessibility attributes
        role: role || 'combobox',
        'aria-expanded': open || false,
        'aria-haspopup': 'listbox',
        'aria-owns': open ? `${id}_list` : undefined,
        'aria-autocomplete': 'list',
        'aria-controls': open ? `${id}_list` : undefined,
        'aria-activedescendant': open ? activeDescendantId : undefined
    };
    // Handle different InputComponent types
    if (/*#__PURE__*/ $acw62.isValidElement(InputComponent)) {
        // If InputComponent is a ReactElement, use cloneElement with merged props
        const existingProps = InputComponent.props || {};
        // Start with shared props as base
        const mergedProps = {
            placeholder: props.placeholder || placeholder,
            ...sharedInputProps,
            ...existingProps
        };
        // Batch update function calls
        Object.keys(existingProps).forEach((key)=>{
            const existingValue = existingProps[key];
            if (typeof existingValue === 'function') // Merge event handlers
            mergedProps[key] = (...args)=>{
                existingValue(...args);
                sharedInputProps[key]?.(...args);
            };
        });
        // Update ref
        mergedProps.ref = (0, $6c628207f5089a39$export$ab452c34e8e05029)(InputComponent.ref, sharedInputProps.ref);
        return /*#__PURE__*/ $acw62.cloneElement(InputComponent, mergedProps);
    }
    // If InputComponent is a component type, render normally
    const Component = InputComponent;
    return /*#__PURE__*/ $acw62.createElement(Component, sharedInputProps);
});
var $5d5007118c176409$export$2e2bcd8739ae039 = $5d5007118c176409$var$Input;





var $acw62 = parcelRequire("acw62");



function $06ca1de7a6eb4026$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, placeholder: placeholder, displayValues: displayValues } = (0, $78b1d98bdf4e652d$export$7785dec5a5aec756)();
    const { classNames: classNames, styles: styles } = (0, $b814b04c35134918$export$2e2bcd8739ae039)();
    const { show: show = true } = props;
    if (displayValues.length) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-placeholder`, classNames?.placeholder),
        style: {
            visibility: show ? 'visible' : 'hidden',
            ...styles?.placeholder
        }
    }, placeholder);
}



var $acw62 = parcelRequire("acw62");
// Use any here since we do not get the type during compilation
/**
 * SelectContext is only used for Select. BaseSelect should not consume this context.
 */ const $170420c7a2cf645d$var$SelectContext = /*#__PURE__*/ $acw62.createContext(null);
var $170420c7a2cf645d$export$2e2bcd8739ae039 = $170420c7a2cf645d$var$SelectContext;


function $806e3c4cb6297091$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
const $806e3c4cb6297091$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
const $806e3c4cb6297091$export$df7146797a248522 = $806e3c4cb6297091$export$7383f122bf48ec30;
function $806e3c4cb6297091$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $806e3c4cb6297091$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $806e3c4cb6297091$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes(typeof title);
}
function $806e3c4cb6297091$export$70d1bf7729efff40(item) {
    let title = undefined;
    if (item) {
        if ($806e3c4cb6297091$var$isTitleType(item.title)) title = item.title.toString();
        else if ($806e3c4cb6297091$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $fdaa2a15c3bd27c2$var$_extends() {
    $fdaa2a15c3bd27c2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdaa2a15c3bd27c2$var$_extends.apply(this, arguments);
}
const $fdaa2a15c3bd27c2$var$SingleContent = /*#__PURE__*/ $acw62.forwardRef(({ inputProps: inputProps }, ref)=>{
    const { prefixCls: prefixCls, searchValue: searchValue, activeValue: activeValue, displayValues: displayValues, maxLength: maxLength, mode: mode, components: components } = (0, $78b1d98bdf4e652d$export$7785dec5a5aec756)();
    const { triggerOpen: triggerOpen, title: rootTitle, showSearch: showSearch, classNames: classNames, styles: styles } = (0, $b814b04c35134918$export$2e2bcd8739ae039)();
    const selectContext = $acw62.useContext((0, $170420c7a2cf645d$export$2e2bcd8739ae039));
    const [inputChanged, setInputChanged] = $acw62.useState(false);
    const combobox = mode === 'combobox';
    const displayValue = displayValues[0];
    // Implement the same logic as the old SingleSelector
    const mergedSearchValue = $acw62.useMemo(()=>{
        if (combobox && activeValue && !inputChanged && triggerOpen) return activeValue;
        return showSearch ? searchValue : '';
    }, [
        combobox,
        activeValue,
        inputChanged,
        triggerOpen,
        searchValue,
        showSearch
    ]);
    const [optionClassName, optionStyle, optionTitle, hasOptionStyle] = $acw62.useMemo(()=>{
        let className;
        let style;
        let titleValue;
        if (displayValue && selectContext?.flattenOptions) {
            const option = selectContext.flattenOptions.find((opt)=>opt.value === displayValue.value);
            if (option?.data) {
                className = option.data.className;
                style = option.data.style;
                titleValue = (0, $806e3c4cb6297091$export$70d1bf7729efff40)(option.data);
            }
        }
        if (displayValue && !titleValue) titleValue = (0, $806e3c4cb6297091$export$70d1bf7729efff40)(displayValue);
        if (rootTitle !== undefined) titleValue = rootTitle;
        const nextHasStyle = !!className || !!style;
        return [
            className,
            style,
            titleValue,
            nextHasStyle
        ];
    }, [
        displayValue,
        selectContext?.flattenOptions,
        rootTitle
    ]);
    $acw62.useEffect(()=>{
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // ========================== Render ==========================
    const showHasValueCls = displayValue && displayValue.label !== null && displayValue.label !== undefined && String(displayValue.label).trim() !== '';
    // Render value
    // Only render value when not using custom input in combobox mode
    const shouldRenderValue = !(combobox && components?.input);
    const renderValue = shouldRenderValue ? displayValue ? hasOptionStyle ? /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-content-value`, optionClassName),
        style: {
            ...mergedSearchValue ? {
                visibility: 'hidden'
            } : {},
            ...optionStyle
        },
        title: optionTitle
    }, displayValue.label) : displayValue.label : /*#__PURE__*/ $acw62.createElement((0, $06ca1de7a6eb4026$export$2e2bcd8739ae039), {
        show: !mergedSearchValue
    }) : null;
    // Render
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-content`, showHasValueCls && `${prefixCls}-content-has-value`, mergedSearchValue && `${prefixCls}-content-has-search-value`, hasOptionStyle && `${prefixCls}-content-has-option-style`, classNames?.content),
        style: styles?.content,
        title: hasOptionStyle ? undefined : optionTitle
    }, renderValue, /*#__PURE__*/ $acw62.createElement((0, $5d5007118c176409$export$2e2bcd8739ae039), $fdaa2a15c3bd27c2$var$_extends({
        ref: ref
    }, inputProps, {
        value: mergedSearchValue,
        maxLength: mode === 'combobox' ? maxLength : undefined,
        onChange: (e)=>{
            setInputChanged(true);
            inputProps.onChange?.(e);
        }
    })));
});
var $fdaa2a15c3bd27c2$export$2e2bcd8739ae039 = $fdaa2a15c3bd27c2$var$SingleContent;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

/**
 * Small wrapper for Select icons (clear/arrow/etc.).
 * Prevents default mousedown to avoid blurring or caret moves, and
 * renders a custom icon or a fallback icon span.
 *
 * DOM structure:
 * <span className={className} ...>
 *   { icon || <span className={`${className}-icon`}>{children}</span> }
 * </span>
 */ const $ade39d76ecd8086b$var$TransBtn = (props)=>{
    const { className: className, style: style, customizeIcon: customizeIcon, customizeIconProps: customizeIconProps, children: children, onMouseDown: onMouseDown, onClick: onClick } = props;
    const icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: className,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            ...style
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className.split(/\s+/).map((cls)=>`${cls}-icon`))
    }, children));
};
var $ade39d76ecd8086b$export$2e2bcd8739ae039 = $ade39d76ecd8086b$var$TransBtn;





function $a5d0cc08e7504a07$var$_extends() {
    $a5d0cc08e7504a07$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5d0cc08e7504a07$var$_extends.apply(this, arguments);
}
function $a5d0cc08e7504a07$var$itemKey(value) {
    return value.key ?? value.value;
}
const $a5d0cc08e7504a07$var$onPreventMouseDown = (event)=>{
    event.preventDefault();
    event.stopPropagation();
};
var $a5d0cc08e7504a07$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef(function MultipleContent({ inputProps: inputProps }, ref) {
    const { prefixCls: prefixCls, displayValues: displayValues, searchValue: searchValue, mode: mode, onSelectorRemove: onSelectorRemove, removeIcon: removeIconFromContext } = (0, $78b1d98bdf4e652d$export$7785dec5a5aec756)();
    const { disabled: disabled, showSearch: showSearch, triggerOpen: triggerOpen, rawOpen: rawOpen, toggleOpen: toggleOpen, autoClearSearchValue: autoClearSearchValue, tagRender: tagRenderFromContext, maxTagPlaceholder: maxTagPlaceholderFromContext, maxTagTextLength: maxTagTextLength, maxTagCount: maxTagCount, classNames: classNames, styles: styles } = (0, $b814b04c35134918$export$2e2bcd8739ae039)();
    const selectionItemPrefixCls = `${prefixCls}-selection-item`;
    // ===================== Search ======================
    // Apply autoClearSearchValue logic: when dropdown is closed and autoClearSearchValue is not false (default true), clear search value
    // Use rawOpen to avoid clearing search when emptyListContent blocks open
    let computedSearchValue = searchValue;
    if (!rawOpen && mode === 'multiple' && autoClearSearchValue !== false) computedSearchValue = '';
    const inputValue = showSearch ? computedSearchValue || '' : '';
    const inputEditable = showSearch && !disabled;
    // Props from context with safe defaults
    const removeIcon = removeIconFromContext ?? "\xd7";
    const maxTagPlaceholder = maxTagPlaceholderFromContext ?? ((omittedValues)=>`+ ${omittedValues.length} ...`);
    const tagRender = tagRenderFromContext;
    const onToggleOpen = (newOpen)=>{
        toggleOpen(newOpen);
    };
    const onRemove = (value)=>{
        onSelectorRemove?.(value);
    };
    // ======================== Item ========================
    // >>> Render Selector Node. Includes Item & Rest
    const defaultRenderSelector = (item, content, itemDisabled, closable, onClose)=>/*#__PURE__*/ $acw62.createElement("span", {
            title: (0, $806e3c4cb6297091$export$70d1bf7729efff40)(item),
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(selectionItemPrefixCls, {
                [`${selectionItemPrefixCls}-disabled`]: itemDisabled
            }, classNames?.item),
            style: styles?.item
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-content`, classNames?.itemContent),
            style: styles?.itemContent
        }, content), closable && /*#__PURE__*/ $acw62.createElement((0, $ade39d76ecd8086b$export$2e2bcd8739ae039), {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-remove`, classNames?.itemRemove),
            style: styles?.itemRemove,
            onMouseDown: $a5d0cc08e7504a07$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    const customizeRenderSelector = (value, content, itemDisabled, closable, onClose, isMaxTag, info)=>{
        const onMouseDown = (e)=>{
            $a5d0cc08e7504a07$var$onPreventMouseDown(e);
            onToggleOpen(!triggerOpen);
        };
        return /*#__PURE__*/ $acw62.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            index: info?.index,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    // ====================== Overflow ======================
    const renderItem = (valueItem, info)=>{
        const { disabled: itemDisabled, label: label, value: value } = valueItem;
        const closable = !disabled && !itemDisabled;
        let displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                const strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = `${strLabel.slice(0, maxTagTextLength)}...`;
            }
        }
        const onClose = (event)=>{
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, undefined, info) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    const renderRest = (omittedValues)=>{
        // https://github.com/ant-design/ant-design/issues/48930
        if (!displayValues.length) return null;
        const content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // ======================= Render =======================
    return /*#__PURE__*/ $acw62.createElement((0, $99393f3768089249$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-content`,
        className: classNames?.content,
        style: styles?.content,
        prefix: !displayValues.length && !inputValue && /*#__PURE__*/ $acw62.createElement((0, $06ca1de7a6eb4026$export$2e2bcd8739ae039), null),
        data: displayValues,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: /*#__PURE__*/ $acw62.createElement((0, $5d5007118c176409$export$2e2bcd8739ae039), $a5d0cc08e7504a07$var$_extends({
            ref: ref,
            disabled: disabled,
            readOnly: !inputEditable
        }, inputProps, {
            value: inputValue || '',
            syncWidth: true
        })),
        itemKey: $a5d0cc08e7504a07$var$itemKey,
        maxCount: maxTagCount
    });
});




const $16de1e7f4f212553$var$SelectContent = /*#__PURE__*/ $acw62.forwardRef(function SelectContent(_, ref) {
    const { multiple: multiple, onInputKeyDown: onInputKeyDown, tabIndex: tabIndex } = (0, $78b1d98bdf4e652d$export$7785dec5a5aec756)();
    const baseProps = (0, $b814b04c35134918$export$2e2bcd8739ae039)();
    const { showSearch: showSearch } = baseProps;
    const ariaProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(baseProps, {
        aria: true
    });
    const sharedInputProps = {
        ...ariaProps,
        onKeyDown: onInputKeyDown,
        readOnly: !showSearch,
        tabIndex: tabIndex
    };
    if (multiple) return /*#__PURE__*/ $acw62.createElement((0, $a5d0cc08e7504a07$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
    return /*#__PURE__*/ $acw62.createElement((0, $fdaa2a15c3bd27c2$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
});
var $16de1e7f4f212553$export$2e2bcd8739ae039 = $16de1e7f4f212553$var$SelectContent;







function $80704deb13e1569f$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ESC,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).SHIFT,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).BACKSPACE,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).TAB,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).WIN_KEY,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ALT,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).META,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).CTRL,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).SEMICOLON,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).EQUALS,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).CONTEXT_MENU,
        // Arrow keys - should not trigger open when navigating in input
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP,
        // KeyCode.DOWN,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).LEFT,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).RIGHT,
        // F1-F12
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F1,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F2,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F3,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F4,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F5,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F6,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F7,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F8,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F9,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F10,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F11,
        (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}






function $a05715072084934a$var$_extends() {
    $a05715072084934a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a05715072084934a$var$_extends.apply(this, arguments);
}
const $a05715072084934a$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex',
    'activeValue',
    'onSelectorRemove',
    'focused'
];
var $a05715072084934a$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { prefixCls: // Style
    prefixCls, className: className, style: style, prefix: // UI
    prefix, suffix: suffix, clearIcon: clearIcon, children: children, multiple: // Data
    multiple, displayValues: displayValues, placeholder: placeholder, mode: mode, searchValue: // Search
    searchValue, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, maxLength: // Input
    maxLength, autoFocus: autoFocus, onMouseDown: // Events
    onMouseDown, onClearMouseDown: onClearMouseDown, onInputKeyDown: onInputKeyDown, onSelectorRemove: onSelectorRemove, tokenWithEnter: // Token handling
    tokenWithEnter, components: // Components
    components, ...restProps } = props;
    const { triggerOpen: triggerOpen, toggleOpen: toggleOpen, showSearch: showSearch, disabled: disabled, loading: loading, classNames: classNames, styles: styles } = (0, $b814b04c35134918$export$2e2bcd8739ae039)();
    const rootRef = $acw62.useRef(null);
    const inputRef = $acw62.useRef(null);
    // Handle keyboard events similar to original Selector
    const onInternalInputKeyDown = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        const { which: which } = event;
        // Compatible with multiple lines in TextArea
        const isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        // Prevent default behavior for up/down arrows when dropdown is open
        if (!isTextAreaElement && triggerOpen && (which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP || which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        // Call the original onInputKeyDown callback
        if (onInputKeyDown) onInputKeyDown(event);
        // Move within the text box for TextArea
        if (isTextAreaElement && !triggerOpen && ~[
            (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP,
            (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).DOWN,
            (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).LEFT,
            (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        // Open dropdown when a valid open key is pressed
        const isModifier = event.ctrlKey || event.altKey || event.metaKey;
        if (!isModifier && (0, $80704deb13e1569f$export$48ac81d4a07c29c)(which)) toggleOpen(true);
    });
    // ====================== Refs ======================
    $acw62.useImperativeHandle(ref, ()=>{
        return {
            focus: (options)=>{
                // Focus the inner input if available, otherwise fall back to root div.
                (inputRef.current || rootRef.current).focus?.(options);
            },
            blur: ()=>{
                (inputRef.current || rootRef.current).blur?.();
            },
            // Use getDOM to handle nested nativeElement structure (e.g., when RootComponent is antd Input)
            nativeElement: (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(rootRef.current)
        };
    });
    // ====================== Open ======================
    const onInternalMouseDown = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((event)=>{
        if (!disabled) {
            const inputDOM = (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(inputRef.current);
            // https://github.com/ant-design/ant-design/issues/56002
            // Tell `useSelectTriggerControl` to ignore this event
            // When icon is dynamic render, the parentNode will miss
            // so we need to mark the event directly
            event.nativeEvent._ori_target = inputDOM;
            const isClickOnInput = inputDOM === event.target || inputDOM?.contains(event.target);
            if (inputDOM && !isClickOnInput) event.preventDefault();
            // Check if we should prevent closing when clicking on selector
            // Don't close if: open && not multiple && (combobox mode || showSearch)
            const shouldPreventCloseOnSingle = triggerOpen && !multiple && (mode === 'combobox' || showSearch);
            // Don't close if: open && multiple && click on input
            const shouldPreventCloseOnMultipleInput = triggerOpen && multiple && isClickOnInput;
            const shouldPreventClose = shouldPreventCloseOnSingle || shouldPreventCloseOnMultipleInput;
            if (!event.nativeEvent._select_lazy) {
                inputRef.current?.focus();
                // Only toggle open if we should not prevent close
                if (!shouldPreventClose) toggleOpen();
            } else if (triggerOpen) // Lazy should also close when click clear icon
            toggleOpen(false);
        }
        onMouseDown?.(event);
    });
    // =================== Components ===================
    const { root: RootComponent } = components;
    // ===================== Render =====================
    const domProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, $a05715072084934a$var$DEFAULT_OMIT_PROPS);
    const ariaProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(domProps, {
        aria: true
    });
    const ariaKeys = Object.keys(ariaProps);
    // Create context value with wrapped callbacks
    const contextValue = {
        ...props,
        onInputKeyDown: onInternalInputKeyDown
    };
    if (RootComponent) {
        const originProps = RootComponent.props || {};
        const mergedProps = {
            ...originProps,
            ...domProps
        };
        Object.keys(originProps).forEach((key)=>{
            const originVal = originProps[key];
            const domVal = domProps[key];
            if (typeof originVal === 'function' && typeof domVal === 'function') mergedProps[key] = (...args)=>{
                domVal(...args);
                originVal(...args);
            };
        });
        if (/*#__PURE__*/ $acw62.isValidElement(RootComponent)) return /*#__PURE__*/ $acw62.cloneElement(RootComponent, {
            ...mergedProps,
            ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(RootComponent.ref, rootRef)
        });
        return /*#__PURE__*/ $acw62.createElement(RootComponent, $a05715072084934a$var$_extends({}, mergedProps, {
            ref: rootRef
        }));
    }
    return /*#__PURE__*/ $acw62.createElement((0, $78b1d98bdf4e652d$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement("div", $a05715072084934a$var$_extends({}, (0, $cdfb578fac308710$export$2e2bcd8739ae039)(domProps, ariaKeys), {
        // Style
        ref: rootRef,
        className: className,
        style: style,
        onMouseDown: onInternalMouseDown
    }), /*#__PURE__*/ $acw62.createElement((0, $388b26a679f69cbb$export$2e2bcd8739ae039), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $acw62.createElement((0, $16de1e7f4f212553$export$2e2bcd8739ae039), {
        ref: inputRef
    }), /*#__PURE__*/ $acw62.createElement((0, $388b26a679f69cbb$export$2e2bcd8739ae039), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, {
            [`${prefixCls}-suffix-loading`]: loading
        }, classNames?.suffix),
        style: styles?.suffix
    }, suffix), clearIcon && /*#__PURE__*/ $acw62.createElement((0, $388b26a679f69cbb$export$2e2bcd8739ae039), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-clear`, classNames?.clear),
        style: styles?.clear,
        onMouseDown: (e)=>{
            // Mark to tell not trigger open or focus
            e.nativeEvent._select_lazy = true;
            onClearMouseDown?.(e);
        }
    }, clearIcon), children));
});



var $acw62 = parcelRequire("acw62");
function $ab7dbbde434a225e$export$2e2bcd8739ae039(components, getInputElement, getRawInputElement) {
    return $acw62.useMemo(()=>{
        let { root: root, input: input } = components || {};
        // root: getRawInputElement
        if (getRawInputElement) root = getRawInputElement();
        // input: getInputElement
        if (getInputElement) input = getInputElement();
        return {
            root: root,
            input: input
        };
    }, [
        components,
        getInputElement,
        getRawInputElement
    ]);
}


function $c0efb706e934d630$var$_extends() {
    $c0efb706e934d630$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0efb706e934d630$var$_extends.apply(this, arguments);
}
const $c0efb706e934d630$export$7f654ad2a77ad2ac = (mode)=>mode === 'tags' || mode === 'multiple';
const $c0efb706e934d630$var$BaseSelect = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls, className: className, styles: styles, classNames: classNames, showSearch: showSearch, tagRender: tagRender, showScrollBar: showScrollBar = 'optional', direction: direction, omitDomProps: omitDomProps, displayValues: // Value
    displayValues, onDisplayValuesChange: onDisplayValuesChange, emptyOptions: emptyOptions, notFoundContent: notFoundContent = 'Not Found', onClear: onClear, maxCount: maxCount, placeholder: placeholder, mode: // Mode
    mode, disabled: // Status
    disabled, loading: loading, getInputElement: // Customize Input
    getInputElement, getRawInputElement: getRawInputElement, open: // Open
    open, defaultOpen: defaultOpen, onPopupVisibleChange: onPopupVisibleChange, activeValue: // Active
    activeValue, onActiveValueChange: onActiveValueChange, activeDescendantId: activeDescendantId, searchValue: // Search
    searchValue, autoClearSearchValue: autoClearSearchValue, onSearch: onSearch, onSearchSplit: onSearchSplit, tokenSeparators: tokenSeparators, allowClear: // Icons
    allowClear, prefix: prefix, suffix: suffix, suffixIcon: suffixIcon, clearIcon: clearIcon, OptionList: // Dropdown
    OptionList, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, placement: placement, builtinPlacements: builtinPlacements, getPopupContainer: getPopupContainer, showAction: // Focus
    showAction = [], onFocus: onFocus, onBlur: onBlur, onKeyUp: // Rest Events
    onKeyUp, onKeyDown: onKeyDown, onMouseDown: onMouseDown, components: // Components
    components, // Rest Props
    ...restProps } = props;
    // ============================== MISC ==============================
    const multiple = $c0efb706e934d630$export$7f654ad2a77ad2ac(mode);
    // ============================== Refs ==============================
    const containerRef = $acw62.useRef(null);
    const triggerRef = $acw62.useRef(null);
    const listRef = $acw62.useRef(null);
    /** Used for component focused management */ const [focused, setFocused] = $acw62.useState(false);
    // =========================== Imperative ===========================
    $acw62.useImperativeHandle(ref, ()=>({
            focus: containerRef.current?.focus,
            blur: containerRef.current?.blur,
            scrollTo: (arg)=>listRef.current?.scrollTo(arg),
            nativeElement: (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(containerRef.current)
        }));
    // =========================== Components ===========================
    const mergedComponents = (0, $ab7dbbde434a225e$export$2e2bcd8739ae039)(components, getInputElement, getRawInputElement);
    // ========================== Search Value ==========================
    const mergedSearchValue = $acw62.useMemo(()=>{
        if (mode !== 'combobox') return searchValue;
        const val = displayValues[0]?.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    const customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // ============================== Open ==============================
    // Not trigger `open` when `notFoundContent` is empty
    const emptyListContent = !notFoundContent && emptyOptions;
    const [rawOpen, mergedOpen, triggerOpen, lockOptions] = (0, $436e386d6ba83c06$export$2e2bcd8739ae039)(defaultOpen || false, open, onPopupVisibleChange, (nextOpen)=>disabled || emptyListContent ? false : nextOpen);
    // ============================= Search =============================
    const tokenWithEnter = $acw62.useMemo(()=>(tokenSeparators || []).some((tokenSeparator)=>[
                '\n',
                '\r\n'
            ].includes(tokenSeparator)), [
        tokenSeparators
    ]);
    const onInternalSearch = (searchText, fromTyping, isCompositing)=>{
        if (multiple && (0, $1e969b06a3fde7cb$export$be48fd776273e509)(maxCount) && displayValues.length >= maxCount) return;
        let ret = true;
        let newSearchText = searchText;
        onActiveValueChange?.(null);
        const separatedList = (0, $1e969b06a3fde7cb$export$a09ca2a89e052b14)(searchText, tokenSeparators, (0, $1e969b06a3fde7cb$export$be48fd776273e509)(maxCount) ? maxCount - displayValues.length : undefined);
        // Check if match the `tokenSeparators`
        const patchLabels = isCompositing ? null : separatedList;
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit?.(patchLabels);
            // Should close when paste finish
            triggerOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        // Open if from typing
        if (searchText && fromTyping && ret) triggerOpen(true);
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    const onInternalSearchSubmit = (searchText)=>{
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Clean up search value when the dropdown is closed.
    // We use `rawOpen` here to avoid clearing the search input when the dropdown is
    // programmatically closed due to `notFoundContent={null}` and no matching options.
    // This allows the user to continue typing their search query.
    $acw62.useEffect(()=>{
        if (!rawOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        rawOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $acw62.useEffect(()=>{
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled) {
            triggerOpen(false);
            setFocused(false);
        }
    }, [
        disabled,
        mergedOpen
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ const [getClearLock, setClearLock] = (0, $ce67f070ade5c772$export$2e2bcd8739ae039)();
    const keyLockRef = $acw62.useRef(false);
    // KeyDown
    const onInternalKeyDown = (event)=>{
        const clearLock = getClearLock();
        const { key: key } = event;
        const isEnterKey = key === 'Enter';
        const isSpaceKey = key === ' ';
        // Enter or Space opens dropdown (ARIA combobox: spacebar should open)
        if (isEnterKey || isSpaceKey) {
            // Do not submit form when type in the input; prevent Space from scrolling page
            const isCombobox = mode === 'combobox';
            const isEditable = isCombobox || showSearch;
            if (isSpaceKey && !isEditable || isEnterKey && !isCombobox) event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) triggerOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            const cloneDisplayValues = [
                ...displayValues
            ];
            let removedDisplayValue = null;
            for(let i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                const current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        if (mergedOpen && (!isEnterKey || !keyLockRef.current) && !isSpaceKey) {
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            listRef.current?.onKeyDown(event);
        }
        onKeyDown?.(event);
    };
    // KeyUp
    const onInternalKeyUp = (event, ...rest)=>{
        if (mergedOpen) listRef.current?.onKeyUp(event, ...rest);
        if (event.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(event, ...rest);
    };
    // ============================ Selector ============================
    const onSelectorRemove = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((val)=>{
        const newValues = displayValues.filter((i)=>i !== val);
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    });
    const onInputBlur = ()=>{
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    const getSelectElements = ()=>[
            (0, $32e960eedc96a2ca$export$9aa546fdc20ae5b3)(containerRef.current),
            triggerRef.current?.getPopupElement()
        ];
    // Close when click on non-select element
    (0, $7ac4acf13acc2978$export$2e2bcd8739ae039)(getSelectElements, mergedOpen, triggerOpen, !!mergedComponents.root);
    // ========================== Focus / Blur ==========================
    const internalMouseDownRef = $acw62.useRef(false);
    const onInternalFocus = (event)=>{
        setFocused(true);
        if (!disabled) {
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) triggerOpen(true);
            onFocus?.(event);
        }
    };
    const onRootBlur = ()=>{
        // Delay close should check the activeElement
        if (mergedOpen && !internalMouseDownRef.current) triggerOpen(false, {
            cancelFun: ()=>(0, $7ac4acf13acc2978$export$4ac6a1c95deee4c5)(getSelectElements(), document.activeElement)
        });
    };
    const onInternalBlur = (event)=>{
        setFocused(false);
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        onRootBlur();
        if (!disabled) onBlur?.(event);
    };
    const onRootMouseDown = (event, ...restArgs)=>{
        const { target: target } = event;
        const popupElement = triggerRef.current?.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement?.contains(target) && triggerOpen) // Tell `open` not to close since it's safe in the popup
        triggerOpen(true);
        onMouseDown?.(event, ...restArgs);
        internalMouseDownRef.current = true;
        (0, $436e386d6ba83c06$export$f1309b2412c6fa89)(()=>{
            internalMouseDownRef.current = false;
        });
    };
    // ============================ Dropdown ============================
    const [, forceUpdate] = $acw62.useState({});
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    let onTriggerVisibleChange;
    if (!!mergedComponents.root) onTriggerVisibleChange = (newOpen)=>{
        triggerOpen(newOpen);
    };
    // ============================ Context =============================
    const baseSelectContext = $acw62.useMemo(()=>({
            ...props,
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: mergedOpen,
            rawOpen: rawOpen,
            id: id,
            showSearch: showSearch,
            multiple: multiple,
            toggleOpen: triggerOpen,
            showScrollBar: showScrollBar,
            styles: styles,
            classNames: classNames,
            lockOptions: lockOptions
        }), [
        props,
        notFoundContent,
        triggerOpen,
        id,
        showSearch,
        multiple,
        mergedOpen,
        rawOpen,
        showScrollBar,
        styles,
        classNames,
        lockOptions
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Suffix =============================
    const mergedSuffixIcon = $acw62.useMemo(()=>{
        const nextSuffix = suffix ?? suffixIcon;
        if (typeof nextSuffix === 'function') return nextSuffix({
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: focused,
            showSearch: showSearch,
            loading: loading
        });
        return nextSuffix;
    }, [
        suffix,
        suffixIcon,
        mergedSearchValue,
        mergedOpen,
        focused,
        showSearch,
        loading
    ]);
    // ============================= Clear ==============================
    const onClearMouseDown = ()=>{
        onClear?.();
        containerRef.current?.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    const { allowClear: mergedAllowClear, clearIcon: clearNode } = (0, $da5aec9a0cde9f50$export$9ea6397a890aa3e5)(prefixCls, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode);
    // =========================== OptionList ===========================
    const optionList = /*#__PURE__*/ $acw62.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    const mergedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-multiple`]: multiple,
        [`${prefixCls}-single`]: !multiple,
        [`${prefixCls}-allow-clear`]: mergedAllowClear,
        [`${prefixCls}-show-arrow`]: mergedSuffixIcon !== undefined && mergedSuffixIcon !== null,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-open`]: mergedOpen,
        [`${prefixCls}-customize-input`]: customizeInputElement,
        [`${prefixCls}-show-search`]: showSearch
    });
    // >>> Render
    let renderNode = /*#__PURE__*/ $acw62.createElement((0, $a05715072084934a$export$2e2bcd8739ae039), $c0efb706e934d630$var$_extends({}, restProps, {
        // Ref
        ref: containerRef,
        prefixCls: prefixCls,
        className: mergedClassName,
        focused: focused,
        prefix: prefix,
        suffix: mergedSuffixIcon,
        clearIcon: clearNode,
        multiple: multiple,
        mode: mode,
        displayValues: displayValues,
        placeholder: placeholder,
        searchValue: mergedSearchValue,
        activeValue: activeValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onInputBlur: onInputBlur,
        onFocus: onInternalFocus,
        onBlur: onInternalBlur,
        onClearMouseDown: onClearMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onSelectorRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onMouseDown: onRootMouseDown,
        components: mergedComponents
    }));
    renderNode = /*#__PURE__*/ $acw62.createElement((0, $58624638ffe21192$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: mergedOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        popupStyle: popupStyle,
        popupClassName: popupClassName,
        direction: direction,
        popupMatchSelectWidth: popupMatchSelectWidth,
        popupRender: popupRender,
        popupAlign: popupAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter,
        onPopupMouseDown: onRootMouseDown,
        onPopupBlur: onRootBlur
    }, renderNode);
    return /*#__PURE__*/ $acw62.createElement((0, $b814b04c35134918$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, /*#__PURE__*/ $acw62.createElement((0, $d6ed507c3ffa674e$export$2e2bcd8739ae039), {
        visible: focused && !mergedOpen,
        values: displayValues
    }), renderNode);
});
var $c0efb706e934d630$export$2e2bcd8739ae039 = $c0efb706e934d630$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $35a36108daccfa96$var$OptGroup = ()=>null;
$35a36108daccfa96$var$OptGroup.isSelectOptGroup = true;
var $35a36108daccfa96$export$2e2bcd8739ae039 = $35a36108daccfa96$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $6558dfad94c21b23$var$Option = ()=>null;
$6558dfad94c21b23$var$Option.isSelectOption = true;
var $6558dfad94c21b23$export$2e2bcd8739ae039 = $6558dfad94c21b23$var$Option;









var $acw62 = parcelRequire("acw62");



/* istanbul ignore file */ function $1eb30685b93f461e$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



function $adb63ae76795a2d1$var$_extends() {
    $adb63ae76795a2d1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $adb63ae76795a2d1$var$_extends.apply(this, arguments);
}
// export interface OptionListProps<OptionsType extends object[]> {
function $adb63ae76795a2d1$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ const $adb63ae76795a2d1$var$OptionList = (_, ref)=>{
    const { prefixCls: prefixCls, id: id, open: open, multiple: multiple, mode: mode, searchValue: searchValue, toggleOpen: toggleOpen, notFoundContent: notFoundContent, onPopupScroll: onPopupScroll, showScrollBar: showScrollBar, lockOptions: lockOptions } = (0, $b814b04c35134918$export$2e2bcd8739ae039)();
    const { maxCount: maxCount, flattenOptions: flattenOptions, onActiveValue: onActiveValue, defaultActiveFirstOption: defaultActiveFirstOption, onSelect: onSelect, menuItemSelectedIcon: menuItemSelectedIcon, rawValues: rawValues, fieldNames: fieldNames, virtual: virtual, direction: direction, listHeight: listHeight, listItemHeight: listItemHeight, optionRender: optionRender, classNames: contextClassNames, styles: contextStyles } = $acw62.useContext((0, $170420c7a2cf645d$export$2e2bcd8739ae039));
    const itemPrefixCls = `${prefixCls}-item`;
    const memoFlattenOptions = (0, $194bfd19ce5ffd07$export$2e2bcd8739ae039)(()=>flattenOptions, [
        open,
        lockOptions
    ], (prev, next)=>next[0] && !next[1]);
    // =========================== List ===========================
    const listRef = $acw62.useRef(null);
    const overMaxCount = $acw62.useMemo(()=>multiple && (0, $1e969b06a3fde7cb$export$be48fd776273e509)(maxCount) && rawValues?.size >= maxCount, [
        multiple,
        maxCount,
        rawValues?.size
    ]);
    const onListMouseDown = (event)=>{
        event.preventDefault();
    };
    const scrollIntoView = (args)=>{
        listRef.current?.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    const isSelected = $acw62.useCallback((value)=>{
        if (mode === 'combobox') return false;
        return rawValues.has(value);
    }, [
        mode,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    const getEnabledActiveIndex = (index, offset = 1)=>{
        const len = memoFlattenOptions.length;
        for(let i = 0; i < len; i += 1){
            const current = (index + i * offset + len) % len;
            const { group: group, data: data } = memoFlattenOptions[current] || {};
            if (!group && !data?.disabled && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    const [activeIndex, setActiveIndex] = $acw62.useState(()=>getEnabledActiveIndex(0));
    const setActive = (index, fromKeyboard = false)=>{
        setActiveIndex(index);
        const info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        const flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $acw62.useEffect)(()=>{
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    const isAriaSelected = $acw62.useCallback((value)=>{
        if (mode === 'combobox') return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $acw62.useEffect)(()=>{
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ let timeoutId;
        if (!multiple && open && rawValues.size === 1) {
            const value = Array.from(rawValues)[0];
            // Scroll to the option closest to the searchValue if searching.
            const index = memoFlattenOptions.findIndex(({ data: data })=>searchValue ? String(data.value).startsWith(searchValue) : data.value === value);
            if (index !== -1) {
                setActive(index);
                timeoutId = setTimeout(()=>{
                    scrollIntoView(index);
                });
            }
        }
        // Force trigger scrollbar visible when open
        if (open) listRef.current?.scrollTo(undefined);
        return ()=>clearTimeout(timeoutId);
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    const onSelectValue = (value)=>{
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $acw62.useImperativeHandle(ref, ()=>({
            onKeyDown: (event)=>{
                const { which: which, ctrlKey: ctrlKey } = event;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).N:
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).P:
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP:
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).DOWN:
                        {
                            let offset = 0;
                            if (which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).UP) offset = -1;
                            else if (which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).DOWN) offset = 1;
                            else if ((0, $1eb30685b93f461e$export$3bbcfec016973a77)() && ctrlKey) {
                                if (which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).N) offset = 1;
                                else if (which === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).P) offset = -1;
                            }
                            if (offset !== 0) {
                                const nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                                scrollIntoView(nextActiveIndex);
                                setActive(nextActiveIndex, true);
                            }
                            break;
                        }
                    // >>> Select (Tab / Enter)
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).TAB:
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER:
                        {
                            // value
                            const item = memoFlattenOptions[activeIndex];
                            if (!item || item.data.disabled) return onSelectValue(undefined);
                            if (!overMaxCount || rawValues.has(item.value)) onSelectValue(item.value);
                            else onSelectValue(undefined);
                            if (open) event.preventDefault();
                            break;
                        }
                    // >>> Close
                    case (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: ()=>{},
            scrollTo: (index)=>{
                scrollIntoView(index);
            }
        }));
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $acw62.createElement("div", {
        role: "listbox",
        id: `${id}_list`,
        className: `${itemPrefixCls}-empty`,
        onMouseDown: onListMouseDown
    }, notFoundContent);
    const omitFieldNameList = Object.keys(fieldNames).map((key)=>fieldNames[key]);
    const getLabel = (item)=>item.label;
    function getItemAriaProps(item, index) {
        const { group: group } = item;
        return {
            role: group ? 'presentation' : 'option',
            id: `${id}_list_${index}`
        };
    }
    const renderItem = (index)=>{
        const item = memoFlattenOptions[index];
        if (!item) return null;
        const itemData = item.data || {};
        const { value: value, disabled: disabled } = itemData;
        const { group: group } = item;
        const attrs = (0, $613e269121c63c71$export$2e2bcd8739ae039)(itemData, true);
        const mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $acw62.createElement("div", $adb63ae76795a2d1$var$_extends({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value),
            "aria-disabled": disabled
        }), value) : null;
    };
    const a11yProps = {
        role: 'listbox',
        id: `${id}_list`
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, virtual && /*#__PURE__*/ $acw62.createElement("div", $adb63ae76795a2d1$var$_extends({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $acw62.createElement((0, $164934b9257bae32$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps,
        showScrollBar: showScrollBar,
        className: contextClassNames?.popup?.list,
        style: contextStyles?.popup?.list
    }, (item, itemIndex)=>{
        const { group: group, groupOption: groupOption, data: data, label: label, value: value } = item;
        const { key: key } = data;
        // Group
        if (group) {
            const groupTitle = data.title ?? ($adb63ae76795a2d1$var$isTitleType(label) ? label.toString() : undefined);
            return /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(itemPrefixCls, `${itemPrefixCls}-group`, data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        const { disabled: disabled, title: title, children: children, style: style, className: className, ...otherProps } = data;
        const passedProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        const selected = isSelected(value);
        const mergedDisabled = disabled || !selected && overMaxCount;
        const optionPrefixCls = `${itemPrefixCls}-option`;
        const optionClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(itemPrefixCls, optionPrefixCls, className, contextClassNames?.popup?.listItem, {
            [`${optionPrefixCls}-grouped`]: groupOption,
            [`${optionPrefixCls}-active`]: activeIndex === itemIndex && !mergedDisabled,
            [`${optionPrefixCls}-disabled`]: mergedDisabled,
            [`${optionPrefixCls}-selected`]: selected
        });
        const mergedLabel = getLabel(item);
        const iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        const content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        let optionTitle = $adb63ae76795a2d1$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $acw62.createElement("div", $adb63ae76795a2d1$var$_extends({}, (0, $613e269121c63c71$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": virtual ? undefined : isAriaSelected(value),
            "aria-disabled": mergedDisabled,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: ()=>{
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: ()=>{
                if (!mergedDisabled) onSelectValue(value);
            },
            style: {
                ...contextStyles?.popup?.listItem,
                ...style
            }
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: `${optionPrefixCls}-content`
        }, typeof optionRender === 'function' ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $acw62.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $acw62.createElement((0, $ade39d76ecd8086b$export$2e2bcd8739ae039), {
            className: `${itemPrefixCls}-option-state`,
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
const $adb63ae76795a2d1$var$RefOptionList = /*#__PURE__*/ $acw62.forwardRef($adb63ae76795a2d1$var$OptionList);
var $adb63ae76795a2d1$export$2e2bcd8739ae039 = $adb63ae76795a2d1$var$RefOptionList;




var $acw62 = parcelRequire("acw62");
var /**
 * Cache `value` related LabeledValue & options.
 */ $7abba2f2dec3a111$export$2e2bcd8739ae039 = (labeledValues, valueOptions)=>{
    const cacheRef = $acw62.useRef({
        values: new Map(),
        options: new Map()
    });
    const filledLabeledValues = $acw62.useMemo(()=>{
        const { values: prevValueCache, options: prevOptionCache } = cacheRef.current;
        // Fill label by cache
        const patchedValues = labeledValues.map((item)=>{
            if (item.label === undefined) return {
                ...item,
                label: prevValueCache.get(item.value)?.label
            };
            return item;
        });
        // Refresh cache
        const valueCache = new Map();
        const optionCache = new Map();
        patchedValues.forEach((item)=>{
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    const getOption = $acw62.useCallback((val)=>valueOptions.get(val) || cacheRef.current.options.get(val), [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $acw62 = parcelRequire("acw62");


function $9e54e1c2d5af1c8b$var$includes(test, search) {
    return (0, $806e3c4cb6297091$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $9e54e1c2d5af1c8b$export$2e2bcd8739ae039 = (options, fieldNames, searchValue, filterOption, optionFilterProp)=>{
    return $acw62.useMemo(()=>{
        if (!searchValue || filterOption === false) return options;
        const { options: fieldOptions, label: fieldLabel, value: fieldValue } = fieldNames;
        const filteredOptions = [];
        const customizeFilter = typeof filterOption === 'function';
        const upperSearch = searchValue.toUpperCase();
        const filterFunc = customizeFilter ? filterOption : (_, option)=>{
            // Use provided `optionFilterProp`
            if (optionFilterProp && optionFilterProp.length) return optionFilterProp.some((prop)=>$9e54e1c2d5af1c8b$var$includes(option[prop], upperSearch));
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $9e54e1c2d5af1c8b$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $9e54e1c2d5af1c8b$var$includes(option[fieldValue], upperSearch);
        };
        const wrapOption = customizeFilter ? (opt)=>(0, $1e969b06a3fde7cb$export$d0b21b213c8c013c)(opt) : (opt)=>opt;
        options.forEach((item)=>{
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                const matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    const subOptions = item[fieldOptions].filter((subItem)=>filterFunc(searchValue, wrapOption(subItem)));
                    if (subOptions.length) filteredOptions.push({
                        ...item,
                        [fieldOptions]: subOptions
                    });
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $1e37279d0465f672$var$convertNodeToOption(node) {
    const { key: key, props: { children: children, value: value, ...restProps } } = node;
    return {
        key: key,
        value: value !== undefined ? value : key,
        children: children,
        ...restProps
    };
}
function $1e37279d0465f672$export$3beca35db74c3985(nodes, optionOnly = false) {
    return (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(nodes).map((node, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return null;
        const { type: { isSelectOptGroup: isSelectOptGroup }, key: key, props: { children: children, ...restProps } } = node;
        if (optionOnly || !isSelectOptGroup) return $1e37279d0465f672$var$convertNodeToOption(node);
        return {
            key: `__RC_SELECT_GRP__${key === null ? index : key}__`,
            label: key,
            ...restProps,
            options: $1e37279d0465f672$export$3beca35db74c3985(children)
        };
    }).filter((data)=>data);
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ const $11f15af47b6596c3$var$useOptions = (options, children, fieldNames, optionFilterProp, optionLabelProp)=>{
    return $acw62.useMemo(()=>{
        let mergedOptions = options;
        const childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $1e37279d0465f672$export$3beca35db74c3985)(children);
        const valueOptions = new Map();
        const labelOptions = new Map();
        const setLabelOptions = (labelOptionsMap, option, key)=>{
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        const dig = (optionList, isChildren = false)=>{
            // for loop to speed up collection speed
            for(let i = 0; i < optionList.length; i += 1){
                const option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    optionFilterProp.forEach((prop)=>{
                        setLabelOptions(labelOptions, option, prop);
                    });
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $11f15af47b6596c3$export$2e2bcd8739ae039 = $11f15af47b6596c3$var$useOptions;



var $acw62 = parcelRequire("acw62");
function $ef7fcb2e12ee7ade$export$2e2bcd8739ae039(callback) {
    const funcRef = $acw62.useRef();
    funcRef.current = callback;
    const cacheFn = $acw62.useCallback((...args)=>{
        return funcRef.current(...args);
    }, []);
    return cacheFn;
}







var $acw62 = parcelRequire("acw62");



function $1f0c4a761b9df0a9$var$warningProps(props) {
    const { mode: mode, options: options, children: children, backfill: backfill, allowClear: allowClear, placeholder: placeholder, getInputElement: getInputElement, showSearch: showSearch, onSearch: onSearch, defaultOpen: defaultOpen, autoFocus: autoFocus, labelInValue: labelInValue, value: value, optionLabelProp: optionLabelProp } = props;
    const multiple = (0, $c0efb706e934d630$export$7f654ad2a77ad2ac)(mode);
    const mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    const mergedOptions = options || (0, $1e37279d0465f672$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(mode !== 'tags' || mergedOptions.every((opt)=>!opt.disabled), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        const hasNumberValue = mergedOptions.some((item)=>{
            if (item.options) return item.options.some((opt)=>typeof ('value' in opt ? opt.value : opt.key) === 'number');
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $3ef2f9e39800a1a1$export$89ff31684837bbbf)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $3ef2f9e39800a1a1$export$89ff31684837bbbf)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        const values = (0, $806e3c4cb6297091$export$45b10814cc054894)(value);
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!labelInValue || values.every((val)=>typeof val === 'object' && ('key' in val || 'value' in val)), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        let invalidateChildType = null;
        (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(children).some((node)=>{
            if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return false;
            const { type: type } = node;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                const allChildrenValid = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(node.props.children).every((subNode)=>{
                    if (!/*#__PURE__*/ $acw62.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, `\`children\` should be \`Select.Option\` or \`Select.OptGroup\` instead of \`${invalidateChildType.displayName || invalidateChildType.name || invalidateChildType}\`.`);
    }
}
function $1f0c4a761b9df0a9$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        const recursiveOptions = (optionsList, inGroup = false)=>{
            for(let i = 0; i < optionsList.length; i++){
                const option = optionsList[i];
                if (option[fieldNames?.value] === null) {
                    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames?.options]) && recursiveOptions(option[fieldNames?.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $1f0c4a761b9df0a9$export$2e2bcd8739ae039 = $1f0c4a761b9df0a9$var$warningProps;



var $acw62 = parcelRequire("acw62");
function $2a3e8e77cab32e1c$export$2e2bcd8739ae039(showSearch, props, mode) {
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue } = props;
    return $acw62.useMemo(()=>{
        const isObject = typeof showSearch === 'object';
        const searchConfig = {
            filterOption: filterOption,
            searchValue: searchValue,
            optionFilterProp: optionFilterProp,
            filterSort: filterSort,
            onSearch: onSearch,
            autoClearSearchValue: autoClearSearchValue,
            ...isObject ? showSearch : {}
        };
        return [
            isObject || mode === 'combobox' || mode === 'tags' || mode === 'multiple' && showSearch === undefined ? true : showSearch,
            searchConfig
        ];
    }, [
        mode,
        showSearch,
        filterOption,
        searchValue,
        optionFilterProp,
        filterSort,
        onSearch,
        autoClearSearchValue
    ]);
}


function $5fdfb1ae0f6eb41e$var$_extends() {
    $5fdfb1ae0f6eb41e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5fdfb1ae0f6eb41e$var$_extends.apply(this, arguments);
}
const $5fdfb1ae0f6eb41e$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $5fdfb1ae0f6eb41e$var$isRawValue(value) {
    return !value || typeof value !== 'object';
}
const $5fdfb1ae0f6eb41e$var$Select = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { id: id, mode: mode, prefixCls: prefixCls = 'rc-select', backfill: backfill, fieldNames: fieldNames, showSearch: // Search
    showSearch, searchValue: legacySearchValue, onSearch: legacyOnSearch, autoClearSearchValue: legacyAutoClearSearchValue, filterOption: legacyFilterOption, optionFilterProp: legacyOptionFilterProp, filterSort: legacyFilterSort, onSelect: // Select
    onSelect, onDeselect: onDeselect, onActive: onActive, popupMatchSelectWidth: popupMatchSelectWidth = true, optionLabelProp: optionLabelProp, options: options, optionRender: optionRender, children: children, defaultActiveFirstOption: defaultActiveFirstOption, menuItemSelectedIcon: menuItemSelectedIcon, virtual: virtual, direction: direction, listHeight: listHeight = 200, listItemHeight: listItemHeight = 20, labelRender: labelRender, value: // Value
    value, defaultValue: defaultValue, labelInValue: labelInValue, onChange: onChange, maxCount: maxCount, classNames: classNames, styles: styles, ...restProps } = props;
    const searchProps = {
        searchValue: legacySearchValue,
        onSearch: legacyOnSearch,
        autoClearSearchValue: legacyAutoClearSearchValue,
        filterOption: legacyFilterOption,
        optionFilterProp: legacyOptionFilterProp,
        filterSort: legacyFilterSort
    };
    const [mergedShowSearch, searchConfig] = (0, $2a3e8e77cab32e1c$export$2e2bcd8739ae039)(showSearch, searchProps, mode);
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue = true } = searchConfig;
    const normalizedOptionFilterProp = $acw62.useMemo(()=>{
        if (!optionFilterProp) return [];
        return Array.isArray(optionFilterProp) ? optionFilterProp : [
            optionFilterProp
        ];
    }, [
        optionFilterProp
    ]);
    const mergedId = (0, $bba066f19964922a$export$2e2bcd8739ae039)(id);
    const multiple = (0, $c0efb706e934d630$export$7f654ad2a77ad2ac)(mode);
    const childrenAsData = !!(!options && children);
    const mergedFilterOption = $acw62.useMemo(()=>{
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    const mergedFieldNames = $acw62.useMemo(()=>(0, $1e969b06a3fde7cb$export$6c519d302dced239)(fieldNames, childrenAsData), /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    const [internalSearchValue, setSearchValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)('', searchValue);
    const mergedSearchValue = internalSearchValue || '';
    // =========================== Option ===========================
    const parsedOptions = (0, $11f15af47b6596c3$export$2e2bcd8739ae039)(options, children, mergedFieldNames, normalizedOptionFilterProp, optionLabelProp);
    const { valueOptions: valueOptions, labelOptions: labelOptions, options: mergedOptions } = parsedOptions;
    // ========================= Wrap Value =========================
    const convert2LabelValues = $acw62.useCallback((draftValues)=>{
        // Convert to array
        const valueList = (0, $806e3c4cb6297091$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map((val)=>{
            let rawValue;
            let rawLabel;
            let rawDisabled;
            let rawTitle;
            // Fill label & value
            if ($5fdfb1ae0f6eb41e$var$isRawValue(val)) rawValue = val;
            else {
                rawLabel = val.label;
                rawValue = val.value;
            }
            const option = valueOptions.get(rawValue);
            if (option) {
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option?.[optionLabelProp || mergedFieldNames.label];
                rawDisabled = option?.disabled;
                rawTitle = option?.title;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawValue,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    const [internalValue, setInternalValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultValue, value);
    // Merged value with LabelValueType
    const rawLabeledValues = $acw62.useMemo(()=>{
        const newInternalValue = multiple && internalValue === null ? [] : internalValue;
        const values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === 'combobox' && (0, $806e3c4cb6297091$export$9d186c3672bb89c6)(values[0]?.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    const [mergedValues, getMixedOption] = (0, $7abba2f2dec3a111$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions);
    const displayValues = $acw62.useMemo(()=>{
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            const firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map((item)=>({
                ...item,
                label: (typeof labelRender === 'function' ? labelRender(item) : item.label) ?? item.value
            }));
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ const rawValues = $acw62.useMemo(()=>new Set(mergedValues.map((val)=>val.value)), [
        mergedValues
    ]);
    $acw62.useEffect(()=>{
        if (mode === 'combobox') {
            const strValue = mergedValues[0]?.value;
            setSearchValue((0, $806e3c4cb6297091$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    const createTagOption = (0, $ef7fcb2e12ee7ade$export$2e2bcd8739ae039)((val, label)=>{
        const mergedLabel = label ?? val;
        return {
            [mergedFieldNames.value]: val,
            [mergedFieldNames.label]: mergedLabel
        };
    });
    // Fill tag as option if mode is `tags`
    const filledTagOptions = $acw62.useMemo(()=>{
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        const cloneOptions = [
            ...mergedOptions
        ];
        // Check if value exist in options (include new patch item)
        const existOptions = (val)=>valueOptions.has(val);
        // Fill current value as option
        [
            ...mergedValues
        ].sort((a, b)=>a.value < b.value ? -1 : 1).forEach((item)=>{
            const val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    const filteredOptions = (0, $9e54e1c2d5af1c8b$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, normalizedOptionFilterProp);
    // Fill options with search value if needed
    const filledSearchOptions = $acw62.useMemo(()=>{
        const hasItemMatchingSearch = (item)=>{
            if (normalizedOptionFilterProp.length) return normalizedOptionFilterProp.some((prop)=>item?.[prop] === mergedSearchValue);
            return item?.value === mergedSearchValue;
        };
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some((item)=>hasItemMatchingSearch(item))) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some((item)=>item[mergedFieldNames.value] === mergedSearchValue)) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue),
            ...filteredOptions
        ];
    }, [
        createTagOption,
        normalizedOptionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    const sorter = (inputOptions)=>{
        const sortedOptions = [
            ...inputOptions
        ].sort((a, b)=>filterSort(a, b, {
                searchValue: mergedSearchValue
            }));
        return sortedOptions.map((item)=>{
            if (Array.isArray(item.options)) return {
                ...item,
                options: item.options.length > 0 ? sorter(item.options) : item.options
            };
            return item;
        });
    };
    const orderedFilteredOptions = $acw62.useMemo(()=>{
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    const displayOptions = $acw62.useMemo(()=>(0, $1e969b06a3fde7cb$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        }), [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    const triggerChange = (values)=>{
        const labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some((newVal, index)=>mergedValues[index]?.value !== newVal?.value))) {
            const returnValues = labelInValue ? labeledValues.map(({ label: l, value: v })=>({
                    label: l,
                    value: v
                })) : labeledValues.map((v)=>v.value);
            const returnOptions = labeledValues.map((v)=>(0, $1e969b06a3fde7cb$export$d0b21b213c8c013c)(getMixedOption(v.value)));
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    const [activeValue, setActiveValue] = $acw62.useState(null);
    const [accessibilityIndex, setAccessibilityIndex] = $acw62.useState(0);
    const mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    const activeEventRef = $acw62.useRef();
    const onActiveValue = $acw62.useCallback((active, index, { source: source = 'keyboard' } = {})=>{
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
        // Active will call multiple times.
        // We only need trigger the last one.
        const promise = Promise.resolve().then(()=>{
            if (activeEventRef.current === promise) onActive?.(active);
        });
        activeEventRef.current = promise;
    }, [
        backfill,
        mode,
        onActive
    ]);
    // ========================= OptionList =========================
    const triggerSelect = (val, selected, type)=>{
        const getSelectEnt = ()=>{
            const option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option?.[mergedFieldNames.label],
                    value: val
                } : val,
                (0, $1e969b06a3fde7cb$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            const [wrappedValue, option] = getSelectEnt();
            onSelect(wrappedValue, option);
        } else if (!selected && onDeselect && type !== 'clear') {
            const [wrappedValue, option] = getSelectEnt();
            onDeselect(wrappedValue, option);
        }
    };
    // Used for OptionList selection
    const onInternalSelect = (0, $ef7fcb2e12ee7ade$export$2e2bcd8739ae039)((val, info)=>{
        let cloneValues;
        // Single mode always trigger select only with option list
        const mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [
            ...mergedValues,
            val
        ] : [
            val
        ];
        else cloneValues = mergedValues.filter((v)=>v.value !== val);
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') setActiveValue('');
        else if (!(0, $c0efb706e934d630$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    const onDisplayValuesChange = (nextValues, info)=>{
        triggerChange(nextValues);
        const { type: type, values: values } = info;
        if (type === 'remove' || type === 'clear') values.forEach((item)=>{
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    const onInternalSearch = (searchText, info)=>{
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            const formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                const newRawValues = Array.from(new Set([
                    ...rawValues,
                    formatted
                ]));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch?.(searchText);
        }
    };
    const onInternalSearchSplit = (words)=>{
        let patchValues = words;
        if (mode !== 'tags') patchValues = words.map((word)=>{
            const opt = labelOptions.get(word);
            return opt?.value;
        }).filter((val)=>val !== undefined);
        const newRawValues = Array.from(new Set([
            ...rawValues,
            ...patchValues
        ]));
        triggerChange(newRawValues);
        newRawValues.forEach((newRawValue)=>{
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    const selectContext = $acw62.useMemo(()=>{
        const realVirtual = virtual !== false && popupMatchSelectWidth !== false;
        return {
            ...parsedOptions,
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender,
            classNames: classNames,
            styles: styles
        };
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        popupMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender,
        classNames,
        styles
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $acw62.createElement((0, $170420c7a2cf645d$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $acw62.createElement((0, $c0efb706e934d630$export$2e2bcd8739ae039), $5fdfb1ae0f6eb41e$var$_extends({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $5fdfb1ae0f6eb41e$var$OMIT_DOM_PROPS,
        mode: mode,
        classNames: classNames,
        styles: styles,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        maxCount: maxCount,
        direction: direction,
        showSearch: mergedShowSearch,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        popupMatchSelectWidth: popupMatchSelectWidth,
        OptionList: (0, $adb63ae76795a2d1$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: `${mergedId}_list_${accessibilityIndex}`
    })));
});
const $5fdfb1ae0f6eb41e$var$TypedSelect = $5fdfb1ae0f6eb41e$var$Select;
$5fdfb1ae0f6eb41e$var$TypedSelect.Option = (0, $6558dfad94c21b23$export$2e2bcd8739ae039);
$5fdfb1ae0f6eb41e$var$TypedSelect.OptGroup = (0, $35a36108daccfa96$export$2e2bcd8739ae039);
var $5fdfb1ae0f6eb41e$export$2e2bcd8739ae039 = $5fdfb1ae0f6eb41e$var$TypedSelect;






var $a386b5f49df0483a$export$2e2bcd8739ae039 = (0, $5fdfb1ae0f6eb41e$export$2e2bcd8739ae039);



















const $5b1ac51a636fb330$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: {
            ...sharedConfig,
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ]
        },
        bottomRight: {
            ...sharedConfig,
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            ...sharedConfig,
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ]
        },
        topRight: {
            ...sharedConfig,
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ]
        }
    };
};
function $5b1ac51a636fb330$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $5b1ac51a636fb330$var$getBuiltInPlacements(popupOverflow);
}
var $5b1ac51a636fb330$export$2e2bcd8739ae039 = $5b1ac51a636fb330$var$mergedBuiltinPlacements;







const $879d950d114a8bdf$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: 'relative',
        display: 'block',
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: 'border-box'
    };
};
const $879d950d114a8bdf$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: {
                // ========================== Popup ==========================
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: 'border-box',
                padding: token.paddingXXS,
                overflow: 'hidden',
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: 'initial',
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $f8b44896cb986807$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $f8b44896cb986807$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $f8b44896cb986807$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $f8b44896cb986807$export$f7243fdb9c27c3b7)
                },
                '&-hidden': {
                    display: 'none'
                },
                [selectItemCls]: {
                    ...$879d950d114a8bdf$var$genItemStyle(token),
                    cursor: 'pointer',
                    transition: `background-color ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    '&-group': {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: 'default'
                    },
                    // =========== Option ===========
                    '&-option': {
                        display: 'flex',
                        '&-content': {
                            flex: 'auto',
                            ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629)
                        },
                        '&-state': {
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center'
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        '&-disabled': {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: 'not-allowed'
                        },
                        '&-grouped': {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    '&-empty': {
                        ...$879d950d114a8bdf$var$genItemStyle(token),
                        color: token.colorTextDisabled
                    }
                },
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Follow code may reuse in other components
        (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var $879d950d114a8bdf$export$2e2bcd8739ae039 = $879d950d114a8bdf$var$genSingleStyle;





const $4279178fb040dcb3$var$genSelectInputCustomizeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-customize`]: {
            border: 0,
            padding: 0,
            fontSize: 'inherit',
            lineHeight: 'inherit',
            [`${componentCls}-placeholder`]: {
                display: 'none'
            },
            [`${componentCls}-content`]: {
                margin: 0,
                padding: 0,
                '&-value': {
                    display: 'none'
                }
            }
        }
    };
};
var $4279178fb040dcb3$export$2e2bcd8739ae039 = $4279178fb040dcb3$var$genSelectInputCustomizeStyle;




const $771e53cb30dfdcff$var$FIXED_INPUT_MIN_WIDTH = 4;
const $771e53cb30dfdcff$var$genSelectInputMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, iconCls: iconCls, paddingXS: paddingXS, paddingXXS: paddingXXS, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, inputPaddingHorizontalBase: inputPaddingHorizontalBase, antCls: antCls } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'select');
    return {
        '&-multiple': {
            [varName('multi-item-background')]: token.multipleItemBg,
            [varName('multi-item-border-color')]: 'transparent',
            [varName('multi-item-border-radius')]: token.borderRadiusSM,
            [varName('multi-item-height')]: token.multipleItemHeight,
            [varName('multi-padding-base')]: `calc((${varRef('height')} - ${varRef('multi-item-height')}) / 2)`,
            [varName('multi-padding-vertical')]: `calc(${varRef('multi-padding-base')} - ${INTERNAL_FIXED_ITEM_MARGIN} - ${lineWidth})`,
            [varName('multi-item-padding-horizontal')]: `calc(${inputPaddingHorizontalBase} - ${varRef('multi-padding-vertical')} - ${lineWidth} * 2)`,
            // ========================================================
            // ==                        Base                        ==
            // ========================================================
            // ========================= Root =========================
            paddingBlock: varRef('multi-padding-vertical'),
            paddingInlineStart: `calc(${varRef('multi-padding-base')} - ${lineWidth})`,
            // ======================== Prefix ========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: varRef('multi-item-padding-horizontal')
            },
            [`${componentCls}-prefix + ${componentCls}-content`]: {
                [`${componentCls}-placeholder`]: {
                    insetInlineStart: 0
                },
                [`${componentCls}-content-item${componentCls}-content-item-suffix`]: {
                    marginInlineStart: 0
                }
            },
            // ===================== Placeholder ======================
            [`${componentCls}-placeholder`]: {
                position: 'absolute',
                lineHeight: varRef('line-height'),
                insetInlineStart: varRef('multi-item-padding-horizontal'),
                width: `calc(100% - ${varRef('multi-item-padding-horizontal')})`,
                top: '50%',
                transform: 'translateY(-50%)'
            },
            // ======================= Content ========================
            [`${componentCls}-content`]: {
                flexWrap: 'wrap',
                alignItems: 'center',
                lineHeight: 1,
                '&-item-prefix': {
                    height: varRef('font-size')
                },
                '&-item': {
                    lineHeight: 1,
                    maxWidth: `calc(100% - ${$771e53cb30dfdcff$var$FIXED_INPUT_MIN_WIDTH}px)`
                },
                [`${componentCls}-content-item-prefix + ${componentCls}-content-item-suffix,
          ${componentCls}-content-item-suffix:first-child`]: {
                    marginInlineStart: varRef('multi-item-padding-horizontal')
                },
                [`${componentCls}-selection-item`]: {
                    lineHeight: `calc(${varRef('multi-item-height')} - ${lineWidth} * 2)`,
                    border: `${lineWidth} solid ${varRef('multi-item-border-color')}`,
                    display: 'flex',
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                    marginInlineEnd: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                    background: varRef('multi-item-background'),
                    borderRadius: varRef('multi-item-border-radius'),
                    paddingInlineStart: paddingXS,
                    paddingInlineEnd: paddingXXS,
                    transition: [
                        'height',
                        'line-height',
                        'padding'
                    ].map((key)=>`${key} ${token.motionDurationSlow}`).join(','),
                    // >>> Content
                    '&-content': {
                        ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                        marginInlineEnd: paddingXXS
                    },
                    // >>> Remove
                    '&-remove': {
                        ...(0, $4733a3b3eb18f80d$export$171ccda7bc085e59)(),
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: colorIcon,
                        fontWeight: 'bold',
                        fontSize: 10,
                        lineHeight: 'inherit',
                        cursor: 'pointer',
                        [`> ${iconCls}`]: {
                            verticalAlign: '-0.2em'
                        },
                        '&:hover': {
                            color: colorIconHover
                        }
                    }
                },
                [`${componentCls}-input`]: {
                    lineHeight: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).add(varRef('multi-item-height')).equal(),
                    width: `calc(var(--select-input-width, 0) * 1px)`,
                    minWidth: $771e53cb30dfdcff$var$FIXED_INPUT_MIN_WIDTH,
                    maxWidth: '100%',
                    transition: `line-height ${token.motionDurationSlow}`
                }
            },
            // ========================================================
            // ==                        Size                        ==
            // ========================================================
            [`&${componentCls}-sm`]: {
                [varName('multi-item-height')]: token.multipleItemHeightSM,
                [varName('multi-item-border-radius')]: token.borderRadiusXS
            },
            [`&${componentCls}-lg`]: {
                [varName('multi-item-height')]: token.multipleItemHeightLG,
                [varName('multi-item-border-radius')]: token.borderRadius
            },
            // ========================================================
            // ==                      Variants                      ==
            // ========================================================
            [`&${componentCls}-filled`]: {
                [varName('multi-item-border-color')]: token.colorSplit,
                [varName('multi-item-background')]: token.colorBgContainer,
                [`&${componentCls}-disabled`]: {
                    [varName('multi-item-border-color')]: 'transparent'
                }
            }
        }
    };
};
var $771e53cb30dfdcff$export$2e2bcd8739ae039 = $771e53cb30dfdcff$var$genSelectInputMultipleStyle;


/** Set CSS variables and hover/focus styles for a Select input based on provided colors. */ const $368a155fccc8de54$var$genSelectInputVariableStyle = (token, colors)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'select');
    const { border: border, borderHover: borderHover, borderActive: borderActive, borderOutline: borderOutline } = colors;
    const baseBG = colors.background || token.selectorBg || token.colorBgContainer;
    return {
        [varName('border-color')]: border,
        [varName('background-color')]: baseBG,
        [varName('color')]: colors.color || token.colorText,
        [`&:not(${componentCls}-disabled)`]: {
            '&:hover': {
                [varName('border-color')]: borderHover,
                [varName('background-color')]: colors.backgroundHover || baseBG
            },
            [`&${componentCls}-focused`]: {
                [varName('border-color')]: borderActive,
                [varName('background-color')]: colors.backgroundActive || baseBG,
                boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} ${borderOutline}`
            }
        },
        [`&${componentCls}-disabled`]: {
            [varName('border-color')]: colors.borderDisabled || colors.border,
            [varName('background-color')]: colors.backgroundDisabled || colors.background
        }
    };
};
/** Generate variant-scoped variable styles and status overrides for a Select input. */ const $368a155fccc8de54$var$genSelectInputVariantStyle = (token, variant, colors, errorColors = {}, warningColors = {}, patchStyle)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-${variant}`]: [
            $368a155fccc8de54$var$genSelectInputVariableStyle(token, colors),
            {
                [`&${componentCls}-status-error`]: $368a155fccc8de54$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    color: errorColors.color || token.colorError,
                    ...errorColors
                }),
                [`&${componentCls}-status-warning`]: $368a155fccc8de54$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    color: warningColors.color || token.colorWarning,
                    ...warningColors
                })
            },
            patchStyle
        ]
    };
};
const $368a155fccc8de54$var$genSelectInputStyle = (token)=>{
    const { componentCls: componentCls, fontHeight: fontHeight, controlHeight: controlHeight, iconCls: iconCls, antCls: antCls, calc: calc } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'select');
    return {
        [componentCls]: [
            {
                // Border
                [varName('border-radius')]: token.borderRadius,
                [varName('border-color')]: '#000',
                [varName('border-size')]: token.lineWidth,
                // Background
                [varName('background-color')]: token.colorBgContainer,
                // Font
                [varName('font-size')]: token.fontSize,
                [varName('line-height')]: token.lineHeight,
                [varName('font-height')]: fontHeight,
                [varName('color')]: token.colorText,
                // Size
                [varName('height')]: controlHeight,
                [varName('padding-horizontal')]: calc(token.paddingSM).sub(token.lineWidth).equal(),
                [varName('padding-vertical')]: `calc((${varRef('height')} - ${varRef('font-height')}) / 2 - ${varRef('border-size')})`,
                // ==========================================================
                // ==                         Base                         ==
                // ==========================================================
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token, true),
                display: 'inline-flex',
                // gap: calc(token.paddingXXS).mul(1.5).equal(),
                flexWrap: 'nowrap',
                position: 'relative',
                transition: `all ${token.motionDurationSlow}`,
                alignItems: 'flex-start',
                outline: 0,
                cursor: 'pointer',
                // Border
                borderRadius: varRef('border-radius'),
                borderWidth: varRef('border-size'),
                borderStyle: token.lineType,
                borderColor: varRef('border-color'),
                // Background
                background: varRef('background-color'),
                // Font
                fontSize: varRef('font-size'),
                lineHeight: varRef('line-height'),
                color: varRef('color'),
                // Padding
                paddingInline: varRef('padding-horizontal'),
                paddingBlock: varRef('padding-vertical'),
                // ========================= Prefix =========================
                [`${componentCls}-prefix`]: {
                    flex: 'none',
                    lineHeight: 1
                },
                // ====================== Placeholder =======================
                [`${componentCls}-placeholder`]: {
                    ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                    color: token.colorTextPlaceholder,
                    pointerEvents: 'none',
                    zIndex: 1
                },
                // ======================== Content =========================
                [`${componentCls}-content`]: {
                    flex: 'auto',
                    minWidth: 0,
                    position: 'relative',
                    display: 'flex',
                    marginInlineEnd: calc(token.paddingXXS).mul(1.5).equal(),
                    '&:before': {
                        content: '"\\a0"',
                        width: 0,
                        overflow: 'hidden'
                    },
                    // >>> Value
                    '&-value': {
                        visibility: 'inherit'
                    },
                    // >>> Input: should only take effect for not customize mode
                    // input element with readOnly use cursor pointer
                    'input[readonly]': {
                        cursor: 'inherit',
                        caretColor: 'transparent'
                    }
                },
                // ========================= Suffix =========================
                [`${componentCls}-suffix`]: {
                    flex: 'none',
                    color: token.colorTextQuaternary,
                    fontSize: token.fontSizeIcon,
                    lineHeight: 1,
                    '> :not(:last-child)': {
                        marginInlineEnd: token.marginXS
                    }
                },
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    alignSelf: 'center',
                    [iconCls]: {
                        verticalAlign: 'top'
                    }
                },
                // ==========================================================
                // ==                       Disabled                       ==
                // ==========================================================
                '&-disabled': {
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed',
                    input: {
                        cursor: 'not-allowed'
                    }
                },
                // ==========================================================
                // ==                         Size                         ==
                // ==========================================================
                '&-sm': {
                    [varName('height')]: token.controlHeightSM,
                    [varName('padding-horizontal')]: calc(token.paddingXS).sub(token.lineWidth).equal(),
                    [varName('border-radius')]: token.borderRadiusSM,
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: varRef('padding-horizontal')
                    }
                },
                '&-lg': {
                    [varName('height')]: token.controlHeightLG,
                    [varName('font-size')]: token.fontSizeLG,
                    [varName('line-height')]: token.lineHeightLG,
                    [varName('font-height')]: token.fontHeightLG,
                    [varName('border-radius')]: token.borderRadiusLG
                }
            },
            // ============================================================
            // ==                         Input                          ==
            // ============================================================
            {
                [`&:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        outline: 'none',
                        background: 'transparent',
                        appearance: 'none',
                        border: 0,
                        margin: 0,
                        padding: 0,
                        color: varRef('color'),
                        '&::-webkit-search-cancel-button': {
                            display: 'none',
                            appearance: 'none'
                        }
                    }
                }
            },
            // ============================================================
            // ==                         Single                         ==
            // ============================================================
            {
                [`&-single:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        position: 'absolute',
                        inset: 0,
                        lineHeight: `calc(${varRef('font-height')} + ${varRef('padding-vertical')} * 2)`
                    },
                    // Content center align
                    [`${componentCls}-content`]: {
                        ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                        alignSelf: 'center',
                        '&-has-value': {
                            display: 'block',
                            '&:before': {
                                display: 'none'
                            }
                        },
                        '&-has-search-value': {
                            color: 'transparent'
                        },
                        // >>> Value
                        '&-value': {
                            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
                            zIndex: 1
                        }
                    },
                    [`&${componentCls}-open ${componentCls}-content`]: {
                        color: token.colorTextPlaceholder,
                        '&-has-search-value': {
                            color: 'transparent'
                        }
                    }
                }
            },
            // ======================== Show Search =======================
            {
                [`&-show-search:not(${componentCls}-customize-input):not(${componentCls}-disabled)`]: {
                    cursor: 'text'
                }
            },
            // ============================================================
            // ==                        Multiple                        ==
            // ============================================================
            (0, $771e53cb30dfdcff$export$2e2bcd8739ae039)(token),
            // ========================= Variant ==========================
            // >>> Outlined
            $368a155fccc8de54$var$genSelectInputVariantStyle(token, 'outlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: token.activeOutlineColor,
                borderDisabled: token.colorBorderDisabled
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorHover,
                borderActive: token.colorError,
                borderOutline: token.colorErrorOutline
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning,
                borderOutline: token.colorWarningOutline
            }),
            // >>> Filled
            $368a155fccc8de54$var$genSelectInputVariantStyle(token, 'filled', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent',
                borderDisabled: token.colorBorderDisabled,
                background: token.colorFillTertiary,
                backgroundHover: token.colorFillSecondary,
                backgroundActive: token.colorBgContainer
            }, // Error
            {
                background: token.colorErrorBg,
                backgroundHover: token.colorErrorBgHover,
                borderActive: token.colorError
            }, // Warning
            {
                background: token.colorWarningBg,
                backgroundHover: token.colorWarningBgHover,
                borderActive: token.colorWarning
            }),
            // >>> Borderless
            $368a155fccc8de54$var$genSelectInputVariantStyle(token, 'borderless', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: 'transparent',
                borderOutline: 'transparent',
                background: 'transparent'
            }),
            // Underlined
            $368a155fccc8de54$var$genSelectInputVariantStyle(token, 'underlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent'
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorHover,
                borderActive: token.colorError
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning
            }, {
                borderRadius: 0,
                borderTopColor: 'transparent',
                borderInlineColor: 'transparent'
            }),
            // ============================================================
            // ==                         Custom                         ==
            // ============================================================
            (0, $4279178fb040dcb3$export$2e2bcd8739ae039)(token)
        ]
    };
};
var $368a155fccc8de54$export$2e2bcd8739ae039 = $368a155fccc8de54$var$genSelectInputStyle;


const $59698eaa3035fee4$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    return {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent',
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
};


// =============================== Base ===============================
const $62a9ef7c3b113a0f$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, motionDurationMid: motionDurationMid, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    const hoverShowClearStyle = {
        [`${componentCls}-clear`]: {
            opacity: 1,
            background: token.colorBgBase,
            borderRadius: '50%'
        }
    };
    return {
        [componentCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: {
                flex: 1,
                fontWeight: 'normal',
                position: 'relative',
                userSelect: 'none',
                ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: 'inline'
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: 'none',
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: 'inline-block',
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                cursor: 'pointer',
                opacity: 0,
                transition: [
                    'color',
                    'opacity'
                ].map((prop)=>`${prop} ${motionDurationMid} ease`).join(', '),
                textRendering: 'auto',
                // https://github.com/ant-design/ant-design/issues/54205
                // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
                transform: 'translateZ(0)',
                '&:before': {
                    display: 'block'
                },
                '&:hover': {
                    color: token.colorIcon
                }
            },
            '@media(hover:none)': hoverShowClearStyle,
            '&:hover': hoverShowClearStyle
        },
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            '&-error, &-warning, &-success, &-validating': {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $62a9ef7c3b113a0f$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: '100%'
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $62a9ef7c3b113a0f$var$genBaseStyle(token),
        // Dropdown
        (0, $879d950d114a8bdf$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(token, {
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$62a9ef7c3b113a0f$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Select', (token, { rootPrefixCls: rootPrefixCls })=>{
    const selectToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(token.lineWidth).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $62a9ef7c3b113a0f$var$genSelectStyle(selectToken),
        (0, $368a155fccc8de54$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $59698eaa3035fee4$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $94b215ba0d5fdf99$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $94b215ba0d5fdf99$export$2e2bcd8739ae039 = $94b215ba0d5fdf99$var$CheckOutlined;



function $731042e70a6ddd3b$var$_extends() {
    $731042e70a6ddd3b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $731042e70a6ddd3b$var$_extends.apply(this, arguments);
}
const $731042e70a6ddd3b$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $731042e70a6ddd3b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $94b215ba0d5fdf99$export$2e2bcd8739ae039)
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $731042e70a6ddd3b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($731042e70a6ddd3b$var$CheckOutlined);
var $731042e70a6ddd3b$export$2e2bcd8739ae039 = $731042e70a6ddd3b$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $91321edc6c28da63$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $91321edc6c28da63$export$2e2bcd8739ae039 = $91321edc6c28da63$var$CloseOutlined;



function $06f117eb9481f34c$var$_extends() {
    $06f117eb9481f34c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $06f117eb9481f34c$var$_extends.apply(this, arguments);
}
const $06f117eb9481f34c$var$CloseOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $06f117eb9481f34c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $91321edc6c28da63$export$2e2bcd8739ae039)
    }));
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ const $06f117eb9481f34c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($06f117eb9481f34c$var$CloseOutlined);
var $06f117eb9481f34c$export$2e2bcd8739ae039 = $06f117eb9481f34c$var$RefIcon;






"use client";
function $f15feb4dca87ef73$export$2e2bcd8739ae039({ suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, loadingIcon: loadingIcon, multiple: multiple, hasFeedback: hasFeedback, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName }) {
    // Clear Icon
    const mergedClearIcon = clearIcon ?? /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(loadingIcon ?? /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        spin: true
    }));
    else mergedSuffixIcon = ({ open: open, showSearch: showSearch })=>{
        if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), null));
        return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), null));
    };
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null);
    return {
        // TODO: remove as when all the deps bumped
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
function $672a67bc6f7cf09e$var$usePopupRender(renderFn) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!renderFn) return undefined;
        return (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
                space: true
            }, renderFn.apply(void 0, args));
    }, [
        renderFn
    ]);
}
var $672a67bc6f7cf09e$export$2e2bcd8739ae039 = $672a67bc6f7cf09e$var$usePopupRender;


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $ce5709ba38c89ca7$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
const $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const $1b56c179e5783cdb$var$InternalSelect = (props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, popupStyle: popupStyle, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix, dropdownRender: dropdownRender, popupRender: /**
     * @since 5.25.0
     */ popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames, ...rest } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { showSearch: showSearch, style: contextStyle, styles: contextStyles, className: contextClassName, classNames: contextClassNames } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('select');
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight ?? token?.controlHeight;
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection ?? contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)('select', customizeVariant, bordered);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $62a9ef7c3b113a0f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $acw62.useMemo(()=>{
        const { mode: m } = props;
        if (m === 'combobox') return undefined;
        if (m === $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    const showSuffixIcon = (0, $ce5709ba38c89ca7$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = popupMatchSelectWidth ?? dropdownMatchSelectWidth ?? contextPopupMatchSelectWidth;
    const mergedPopupRender = (0, $672a67bc6f7cf09e$export$2e2bcd8739ae039)(popupRender || dropdownRender);
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = renderEmpty?.('Select') || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $f15feb4dca87ef73$export$2e2bcd8739ae039)({
        ...rest,
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: 'Select'
    });
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(rest, [
        'suffixIcon',
        'itemIcon'
    ]);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ========== Merged Props for Semantic ==================
    const mergedProps = {
        ...props,
        variant: variant,
        status: mergedStatus,
        disabled: mergedDisabled,
        size: mergedSize
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    const mergedPopupClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.popup?.root, popupClassName, dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedPopupStyle = {
        ...mergedStyles.popup?.root,
        ...popupStyle ?? dropdownStyle
    };
    const mergedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $acw62.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }, [
        placement,
        direction
    ]);
    var oldProp, newProp;
    // ====================== zIndex =========================
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('SelectLike', mergedStyles.popup?.root?.zIndex ?? mergedPopupStyle?.zIndex);
    // ====================== Render =======================
    return /*#__PURE__*/ $acw62.createElement((0, $a386b5f49df0483a$export$2e2bcd8739ae039), {
        ref: ref,
        virtual: virtual,
        classNames: mergedClassNames,
        styles: mergedStyles,
        showSearch: showSearch,
        ...selectProps,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        popupMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'slide-up', transitionName),
        builtinPlacements: (0, $5b1ac51a636fb330$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        popupClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        popupStyle: {
            ...mergedStyles.popup?.root,
            ...mergedPopupStyle,
            zIndex: zIndex
        },
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange
    });
};
const $1b56c179e5783cdb$var$Select = /*#__PURE__*/ $acw62.forwardRef($1b56c179e5783cdb$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $1b56c179e5783cdb$var$PurePanel = (0, $91653a8941ab7768$export$2e2bcd8739ae039)($1b56c179e5783cdb$var$Select, 'popupAlign');
$1b56c179e5783cdb$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$1b56c179e5783cdb$var$Select.Option = (0, $6558dfad94c21b23$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select.OptGroup = (0, $35a36108daccfa96$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $1b56c179e5783cdb$var$PurePanel;
var $1b56c179e5783cdb$export$2e2bcd8739ae039 = $1b56c179e5783cdb$var$Select;









const $98f050512cca42a2$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            '&, &:hover': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            '&:focus-visible': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: 'not-allowed',
            [`${componentCls}-item`]: {
                cursor: 'not-allowed',
                backgroundColor: 'transparent',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'not-allowed'
                },
                '&-active': {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    '&:hover, &:active': {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: 'transparent',
                    '&:hover, &:active': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationSmallStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-small ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            '&-quick-jumper': {
                input: {
                    ...(0, $232788b5c0fca573$export$bb047f62c5a56f90)(token),
                    width: token.paginationMiniQuickJumperInputWidth
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationLargeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-large ${componentCls}-options`]: {
            '&-quick-jumper': {
                input: {
                    ...(0, $232788b5c0fca573$export$88e04420bb2dc003)(token)
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                height: varRef(`item-size-actual`),
                lineHeight: varRef(`item-size-actual`),
                verticalAlign: 'top',
                [`${componentCls}-item-link`]: {
                    height: varRef(`item-size-actual`),
                    backgroundColor: 'transparent',
                    border: 0,
                    '&:hover': {
                        backgroundColor: token.colorBgTextHover
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    '&::after': {
                        height: varRef(`item-size-actual`),
                        lineHeight: varRef(`item-size-actual`)
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                display: 'inline-flex',
                alignItems: 'center',
                height: varRef(`item-size-actual`),
                marginInlineEnd: varRef(`item-spacing-actual`),
                input: {
                    boxSizing: 'border-box',
                    height: '100%',
                    width: token.quickJumperInputWidth,
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                    textAlign: 'center',
                    backgroundColor: token.itemInputBg,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadius,
                    outline: 'none',
                    transition: `border-color ${token.motionDurationMid}`,
                    color: 'inherit',
                    '&:hover': {
                        borderColor: token.colorPrimary
                    },
                    '&:focus': {
                        borderColor: token.colorPrimaryHover,
                        boxShadow: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.inputOutlineOffset)} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
                    },
                    '&[disabled]': {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled,
                        borderColor: token.colorBorder,
                        cursor: 'not-allowed'
                    }
                }
            },
            [`&${componentCls}-disabled`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    [`${componentCls}-item-link`]: {
                        '&:hover, &:active': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            [`&${componentCls}-small`]: {
                [`${componentCls}-simple-pager`]: {
                    input: {
                        width: token.paginationMiniQuickJumperInputWidth
                    }
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: 'relative',
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    '&-svg': {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: 'auto'
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    display: 'block',
                    margin: 'auto',
                    color: token.colorTextDisabled,
                    letterSpacing: token.paginationEllipsisLetterSpacing,
                    textAlign: 'center',
                    textIndent: token.paginationEllipsisTextIndent,
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`
                }
            },
            '&:hover': {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: varRef(`item-spacing-actual`)
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: 'inline-block',
            minWidth: varRef(`item-size-actual`),
            height: varRef(`item-size-actual`),
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: varRef(`item-size-actual`),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            borderRadius: token.borderRadius,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            outline: 0,
            button: {
                color: token.colorText,
                cursor: 'pointer',
                userSelect: 'none'
            },
            [`${componentCls}-item-link`]: {
                display: 'block',
                width: '100%',
                height: '100%',
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: 'center',
                backgroundColor: 'transparent',
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: 'none',
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: 'inline-block',
            marginInlineStart: token.margin,
            verticalAlign: 'middle',
            '&-size-changer': {
                width: 'auto'
            },
            '&-quick-jumper': {
                display: 'inline-block',
                height: varRef(`item-size-actual`),
                marginInlineStart: token.marginXS,
                lineHeight: varRef(`item-size-actual`),
                verticalAlign: 'baseline',
                input: {
                    ...(0, $232788b5c0fca573$export$8c9a381315f3ebcd)(token),
                    ...(0, $26df503c9b7ea2eb$export$8c569e4cc3fd115f)(token, {
                        borderColor: token.colorBorder,
                        hoverBorderColor: token.colorPrimaryHover,
                        activeBorderColor: token.colorPrimary,
                        activeShadow: token.activeShadow
                    }),
                    '&[disabled]': {
                        ...(0, $26df503c9b7ea2eb$export$12789f962d420a93)(token)
                    },
                    width: token.quickJumperInputWidth,
                    height: varRef(`item-size-actual`),
                    boxSizing: 'border-box',
                    margin: 0,
                    marginInlineStart: varRef(`item-spacing-actual`),
                    marginInlineEnd: varRef(`item-spacing-actual`)
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [`${componentCls}-item`]: {
            display: 'inline-block',
            minWidth: varRef(`item-size-actual`),
            height: varRef(`item-size-actual`),
            marginInlineEnd: varRef(`item-spacing-actual`),
            fontFamily: token.fontFamily,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(varRef('item-size-actual')).sub(2).equal()),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            backgroundColor: token.itemBg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: 'pointer',
            userSelect: 'none',
            a: {
                display: 'block',
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                '&:hover': {
                    textDecoration: 'none'
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                '&:hover': {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                '&:active': {
                    backgroundColor: token.colorBgTextActive
                }
            },
            '&-active': {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.itemActiveColor
                },
                '&:hover': {
                    borderColor: token.colorPrimaryHover
                },
                '&:hover a': {
                    color: token.itemActiveColorHover
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [componentCls]: {
            [varName(`item-size-actual`)]: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSize),
            [varName(`item-spacing-actual`)]: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXS),
            '&-small': {
                [varName(`item-size-actual`)]: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM),
                [varName(`item-spacing-actual`)]: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXXS)
            },
            '&-large': {
                [varName(`item-size-actual`)]: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeLG),
                [varName(`item-spacing-actual`)]: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginSM)
            },
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            display: 'flex',
            alignItems: 'center',
            '&-start': {
                justifyContent: 'start'
            },
            '&-center': {
                justifyContent: 'center'
            },
            '&-end': {
                justifyContent: 'end'
            },
            'ul, ol': {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                overflow: 'hidden',
                visibility: 'hidden',
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: 'inline-block',
                height: varRef(`item-size-actual`),
                marginInlineEnd: varRef(`item-spacing-actual`),
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(varRef(`item-size-actual`)).sub(2).equal()),
                verticalAlign: 'middle'
            },
            // item style
            ...$98f050512cca42a2$var$genPaginationItemStyle(token),
            // jump btn style
            ...$98f050512cca42a2$var$genPaginationJumpStyle(token),
            // simple style
            ...$98f050512cca42a2$var$genPaginationSimpleStyle(token),
            // size style
            ...$98f050512cca42a2$var$genPaginationSmallStyle(token),
            ...$98f050512cca42a2$var$genPaginationLargeStyle(token),
            // disabled style
            ...$98f050512cca42a2$var$genPaginationDisabledStyle(token),
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    '&-after-jump-prev, &-before-jump-next': {
                        display: 'none'
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: 'none'
                }
            }
        },
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
const $98f050512cca42a2$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: {
                ...(0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                '&:focus-visible': {
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    },
                    ...(0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)
            }
        }
    };
};
const $98f050512cca42a2$export$9ca1be8807fe0675 = (token)=>({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemSizeLG: token.controlHeightLG,
        itemActiveBg: token.colorBgContainer,
        itemActiveColor: token.colorPrimary,
        itemActiveColorHover: token.colorPrimaryHover,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0,
        ...(0, $500d0ae39d0ead62$export$bd8b682992bc9781)(token)
    });
const $98f050512cca42a2$export$362fb92a8f81bbf9 = (token)=>(0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        quickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.25).equal(),
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: '0.13em' // magic for ui experience
    }, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$98f050512cca42a2$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Pagination', (token)=>{
    const paginationToken = $98f050512cca42a2$export$362fb92a8f81bbf9(token);
    return [
        $98f050512cca42a2$var$genPaginationStyle(paginationToken),
        $98f050512cca42a2$var$genPaginationFocusStyle(paginationToken)
    ];
}, $98f050512cca42a2$export$9ca1be8807fe0675);





const $56652cfef6436cfa$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled`]: {
            '&, &:hover': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            '&:focus-visible': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                '&-active': {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $56652cfef6436cfa$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Pagination',
    'bordered'
], (token)=>{
    const paginationToken = (0, $98f050512cca42a2$export$362fb92a8f81bbf9)(token);
    return $56652cfef6436cfa$var$genBorderedStyle(paginationToken);
}, (0, $98f050512cca42a2$export$9ca1be8807fe0675));



var $acw62 = parcelRequire("acw62");

function $fe3d2f47cbb5df75$export$2e2bcd8739ae039(showSizeChanger) {
    return (0, $acw62.useMemo)(()=>{
        if (typeof showSizeChanger === 'boolean') return [
            showSizeChanger,
            {}
        ];
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(showSizeChanger)) return [
            true,
            showSizeChanger
        ];
        return [
            undefined,
            undefined
        ];
    }, [
        showSizeChanger
    ]);
}


"use client";
const $41bb1cf6e4b63275$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, responsive: responsive, showSizeChanger: showSizeChanger, selectComponentClass: selectComponentClass, pageSizeOptions: pageSizeOptions, styles: styles, classNames: classNames, ...restProps } = props;
    const { xs: xs } = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, showSizeChanger: contextShowSizeChangerConfig, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, totalBoundaryShowSizeChanger: contextTotalBoundaryShowSizeChanger } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('pagination');
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $98f050512cca42a2$export$2e2bcd8739ae039)(prefixCls);
    // ============================== Size ==============================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === 'small' || !!(xs && !mergedSize && responsive);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ============================= Locale =============================
    const [contextLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Pagination', (0, $0890f9c201430fe8$export$2e2bcd8739ae039));
    const locale = {
        ...contextLocale,
        ...customLocale
    };
    // ========================== Size Changer ==========================
    // Merge the props showSizeChanger
    const [propShowSizeChanger, propSizeChangerSelectProps] = (0, $fe3d2f47cbb5df75$export$2e2bcd8739ae039)(showSizeChanger);
    const [contextShowSizeChanger, contextSizeChangerSelectProps] = (0, $fe3d2f47cbb5df75$export$2e2bcd8739ae039)(contextShowSizeChangerConfig);
    const mergedShowSizeChanger = propShowSizeChanger ?? contextShowSizeChanger;
    const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps ?? contextSizeChangerSelectProps;
    const SizeChanger = selectComponentClass || (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
    // Generate options
    const mergedPageSizeOptions = $acw62.useMemo(()=>{
        return pageSizeOptions ? pageSizeOptions.map(Number) : undefined;
    }, [
        pageSizeOptions
    ]);
    // Render size changer
    const sizeChangerRender = (info)=>{
        const { disabled: disabled, size: pageSize, onSizeChange: onSizeChange, 'aria-label': ariaLabel, className: sizeChangerClassName, options: options } = info;
        const { className: propSizeChangerClassName, onChange: propSizeChangerOnChange } = mergedShowSizeChangerSelectProps || {};
        // Origin Select is using Select.Option,
        // So it make the option value must be string
        // Just for compatible
        const selectedValue = options.find((option)=>String(option.value) === String(pageSize))?.value;
        return /*#__PURE__*/ $acw62.createElement(SizeChanger, {
            disabled: disabled,
            showSearch: true,
            popupMatchSelectWidth: false,
            getPopupContainer: (triggerNode)=>triggerNode.parentNode,
            "aria-label": ariaLabel,
            options: options,
            ...mergedShowSizeChangerSelectProps,
            value: selectedValue,
            onChange: (nextSize, option)=>{
                onSizeChange?.(nextSize);
                propSizeChangerOnChange?.(nextSize, option);
            },
            size: mergedSize,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(sizeChangerClassName, propSizeChangerClassName)
        });
    };
    // ============================= Render =============================
    const iconsProps = $acw62.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, "\u2022\u2022\u2022");
        const prevIcon = /*#__PURE__*/ $acw62.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $acw62.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ $acw62.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $acw62.createElement((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $acw62.createElement((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ $acw62.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $acw62.createElement((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $acw62.createElement((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    const extendedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        /** @deprecated Should be removed in v7 */ [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-bordered`]: token.wireframe
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, token.wireframe && /*#__PURE__*/ $acw62.createElement((0, $56652cfef6436cfa$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $acw62.createElement((0, $c2bd458455237c3e$export$2e2bcd8739ae039), {
        ...iconsProps,
        ...restProps,
        styles: mergedStyles,
        classNames: mergedClassNames,
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        locale: locale,
        pageSizeOptions: mergedPageSizeOptions,
        showSizeChanger: mergedShowSizeChanger,
        totalBoundaryShowSizeChanger: restProps.totalBoundaryShowSizeChanger ?? contextTotalBoundaryShowSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $41bb1cf6e4b63275$export$2e2bcd8739ae039 = $41bb1cf6e4b63275$var$Pagination;


"use client";
var $457c0f7bc166788c$export$2e2bcd8739ae039 = (0, $41bb1cf6e4b63275$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


"use client";
const $242a363dabc3566f$var$viewSize = 100;
const $242a363dabc3566f$var$borderWidth = $242a363dabc3566f$var$viewSize / 5;
const $242a363dabc3566f$var$radius = $242a363dabc3566f$var$viewSize / 2 - $242a363dabc3566f$var$borderWidth / 2;
const $242a363dabc3566f$var$circumference = $242a363dabc3566f$var$radius * 2 * Math.PI;
const $242a363dabc3566f$var$position = 50;
const $242a363dabc3566f$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $acw62.createElement("circle", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $242a363dabc3566f$var$radius,
        cx: $242a363dabc3566f$var$position,
        cy: $242a363dabc3566f$var$position,
        strokeWidth: $242a363dabc3566f$var$borderWidth,
        style: style
    });
};
const $242a363dabc3566f$var$Progress = ({ percent: percent, prefixCls: prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $acw62.useState(false);
    // ==================== Visible =====================
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$242a363dabc3566f$var$circumference / 4}`,
        strokeDasharray: `${$242a363dabc3566f$var$circumference * safePtg / 100} ${$242a363dabc3566f$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(holderClassName, `${dotClassName}-progress`, {
            [hideClassName]: safePtg <= 0
        })
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        viewBox: `0 0 ${$242a363dabc3566f$var$viewSize} ${$242a363dabc3566f$var$viewSize}`,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $acw62.createElement($242a363dabc3566f$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $acw62.createElement($242a363dabc3566f$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $242a363dabc3566f$export$2e2bcd8739ae039 = $242a363dabc3566f$var$Progress;


"use client";
function $827038dbb6bd8311$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(holderClassName, className, percent > 0 && hideClassName),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $acw62.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $acw62.createElement((0, $242a363dabc3566f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $f531c664e0f3d7ea$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $acw62.isValidElement(indicator)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(indicator, (currentProps)=>({
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(currentProps.className, dotClassName, className),
            style: {
                ...currentProps.style,
                ...style
            },
            percent: percent
        }));
    return /*#__PURE__*/ $acw62.createElement((0, $827038dbb6bd8311$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent,
        className: className,
        style: style
    });
}






const $f4e8aa06f042a155$var$antSpinMove = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const $f4e8aa06f042a155$var$antRotate = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
// =============================== Spin ===============================
const $f4e8aa06f042a155$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const sectionCls = `${componentCls}-section`;
    return {
        [componentCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            position: 'relative',
            '&-rtl': {
                direction: 'rtl'
            },
            // ========================== Section ===========================
            [`&${sectionCls}, ${sectionCls}`]: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: token.paddingSM,
                color: token.colorPrimary
            },
            [`&${sectionCls}`]: {
                display: 'inline-flex'
            },
            [sectionCls]: {
                position: 'absolute',
                top: '50%',
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translate(-50%, -50%)',
                zIndex: 1
            },
            [`${componentCls}-description`]: {
                fontSize: token.fontSize,
                lineHeight: 1
            },
            // ========================= Container ==========================
            [`${componentCls}-container`]: {
                position: 'relative',
                transition: `opacity ${token.motionDurationSlow}`,
                '&::after': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: '100%',
                    height: '100%',
                    background: token.colorBgContainer,
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    content: '""',
                    pointerEvents: 'none'
                }
            },
            // ========================== Spinning ==========================
            '&-spinning': {
                [`${componentCls}-description`]: {
                    textShadow: `0 0px 5px ${token.colorBgContainer}`
                },
                [`${componentCls}-container`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // ========================= Fullscreen =========================
            '&-fullscreen': {
                position: 'fixed',
                inset: 0,
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                opacity: 0,
                pointerEvents: 'none',
                transition: `all ${token.motionDurationMid}`,
                [`&${componentCls}-spinning`]: {
                    opacity: 1,
                    pointerEvents: 'auto'
                },
                [sectionCls]: {
                    color: token.colorWhite,
                    [`${componentCls}-description`]: {
                        color: token.colorTextLightSolid
                    }
                }
            }
        }
    };
};
// ============================ Indicator =============================
const $f4e8aa06f042a155$var$genIndicatorStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow } = token;
    const [varName, varRef] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(antCls, 'spin');
    return {
        [componentCls]: {
            [varName('dot-holder-size')]: token.dotSize,
            [varName('dot-item-size')]: `calc((${varRef('dot-holder-size')} - ${token.marginXXS} / 2) / 2)`,
            [`${componentCls}-dot`]: {
                // >>> holder
                '&-holder': {
                    width: '1em',
                    height: '1em',
                    fontSize: varRef('dot-holder-size'),
                    display: 'inline-block',
                    transition: [
                        'transform',
                        'opacity'
                    ].map((prop)=>`${prop} ${motionDurationSlow} ease`).join(', '),
                    transformOrigin: '50% 50%',
                    lineHeight: 1,
                    '&-hidden': {
                        transform: 'scale(0.3)',
                        opacity: 0
                    }
                },
                // >>> holder > dot
                position: 'relative',
                display: 'inline-block',
                fontSize: varRef('dot-holder-size'),
                width: '1em',
                height: '1em',
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: $f4e8aa06f042a155$var$antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                // >>> holder > dot > item
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: varRef('dot-item-size'),
                    height: varRef('dot-item-size'),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: $f4e8aa06f042a155$var$antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                // ========================= Progress =========================
                '&-progress': {
                    position: 'absolute',
                    left: '50%',
                    top: 0,
                    transform: 'translateX(-50%)'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            }
        }
    };
};
// =============================== Size ===============================
const $f4e8aa06f042a155$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [varName] = (0, $0f84270bd7498f9c$export$d82b8f66c5649e14)(token.antCls, 'spin');
    return {
        [componentCls]: {
            '&-sm': {
                [varName('dot-holder-size')]: token.dotSizeSM
            },
            '&-lg': {
                [varName('dot-holder-size')]: token.dotSizeLG
            }
        }
    };
};
const $f4e8aa06f042a155$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$f4e8aa06f042a155$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Spin', (token)=>{
    const spinToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $f4e8aa06f042a155$var$genSpinStyle(spinToken),
        $f4e8aa06f042a155$var$genIndicatorStyle(spinToken),
        $f4e8aa06f042a155$var$genSizeStyle(spinToken)
    ];
}, $f4e8aa06f042a155$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");
const $4374779c501b3dd4$var$AUTO_INTERVAL = 200;
const $4374779c501b3dd4$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $4374779c501b3dd4$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $acw62.useState(0);
    const mockIntervalRef = $acw62.useRef(null);
    const isAuto = percent === 'auto';
    $acw62.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $4374779c501b3dd4$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $4374779c501b3dd4$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $4374779c501b3dd4$var$AUTO_INTERVAL);
        }
        return ()=>{
            if (mockIntervalRef.current) {
                clearInterval(mockIntervalRef.current);
                mockIntervalRef.current = null;
            }
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
// Render indicator
let $26f1cf19d4dd7058$var$defaultIndicator;
function $26f1cf19d4dd7058$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $26f1cf19d4dd7058$var$Spin = (props)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size, tip: tip, description: description, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, indicator: contextIndicator, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('spin');
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $f4e8aa06f042a155$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $acw62.useState(()=>customSpinning && !$26f1cf19d4dd7058$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $4374779c501b3dd4$export$2e2bcd8739ae039)(spinning, percent);
    $acw62.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                showSpinning?.cancel?.();
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    // ======================= Size ======================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    // ======================= Description ======================
    const mergedDescription = description ?? tip;
    // =============== Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        size: mergedSize,
        spinning: spinning,
        tip: mergedDescription,
        description: mergedDescription,
        fullscreen: fullscreen,
        children: children,
        percent: mergedPercent
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ======================= Indicator ========================
    const mergedIndicator = indicator ?? contextIndicator ?? $26f1cf19d4dd7058$var$defaultIndicator;
    // ========================= Render =========================
    const hasChildren = typeof children !== 'undefined';
    const isNested = hasChildren || fullscreen;
    const indicatorNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $f531c664e0f3d7ea$export$2e2bcd8739ae039), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.indicator),
        style: mergedStyles.indicator,
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), mergedDescription && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.tip, mergedClassNames.description),
        style: {
            ...mergedStyles.tip,
            ...mergedStyles.description
        }
    }, mergedDescription));
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-spinning`]: spinning,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-fullscreen`]: fullscreen
        }, rootClassName, mergedClassNames.root, fullscreen && mergedClassNames.mask, isNested ? wrapperClassName : [
            `${prefixCls}-section`,
            mergedClassNames.section
        ], contextClassName, className, hashId, cssVarCls),
        style: {
            ...mergedStyles.root,
            ...!isNested ? mergedStyles.section : {},
            ...fullscreen ? mergedStyles.mask : {},
            ...contextStyle,
            ...style
        },
        "aria-live": "polite",
        "aria-busy": spinning,
        ...restProps
    }, spinning && (isNested ? /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-section`, mergedClassNames.section),
        style: mergedStyles.section
    }, indicatorNode) : indicatorNode), hasChildren && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-container`, mergedClassNames.container),
        style: mergedStyles.container
    }, children));
};
$26f1cf19d4dd7058$var$Spin.setDefaultIndicator = (indicator)=>{
    $26f1cf19d4dd7058$var$defaultIndicator = indicator;
};
var $26f1cf19d4dd7058$export$2e2bcd8739ae039 = $26f1cf19d4dd7058$var$Spin;




var $acw62 = parcelRequire("acw62");

"use client";
function $8f25299cf0da5780$var$renderExpandIcon(locale) {
    return (props)=>{
        const { prefixCls: prefixCls, onExpand: onExpand, record: record, expanded: expanded, expandable: expandable } = props;
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            onClick: (e)=>{
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded
            }),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $8f25299cf0da5780$export$2e2bcd8739ae039 = $8f25299cf0da5780$var$renderExpandIcon;


function $2da82ee1b6da5550$export$2e2bcd8739ae039(prefixCls) {
    const getContainerWidth = (ele, width)=>{
        const container = ele.querySelector(`.${prefixCls}-container`);
        let returnWidth = width;
        if (container) {
            const style = getComputedStyle(container);
            const borderLeft = Number.parseInt(style.borderLeftWidth, 10);
            const borderRight = Number.parseInt(style.borderRightWidth, 10);
            returnWidth = width - borderLeft - borderRight;
        }
        return returnWidth;
    };
    return getContainerWidth;
}




var $acw62 = parcelRequire("acw62");


const $10b8a922ada6c9c1$export$480219a02f196e72 = (column, defaultKey)=>{
    if ('key' in column && (0, $b956dab96d0e505b$export$826fff653a329e83)(column.key)) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
};
function $10b8a922ada6c9c1$export$7e4db04adce9b4db(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
const $10b8a922ada6c9c1$export$cfda450db2088de7 = (title, props)=>{
    if (typeof title === 'function') return title(props);
    return title;
};
const $10b8a922ada6c9c1$export$1c24e0676a106839 = (title, props)=>{
    const res = $10b8a922ada6c9c1$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5dc9c75e7259b2a6$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $5dc9c75e7259b2a6$export$2e2bcd8739ae039 = $5dc9c75e7259b2a6$var$FilterFilled;



function $6d4c3c11d072512d$var$_extends() {
    $6d4c3c11d072512d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d4c3c11d072512d$var$_extends.apply(this, arguments);
}
const $6d4c3c11d072512d$var$FilterFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $6d4c3c11d072512d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $5dc9c75e7259b2a6$export$2e2bcd8739ae039)
    }));
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */ const $6d4c3c11d072512d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($6d4c3c11d072512d$var$FilterFilled);
var $6d4c3c11d072512d$export$2e2bcd8739ae039 = $6d4c3c11d072512d$var$RefIcon;




function $be673cd5391dca21$var$mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
var $be673cd5391dca21$export$2e2bcd8739ae039 = $be673cd5391dca21$var$mergeProps;



var $acw62 = parcelRequire("acw62");

const $1f7b7badb410ab86$export$bd58d1a153fd4998 = (initialValue)=>{
    const ref = $acw62.useRef(initialValue);
    const [, forceUpdate] = (0, $dcbb6d0bd42650d6$export$91db9bc4f8ac944a)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            forceUpdate();
        }
    ];
};
















var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $4f5b21e77d31bed2$var$DropIndicator = (props)=>{
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, indent: indent } = props;
    const style = {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: 'red',
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style
    });
};
var $4f5b21e77d31bed2$export$2e2bcd8739ae039 = $4f5b21e77d31bed2$var$DropIndicator;






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

/**
 * Trigger only when component unmount
 */ function $20dbaa59d9ab2479$var$useUnmount(triggerStart, triggerEnd) {
    const [firstMount, setFirstMount] = $acw62.useState(false);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (firstMount) {
            triggerStart();
            return ()=>{
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        setFirstMount(true);
        return ()=>{
            setFirstMount(false);
        };
    }, []);
}
var $20dbaa59d9ab2479$export$2e2bcd8739ae039 = $20dbaa59d9ab2479$var$useUnmount;



function $d913993ca95e1399$var$_extends() {
    $d913993ca95e1399$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d913993ca95e1399$var$_extends.apply(this, arguments);
}
const $d913993ca95e1399$var$MotionTreeNode = /*#__PURE__*/ $acw62.forwardRef((oriProps, ref)=>{
    const { className: className, style: style, motion: motion, motionNodes: motionNodes, motionType: motionType, onMotionStart: onOriginMotionStart, onMotionEnd: onOriginMotionEnd, active: active, treeNodeRequiredProps: treeNodeRequiredProps, ...props } = oriProps;
    const [visible, setVisible] = $acw62.useState(true);
    const { prefixCls: prefixCls } = $acw62.useContext((0, $ea57aee73349ae60$export$dfae7d399eea2568));
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    const targetVisible = motionNodes && motionType !== 'hide';
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    const triggerMotionStart = ()=>{
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    const triggerMotionEndRef = $acw62.useRef(false);
    const triggerMotionEnd = ()=>{
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $20dbaa59d9ab2479$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    const onVisibleChanged = (nextVisible)=>{
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $d913993ca95e1399$var$_extends({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === 'show',
        onVisibleChanged: onVisibleChanged
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-treenode-motion`, motionClassName),
            style: motionStyle
        }, motionNodes.map((treeNode)=>{
            const { data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
            delete restProps.children;
            const treeNodeProps = (0, $a4a4b11aebc073d4$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $acw62.createElement((0, $00996a3f5b641670$export$2e2bcd8739ae039), $d913993ca95e1399$var$_extends({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        })));
    return /*#__PURE__*/ $acw62.createElement((0, $00996a3f5b641670$export$2e2bcd8739ae039), $d913993ca95e1399$var$_extends({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
});
var $d913993ca95e1399$export$2e2bcd8739ae039 = $d913993ca95e1399$var$MotionTreeNode;


function $dec5218038afaa59$export$d561f9b5d6be9236(prev = [], next = []) {
    const prevLen = prev.length;
    const nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        const cache = new Map();
        shorter.forEach((key)=>{
            cache.set(key, true);
        });
        const keys = longer.filter((key)=>!cache.has(key));
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $dec5218038afaa59$export$d9cfb1169163442d(shorter, longer, key) {
    const shorterStartIndex = shorter.findIndex((data)=>data.key === key);
    const shorterEndNode = shorter[shorterStartIndex + 1];
    const longerStartIndex = longer.findIndex((data)=>data.key === key);
    if (shorterEndNode) {
        const longerEndIndex = longer.findIndex((data)=>data.key === shorterEndNode.key);
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



function $e8eed9e85de7446b$var$_extends() {
    $e8eed9e85de7446b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8eed9e85de7446b$var$_extends.apply(this, arguments);
}
const $e8eed9e85de7446b$export$17c02cdd52a7d889 = `RC_TREE_MOTION_${Math.random()}`;
const $e8eed9e85de7446b$var$MotionNode = {
    key: $e8eed9e85de7446b$export$17c02cdd52a7d889
};
const $e8eed9e85de7446b$export$2d18abad5109a402 = {
    key: $e8eed9e85de7446b$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: '0',
    node: $e8eed9e85de7446b$var$MotionNode,
    nodes: [
        $e8eed9e85de7446b$var$MotionNode
    ]
};
const $e8eed9e85de7446b$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $e8eed9e85de7446b$export$2d18abad5109a402.pos,
    data: $e8eed9e85de7446b$var$MotionNode,
    title: null,
    key: $e8eed9e85de7446b$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $e8eed9e85de7446b$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $e8eed9e85de7446b$var$itemKey(item) {
    const { key: key, pos: pos } = item;
    return (0, $a4a4b11aebc073d4$export$a47fb462a08de82f)(key, pos);
}
const $e8eed9e85de7446b$var$NodeList = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, data: data, selectable: selectable, checkable: checkable, expandedKeys: expandedKeys, selectedKeys: selectedKeys, checkedKeys: checkedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, halfCheckedKeys: halfCheckedKeys, keyEntities: keyEntities, disabled: disabled, dragging: dragging, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, motion: motion, height: height, itemHeight: itemHeight, virtual: virtual, scrollWidth: scrollWidth, focusable: focusable, activeItem: activeItem, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onActiveChange: onActiveChange, onListChangeStart: onListChangeStart, onListChangeEnd: onListChangeEnd, ...domProps } = props;
    const treeId = (0, $bba066f19964922a$export$2e2bcd8739ae039)();
    // =============================== Ref ================================
    const listRef = $acw62.useRef(null);
    const indentMeasurerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>({
            scrollTo: (scroll)=>{
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: ()=>indentMeasurerRef.current.offsetWidth
        }));
    // ============================== Motion ==============================
    const [prevExpandedKeys, setPrevExpandedKeys] = $acw62.useState(expandedKeys);
    const [prevData, setPrevData] = $acw62.useState(data);
    const [transitionData, setTransitionData] = $acw62.useState(data);
    const [transitionRange, setTransitionRange] = $acw62.useState([]);
    const [motionType, setMotionType] = $acw62.useState(null);
    // When motion end but data change, this will makes data back to previous one
    const dataRef = $acw62.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        const latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        setPrevExpandedKeys(expandedKeys);
        const diffExpanded = (0, $dec5218038afaa59$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                const keyIndex = prevData.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $e8eed9e85de7446b$export$435bacc8d7a01e14((0, $dec5218038afaa59$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $e8eed9e85de7446b$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('show');
            } else {
                const keyIndex = data.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $e8eed9e85de7446b$export$435bacc8d7a01e14((0, $dec5218038afaa59$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = data.slice();
                newTransitionData.splice(keyIndex + 1, 0, $e8eed9e85de7446b$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('hide');
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $acw62.useEffect(()=>{
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    const mergedData = motion ? transitionData : data;
    const treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-treenode`,
        "aria-hidden": true,
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            visibility: 'hidden',
            height: 0,
            overflow: 'hidden',
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-indent`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: indentMeasurerRef,
        className: `${prefixCls}-indent-unit`
    }))), /*#__PURE__*/ $acw62.createElement((0, $164934b9257bae32$export$2e2bcd8739ae039), $e8eed9e85de7446b$var$_extends({}, domProps, {
        data: mergedData,
        itemKey: $e8eed9e85de7446b$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        scrollWidth: scrollWidth,
        prefixCls: `${prefixCls}-list`,
        ref: listRef,
        role: "tree",
        tabIndex: focusable !== false && !disabled ? tabIndex : undefined,
        "aria-activedescendant": activeItem ? (0, $bba066f19964922a$export$218c8c3169c024d2)(treeId, activeItem.key) : undefined,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onVisibleChange: (originList)=>{
            // The best match is using `fullList` - `originList` = `restList`
            // and check the `restList` to see if has the MOTION_KEY node
            // but this will cause performance issue for long list compare
            // we just check `originList` and repeat trigger `onMotionEnd`
            if (originList.every((item)=>$e8eed9e85de7446b$var$itemKey(item) !== $e8eed9e85de7446b$export$17c02cdd52a7d889)) onMotionEnd();
        }
    }), (treeNode)=>{
        const { pos: pos, data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
        const mergedKey = (0, $a4a4b11aebc073d4$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        const treeNodeProps = (0, $a4a4b11aebc073d4$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $acw62.createElement((0, $d913993ca95e1399$export$2e2bcd8739ae039), $e8eed9e85de7446b$var$_extends({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $e8eed9e85de7446b$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            treeId: treeId,
            onMouseMove: ()=>{
                onActiveChange(null);
            }
        }));
    }));
});
var $e8eed9e85de7446b$export$2e2bcd8739ae039 = $e8eed9e85de7446b$var$NodeList;







function $d3ffd8d9829f3d0a$var$_extends() {
    $d3ffd8d9829f3d0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3ffd8d9829f3d0a$var$_extends.apply(this, arguments);
}
const $d3ffd8d9829f3d0a$var$MAX_RETRY_TIMES = 10;
class $d3ffd8d9829f3d0a$var$Tree extends $acw62.Component {
    static defaultProps = {
        prefixCls: 'rc-tree',
        showLine: false,
        showIcon: true,
        selectable: true,
        multiple: false,
        checkable: false,
        disabled: false,
        checkStrictly: false,
        draggable: false,
        defaultExpandParent: true,
        autoExpandParent: false,
        defaultExpandAll: false,
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        defaultSelectedKeys: [],
        dropIndicatorRender: (0, $4f5b21e77d31bed2$export$2e2bcd8739ae039),
        allowDrop: ()=>true,
        expandAction: false
    };
    static TreeNode = (0, $00996a3f5b641670$export$2e2bcd8739ae039);
    destroyed = false;
    delayedDragEnterLogic;
    loadingRetryTimes = {};
    state = {
        keyEntities: {},
        indent: null,
        selectedKeys: [],
        checkedKeys: [],
        halfCheckedKeys: [],
        loadedKeys: [],
        loadingKeys: [],
        expandedKeys: [],
        draggingNodeKey: null,
        dragChildrenKeys: [],
        // dropTargetKey is the key of abstract-drop-node
        // the abstract-drop-node is the real drop node when drag and drop
        // not the DOM drag over node
        dropTargetKey: null,
        dropPosition: null,
        // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
        dropContainerKey: null,
        // the container key of abstract-drop-node if dropPosition is -1 or 1
        dropLevelOffset: null,
        // the drop level offset of abstract-drag-over-node
        dropTargetPos: null,
        // the pos of abstract-drop-node
        dropAllowed: true,
        // if drop to abstract-drop-node is allowed
        // the abstract-drag-over-node
        // if mouse is on the bottom of top dom node or no the top of the bottom dom node
        // abstract-drag-over-node is the top node
        dragOverNodeKey: null,
        treeData: [],
        flattenNodes: [],
        activeKey: null,
        listChanging: false,
        prevProps: null,
        fieldNames: (0, $a4a4b11aebc073d4$export$6c519d302dced239)()
    };
    dragStartMousePosition = null;
    dragNodeProps = null;
    currentMouseOverDroppableNodeKey = null;
    focusedByMouse = false;
    listRef = /*#__PURE__*/ $acw62.createRef();
    componentDidMount() {
        this.destroyed = false;
        this.onUpdated();
    }
    componentDidUpdate() {
        this.onUpdated();
    }
    onUpdated() {
        const { activeKey: activeKey, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey !== undefined && activeKey !== this.state.activeKey) {
            this.setState({
                activeKey: activeKey
            });
            if (activeKey !== null) this.scrollTo({
                key: activeKey,
                offset: itemScrollOffset
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('dragend', this.onWindowDragEnd);
        this.destroyed = true;
    }
    static getDerivedStateFromProps(props, prevState) {
        const { prevProps: prevProps } = prevState;
        const newState = {
            prevProps: props
        };
        function needSync(name) {
            return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
        }
        // ================== Tree Node ==================
        let treeData;
        // fieldNames
        let { fieldNames: fieldNames } = prevState;
        if (needSync('fieldNames')) {
            fieldNames = (0, $a4a4b11aebc073d4$export$6c519d302dced239)(props.fieldNames);
            newState.fieldNames = fieldNames;
        }
        // Check if `treeData` or `children` changed and save into the state.
        if (needSync('treeData')) ({ treeData: treeData } = props);
        else if (needSync('children')) {
            (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
            treeData = (0, $a4a4b11aebc073d4$export$6d8b10995563b669)(props.children);
        }
        // Save flatten nodes info and convert `treeData` into keyEntities
        if (treeData) {
            newState.treeData = treeData;
            const entitiesMap = (0, $a4a4b11aebc073d4$export$e5d831ce033a4615)(treeData, {
                fieldNames: fieldNames
            });
            newState.keyEntities = {
                [(0, $e8eed9e85de7446b$export$17c02cdd52a7d889)]: (0, $e8eed9e85de7446b$export$2d18abad5109a402),
                ...entitiesMap.keyEntities
            };
        }
        const keyEntities = newState.keyEntities || prevState.keyEntities;
        // ================ expandedKeys =================
        if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $6290ecf480ea1bbd$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
        else if (!prevProps && props.defaultExpandAll) {
            const cloneKeyEntities = {
                ...keyEntities
            };
            delete cloneKeyEntities[0, $e8eed9e85de7446b$export$17c02cdd52a7d889];
            // Only take the key who has the children to enhance the performance
            const nextExpandedKeys = [];
            Object.keys(cloneKeyEntities).forEach((key)=>{
                const entity = cloneKeyEntities[key];
                if (entity.children && entity.children.length) nextExpandedKeys.push(entity.key);
            });
            newState.expandedKeys = nextExpandedKeys;
        } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $6290ecf480ea1bbd$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
        if (!newState.expandedKeys) delete newState.expandedKeys;
        // ================ flattenNodes =================
        if (treeData || newState.expandedKeys) {
            const flattenNodes = (0, $a4a4b11aebc073d4$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
            newState.flattenNodes = flattenNodes;
        }
        // ================ selectedKeys =================
        if (props.selectable) {
            if (needSync('selectedKeys')) newState.selectedKeys = (0, $6290ecf480ea1bbd$export$fffc10811828fd68)(props.selectedKeys, props);
            else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $6290ecf480ea1bbd$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
        }
        // ================= checkedKeys =================
        if (props.checkable) {
            let checkedKeyEntity;
            if (needSync('checkedKeys')) checkedKeyEntity = (0, $6290ecf480ea1bbd$export$29d4989c23990d41)(props.checkedKeys) || {};
            else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $6290ecf480ea1bbd$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
            else if (treeData) // If `treeData` changed, we also need check it
            checkedKeyEntity = (0, $6290ecf480ea1bbd$export$29d4989c23990d41)(props.checkedKeys) || {
                checkedKeys: prevState.checkedKeys,
                halfCheckedKeys: prevState.halfCheckedKeys
            };
            if (checkedKeyEntity) {
                let { checkedKeys: checkedKeys = [], halfCheckedKeys: halfCheckedKeys = [] } = checkedKeyEntity;
                if (!props.checkStrictly) {
                    const conductKeys = (0, $a76a7570d4fe3ae6$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                    ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = conductKeys);
                }
                newState.checkedKeys = checkedKeys;
                newState.halfCheckedKeys = halfCheckedKeys;
            }
        }
        // ================= loadedKeys ==================
        if (needSync('loadedKeys')) newState.loadedKeys = props.loadedKeys;
        return newState;
    }
    onNodeDragStart = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities } = this.state;
        const { onDragStart: onDragStart } = this.props;
        const { eventKey: eventKey } = nodeProps;
        this.dragNodeProps = nodeProps;
        this.dragStartMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        const newExpandedKeys = (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
        this.setState({
            draggingNodeKey: eventKey,
            dragChildrenKeys: (0, $6290ecf480ea1bbd$export$b0610c44bcbb051c)(eventKey, keyEntities),
            indent: this.listRef.current.getIndentWidth()
        });
        this.setExpandedKeys(newExpandedKeys);
        window.addEventListener('dragend', this.onWindowDragEnd);
        onDragStart?.({
            event: event,
            node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    /**
   * [Legacy] Select handler is smaller than node,
   * so that this will trigger when drag enter node or select handler.
   * This is a little tricky if customize css without padding.
   * Better for use mouse move event to refresh drag state.
   * But let's just keep it to avoid event trigger logic change.
   */ onNodeDragEnter = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities, dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, indent: indent } = this.state;
        const { onDragEnter: onDragEnter, onExpand: onExpand, allowDrop: allowDrop, direction: direction } = this.props;
        const { pos: pos, eventKey: eventKey } = nodeProps;
        // record the key of node which is latest entered, used in dragleave event.
        if (this.currentMouseOverDroppableNodeKey !== eventKey) this.currentMouseOverDroppableNodeKey = eventKey;
        if (!this.dragNodeProps) {
            this.resetDragState();
            return;
        }
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $6290ecf480ea1bbd$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (// don't allow drop inside its children
        dragChildrenKeys.includes(dropTargetKey) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !dropAllowed) {
            this.resetDragState();
            return;
        }
        // Side effect for delay drag
        if (!this.delayedDragEnterLogic) this.delayedDragEnterLogic = {};
        Object.keys(this.delayedDragEnterLogic).forEach((key)=>{
            clearTimeout(this.delayedDragEnterLogic[key]);
        });
        if (this.dragNodeProps.eventKey !== nodeProps.eventKey) {
            // hoist expand logic here
            // since if logic is on the bottom
            // it will be blocked by abstract dragover node check
            //   => if you dragenter from top, you mouse will still be consider as in the top node
            event.persist();
            this.delayedDragEnterLogic[pos] = window.setTimeout(()=>{
                if (this.state.draggingNodeKey === null) return;
                let newExpandedKeys = [
                    ...expandedKeys
                ];
                const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, nodeProps.eventKey);
                if (entity && (entity.children || []).length) newExpandedKeys = (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(expandedKeys, nodeProps.eventKey);
                if (!this.props.hasOwnProperty('expandedKeys')) this.setExpandedKeys(newExpandedKeys);
                onExpand?.(newExpandedKeys, {
                    node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(nodeProps),
                    expanded: true,
                    nativeEvent: event.nativeEvent
                });
            }, 800);
        }
        // Skip if drag node is self
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            this.resetDragState();
            return;
        }
        // Update drag over node and drag state
        this.setState({
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed
        });
        onDragEnter?.({
            event: event,
            node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(nodeProps),
            expandedKeys: expandedKeys
        });
    };
    onNodeDragOver = (event, nodeProps)=>{
        const { dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, keyEntities: keyEntities, expandedKeys: expandedKeys, indent: indent } = this.state;
        const { onDragOver: onDragOver, allowDrop: allowDrop, direction: direction } = this.props;
        if (!this.dragNodeProps) return;
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $6290ecf480ea1bbd$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) // don't allow drop inside its children
        // don't allow drop when drop is not allowed calculated by calcDropPosition
        return;
        // Update drag position
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            if (!(this.state.dropPosition === null && this.state.dropLevelOffset === null && this.state.dropTargetKey === null && this.state.dropContainerKey === null && this.state.dropTargetPos === null && this.state.dropAllowed === false && this.state.dragOverNodeKey === null)) this.resetDragState();
        } else if (!(dropPosition === this.state.dropPosition && dropLevelOffset === this.state.dropLevelOffset && dropTargetKey === this.state.dropTargetKey && dropContainerKey === this.state.dropContainerKey && dropTargetPos === this.state.dropTargetPos && dropAllowed === this.state.dropAllowed && dragOverNodeKey === this.state.dragOverNodeKey)) this.setState({
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed,
            dragOverNodeKey: dragOverNodeKey
        });
        onDragOver?.({
            event: event,
            node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    onNodeDragLeave = (event, nodeProps)=>{
        // if it is outside the droppable area
        // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
        if (this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
            this.resetDragState();
            this.currentMouseOverDroppableNodeKey = null;
        }
        const { onDragLeave: onDragLeave } = this.props;
        onDragLeave?.({
            event: event,
            node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    // since stopPropagation() is called in treeNode
    // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
    onWindowDragEnd = (event)=>{
        this.onNodeDragEnd(event, null, true);
        window.removeEventListener('dragend', this.onWindowDragEnd);
    };
    // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
    onNodeDragEnd = (event, nodeProps)=>{
        const { onDragEnd: onDragEnd } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        onDragEnd?.({
            event: event,
            node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(nodeProps)
        });
        this.dragNodeProps = null;
        window.removeEventListener('dragend', this.onWindowDragEnd);
    };
    onNodeDrop = (event, _, outsideTree = false)=>{
        const { dragChildrenKeys: dragChildrenKeys, dropPosition: dropPosition, dropTargetKey: dropTargetKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed } = this.state;
        if (!dropAllowed) return;
        const { onDrop: onDrop } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        if (dropTargetKey === null) return;
        const abstractDropNodeProps = {
            ...(0, $a4a4b11aebc073d4$export$d961fd523a514db5)(dropTargetKey, this.getTreeNodeRequiredProps()),
            active: this.getActiveItem()?.key === dropTargetKey,
            data: (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(this.state.keyEntities, dropTargetKey).node
        };
        const dropToChild = dragChildrenKeys.includes(dropTargetKey);
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
        const posArr = (0, $6290ecf480ea1bbd$export$ddaee97dc8907312)(dropTargetPos);
        const dropResult = {
            event: event,
            node: (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
            dragNode: this.dragNodeProps ? (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)(this.dragNodeProps) : null,
            dragNodesKeys: [
                this.dragNodeProps.eventKey
            ].concat(dragChildrenKeys),
            dropToGap: dropPosition !== 0,
            dropPosition: dropPosition + Number(posArr[posArr.length - 1])
        };
        if (!outsideTree) onDrop?.(dropResult);
        this.dragNodeProps = null;
    };
    resetDragState() {
        this.setState({
            dragOverNodeKey: null,
            dropPosition: null,
            dropLevelOffset: null,
            dropTargetKey: null,
            dropContainerKey: null,
            dropTargetPos: null,
            dropAllowed: false
        });
    }
    cleanDragState = ()=>{
        const { draggingNodeKey: draggingNodeKey } = this.state;
        if (draggingNodeKey !== null) this.setState({
            draggingNodeKey: null,
            dropPosition: null,
            dropContainerKey: null,
            dropTargetKey: null,
            dropLevelOffset: null,
            dropAllowed: true,
            dragOverNodeKey: null
        });
        this.dragStartMousePosition = null;
        this.currentMouseOverDroppableNodeKey = null;
    };
    triggerExpandActionExpand = (e, treeNode)=>{
        const { expandedKeys: expandedKeys, flattenNodes: flattenNodes } = this.state;
        const { expanded: expanded, key: key, isLeaf: isLeaf } = treeNode;
        if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
        const node = flattenNodes.filter((nodeItem)=>nodeItem.key === key)[0];
        const eventNode = (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)({
            ...(0, $a4a4b11aebc073d4$export$d961fd523a514db5)(key, this.getTreeNodeRequiredProps()),
            data: node.data
        });
        this.setExpandedKeys(expanded ? (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(expandedKeys, key));
        this.onNodeExpand(e, eventNode);
    };
    onNodeClick = (e, treeNode)=>{
        const { onClick: onClick, expandAction: expandAction } = this.props;
        if (expandAction === 'click') this.triggerExpandActionExpand(e, treeNode);
        onClick?.(e, treeNode);
    };
    onNodeDoubleClick = (e, treeNode)=>{
        const { onDoubleClick: onDoubleClick, expandAction: expandAction } = this.props;
        if (expandAction === 'doubleClick') this.triggerExpandActionExpand(e, treeNode);
        onDoubleClick?.(e, treeNode);
    };
    onNodeSelect = (e, treeNode)=>{
        let { selectedKeys: selectedKeys } = this.state;
        const { keyEntities: keyEntities, fieldNames: fieldNames } = this.state;
        const { onSelect: onSelect, multiple: multiple } = this.props;
        const { selected: selected } = treeNode;
        const key = treeNode[fieldNames.key];
        const targetSelected = !selected;
        // Update selected keys
        if (!targetSelected) selectedKeys = (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(selectedKeys, key);
        else if (!multiple) selectedKeys = [
            key
        ];
        else selectedKeys = (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(selectedKeys, key);
        // [Legacy] Not found related usage in doc or upper libs
        const selectedNodes = selectedKeys.map((selectedKey)=>{
            const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, selectedKey);
            return entity ? entity.node : null;
        }).filter(Boolean);
        this.setUncontrolledState({
            selectedKeys: selectedKeys
        });
        onSelect?.(selectedKeys, {
            event: 'select',
            selected: targetSelected,
            node: treeNode,
            selectedNodes: selectedNodes,
            nativeEvent: e.nativeEvent
        });
    };
    onNodeCheck = (e, treeNode, checked)=>{
        const { keyEntities: keyEntities, checkedKeys: oriCheckedKeys, halfCheckedKeys: oriHalfCheckedKeys } = this.state;
        const { checkStrictly: checkStrictly, onCheck: onCheck } = this.props;
        const { key: key } = treeNode;
        // Prepare trigger arguments
        let checkedObj;
        const eventObj = {
            event: 'check',
            node: treeNode,
            checked: checked,
            nativeEvent: e.nativeEvent
        };
        if (checkStrictly) {
            const checkedKeys = checked ? (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
            const halfCheckedKeys = (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
            checkedObj = {
                checked: checkedKeys,
                halfChecked: halfCheckedKeys
            };
            eventObj.checkedNodes = checkedKeys.map((checkedKey)=>(0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, checkedKey)).filter(Boolean).map((entity)=>entity.node);
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            });
        } else {
            // Always fill first
            let { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $a76a7570d4fe3ae6$export$43adf2c483e3e633)([
                ...oriCheckedKeys,
                key
            ], true, keyEntities);
            // If remove, we do it again to correction
            if (!checked) {
                const keySet = new Set(checkedKeys);
                keySet.delete(key);
                ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $a76a7570d4fe3ae6$export$43adf2c483e3e633)(Array.from(keySet), {
                    checked: false,
                    halfCheckedKeys: halfCheckedKeys
                }, keyEntities));
            }
            checkedObj = checkedKeys;
            // [Legacy] This is used for `rc-tree-select`
            eventObj.checkedNodes = [];
            eventObj.checkedNodesPositions = [];
            eventObj.halfCheckedKeys = halfCheckedKeys;
            checkedKeys.forEach((checkedKey)=>{
                const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                if (!entity) return;
                const { node: node, pos: pos } = entity;
                eventObj.checkedNodes.push(node);
                eventObj.checkedNodesPositions.push({
                    node: node,
                    pos: pos
                });
            });
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            }, false, {
                halfCheckedKeys: halfCheckedKeys
            });
        }
        onCheck?.(checkedObj, eventObj);
    };
    onNodeLoad = (treeNode)=>{
        const { key: key } = treeNode;
        const { keyEntities: keyEntities } = this.state;
        // Skip if has children already
        const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, key);
        if (entity?.children?.length) return;
        const loadPromise = new Promise((resolve, reject)=>{
            // We need to get the latest state of loading/loaded keys
            this.setState(({ loadedKeys: loadedKeys = [], loadingKeys: loadingKeys = [] })=>{
                const { loadData: loadData, onLoad: onLoad } = this.props;
                if (!loadData || loadedKeys.includes(key) || loadingKeys.includes(key)) return null;
                // Process load data
                const promise = loadData(treeNode);
                promise.then(()=>{
                    const { loadedKeys: currentLoadedKeys } = this.state;
                    const newLoadedKeys = (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                    // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                    // https://github.com/ant-design/ant-design/issues/12464
                    onLoad?.(newLoadedKeys, {
                        event: 'load',
                        node: treeNode
                    });
                    this.setUncontrolledState({
                        loadedKeys: newLoadedKeys
                    });
                    this.setState((prevState)=>({
                            loadingKeys: (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    resolve();
                }).catch((e)=>{
                    this.setState((prevState)=>({
                            loadingKeys: (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    // If exceed max retry times, we give up retry
                    this.loadingRetryTimes[key] = (this.loadingRetryTimes[key] || 0) + 1;
                    if (this.loadingRetryTimes[key] >= $d3ffd8d9829f3d0a$var$MAX_RETRY_TIMES) {
                        const { loadedKeys: currentLoadedKeys } = this.state;
                        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, 'Retry for `loadData` many times but still failed. No more retry.');
                        this.setUncontrolledState({
                            loadedKeys: (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                        });
                        resolve();
                    }
                    reject(e);
                });
                return {
                    loadingKeys: (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(loadingKeys, key)
                };
            });
        });
        // Not care warning if we ignore this
        loadPromise.catch(()=>{});
        return loadPromise;
    };
    onNodeMouseEnter = (event, node)=>{
        const { onMouseEnter: onMouseEnter } = this.props;
        onMouseEnter?.({
            event: event,
            node: node
        });
    };
    onNodeMouseLeave = (event, node)=>{
        const { onMouseLeave: onMouseLeave } = this.props;
        onMouseLeave?.({
            event: event,
            node: node
        });
    };
    onNodeContextMenu = (event, node)=>{
        const { onRightClick: onRightClick } = this.props;
        if (onRightClick) {
            event.preventDefault();
            onRightClick({
                event: event,
                node: node
            });
        }
    };
    onMouseDown = (event)=>{
        this.focusedByMouse = true;
        const { onMouseDown: onMouseDown } = this.props;
        onMouseDown?.(event);
    };
    onMouseUp = (event)=>{
        this.focusedByMouse = false;
        const { onMouseUp: onMouseUp } = this.props;
        onMouseUp?.(event);
    };
    onFocus = (...args)=>{
        const { onFocus: onFocus, disabled: disabled } = this.props;
        const { activeKey: activeKey, selectedKeys: selectedKeys, flattenNodes: flattenNodes } = this.state;
        if (!this.focusedByMouse && !disabled && activeKey === null) {
            const visibleSelectedKey = selectedKeys.find((key)=>{
                return flattenNodes.some((nodeItem)=>nodeItem.key === key);
            });
            if (visibleSelectedKey !== undefined) this.onActiveChange(visibleSelectedKey);
            else this.onActiveChange(flattenNodes?.[0]?.key || null);
        }
        onFocus?.(...args);
    };
    onBlur = (...args)=>{
        this.focusedByMouse = false;
        const { onBlur: onBlur } = this.props;
        this.onActiveChange(null);
        onBlur?.(...args);
    };
    getTreeNodeRequiredProps = ()=>{
        const { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities } = this.state;
        return {
            expandedKeys: expandedKeys || [],
            selectedKeys: selectedKeys || [],
            loadedKeys: loadedKeys || [],
            loadingKeys: loadingKeys || [],
            checkedKeys: checkedKeys || [],
            halfCheckedKeys: halfCheckedKeys || [],
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            keyEntities: keyEntities
        };
    };
    // =========================== Expanded ===========================
    /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ setExpandedKeys = (expandedKeys)=>{
        const { treeData: treeData, fieldNames: fieldNames } = this.state;
        const flattenNodes = (0, $a4a4b11aebc073d4$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
        this.setUncontrolledState({
            expandedKeys: expandedKeys,
            flattenNodes: flattenNodes
        }, true);
    };
    onNodeExpand = (e, treeNode)=>{
        let { expandedKeys: expandedKeys } = this.state;
        const { listChanging: listChanging, fieldNames: fieldNames } = this.state;
        const { onExpand: onExpand, loadData: loadData } = this.props;
        const { expanded: expanded } = treeNode;
        const key = treeNode[fieldNames.key];
        // Do nothing when motion is in progress
        if (listChanging) return;
        // Update selected keys
        const certain = expandedKeys.includes(key);
        const targetExpanded = !expanded;
        (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(expanded && certain || !expanded && !certain, 'Expand state not sync with index check');
        expandedKeys = targetExpanded ? (0, $6290ecf480ea1bbd$export$10663f6bbd2fd717)(expandedKeys, key) : (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(expandedKeys, key);
        this.setExpandedKeys(expandedKeys);
        onExpand?.(expandedKeys, {
            node: treeNode,
            expanded: targetExpanded,
            nativeEvent: e.nativeEvent
        });
        // Async Load data
        if (targetExpanded && loadData) {
            const loadPromise = this.onNodeLoad(treeNode);
            if (loadPromise) loadPromise.then(()=>{
                // [Legacy] Refresh logic
                const newFlattenTreeData = (0, $a4a4b11aebc073d4$export$215c1b4f1ba88b23)(this.state.treeData, expandedKeys, fieldNames);
                this.setUncontrolledState({
                    flattenNodes: newFlattenTreeData
                });
            }).catch(()=>{
                const { expandedKeys: currentExpandedKeys } = this.state;
                const expandedKeysToRestore = (0, $6290ecf480ea1bbd$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                this.setExpandedKeys(expandedKeysToRestore);
            });
        }
    };
    onListChangeStart = ()=>{
        this.setUncontrolledState({
            listChanging: true
        });
    };
    onListChangeEnd = ()=>{
        setTimeout(()=>{
            this.setUncontrolledState({
                listChanging: false
            });
        });
    };
    // =========================== Keyboard ===========================
    onActiveChange = (newActiveKey)=>{
        const { activeKey: activeKey } = this.state;
        const { onActiveChange: onActiveChange, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey === newActiveKey) return;
        this.setState({
            activeKey: newActiveKey
        });
        if (newActiveKey !== null) this.scrollTo({
            key: newActiveKey,
            offset: itemScrollOffset
        });
        onActiveChange?.(newActiveKey);
    };
    getActiveItem = ()=>{
        const { activeKey: activeKey, flattenNodes: flattenNodes } = this.state;
        if (activeKey === null) return null;
        return flattenNodes.find(({ key: key })=>key === activeKey) || null;
    };
    offsetActiveKey = (offset)=>{
        const { flattenNodes: flattenNodes, activeKey: activeKey } = this.state;
        let index = flattenNodes.findIndex(({ key: key })=>key === activeKey);
        // Align with index
        if (index === -1 && offset < 0) index = flattenNodes.length;
        index = (index + offset + flattenNodes.length) % flattenNodes.length;
        const item = flattenNodes[index];
        if (item) {
            const { key: key } = item;
            this.onActiveChange(key);
        } else this.onActiveChange(null);
    };
    onKeyDown = (event)=>{
        const { activeKey: activeKey, expandedKeys: expandedKeys, checkedKeys: checkedKeys, flattenNodes: flattenNodes, keyEntities: keyEntities } = this.state;
        const { onKeyDown: onKeyDown, checkable: checkable, selectable: selectable, disabled: disabled, loadData: loadData } = this.props;
        if (disabled) return;
        // >>>>>>>>>> Direction
        switch(event.key){
            case 'ArrowUp':
                this.offsetActiveKey(-1);
                event.preventDefault();
                break;
            case 'ArrowDown':
                this.offsetActiveKey(1);
                event.preventDefault();
                break;
            case 'Home':
                this.onActiveChange(flattenNodes?.[0]?.key);
                event.preventDefault();
                break;
            case 'End':
                this.onActiveChange(flattenNodes?.[flattenNodes.length - 1]?.key);
                event.preventDefault();
                break;
        }
        // >>>>>>>>>> Expand & Selection
        const activeItem = this.getActiveItem();
        if (activeItem && activeItem.data) {
            const treeNodeRequiredProps = this.getTreeNodeRequiredProps();
            const eventNode = (0, $a4a4b11aebc073d4$export$7bd1b0fd4a8b540b)({
                ...(0, $a4a4b11aebc073d4$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps),
                data: activeItem.data,
                active: true
            });
            const entity = (0, $7cb092bcfa0f8903$export$2e2bcd8739ae039)(keyEntities, activeKey);
            const hasChildren = !!entity?.children?.length;
            const expandable = !(0, $a4a4b11aebc073d4$export$335db82b86111fd1)(activeItem.data.isLeaf, loadData, hasChildren, eventNode.loaded);
            const canCheck = checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox;
            const canSelect = !checkable && selectable && !eventNode.disabled && eventNode.selectable !== false;
            switch(event.key){
                // >>> Expand
                case 'ArrowLeft':
                    // Collapse if possible
                    if (expandable && expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.parent) this.onActiveChange(activeItem.parent.key);
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    // Expand if possible
                    if (expandable && !expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.children && activeItem.children.length) this.onActiveChange(activeItem.children[0].key);
                    event.preventDefault();
                    break;
                case 'Enter':
                    if (expandable) {
                        event.preventDefault();
                        this.onNodeExpand({}, eventNode);
                    } else if (canCheck) {
                        if (!checkedKeys.includes(activeKey)) {
                            event.preventDefault();
                            this.onNodeCheck({}, eventNode, true);
                        }
                    } else if (canSelect && !eventNode.selected) {
                        event.preventDefault();
                        this.onNodeSelect({}, eventNode);
                    }
                    break;
                case ' ':
                    if (canCheck) {
                        event.preventDefault();
                        this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                    } else if (canSelect) {
                        event.preventDefault();
                        this.onNodeSelect({}, eventNode);
                    }
                    break;
            }
        }
        onKeyDown?.(event);
    };
    /**
   * Only update the value which is not in props
   */ setUncontrolledState = (state, atomic = false, forceState = null)=>{
        if (!this.destroyed) {
            let needSync = false;
            let allPassed = true;
            const newState = {};
            Object.keys(state).forEach((name)=>{
                if (this.props.hasOwnProperty(name)) {
                    allPassed = false;
                    return;
                }
                needSync = true;
                newState[name] = state[name];
            });
            if (needSync && (!atomic || allPassed)) this.setState({
                ...newState,
                ...forceState
            });
        }
    };
    scrollTo = (scroll)=>{
        this.listRef.current.scrollTo(scroll);
    };
    render() {
        const { flattenNodes: flattenNodes, keyEntities: keyEntities, draggingNodeKey: draggingNodeKey, dropLevelOffset: dropLevelOffset, dropContainerKey: dropContainerKey, dropTargetKey: dropTargetKey, dropPosition: dropPosition, dragOverNodeKey: dragOverNodeKey, indent: indent } = this.state;
        const { prefixCls: prefixCls, className: className, style: style, styles: styles, classNames: treeClassNames, showLine: showLine, focusable: focusable, tabIndex: tabIndex = 0, selectable: selectable, showIcon: showIcon, icon: icon, switcherIcon: switcherIcon, draggable: draggable, checkable: checkable, checkStrictly: checkStrictly, disabled: disabled, motion: motion, loadData: loadData, filterTreeNode: filterTreeNode, height: height, itemHeight: itemHeight, scrollWidth: scrollWidth, virtual: virtual, titleRender: titleRender, dropIndicatorRender: dropIndicatorRender, onContextMenu: onContextMenu, onScroll: onScroll, direction: direction, rootClassName: rootClassName, rootStyle: rootStyle } = this.props;
        const domProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(this.props, {
            aria: true,
            data: true
        });
        // It's better move to hooks but we just simply keep here
        let draggableConfig;
        if (draggable) {
            if (typeof draggable === 'object') draggableConfig = draggable;
            else if (typeof draggable === 'function') draggableConfig = {
                nodeDraggable: draggable
            };
            else draggableConfig = {};
        }
        const contextValue = {
            styles: styles,
            classNames: treeClassNames,
            prefixCls: prefixCls,
            selectable: selectable,
            showIcon: showIcon,
            icon: icon,
            switcherIcon: switcherIcon,
            draggable: draggableConfig,
            draggingNodeKey: draggingNodeKey,
            checkable: checkable,
            checkStrictly: checkStrictly,
            disabled: disabled,
            keyEntities: keyEntities,
            dropLevelOffset: dropLevelOffset,
            dropContainerKey: dropContainerKey,
            dropTargetKey: dropTargetKey,
            dropPosition: dropPosition,
            dragOverNodeKey: dragOverNodeKey,
            indent: indent,
            direction: direction,
            dropIndicatorRender: dropIndicatorRender,
            loadData: loadData,
            filterTreeNode: filterTreeNode,
            titleRender: titleRender,
            onNodeClick: this.onNodeClick,
            onNodeDoubleClick: this.onNodeDoubleClick,
            onNodeExpand: this.onNodeExpand,
            onNodeSelect: this.onNodeSelect,
            onNodeCheck: this.onNodeCheck,
            onNodeLoad: this.onNodeLoad,
            onNodeMouseEnter: this.onNodeMouseEnter,
            onNodeMouseLeave: this.onNodeMouseLeave,
            onNodeContextMenu: this.onNodeContextMenu,
            onNodeDragStart: this.onNodeDragStart,
            onNodeDragEnter: this.onNodeDragEnter,
            onNodeDragOver: this.onNodeDragOver,
            onNodeDragLeave: this.onNodeDragLeave,
            onNodeDragEnd: this.onNodeDragEnd,
            onNodeDrop: this.onNodeDrop
        };
        return /*#__PURE__*/ $acw62.createElement((0, $ea57aee73349ae60$export$dfae7d399eea2568).Provider, {
            value: contextValue
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className, rootClassName, {
                [`${prefixCls}-show-line`]: showLine
            }),
            style: rootStyle
        }, /*#__PURE__*/ $acw62.createElement((0, $e8eed9e85de7446b$export$2e2bcd8739ae039), $d3ffd8d9829f3d0a$var$_extends({
            ref: this.listRef,
            prefixCls: prefixCls,
            style: style,
            data: flattenNodes,
            disabled: disabled,
            selectable: selectable,
            checkable: !!checkable,
            motion: motion,
            dragging: draggingNodeKey !== null,
            height: height,
            itemHeight: itemHeight,
            virtual: virtual,
            focusable: focusable,
            tabIndex: tabIndex,
            activeItem: this.getActiveItem(),
            onFocus: this.onFocus,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            onActiveChange: this.onActiveChange,
            onListChangeStart: this.onListChangeStart,
            onListChangeEnd: this.onListChangeEnd,
            onContextMenu: onContextMenu,
            onScroll: onScroll,
            scrollWidth: scrollWidth
        }, this.getTreeNodeRequiredProps(), domProps))));
    }
}
var $d3ffd8d9829f3d0a$export$2e2bcd8739ae039 = $d3ffd8d9829f3d0a$var$Tree;




var $aceb0d70f73eb3c8$export$2e2bcd8739ae039 = (0, $d3ffd8d9829f3d0a$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5b173e35d737c62d$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $5b173e35d737c62d$export$2e2bcd8739ae039 = $5b173e35d737c62d$var$FileOutlined;



function $810fbb56c7a452ed$var$_extends() {
    $810fbb56c7a452ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $810fbb56c7a452ed$var$_extends.apply(this, arguments);
}
const $810fbb56c7a452ed$var$FileOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $810fbb56c7a452ed$var$_extends({}, props, {
        ref: ref,
        icon: (0, $5b173e35d737c62d$export$2e2bcd8739ae039)
    }));
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const $810fbb56c7a452ed$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($810fbb56c7a452ed$var$FileOutlined);
var $810fbb56c7a452ed$export$2e2bcd8739ae039 = $810fbb56c7a452ed$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $682105b8f0090055$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $682105b8f0090055$export$2e2bcd8739ae039 = $682105b8f0090055$var$FolderOpenOutlined;



function $a9e9f1e6898cec9b$var$_extends() {
    $a9e9f1e6898cec9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9e9f1e6898cec9b$var$_extends.apply(this, arguments);
}
const $a9e9f1e6898cec9b$var$FolderOpenOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $a9e9f1e6898cec9b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $682105b8f0090055$export$2e2bcd8739ae039)
    }));
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ const $a9e9f1e6898cec9b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($a9e9f1e6898cec9b$var$FolderOpenOutlined);
var $a9e9f1e6898cec9b$export$2e2bcd8739ae039 = $a9e9f1e6898cec9b$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $fc99a386109651e1$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $fc99a386109651e1$export$2e2bcd8739ae039 = $fc99a386109651e1$var$FolderOutlined;



function $7413288a2bacf616$var$_extends() {
    $7413288a2bacf616$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7413288a2bacf616$var$_extends.apply(this, arguments);
}
const $7413288a2bacf616$var$FolderOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $7413288a2bacf616$var$_extends({}, props, {
        ref: ref,
        icon: (0, $fc99a386109651e1$export$2e2bcd8739ae039)
    }));
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ const $7413288a2bacf616$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($7413288a2bacf616$var$FolderOutlined);
var $7413288a2bacf616$export$2e2bcd8739ae039 = $7413288a2bacf616$var$RefIcon;







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8c209b42de494af1$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $8c209b42de494af1$export$2e2bcd8739ae039 = $8c209b42de494af1$var$HolderOutlined;



function $19519bd5f49a4d45$var$_extends() {
    $19519bd5f49a4d45$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19519bd5f49a4d45$var$_extends.apply(this, arguments);
}
const $19519bd5f49a4d45$var$HolderOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $19519bd5f49a4d45$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8c209b42de494af1$export$2e2bcd8739ae039)
    }));
/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */ const $19519bd5f49a4d45$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($19519bd5f49a4d45$var$HolderOutlined);
var $19519bd5f49a4d45$export$2e2bcd8739ae039 = $19519bd5f49a4d45$var$RefIcon;















// ============================ Directory =============================
const $dd688963605698b3$export$2f47474ee6fcebcf = ({ treeCls: treeCls, treeNodeCls: treeNodeCls, directoryNodeSelectedBg: directoryNodeSelectedBg, directoryNodeSelectedColor: directoryNodeSelectedColor, motionDurationMid: motionDurationMid, borderRadius: borderRadius, controlItemBgHover: controlItemBgHover })=>({
        [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
            // >>> Title
            [`${treeCls}-node-content-wrapper`]: {
                position: 'static',
                [`&:has(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                [`> *:not(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                '&:hover': {
                    background: 'transparent'
                },
                // Expand interactive area to whole line
                '&:before': {
                    position: 'absolute',
                    inset: 0,
                    transition: `background-color ${motionDurationMid}`,
                    content: '""',
                    borderRadius: borderRadius
                },
                '&:hover:before': {
                    background: controlItemBgHover
                }
            },
            [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
                zIndex: 1
            },
            // ============= Selected =============
            '&-selected': {
                background: directoryNodeSelectedBg,
                borderRadius: borderRadius,
                [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
                    color: directoryNodeSelectedColor
                },
                // >>> Title
                [`${treeCls}-node-content-wrapper`]: {
                    color: directoryNodeSelectedColor,
                    background: 'transparent',
                    '&, &:hover': {
                        color: directoryNodeSelectedColor
                    },
                    '&:before, &:hover:before': {
                        background: directoryNodeSelectedBg
                    }
                }
            }
        }
    });


// ============================ Keyframes =============================
const $1453a5f857f99b8a$var$treeNodeFX = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('ant-tree-node-fx-do-not-use', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// ============================== Switch ==============================
const $1453a5f857f99b8a$var$getSwitchStyle = (prefixCls, token)=>({
        [`.${prefixCls}-switcher-icon`]: {
            display: 'inline-block',
            fontSize: 10,
            verticalAlign: 'baseline',
            svg: {
                transition: `transform ${token.motionDurationSlow}`
            }
        }
    });
// =============================== Drop ===============================
const $1453a5f857f99b8a$var$getDropIndicatorStyle = (prefixCls, token)=>({
        [`.${prefixCls}-drop-indicator`]: {
            position: 'absolute',
            // it should displayed over the following node
            zIndex: 1,
            height: 2,
            backgroundColor: token.colorPrimary,
            borderRadius: 1,
            pointerEvents: 'none',
            '&:after': {
                position: 'absolute',
                top: -3,
                insetInlineStart: -6,
                width: 8,
                height: 8,
                backgroundColor: 'transparent',
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorPrimary}`,
                borderRadius: '50%',
                content: '""'
            }
        }
    });
const $1453a5f857f99b8a$export$5ca74f7be820a85 = (prefixCls, token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, titleHeight: titleHeight, indentSize: indentSize, switcherSize: switcherSize, motionDurationMid: motionDurationMid, nodeSelectedBg: nodeSelectedBg, nodeHoverBg: nodeHoverBg, colorTextQuaternary: colorTextQuaternary, controlItemBgActiveDisabled: controlItemBgActiveDisabled } = token;
    return {
        [treeCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            // fix https://github.com/ant-design/ant-design/issues/50316
            ['--rc-virtual-list-scrollbar-bg']: token.colorSplit,
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            transition: `background-color ${token.motionDurationSlow}`,
            '&-rtl': {
                direction: 'rtl'
            },
            [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
                transform: 'rotate(90deg)'
            },
            // =================== Virtual List ===================
            [`${treeCls}-list`]: {
                '&:focus-visible': {
                    outline: 'none',
                    [`${treeNodeCls}-active ${treeCls}-node-content-wrapper`]: {
                        ...(0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)
                    }
                }
            },
            [`${treeCls}-list-holder-inner`]: {
                alignItems: 'flex-start'
            },
            [`&${treeCls}-block-node`]: {
                [`${treeCls}-list-holder-inner`]: {
                    alignItems: 'stretch',
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        flex: 'auto'
                    },
                    // >>> Drag
                    [`${treeNodeCls}.dragging:after`]: {
                        position: 'absolute',
                        inset: 0,
                        border: `1px solid ${token.colorPrimary}`,
                        opacity: 0,
                        animationName: $1453a5f857f99b8a$var$treeNodeFX,
                        animationDuration: token.motionDurationSlow,
                        animationPlayState: 'running',
                        animationFillMode: 'forwards',
                        content: '""',
                        pointerEvents: 'none',
                        borderRadius: token.borderRadius
                    }
                }
            },
            // ===================== TreeNode =====================
            [treeNodeCls]: {
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: treeNodePadding,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(titleHeight),
                position: 'relative',
                // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    zIndex: 1,
                    insetInlineStart: 0,
                    width: '100%',
                    top: '100%',
                    height: treeNodePadding
                },
                // Disabled
                [`&-disabled ${treeCls}-node-content-wrapper`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed',
                    '&:hover': {
                        background: 'transparent'
                    }
                },
                [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
                    backgroundColor: controlItemBgActiveDisabled
                },
                // we can not set pointer-events to none for checkbox in tree
                // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
                [`${treeCls}-checkbox-disabled`]: {
                    pointerEvents: 'unset'
                },
                // not disable
                [`&:not(${treeNodeCls}-disabled)`]: {
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        '&:hover': {
                            color: token.nodeHoverColor
                        }
                    }
                },
                [`&-active ${treeCls}-node-content-wrapper`]: {
                    background: token.controlItemBgHover
                },
                [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
                    color: token.colorPrimary,
                    fontWeight: token.fontWeightStrong
                },
                '&-draggable': {
                    cursor: 'grab',
                    [`${treeCls}-draggable-icon`]: {
                        // https://github.com/ant-design/ant-design/issues/41915
                        flexShrink: 0,
                        width: switcherSize,
                        textAlign: 'center',
                        visibility: 'visible',
                        color: colorTextQuaternary
                    },
                    [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
                        visibility: 'hidden'
                    }
                }
            },
            // >>> Indent
            [`${treeCls}-indent`]: {
                alignSelf: 'stretch',
                whiteSpace: 'nowrap',
                userSelect: 'none',
                '&-unit': {
                    display: 'inline-block',
                    width: indentSize
                }
            },
            // >>> Drag Handler
            [`${treeCls}-draggable-icon`]: {
                visibility: 'hidden'
            },
            // Switcher / Checkbox
            [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
                marginInlineEnd: token.calc(token.calc(switcherSize).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Checkbox
            // https://github.com/ant-design/ant-design/issues/56957
            [`${treeCls}-checkbox`]: {
                flexShrink: 0,
                // When the title spans multiple lines, the checkbox aligns vertically centered with other elements
                // However, the switcher aligns to flex-start, causing a vertical alignment discrepancy in the parent node
                // Currently, the checkbox uses start alignment, but this causes it to stick to the top, resulting in a visually higher position
                // By setting the switcher's lineHeight to titleHeight, the required margin-block-start distance can be calculated to correct the alignment
                alignSelf: 'flex-start',
                marginBlockStart: token.calc(token.calc(titleHeight).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Switcher
            [`${treeCls}-switcher`]: {
                ...$1453a5f857f99b8a$var$getSwitchStyle(prefixCls, token),
                position: 'relative',
                flex: 'none',
                alignSelf: 'stretch',
                width: switcherSize,
                textAlign: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                transition: `all ${token.motionDurationSlow}`,
                '&-noop': {
                    cursor: 'unset'
                },
                '&:before': {
                    pointerEvents: 'none',
                    content: '""',
                    width: switcherSize,
                    height: titleHeight,
                    position: 'absolute',
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    top: 0,
                    borderRadius: token.borderRadius,
                    transition: `all ${token.motionDurationSlow}`
                },
                [`&:not(${treeCls}-switcher-noop):hover:before`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&_close ${treeCls}-switcher-icon svg`]: {
                    transform: 'rotate(-90deg)'
                },
                '&-loading-icon': {
                    color: token.colorPrimary
                },
                '&-leaf-line': {
                    position: 'relative',
                    zIndex: 1,
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                    // https://github.com/ant-design/ant-design/issues/31884
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(switcherSize).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        marginInlineStart: -1,
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&:after': {
                        position: 'absolute',
                        width: token.calc(token.calc(switcherSize).div(2).equal()).mul(0.8).equal(),
                        height: token.calc(titleHeight).div(2).equal(),
                        borderBottom: `1px solid ${token.colorBorder}`,
                        content: '""'
                    }
                }
            },
            // >>> Title
            // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
            [`${treeCls}-node-content-wrapper`]: {
                position: 'relative',
                minHeight: titleHeight,
                paddingBlock: 0,
                paddingInline: token.paddingXS,
                background: 'transparent',
                borderRadius: token.borderRadius,
                cursor: 'pointer',
                transition: [
                    `all ${motionDurationMid}`,
                    'border 0s',
                    'line-height 0s',
                    'box-shadow 0s'
                ].join(', '),
                ...$1453a5f857f99b8a$var$getDropIndicatorStyle(prefixCls, token),
                '&:hover': {
                    backgroundColor: nodeHoverBg
                },
                [`&${treeCls}-node-selected`]: {
                    color: token.nodeSelectedColor,
                    backgroundColor: nodeSelectedBg
                },
                // Icon
                [`${treeCls}-iconEle`]: {
                    display: 'inline-block',
                    width: switcherSize,
                    height: titleHeight,
                    textAlign: 'center',
                    verticalAlign: 'top',
                    '&:empty': {
                        display: 'none'
                    }
                }
            },
            // https://github.com/ant-design/ant-design/issues/28217
            [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${treeNodeCls}.drop-container > [draggable]`]: {
                boxShadow: `0 0 0 2px ${token.colorPrimary}`
            },
            // ==================== Show Line =====================
            '&-show-line': {
                // ================ Indent lines ================
                [`${treeCls}-indent-unit`]: {
                    position: 'relative',
                    height: '100%',
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(switcherSize).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&-end:before': {
                        display: 'none'
                    }
                },
                // ============== Cover Background ==============
                [`${treeCls}-switcher`]: {
                    background: 'transparent',
                    '&-line-icon': {
                        // https://github.com/ant-design/ant-design/issues/32813
                        verticalAlign: '-0.15em'
                    }
                }
            },
            [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
                top: 'auto !important',
                bottom: 'auto !important',
                height: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(titleHeight).div(2).equal())} !important`
            }
        }
    };
};
const $1453a5f857f99b8a$export$6543b952798356f2 = (prefixCls, token, /**
 * @descCN 是否启用目录树样式
 * @descEN Whether to enable directory style
 * @default true
 */ enableDirectory = true)=>{
    const treeCls = `.${prefixCls}`;
    const treeNodeCls = `${treeCls}-treenode`;
    const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
    const treeToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        treeCls: treeCls,
        treeNodeCls: treeNodeCls,
        treeNodePadding: treeNodePadding
    });
    return [
        // Basic
        $1453a5f857f99b8a$export$5ca74f7be820a85(prefixCls, treeToken),
        // Directory
        enableDirectory && (0, $dd688963605698b3$export$2f47474ee6fcebcf)(treeToken)
    ].filter(Boolean);
};
const $1453a5f857f99b8a$export$bd8b682992bc9781 = (token)=>{
    const { controlHeightSM: controlHeightSM, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive } = token;
    const titleHeight = controlHeightSM;
    return {
        titleHeight: titleHeight,
        switcherSize: titleHeight,
        indentSize: titleHeight,
        nodeHoverBg: controlItemBgHover,
        nodeHoverColor: token.colorText,
        nodeSelectedBg: controlItemBgActive,
        nodeSelectedColor: token.colorText
    };
};
const $1453a5f857f99b8a$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary } = token;
    return {
        ...$1453a5f857f99b8a$export$bd8b682992bc9781(token),
        directoryNodeSelectedColor: colorTextLightSolid,
        directoryNodeSelectedBg: colorPrimary
    };
};
var $1453a5f857f99b8a$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Tree', (token, { prefixCls: prefixCls })=>[
        {
            [token.componentCls]: (0, $04e90e571fcd1828$export$3d2f074408bd1b82)(`${prefixCls}-checkbox`, token)
        },
        $1453a5f857f99b8a$export$6543b952798356f2(prefixCls, token),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(token)
    ], $1453a5f857f99b8a$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");
"use client";
const $1dfbc26739217dee$export$cc800923e997bb8 = 4;
const $1dfbc26739217dee$var$dropIndicatorRender = (props)=>{
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, prefixCls: prefixCls, indent: indent, direction: direction = 'ltr' } = props;
    const startPosition = direction === 'ltr' ? 'left' : 'right';
    const endPosition = direction === 'ltr' ? 'right' : 'left';
    const style = {
        [startPosition]: -dropLevelOffset * indent + $1dfbc26739217dee$export$cc800923e997bb8,
        [endPosition]: 0
    };
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $1dfbc26739217dee$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: `${prefixCls}-drop-indicator`
    });
};
var $1dfbc26739217dee$export$2e2bcd8739ae039 = $1dfbc26739217dee$var$dropIndicatorRender;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d18b58b25958afc6$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $d18b58b25958afc6$export$2e2bcd8739ae039 = $d18b58b25958afc6$var$CaretDownFilled;



function $be6cf3d0998df145$var$_extends() {
    $be6cf3d0998df145$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be6cf3d0998df145$var$_extends.apply(this, arguments);
}
const $be6cf3d0998df145$var$CaretDownFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $be6cf3d0998df145$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d18b58b25958afc6$export$2e2bcd8739ae039)
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $be6cf3d0998df145$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($be6cf3d0998df145$var$CaretDownFilled);
var $be6cf3d0998df145$export$2e2bcd8739ae039 = $be6cf3d0998df145$var$RefIcon;





var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c39dba0bbe13c0cc$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $c39dba0bbe13c0cc$export$2e2bcd8739ae039 = $c39dba0bbe13c0cc$var$MinusSquareOutlined;



function $1c3abacbb20fe960$var$_extends() {
    $1c3abacbb20fe960$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c3abacbb20fe960$var$_extends.apply(this, arguments);
}
const $1c3abacbb20fe960$var$MinusSquareOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1c3abacbb20fe960$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c39dba0bbe13c0cc$export$2e2bcd8739ae039)
    }));
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $1c3abacbb20fe960$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1c3abacbb20fe960$var$MinusSquareOutlined);
var $1c3abacbb20fe960$export$2e2bcd8739ae039 = $1c3abacbb20fe960$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0bd4c0466d4aa550$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $0bd4c0466d4aa550$export$2e2bcd8739ae039 = $0bd4c0466d4aa550$var$PlusSquareOutlined;



function $534a8c31bb2cb9ed$var$_extends() {
    $534a8c31bb2cb9ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $534a8c31bb2cb9ed$var$_extends.apply(this, arguments);
}
const $534a8c31bb2cb9ed$var$PlusSquareOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $534a8c31bb2cb9ed$var$_extends({}, props, {
        ref: ref,
        icon: (0, $0bd4c0466d4aa550$export$2e2bcd8739ae039)
    }));
/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $534a8c31bb2cb9ed$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($534a8c31bb2cb9ed$var$PlusSquareOutlined);
var $534a8c31bb2cb9ed$export$2e2bcd8739ae039 = $534a8c31bb2cb9ed$var$RefIcon;





"use client";
const $587d94115e84e73e$var$SwitcherIconCom = (props)=>{
    const { prefixCls: prefixCls, switcherIcon: switcherIcon, treeNodeProps: treeNodeProps, showLine: showLine, switcherLoadingIcon: switcherLoadingIcon } = props;
    const { isLeaf: isLeaf, expanded: expanded, loading: loading } = treeNodeProps;
    if (loading) {
        if (/*#__PURE__*/ $acw62.isValidElement(switcherLoadingIcon)) return switcherLoadingIcon;
        return /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-loading-icon`
        });
    }
    let showLeafIcon;
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(showLine)) showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (/*#__PURE__*/ $acw62.isValidElement(leafIcon)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(leafIcon, {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(leafIcon.props?.className, leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $acw62.createElement((0, $810fbb56c7a452ed$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-line-icon`
        }) : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-switcher-leaf-line`
        });
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if (/*#__PURE__*/ $acw62.isValidElement(switcher)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(switcher, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(switcher.props?.className, showLine ? `${prefixCls}-switcher-line-icon` : switcherCls)
    });
    if (switcher !== undefined) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $acw62.createElement((0, $1c3abacbb20fe960$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/ $acw62.createElement((0, $534a8c31bb2cb9ed$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    });
    return /*#__PURE__*/ $acw62.createElement((0, $be6cf3d0998df145$export$2e2bcd8739ae039), {
        className: switcherCls
    });
};
var $587d94115e84e73e$export$2e2bcd8739ae039 = $587d94115e84e73e$var$SwitcherIconCom;


"use client";
const $71445890cbc611bb$var$Tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('tree');
    const { virtual: virtual } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = false, showLine: showLine, switcherIcon: switcherIcon, switcherLoadingIcon: switcherLoadingIcon, blockNode: blockNode = false, children: children, checkable: checkable = false, selectable: selectable = true, draggable: draggable, disabled: disabled, motion: customMotion, style: style, rootClassName: rootClassName, classNames: classNames, styles: styles, icon: icon } = props;
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const motion = customMotion ?? {
        ...(0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls),
        motionAppear: false
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        showIcon: showIcon,
        blockNode: blockNode,
        checkable: checkable,
        selectable: selectable,
        disabled: mergedDisabled,
        motion: motion
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const newProps = {
        ...mergedProps,
        showLine: Boolean(showLine),
        icon: icon,
        dropIndicatorRender: (0, $1dfbc26739217dee$export$2e2bcd8739ae039)
    };
    const [hashId, cssVarCls] = (0, $1453a5f857f99b8a$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const itemHeight = token.paddingXS / 2 + (token.Tree?.titleHeight || token.controlHeightSM);
    const draggableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!draggable) return false;
        let mergedDraggable = {};
        switch(typeof draggable){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = {
                    ...draggable
                };
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19519bd5f49a4d45$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    const renderSwitcherIcon = (nodeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $587d94115e84e73e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            switcherIcon: switcherIcon,
            switcherLoadingIcon: switcherLoadingIcon,
            treeNodeProps: nodeProps,
            showLine: showLine
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aceb0d70f73eb3c8$export$2e2bcd8739ae039), {
        itemHeight: itemHeight,
        ref: ref,
        virtual: virtual,
        ...newProps,
        // newProps may contain style so declare style below it
        prefixCls: prefixCls,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
            [`${prefixCls}-icon-hide`]: !showIcon,
            [`${prefixCls}-block-node`]: blockNode,
            [`${prefixCls}-unselectable`]: !selectable,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-disabled`]: mergedDisabled
        }, contextClassName, className, hashId, cssVarCls),
        style: {
            ...contextStyle,
            ...style
        },
        rootClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.root, rootClassName),
        rootStyle: mergedStyles.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: `${prefixCls}-checkbox-inner`
        }) : checkable,
        selectable: selectable,
        switcherIcon: renderSwitcherIcon,
        draggable: draggableConfig
    }, children);
});
var $71445890cbc611bb$export$2e2bcd8739ae039 = $71445890cbc611bb$var$Tree;




const $b87075829d49fe5e$var$RECORD_NONE = 0;
const $b87075829d49fe5e$var$RECORD_START = 1;
const $b87075829d49fe5e$var$RECORD_END = 2;
function $b87075829d49fe5e$var$traverseNodesKey(treeData, callback, fieldNames) {
    const { key: fieldKey, children: fieldChildren } = fieldNames;
    function processNode(dataNode) {
        const key = dataNode[fieldKey];
        const children = dataNode[fieldChildren];
        if (callback(key, dataNode) !== false) $b87075829d49fe5e$var$traverseNodesKey(children || [], callback, fieldNames);
    }
    treeData.forEach(processNode);
}
function $b87075829d49fe5e$export$aad0b800290b42ab({ treeData: treeData, expandedKeys: expandedKeys, startKey: startKey, endKey: endKey, fieldNames: fieldNames }) {
    const keys = [];
    let record = $b87075829d49fe5e$var$RECORD_NONE;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $b87075829d49fe5e$var$traverseNodesKey(treeData, (key)=>{
        if (record === $b87075829d49fe5e$var$RECORD_END) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $b87075829d49fe5e$var$RECORD_NONE) record = $b87075829d49fe5e$var$RECORD_START;
            else if (record === $b87075829d49fe5e$var$RECORD_START) {
                record = $b87075829d49fe5e$var$RECORD_END;
                return false;
            }
        } else if (record === $b87075829d49fe5e$var$RECORD_START) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    }, (0, $a4a4b11aebc073d4$export$6c519d302dced239)(fieldNames));
    return keys;
}
function $b87075829d49fe5e$export$7d40a46ab3886826(treeData, keys, fieldNames) {
    const restKeys = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keys);
    const nodes = [];
    $b87075829d49fe5e$var$traverseNodesKey(treeData, (key, node)=>{
        const index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    }, (0, $a4a4b11aebc073d4$export$6c519d302dced239)(fieldNames));
    return nodes;
}


"use client";
function $6fd2de76bf4211ba$var$getIcon(props) {
    const { isLeaf: isLeaf, expanded: expanded } = props;
    if (isLeaf) return /*#__PURE__*/ $acw62.createElement((0, $810fbb56c7a452ed$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $acw62.createElement((0, $a9e9f1e6898cec9b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $7413288a2bacf616$export$2e2bcd8739ae039), null);
}
function $6fd2de76bf4211ba$var$getTreeData({ treeData: treeData, children: children }) {
    return treeData || (0, $a4a4b11aebc073d4$export$6d8b10995563b669)(children);
}
const $6fd2de76bf4211ba$var$DirectoryTree = /*#__PURE__*/ $acw62.forwardRef((oriProps, ref)=>{
    const { defaultExpandAll: defaultExpandAll, defaultExpandParent: defaultExpandParent, defaultExpandedKeys: defaultExpandedKeys, ...props } = oriProps;
    // Shift click usage
    const lastSelectedKeyRef = $acw62.useRef(null);
    const cachedSelectedKeysRef = $acw62.useRef(null);
    const getInitExpandedKeys = ()=>{
        const { keyEntities: keyEntities } = (0, $a4a4b11aebc073d4$export$e5d831ce033a4615)($6fd2de76bf4211ba$var$getTreeData(props), {
            fieldNames: props.fieldNames
        });
        let initExpandedKeys;
        const mergedExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $6290ecf480ea1bbd$export$fac4a40c345ccd80)(mergedExpandedKeys, keyEntities);
        else initExpandedKeys = mergedExpandedKeys;
        return initExpandedKeys;
    };
    const [selectedKeys, setSelectedKeys] = $acw62.useState(props.selectedKeys || props.defaultSelectedKeys || []);
    const [expandedKeys, setExpandedKeys] = $acw62.useState(()=>getInitExpandedKeys());
    $acw62.useEffect(()=>{
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $acw62.useEffect(()=>{
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    const onExpand = (keys, info)=>{
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return props.onExpand?.(keys, info);
    };
    const onSelect = (keys, event)=>{
        const { multiple: multiple, fieldNames: fieldNames } = props;
        const { node: node, nativeEvent: nativeEvent } = event;
        const { key: key = '' } = node;
        const treeData = $6fd2de76bf4211ba$var$getTreeData(props);
        // We need wrap this event since some value is not same
        const newEvent = {
            ...event,
            selected: true // Directory selected always true
        };
        // Windows / Mac single pick
        const ctrlPick = nativeEvent?.ctrlKey || nativeEvent?.metaKey;
        const shiftPick = nativeEvent?.shiftKey;
        // Generate new selected keys
        let newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKeyRef.current = key;
            cachedSelectedKeysRef.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cachedSelectedKeysRef.current || []), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $b87075829d49fe5e$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKeyRef.current,
                fieldNames: fieldNames
            })))));
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKeyRef.current = key;
            cachedSelectedKeysRef.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        }
        props.onSelect?.(newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = true, expandAction: expandAction = 'click', ...restProps } = props;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const connectClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-directory`, {
        [`${prefixCls}-directory-rtl`]: direction === 'rtl'
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $71445890cbc611bb$export$2e2bcd8739ae039), {
        icon: $6fd2de76bf4211ba$var$getIcon,
        ref: ref,
        blockNode: true,
        ...restProps,
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    });
});
var $6fd2de76bf4211ba$export$2e2bcd8739ae039 = $6fd2de76bf4211ba$var$DirectoryTree;



"use client";
const $214c2d233474e3a9$var$Tree = (0, $71445890cbc611bb$export$2e2bcd8739ae039);
$214c2d233474e3a9$var$Tree.DirectoryTree = (0, $6fd2de76bf4211ba$export$2e2bcd8739ae039);
$214c2d233474e3a9$var$Tree.TreeNode = (0, $00996a3f5b641670$export$2e2bcd8739ae039);
var $214c2d233474e3a9$export$2e2bcd8739ae039 = $214c2d233474e3a9$var$Tree;




var $acw62 = parcelRequire("acw62");


"use client";
const $c1d7c8bb2fcfceb3$var$FilterSearch = (props)=>{
    const { value: value, filterSearch: filterSearch, tablePrefixCls: tablePrefixCls, locale: locale, onChange: onChange } = props;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${tablePrefixCls}-filter-dropdown-search`
    }, /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: `${tablePrefixCls}-filter-dropdown-search-input`
    }));
};
var $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039 = $c1d7c8bb2fcfceb3$var$FilterSearch;



var $acw62 = parcelRequire("acw62");

"use client";
const $93969139f956c4b8$var$onKeyDown = (event)=>{
    const { keyCode: keyCode } = event;
    if (keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
const $93969139f956c4b8$var$FilterDropdownMenuWrapper = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement("div", {
        className: props.className,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: $93969139f956c4b8$var$onKeyDown,
        ref: ref
    }, props.children));
var $93969139f956c4b8$export$2e2bcd8739ae039 = $93969139f956c4b8$var$FilterDropdownMenuWrapper;


"use client";
function $e2c4fb76408c4dec$export$50792ddeed01ab0a(filters) {
    let keys = [];
    (filters || []).forEach(({ value: value, children: children })=>{
        keys.push(value);
        if (children) keys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keys), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($e2c4fb76408c4dec$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $e2c4fb76408c4dec$var$hasSubMenu(filters) {
    return filters.some(({ children: children })=>children);
}
const $e2c4fb76408c4dec$var$searchValueMatched = (normalizedSearchValue, text)=>{
    if (typeof text === 'string' || (0, $b956dab96d0e505b$export$7e4aa119212bc614)(text)) return text.toString().toLowerCase().includes(normalizedSearchValue);
    return false;
};
const $e2c4fb76408c4dec$var$renderFilterItems = (options)=>{
    const { filters: filters, prefixCls: prefixCls, filteredKeys: filteredKeys, filterMultiple: filterMultiple, searchValue: searchValue, normalizedSearchValue: normalizedSearchValue, filterSearch: filterSearch } = options;
    return filters.map((filter, index)=>{
        const key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: `${prefixCls}-dropdown-submenu`,
            children: $e2c4fb76408c4dec$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                normalizedSearchValue: normalizedSearchValue,
                filterSearch: filterSearch
            })
        };
        const Component = filterMultiple ? (0, $da237ba92f78ed9a$export$2e2bcd8739ae039) : (0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039);
        const item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $acw62.createElement("span", null, filter.text))
        };
        if (normalizedSearchValue) {
            if (typeof filterSearch === 'function') return filterSearch(normalizedSearchValue, filter) ? item : null;
            return $e2c4fb76408c4dec$var$searchValueMatched(normalizedSearchValue, filter.text) ? item : null;
        }
        return item;
    });
};
function $e2c4fb76408c4dec$var$wrapStringListType(keys) {
    return keys || [];
}
const $e2c4fb76408c4dec$var$FilterDropdown = (props)=>{
    const { tablePrefixCls: tablePrefixCls, prefixCls: prefixCls, column: column, dropdownPrefixCls: dropdownPrefixCls, columnKey: columnKey, filterOnClose: filterOnClose, filterMultiple: filterMultiple, filterMode: filterMode = 'menu', filterSearch: filterSearch = false, filterState: filterState, triggerFilter: triggerFilter, locale: locale, children: children, getPopupContainer: getPopupContainer, rootClassName: rootClassName } = props;
    const { filterResetToDefaultFilteredValue: filterResetToDefaultFilteredValue, defaultFilteredValue: defaultFilteredValue, filterDropdownProps: filterDropdownProps = {}, filterDropdownOpen: // Deprecated
    filterDropdownOpen, onFilterDropdownOpenChange: onFilterDropdownOpenChange } = column;
    const [visible, setVisible] = $acw62.useState(false);
    const inMeasureRow = $acw62.useContext((0, $0294edcb7fd2dbc1$export$2e2bcd8739ae039));
    const filtered = !!(filterState && (filterState.filteredKeys?.length || filterState.forceFiltered));
    const triggerVisible = (newVisible)=>{
        setVisible(newVisible);
        filterDropdownProps.onOpenChange?.(newVisible);
        // deprecated
        onFilterDropdownOpenChange?.(newVisible);
    };
    var deprecatedName, newName;
    const mergedVisible = filterDropdownProps.open ?? filterDropdownOpen ?? // deprecated
    visible; // inner state
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState?.filteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = (0, $1f7b7badb410ab86$export$bd58d1a153fd4998)($e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys));
    const onSelectKeys = ({ selectedKeys: selectedKeys })=>{
        setFilteredKeysSync(selectedKeys);
    };
    const onCheck = (keys, { node: node, checked: checked })=>{
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $acw62.useEffect(()=>{
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    const [openKeys, setOpenKeys] = $acw62.useState([]);
    const onOpenChange = (keys)=>{
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    const [searchValue, setSearchValue] = $acw62.useState('');
    const normalizedSearchValue = $acw62.useMemo(()=>searchValue.trim().toLowerCase(), [
        searchValue
    ]);
    const onSearch = (e)=>{
        const { value: value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $acw62.useEffect(()=>{
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys)=>{
        const mergedKeys = keys?.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)(mergedKeys, filterState?.filteredKeys, true)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = ()=>{
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = ({ confirm: confirm, closeDropdown: closeDropdown } = {
        confirm: false,
        closeDropdown: false
    })=>{
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map(String));
        else setFilteredKeysSync([]);
    };
    const doFilter = ({ closeDropdown: closeDropdown } = {
        closeDropdown: true
    })=>{
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible, info)=>{
        if (info.source === 'trigger') {
            if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
            setFilteredKeysSync($e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys));
            triggerVisible(newVisible);
            if (!newVisible && !column.filterDropdown && filterOnClose) onConfirm();
        }
    };
    // ======================== Style ========================
    const dropdownMenuClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${dropdownPrefixCls}-menu-without-submenu`]: !$e2c4fb76408c4dec$var$hasSubMenu(column.filters || [])
    });
    const onCheckAll = (e)=>{
        if (e.target.checked) {
            const allFilterKeys = $e2c4fb76408c4dec$export$50792ddeed01ab0a(column?.filters).map(String);
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    const getTreeData = ({ filters: filters })=>(filters || []).map((filter, index)=>{
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    const getFilterData = (node)=>({
            ...node,
            text: node.title,
            value: node.key,
            children: node.children?.map(getFilterData) || []
        });
    let dropdownContent;
    const { direction: direction, renderEmpty: renderEmpty } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: `${dropdownPrefixCls}-custom`,
        setSelectedKeys: (selectedKeys)=>onSelectKeys({
                selectedKeys: selectedKeys
            }),
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: ()=>{
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        const selectedKeys = getFilteredKeysSync() || [];
        const getFilterComponent = ()=>{
            const empty = renderEmpty?.('Table.filter') ?? /*#__PURE__*/ $acw62.createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                styles: {
                    image: {
                        height: 24
                    }
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if ((column.filters || []).length === 0) return empty;
            if (filterMode === 'tree') return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $acw62.createElement("div", {
                className: `${tablePrefixCls}-filter-dropdown-tree`
            }, filterMultiple ? /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === $e2c4fb76408c4dec$export$50792ddeed01ab0a(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < $e2c4fb76408c4dec$export$50792ddeed01ab0a(column.filters).length,
                className: `${tablePrefixCls}-filter-dropdown-checkall`,
                onChange: onCheckAll
            }, locale?.filterCheckall ?? locale?.filterCheckAll) : null, /*#__PURE__*/ $acw62.createElement((0, $214c2d233474e3a9$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: `${dropdownPrefixCls}-menu`,
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: normalizedSearchValue ? (node)=>{
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $e2c4fb76408c4dec$var$searchValueMatched(normalizedSearchValue, node.title);
                } : undefined
            })));
            const items = $e2c4fb76408c4dec$var$renderFilterItems({
                filters: column.filters || [],
                filterSearch: filterSearch,
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                normalizedSearchValue: normalizedSearchValue
            });
            const isEmpty = items.every((item)=>item === null);
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), isEmpty ? empty : /*#__PURE__*/ $acw62.createElement((0, $47077f34c49bbd52$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: `${dropdownPrefixCls}-menu`,
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: items
            }));
        };
        const getResetDisabled = ()=>{
            if (filterResetToDefaultFilteredValue) return (0, $9d466ab90ba4f32d$export$2e2bcd8739ae039)((defaultFilteredValue || []).map(String), selectedKeys, true);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, getFilterComponent(), /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-dropdown-btns`
        }, /*#__PURE__*/ $acw62.createElement((0, $6b70efe984f9bc5b$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: ()=>onReset()
        }, locale.filterReset), /*#__PURE__*/ $acw62.createElement((0, $6b70efe984f9bc5b$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    dropdownContent = /*#__PURE__*/ $acw62.createElement((0, $93969139f956c4b8$export$2e2bcd8739ae039), {
        className: `${prefixCls}-dropdown`
    }, dropdownContent);
    const getDropdownTrigger = ()=>{
        let filterIcon;
        if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
        else if (column.filterIcon) filterIcon = column.filterIcon;
        else filterIcon = /*#__PURE__*/ $acw62.createElement((0, $6d4c3c11d072512d$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $acw62.createElement("span", {
            role: "button",
            tabIndex: -1,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
                active: filtered
            }),
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, filterIcon);
    };
    const triggerNode = getDropdownTrigger();
    // MeasureRow：仅渲染静态 trigger，不渲染 Dropdown 实例
    if (inMeasureRow) return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), triggerNode);
    const mergedDropdownProps = (0, $be673cd5391dca21$export$2e2bcd8739ae039)({
        trigger: [
            'click'
        ],
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight',
        children: triggerNode,
        getPopupContainer: getPopupContainer
    }, {
        ...filterDropdownProps,
        rootClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rootClassName, filterDropdownProps.rootClassName),
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        popupRender: ()=>{
            if (typeof filterDropdownProps?.dropdownRender === 'function') return filterDropdownProps.dropdownRender(dropdownContent);
            return dropdownContent;
        }
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), /*#__PURE__*/ $acw62.createElement((0, $9df091eb5002c0d1$export$2e2bcd8739ae039), {
        ...mergedDropdownProps
    }));
};
var $e2c4fb76408c4dec$export$2e2bcd8739ae039 = $e2c4fb76408c4dec$var$FilterDropdown;


"use client";
const $498593f51893a533$var$collectFilterStates = (columns, init, pos)=>{
    let filterStates = [];
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        const filterDropdownIsDefined = column.filterDropdown !== undefined;
        if (column.filters || filterDropdownIsDefined || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                let filteredValues = column.filteredValue;
                if (!filterDropdownIsDefined) filteredValues = filteredValues?.map(String) ?? filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filterStates), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($498593f51893a533$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
};
function $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
    return columns.map((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        const { filterOnClose: filterOnClose = true, filterMultiple: filterMultiple = true, filterMode: filterMode, filterSearch: filterSearch } = column;
        let newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            const columnKey = (0, $10b8a922ada6c9c1$export$480219a02f196e72)(newColumn, columnPos);
            const filterState = filterStates.find(({ key: key })=>columnKey === key);
            newColumn = {
                ...newColumn,
                title: (renderProps)=>/*#__PURE__*/ $acw62.createElement((0, $e2c4fb76408c4dec$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: `${prefixCls}-filter`,
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterOnClose: filterOnClose,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer,
                        rootClassName: rootClassName
                    }, (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, renderProps))
            };
        }
        if ('children' in newColumn) newColumn = {
            ...newColumn,
            children: $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
        };
        return newColumn;
    });
}
const $498593f51893a533$var$generateFilterInfo = (filterStates)=>{
    const currentFilters = {};
    filterStates.forEach(({ key: key, filteredKeys: filteredKeys, column: column })=>{
        const keyAsString = key;
        const { filters: filters, filterDropdown: filterDropdown } = column;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            const keys = (0, $e2c4fb76408c4dec$export$50792ddeed01ab0a)(filters);
            currentFilters[keyAsString] = keys.filter((originKey)=>filteredKeys.includes(String(originKey)));
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
};
const $498593f51893a533$export$37643bb40f4c1c56 = (data, filterStates, childrenColumnName)=>{
    const filterDatas = filterStates.reduce((currentData, filterState)=>{
        const { column: { onFilter: onFilter, filters: filters }, filteredKeys: filteredKeys } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) {
            // Preprocess the keys corresponding to the filter tree,
            // use Map to improve lookup performance to O(1).
            const flatKeys = (0, $e2c4fb76408c4dec$export$50792ddeed01ab0a)(filters);
            const keyMap = new Map();
            flatKeys.forEach((k)=>{
                const strKey = String(k);
                if (!keyMap.has(strKey)) keyMap.set(strKey, k);
            });
            const realKeys = filteredKeys.map((key)=>{
                const strKey = String(key);
                return keyMap.get(strKey) ?? key;
            });
            const internalFilter = (subset)=>subset.reduce((acc, record)=>{
                    const clonedRecord = {
                        ...record
                    };
                    if (clonedRecord[childrenColumnName]) clonedRecord[childrenColumnName] = $498593f51893a533$export$37643bb40f4c1c56(clonedRecord[childrenColumnName], filterStates, childrenColumnName);
                    if (realKeys.some((realKey)=>onFilter(realKey, clonedRecord))) acc.push(clonedRecord);
                    return acc;
                }, []);
            return internalFilter(currentData);
        }
        return currentData;
    }, data);
    return filterDatas;
};
const $498593f51893a533$var$getMergedColumns = (rawMergedColumns)=>rawMergedColumns.flatMap((column)=>{
        if ('children' in column) return [
            column
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($498593f51893a533$var$getMergedColumns(column.children || [])));
        return [
            column
        ];
    });
const $498593f51893a533$var$useFilter = (props)=>{
    const { prefixCls: prefixCls, dropdownPrefixCls: dropdownPrefixCls, mergedColumns: rawMergedColumns, onFilterChange: onFilterChange, getPopupContainer: getPopupContainer, locale: tableLocale, rootClassName: rootClassName } = props;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Table');
    const mergedColumns = $acw62.useMemo(()=>$498593f51893a533$var$getMergedColumns(rawMergedColumns || []), [
        rawMergedColumns
    ]);
    const [filterStates, setFilterStates] = $acw62.useState(()=>$498593f51893a533$var$collectFilterStates(mergedColumns, true));
    const mergedFilterStates = $acw62.useMemo(()=>{
        const collectedStates = $498593f51893a533$var$collectFilterStates(mergedColumns, false);
        if (collectedStates.length === 0) return collectedStates;
        let filteredKeysIsAllNotControlled = true;
        let filteredKeysIsAllControlled = true;
        collectedStates.forEach(({ filteredKeys: filteredKeys })=>{
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) {
            // Filter column may have been removed
            const keyList = (mergedColumns || []).map((column, index)=>(0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index)));
            return filterStates.filter(({ key: key })=>keyList.includes(key)).map((item)=>{
                const col = mergedColumns[keyList.indexOf(item.key)];
                return {
                    ...item,
                    column: {
                        ...item.column,
                        ...col
                    },
                    forceFiltered: col.filtered
                };
            });
        }
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    const filters = $acw62.useMemo(()=>$498593f51893a533$var$generateFilterInfo(mergedFilterStates), [
        mergedFilterStates
    ]);
    const triggerFilter = (filterState)=>{
        const newFilterStates = mergedFilterStates.filter(({ key: key })=>key !== filterState.key);
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($498593f51893a533$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns)=>$498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
};
var $498593f51893a533$export$2e2bcd8739ae039 = $498593f51893a533$var$useFilter;



var $acw62 = parcelRequire("acw62");

const $e2770d04bc76b8cc$var$useLazyKVMap = (data, childrenColumnName, getRowKey)=>{
    const mapCacheRef = $acw62.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            const kvMap = new Map();
            function dig(records) {
                records.forEach((record, index)=>{
                    const rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(record) && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap?.get(key);
    }
    return [
        getRecordByKey
    ];
};
var $e2770d04bc76b8cc$export$2e2bcd8739ae039 = $e2770d04bc76b8cc$var$useLazyKVMap;



var $acw62 = parcelRequire("acw62");


const $b37c5a68d8297fb7$export$5716e8bcb003888d = 10;
function $b37c5a68d8297fb7$export$27eceeed7bf0f4c2(mergedPagination, pagination) {
    const param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    const paginationObj = (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(pagination) ? pagination : {};
    Object.keys(paginationObj).forEach((pageProp)=>{
        const value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $b37c5a68d8297fb7$var$usePagination(total, onChange, pagination) {
    const { total: paginationTotal = 0, ...paginationObj } = (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(pagination) ? pagination : {};
    const [innerPagination, setInnerPagination] = (0, $acw62.useState)(()=>({
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $b37c5a68d8297fb7$export$5716e8bcb003888d
        }));
    // ============ Basic Pagination Config ============
    const mergedPagination = (0, $be673cd5391dca21$export$2e2bcd8739ae039)(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    const refreshPagination = (current, pageSize)=>{
        setInnerPagination({
            current: current ?? 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    const onInternalChange = (current, pageSize)=>{
        if (pagination) pagination.onChange?.(current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || mergedPagination?.pageSize);
    };
    if (pagination === false) return [
        {},
        ()=>{}
    ];
    return [
        {
            ...mergedPagination,
            onChange: onInternalChange
        },
        refreshPagination
    ];
}
var $b37c5a68d8297fb7$export$2e2bcd8739ae039 = $b37c5a68d8297fb7$var$usePagination;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $749787560a770a62$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $749787560a770a62$export$2e2bcd8739ae039 = $749787560a770a62$var$CaretDownOutlined;



function $d6a331782cd0282d$var$_extends() {
    $d6a331782cd0282d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d6a331782cd0282d$var$_extends.apply(this, arguments);
}
const $d6a331782cd0282d$var$CaretDownOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $d6a331782cd0282d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $749787560a770a62$export$2e2bcd8739ae039)
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $d6a331782cd0282d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d6a331782cd0282d$var$CaretDownOutlined);
var $d6a331782cd0282d$export$2e2bcd8739ae039 = $d6a331782cd0282d$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $478fce407c73001f$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $478fce407c73001f$export$2e2bcd8739ae039 = $478fce407c73001f$var$CaretUpOutlined;



function $ee1b76222e0d2812$var$_extends() {
    $ee1b76222e0d2812$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee1b76222e0d2812$var$_extends.apply(this, arguments);
}
const $ee1b76222e0d2812$var$CaretUpOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $ee1b76222e0d2812$var$_extends({}, props, {
        ref: ref,
        icon: (0, $478fce407c73001f$export$2e2bcd8739ae039)
    }));
/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */ const $ee1b76222e0d2812$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ee1b76222e0d2812$var$CaretUpOutlined);
var $ee1b76222e0d2812$export$2e2bcd8739ae039 = $ee1b76222e0d2812$var$RefIcon;







"use client";
const $71f5389ed963960f$var$ASCEND = 'ascend';
const $71f5389ed963960f$var$DESCEND = 'descend';
const $71f5389ed963960f$var$getMultiplePriority = (column)=>{
    if (column.sorter && typeof column.sorter === 'object' && (0, $b956dab96d0e505b$export$7e4aa119212bc614)(column.sorter.multiple)) return column.sorter.multiple;
    return false;
};
const $71f5389ed963960f$var$getSortFunction = (sorter)=>{
    if (typeof sorter === 'function') return sorter;
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(sorter) && sorter.compare) return sorter.compare;
    return false;
};
const $71f5389ed963960f$var$nextSortDirection = (sortDirections, current)=>{
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
};
const $71f5389ed963960f$var$collectSortStates = (columns, init, pos)=>{
    let sortStates = [];
    const pushState = (column, columnPos)=>{
        sortStates.push({
            column: column,
            key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    };
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(sortStates), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($71f5389ed963960f$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
};
const $71f5389ed963960f$var$injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos, a11yLocale)=>{
    const finalColumns = (columns || []).map((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        let newColumn = column;
        if (newColumn.sorter) {
            const sortDirections = newColumn.sortDirections || defaultSortDirections;
            const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            const columnKey = (0, $10b8a922ada6c9c1$export$480219a02f196e72)(newColumn, columnPos);
            const sorterState = sorterStates.find(({ key: key })=>key === columnKey);
            const sortOrder = sorterState ? sorterState.sortOrder : null;
            const nextSortOrder = $71f5389ed963960f$var$nextSortDirection(sortDirections, sortOrder);
            let sorter;
            if (column.sortIcon) sorter = column.sortIcon({
                sortOrder: sortOrder
            });
            else {
                const upNode = sortDirections.includes($71f5389ed963960f$var$ASCEND) && /*#__PURE__*/ $acw62.createElement((0, $ee1b76222e0d2812$export$2e2bcd8739ae039), {
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-up`, {
                        active: sortOrder === $71f5389ed963960f$var$ASCEND
                    })
                });
                const downNode = sortDirections.includes($71f5389ed963960f$var$DESCEND) && /*#__PURE__*/ $acw62.createElement((0, $d6a331782cd0282d$export$2e2bcd8739ae039), {
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-down`, {
                        active: sortOrder === $71f5389ed963960f$var$DESCEND
                    })
                });
                sorter = /*#__PURE__*/ $acw62.createElement("span", {
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter`, {
                        [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
                    })
                }, /*#__PURE__*/ $acw62.createElement("span", {
                    className: `${prefixCls}-column-sorter-inner`,
                    "aria-hidden": "true"
                }, upNode, downNode));
            }
            const { cancelSort: cancelSort, triggerAsc: triggerAsc, triggerDesc: triggerDesc } = tableLocale || {};
            let sortTip = cancelSort;
            if (nextSortOrder === $71f5389ed963960f$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $71f5389ed963960f$var$ASCEND) sortTip = triggerAsc;
            const tooltipProps = (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(showSorterTooltip) ? {
                title: sortTip,
                ...showSorterTooltip
            } : {
                title: sortTip
            };
            newColumn = {
                ...newColumn,
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(newColumn.className, {
                    [`${prefixCls}-column-sort`]: sortOrder
                }),
                title: (renderProps)=>{
                    const columnSortersClass = `${prefixCls}-column-sorters`;
                    const renderColumnTitleWrapper = /*#__PURE__*/ $acw62.createElement("span", {
                        className: `${prefixCls}-column-title`
                    }, (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, renderProps));
                    const renderSortTitle = /*#__PURE__*/ $acw62.createElement("div", {
                        className: columnSortersClass
                    }, renderColumnTitleWrapper, sorter);
                    if (showSorterTooltip) {
                        if (typeof showSorterTooltip !== 'boolean' && showSorterTooltip?.target === 'sorter-icon') return /*#__PURE__*/ $acw62.createElement("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(columnSortersClass, `${columnSortersClass}-tooltip-target-sorter`)
                        }, renderColumnTitleWrapper, /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, sorter));
                        return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, renderSortTitle);
                    }
                    return renderSortTitle;
                },
                onHeaderCell: (col)=>{
                    const cell = column.onHeaderCell?.(col) || {};
                    const originOnClick = cell.onClick;
                    const originOKeyDown = cell.onKeyDown;
                    cell.onClick = (event)=>{
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column)
                        });
                        originOnClick?.(event);
                    };
                    cell.onKeyDown = (event)=>{
                        if (event.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column)
                            });
                            originOKeyDown?.(event);
                        }
                    };
                    const renderTitle = (0, $10b8a922ada6c9c1$export$1c24e0676a106839)(column.title, {});
                    const displayTitle = renderTitle?.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sortOrder) cell['aria-sort'] = sortOrder === 'ascend' ? 'ascending' : 'descending';
                    // Inform the screen-reader so it can tell the visually impaired user that this column can be sorted
                    cell['aria-description'] = a11yLocale?.sortable;
                    cell['aria-label'] = displayTitle || '';
                    cell.className = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(cell.className, `${prefixCls}-column-has-sorters`);
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle ?? '').toString();
                    return cell;
                }
            };
        }
        if ('children' in newColumn) newColumn = {
            ...newColumn,
            children: $71f5389ed963960f$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos, a11yLocale)
        };
        return newColumn;
    });
    return finalColumns;
};
const $71f5389ed963960f$var$stateToInfo = (sorterState)=>{
    const { column: column, sortOrder: sortOrder } = sorterState;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
};
const $71f5389ed963960f$var$generateSorterInfo = (sorterStates)=>{
    const activeSorters = sorterStates.filter(({ sortOrder: sortOrder })=>sortOrder).map($71f5389ed963960f$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (activeSorters.length === 0 && sorterStates.length) {
        const lastIndex = sorterStates.length - 1;
        return {
            ...$71f5389ed963960f$var$stateToInfo(sorterStates[lastIndex]),
            column: undefined,
            order: undefined,
            field: undefined,
            columnKey: undefined
        };
    }
    if (activeSorters.length <= 1) return activeSorters[0] || {};
    return activeSorters;
};
const $71f5389ed963960f$export$594b2c8da4a70ee = (data, sortStates, childrenColumnName)=>{
    const innerSorterStates = sortStates.slice().sort((a, b)=>b.multiplePriority - a.multiplePriority);
    const cloneData = data.slice();
    const runningSorters = innerSorterStates.filter(({ column: { sorter: sorter }, sortOrder: sortOrder })=>$71f5389ed963960f$var$getSortFunction(sorter) && sortOrder);
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort((record1, record2)=>{
        for(let i = 0; i < runningSorters.length; i += 1){
            const sorterState = runningSorters[i];
            const { column: { sorter: sorter }, sortOrder: sortOrder } = sorterState;
            const compareFn = $71f5389ed963960f$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                const compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $71f5389ed963960f$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map((record)=>{
        const subRecords = record[childrenColumnName];
        if (subRecords) return {
            ...record,
            [childrenColumnName]: $71f5389ed963960f$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)
        };
        return record;
    });
};
const $71f5389ed963960f$var$useFilterSorter = (props)=>{
    const { prefixCls: prefixCls, mergedColumns: mergedColumns, sortDirections: sortDirections, tableLocale: tableLocale, showSorterTooltip: showSorterTooltip, onSorterChange: onSorterChange, globalLocale: globalLocale } = props;
    const [sortStates, setSortStates] = $acw62.useState(()=>$71f5389ed963960f$var$collectSortStates(mergedColumns, true));
    const getColumnKeys = (columns, pos)=>{
        const newKeys = [];
        columns.forEach((item, index)=>{
            const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
            newKeys.push((0, $10b8a922ada6c9c1$export$480219a02f196e72)(item, columnPos));
            if (Array.isArray(item.children)) {
                const childKeys = getColumnKeys(item.children, columnPos);
                newKeys.push.apply(newKeys, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(childKeys));
            }
        });
        return newKeys;
    };
    const mergedSorterStates = $acw62.useMemo(()=>{
        let validate = true;
        const collectedStates = $71f5389ed963960f$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) {
            const mergedColumnsKeys = getColumnKeys(mergedColumns);
            return sortStates.filter(({ key: key })=>mergedColumnsKeys.includes(key));
        }
        const validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push({
                ...state,
                sortOrder: null
            });
        }
        let multipleMode = null;
        collectedStates.forEach((state)=>{
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    const columnTitleSorterProps = $acw62.useMemo(()=>{
        const sortColumns = mergedSorterStates.map(({ column: column, sortOrder: sortOrder })=>({
                column: column,
                order: sortOrder
            }));
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0]?.column,
            sortOrder: sortColumns[0]?.order
        };
    }, [
        mergedSorterStates
    ]);
    const triggerSorter = (sortState)=>{
        let newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedSorterStates.filter(({ key: key })=>key !== sortState.key)), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($71f5389ed963960f$var$generateSorterInfo(newSorterStates), newSorterStates);
    };
    const transformColumns = (innerColumns)=>$71f5389ed963960f$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip, undefined, globalLocale);
    const getSorters = ()=>$71f5389ed963960f$var$generateSorterInfo(mergedSorterStates);
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
};
var $71f5389ed963960f$export$2e2bcd8739ae039 = $71f5389ed963960f$var$useFilterSorter;



var $acw62 = parcelRequire("acw62");

const $6bcbe2fbe72fb80a$var$fillTitle = (columns, columnTitleProps)=>{
    const finalColumns = columns.map((column)=>{
        const cloneColumn = {
            ...column
        };
        cloneColumn.title = (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $6bcbe2fbe72fb80a$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
    return finalColumns;
};
const $6bcbe2fbe72fb80a$var$useTitleColumns = (columnTitleProps)=>{
    const filledColumns = $acw62.useCallback((columns)=>$6bcbe2fbe72fb80a$var$fillTitle(columns, columnTitleProps), [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
};
var $6bcbe2fbe72fb80a$export$2e2bcd8739ae039 = $6bcbe2fbe72fb80a$var$useTitleColumns;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $5ea5ba4b4caafc13$var$RcTable = (0, $dfb65e8e39c1bbc2$export$13da147d1fdf3e3c)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $5ea5ba4b4caafc13$export$2e2bcd8739ae039 = $5ea5ba4b4caafc13$var$RcTable;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $18bcd07e79dcd06c$var$RcVirtualTable = (0, $d6570e86aa37195f$export$4747b79b36862360)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $18bcd07e79dcd06c$export$2e2bcd8739ae039 = $18bcd07e79dcd06c$var$RcVirtualTable;







const $b9b6fedf44f4f803$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableHeaderBg: tableHeaderBg, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal)=>({
            [`&${componentCls}-${size}`]: {
                [`> ${componentCls}-container`]: {
                    [`> ${componentCls}-content, > ${componentCls}-body`]: {
                        '> table > tbody > tr > th, > table > tbody > tr > td': {
                            [`> ${componentCls}-expanded-row-fixed`]: {
                                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())}
              ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
                            }
                        }
                    }
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}${componentCls}-bordered`]: {
                // ============================ Title =============================
                [`> ${componentCls}-title`]: {
                    border: tableBorder,
                    borderBottom: 0
                },
                // ============================ Content ============================
                [`> ${componentCls}-container`]: {
                    borderInlineStart: tableBorder,
                    borderTop: tableBorder,
                    [`> ${componentCls}-content, > ${componentCls}-header, > ${componentCls}-body, > ${componentCls}-summary`]: {
                        '> table': {
                            // ============================= Cell =============================
                            '> thead > tr > th, > thead > tr > td, > tbody > tr > th, > tbody > tr > td, > tfoot > tr > th, > tfoot > tr > td': {
                                borderInlineEnd: tableBorder
                            },
                            // ============================ Header ============================
                            '> thead': {
                                '> tr:not(:last-child) > th': {
                                    borderBottom: tableBorder
                                },
                                '> tr > th::before': {
                                    backgroundColor: 'transparent !important'
                                }
                            },
                            // Fixed right should provides additional border
                            '> thead > tr, > tbody > tr, > tfoot > tr': {
                                [`> ${componentCls}-cell-fix-right-first::after`]: {
                                    borderInlineEnd: tableBorder
                                }
                            },
                            // ========================== Expandable ==========================
                            '> tbody > tr > th, > tbody > tr > td': {
                                [`> ${componentCls}-expanded-row-fixed`]: {
                                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                                    '&::after': {
                                        position: 'absolute',
                                        top: 0,
                                        insetInlineEnd: lineWidth,
                                        bottom: 0,
                                        borderInlineEnd: tableBorder,
                                        content: '""'
                                    }
                                }
                            }
                        }
                    }
                },
                // ============================ Scroll ============================
                [`&${componentCls}-scroll-horizontal`]: {
                    [`> ${componentCls}-container > ${componentCls}-body`]: {
                        '> table > tbody': {
                            [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                                '> th, > td': {
                                    borderInlineEnd: 0
                                }
                            }
                        }
                    }
                },
                // ============================ Size ============================
                ...getSizeBorderStyle('medium', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle),
                ...getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall),
                // ============================ Footer ============================
                [`> ${componentCls}-footer`]: {
                    border: tableBorder,
                    borderTop: 0
                }
            },
            // ============================ Nested ============================
            [`${componentCls}-cell`]: {
                [`${componentCls}-container:first-child`]: {
                    // :first-child to avoid the case when bordered and title is set
                    borderTop: 0
                },
                // https://github.com/ant-design/ant-design/issues/35577
                '&-scrollbar:not([rowspan])': {
                    boxShadow: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${tableHeaderBg}`
                }
            },
            [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
                borderInlineEnd: tableBorder
            }
        }
    };
};
var $b9b6fedf44f4f803$export$2e2bcd8739ae039 = $b9b6fedf44f4f803$var$genBorderedStyle;



const $bce3bf4179f630c0$var$genEllipsisStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-cell-ellipsis`]: {
                ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                wordBreak: 'keep-all',
                // Fixed first or last should special process
                [`
          &${componentCls}-cell-fix-start-shadow,
          &${componentCls}-cell-fix-end-shadow
        `]: {
                    overflow: 'visible',
                    [`${componentCls}-cell-content`]: {
                        ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                        display: 'block'
                    }
                },
                [`${componentCls}-column-title`]: {
                    ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                    wordBreak: 'keep-all'
                }
            }
        }
    };
};
var $bce3bf4179f630c0$export$2e2bcd8739ae039 = $bce3bf4179f630c0$var$genEllipsisStyle;


// ========================= Placeholder ==========================
const $2d5ebf15cfaf4644$var$genEmptyStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
                textAlign: 'center',
                color: token.colorTextDisabled,
                '&:hover > th, &:hover > td': {
                    background: token.colorBgContainer
                }
            }
        }
    };
};
var $2d5ebf15cfaf4644$export$2e2bcd8739ae039 = $2d5ebf15cfaf4644$var$genEmptyStyle;




const $8888c6f6420bf18d$var$genExpandStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, paddingXS: paddingXS, lineType: lineType, tableBorderColor: tableBorderColor, tableExpandIconBg: tableExpandIconBg, tableExpandColumnWidth: tableExpandColumnWidth, borderRadius: borderRadius, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandedRowBg: tableExpandedRowBg, paddingXXS: paddingXXS, expandIconMarginTop: expandIconMarginTop, expandIconSize: expandIconSize, expandIconHalfInner: expandIconHalfInner, expandIconScale: expandIconScale, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-expand-icon-col`]: {
                width: tableExpandColumnWidth
            },
            [`${componentCls}-row-expand-icon-cell`]: {
                textAlign: 'center',
                [`${componentCls}-row-expand-icon`]: {
                    display: 'inline-flex',
                    float: 'none',
                    verticalAlign: 'sub'
                }
            },
            [`${componentCls}-row-indent`]: {
                height: 1,
                float: 'left'
            },
            [`${componentCls}-row-expand-icon`]: {
                ...(0, $4733a3b3eb18f80d$export$9a16e7694a707ab4)(token),
                position: 'relative',
                float: 'left',
                width: expandIconSize,
                height: expandIconSize,
                color: 'inherit',
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(expandIconSize),
                background: tableExpandIconBg,
                border: tableBorder,
                borderRadius: borderRadius,
                transform: `scale(${expandIconScale})`,
                '&:focus, &:hover, &:active': {
                    borderColor: 'currentcolor'
                },
                '&::before, &::after': {
                    position: 'absolute',
                    background: 'currentcolor',
                    transition: `transform ${motionDurationSlow} ease-out`,
                    content: '""'
                },
                '&::before': {
                    top: expandIconHalfInner,
                    insetInlineEnd: expandIconLineOffset,
                    insetInlineStart: expandIconLineOffset,
                    height: lineWidth
                },
                '&::after': {
                    top: expandIconLineOffset,
                    bottom: expandIconLineOffset,
                    insetInlineStart: expandIconHalfInner,
                    width: lineWidth,
                    transform: 'rotate(90deg)'
                },
                // Motion effect
                '&-collapsed::before': {
                    transform: 'rotate(-180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                },
                '&-spaced': {
                    '&::before, &::after': {
                        display: 'none',
                        content: 'none'
                    },
                    background: 'transparent',
                    border: 0,
                    visibility: 'hidden'
                }
            },
            [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
                marginTop: expandIconMarginTop,
                marginInlineEnd: paddingXS
            },
            [`tr${componentCls}-expanded-row`]: {
                '&, &:hover': {
                    '> th, > td': {
                        background: tableExpandedRowBg
                    }
                },
                // https://github.com/ant-design/ant-design/issues/25573
                [`${antCls}-descriptions-view`]: {
                    display: 'flex',
                    table: {
                        flex: 'auto',
                        width: '100%'
                    }
                }
            },
            // With fixed
            [`${componentCls}-expanded-row-fixed`]: {
                position: 'relative',
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`
            }
        }
    };
};
var $8888c6f6420bf18d$export$2e2bcd8739ae039 = $8888c6f6420bf18d$var$genExpandStyle;




const $da23b384be167274$var$genFilterStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, tableFilterDropdownWidth: tableFilterDropdownWidth, tableFilterDropdownSearchWidth: tableFilterDropdownSearchWidth, paddingXXS: paddingXXS, paddingXS: paddingXS, colorText: colorText, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, headerIconColor: headerIconColor, fontSizeSM: fontSizeSM, tablePaddingHorizontal: tablePaddingHorizontal, borderRadius: borderRadius, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorPrimary: colorPrimary, tableHeaderFilterActiveBg: tableHeaderFilterActiveBg, colorTextDisabled: colorTextDisabled, tableFilterDropdownBg: tableFilterDropdownBg, tableFilterDropdownHeight: tableFilterDropdownHeight, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive, boxShadowSecondary: boxShadowSecondary, filterDropdownMenuBg: filterDropdownMenuBg, calc: calc } = token;
    const dropdownPrefixCls = `${antCls}-dropdown`;
    const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
    const treePrefixCls = `${antCls}-tree`;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${componentCls}-filter-column`]: {
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                [`${componentCls}-filter-trigger`]: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    marginBlock: calc(paddingXXS).mul(-1).equal(),
                    marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXXS)}`,
                    color: headerIconColor,
                    fontSize: fontSizeSM,
                    borderRadius: borderRadius,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}`,
                    '&:hover': {
                        color: colorIcon,
                        background: tableHeaderFilterActiveBg
                    },
                    '&.active': {
                        color: colorPrimary
                    }
                }
            }
        },
        {
            // Dropdown
            [`${antCls}-dropdown`]: {
                [tableFilterDropdownPrefixCls]: {
                    ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                    minWidth: tableFilterDropdownWidth,
                    backgroundColor: tableFilterDropdownBg,
                    borderRadius: borderRadius,
                    boxShadow: boxShadowSecondary,
                    overflow: 'hidden',
                    // Reset menu
                    [`${dropdownPrefixCls}-menu`]: {
                        // https://github.com/ant-design/ant-design/issues/4916
                        // https://github.com/ant-design/ant-design/issues/19542
                        maxHeight: tableFilterDropdownHeight,
                        overflowX: 'hidden',
                        border: 0,
                        boxShadow: 'none',
                        borderRadius: 'unset',
                        backgroundColor: filterDropdownMenuBg,
                        '&:empty::after': {
                            display: 'block',
                            padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)} 0`,
                            color: colorTextDisabled,
                            fontSize: fontSizeSM,
                            textAlign: 'center',
                            content: '"Not Found"'
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-tree`]: {
                        paddingBlock: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)} 0`,
                        paddingInline: paddingXS,
                        [treePrefixCls]: {
                            padding: 0
                        },
                        [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
                            backgroundColor: controlItemBgHover
                        },
                        [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
                            '&, &:hover': {
                                backgroundColor: controlItemBgActive
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-search`]: {
                        padding: paddingXS,
                        borderBottom: tableBorder,
                        '&-input': {
                            input: {
                                minWidth: tableFilterDropdownSearchWidth
                            },
                            [iconCls]: {
                                color: colorTextDisabled
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-checkall`]: {
                        width: '100%',
                        marginBottom: paddingXXS,
                        marginInlineStart: paddingXXS
                    },
                    // Operation
                    [`${tableFilterDropdownPrefixCls}-btns`]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingXS).sub(lineWidth).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)}`,
                        overflow: 'hidden',
                        borderTop: tableBorder
                    }
                }
            }
        },
        // Dropdown Menu & SubMenu
        {
            // submenu of table filter dropdown
            [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
                // Checkbox
                [`${antCls}-checkbox-wrapper + span`]: {
                    paddingInlineStart: paddingXS,
                    color: colorText
                },
                '> ul': {
                    maxHeight: 'calc(100vh - 130px)',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        }
    ];
};
var $da23b384be167274$export$2e2bcd8739ae039 = $da23b384be167274$var$genFilterStyle;


function $3bb78fceca3da582$export$a16fd84c5da6565a({ colorSplit: shadowColor }) {
    const leftShadowStyle = {
        boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
    };
    const rightShadowStyle = {
        boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
    };
    return [
        leftShadowStyle,
        rightShadowStyle
    ];
}
const $3bb78fceca3da582$var$genFixedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, motionDurationSlow: motionDurationSlow, zIndexTableFixed: zIndexTableFixed, tableBg: tableBg, calc: calc } = token;
    const cellCls = `${componentCls}-cell`;
    const fixCellCls = `${cellCls}-fix`;
    const sharedShadowStyle = {
        position: 'absolute',
        top: 0,
        bottom: calc(lineWidth).mul(-1).equal(),
        width: 30,
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: 'none'
    };
    const [leftShadowStyle, rightShadowStyle] = $3bb78fceca3da582$export$a16fd84c5da6565a(token);
    // Follow style is magic of shadow which should not follow token:
    return {
        [`${componentCls}-wrapper`]: {
            // ====================== Cell ======================
            [`${cellCls}${fixCellCls}`]: {
                position: 'sticky'
            },
            [fixCellCls]: {
                zIndex: `calc(var(--z-offset-reverse) + ${zIndexTableFixed})`,
                background: tableBg,
                '&:after': sharedShadowStyle,
                // Position
                '&-start:after': {
                    insetInlineStart: '100%'
                },
                '&-end:after': {
                    insetInlineEnd: '100%'
                },
                // visible
                '&-start-shadow-show:after': leftShadowStyle,
                '&-end-shadow-show:after': rightShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                position: 'relative',
                '&:before, &:after': {
                    ...sharedShadowStyle,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`
                },
                '&:before': {
                    insetInlineStart: 0
                },
                '&:after': {
                    insetInlineEnd: 0
                }
            },
            [`${componentCls}-has-fix-start ${componentCls}-container:before`]: {
                display: 'none'
            },
            [`${componentCls}-has-fix-end ${componentCls}-container:after`]: {
                display: 'none'
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: leftShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: rightShadowStyle
        }
    };
};
var $3bb78fceca3da582$export$2e2bcd8739ae039 = $3bb78fceca3da582$var$genFixedStyle;



const $9a6bae14c3d282e3$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, margin: margin } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Pagination ==========================
            [`${componentCls}-pagination${antCls}-pagination`]: {
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(margin)} 0`
            },
            [`${componentCls}-pagination`]: {
                display: 'flex',
                flexWrap: 'wrap',
                rowGap: token.paddingXS,
                '> *': {
                    flex: 'none'
                },
                '&-start': {
                    justifyContent: 'flex-start'
                },
                '&-center': {
                    justifyContent: 'center'
                },
                '&-end': {
                    justifyContent: 'flex-end'
                }
            }
        }
    };
};
var $9a6bae14c3d282e3$export$2e2bcd8739ae039 = $9a6bae14c3d282e3$var$genPaginationStyle;



const $4773b3998487f976$var$genRadiusStyle = (token)=>{
    const { componentCls: componentCls, tableRadius: tableRadius } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [componentCls]: {
                // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
                [`${componentCls}-title, ${componentCls}-header`]: {
                    borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} 0 0`
                },
                [`${componentCls}-title + ${componentCls}-container`]: {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    // https://github.com/ant-design/ant-design/issues/41975
                    [`${componentCls}-header, table`]: {
                        borderRadius: 0
                    },
                    'table > thead > tr:first-child': {
                        'th:first-child, th:last-child, td:first-child, td:last-child': {
                            borderRadius: 0
                        }
                    }
                },
                '&-container': {
                    borderStartStartRadius: tableRadius,
                    borderStartEndRadius: tableRadius,
                    '&::before': {
                        borderStartStartRadius: tableRadius
                    },
                    '&::after': {
                        borderStartEndRadius: tableRadius
                    },
                    [`> ${componentCls}-content`]: {
                        borderStartStartRadius: tableRadius,
                        borderStartEndRadius: tableRadius
                    },
                    'table > thead > tr:first-child': {
                        '> *:first-child': {
                            borderStartStartRadius: tableRadius
                        },
                        '> *:last-child': {
                            borderStartEndRadius: tableRadius
                        }
                    }
                },
                '&-footer': {
                    borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)}`
                }
            }
        }
    };
};
var $4773b3998487f976$export$2e2bcd8739ae039 = $4773b3998487f976$var$genRadiusStyle;



const $5ed237fc7d94970f$var$genStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [leftShadowStyle, rightShadowStyle] = (0, $3bb78fceca3da582$export$a16fd84c5da6565a)(token);
    return {
        [`${componentCls}-wrapper-rtl`]: {
            direction: 'rtl',
            table: {
                direction: 'rtl'
            },
            [`${componentCls}-row-expand-icon`]: {
                float: 'right',
                '&::after': {
                    transform: 'rotate(-90deg)'
                },
                '&-collapsed::before': {
                    transform: 'rotate(180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                }
            },
            // ====================== Cell ======================
            [`${componentCls}-cell-fix`]: {
                '&-start-shadow-show:after': rightShadowStyle,
                '&-end-shadow-show:after': leftShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                [`${componentCls}-row-indent`]: {
                    float: 'right'
                }
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: rightShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: leftShadowStyle
        }
    };
};
var $5ed237fc7d94970f$export$2e2bcd8739ae039 = $5ed237fc7d94970f$var$genStyle;



const $ca6d152d3b6852e2$var$genSelectionStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSizeIcon: fontSizeIcon, padding: padding, paddingXS: paddingXS, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor, tableSelectionColumnWidth: tableSelectionColumnWidth, tableSelectedRowBg: tableSelectedRowBg, tableSelectedRowHoverBg: tableSelectedRowHoverBg, tableRowHoverBg: tableRowHoverBg, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Selections ==========================
            [`${componentCls}-selection-col`]: {
                width: tableSelectionColumnWidth,
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
                }
            },
            [`${componentCls}-bordered ${componentCls}-selection-col`]: {
                width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
                }
            },
            [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS,
                textAlign: 'center',
                [`${antCls}-radio-wrapper`]: {
                    marginInlineEnd: 0
                }
            },
            [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
                zIndex: calc(token.zIndexTableFixed).add(1).equal({
                    unit: false
                })
            },
            [`table tr th${componentCls}-selection-column::after`]: {
                backgroundColor: 'transparent !important'
            },
            [`${componentCls}-selection`]: {
                position: 'relative',
                display: 'inline-flex',
                flexDirection: 'column'
            },
            [`${componentCls}-selection-extra`]: {
                position: 'absolute',
                top: 0,
                zIndex: 1,
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                marginInlineStart: '100%',
                paddingInlineStart: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(4).equal()),
                [iconCls]: {
                    color: headerIconColor,
                    fontSize: fontSizeIcon,
                    verticalAlign: 'baseline',
                    '&:hover': {
                        color: headerIconHoverColor
                    }
                }
            },
            // ============================= Rows =============================
            [`${componentCls}-tbody`]: {
                [`${componentCls}-row`]: {
                    [`&${componentCls}-row-selected`]: {
                        [`> ${componentCls}-cell`]: {
                            background: tableSelectedRowBg,
                            '&-row-hover': {
                                background: tableSelectedRowHoverBg
                            }
                        }
                    },
                    [`> ${componentCls}-cell-row-hover`]: {
                        background: tableRowHoverBg
                    }
                }
            }
        }
    };
};
var $ca6d152d3b6852e2$export$2e2bcd8739ae039 = $ca6d152d3b6852e2$var$genSelectionStyle;



const $d7a83fe23e3255cb$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, tableExpandColumnWidth: tableExpandColumnWidth, calc: calc } = token;
    const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize)=>({
            [`${componentCls}${componentCls}-${size}`]: {
                fontSize: fontSize,
                [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingHorizontal)}`
                },
                [`${componentCls}-filter-trigger`]: {
                    marginInlineEnd: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).div(2).mul(-1).equal())
                },
                [`${componentCls}-expanded-row-fixed`]: {
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                },
                [`${componentCls}-tbody`]: {
                    // ========================= Nest Table ===========================
                    [`${componentCls}-wrapper:only-child ${componentCls}`]: {
                        marginBlock: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal()),
                        marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                    }
                },
                // https://github.com/ant-design/ant-design/issues/35167
                [`${componentCls}-selection-extra`]: {
                    paddingInlineStart: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).div(4).equal())
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            ...getSizeStyle('medium', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle),
            ...getSizeStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall)
        }
    };
};
var $d7a83fe23e3255cb$export$2e2bcd8739ae039 = $d7a83fe23e3255cb$var$genSizeStyle;


const $6655b371bedfd634$var$genSorterStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, fontSizeIcon: fontSizeIcon, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
                outline: 'none',
                cursor: 'pointer',
                // why left 0s? Avoid column header move with transition when left is changed
                // https://github.com/ant-design/ant-design/issues/50588
                transition: `all ${token.motionDurationSlow}, left 0s`,
                '&:hover': {
                    background: token.tableHeaderSortHoverBg,
                    '&::before': {
                        backgroundColor: 'transparent !important'
                    }
                },
                '&:focus-visible': {
                    color: token.colorPrimary
                },
                // https://github.com/ant-design/ant-design/issues/30969
                [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
                    background: token.tableFixedHeaderSortActiveBg
                }
            },
            [`${componentCls}-thead th${componentCls}-column-sort`]: {
                background: token.tableHeaderSortBg,
                '&::before': {
                    backgroundColor: 'transparent !important'
                }
            },
            [`td${componentCls}-column-sort`]: {
                background: token.tableBodySortBg
            },
            [`${componentCls}-column-title`]: {
                position: 'relative',
                zIndex: 1,
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-column-sorters`]: {
                display: 'flex',
                flex: 'auto',
                alignItems: 'center',
                justifyContent: 'space-between',
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    content: '""'
                }
            },
            [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
                '&::after': {
                    content: 'none'
                }
            },
            [`${componentCls}-column-sorter`]: {
                marginInlineStart: marginXXS,
                color: headerIconColor,
                fontSize: 0,
                transition: `color ${token.motionDurationSlow}`,
                '&-inner': {
                    display: 'inline-flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                },
                '&-up, &-down': {
                    fontSize: fontSizeIcon,
                    '&.active': {
                        color: token.colorPrimary
                    }
                },
                [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
                    marginTop: '-0.3em'
                }
            },
            [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
                color: headerIconHoverColor
            }
        }
    };
};
var $6655b371bedfd634$export$2e2bcd8739ae039 = $6655b371bedfd634$var$genSorterStyle;



const $994f7808639e9938$var$genStickyStyle = (token)=>{
    const { componentCls: componentCls, opacityLoading: opacityLoading, tableScrollThumbBg: tableScrollThumbBg, tableScrollThumbBgHover: tableScrollThumbBgHover, tableScrollThumbSize: tableScrollThumbSize, tableScrollBg: tableScrollBg, stickyScrollBarBorderRadius: stickyScrollBarBorderRadius, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, zIndexTableFixed: zIndexTableFixed } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-sticky`]: {
                '&-holder': {
                    position: 'sticky',
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    background: token.colorBgContainer
                },
                '&-scroll': {
                    position: 'sticky',
                    bottom: 0,
                    height: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableScrollThumbSize)} !important`,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    display: 'flex',
                    alignItems: 'center',
                    background: tableScrollBg,
                    borderTop: tableBorder,
                    opacity: opacityLoading,
                    '&:hover': {
                        transformOrigin: 'center bottom'
                    },
                    // fake scrollbar style of sticky
                    '&-bar': {
                        height: tableScrollThumbSize,
                        backgroundColor: tableScrollThumbBg,
                        borderRadius: stickyScrollBarBorderRadius,
                        transition: `all ${token.motionDurationSlow}, transform 0s`,
                        position: 'absolute',
                        bottom: 0,
                        '&:hover, &-active': {
                            backgroundColor: tableScrollThumbBgHover
                        }
                    }
                }
            }
        }
    };
};
var $994f7808639e9938$export$2e2bcd8739ae039 = $994f7808639e9938$var$genStickyStyle;



const $9a56b0c2c027df00$var$genSummaryStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-summary`]: {
                position: 'relative',
                zIndex: token.zIndexTableFixed,
                background: token.tableBg,
                '> tr': {
                    '> th, > td': {
                        borderBottom: tableBorder
                    }
                }
            },
            [`div${componentCls}-summary`]: {
                boxShadow: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
            }
        }
    };
};
var $9a56b0c2c027df00$export$2e2bcd8739ae039 = $9a56b0c2c027df00$var$genSummaryStyle;



const $f75ead9ff31bbaa9$var$genVirtualStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const rowCellCls = `${componentCls}-expanded-row-cell`;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Row ==========================
            [`${componentCls}-tbody-virtual`]: {
                [`${componentCls}-tbody-virtual-holder-inner`]: {
                    [`
            & > ${componentCls}-row,
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
                        display: 'flex',
                        boxSizing: 'border-box',
                        width: '100%'
                    }
                },
                [`${componentCls}-cell`]: {
                    borderBottom: tableBorder,
                    transition: `background-color ${motionDurationMid}`
                },
                [`${componentCls}-expanded-row`]: {
                    [`${rowCellCls}${rowCellCls}-fixed`]: {
                        position: 'sticky',
                        insetInlineStart: 0,
                        overflow: 'hidden',
                        width: `calc(var(--virtual-width) - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)})`,
                        borderInlineEnd: 'none'
                    }
                }
            },
            // ======================== Border =========================
            [`${componentCls}-bordered`]: {
                [`${componentCls}-tbody-virtual`]: {
                    '&:after': {
                        content: '""',
                        insetInline: 0,
                        bottom: 0,
                        borderBottom: tableBorder,
                        position: 'absolute'
                    },
                    [`${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        [`&${componentCls}-cell-fix-right-first:before`]: {
                            content: '""',
                            position: 'absolute',
                            insetBlock: 0,
                            insetInlineStart: calc(lineWidth).mul(-1).equal(),
                            borderInlineStart: tableBorder
                        }
                    }
                },
                // Empty placeholder
                [`&${componentCls}-virtual`]: {
                    [`${componentCls}-placeholder ${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        borderBottom: tableBorder
                    }
                }
            }
        }
    };
};
var $f75ead9ff31bbaa9$export$2e2bcd8739ae039 = $f75ead9ff31bbaa9$var$genVirtualStyle;


const $52ea1741590722c9$var$genTableStyle = (token)=>{
    const { componentCls: componentCls, fontWeightStrong: fontWeightStrong, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandColumnWidth: tableExpandColumnWidth, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableFontSize: tableFontSize, tableBg: tableBg, tableRadius: tableRadius, tableHeaderTextColor: tableHeaderTextColor, motionDurationMid: motionDurationMid, tableHeaderBg: tableHeaderBg, tableHeaderCellSplitColor: tableHeaderCellSplitColor, tableFooterTextColor: tableFooterTextColor, tableFooterBg: tableFooterBg, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            clear: 'both',
            maxWidth: '100%',
            // fix https://github.com/ant-design/ant-design/issues/46177
            ['--rc-virtual-list-scrollbar-bg']: token.tableScrollBg,
            ...(0, $4733a3b3eb18f80d$export$8c467e8859fdef13)(),
            [componentCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                fontSize: tableFontSize,
                background: tableBg,
                borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} 0 0`,
                // https://github.com/ant-design/ant-design/issues/47486
                scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
            },
            // https://github.com/ant-design/ant-design/issues/17611
            table: {
                width: '100%',
                textAlign: 'start',
                borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} 0 0`,
                borderCollapse: 'separate',
                borderSpacing: 0
            },
            // ============================= Cell ==============================
            [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
                position: 'relative',
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                overflowWrap: 'break-word'
            },
            // ============================ Title =============================
            [`${componentCls}-title`]: {
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`
            },
            // ============================ Header ============================
            [`${componentCls}-thead`]: {
                '> tr > th, > tr > td': {
                    position: 'relative',
                    color: tableHeaderTextColor,
                    fontWeight: fontWeightStrong,
                    textAlign: 'start',
                    background: tableHeaderBg,
                    borderBottom: tableBorder,
                    transition: `background-color ${motionDurationMid} ease`,
                    "&[colspan]:not([colspan='1'])": {
                        textAlign: 'center'
                    },
                    [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineEnd: 0,
                        width: 1,
                        height: '1.6em',
                        backgroundColor: tableHeaderCellSplitColor,
                        transform: 'translateY(-50%)',
                        transition: `background-color ${motionDurationMid}`,
                        content: '""'
                    }
                },
                '> tr:not(:last-child) > th[colspan]': {
                    borderBottom: 0
                }
            },
            // ============================ Body ============================
            [`${componentCls}-tbody`]: {
                '> tr': {
                    '> th, > td': {
                        borderBottom: tableBorder,
                        transition: [
                            `background-color`,
                            `border-color`
                        ].map((prop)=>`${prop} ${motionDurationMid}`).join(', '),
                        // ========================= Nest Table ===========================
                        [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
                            [componentCls]: {
                                marginBlock: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal()),
                                marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                                [`${componentCls}-tbody > tr:last-child > td`]: {
                                    borderBottomWidth: 0,
                                    '&:first-child, &:last-child': {
                                        borderRadius: 0
                                    }
                                }
                            }
                        }
                    },
                    '> th': {
                        position: 'relative',
                        color: tableHeaderTextColor,
                        fontWeight: fontWeightStrong,
                        textAlign: 'start',
                        background: tableHeaderBg,
                        borderBottom: tableBorder,
                        transition: `background-color ${motionDurationMid} ease`
                    },
                    // measure cell styles
                    [`& > ${componentCls}-measure-cell`]: {
                        paddingBlock: `0 !important`,
                        borderBlock: `0 !important`,
                        [`${componentCls}-measure-cell-content`]: {
                            height: 0,
                            overflow: 'hidden',
                            pointerEvents: 'none'
                        }
                    }
                }
            },
            // ============================ Footer ============================
            [`${componentCls}-footer`]: {
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                color: tableFooterTextColor,
                background: tableFooterBg
            }
        }
    };
};
const $52ea1741590722c9$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillAlter: colorFillAlter, colorBgContainer: colorBgContainer, colorTextHeading: colorTextHeading, colorFillSecondary: colorFillSecondary, colorFillContent: colorFillContent, controlItemBgActive: controlItemBgActive, controlItemBgActiveHover: controlItemBgActiveHover, padding: padding, paddingSM: paddingSM, paddingXS: paddingXS, colorBorderSecondary: colorBorderSecondary, borderRadiusLG: borderRadiusLG, controlHeight: controlHeight, colorTextPlaceholder: colorTextPlaceholder, fontSize: fontSize, fontSizeSM: fontSizeSM, lineHeight: lineHeight, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, opacityLoading: opacityLoading, controlInteractiveSize: controlInteractiveSize } = token;
    const colorFillSecondarySolid = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillSecondary).onBackground(colorBgContainer).toHexString();
    const colorFillContentSolid = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillContent).onBackground(colorBgContainer).toHexString();
    const colorFillAlterSolid = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillAlter).onBackground(colorBgContainer).toHexString();
    const baseColorAction = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorIcon);
    const baseColorActionHover = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorIconHover);
    const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
    const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
    return {
        headerBg: colorFillAlterSolid,
        headerColor: colorTextHeading,
        headerSortActiveBg: colorFillSecondarySolid,
        headerSortHoverBg: colorFillContentSolid,
        bodySortBg: colorFillAlterSolid,
        rowHoverBg: colorFillAlterSolid,
        rowSelectedBg: controlItemBgActive,
        rowSelectedHoverBg: controlItemBgActiveHover,
        rowExpandedBg: colorFillAlter,
        cellPaddingBlock: padding,
        cellPaddingInline: padding,
        cellPaddingBlockMD: paddingSM,
        cellPaddingInlineMD: paddingXS,
        cellPaddingBlockSM: paddingXS,
        cellPaddingInlineSM: paddingXS,
        borderColor: colorBorderSecondary,
        headerBorderRadius: borderRadiusLG,
        footerBg: colorFillAlterSolid,
        footerColor: colorTextHeading,
        cellFontSize: fontSize,
        cellFontSizeMD: fontSize,
        cellFontSizeSM: fontSize,
        headerSplitColor: colorBorderSecondary,
        fixedHeaderSortActiveBg: colorFillSecondarySolid,
        headerFilterHoverBg: colorFillContent,
        filterDropdownMenuBg: colorBgContainer,
        filterDropdownBg: colorBgContainer,
        expandIconBg: colorBgContainer,
        selectionColumnWidth: controlHeight,
        stickyScrollBarBg: colorTextPlaceholder,
        stickyScrollBarBorderRadius: 100,
        expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
        headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
        headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
        expandIconHalfInner: expandIconHalfInner,
        expandIconSize: expandIconSize,
        expandIconScale: controlInteractiveSize / expandIconSize
    };
};
const $52ea1741590722c9$var$zIndexTableFixed = 2;
var // ============================== Export ==============================
$52ea1741590722c9$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Table', (token)=>{
    const { colorTextHeading: colorTextHeading, colorSplit: colorSplit, colorBgContainer: colorBgContainer, controlInteractiveSize: checkboxSize, headerBg: headerBg, headerColor: headerColor, headerSortActiveBg: headerSortActiveBg, headerSortHoverBg: headerSortHoverBg, bodySortBg: bodySortBg, rowHoverBg: rowHoverBg, rowSelectedBg: rowSelectedBg, rowSelectedHoverBg: rowSelectedHoverBg, rowExpandedBg: rowExpandedBg, cellPaddingBlock: cellPaddingBlock, cellPaddingInline: cellPaddingInline, cellPaddingBlockMD: cellPaddingBlockMD, cellPaddingInlineMD: cellPaddingInlineMD, cellPaddingBlockSM: cellPaddingBlockSM, cellPaddingInlineSM: cellPaddingInlineSM, borderColor: borderColor, footerBg: footerBg, footerColor: footerColor, headerBorderRadius: headerBorderRadius, cellFontSize: cellFontSize, cellFontSizeMD: cellFontSizeMD, cellFontSizeSM: cellFontSizeSM, headerSplitColor: headerSplitColor, fixedHeaderSortActiveBg: fixedHeaderSortActiveBg, headerFilterHoverBg: headerFilterHoverBg, filterDropdownBg: filterDropdownBg, expandIconBg: expandIconBg, selectionColumnWidth: selectionColumnWidth, stickyScrollBarBg: stickyScrollBarBg, calc: calc } = token;
    const tableToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        tableFontSize: cellFontSize,
        tableBg: colorBgContainer,
        tableRadius: headerBorderRadius,
        tablePaddingVertical: cellPaddingBlock,
        tablePaddingHorizontal: cellPaddingInline,
        tablePaddingVerticalMiddle: cellPaddingBlockMD,
        tablePaddingHorizontalMiddle: cellPaddingInlineMD,
        tablePaddingVerticalSmall: cellPaddingBlockSM,
        tablePaddingHorizontalSmall: cellPaddingInlineSM,
        tableBorderColor: borderColor,
        tableHeaderTextColor: headerColor,
        tableHeaderBg: headerBg,
        tableFooterTextColor: footerColor,
        tableFooterBg: footerBg,
        tableHeaderCellSplitColor: headerSplitColor,
        tableHeaderSortBg: headerSortActiveBg,
        tableHeaderSortHoverBg: headerSortHoverBg,
        tableBodySortBg: bodySortBg,
        tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
        tableHeaderFilterActiveBg: headerFilterHoverBg,
        tableFilterDropdownBg: filterDropdownBg,
        tableRowHoverBg: rowHoverBg,
        tableSelectedRowBg: rowSelectedBg,
        tableSelectedRowHoverBg: rowSelectedHoverBg,
        zIndexTableFixed: $52ea1741590722c9$var$zIndexTableFixed,
        tableFontSizeMiddle: cellFontSizeMD,
        tableFontSizeSmall: cellFontSizeSM,
        tableSelectionColumnWidth: selectionColumnWidth,
        tableExpandIconBg: expandIconBg,
        tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
        tableExpandedRowBg: rowExpandedBg,
        // Dropdown
        tableFilterDropdownWidth: 120,
        tableFilterDropdownHeight: 264,
        tableFilterDropdownSearchWidth: 140,
        // Virtual Scroll Bar
        tableScrollThumbSize: 8,
        // Mac scroll bar size
        tableScrollThumbBg: stickyScrollBarBg,
        tableScrollThumbBgHover: colorTextHeading,
        tableScrollBg: colorSplit
    });
    return [
        $52ea1741590722c9$var$genTableStyle(tableToken),
        (0, $9a6bae14c3d282e3$export$2e2bcd8739ae039)(tableToken),
        (0, $9a56b0c2c027df00$export$2e2bcd8739ae039)(tableToken),
        (0, $6655b371bedfd634$export$2e2bcd8739ae039)(tableToken),
        (0, $da23b384be167274$export$2e2bcd8739ae039)(tableToken),
        (0, $b9b6fedf44f4f803$export$2e2bcd8739ae039)(tableToken),
        (0, $4773b3998487f976$export$2e2bcd8739ae039)(tableToken),
        (0, $8888c6f6420bf18d$export$2e2bcd8739ae039)(tableToken),
        (0, $9a56b0c2c027df00$export$2e2bcd8739ae039)(tableToken),
        (0, $2d5ebf15cfaf4644$export$2e2bcd8739ae039)(tableToken),
        (0, $ca6d152d3b6852e2$export$2e2bcd8739ae039)(tableToken),
        (0, $3bb78fceca3da582$export$2e2bcd8739ae039)(tableToken),
        (0, $994f7808639e9938$export$2e2bcd8739ae039)(tableToken),
        (0, $bce3bf4179f630c0$export$2e2bcd8739ae039)(tableToken),
        (0, $d7a83fe23e3255cb$export$2e2bcd8739ae039)(tableToken),
        (0, $5ed237fc7d94970f$export$2e2bcd8739ae039)(tableToken),
        (0, $f75ead9ff31bbaa9$export$2e2bcd8739ae039)(tableToken)
    ];
}, $52ea1741590722c9$export$9ca1be8807fe0675, {
    resetFont: false,
    unitless: {
        expandIconScale: true
    }
});



"use client";
const $bb02e87ac9998cdb$var$EMPTY_LIST = [];
const $bb02e87ac9998cdb$var$InternalTable = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, classNames: classNames, styles: styles, size: customizeSize, bordered: bordered, dropdownPrefixCls: customizeDropdownPrefixCls, dataSource: dataSource, pagination: pagination, rowSelection: customizeRowSelection, rowKey: customizeRowKey, rowClassName: rowClassName, columns: columns, children: children, childrenColumnName: legacyChildrenColumnName, onChange: onChange, getPopupContainer: getPopupContainer, loading: loading, expandIcon: expandIcon, expandable: expandable, expandedRowRender: expandedRowRender, expandIconColumnIndex: expandIconColumnIndex, indentSize: indentSize, scroll: scroll, sortDirections: sortDirections, locale: locale, showSorterTooltip: showSorterTooltip = {
        target: 'full-header'
    }, virtual: virtual } = props;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Table');
    const baseColumns = $acw62.useMemo(()=>columns || (0, $93048120da69385c$export$d87a97eba44e0f9c)(children), [
        columns,
        children
    ]);
    const needResponsive = $acw62.useMemo(()=>baseColumns.some((col)=>col.responsive), [
        baseColumns
    ]);
    const screens = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(needResponsive);
    const mergedColumns = $acw62.useMemo(()=>{
        const matched = new Set(Object.keys(screens).filter((m)=>screens[m]));
        return baseColumns.filter((c)=>!c.responsive || c.responsive.some((r)=>matched.has(r)));
    }, [
        baseColumns,
        screens
    ]);
    const tableProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(props, [
        'className',
        'style',
        'columns'
    ]);
    const { locale: contextLocale = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039), table: table } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, direction: direction, renderEmpty: renderEmpty, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('table');
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customizeSize === 'middle' ? 'medium' : customizeSize ?? ctx);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        pagination: {
            _default: 'root'
        },
        header: {
            _default: 'wrapper'
        },
        body: {
            _default: 'wrapper'
        }
    });
    const tableLocale = {
        ...contextLocale.Table,
        ...locale
    };
    const [globalLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('global', (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).global);
    const rawData = dataSource || $bb02e87ac9998cdb$var$EMPTY_LIST;
    const prefixCls = getPrefixCls('table', customizePrefixCls);
    const dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const mergedRowSelection = $acw62.useMemo(()=>{
        return (0, $b956dab96d0e505b$export$53b83ca8eaab0383)(customizeRowSelection) ? {
            columnWidth: token.Table?.selectionColumnWidth,
            ...customizeRowSelection
        } : customizeRowSelection;
    }, [
        customizeRowSelection,
        token.Table?.selectionColumnWidth
    ]);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $52ea1741590722c9$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedExpandable = {
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex,
        ...expandable,
        expandIcon: expandable?.expandIcon ?? table?.expandable?.expandIcon
    };
    const { childrenColumnName: childrenColumnName = 'children' } = mergedExpandable;
    const expandType = $acw62.useMemo(()=>{
        if (rawData.some((item)=>item?.[childrenColumnName])) return 'nest';
        if (expandedRowRender || expandable?.expandedRowRender) return 'row';
        return null;
    }, [
        childrenColumnName,
        rawData
    ]);
    const internalRef = {
        body: $acw62.useRef(null)
    };
    // ============================ Width =============================
    const getContainerWidth = (0, $2da82ee1b6da5550$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Refs =============================
    const rootRef = $acw62.useRef(null);
    const tblRef = $acw62.useRef(null);
    (0, $f0212a5d02e19b33$export$8edbe0145ad77a36)(ref, ()=>({
            ...tblRef.current,
            nativeElement: rootRef.current
        }));
    // ============================ RowKey ============================
    const rowKey = customizeRowKey || table?.rowKey || 'key';
    // ============================ Scroll ============================
    const mergedScroll = scroll ?? table?.scroll;
    const getRowKey = $acw62.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>record?.[rowKey];
    }, [
        rowKey
    ]);
    const [getRecordByKey] = (0, $e2770d04bc76b8cc$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey);
    // ============================ Events =============================
    const changeEventInfo = {};
    const triggerOnChange = (info, action, reset = false)=>{
        const changeInfo = {
            ...changeEventInfo,
            ...info
        };
        if (reset) {
            changeEventInfo.resetPagination?.();
            // Reset event param
            if (changeInfo.pagination?.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination) pagination.onChange?.(1, changeInfo.pagination?.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRef.body.current) (0, $4262b79604674a3c$export$2e2bcd8739ae039)(0, {
            getContainer: ()=>internalRef.body.current
        });
        onChange?.(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $498593f51893a533$export$37643bb40f4c1c56)((0, $71f5389ed963960f$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    const onSorterChange = (sorter, sorterStates)=>{
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = (0, $71f5389ed963960f$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip,
        globalLocale: globalLocale
    });
    const sortedData = $acw62.useMemo(()=>(0, $71f5389ed963960f$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName), [
        childrenColumnName,
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    const onFilterChange = (filters, filterStates)=>{
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    const [transformFilterColumns, filterStates, filters] = (0, $498593f51893a533$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        rootClassName: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(rootClassName, rootCls)
    });
    const mergedData = (0, $498593f51893a533$export$37643bb40f4c1c56)(sortedData, filterStates, childrenColumnName);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    const columnTitleProps = $acw62.useMemo(()=>{
        const mergedFilters = {};
        Object.keys(filters).forEach((filterKey)=>{
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return {
            ...sorterTitleProps,
            filters: mergedFilters
        };
    }, [
        sorterTitleProps,
        filters
    ]);
    const [transformTitleColumns] = (0, $6bcbe2fbe72fb80a$export$2e2bcd8739ae039)(columnTitleProps);
    // ========================== Pagination ==========================
    const onPaginationChange = (current, pageSize)=>{
        triggerOnChange({
            pagination: {
                ...changeEventInfo.pagination,
                current: current,
                pageSize: pageSize
            }
        }, 'paginate');
    };
    const [mergedPagination, resetPagination] = (0, $b37c5a68d8297fb7$export$2e2bcd8739ae039)(mergedData.length, onPaginationChange, pagination);
    changeEventInfo.pagination = pagination === false ? {} : (0, $b37c5a68d8297fb7$export$27eceeed7bf0f4c2)(mergedPagination, pagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    const pageData = $acw62.useMemo(()=>{
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        const { current: current = 1, total: total, pageSize: pageSize = (0, $b37c5a68d8297fb7$export$5716e8bcb003888d) } = mergedPagination;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination?.current,
        mergedPagination?.pageSize,
        mergedPagination?.total
    ]);
    // ========================== Selections ==========================
    const [transformSelectionColumns, selectedKeySet] = (0, $e201eb08b7050f4b$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer || getContextPopupContainer
    }, mergedRowSelection);
    const internalRowClassName = (record, index, indent)=>{
        const resolvedRowClassName = typeof rowClassName === 'function' ? rowClassName(record, index, indent) : rowClassName;
        return (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
            [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
        }, resolvedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `@rc-component/table`, this can be removed when refactor with `@rc-component/table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $8f25299cf0da5780$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = mergedRowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && mergedRowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = (0, $b956dab96d0e505b$export$7e4aa119212bc614)(indentSize) ? indentSize : 15;
    // ============================ Render ============================
    const transformColumns = $acw62.useCallback((innerColumns)=>transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    let topPaginationNode;
    let bottomPaginationNode;
    if (pagination !== false && mergedPagination?.total) {
        let paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'medium' ? 'small' : undefined;
        const renderPagination = (placement = 'end')=>/*#__PURE__*/ $acw62.createElement((0, $457c0f7bc166788c$export$2e2bcd8739ae039), {
                ...mergedPagination,
                classNames: mergedClassNames.pagination,
                styles: mergedStyles.pagination,
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-pagination ${prefixCls}-pagination-${placement}`, mergedPagination.className),
                size: paginationSize
            });
        const { placement: placement, position: position } = mergedPagination;
        const mergedPlacement = placement ?? position;
        const normalizePlacement = (pos)=>{
            const lowerPos = pos.toLowerCase();
            if (lowerPos.includes('center')) return 'center';
            return lowerPos.includes('left') || lowerPos.includes('start') ? 'start' : 'end';
        };
        if (Array.isArray(mergedPlacement)) {
            const [topPos, bottomPos] = [
                'top',
                'bottom'
            ].map((dir)=>mergedPlacement.find((p)=>p.includes(dir)));
            const isDisable = mergedPlacement.every((p)=>`${p}` === 'none');
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination();
            if (topPos) topPaginationNode = renderPagination(normalizePlacement(topPos));
            if (bottomPos) bottomPaginationNode = renderPagination(normalizePlacement(bottomPos));
        } else bottomPaginationNode = renderPagination();
    }
    // >>>>>>>>> Spinning
    const spinProps = $acw62.useMemo(()=>{
        if (typeof loading === 'boolean') return {
            spinning: loading
        };
        else if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(loading)) return {
            spinning: true,
            ...loading
        };
        else return undefined;
    }, [
        loading
    ]);
    const wrappercls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(cssVarCls, rootCls, `${prefixCls}-wrapper`, contextClassName, {
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl'
    }, className, rootClassName, mergedClassNames.root, hashId);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    // ========== empty ==========
    const mergedEmptyNode = $acw62.useMemo(()=>{
        // When dataSource is null/undefined (detected by reference equality with EMPTY_LIST),
        // and the table is in a loading state, we only show the loading spinner without the empty placeholder.
        // For empty arrays (datasource={[]}), both loading and empty states would normally be shown.
        // discussion https://github.com/ant-design/ant-design/issues/54601#issuecomment-3158091383
        if (spinProps?.spinning && rawData === $bb02e87ac9998cdb$var$EMPTY_LIST) return null;
        if (typeof locale?.emptyText !== 'undefined') return locale.emptyText;
        return renderEmpty?.('Table') || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
            componentName: "Table"
        });
    }, [
        spinProps?.spinning,
        rawData,
        locale?.emptyText,
        renderEmpty
    ]);
    // ========================== Render ==========================
    const TableComponent = virtual ? (0, $18bcd07e79dcd06c$export$2e2bcd8739ae039) : (0, $5ea5ba4b4caafc13$export$2e2bcd8739ae039);
    // >>> Virtual Table props. We set height here since it will affect height collection
    const virtualProps = {};
    const listItemHeight = $acw62.useMemo(()=>{
        const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, padding: padding, paddingXS: paddingXS, paddingSM: paddingSM } = token;
        const fontHeight = Math.floor(fontSize * lineHeight);
        switch(mergedSize){
            case 'medium':
                return paddingSM * 2 + fontHeight + lineWidth;
            case 'small':
                return paddingXS * 2 + fontHeight + lineWidth;
            default:
                return padding * 2 + fontHeight + lineWidth;
        }
    }, [
        token,
        mergedSize
    ]);
    if (virtual) virtualProps.listItemHeight = listItemHeight;
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: rootRef,
        className: wrappercls,
        style: mergedStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {
        spinning: false,
        ...spinProps
    }, topPaginationNode, /*#__PURE__*/ $acw62.createElement(TableComponent, {
        ...virtualProps,
        ...tableProps,
        scroll: mergedScroll,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ref: tblRef,
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
            [`${prefixCls}-medium`]: mergedSize === 'medium',
            [`${prefixCls}-small`]: mergedSize === 'small',
            [`${prefixCls}-bordered`]: bordered,
            [`${prefixCls}-empty`]: rawData.length === 0
        }, cssVarCls, rootCls, hashId),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: mergedEmptyNode,
        // Internal
        internalHooks: (0, $3b2a2eb42115b4e5$export$91b75cf262680225),
        internalRefs: internalRef,
        transformColumns: transformColumns,
        getContainerWidth: getContainerWidth,
        measureRowRender: (measureRow)=>/*#__PURE__*/ $acw62.createElement((0, $0294edcb7fd2dbc1$export$2e2bcd8739ae039).Provider, {
                value: true
            }, /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                getPopupContainer: (node)=>node
            }, measureRow))
    }), bottomPaginationNode));
};
var $bb02e87ac9998cdb$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($bb02e87ac9998cdb$var$InternalTable);


"use client";
const $57b3d2664e78424f$var$Table = (props, ref)=>{
    const renderTimesRef = $acw62.useRef(0);
    renderTimesRef.current += 1;
    return /*#__PURE__*/ $acw62.createElement((0, $bb02e87ac9998cdb$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        _renderTimes: renderTimesRef.current
    });
};
const $57b3d2664e78424f$var$ForwardTable = /*#__PURE__*/ $acw62.forwardRef($57b3d2664e78424f$var$Table);
$57b3d2664e78424f$var$ForwardTable.SELECTION_COLUMN = (0, $e201eb08b7050f4b$export$ed10248435b8f218);
$57b3d2664e78424f$var$ForwardTable.EXPAND_COLUMN = (0, $3b2a2eb42115b4e5$export$e1053575ddfcb301);
$57b3d2664e78424f$var$ForwardTable.SELECTION_ALL = (0, $e201eb08b7050f4b$export$14159cd9e2a500c8);
$57b3d2664e78424f$var$ForwardTable.SELECTION_INVERT = (0, $e201eb08b7050f4b$export$625c4f68eaaf8cfd);
$57b3d2664e78424f$var$ForwardTable.SELECTION_NONE = (0, $e201eb08b7050f4b$export$c1a725540f5a63bd);
$57b3d2664e78424f$var$ForwardTable.Column = (0, $fad2a96b4c8bbab5$export$2e2bcd8739ae039);
$57b3d2664e78424f$var$ForwardTable.ColumnGroup = (0, $836a2b733f2d0243$export$2e2bcd8739ae039);
$57b3d2664e78424f$var$ForwardTable.Summary = (0, $40f6b4085cce6d6d$export$d605f3af09eef683);
var $57b3d2664e78424f$export$2e2bcd8739ae039 = $57b3d2664e78424f$var$ForwardTable;


"use client";
var $de80f58eedfd6ef7$export$2e2bcd8739ae039 = (0, $57b3d2664e78424f$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






"use client";
const $91e86e8e8e97dd3f$export$51ad9c30389f050b = (context)=>{
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
};
const $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection = {};
const $91e86e8e8e97dd3f$var$computeClosableConfig = (closable, closeIcon)=>{
    if (!closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
    if (closable === undefined && closeIcon === undefined) return null;
    let closableConfig = {
        closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
    };
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(closable)) closableConfig = {
        ...closableConfig,
        ...closable
    };
    return closableConfig;
};
const $91e86e8e8e97dd3f$var$mergeClosableConfigs = (propConfig, contextConfig, fallbackConfig)=>{
    if (propConfig === false) return false;
    if (propConfig) return (0, $be673cd5391dca21$export$2e2bcd8739ae039)(fallbackConfig, contextConfig, propConfig);
    if (contextConfig === false) return false;
    if (contextConfig) return (0, $be673cd5391dca21$export$2e2bcd8739ae039)(fallbackConfig, contextConfig);
    return fallbackConfig.closable ? fallbackConfig : false;
};
const $91e86e8e8e97dd3f$var$computeCloseIcon = (mergedConfig, fallbackCloseCollection, closeLabel)=>{
    const { closeIconRender: closeIconRender } = fallbackCloseCollection;
    const { closeIcon: closeIcon, ...restConfig } = mergedConfig;
    let finalCloseIcon = closeIcon;
    const ariaOrDataProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(restConfig, true);
    if ((0, $b956dab96d0e505b$export$826fff653a329e83)(finalCloseIcon)) {
        if (closeIconRender) finalCloseIcon = closeIconRender(finalCloseIcon);
        finalCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(finalCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(finalCloseIcon, {
            'aria-label': closeLabel,
            ...finalCloseIcon.props,
            ...ariaOrDataProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-label": closeLabel,
            ...ariaOrDataProps
        }, finalCloseIcon);
    }
    return [
        finalCloseIcon,
        ariaOrDataProps
    ];
};
const $91e86e8e8e97dd3f$export$41ed0597a5c42f8 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection, closeLabel = 'Close')=>{
    const propConfig = $91e86e8e8e97dd3f$var$computeClosableConfig(propCloseCollection?.closable, propCloseCollection?.closeIcon);
    const contextConfig = $91e86e8e8e97dd3f$var$computeClosableConfig(contextCloseCollection?.closable, contextCloseCollection?.closeIcon);
    const mergedFallback = {
        closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null),
        ...fallbackCloseCollection
    };
    const mergedConfig = $91e86e8e8e97dd3f$var$mergeClosableConfigs(propConfig, contextConfig, mergedFallback);
    const closeBtnIsDisabled = typeof mergedConfig !== 'boolean' ? !!mergedConfig?.disabled : false;
    if (mergedConfig === false) return [
        false,
        null,
        closeBtnIsDisabled,
        {}
    ];
    const [closeIcon, ariaProps] = $91e86e8e8e97dd3f$var$computeCloseIcon(mergedConfig, mergedFallback, closeLabel);
    return [
        true,
        closeIcon,
        closeBtnIsDisabled,
        ariaProps
    ];
};
const $91e86e8e8e97dd3f$export$aa101db403ccf5f3 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection)=>{
    const [contextLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('global', (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).global);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return $91e86e8e8e97dd3f$export$41ed0597a5c42f8(propCloseCollection, contextCloseCollection, {
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null),
            ...fallbackCloseCollection
        }, contextLocale.close);
    }, [
        propCloseCollection,
        contextCloseCollection,
        fallbackCloseCollection,
        contextLocale.close
    ]);
};









var $acw62 = parcelRequire("acw62");









// ============================== Styles ==============================
const $bd814ea00a1f65a8$var$genBaseStyle = (token)=>{
    const { paddingXXS: paddingXXS, lineWidth: lineWidth, tagPaddingHorizontal: tagPaddingHorizontal, componentCls: componentCls, calc: calc } = token;
    const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    return {
        // Result
        [componentCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            height: 'auto',
            paddingInline: paddingInline,
            fontSize: token.tagFontSize,
            lineHeight: token.tagLineHeight,
            whiteSpace: 'nowrap',
            backgroundColor: token.defaultBg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: token.borderRadiusSM,
            opacity: 1,
            transition: `all ${token.motionDurationMid}`,
            textAlign: 'start',
            position: 'relative',
            // RTL
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            '&, a, a:hover': {
                color: token.defaultColor
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: iconMarginInline,
                fontSize: token.tagIconSize,
                color: token.colorIcon,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}`,
                '&:hover': {
                    color: token.colorTextHeading
                }
            },
            '&-checkable': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                cursor: 'pointer',
                [`&:not(${componentCls}-checkable-checked):hover`]: {
                    color: token.colorPrimary,
                    backgroundColor: token.colorFillSecondary
                },
                '&:active, &-checked': {
                    color: token.colorTextLightSolid
                },
                '&-checked': {
                    backgroundColor: token.colorPrimary,
                    '&:hover': {
                        backgroundColor: token.colorPrimaryHover
                    }
                },
                '&:active': {
                    backgroundColor: token.colorPrimaryActive
                },
                '&-disabled': {
                    cursor: 'not-allowed',
                    [`&:not(${componentCls}-checkable-checked)`]: {
                        color: token.colorTextDisabled,
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    },
                    [`&${componentCls}-checkable-checked`]: {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled
                    },
                    '&:hover, &:active': {
                        backgroundColor: token.colorBgContainerDisabled,
                        color: token.colorTextDisabled
                    },
                    [`&:not(${componentCls}-checkable-checked):hover`]: {
                        color: token.colorTextDisabled
                    }
                },
                '&-group': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: token.paddingXS
                }
            },
            '&-hidden': {
                display: 'none'
            },
            // To ensure that a space will be placed between character and `Icon`.
            [`> ${token.iconCls} + span, > span + ${token.iconCls}`]: {
                marginInlineStart: paddingInline
            }
        },
        [`&${token.componentCls}-solid`]: {
            borderColor: 'transparent',
            color: token.colorTextLightSolid,
            backgroundColor: token.colorBgSolid,
            [`&${componentCls}-default`]: {
                color: token.solidTextColor
            }
        },
        [`${componentCls}-filled`]: {
            borderColor: 'transparent',
            backgroundColor: token.tagBorderlessBg
        },
        [`&${componentCls}-disabled`]: {
            color: token.colorTextDisabled,
            cursor: 'not-allowed',
            backgroundColor: token.colorBgContainerDisabled,
            a: {
                cursor: 'not-allowed',
                pointerEvents: 'none',
                color: token.colorTextDisabled,
                '&:hover': {
                    color: token.colorTextDisabled
                }
            },
            'a&': {
                '&:hover, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`&${componentCls}-outlined`]: {
                borderColor: token.colorBorderDisabled
            },
            [`&${componentCls}-solid, &${componentCls}-filled`]: {
                color: token.colorTextDisabled,
                [`${componentCls}-close-icon`]: {
                    color: token.colorTextDisabled
                }
            },
            [`${componentCls}-close-icon`]: {
                cursor: 'not-allowed',
                color: token.colorTextDisabled,
                '&:hover': {
                    color: token.colorTextDisabled
                }
            }
        }
    };
};
const $bd814ea00a1f65a8$export$362fb92a8f81bbf9 = (token)=>{
    const { lineWidth: lineWidth, fontSizeIcon: fontSizeIcon, calc: calc } = token;
    const tagFontSize = token.fontSizeSM;
    const tagToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.defaultBg
    });
    return tagToken;
};
const $bd814ea00a1f65a8$export$9ca1be8807fe0675 = (token)=>{
    const solidTextColor = (0, $d5221672d26ff0b4$export$6341b37cb79161da)(new (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    return {
        defaultBg: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(token.colorFillTertiary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText,
        solidTextColor: solidTextColor
    };
};
var $bd814ea00a1f65a8$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Tag', (token)=>{
    const tagToken = $bd814ea00a1f65a8$export$362fb92a8f81bbf9(token);
    return $bd814ea00a1f65a8$var$genBaseStyle(tagToken);
}, $bd814ea00a1f65a8$export$9ca1be8807fe0675);


"use client";
const $8aa648d8fa6484b7$var$CheckableTag = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, checked: checked, children: children, icon: icon, onChange: onChange, onClick: onClick, disabled: customDisabled, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, tag: tag } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const handleClick = (e)=>{
        if (mergedDisabled) return;
        onChange?.(!checked);
        onClick?.(e);
    };
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $bd814ea00a1f65a8$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked,
        [`${prefixCls}-checkable-disabled`]: mergedDisabled
    }, tag?.className, className, hashId, cssVarCls);
    return /*#__PURE__*/ $acw62.createElement("span", {
        ...restProps,
        ref: ref,
        style: {
            ...style,
            ...tag?.style
        },
        className: cls,
        onClick: handleClick
    }, icon, /*#__PURE__*/ $acw62.createElement("span", null, children));
});
var $8aa648d8fa6484b7$export$2e2bcd8739ae039 = $8aa648d8fa6484b7$var$CheckableTag;




var $acw62 = parcelRequire("acw62");









"use client";
const $aa0b60a9dd7f4ba3$var$CheckableTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { id: id, prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, classNames: classNames, styles: styles, disabled: disabled, options: options, value: value, defaultValue: defaultValue, onChange: onChange, multiple: multiple, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('tag');
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-checkable-group`;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $bd814ea00a1f65a8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ====================== Styles ======================
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    // =============================== Option ===============================
    const parsedOptions = (0, $acw62.useMemo)(()=>{
        if (!Array.isArray(options)) return [];
        return options.map((option)=>{
            if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(option)) return option;
            return {
                value: option,
                label: option
            };
        });
    }, [
        options
    ]);
    // =============================== Values ===============================
    const [mergedValue, setMergedValue] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(defaultValue, value);
    const handleChange = (checked, option)=>{
        let newValue = null;
        if (multiple) {
            const valueList = mergedValue || [];
            newValue = checked ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(valueList), [
                option.value
            ]) : valueList.filter((item)=>item !== option.value);
        } else newValue = checked ? option.value : null;
        setMergedValue(newValue);
        onChange?.(newValue); // TS not support generic type in function call
    };
    // ================================ Refs ================================
    const divRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            nativeElement: divRef.current
        }));
    // ================================ ARIA ================================
    const ariaProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true
    });
    // =============================== Render ===============================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...ariaProps,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(groupPrefixCls, contextClassName, rootClassName, {
            [`${groupPrefixCls}-disabled`]: disabled,
            [`${groupPrefixCls}-rtl`]: direction === 'rtl'
        }, hashId, cssVarCls, className, mergedClassNames.root),
        style: {
            ...contextStyle,
            ...mergedStyles.root,
            ...style
        },
        id: id,
        ref: divRef
    }, parsedOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8aa648d8fa6484b7$export$2e2bcd8739ae039), {
            key: option.value,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, mergedClassNames.item),
            style: mergedStyles.item,
            checked: multiple ? (mergedValue || []).includes(option.value) : mergedValue === option.value,
            onChange: (checked)=>handleChange(checked, option),
            disabled: disabled
        }, option.label)));
});
var $aa0b60a9dd7f4ba3$export$2e2bcd8739ae039 = $aa0b60a9dd7f4ba3$var$CheckableTagGroup;



var $acw62 = parcelRequire("acw62");


function $c75eac757abb41fb$export$2e2bcd8739ae039(props, contextVariant) {
    const { color: color, variant: variant, bordered: bordered } = props;
    return $acw62.useMemo(()=>{
        const isInverseColor = color?.endsWith('-inverse');
        // =================== Variant ===================
        let nextVariant;
        if (variant) // `variant` first
        nextVariant = variant;
        else if (isInverseColor) // Fallback if using inverse color
        nextVariant = 'solid';
        else if (bordered === false) // Fallback if using filled
        nextVariant = 'filled';
        else // Finally not conflict, use context
        nextVariant = contextVariant || 'filled';
        // ==================== Color ====================
        const nextColor = isInverseColor ? color?.replace('-inverse', '') : color;
        // =============== Preset & Status ===============
        const nextIsPreset = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color);
        const nextIsStatus = (0, $1513ceb924eda9b6$export$88a0ba1f7d1ea40e)(color);
        // ================== Customize ==================
        // When `color` is not preset color,
        // dynamic calculate the color pair.
        const tagStyle = {};
        if (!nextIsPreset && !nextIsStatus && nextColor) {
            if (nextVariant === 'solid') tagStyle.backgroundColor = color;
            else {
                const hsl = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(nextColor).toHsl();
                hsl.l = 0.95;
                tagStyle.backgroundColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(hsl).toHexString();
                tagStyle.color = color;
                if (nextVariant === 'outlined') tagStyle.borderColor = color;
            }
        }
        return [
            nextVariant,
            nextColor,
            nextIsPreset,
            nextIsStatus,
            tagStyle
        ];
    }, [
        color,
        variant,
        bordered,
        contextVariant
    ]);
}



// Style as status component


// ============================== Preset ==============================
const $1261c8cdaed9abdc$var$genPresetStyle = (token)=>(0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, { textColor: textColor, lightBorderColor: lightBorderColor, lightColor: lightColor, darkColor: darkColor })=>({
            [`${token.componentCls}${token.componentCls}-${colorKey}:not(${token.componentCls}-disabled)`]: {
                [`&${token.componentCls}-outlined`]: {
                    backgroundColor: lightColor,
                    borderColor: lightBorderColor,
                    color: textColor
                },
                [`&${token.componentCls}-solid`]: {
                    backgroundColor: darkColor,
                    borderColor: darkColor,
                    color: token.colorTextLightSolid
                },
                [`&${token.componentCls}-filled`]: {
                    backgroundColor: lightColor,
                    color: textColor
                }
            }
        }));
var // ============================== Export ==============================
$1261c8cdaed9abdc$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Tag',
    'preset'
], (token)=>{
    const tagToken = (0, $bd814ea00a1f65a8$export$362fb92a8f81bbf9)(token);
    return $1261c8cdaed9abdc$var$genPresetStyle(tagToken);
}, (0, $bd814ea00a1f65a8$export$9ca1be8807fe0675));



function $95190870cfa49bfc$export$2e2bcd8739ae039(str) {
    if (typeof str !== 'string') return str;
    const ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}



const $11969e51a90dd42b$var$genTagStatusStyle = (token, status, cssVariableType)=>{
    const capitalizedCssVariableType = (0, $95190870cfa49bfc$export$2e2bcd8739ae039)(cssVariableType);
    return {
        [`${token.componentCls}${token.componentCls}-${status}:not(${token.componentCls}-disabled)`]: {
            [`&${token.componentCls}-outlined`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                borderColor: token[`color${capitalizedCssVariableType}Border`],
                color: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-solid`]: {
                backgroundColor: token[`color${cssVariableType}`],
                borderColor: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-filled`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                color: token[`color${cssVariableType}`]
            }
        }
    };
};
var // ============================== Export ==============================
$11969e51a90dd42b$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Tag',
    'status'
], (token)=>{
    const tagToken = (0, $bd814ea00a1f65a8$export$362fb92a8f81bbf9)(token);
    return [
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'success', 'Success'),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'processing', 'Info'),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'error', 'Error'),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'warning', 'Warning')
    ];
}, (0, $bd814ea00a1f65a8$export$9ca1be8807fe0675));


"use client";
const $91f0876852f6510f$var$InternalTag = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, children: children, icon: icon, color: color, variant: _variant, onClose: onClose, bordered: bordered, disabled: customDisabled, href: href, target: target, styles: styles, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, variant: contextVariant, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('tag');
    // ====================== Colors ======================
    const [mergedVariant, mergedColor, isPreset, isStatus, customTagStyle] = (0, $c75eac757abb41fb$export$2e2bcd8739ae039)(props, contextVariant);
    const isInternalColor = isPreset || isStatus;
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const { tag: tagContext } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [visible, setVisible] = $acw62.useState(true);
    const domProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, [
        'closeIcon',
        'closable'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        color: mergedColor,
        variant: mergedVariant,
        disabled: mergedDisabled
    };
    // ====================== Styles ======================
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const tagStyle = $acw62.useMemo(()=>{
        let nextTagStyle = {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        };
        if (!mergedDisabled) nextTagStyle = {
            ...customTagStyle,
            ...nextTagStyle
        };
        return nextTagStyle;
    }, [
        mergedStyles.root,
        contextStyle,
        style,
        customTagStyle,
        mergedDisabled
    ]);
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bd814ea00a1f65a8$export$2e2bcd8739ae039)(prefixCls);
    const tagClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, contextClassName, mergedClassNames.root, `${prefixCls}-${mergedVariant}`, {
        [`${prefixCls}-${mergedColor}`]: isInternalColor,
        [`${prefixCls}-hidden`]: !visible,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-disabled`]: mergedDisabled
    }, className, rootClassName, hashId, cssVarCls);
    // ===================== Closable =====================
    const handleCloseClick = (e)=>{
        if (mergedDisabled) return;
        e.stopPropagation();
        onClose?.(e);
        if (e.defaultPrevented) return;
        setVisible(false);
    };
    const [, mergedCloseIcon] = (0, $91e86e8e8e97dd3f$export$aa101db403ccf5f3)((0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(props), (0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(tagContext), {
        closable: false,
        closeIconRender: (iconNode)=>{
            const replacement = /*#__PURE__*/ $acw62.createElement("span", {
                className: `${prefixCls}-close-icon`,
                onClick: handleCloseClick
            }, iconNode);
            return (0, $30796c32f374b477$export$2dfe578f95754f6a)(iconNode, replacement, (originProps)=>({
                    onClick: (e)=>{
                        originProps?.onClick?.(e);
                        handleCloseClick(e);
                    },
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(originProps?.className, `${prefixCls}-close-icon`)
                }));
        }
    });
    // ====================== Render ======================
    const isNeedWave = typeof restProps.onClick === 'function' || children && children.type === 'a';
    const iconNode = (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(/*#__PURE__*/ $acw62.isValidElement(icon) ? icon.props?.className : undefined, mergedClassNames.icon),
        style: mergedStyles.icon
    });
    const child = iconNode ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, iconNode, children && /*#__PURE__*/ $acw62.createElement("span", {
        className: mergedClassNames.content,
        style: mergedStyles.content
    }, children)) : children;
    const TagWrapper = href ? 'a' : 'span';
    const tagNode = /*#__PURE__*/ $acw62.createElement(TagWrapper, {
        ...domProps,
        // @ts-expect-error
        ref: ref,
        className: tagClassName,
        style: tagStyle,
        href: mergedDisabled ? undefined : href,
        target: target,
        onClick: mergedDisabled ? undefined : domProps.onClick,
        ...href && mergedDisabled ? {
            'aria-disabled': true
        } : {}
    }, child, mergedCloseIcon, isPreset && /*#__PURE__*/ $acw62.createElement((0, $1261c8cdaed9abdc$export$2e2bcd8739ae039), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $acw62.createElement((0, $11969e51a90dd42b$export$2e2bcd8739ae039), {
        key: "status",
        prefixCls: prefixCls
    }));
    return isNeedWave ? /*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Tag"
    }, tagNode) : tagNode;
});
const $91f0876852f6510f$var$Tag = $91f0876852f6510f$var$InternalTag;
$91f0876852f6510f$var$Tag.CheckableTag = (0, $8aa648d8fa6484b7$export$2e2bcd8739ae039);
$91f0876852f6510f$var$Tag.CheckableTagGroup = (0, $aa0b60a9dd7f4ba3$export$2e2bcd8739ae039);
var $91f0876852f6510f$export$2e2bcd8739ae039 = $91f0876852f6510f$var$Tag;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $c39b69cd10e6bfc9$export$9d62369235ef5d5a(func) {
    const ref = (0, $acw62.useRef)(null);
    if (!ref.current) ref.current = {
        callee: func,
        caller: function() {
            return ref.current.callee.apply(this, arguments);
        }
    };
    ref.current.callee = func;
    return ref.current.caller;
}


const $7fe116ddba5bf8b9$export$52e83573e7782585 = async ({ url: url, params: params, ...restParams })=>{
    const method = restParams.method ?? "GET";
    const needRequestBody = method !== "GET" && Boolean(params);
    const needQueryParams = method === "GET" && Boolean(params);
    const headers = {};
    if (needRequestBody) headers["Content-Type"] = "application/json";
    const response = await fetch(`api/${url}${needQueryParams ? `?${new URLSearchParams(params)}` : ""}`, {
        method: method ?? "GET",
        headers: headers,
        body: needRequestBody ? JSON.stringify(params) : undefined
    });
    return response.json();
};


const $bdf8720a025ab42f$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $bdf8720a025ab42f$export$b8bc32887f2499dc = ()=>{
    let [filters, setFilters] = (0, $acw62.useState)({});
    let [requests, setRequests] = (0, $acw62.useState)([]);
    const loadData = (0, $c39b69cd10e6bfc9$export$9d62369235ef5d5a)(async ()=>{
        const data = await (0, $7fe116ddba5bf8b9$export$52e83573e7782585)({
            url: "logs",
            params: filters
        });
        setRequests(data.logs);
    });
    let stopped = false;
    const startLoadingData = async ()=>{
        while(!stopped){
            try {
                await loadData();
            } catch (e) {}
            await $bdf8720a025ab42f$var$sleep(500);
        }
    };
    (0, $acw62.useEffect)(()=>{
        startLoadingData();
        return ()=>{
            stopped = true;
        };
    }, []);
    const onChangeSearch = (newSearch)=>{
        setFilters({
            ...filters,
            search: newSearch
        });
    };
    return {
        requests: requests,
        onChangeSearch: onChangeSearch
    };
};


var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");








const $efd2c765531bad84$var$DEFAULT_COLUMN_MAP = {
    xxxl: 4,
    xxl: 3,
    xl: 3,
    lg: 3,
    md: 3,
    sm: 2,
    xs: 1
};
var $efd2c765531bad84$export$2e2bcd8739ae039 = $efd2c765531bad84$var$DEFAULT_COLUMN_MAP;



var $acw62 = parcelRequire("acw62");
const $909a446c3c56ff9d$var$DescriptionsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $909a446c3c56ff9d$export$2e2bcd8739ae039 = $909a446c3c56ff9d$var$DescriptionsContext;



var $acw62 = parcelRequire("acw62");



// Convert children into items
const $181a720a416959be$var$transChildren2Items = (childNodes)=>(0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(childNodes).map((node)=>({
            ...node?.props,
            key: node.key
        }));
function $181a720a416959be$export$2e2bcd8739ae039(screens, items, children) {
    const mergedItems = $acw62.useMemo(()=>// Take `items` first or convert `children` into items
        items || $181a720a416959be$var$transChildren2Items(children), [
        items,
        children
    ]);
    const responsiveItems = $acw62.useMemo(()=>mergedItems.map(({ span: span, ...restItem })=>{
            if (span === 'filled') return {
                ...restItem,
                filled: true
            };
            return {
                ...restItem,
                span: (0, $b956dab96d0e505b$export$7e4aa119212bc614)(span) ? span : (0, $36689cb123f552b0$export$862220c15691d248)(screens, span)
            };
        }), [
        mergedItems,
        screens
    ]);
    return responsiveItems;
}



var $acw62 = parcelRequire("acw62");

// Calculate the sum of span in a row
function $7fc9cecb8c4b4adf$var$getCalcRows(rowItems, mergedColumn) {
    let rows = [];
    let tmpRow = [];
    let exceed = false;
    let count = 0;
    rowItems.filter((n)=>n).forEach((rowItem)=>{
        const { filled: filled, ...restItem } = rowItem;
        if (filled) {
            tmpRow.push(restItem);
            rows.push(tmpRow);
            // reset
            tmpRow = [];
            count = 0;
            return;
        }
        const restSpan = mergedColumn - count;
        count += rowItem.span || 1;
        if (count >= mergedColumn) {
            if (count > mergedColumn) {
                exceed = true;
                tmpRow.push({
                    ...restItem,
                    span: restSpan
                });
            } else tmpRow.push(restItem);
            rows.push(tmpRow);
            // reset
            tmpRow = [];
            count = 0;
        } else tmpRow.push(restItem);
    });
    if (tmpRow.length > 0) rows.push(tmpRow);
    rows = rows.map((rows)=>{
        const count = rows.reduce((acc, item)=>acc + (item.span || 1), 0);
        if (count < mergedColumn) {
            // If the span of the last element in the current row is less than the column, then add its span to the remaining columns
            const last = rows[rows.length - 1];
            last.span = mergedColumn - (count - (last.span || 1));
            return rows;
        }
        return rows;
    });
    return [
        rows,
        exceed
    ];
}
const $7fc9cecb8c4b4adf$var$useRow = (mergedColumn, items)=>{
    const [rows, exceed] = (0, $acw62.useMemo)(()=>$7fc9cecb8c4b4adf$var$getCalcRows(items, mergedColumn), [
        items,
        mergedColumn
    ]);
    return rows;
};
var $7fc9cecb8c4b4adf$export$2e2bcd8739ae039 = $7fc9cecb8c4b4adf$var$useRow;


// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */ const $eb778ea7e6553a20$var$DescriptionsItem = (props)=>{
    return props.children;
};
var $eb778ea7e6553a20$export$2e2bcd8739ae039 = $eb778ea7e6553a20$var$DescriptionsItem;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




"use client";
const $fb5584ec88b60ddc$var$Cell = (props)=>{
    const { itemPrefixCls: itemPrefixCls, component: component, span: span, className: className, style: style, labelStyle: labelStyle, contentStyle: contentStyle, bordered: bordered, label: label, content: content, colon: colon, type: type, styles: styles, classNames: classNames } = props;
    const Component = component;
    const { classNames: contextClassNames, styles: contextStyles } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $909a446c3c56ff9d$export$2e2bcd8739ae039));
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const mergedLabelStyle = {
        ...labelStyle,
        ...mergedStyles.label
    };
    const mergedContentStyle = {
        ...contentStyle,
        ...mergedStyles.content
    };
    if (bordered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
        colSpan: span,
        style: style,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, {
            [`${itemPrefixCls}-item-${type}`]: type === 'label' || type === 'content',
            [mergedClassNames.label]: mergedClassNames.label && type === 'label',
            [mergedClassNames.content]: mergedClassNames.content && type === 'content'
        })
    }, (0, $b956dab96d0e505b$export$826fff653a329e83)(label) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: mergedLabelStyle
    }, label), (0, $b956dab96d0e505b$export$826fff653a329e83)(content) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: mergedContentStyle
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${itemPrefixCls}-item`, className),
        style: style,
        colSpan: span
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${itemPrefixCls}-item-container`
    }, (0, $b956dab96d0e505b$export$826fff653a329e83)(label) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: mergedLabelStyle,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${itemPrefixCls}-item-label`, mergedClassNames.label, {
            [`${itemPrefixCls}-item-no-colon`]: !colon
        })
    }, label), (0, $b956dab96d0e505b$export$826fff653a329e83)(content) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: mergedContentStyle,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${itemPrefixCls}-item-content`, mergedClassNames.content)
    }, content)));
};
var $fb5584ec88b60ddc$export$2e2bcd8739ae039 = $fb5584ec88b60ddc$var$Cell;



"use client";
function $c1b29817ab2187ca$var$renderCells(items, { colon: colon, prefixCls: prefixCls, bordered: bordered }, { component: component, type: type, showLabel: showLabel, showContent: showContent, labelStyle: rootLabelStyle, contentStyle: rootContentStyle, styles: rootStyles }) {
    return items.map(({ label: label, children: children, prefixCls: itemPrefixCls = prefixCls, className: className, style: style, labelStyle: labelStyle, contentStyle: contentStyle, span: span = 1, key: key, styles: styles, classNames: classNames }, index)=>{
        if (typeof component === 'string') return /*#__PURE__*/ $acw62.createElement((0, $fb5584ec88b60ddc$export$2e2bcd8739ae039), {
            key: `${type}-${key || index}`,
            className: className,
            style: style,
            classNames: classNames,
            styles: {
                label: {
                    ...rootLabelStyle,
                    ...rootStyles?.label,
                    ...labelStyle,
                    ...styles?.label
                },
                content: {
                    ...rootContentStyle,
                    ...rootStyles?.content,
                    ...contentStyle,
                    ...styles?.content
                }
            },
            span: span,
            colon: colon,
            component: component,
            itemPrefixCls: itemPrefixCls,
            bordered: bordered,
            label: showLabel ? label : null,
            content: showContent ? children : null,
            type: type
        });
        return [
            /*#__PURE__*/ $acw62.createElement((0, $fb5584ec88b60ddc$export$2e2bcd8739ae039), {
                key: `label-${key || index}`,
                className: className,
                style: {
                    ...rootLabelStyle,
                    ...rootStyles?.label,
                    ...style,
                    ...labelStyle,
                    ...styles?.label
                },
                span: 1,
                colon: colon,
                component: component[0],
                itemPrefixCls: itemPrefixCls,
                bordered: bordered,
                label: label,
                type: "label"
            }),
            /*#__PURE__*/ $acw62.createElement((0, $fb5584ec88b60ddc$export$2e2bcd8739ae039), {
                key: `content-${key || index}`,
                className: className,
                style: {
                    ...rootContentStyle,
                    ...rootStyles?.content,
                    ...style,
                    ...contentStyle,
                    ...styles?.content
                },
                span: span * 2 - 1,
                component: component[1],
                itemPrefixCls: itemPrefixCls,
                bordered: bordered,
                content: children,
                type: "content"
            })
        ];
    });
}
const $c1b29817ab2187ca$var$Row = (props)=>{
    const descContext = $acw62.useContext((0, $909a446c3c56ff9d$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, vertical: vertical, row: row, index: index, bordered: bordered } = props;
    if (vertical) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("tr", {
        key: `label-${index}`,
        className: `${prefixCls}-row`
    }, $c1b29817ab2187ca$var$renderCells(row, props, {
        component: 'th',
        type: 'label',
        showLabel: true,
        ...descContext
    })), /*#__PURE__*/ $acw62.createElement("tr", {
        key: `content-${index}`,
        className: `${prefixCls}-row`
    }, $c1b29817ab2187ca$var$renderCells(row, props, {
        component: 'td',
        type: 'content',
        showContent: true,
        ...descContext
    })));
    return /*#__PURE__*/ $acw62.createElement("tr", {
        key: index,
        className: `${prefixCls}-row`
    }, $c1b29817ab2187ca$var$renderCells(row, props, {
        component: bordered ? [
            'th',
            'td'
        ] : 'td',
        type: 'item',
        showLabel: true,
        showContent: true,
        ...descContext
    }));
};
var $c1b29817ab2187ca$export$2e2bcd8739ae039 = $c1b29817ab2187ca$var$Row;





const $b3fa5e7e6670dcfc$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, labelBg: labelBg } = token;
    return {
        [`&${componentCls}-bordered`]: {
            [`> ${componentCls}-view`]: {
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                '> table': {
                    tableLayout: 'auto'
                },
                [`${componentCls}-row`]: {
                    borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                    '&:first-child': {
                        '> th:first-child, > td:first-child': {
                            borderStartStartRadius: token.borderRadiusLG
                        }
                    },
                    '&:last-child': {
                        borderBottom: 'none',
                        '> th:first-child, > td:first-child': {
                            borderEndStartRadius: token.borderRadiusLG
                        }
                    },
                    [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}`,
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                        '&:last-child': {
                            borderInlineEnd: 'none'
                        }
                    },
                    [`> ${componentCls}-item-label`]: {
                        color: token.colorTextSecondary,
                        backgroundColor: labelBg,
                        '&::after': {
                            display: 'none'
                        }
                    }
                }
            },
            [`&${componentCls}-medium`]: {
                [`${componentCls}-row`]: {
                    [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingSM)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}`
                    }
                }
            },
            [`&${componentCls}-small`]: {
                [`${componentCls}-row`]: {
                    [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)}`
                    }
                }
            }
        }
    };
};
const $b3fa5e7e6670dcfc$var$genDescriptionStyles = (token)=>{
    const { componentCls: componentCls, extraColor: extraColor, itemPaddingBottom: itemPaddingBottom, itemPaddingEnd: itemPaddingEnd, colonMarginRight: colonMarginRight, colonMarginLeft: colonMarginLeft, titleMarginBottom: titleMarginBottom } = token;
    return {
        [componentCls]: {
            ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
            ...$b3fa5e7e6670dcfc$var$genBorderedStyle(token),
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-header`]: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: titleMarginBottom
            },
            [`${componentCls}-title`]: {
                ...(0, $4733a3b3eb18f80d$export$b2b65df0d0824629),
                flex: 'auto',
                color: token.titleColor,
                fontWeight: token.fontWeightStrong,
                fontSize: token.fontSizeLG,
                lineHeight: token.lineHeightLG
            },
            [`${componentCls}-extra`]: {
                marginInlineStart: 'auto',
                color: extraColor,
                fontSize: token.fontSize
            },
            [`${componentCls}-view`]: {
                width: '100%',
                borderRadius: token.borderRadiusLG,
                table: {
                    width: '100%',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse'
                }
            },
            [`${componentCls}-row`]: {
                '> th, > td': {
                    paddingBottom: itemPaddingBottom,
                    paddingInlineEnd: itemPaddingEnd
                },
                '> th:last-child, > td:last-child': {
                    paddingInlineEnd: 0
                },
                '&:last-child': {
                    borderBottom: 'none',
                    '> th, > td': {
                        paddingBottom: 0
                    }
                }
            },
            [`${componentCls}-item-label`]: {
                color: token.labelColor,
                fontWeight: 'normal',
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                textAlign: 'start',
                '&::after': {
                    content: '":"',
                    position: 'relative',
                    top: -0.5,
                    // magic for position
                    marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(colonMarginLeft)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(colonMarginRight)}`
                },
                [`&${componentCls}-item-no-colon::after`]: {
                    content: '""'
                }
            },
            [`${componentCls}-item-no-label`]: {
                '&::after': {
                    margin: 0,
                    content: '""'
                }
            },
            [`${componentCls}-item-content`]: {
                display: 'table-cell',
                flex: 1,
                color: token.contentColor,
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
            },
            [`${componentCls}-item`]: {
                paddingBottom: 0,
                verticalAlign: 'top',
                '&-container': {
                    display: 'flex',
                    [`${componentCls}-item-label`]: {
                        display: 'inline-flex',
                        alignItems: 'baseline'
                    },
                    [`${componentCls}-item-content`]: {
                        display: 'inline-flex',
                        alignItems: 'baseline',
                        minWidth: '1em'
                    }
                }
            },
            '&-medium': {
                [`${componentCls}-row`]: {
                    '> th, > td': {
                        paddingBottom: token.paddingSM
                    }
                }
            },
            '&-small': {
                [`${componentCls}-row`]: {
                    '> th, > td': {
                        paddingBottom: token.paddingXS
                    }
                }
            }
        }
    };
};
const $b3fa5e7e6670dcfc$export$9ca1be8807fe0675 = (token)=>({
        labelBg: token.colorFillAlter,
        labelColor: token.colorTextTertiary,
        titleColor: token.colorText,
        titleMarginBottom: token.fontSizeSM * token.lineHeightSM,
        itemPaddingBottom: token.padding,
        itemPaddingEnd: token.padding,
        colonMarginRight: token.marginXS,
        colonMarginLeft: token.marginXXS / 2,
        contentColor: token.colorText,
        extraColor: token.colorText
    });
var // ============================== Export ==============================
$b3fa5e7e6670dcfc$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Descriptions', (token)=>{
    const descriptionToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {});
    return $b3fa5e7e6670dcfc$var$genDescriptionStyles(descriptionToken);
}, $b3fa5e7e6670dcfc$export$9ca1be8807fe0675);


"use client";
const $d93e861837558e71$var$Descriptions = (props)=>{
    const { prefixCls: customizePrefixCls, title: title, extra: extra, column: column, colon: colon = true, bordered: bordered, layout: layout, children: children, className: className, rootClassName: rootClassName, style: style, size: customizeSize, labelStyle: labelStyle, contentStyle: contentStyle, styles: styles, items: items, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('descriptions');
    const prefixCls = getPrefixCls('descriptions', customizePrefixCls);
    const screens = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)();
    var deprecatedName, newName;
    // Column count
    const mergedColumn = $acw62.useMemo(()=>{
        if ((0, $b956dab96d0e505b$export$7e4aa119212bc614)(column)) return column;
        return (0, $36689cb123f552b0$export$862220c15691d248)(screens, {
            ...(0, $efd2c765531bad84$export$2e2bcd8739ae039),
            ...column
        }) ?? 3;
    }, [
        screens,
        column
    ]);
    // Items with responsive
    const mergedItems = (0, $181a720a416959be$export$2e2bcd8739ae039)(screens, items, children);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const rows = (0, $7fc9cecb8c4b4adf$export$2e2bcd8739ae039)(mergedColumn, mergedItems);
    const [hashId, cssVarCls] = (0, $b3fa5e7e6670dcfc$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        column: mergedColumn,
        items: mergedItems,
        size: mergedSize
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ======================== Render ========================
    const memoizedValue = $acw62.useMemo(()=>({
            labelStyle: labelStyle,
            contentStyle: contentStyle,
            styles: {
                label: mergedStyles.label,
                content: mergedStyles.content
            },
            classNames: {
                label: mergedClassNames.label,
                content: mergedClassNames.content
            }
        }), [
        labelStyle,
        contentStyle,
        mergedStyles.label,
        mergedStyles.content,
        mergedClassNames.label,
        mergedClassNames.content
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $909a446c3c56ff9d$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, contextClassName, mergedClassNames.root, {
            [`${prefixCls}-medium`]: mergedSize === 'medium' || mergedSize === 'middle',
            [`${prefixCls}-small`]: mergedSize === 'small',
            [`${prefixCls}-bordered`]: !!bordered,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, hashId, cssVarCls),
        style: {
            ...contextStyle,
            ...mergedStyles.root,
            ...style
        },
        ...restProps
    }, (title || extra) && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-header`, mergedClassNames.header),
        style: mergedStyles.header
    }, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
        style: mergedStyles.title
    }, title), extra && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra),
        style: mergedStyles.extra
    }, extra)), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-view`
    }, /*#__PURE__*/ $acw62.createElement("table", null, /*#__PURE__*/ $acw62.createElement("tbody", null, rows.map((row, index)=>/*#__PURE__*/ $acw62.createElement((0, $c1b29817ab2187ca$export$2e2bcd8739ae039), {
            key: index,
            index: index,
            colon: colon,
            prefixCls: prefixCls,
            vertical: layout === 'vertical',
            bordered: bordered,
            row: row
        })))))));
};
$d93e861837558e71$var$Descriptions.Item = (0, $eb778ea7e6553a20$export$2e2bcd8739ae039);
var $d93e861837558e71$export$2e2bcd8739ae039 = $d93e861837558e71$var$Descriptions;


var $acw62 = parcelRequire("acw62");
// export this package's api



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $d6f15c242b193e48$var$DrawerContext = /*#__PURE__*/ $acw62.createContext(null);
const $d6f15c242b193e48$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $acw62.createContext({});
var $d6f15c242b193e48$export$2e2bcd8739ae039 = $d6f15c242b193e48$var$DrawerContext;






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



function $c1687e2f22645073$var$_extends() {
    $c1687e2f22645073$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c1687e2f22645073$var$_extends.apply(this, arguments);
}
const $c1687e2f22645073$var$DrawerPanel = (props)=>{
    const { prefixCls: prefixCls, className: className, containerRef: containerRef, ...restProps } = props;
    const { panel: panelRef } = $acw62.useContext((0, $d6f15c242b193e48$export$ee4e38b469b6f5d1));
    const mergedRef = (0, $6c628207f5089a39$export$1d1c999670a1285d)(panelRef, containerRef);
    // =============================== Render ===============================
    return /*#__PURE__*/ $acw62.createElement("div", $c1687e2f22645073$var$_extends({
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-section`, className),
        role: "dialog",
        ref: mergedRef
    }, (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
        aria: true
    }), {
        "aria-modal": "true"
    }, restProps));
};
var $c1687e2f22645073$export$2e2bcd8739ae039 = $c1687e2f22645073$var$DrawerPanel;



var $acw62 = parcelRequire("acw62");


function $0f717e703dff6512$export$2e2bcd8739ae039(options) {
    const { prefixCls: prefixCls, direction: direction, className: className, style: style, maxSize: maxSize, containerRef: containerRef, currentSize: currentSize, onResize: onResize, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart } = options;
    const [isDragging, setIsDragging] = $acw62.useState(false);
    const [startPos, setStartPos] = $acw62.useState(0);
    const [startSize, setStartSize] = $acw62.useState(0);
    const isHorizontal = direction === 'left' || direction === 'right';
    const handleMouseDown = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        if (isHorizontal) setStartPos(e.clientX);
        else setStartPos(e.clientY);
        // Use provided currentSize, or fallback to container size
        let startSize;
        if (typeof currentSize === 'number') startSize = currentSize;
        else if (containerRef?.current) {
            const rect = containerRef.current.getBoundingClientRect();
            startSize = isHorizontal ? rect.width : rect.height;
        }
        setStartSize(startSize);
        onResizeStart?.(startSize);
    });
    const handleMouseMove = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((e)=>{
        if (!isDragging) return;
        const currentPos = isHorizontal ? e.clientX : e.clientY;
        let delta = currentPos - startPos;
        // Adjust delta direction based on placement
        if (direction === 'right' || direction === 'bottom') delta = -delta;
        let newSize = startSize + delta;
        // Apply min/max size limits
        if (newSize < 0) newSize = 0;
        // Only apply maxSize if it's a valid positive number
        if (maxSize && newSize > maxSize) newSize = maxSize;
        onResize?.(newSize);
    });
    const handleMouseUp = $acw62.useCallback(()=>{
        if (isDragging) {
            setIsDragging(false);
            // Get the final size after resize
            if (containerRef?.current) {
                const rect = containerRef.current.getBoundingClientRect();
                const finalSize = isHorizontal ? rect.width : rect.height;
                onResizeEnd?.(finalSize);
            }
        }
    }, [
        isDragging,
        containerRef,
        onResizeEnd,
        isHorizontal
    ]);
    $acw62.useEffect(()=>{
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return ()=>{
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const dragElementClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-dragger`, `${prefixCls}-dragger-${direction}`, {
        [`${prefixCls}-dragger-dragging`]: isDragging,
        [`${prefixCls}-dragger-horizontal`]: isHorizontal,
        [`${prefixCls}-dragger-vertical`]: !isHorizontal
    }, className);
    return {
        dragElementProps: {
            className: dragElementClassName,
            style: style,
            onMouseDown: handleMouseDown
        },
        isDragging: isDragging
    };
}




function $9b6de8171db7bbed$export$efeadb1af96d0a6d(value) {
    if (typeof value === 'string') {
        const num = Number(value.replace(/px$/i, ''));
        const floatNum = parseFloat(value);
        if (floatNum === num) (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(false, 'Invalid value type of `width` or `height` which should be number type instead.');
        if (!Number.isNaN(num)) return num;
    }
    return value;
}
function $9b6de8171db7bbed$export$e77176dc71180add(props) {
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)(!('wrapperClassName' in props), `'wrapperClassName' is removed. Please use 'rootClassName' instead.`);
    (0, $3ef2f9e39800a1a1$export$2e2bcd8739ae039)((0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() || !props.open, `Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.`);
}




var $acw62 = parcelRequire("acw62");

function $5493f37a3ee25caa$export$2e2bcd8739ae039(getContainer, open, autoFocus, focusTrap, mask) {
    const mergedFocusTrap = focusTrap ?? mask !== false;
    // Focus lock
    const [ignoreElement] = (0, $09560f6ea64963fd$export$9e3bf6f439c42dc9)(open && mergedFocusTrap, getContainer);
    // Auto Focus
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && autoFocus === true) getContainer()?.focus({
            preventScroll: true
        });
    }, [
        open
    ]);
    return ignoreElement;
}


function $5abf31bf54b69d4b$var$_extends() {
    $5abf31bf54b69d4b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5abf31bf54b69d4b$var$_extends.apply(this, arguments);
}
const $5abf31bf54b69d4b$var$DrawerPopup = (props, ref)=>{
    const { prefixCls: prefixCls, open: open, placement: placement, inline: inline, push: push, forceRender: forceRender, autoFocus: // Focus
    autoFocus, focusTrap: focusTrap, // classNames
    classNames: drawerClassNames, rootClassName: // Root
    rootClassName, rootStyle: rootStyle, zIndex: zIndex, className: // Drawer
    className, id: id, style: style, motion: motion, width: width, height: height, size: size, maxSize: maxSize, children: children, mask: // Mask
    mask, maskClosable: maskClosable, maskMotion: maskMotion, maskClassName: maskClassName, maskStyle: maskStyle, afterOpenChange: // Events
    afterOpenChange, onClose: onClose, onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, styles: styles, drawerRender: drawerRender, resizable: resizable, defaultSize: defaultSize } = props;
    // ================================ Refs ================================
    const panelRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>panelRef.current);
    // ========================= Focusable ==========================
    const ignoreElement = (0, $5493f37a3ee25caa$export$2e2bcd8739ae039)(()=>panelRef.current, open, autoFocus, focusTrap, mask);
    // ============================ Push ============================
    const [pushed, setPushed] = $acw62.useState(false);
    const parentContext = $acw62.useContext((0, $d6f15c242b193e48$export$2e2bcd8739ae039));
    // Merge push distance
    let pushConfig;
    if (typeof push === 'boolean') pushConfig = push ? {} : {
        distance: 0
    };
    else pushConfig = push || {};
    const pushDistance = pushConfig?.distance ?? parentContext?.pushDistance ?? 180;
    const mergedContext = $acw62.useMemo(()=>({
            pushDistance: pushDistance,
            push: ()=>{
                setPushed(true);
            },
            pull: ()=>{
                setPushed(false);
            }
        }), [
        pushDistance
    ]);
    // ========================= ScrollLock =========================
    // Tell parent to push
    $acw62.useEffect(()=>{
        if (open) parentContext?.push?.();
        else parentContext?.pull?.();
    }, [
        open
    ]);
    // Clean up
    $acw62.useEffect(()=>()=>{
            parentContext?.pull?.();
        }, []);
    // ============================ Mask ============================
    const maskNode = /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $5abf31bf54b69d4b$var$_extends({
        key: "mask"
    }, maskMotion, {
        visible: mask && open
    }), ({ className: motionMaskClassName, style: motionMaskStyle }, maskRef)=>/*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, motionMaskClassName, drawerClassNames?.mask, maskClassName),
            style: {
                ...motionMaskStyle,
                ...maskStyle,
                ...styles?.mask
            },
            onClick: maskClosable && open ? onClose : undefined,
            ref: maskRef
        }));
    // =========================== Panel ============================
    const motionProps = typeof motion === 'function' ? motion(placement) : motion;
    // ============================ Size ============================
    const [currentSize, setCurrentSize] = $acw62.useState();
    const isHorizontal = placement === 'left' || placement === 'right';
    // Aggregate size logic with backward compatibility using useMemo
    const mergedSize = $acw62.useMemo(()=>{
        const legacySize = isHorizontal ? width : height;
        const nextMergedSize = size ?? legacySize ?? currentSize ?? defaultSize ?? (isHorizontal ? 378 : undefined);
        return (0, $9b6de8171db7bbed$export$efeadb1af96d0a6d)(nextMergedSize);
    }, [
        size,
        width,
        height,
        defaultSize,
        isHorizontal,
        currentSize
    ]);
    // >>> Style
    const wrapperStyle = $acw62.useMemo(()=>{
        const nextWrapperStyle = {};
        if (pushed && pushDistance) switch(placement){
            case 'top':
                nextWrapperStyle.transform = `translateY(${pushDistance}px)`;
                break;
            case 'bottom':
                nextWrapperStyle.transform = `translateY(${-pushDistance}px)`;
                break;
            case 'left':
                nextWrapperStyle.transform = `translateX(${pushDistance}px)`;
                break;
            default:
                nextWrapperStyle.transform = `translateX(${-pushDistance}px)`;
                break;
        }
        if (isHorizontal) nextWrapperStyle.width = (0, $9b6de8171db7bbed$export$efeadb1af96d0a6d)(mergedSize);
        else nextWrapperStyle.height = (0, $9b6de8171db7bbed$export$efeadb1af96d0a6d)(mergedSize);
        return nextWrapperStyle;
    }, [
        pushed,
        pushDistance,
        placement,
        isHorizontal,
        mergedSize
    ]);
    // =========================== Resize ===========================
    const wrapperRef = $acw62.useRef(null);
    const isResizable = !!resizable;
    const resizeConfig = typeof resizable === 'object' && resizable || {};
    const onInternalResize = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((size)=>{
        setCurrentSize(size);
        resizeConfig.onResize?.(size);
    });
    const { dragElementProps: dragElementProps, isDragging: isDragging } = (0, $0f717e703dff6512$export$2e2bcd8739ae039)({
        prefixCls: `${prefixCls}-resizable`,
        direction: placement,
        className: drawerClassNames?.dragger,
        style: styles?.dragger,
        maxSize: maxSize,
        containerRef: wrapperRef,
        currentSize: mergedSize,
        onResize: onInternalResize,
        onResizeStart: resizeConfig.onResizeStart,
        onResizeEnd: resizeConfig.onResizeEnd
    });
    // =========================== Events ===========================
    const eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onFocus: (e)=>{
            ignoreElement(e.target);
        }
    };
    // =========================== Render ==========================
    // >>>>> Panel
    const panelNode = /*#__PURE__*/ $acw62.createElement((0, $f302abe021ca493e$export$2e2bcd8739ae039), $5abf31bf54b69d4b$var$_extends({
        key: "panel"
    }, motionProps, {
        visible: open,
        forceRender: forceRender,
        onVisibleChanged: afterOpenChange,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-content-wrapper-hidden`
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        const content = /*#__PURE__*/ $acw62.createElement((0, $c1687e2f22645073$export$2e2bcd8739ae039), $5abf31bf54b69d4b$var$_extends({
            id: id,
            containerRef: motionRef,
            prefixCls: prefixCls,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, drawerClassNames?.section),
            style: {
                ...style,
                ...styles?.section
            }
        }, (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
            aria: true
        }), eventHandlers), children);
        return /*#__PURE__*/ $acw62.createElement("div", $5abf31bf54b69d4b$var$_extends({
            ref: wrapperRef,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-content-wrapper`, isDragging && `${prefixCls}-content-wrapper-dragging`, drawerClassNames?.wrapper, !isDragging && motionClassName),
            style: {
                ...motionStyle,
                ...wrapperStyle,
                ...styles?.wrapper
            }
        }, (0, $613e269121c63c71$export$2e2bcd8739ae039)(props, {
            data: true
        })), isResizable && /*#__PURE__*/ $acw62.createElement("div", dragElementProps), drawerRender ? drawerRender(content) : content);
    });
    // >>>>> Container
    const containerStyle = {
        ...rootStyle
    };
    if (zIndex) containerStyle.zIndex = zIndex;
    return /*#__PURE__*/ $acw62.createElement((0, $d6f15c242b193e48$export$2e2bcd8739ae039).Provider, {
        value: mergedContext
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${placement}`, rootClassName, {
            [`${prefixCls}-open`]: open,
            [`${prefixCls}-inline`]: inline
        }),
        style: containerStyle,
        tabIndex: -1,
        ref: panelRef
    }, maskNode, panelNode));
};
const $5abf31bf54b69d4b$var$RefDrawerPopup = /*#__PURE__*/ $acw62.forwardRef($5abf31bf54b69d4b$var$DrawerPopup);
var $5abf31bf54b69d4b$export$2e2bcd8739ae039 = $5abf31bf54b69d4b$var$RefDrawerPopup;



const $900e854a27edf2c5$var$Drawer = (props)=>{
    const { open: open = false, prefixCls: prefixCls = 'rc-drawer', placement: placement = 'right', autoFocus: autoFocus = true, keyboard: keyboard = true, width: width, height: height, size: size, maxSize: maxSize, mask: mask = true, maskClosable: maskClosable = true, getContainer: getContainer, forceRender: forceRender, afterOpenChange: afterOpenChange, destroyOnHidden: destroyOnHidden, onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClose: onClose, resizable: resizable, defaultSize: defaultSize, focusTriggerAfterClose: focusTriggerAfterClose, panelRef: // Refs
    panelRef } = props;
    const [animatedVisible, setAnimatedVisible] = $acw62.useState(false);
    // ============================= Open =============================
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        setMounted(true);
    }, []);
    const mergedOpen = mounted ? open : false;
    // ============================ Focus =============================
    const popupRef = $acw62.useRef(null);
    const lastActiveRef = $acw62.useRef(null);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (mergedOpen) lastActiveRef.current = document.activeElement;
    }, [
        mergedOpen
    ]);
    // ============================= Open =============================
    const internalAfterOpenChange = (nextVisible)=>{
        setAnimatedVisible(nextVisible);
        afterOpenChange?.(nextVisible);
        if (!nextVisible && focusTriggerAfterClose !== false && lastActiveRef.current && !popupRef.current?.contains(lastActiveRef.current)) lastActiveRef.current?.focus({
            preventScroll: true
        });
    };
    // =========================== Context ============================
    const refContext = $acw62.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    // ============================ Render ============================
    if (!forceRender && !animatedVisible && !mergedOpen && destroyOnHidden) return null;
    const eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    const drawerPopupProps = {
        ...props,
        open: mergedOpen,
        prefixCls: prefixCls,
        placement: placement,
        autoFocus: autoFocus,
        keyboard: keyboard,
        width: width,
        height: height,
        size: size,
        maxSize: maxSize,
        defaultSize: defaultSize,
        mask: mask,
        maskClosable: maskClosable,
        inline: getContainer === false,
        afterOpenChange: internalAfterOpenChange,
        ref: popupRef,
        resizable: resizable,
        ...eventHandlers
    };
    const onEsc = ({ top: top, event: event })=>{
        if (top && keyboard) {
            event.stopPropagation();
            onClose?.(event);
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $d6f15c242b193e48$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
        open: mergedOpen || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: mask && (mergedOpen || animatedVisible),
        onEsc: onEsc
    }, /*#__PURE__*/ $acw62.createElement((0, $5abf31bf54b69d4b$export$2e2bcd8739ae039), drawerPopupProps)));
};
var $900e854a27edf2c5$export$2e2bcd8739ae039 = $900e854a27edf2c5$var$Drawer;


var $b708617b4546356e$export$2e2bcd8739ae039 = (0, $900e854a27edf2c5$export$2e2bcd8739ae039);







var $acw62 = parcelRequire("acw62");

const $85b52f3191e32cc4$export$c0a98b854d121670 = (mask, maskClosable)=>{
    let maskConfig = {};
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(mask)) maskConfig = mask;
    if (typeof mask === 'boolean') maskConfig = {
        enabled: mask
    };
    if (maskConfig.closable === undefined && maskClosable !== undefined) maskConfig.closable = maskClosable;
    return maskConfig;
};
const $85b52f3191e32cc4$export$a4ac1bdd74570410 = (mask, contextMask, prefixCls, maskClosable)=>{
    return (0, $acw62.useMemo)(()=>{
        const maskConfig = $85b52f3191e32cc4$export$c0a98b854d121670(mask, maskClosable);
        const contextMaskConfig = $85b52f3191e32cc4$export$c0a98b854d121670(contextMask);
        const mergedConfig = {
            blur: false,
            ...contextMaskConfig,
            ...maskConfig,
            closable: maskConfig.closable ?? maskClosable ?? contextMaskConfig.closable ?? true
        };
        const className = mergedConfig.blur ? `${prefixCls}-mask-blur` : undefined;
        return [
            mergedConfig.enabled !== false,
            {
                mask: className
            },
            !!mergedConfig.closable
        ];
    }, [
        mask,
        contextMask,
        prefixCls,
        maskClosable
    ]);
};









var $acw62 = parcelRequire("acw62");

function $9ce1b741d917b083$var$voidFunc() {}
const $9ce1b741d917b083$var$WatermarkContext = /*#__PURE__*/ $acw62.createContext({
    add: $9ce1b741d917b083$var$voidFunc,
    remove: $9ce1b741d917b083$var$voidFunc
});
function $9ce1b741d917b083$export$94ab53417567be34(panelSelector) {
    const watermark = $acw62.useContext($9ce1b741d917b083$var$WatermarkContext);
    const panelEleRef = $acw62.useRef(null);
    const panelRef = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $9ce1b741d917b083$export$2e2bcd8739ae039 = $9ce1b741d917b083$var$WatermarkContext;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



"use client";
const $7c41d3edfd4df78b$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $acw62.useMemo(()=>(0, $b956dab96d0e505b$export$7e4aa119212bc614)(size) ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, sizeCls, shapeCls, className),
        style: {
            ...sizeStyle,
            ...style
        }
    });
};
var $7c41d3edfd4df78b$export$2e2bcd8739ae039 = $7c41d3edfd4df78b$var$Element;




const $c8ad1686c6f1e1ca$var$skeletonClsLoading = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(size)
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementSize = (size)=>({
        width: size,
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size)
    });
const $c8ad1686c6f1e1ca$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $c8ad1686c6f1e1ca$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize = (size, calc)=>({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal(),
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size)
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(controlHeight)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(controlHeightLG)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(controlHeightSM)
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeight, calc)
        },
        [`${skeletonInputCls}-lg`]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeightLG, calc)
        },
        [`${skeletonInputCls}-sm`]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeightSM, calc)
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementShape = (token)=>{
    const { gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(calc(imageSizeBase).mul(2).equal())
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementNode = (token)=>{
    return {
        [token.skeletonNodeCls]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementShape(token)
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        [skeletonImageCls]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementShape(token),
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: {
                ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(imageSizeBase),
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            },
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        },
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize = (size, calc)=>({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal(),
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size)
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonButtonCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal(),
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeight, calc)
        },
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls),
        [`${skeletonButtonCls}-lg`]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeightLG, calc)
        },
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`),
        [`${skeletonButtonCls}-sm`]: {
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeightSM, calc)
        },
        ...$c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`)
    };
};
// =============================== Base ===============================
const $c8ad1686c6f1e1ca$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonNodeCls: skeletonNodeCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor,
                    ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(controlHeight)
                },
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: {
                    ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(controlHeightLG)
                },
                [`${skeletonAvatarCls}-sm`]: {
                    ...$c8ad1686c6f1e1ca$var$genSkeletonElementSize(controlHeightSM)
                }
            },
            [`${componentCls}-section`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-section`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-section`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton with element
        [`${componentCls}${componentCls}-element`]: {
            display: 'inline-block',
            width: 'auto',
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementButton(token),
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementAvatar(token),
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementInput(token),
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementNode(token),
            ...$c8ad1686c6f1e1ca$var$genSkeletonElementImage(token)
        },
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonNodeCls},
        ${skeletonImageCls}
      `]: {
                ...$c8ad1686c6f1e1ca$var$genSkeletonColor(token)
            }
        }
    };
};
const $c8ad1686c6f1e1ca$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $c8ad1686c6f1e1ca$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonNodeCls: `${componentCls}-node`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return $c8ad1686c6f1e1ca$var$genBaseStyle(skeletonToken);
}, $c8ad1686c6f1e1ca$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});


"use client";
const $febf367e4c351696$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, style: style, styles: styles, shape: shape = 'circle', size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-avatar`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        shape: shape,
        size: mergedSize,
        ...rest
    }));
};
var $febf367e4c351696$export$2e2bcd8739ae039 = $febf367e4c351696$var$SkeletonAvatar;



var $acw62 = parcelRequire("acw62");





"use client";
const $13df8eca828a64aa$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, active: active, style: style, styles: styles, block: block = false, size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-button`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: mergedSize,
        ...rest
    }));
};
var $13df8eca828a64aa$export$2e2bcd8739ae039 = $13df8eca828a64aa$var$SkeletonButton;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



"use client";
const $28cf1b1f35f23ace$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, internalClassName: internalClassName, style: style, styles: styles, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, classNames?.root, className, rootClassName, cssVarCls);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(classNames?.content, internalClassName || `${prefixCls}-node`),
        style: {
            ...styles?.content,
            ...style
        }
    }, children));
};
var $28cf1b1f35f23ace$export$2e2bcd8739ae039 = $28cf1b1f35f23ace$var$SkeletonNode;


"use client";
const $2d15da232c1f201d$var$SkeletonImage = (props)=>{
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', props.prefixCls);
    return /*#__PURE__*/ $acw62.createElement((0, $28cf1b1f35f23ace$export$2e2bcd8739ae039), {
        ...props,
        internalClassName: `${prefixCls}-image`
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $acw62.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M365.7 329.1q0 45.8-32 77.7t-77.7 32-77.7-32-32-77.7 32-77.6 77.7-32 77.7 32 32 77.6M951 548.6v256H146.3V694.9L329 512l91.5 91.4L713 311zm54.8-402.3H91.4q-7.4 0-12.8 5.4T73 164.6v694.8q0 7.5 5.5 12.9t12.8 5.4h914.3q7.5 0 12.9-5.4t5.4-12.9V164.6q0-7.5-5.4-12.9t-12.9-5.4m91.4 18.3v694.8q0 37.8-26.8 64.6t-64.6 26.9H91.4q-37.7 0-64.6-26.9T0 859.4V164.6q0-37.8 26.8-64.6T91.4 73h914.3q37.8 0 64.6 26.9t26.8 64.6",
        className: `${prefixCls}-image-path`
    })));
};
var $2d15da232c1f201d$export$2e2bcd8739ae039 = $2d15da232c1f201d$var$SkeletonImage;



var $acw62 = parcelRequire("acw62");





"use client";
const $91e87c3cdd7d215d$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, block: block, style: style, styles: styles, size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-input`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: mergedSize,
        ...rest
    }));
};
var $91e87c3cdd7d215d$export$2e2bcd8739ae039 = $91e87c3cdd7d215d$var$SkeletonInput;




var $acw62 = parcelRequire("acw62");

"use client";
const $df381a499592442b$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $df381a499592442b$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: index,
            style: {
                width: $df381a499592442b$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style
    }, rowList);
};
var $df381a499592442b$export$2e2bcd8739ae039 = $df381a499592442b$var$Paragraph;




var $acw62 = parcelRequire("acw62");

"use client";
const $d644e5b233ba4700$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ $acw62.createElement("h3", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, className),
        style: {
            width: width,
            ...style
        }
    });
var $d644e5b233ba4700$export$2e2bcd8739ae039 = $d644e5b233ba4700$var$Title;


"use client";
function $186852cf13bfcae4$var$getComponentProps(prop) {
    if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(prop)) return prop;
    return {};
}
function $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
// Tips: ctx.classNames.root < ctx.className < cpns.classNames.root < cpns.className < rootClassName
const $186852cf13bfcae4$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, classNames: classNames, style: style, styles: styles, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        avatar: avatar,
        title: title,
        paragraph: paragraph
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = {
                className: mergedClassNames.avatar,
                prefixCls: `${prefixCls}-avatar`,
                ...$186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph),
                ...$186852cf13bfcae4$var$getComponentProps(avatar),
                style: mergedStyles.avatar
            };
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.header, `${prefixCls}-header`),
                style: mergedStyles.header
            }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), {
                ...avatarProps
            }));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = {
                    className: mergedClassNames.title,
                    prefixCls: `${prefixCls}-title`,
                    ...$186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph),
                    ...$186852cf13bfcae4$var$getComponentProps(title),
                    style: mergedStyles.title
                };
                $title = /*#__PURE__*/ $acw62.createElement((0, $d644e5b233ba4700$export$2e2bcd8739ae039), {
                    ...titleProps
                });
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = {
                    className: mergedClassNames.paragraph,
                    prefixCls: `${prefixCls}-paragraph`,
                    ...$186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle),
                    ...$186852cf13bfcae4$var$getComponentProps(paragraph),
                    style: mergedStyles.paragraph
                };
                paragraphNode = /*#__PURE__*/ $acw62.createElement((0, $df381a499592442b$export$2e2bcd8739ae039), {
                    ...paragraphProps
                });
            }
            contentNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.section, `${prefixCls}-section`),
                style: mergedStyles.section
            }, $title, paragraphNode);
        }
        const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, mergedClassNames.root, contextClassName, className, rootClassName, hashId, cssVarCls);
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: cls,
            style: {
                ...mergedStyles.root,
                ...contextStyle,
                ...style
            }
        }, avatarNode, contentNode);
    }
    return children ?? null;
};
$186852cf13bfcae4$var$Skeleton.Button = (0, $13df8eca828a64aa$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Avatar = (0, $febf367e4c351696$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Input = (0, $91e87c3cdd7d215d$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Image = (0, $2d15da232c1f201d$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Node = (0, $28cf1b1f35f23ace$export$2e2bcd8739ae039);
var $186852cf13bfcae4$export$2e2bcd8739ae039 = $186852cf13bfcae4$var$Skeleton;


"use client";
var $b9eb1d5949d003b0$export$2e2bcd8739ae039 = (0, $186852cf13bfcae4$export$2e2bcd8739ae039);


"use client";
const $0279d43d1c26ee11$var$DrawerPanel = (props)=>{
    const { prefixCls: prefixCls, ariaId: ariaId, title: title, footer: footer, extra: extra, closable: closable, loading: loading, onClose: onClose, headerStyle: headerStyle, bodyStyle: bodyStyle, footerStyle: footerStyle, children: children, classNames: drawerClassNames, styles: drawerStyles } = props;
    const drawerContext = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('drawer');
    const { classNames: contextClassNames, styles: contextStyles, closable: contextClosable } = drawerContext;
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        drawerClassNames
    ], [
        contextStyles,
        drawerStyles
    ], {
        props: {
            ...props,
            closable: closable ?? contextClosable
        }
    });
    const closablePlacement = $acw62.useMemo(()=>{
        const merged = closable ?? contextClosable;
        if (merged === false) return undefined;
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(merged) && merged?.placement === 'end') return 'end';
        return 'start';
    }, [
        closable,
        contextClosable
    ]);
    const customCloseIconRender = $acw62.useCallback((icon)=>/*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            onClick: onClose,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-close`, {
                [`${prefixCls}-close-${closablePlacement}`]: closablePlacement === 'end'
            }, mergedClassNames.close),
            style: mergedStyles.close
        }, icon), [
        onClose,
        prefixCls,
        closablePlacement,
        mergedClassNames.close,
        mergedStyles.close
    ]);
    const [mergedClosable, mergedCloseIcon] = (0, $91e86e8e8e97dd3f$export$aa101db403ccf5f3)((0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(props), (0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(drawerContext), {
        closable: true,
        closeIconRender: customCloseIconRender
    });
    const renderHeader = ()=>{
        if (!title && !mergedClosable) return null;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                ...mergedStyles.header,
                ...headerStyle
            },
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-header`, mergedClassNames.header, {
                [`${prefixCls}-header-close-only`]: mergedClosable && !title && !extra
            })
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-header-title`
        }, closablePlacement === 'start' && mergedCloseIcon, title && /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
            style: mergedStyles.title,
            id: ariaId
        }, title)), extra && /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra),
            style: mergedStyles.extra
        }, extra), closablePlacement === 'end' && mergedCloseIcon);
    };
    const renderFooter = ()=>{
        if (!footer) return null;
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
            style: {
                ...mergedStyles.footer,
                ...footerStyle
            }
        }, footer);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, renderHeader(), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body),
        style: {
            ...mergedStyles.body,
            ...bodyStyle
        }
    }, loading ? /*#__PURE__*/ $acw62.createElement((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 5
        },
        className: `${prefixCls}-body-skeleton`
    }) : children), renderFooter());
};
var $0279d43d1c26ee11$export$2e2bcd8739ae039 = $0279d43d1c26ee11$var$DrawerPanel;





const $663c87952542a325$var$getMoveTranslate = (direction)=>{
    const value = '100%';
    return ({
        left: `translateX(-${value})`,
        right: `translateX(${value})`,
        top: `translateY(-${value})`,
        bottom: `translateY(${value})`
    })[direction];
};
const $663c87952542a325$var$getEnterLeaveStyle = (startStyle, endStyle)=>({
        '&-enter, &-appear': {
            ...startStyle,
            '&-active': endStyle
        },
        '&-leave': {
            ...endStyle,
            '&-active': startStyle
        }
    });
const $663c87952542a325$var$getFadeStyle = (from, duration)=>({
        '&-enter, &-appear, &-leave': {
            '&-start': {
                transition: 'none'
            },
            '&-active': {
                transition: `all ${duration}`
            }
        },
        ...$663c87952542a325$var$getEnterLeaveStyle({
            opacity: from
        }, {
            opacity: 1
        })
    });
const $663c87952542a325$var$getPanelMotionStyles = (direction, duration)=>[
        $663c87952542a325$var$getFadeStyle(0.7, duration),
        $663c87952542a325$var$getEnterLeaveStyle({
            transform: $663c87952542a325$var$getMoveTranslate(direction)
        }, {
            transform: 'none'
        })
    ];
const $663c87952542a325$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [componentCls]: {
            // ======================== Mask ========================
            [`${componentCls}-mask-motion`]: $663c87952542a325$var$getFadeStyle(0, motionDurationSlow),
            // ======================= Panel ========================
            [`${componentCls}-panel-motion`]: [
                'left',
                'right',
                'top',
                'bottom'
            ].reduce((obj, direction)=>{
                return {
                    ...obj,
                    [`&-${direction}`]: $663c87952542a325$var$getPanelMotionStyles(direction, motionDurationSlow)
                };
            }, {})
        }
    };
};
var $663c87952542a325$export$2e2bcd8739ae039 = $663c87952542a325$var$genMotionStyle;


// =============================== Base ===============================
const $f93b1dac0ddeb04a$var$genDrawerStyle = (token)=>{
    const { borderRadiusSM: borderRadiusSM, componentCls: componentCls, zIndexPopup: zIndexPopup, colorBgMask: colorBgMask, colorBgElevated: colorBgElevated, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, paddingXS: paddingXS, padding: padding, paddingLG: paddingLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, lineWidth: lineWidth, lineType: lineType, colorSplit: colorSplit, marginXS: marginXS, colorIcon: colorIcon, colorIconHover: colorIconHover, colorBgTextHover: colorBgTextHover, colorBgTextActive: colorBgTextActive, colorText: colorText, fontWeightStrong: fontWeightStrong, footerPaddingBlock: footerPaddingBlock, footerPaddingInline: footerPaddingInline, draggerSize: draggerSize, calc: calc } = token;
    const wrapperCls = `${componentCls}-content-wrapper`;
    const draggerCls = `${componentCls}-resizable-dragger`;
    return {
        [componentCls]: {
            position: 'fixed',
            inset: 0,
            zIndex: zIndexPopup,
            pointerEvents: 'none',
            color: colorText,
            '&-pure': {
                position: 'relative',
                background: colorBgElevated,
                display: 'flex',
                flexDirection: 'column',
                pointerEvents: 'auto',
                [`&${componentCls}-left`]: {
                    boxShadow: token.boxShadowDrawerLeft
                },
                [`&${componentCls}-right`]: {
                    boxShadow: token.boxShadowDrawerRight
                },
                [`&${componentCls}-top`]: {
                    boxShadow: token.boxShadowDrawerUp
                },
                [`&${componentCls}-bottom`]: {
                    boxShadow: token.boxShadowDrawerDown
                }
            },
            '&-inline': {
                position: 'absolute'
            },
            // ====================== Mask ======================
            [`${componentCls}-mask`]: {
                position: 'absolute',
                inset: 0,
                zIndex: zIndexPopup,
                background: colorBgMask,
                pointerEvents: 'auto',
                [`&${componentCls}-mask-blur`]: {
                    backdropFilter: 'blur(4px)'
                }
            },
            // ==================== Content =====================
            [wrapperCls]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                maxWidth: '100vw',
                transition: `all ${motionDurationSlow}`,
                '&-hidden': {
                    display: 'none'
                }
            },
            // Placement
            [`&-left > ${wrapperCls}`]: {
                top: 0,
                bottom: 0,
                left: {
                    _skip_check_: true,
                    value: 0
                },
                boxShadow: token.boxShadowDrawerLeft
            },
            [`&-right > ${wrapperCls}`]: {
                top: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: 0,
                boxShadow: token.boxShadowDrawerRight
            },
            [`&-top > ${wrapperCls}`]: {
                top: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerUp
            },
            [`&-bottom > ${wrapperCls}`]: {
                bottom: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerDown
            },
            [`${componentCls}-section`]: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                overflow: 'auto',
                background: colorBgElevated,
                pointerEvents: 'auto'
            },
            // Header
            [`${componentCls}-header`]: {
                display: 'flex',
                flex: 0,
                alignItems: 'center',
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingLG)}`,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG,
                borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                '&-title': {
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    minWidth: 0,
                    minHeight: 0
                }
            },
            [`${componentCls}-extra`]: {
                flex: 'none'
            },
            [`${componentCls}-close`]: {
                display: 'inline-flex',
                width: calc(fontSizeLG).add(paddingXS).equal(),
                height: calc(fontSizeLG).add(paddingXS).equal(),
                borderRadius: borderRadiusSM,
                justifyContent: 'center',
                alignItems: 'center',
                color: colorIcon,
                fontWeight: fontWeightStrong,
                fontSize: fontSizeLG,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                textDecoration: 'none',
                background: 'transparent',
                border: 0,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`,
                textRendering: 'auto',
                [`&${componentCls}-close-end`]: {
                    marginInlineStart: marginXS
                },
                [`&:not(${componentCls}-close-end)`]: {
                    marginInlineEnd: marginXS
                },
                '&:hover': {
                    color: colorIconHover,
                    backgroundColor: colorBgTextHover,
                    textDecoration: 'none'
                },
                '&:active': {
                    backgroundColor: colorBgTextActive
                },
                ...(0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-title`]: {
                flex: 1,
                margin: 0,
                fontWeight: token.fontWeightStrong,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG
            },
            // Body
            [`${componentCls}-body`]: {
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                padding: paddingLG,
                overflow: 'auto',
                [`${componentCls}-body-skeleton`]: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                }
            },
            // Footer
            [`${componentCls}-footer`]: {
                flexShrink: 0,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(footerPaddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(footerPaddingInline)}`,
                borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
            },
            // ==================== Resizable ===================
            [draggerCls]: {
                position: 'absolute',
                zIndex: 1,
                backgroundColor: 'transparent',
                userSelect: 'none',
                pointerEvents: 'auto',
                '&:hover': {
                    backgroundColor: token.colorPrimary,
                    opacity: 0.2
                },
                '&-dragging': {
                    backgroundColor: token.colorPrimary,
                    opacity: 0.3
                }
            },
            [`${draggerCls}-left`]: {
                top: 0,
                bottom: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                width: draggerSize,
                cursor: 'col-resize'
            },
            [`${draggerCls}-right`]: {
                top: 0,
                bottom: 0,
                left: {
                    _skip_check_: true,
                    value: 0
                },
                width: draggerSize,
                cursor: 'col-resize'
            },
            [`${draggerCls}-top`]: {
                insetInline: 0,
                bottom: 0,
                height: draggerSize,
                cursor: 'row-resize'
            },
            [`${draggerCls}-bottom`]: {
                insetInline: 0,
                top: 0,
                height: draggerSize,
                cursor: 'row-resize'
            },
            // Wrapper dragging state - disable transitions for smooth dragging
            [`${wrapperCls}-dragging`]: {
                userSelect: 'none',
                transition: 'none',
                willChange: 'width, height',
                [`${componentCls}-content`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-section`]: {
                    pointerEvents: 'none'
                }
            },
            // ====================== RTL =======================
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
const $f93b1dac0ddeb04a$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase,
        footerPaddingBlock: token.paddingXS,
        footerPaddingInline: token.padding,
        draggerSize: 4
    });
var // ============================== Export ==============================
$f93b1dac0ddeb04a$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Drawer', (token)=>{
    const drawerToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {});
    return [
        $f93b1dac0ddeb04a$var$genDrawerStyle(drawerToken),
        (0, $663c87952542a325$export$2e2bcd8739ae039)(drawerToken)
    ];
}, $f93b1dac0ddeb04a$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");
function $305f672f70399927$export$2e2bcd8739ae039(focusable, defaultTrap, legacyFocusTriggerAfterClose) {
    return (0, $acw62.useMemo)(()=>{
        const ret = {
            trap: defaultTrap ?? true,
            focusTriggerAfterClose: legacyFocusTriggerAfterClose ?? true
        };
        return {
            ...ret,
            ...focusable
        };
    }, [
        focusable,
        defaultTrap,
        legacyFocusTriggerAfterClose
    ]);
}


"use client";
const $2be52397fe0496f7$var$_SizeTypes = [
    'default',
    'large'
];
const $2be52397fe0496f7$var$DEFAULT_PUSH_STATE = {
    distance: 180
};
const $2be52397fe0496f7$var$DEFAULT_SIZE = 378;
const $2be52397fe0496f7$var$MOTION_CONFIG = {
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 500
};
const $2be52397fe0496f7$var$Drawer = (props)=>{
    const { rootClassName: rootClassName, size: size, defaultSize: defaultSize = $2be52397fe0496f7$var$DEFAULT_SIZE, height: height, width: width, mask: drawerMask, push: push = $2be52397fe0496f7$var$DEFAULT_PUSH_STATE, open: open, afterOpenChange: afterOpenChange, onClose: onClose, prefixCls: customizePrefixCls, getContainer: customizeGetContainer, panelRef: panelRef = null, style: style, className: className, resizable: resizable, 'aria-labelledby': ariaLabelledby, focusable: // Focus
    focusable, maskClosable: // Deprecated
    maskClosable, maskStyle: maskStyle, drawerStyle: drawerStyle, contentWrapperStyle: contentWrapperStyle, destroyOnClose: destroyOnClose, destroyOnHidden: destroyOnHidden, ...rest } = props;
    const { placement: placement } = rest;
    const id = (0, $bba066f19964922a$export$2e2bcd8739ae039)();
    const ariaId = rest.title ? id : undefined;
    const { getPopupContainer: getPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, mask: contextMask } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('drawer');
    const prefixCls = getPrefixCls('drawer', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $f93b1dac0ddeb04a$export$2e2bcd8739ae039)(prefixCls);
    const getContainer = // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer ? ()=>getPopupContainer(document.body) : customizeGetContainer;
    // ============================ Size ============================
    const drawerSize = $acw62.useMemo(()=>{
        if ((0, $b956dab96d0e505b$export$7e4aa119212bc614)(size)) return size;
        if (size === 'large') return 736;
        if (size === 'default') return $2be52397fe0496f7$var$DEFAULT_SIZE;
        if (typeof size === 'string') {
            if (/^\d+(\.\d+)?$/.test(size)) return Number(size);
            return size;
        }
        if (!placement || placement === 'left' || placement === 'right') return width;
        return height;
    }, [
        size,
        placement,
        width,
        height
    ]);
    // =========================== Motion ===========================
    const maskMotion = {
        motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(prefixCls, 'mask-motion'),
        ...$2be52397fe0496f7$var$MOTION_CONFIG
    };
    const panelMotion = (motionPlacement)=>({
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(prefixCls, `panel-motion-${motionPlacement}`),
            ...$2be52397fe0496f7$var$MOTION_CONFIG
        });
    // ============================ Refs ============================
    // Select `ant-drawer-content` by `panelRef`
    const innerPanelRef = (0, $9ce1b741d917b083$export$94ab53417567be34)();
    const mergedPanelRef = (0, $6c628207f5089a39$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // =========================== zIndex ===========================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('Drawer', rest.zIndex);
    // ============================ Mask ============================
    const [mergedMask, maskBlurClassName, mergedMaskClosable] = (0, $85b52f3191e32cc4$export$a4ac1bdd74570410)(drawerMask, contextMask, prefixCls, maskClosable);
    // ========================== Focusable =========================
    const mergedFocusable = (0, $305f672f70399927$export$2e2bcd8739ae039)(focusable, getContainer !== false && mergedMask);
    // =========================== Render ===========================
    const { classNames: classNames, styles: styles, rootStyle: rootStyle } = rest;
    const mergedProps = {
        ...props,
        zIndex: zIndex,
        panelRef: panelRef,
        mask: mergedMask,
        maskClosable: mergedMaskClosable,
        defaultSize: defaultSize,
        push: push,
        focusable: mergedFocusable
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const drawerClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
        'no-mask': !mergedMask,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    var deprecatedName, newName;
    return /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $b708617b4546356e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        onClose: onClose,
        maskMotion: maskMotion,
        motion: panelMotion,
        ...rest,
        classNames: {
            mask: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(mergedClassNames.mask, maskBlurClassName.mask),
            section: mergedClassNames.section,
            wrapper: mergedClassNames.wrapper,
            dragger: mergedClassNames.dragger
        },
        styles: {
            mask: {
                ...mergedStyles.mask,
                ...maskStyle
            },
            section: {
                ...mergedStyles.section,
                ...drawerStyle
            },
            wrapper: {
                ...mergedStyles.wrapper,
                ...contentWrapperStyle
            },
            dragger: mergedStyles.dragger
        },
        open: open,
        mask: mergedMask,
        maskClosable: mergedMaskClosable,
        push: push,
        size: drawerSize,
        defaultSize: defaultSize,
        style: {
            ...contextStyle,
            ...style
        },
        rootStyle: {
            ...rootStyle,
            ...mergedStyles.root
        },
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(contextClassName, className),
        rootClassName: drawerClassName,
        getContainer: getContainer,
        afterOpenChange: afterOpenChange,
        panelRef: mergedPanelRef,
        zIndex: zIndex,
        ...resizable ? {
            resizable: resizable
        } : {},
        "aria-labelledby": ariaLabelledby ?? ariaId,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        // Focusable
        focusTriggerAfterClose: mergedFocusable.focusTriggerAfterClose,
        focusTrap: mergedFocusable.trap
    }, /*#__PURE__*/ $acw62.createElement((0, $0279d43d1c26ee11$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        size: size,
        ...rest,
        ariaId: ariaId,
        onClose: onClose
    }))));
};
/** @private Internal Component. Do not use in your production. */ const $2be52397fe0496f7$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, placement: placement = 'right', ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('drawer', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $f93b1dac0ddeb04a$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-pure`, `${prefixCls}-${placement}`, hashId, cssVarCls, className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $0279d43d1c26ee11$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        ...restProps
    }));
};
$2be52397fe0496f7$var$Drawer._InternalPanelDoNotUseOrYouWillBeFired = $2be52397fe0496f7$var$PurePanel;
var $2be52397fe0496f7$export$2e2bcd8739ae039 = $2be52397fe0496f7$var$Drawer;


"use client";
var $d2824be14bd3234d$export$2e2bcd8739ae039 = (0, $2be52397fe0496f7$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8e7f784a29e9449d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $8e7f784a29e9449d$export$2e2bcd8739ae039 = $8e7f784a29e9449d$var$CheckCircleFilled;



function $9149fdfb4424d1d9$var$_extends() {
    $9149fdfb4424d1d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9149fdfb4424d1d9$var$_extends.apply(this, arguments);
}
const $9149fdfb4424d1d9$var$CheckCircleFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $9149fdfb4424d1d9$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8e7f784a29e9449d$export$2e2bcd8739ae039)
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ const $9149fdfb4424d1d9$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9149fdfb4424d1d9$var$CheckCircleFilled);
var $9149fdfb4424d1d9$export$2e2bcd8739ae039 = $9149fdfb4424d1d9$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ce0f95a23ea8b20d$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ce0f95a23ea8b20d$export$2e2bcd8739ae039 = $ce0f95a23ea8b20d$var$ExclamationCircleFilled;



function $2444f6da62064575$var$_extends() {
    $2444f6da62064575$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2444f6da62064575$var$_extends.apply(this, arguments);
}
const $2444f6da62064575$var$ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $2444f6da62064575$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ce0f95a23ea8b20d$export$2e2bcd8739ae039)
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $2444f6da62064575$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2444f6da62064575$var$ExclamationCircleFilled);
var $2444f6da62064575$export$2e2bcd8739ae039 = $2444f6da62064575$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2dbdfa039f5e9286$var$WarningFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "filled"
};
var $2dbdfa039f5e9286$export$2e2bcd8739ae039 = $2dbdfa039f5e9286$var$WarningFilled;



function $3f0d8fd9f57ea6fb$var$_extends() {
    $3f0d8fd9f57ea6fb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f0d8fd9f57ea6fb$var$_extends.apply(this, arguments);
}
const $3f0d8fd9f57ea6fb$var$WarningFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $3f0d8fd9f57ea6fb$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2dbdfa039f5e9286$export$2e2bcd8739ae039)
    }));
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1NS43IDg1NmwtNDE2LTcyMGMtNi4yLTEwLjctMTYuOS0xNi0yNy43LTE2cy0yMS42IDUuMy0yNy43IDE2bC00MTYgNzIwQzU2IDg3Ny40IDcxLjQgOTA0IDk2IDkwNGg4MzJjMjQuNiAwIDQwLTI2LjYgMjcuNy00OHpNNDgwIDQxNmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djE4NGMwIDQuNC0zLjYgOC04IDhoLTQ4Yy00LjQgMC04LTMuNi04LThWNDE2em0zMiAzNTJhNDguMDEgNDguMDEgMCAwMTAtOTYgNDguMDEgNDguMDEgMCAwMTAgOTZ6IiAvPjwvc3ZnPg==) */ const $3f0d8fd9f57ea6fb$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3f0d8fd9f57ea6fb$var$WarningFilled);
var $3f0d8fd9f57ea6fb$export$2e2bcd8739ae039 = $3f0d8fd9f57ea6fb$var$RefIcon;








var $acw62 = parcelRequire("acw62");
"use client";
const $30eb2e921dbc382e$var$NoFound = ()=>/*#__PURE__*/ $acw62.createElement("svg", {
        width: "252",
        height: "294"
    }, /*#__PURE__*/ $acw62.createElement("title", null, "No Found"), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "126.75",
        cy: "128.1",
        r: "126",
        fill: "#E4EBF7"
    }), /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "31.55",
        cy: "130.8",
        r: "8.3",
        fill: "#FFF"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m37 134.3 10.5 6m.9 6.2-12.7 10.8",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M39.9 159.4a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m17.7-16.2a5.7 5.7 0 1 1-11.4-1.1 5.7 5.7 0 0 1 11.4 1.1M99 27h29.8a4.6 4.6 0 1 0 0-9.2H99a4.6 4.6 0 1 0 0 9.2m11.4 18.3h29.8a4.6 4.6 0 0 0 0-9.2h-29.8a4.6 4.6 0 1 0 0 9.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M112.8 26.9h15.8a4.6 4.6 0 1 0 0 9.1h-15.8a4.6 4.6 0 0 0 0-9.1m71.7 108.8a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m179.3 141.8 12.6 7.1m1.1 7.6-15.2 13",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M184.7 170a6.8 6.8 0 1 1-13.6-1.3 6.8 6.8 0 0 1 13.6 1.4m18.6-16.8a6.9 6.9 0 1 1-13.7-1.4 6.9 6.9 0 0 1 13.7 1.4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "M152 192.3a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm73.3-76.2a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm-9 35a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.5 0zM177 107.6a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.4-15.4a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm6.8 88.5a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0z",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m214.4 153.3-2 20.2-10.8 6m-28-4.7-6.3 9.8H156l-4.5 6.5m23.5-66v-15.7m46 7.8-13 8-15.2-8V94.4",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M166.6 66h-4a4.8 4.8 0 0 1-4.7-4.8 4.8 4.8 0 0 1 4.7-4.7h4a4.8 4.8 0 0 1 4.7 4.7 4.8 4.8 0 0 1-4.7 4.7"
    }), /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "204.3",
        cy: "30",
        r: "29.5",
        fill: "#1677ff"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M206 38.4c.5.5.7 1.1.7 2s-.2 1.4-.7 1.9a3 3 0 0 1-2 .7c-.8 0-1.5-.3-2-.8s-.8-1.1-.8-1.9.3-1.4.8-2c.5-.4 1.2-.7 2-.7.7 0 1.4.3 2 .8m4.2-19.5c1.5 1.3 2.2 3 2.2 5.2a7.2 7.2 0 0 1-1.5 4.5l-3 2.7a5 5 0 0 0-1.3 1.7 5.2 5.2 0 0 0-.6 2.4v.5h-4v-.5c0-1.4.1-2.5.6-3.5s1.9-2.5 4.2-4.5l.4-.5a4 4 0 0 0 1-2.6c0-1.2-.4-2-1-2.8-.7-.6-1.6-1-2.9-1-1.5 0-2.6.5-3.3 1.5-.4.5-.6 1-.8 1.9a2 2 0 0 1-2 1.6 2 2 0 0 1-2-2.4c.4-1.6 1-2.8 2.1-3.8a8.5 8.5 0 0 1 6.3-2.3c2.3 0 4.2.6 5.6 2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFB594",
        d: "M52 76.1s21.8 5.4 27.3 16c5.6 10.7-6.3 9.2-15.7 5C52.8 92 39 85 52 76"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "m90.5 67.5-.5 2.9c-.7.5-4.7-2.7-4.7-2.7l-1.7.8-1.3-5.7s6.8-4.6 9-5c2.4-.5 9.8 1 10.6 2.3 0 0 1.3.4-2.2.6-3.6.3-5 .5-6.8 3.2l-2.4 3.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M128 111.4a36.7 36.7 0 0 0-8.9-15.5c-3.5-3-9.3-2.2-11.3-4.2-1.3-1.2-3.2-1.2-3.2-1.2L87.7 87c-2.3-.4-2.1-.7-6-1.4-1.6-1.9-3-1.1-3-1.1l-7-1.4c-1-1.5-2.5-1-2.5-1l-2.4-.9C65 91.2 59 95 59 95c1.8 1.1 15.7 8.3 15.7 8.3l5.1 37.1s-3.3 5.7 1.4 9.1c0 0 19.9-3.7 34.9-.3 0 0 3-2.6 1-8.8.5-3 1.4-8.3 1.7-11.6.4.7 2 1.9 3.1 3.4 0 0 9.4-7.3 11-14a17 17 0 0 1-2.2-2.4c-.5-.8-.3-2-.7-2.8-.7-1-1.8-1.3-2-1.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CBD1D1",
        d: "M101 290s4.4 2 7.4 1c2.9-1 4.6.7 7.1 1.2 2.6.5 6.9 1.1 11.7-1.3 0-5.5-6.9-4-12-6.7-2.5-1.4-3.7-4.7-3.5-8.8h-9.5s-1.2 10.6-1 14.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#2B0849",
        d: "M101 289.8s2.5 1.3 6.8.7c3-.5 3.7.5 7.4 1 3.8.6 10.8 0 11.9-.9.4 1.1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.6-.5-1.8-1.4-5.2-1.9-5.7-.2-4 1-7.4-.3-7.4-.3l-.1-2.7z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A4AABA",
        d: "M108.3 276h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CBD1D1",
        d: "M57.5 272.4s-2 7.4-4.4 12.3c-1.8 3.7-4.3 7.5 5.4 7.5 6.7 0 9-.5 7.4-6.6-1.5-6.1.3-13.2.3-13.2h-8.7z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#2B0849",
        d: "M51.5 289.8s2 1.2 6.6 1.2c6 0 8.3-1.7 8.3-1.7s.6 1.1-.7 2.2c-1 .8-3.6 1.6-7.4 1.5-4.1 0-5.8-.5-6.7-1.1-.8-.6-.7-1.6-.1-2.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A4AABA",
        d: "M58.4 274.3s0 1.5-.3 3c-.3 1.4-1 3-1.1 4 0 1.2 4.5 1.7 5.1.1.6-1.5 1.3-6.4 2-7.2.6-.9-5-2.2-5.7.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#7BB2F9",
        d: "m99.7 278.5 13.3.1s1.3-54.5 1.9-64.4c.5-9.9 3.8-43.4 1-63.1l-12.6-.7-22.8.8-1.2 10c0 .5-.7.8-.7 1.4-.1.5.4 1.3.3 2-2.4 14-6.4 33-8.8 46.6 0 .7-1.2 1-1.4 2.7 0 .3.2 1.5 0 1.8-6.8 18.7-10.9 47.8-14.2 61.9h14.6s2.2-8.6 4-17c2.9-12.9 23.2-85 23.2-85l3-.5 1 46.3s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.8-1 11.8c-.4 4.8 0 39.2 0 39.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M76 221.6c1.2.1 4.1-2 7-5m23.4 8.5s2.7-1 6-3.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M107.3 222.1s2.7-1.1 6-3.9",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M74.7 224.8s2.7-.6 6.5-3.4m4.8-69.8c-.2 3.1.3 8.6-4.3 9.2m22-11s0 14-1.4 15.1a15 15 0 0 1-3 2m.5-16.5s0 13-1.2 24.4m-5 1.1s7.3-1.7 9.5-1.7M74.3 206a212 212 0 0 1-1 4.5s-1.4 1.9-1 3.8c.5 2-1 2-5 15.4A353 353 0 0 0 61 257l-.2 1.2m14.9-60.5a321 321 0 0 1-.9 4.8m7.8-50.4-1.2 10.5s-1.1.1-.5 2.2c.1 1.4-2.7 15.8-5.2 30.5m-19.6 79h13.3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#192064",
        d: "M116.2 148.2s-17-3-35.9.2c.2 2.5 0 4.2 0 4.2s14.7-2.8 35.7-.3c.3-2.4.2-4 .2-4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M106.3 151.2v-5a.8.8 0 0 0-.8-.8h-7.8a.8.8 0 0 0-.8.8v5a.8.8 0 0 0 .8.8h7.8a.8.8 0 0 0 .8-.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#192064",
        d: "M105.2 150.2v-3a.6.6 0 0 0-.6-.7 94.3 94.3 0 0 0-5.9 0 .7.7 0 0 0-.6.6v3.1a.6.6 0 0 0 .6.7 121.1 121.1 0 0 1 5.8 0c.4 0 .7-.3.7-.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M100.3 275.4h12.3m-11.2-4.9.1 6.5m0-12.5a915.8 915.8 0 0 0 0 4.4m-.5-94 .9 44.7s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.2 0 3.4-.6 1.5-1 21.1-1.1 35.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M46.9 83.4s-.5 6 7.2 5.6c11.2-.7 9.2-9.4 31.5-21.7-.7-2.7-2.4-4.7-2.4-4.7s-11 3-22.6 8c-6.8 3-13.4 6.4-13.7 12.8m57.6 7.7.9-5.4-8.9-11.4-5 5.3-1.8 7.9a.3.3 0 0 0 .1.3c1 .8 6.5 5 14.4 3.5a.3.3 0 0 0 .3-.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M94 79.4s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.1-3.7c.6-1 1.6-4.1 1.6-4.1l13.5 3c0 5.3-2.3 19.5-7.8 20-8.9.6-12.5-9.5-12.5-9.5"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#520038",
        d: "M113.9 73.4c2.6-2 3.4-9.7 3.4-9.7s-2.4-.5-6.6-2c-4.7-2.1-12.8-4.8-17.5 1-9.6 3.2-2 19.8-2 19.8l2.7-3s-4-3.3-2-6.3c2-3.5 3.8 1 3.8 1s.7-2.3 3.6-3.3c.4-.7 1-2.6 1.4-3.8a1 1 0 0 1 1.3-.7l11.4 2.6c.5.2.8.7.8 1.2l-.3 3.2z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#552950",
        d: "M105 76c-.1.7-.6 1.1-1 1-.6 0-.9-.6-.8-1.2.1-.6.6-1 1-1 .6 0 .9.7.8 1.3m7.1 1.6c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.5-1 1-1 .5.1.8.7.7 1.3"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "m110.1 74.8-.9 1.7-.3 4.3h-2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#5C2552",
        d: "M110.8 74.5s1.8-.7 2.6.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M92.4 74.3s.5-1.1 1.1-.7c.6.4 1.3 1.4.6 2-.8.5.1 1.6.1 1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#5C2552",
        d: "M103.3 73s1.8 1 4.1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M103.7 81.8s2.2 1.2 4.4 1.2m-3.5 1.3s1 .4 1.6.3m-11.5-3.4s2.3 7.4 10.4 7.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M81.5 89.4s.4 5.6-5 12.8M69 82.7s-.7 9.2-8.2 14.2m68.6 26s-5.3 7.4-9.4 10.7m-.7-26.3s.5 4.4-2.1 32",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F2D7AD",
        d: "M150 151.2h-49.8a1 1 0 0 1-1-1v-31.7c0-.5.4-1 1-1H150c.6 0 1 .5 1 1v31.7a1 1 0 0 1-1 1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F4D19D",
        d: "M150.3 151.2h-19.9v-33.7h20.8v32.8a1 1 0 0 1-1 1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F2D7AD",
        d: "M123.6 127.9H92.9a.5.5 0 0 1-.4-.8l6.4-9.1c.2-.3.5-.5.8-.5h31.1l-7.2 10.4z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CC9B6E",
        d: "M123.7 128.4H99.2v-.5h24.2l7.2-10.2.4.3z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F4D19D",
        d: "M158.3 127.9h-18.7a2 2 0 0 1-1.6-.8l-7.2-9.6h20c.5 0 1 .3 1.2.6l6.7 9a.5.5 0 0 1-.4.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CC9B6E",
        d: "M157.8 128.5h-19.3l-7.9-10.5.4-.3 7.7 10.3h19.1zm-27.2 22.2v-8.2h.4v8.2zm-.1-10.9v-21.4h.4l.1 21.4zm-18.6 1.1-.5-.1 1.5-5.2.5.2zm-3.5.2-2.6-3 2.6-3.4.4.3-2.4 3.1 2.4 2.6zm8.2 0-.4-.4 2.4-2.6-2.4-3 .4-.4 2.7 3.4z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "m154.3 131.9-3.1-2v3.5l-1 .1a85 85 0 0 1-4.8.3c-1.9 0-2.7 2.2 2.2 2.6l-2.6-.6s-2.2 1.3.5 2.3c0 0-1.6 1.2.6 2.6-.6 3.5 5.2 4 7 3.6a6.1 6.1 0 0 0 4.6-5.2 8 8 0 0 0-3.4-7.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M153.7 133.6s-6.5.4-8.4.3c-1.8 0-1.9 2.2 2.4 2.3 3.7.2 5.4 0 5.4 0",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M145.2 135.9c-1.9 1.3.5 2.3.5 2.3s3.5 1 6.8.6m-.6 2.9s-6.3.1-6.7-2.1c-.3-1.4.4-1.4.4-1.4m.5 2.7s-1 3.1 5.5 3.5m-.4-14.5v3.5M52.8 89.3a18 18 0 0 0 13.6-7.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#5BA02E",
        d: "M168.6 248.3a6.6 6.6 0 0 1-6.7-6.6v-66.5a6.6 6.6 0 1 1 13.3 0v66.5a6.6 6.6 0 0 1-6.6 6.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#92C110",
        d: "M176.5 247.7a6.6 6.6 0 0 1-6.6-6.7v-33.2a6.6 6.6 0 1 1 13.3 0V241a6.6 6.6 0 0 1-6.7 6.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F2D7AD",
        d: "M186.4 293.6H159a3.2 3.2 0 0 1-3.2-3.2v-46.1a3.2 3.2 0 0 1 3.2-3.2h27.5a3.2 3.2 0 0 1 3.2 3.2v46.1a3.2 3.2 0 0 1-3.2 3.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M89 89.5s7.8 5.4 16.6 2.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    })));
var $30eb2e921dbc382e$export$2e2bcd8739ae039 = $30eb2e921dbc382e$var$NoFound;



var $acw62 = parcelRequire("acw62");
"use client";
const $52cda3972f7a928b$var$ServerError = ()=>/*#__PURE__*/ $acw62.createElement("svg", {
        width: "254",
        height: "294"
    }, /*#__PURE__*/ $acw62.createElement("title", null, "Server Error"), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#E4EBF7",
        d: "M0 128.1v-2C0 56.5 56.3.2 125.7.2h2.1C197.2.3 253.5 56.6 253.5 126v2.1c0 69.5-56.3 125.7-125.7 125.7h-2.1A125.7 125.7 0 0 1 0 128.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M40 132.1a8.3 8.3 0 1 1-16.6-1.7 8.3 8.3 0 0 1 16.6 1.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m37.2 135.6 10.5 6m1 6.3-12.8 10.8",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M40.1 160.8a5.7 5.7 0 1 1-11.3-1.1 5.7 5.7 0 0 1 11.3 1.1M58 144.6a5.7 5.7 0 1 1-11.4-1.2 5.7 5.7 0 0 1 11.4 1.2M99.7 27.4h30a4.6 4.6 0 1 0 0-9.2h-30a4.6 4.6 0 0 0 0 9.2M111 46h30a4.6 4.6 0 1 0 0-9.3h-30a4.6 4.6 0 1 0 0 9.3m2.5-18.6h16a4.6 4.6 0 1 0 0 9.3h-16a4.6 4.6 0 0 0 0-9.3m36.7 42.7h-4a4.8 4.8 0 0 1-4.8-4.8 4.8 4.8 0 0 1 4.8-4.8h4a4.8 4.8 0 0 1 4.7 4.8 4.8 4.8 0 0 1-4.7 4.8"
    }), /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "201.35",
        cy: "30.2",
        r: "29.7",
        fill: "#FF603B"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "m203.6 19.4-.7 15a1.5 1.5 0 0 1-3 0l-.7-15a2.2 2.2 0 1 1 4.4 0m-.3 19.4c.5.5.8 1.1.8 1.9s-.3 1.4-.8 1.9a3 3 0 0 1-2 .7 2.5 2.5 0 0 1-1.8-.7c-.6-.6-.8-1.2-.8-2 0-.7.2-1.3.8-1.8.5-.5 1.1-.7 1.8-.7.8 0 1.5.2 2 .7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFB594",
        d: "M119.3 133.3c4.4-.6 3.6-1.2 4-4.8.8-5.2-3-17-8.2-25.1-1-10.7-12.6-11.3-12.6-11.3s4.3 5 4.2 16.2c1.4 5.3.8 14.5.8 14.5s5.3 11.4 11.8 10.5"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M101 91.6s1.4-.6 3.2.6c8 1.4 10.3 6.7 11.3 11.4 1.8 1.2 1.8 2.3 1.8 3.5l1.5 3s-7.2 1.7-11 6.7c-1.3-6.4-6.9-25.2-6.9-25.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFB594",
        d: "m94 90.5 1-5.8-9.2-11.9-5.2 5.6-2.6 9.9s8.4 5 16 2.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M83 78.2s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.2-3.7c.5-1 1.5-4.2 1.5-4.2l13.6 3.2c0 5.2-2.3 19.5-7.9 20-8.9.6-12.5-9.6-12.5-9.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#520038",
        d: "M103 72.2c2.6-2 3.5-9.7 3.5-9.7s-2.5-.5-6.7-2c-4.7-2.2-12.9-4.9-17.6.9-9.5 4.4-2 20-2 20l2.7-3.1s-4-3.3-2.1-6.3c2.2-3.5 4 1 4 1s.6-2.3 3.5-3.3c.4-.7 1-2.7 1.5-3.8A1 1 0 0 1 91 65l11.5 2.7c.5.1.8.6.8 1.2l-.3 3.2z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#552950",
        d: "M101.2 76.5c0 .6-.6 1-1 1-.5-.1-.9-.7-.8-1.3.1-.6.6-1 1.1-1 .5.1.8.7.7 1.3m-7-1.4c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.6-1 1-1 .5.1.9.7.8 1.3"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "m99.2 73.6-.9 1.7-.3 4.3h-2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#5C2552",
        d: "M100 73.3s1.7-.7 2.4.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M81.4 73s.4-1 1-.6c.7.4 1.4 1.4.6 2s.2 1.6.2 1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#5C2552",
        d: "M92.3 71.7s1.9 1.1 4.2 1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M92.7 80.6s2.3 1.2 4.4 1.2m-3.4 1.4s1 .4 1.5.3M83.7 80s1.8 6.6 9.2 8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M95.5 91.7s-1 2.8-8.2 2c-7.3-.6-10.3-5-10.3-5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M78.1 87.5s6.6 5 16.5 2.5c0 0 9.6 1 11.5 5.3 5.4 11.8.6 36.8 0 40 3.5 4-.4 8.4-.4 8.4-15.7-3.5-35.8-.6-35.8-.6-4.9-3.5-1.3-9-1.3-9l-6.2-23.8c-2.5-15.2.8-19.8 3.5-20.7 3-1 8-1.3 8-1.3.6 0 1.1 0 1.4-.2 2.4-1.3 2.8-.6 2.8-.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M65.8 89.8s-6.8.5-7.6 8.2c-.4 8.8 3 11 3 11s6.1 22 16.9 22.9c8.4-2.2 4.7-6.7 4.6-11.4-.2-11.3-7-17-7-17s-4.3-13.7-9.9-13.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M71.7 124.2s.9 11.3 9.8 6.5c4.8-2.5 7.6-13.8 9.8-22.6A201 201 0 0 0 94 96l-5-1.7s-2.4 5.6-7.7 12.3c-4.4 5.5-9.2 11.1-9.5 17.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M108.5 105.2s1.7 2.7-2.4 30.5c2.4 2.2 1 6-.2 7.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M123.3 131.5s-.5 2.8-11.8 2c-15.2-1-25.3-3.2-25.3-3.2l.9-5.8s.7.2 9.7-.1c11.9-.4 18.7-6 25-1 4 3.2 1.5 8.1 1.5 8.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M70.2 91s-5.6-4.8-11 2.7c-3.3 7.2.5 15.2 2.6 19.5-.3 3.8 2.4 4.3 2.4 4.3s0 1 1.5 2.7c4-7 6.7-9.1 13.7-12.5-.3-.7-1.9-3.3-1.8-3.8.2-1.7-1.3-2.6-1.3-2.6s-.3-.2-1.2-2.8c-.8-2.3-2-5.1-4.9-7.5"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CBD1D1",
        d: "M90.2 288s4.9 2.3 8.3 1.2c3.2-1 5.2.7 8 1.3a20 20 0 0 0 13.3-1.4c-.2-6.2-7.8-4.5-13.6-7.6-2.9-1.6-4.2-5.3-4-10H91.5s-1.5 12-1.3 16.5"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#2B0849",
        d: "M90.2 287.8s2.8 1.5 7.6.8c3.5-.5 3.3.6 7.5 1.3 4.2.6 13-.2 14.3-1.2.5 1.3-.4 2.4-.4 2.4s-1.7.6-5.4.9c-2.3.1-8.1.3-10.2-.6-2-1.6-4.9-1.5-6-.3-4.5 1.1-7.2-.3-7.2-.3l-.2-3z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A4AABA",
        d: "M98.4 272.3h3.5s0 7.5 5.2 9.6c-5.3.7-9.7-2.6-8.7-9.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CBD1D1",
        d: "M44.4 272s-2.2 7.8-4.7 13c-1.9 3.8-4.4 7.8 5.8 7.8 7 0 9.3-.5 7.7-7-1.6-6.3.3-13.8.3-13.8h-9z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#2B0849",
        d: "M38 290.3s2.3 1.2 7 1.2c6.4 0 8.7-1.7 8.7-1.7s.6 1.1-.7 2.2c-1 1-3.8 1.7-7.7 1.7-4.4 0-6.1-.6-7-1.3-1-.5-.8-1.6-.2-2.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A4AABA",
        d: "M45.3 274s0 1.6-.3 3.1-1.1 3.3-1.2 4.4c0 1.2 4.8 1.6 5.4 0 .7-1.6 1.4-6.8 2-7.6.7-.9-5.1-2.2-5.9.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#7BB2F9",
        d: "M89.5 277.6h13.9s1.3-56.6 1.9-66.8c.6-10.3 4-45.1 1-65.6l-13-.7-23.7.8-1.3 10.4c0 .5-.7.9-.8 1.4 0 .6.5 1.4.4 2L59.6 206c-.1.7-1.3 1-1.5 2.8 0 .3.2 1.6.1 1.8-7.1 19.5-12.2 52.6-15.6 67.2h15.1L62 259c3-13.3 24-88.3 24-88.3l3.2-1-.2 48.6s-.2 1.3.4 2.1c.5.8-.6 1.2-.4 2.4l.4 1.8-1 12.4c-.4 4.9 1.2 40.7 1.2 40.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M64.6 218.9c1.2 0 4.2-2.1 7.2-5.1m24.2 8.7s3-1.1 6.4-4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M97 219.4s2.9-1.2 6.3-4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M63.2 222.1s2.7-.6 6.7-3.5m5-72.4c-.3 3.2.3 8.8-4.5 9.4m22.8-11.3s.1 14.6-1.4 15.7c-2.3 1.7-3 2-3 2m.4-17s.3 13-1 25m-4.7.7s6.8-1 9.1-1M46 270l-.9 4.6m1.8-11.3-.8 4.1m16.6-64.9c-.3 1.6 0 2-.4 3.4 0 0-2.8 2-2.3 4s-.3 3.4-4.5 17.2c-1.8 5.8-4.3 19-6.2 28.3l-1.1 5.8m16-67-1 4.9m8.1-52.3-1.2 10.9s-1.2.1-.5 2.3c0 1.4-2.8 16.4-5.4 31.6m-20 82.1h13.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#192064",
        d: "M106.2 142.1c-3-.5-18.8-2.7-36.2.2a.6.6 0 0 0-.6.7v3a.6.6 0 0 0 .8.6c3.3-.5 17-2.4 35.6-.3.4 0 .7-.2.7-.5.2-1.4.2-2.5.2-3a.6.6 0 0 0-.5-.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M96.4 145.3v-5.1a.8.8 0 0 0-.8-.9 114.1 114.1 0 0 0-8.1 0 .8.8 0 0 0-.9.8v5.1c0 .5.4.9.9.9h8a.8.8 0 0 0 .9-.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#192064",
        d: "M95.2 144.3v-3.2a.7.7 0 0 0-.6-.7h-6.1a.7.7 0 0 0-.6.7v3.2c0 .4.3.7.6.7h6c.4 0 .7-.3.7-.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M90.1 273.5h12.8m-11.7-3.7v6.3m-.3-12.6v4.5m-.5-97.6 1 46.4s.7 1.6-.3 2.8c-.9 1.1 2.6.7 1 2.3-1.7 1.6.9 1.2 0 3.5-.6 1.6-1 22-1.2 36.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M73.7 98.7 76 103s2 .8 1.8 2.7l.8 2.2m-14.3 8.7c.2-1 2.2-7.1 12.6-10.5m.7-16s7.7 6 16.5 2.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M92 87s5.5-.9 7.5-4.6c1.3-.3.8 2.2-.3 3.7l-1 1.5s.2.3.2.9c0 .6-.2.6-.3 1v1l-.4 1c-.1.2 0 .6-.2.9-.2.4-1.6 1.8-2.6 2.8-3.8 3.6-5 1.7-6-.4-1-1.8-.7-5.1-.9-6.9-.3-2.9-2.6-3-2-4.4.4-.7 3 .7 3.4 1.8.7 2 2.9 1.8 2.6 1.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M99.8 82.4c-.5.1-.3.3-1 1.3-.6 1-4.8 2.9-6.4 3.2-2.5.5-2.2-1.6-4.2-2.9-1.7-1-3.6-.6-1.4 1.4 1 1 1 1.1 1.4 3.2.3 1.5-.7 3.7.7 5.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E59788",
        d: "M79.5 108.7c-2 2.9-4.2 6.1-5.5 8.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M87.7 124.8s-2-2-5.1-2.8c-3-.7-3.6-.1-5.5.1-2 .3-4-.9-3.7.7.3 1.7 5 1 5.2 2.1.2 1.1-6.3 2.8-8.3 2.2-.8.8.5 1.9 2 2.2.3 1.5 2.3 1.5 2.3 1.5s.7 1 2.6 1.1c2.5 1.3 9-.7 11-1.5 2-.9-.5-5.6-.5-5.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E59788",
        d: "M73.4 122.8s.7 1.2 3.2 1.4c2.3.3 2.6.6 2.6.6s-2.6 3-9.1 2.3m2.3 2.2s3.8 0 5-.7m-2.4 2.2s2 0 3.3-.6m-1 1.7s1.7 0 2.8-.5m-6.8-9s-.6-1.1 1.3-.5c1.7.5 2.8 0 5.1.1 1.4.1 3-.2 4 .2 1.6.8 3.6 2.2 3.6 2.2s10.6 1.2 19-1.1M79 108s-8.4 2.8-13.2 12.1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M109.3 112.5s3.4-3.6 7.6-4.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E59788",
        d: "M107.4 123s9.7-2.7 11.4-.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#BFCDDD",
        d: "m194.6 83.7 4-4M187.2 91l3.7-3.6m.9-3-4.5-4.7m11.2 11.5-4.2-4.3m-65 76.3 3.7-3.7M122.3 170l3.5-3.5m.8-2.9-4.3-4.2M133 170l-4-4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A3B4C6",
        d: "M190.2 211.8h-1.6a4 4 0 0 1-4-4v-32.1a4 4 0 0 1 4-4h1.6a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A3B4C6",
        d: "M237.8 213a4.8 4.8 0 0 1-4.8 4.8h-86.6a4.8 4.8 0 0 1 0-9.6H233a4.8 4.8 0 0 1 4.8 4.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A3B4C6",
        d: "M154.1 190.1h70.5v-84.6h-70.5z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#BFCDDD",
        d: "M225 190.1h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2m0-59.3h-71.1a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.3v19a3.2 3.2 0 0 1-3.2 3.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M159.6 120.5a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8v-3.2c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#BFCDDD",
        d: "M225 160.5h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#7C90A5",
        d: "M173.5 130.8h49.3m-57.8 0h6m-15 0h6.7m11.1 29.8h49.3m-57.7 0h6m-15.8 0h6.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M159.6 151a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V147c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8m-63 29a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.5 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V176c0-.5.3-.8.8-.8h22.4c.5 0 .8.3.8.8v3.2c0 .4-.3.8-.8.8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#BFCDDD",
        d: "M203 221.1h-27.3a2.4 2.4 0 0 1-2.4-2.4v-11.4a2.4 2.4 0 0 1 2.4-2.5H203a2.4 2.4 0 0 1 2.4 2.5v11.4a2.4 2.4 0 0 1-2.4 2.4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#A3B4C6",
        d: "M177.3 207.2v11.5m23.8-11.5v11.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#5BA02E",
        d: "M162.9 267.9a9.4 9.4 0 0 1-9.4-9.4v-14.8a9.4 9.4 0 0 1 18.8 0v14.8a9.4 9.4 0 0 1-9.4 9.4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#92C110",
        d: "M171.2 267.8a9.4 9.4 0 0 1-9.4-9.4V255a9.4 9.4 0 0 1 18.8 0v3.4a9.4 9.4 0 0 1-9.4 9.4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F2D7AD",
        d: "M181.3 293.7h-27.7a3.2 3.2 0 0 1-3.2-3.2v-20.7a3.2 3.2 0 0 1 3.2-3.2h27.7a3.2 3.2 0 0 1 3.2 3.2v20.7a3.2 3.2 0 0 1-3.2 3.2"
    })));
var $52cda3972f7a928b$export$2e2bcd8739ae039 = $52cda3972f7a928b$var$ServerError;




// ============================== Styles ==============================
const $d9a6d68df32f1249$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, lineHeightHeading3: lineHeightHeading3, iconCls: iconCls, padding: padding, paddingXL: paddingXL, paddingXS: paddingXS, paddingLG: paddingLG, marginXS: marginXS, lineHeight: lineHeight } = token;
    return {
        // Result
        [componentCls]: {
            padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(paddingLG).mul(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXL)}`,
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // Exception Status image
        [`${componentCls} ${componentCls}-image`]: {
            width: token.imageWidth,
            height: token.imageHeight,
            margin: 'auto'
        },
        [`${componentCls} ${componentCls}-icon`]: {
            marginBottom: paddingLG,
            textAlign: 'center',
            [`& > ${iconCls}`]: {
                fontSize: token.iconFontSize
            }
        },
        [`${componentCls} ${componentCls}-title`]: {
            color: token.colorTextHeading,
            fontSize: token.titleFontSize,
            lineHeight: lineHeightHeading3,
            marginBlock: marginXS,
            textAlign: 'center'
        },
        [`${componentCls} ${componentCls}-subtitle`]: {
            color: token.colorTextDescription,
            fontSize: token.subtitleFontSize,
            lineHeight: lineHeight,
            textAlign: 'center'
        },
        [`${componentCls} ${componentCls}-body`]: {
            marginTop: paddingLG,
            padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(padding).mul(2.5).equal())}`,
            backgroundColor: token.colorFillAlter
        },
        [`${componentCls} ${componentCls}-extra`]: {
            margin: token.extraMargin,
            textAlign: 'center',
            '& > *': {
                marginInlineEnd: paddingXS,
                '&:last-child': {
                    marginInlineEnd: 0
                }
            }
        }
    };
};
const $d9a6d68df32f1249$var$genStatusIconStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-success ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultSuccessIconColor
        },
        [`${componentCls}-error ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultErrorIconColor
        },
        [`${componentCls}-info ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultInfoIconColor
        },
        [`${componentCls}-warning ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultWarningIconColor
        }
    };
};
const $d9a6d68df32f1249$var$genResultStyle = (token)=>[
        $d9a6d68df32f1249$var$genBaseStyle(token),
        $d9a6d68df32f1249$var$genStatusIconStyle(token)
    ];
const $d9a6d68df32f1249$export$9ca1be8807fe0675 = (token)=>({
        titleFontSize: token.fontSizeHeading3,
        subtitleFontSize: token.fontSize,
        iconFontSize: token.fontSizeHeading3 * 3,
        extraMargin: `${token.paddingLG}px 0 0 0`
    });
var $d9a6d68df32f1249$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Result', (token)=>{
    const resultInfoIconColor = token.colorInfo;
    const resultErrorIconColor = token.colorError;
    const resultSuccessIconColor = token.colorSuccess;
    const resultWarningIconColor = token.colorWarning;
    const resultToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        resultInfoIconColor: resultInfoIconColor,
        resultErrorIconColor: resultErrorIconColor,
        resultSuccessIconColor: resultSuccessIconColor,
        resultWarningIconColor: resultWarningIconColor,
        imageWidth: 250,
        imageHeight: 295
    });
    return $d9a6d68df32f1249$var$genResultStyle(resultToken);
}, $d9a6d68df32f1249$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");
"use client";
const $613dcb7464547760$var$Unauthorized = ()=>/*#__PURE__*/ $acw62.createElement("svg", {
        width: "251",
        height: "294"
    }, /*#__PURE__*/ $acw62.createElement("title", null, "Unauthorized"), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#E4EBF7",
        d: "M0 129v-2C0 58.3 55.6 2.7 124.2 2.7h2c68.6 0 124.2 55.6 124.2 124.1v2.1c0 68.6-55.6 124.2-124.1 124.2h-2.1A124.2 124.2 0 0 1 0 129"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M41.4 133a8.2 8.2 0 1 1-16.4-1.7 8.2 8.2 0 0 1 16.4 1.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m38.7 136.4 10.4 5.9m.9 6.2-12.6 10.7",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M41.5 161.3a5.6 5.6 0 1 1-11.2-1.2 5.6 5.6 0 0 1 11.2 1.2m17.7-16a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m41.2-115.8H130a4.6 4.6 0 1 0 0-9.1h-29.6a4.6 4.6 0 0 0 0 9.1m11.3 18.3h29.7a4.6 4.6 0 1 0 0-9.2h-29.7a4.6 4.6 0 1 0 0 9.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M114 29.5h15.8a4.6 4.6 0 1 0 0 9.1H114a4.6 4.6 0 0 0 0-9.1m71.3 108.2a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m180.2 143.8 12.5 7.1m1.1 7.5-15.1 13",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M185.6 172a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.5 1.3m18.6-16.6a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.6 1.4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "M153 194a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm73-75.8a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm-9 34.9a2.2 2.2 0 1 1-4.3 0 2.2 2.2 0 0 1 4.4 0zm-39.2-43.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.3-15.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm6.7 88a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0z",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#FFF",
        d: "m215.1 155.3-1.9 20-10.8 6m-27.8-4.7-6.3 9.8H157l-4.5 6.4m23.4-65.5v-15.7m45.6 7.8-12.8 7.9-15.2-7.9V96.7",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A26EF4",
        d: "M180.7 29.3a29.3 29.3 0 1 1 58.6 0 29.3 29.3 0 0 1-58.6 0"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "m221.4 41.7-21.5-.1a1.7 1.7 0 0 1-1.7-1.8V27.6a1.7 1.7 0 0 1 1.8-1.7h21.5c1 0 1.8.9 1.8 1.8l-.1 12.3a1.7 1.7 0 0 1-1.7 1.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M215.1 29.2c0 2.6-2 4.6-4.5 4.6a4.6 4.6 0 0 1-4.5-4.7v-6.9c0-2.6 2-4.6 4.6-4.6 2.5 0 4.5 2 4.4 4.7v6.9zm-4.5-14a6.9 6.9 0 0 0-7 6.8v7.3a6.9 6.9 0 0 0 13.8.1V22a6.9 6.9 0 0 0-6.8-6.9zm-43 53.2h-4a4.7 4.7 0 0 1-4.7-4.8 4.7 4.7 0 0 1 4.7-4.7h4a4.7 4.7 0 0 1 4.7 4.8 4.7 4.7 0 0 1-4.7 4.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#5BA02E",
        d: "M168.2 248.8a6.6 6.6 0 0 1-6.6-6.6v-66a6.6 6.6 0 0 1 13.2 0v66a6.6 6.6 0 0 1-6.6 6.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#92C110",
        d: "M176.1 248.2a6.6 6.6 0 0 1-6.6-6.6v-33a6.6 6.6 0 1 1 13.3 0v33a6.6 6.6 0 0 1-6.7 6.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#F2D7AD",
        d: "M186 293.9h-27.4a3.2 3.2 0 0 1-3.2-3.2v-45.9a3.2 3.2 0 0 1 3.2-3.1H186a3.2 3.2 0 0 1 3.2 3.1v46a3.2 3.2 0 0 1-3.2 3"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M82 147.7s6.3-1 17.5-1.3c11.8-.4 17.6 1 17.6 1s3.7-3.8 1-8.3c1.3-12.1 6-32.9.3-48.3-1.1-1.4-3.7-1.5-7.5-.6-1.4.3-7.2-.2-8-.1l-15.3-.4-8-.5c-1.6-.1-4.3-1.7-5.5-.3-.4.4-2.4 5.6-2 16l8.7 35.7s-3.2 3.6 1.2 7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "m75.8 73.3-1-6.4 12-6.5s7.4-.1 8 1.2c.8 1.3-5.5 1-5.5 1s-1.9 1.4-2.6 2.5c-1.7 2.4-1 6.5-8.4 6-1.7.3-2.5 2.2-2.5 2.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFB594",
        d: "M52.4 77.7S66.7 87 77.4 92c1 .5-2 16.2-11.9 11.8-7.4-3.3-20.1-8.4-21.5-14.5-.7-3.2 2.6-7.6 8.4-11.7M142 80s-6.7 3-13.9 6.9c-3.9 2.1-10.1 4.7-12.3 8-6.2 9.3 3.5 11.2 13 7.5 6.6-2.7 29-12.1 13.2-22.4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "m76.2 66.4 3 3.8S76.4 73 73 76c-7 6.2-12.8 14.3-16 16.4-4 2.7-9.7 3.3-12.2 0-3.5-5.1.5-14.7 31.5-26"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M64.7 85.1s-2.4 8.4-9 14.5c.7.5 18.6 10.5 22.2 10 5.2-.6 6.4-19 1.2-20.5-.8-.2-6-1.3-8.9-2.2-.9-.2-1.6-1.7-3.5-1l-2-.8zm63.7.7s5.3 2 7.3 13.8c-.6.2-17.6 12.3-21.8 7.8-6.6-7-.8-17.4 4.2-18.6 4.7-1.2 5-1.4 10.3-3"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M78.2 94.7s.9 7.4-5 13",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M87.4 94.7s3.1 2.6 10.3 2.6c7.1 0 9-3.5 9-3.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".9"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "m117.2 68.6-6.8-6.1s-5.4-4.4-9.2-1c-3.9 3.5 4.4 2.2 5.6 4.2 1.2 2.1.9 1.2-2 .5-5.7-1.4-2.1.9 3 5.3 2 1.9 7 1 7 1l2.4-3.9z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFB594",
        d: "m105.3 91.3-.3-11H89l-.5 10.5c0 .4.2.8.6 1 2 1.3 9.3 5 15.8.4.2-.2.4-.5.4-.9"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#5C2552",
        d: "M107.6 74.2c.8-1.1 1-9 1-11.9a1 1 0 0 0-1-1l-4.6-.4c-7.7-1-17 .6-18.3 6.3-5.4 5.9-.4 13.3-.4 13.3s2 3.5 4.3 6.8c.8 1 .4-3.8 3-6a47.9 47.9 0 0 1 16-7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "M88.4 83.2s2.7 6.2 11.6 6.5c7.8.3 9-7 7.5-17.5l-1-5.5c-6-2.9-15.4.6-15.4.6s-.6 2-.2 5.5c-2.3 2-1.8 5.6-1.8 5.6s-1-2-2-2.3c-.9-.3-2 0-2.3 2-1 4.6 3.6 5.1 3.6 5.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "m100.8 77.1 1.7-1-1-4.3.7-1.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#552950",
        d: "M105.5 74c0 .8-.4 1.4-1 1.4-.4 0-.8-.7-.8-1.4s.5-1.2 1-1.2.9.6.8 1.3m-8 .2c0 .8-.4 1.3-.9 1.3s-.9-.6-.9-1.3c0-.7.5-1.3 1-1.3s1 .6.9 1.3"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M91.1 86.8s5.3 5 12.7 2.3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#DB836E",
        d: "M99.8 81.9s-3.6.2-1.5-2.8c1.6-1.5 5-.4 5-.4s1 3.9-3.5 3.2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#5C2552",
        d: "M102.9 70.6s2.5.8 3.4.7m-12.4.7s2.5-1.2 4.8-1.1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M86.3 77.4s1 .9 1.5 2c-.4.6-1 1.2-.3 1.9m11.8 2.4s2 .2 2.5-.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "m87.8 115.8 15.7-3m-3.3 3 10-2m-43.7-27s-1.6 8.8-6.7 14M128.3 88s3 4 4 11.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M64 84.8s-6 10-13.5 10",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFC6A0",
        d: "m112.4 66-.2 5.2 12 9.2c4.5 3.6 8.9 7.5 11 8.7 4.8 2.8 8.9 3.3 11 1.8 4.1-2.9 4.4-9.9-8.1-15.3-4.3-1.8-16.1-6.3-25.7-9.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#DB836E",
        d: "M130.5 85.5s4.6 5.7 11.7 6.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#E4EBF7",
        d: "M121.7 105.7s-.4 8.6-1.3 13.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M115.8 161.5s-3.6-1.5-2.7-7.1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CBD1D1",
        d: "M101.5 290.2s4.3 2.1 7.4 1c2.9-.9 4.6.7 7.2 1.3 2.5.5 6.9 1 11.7-1.3 0-5.6-7-4-12-6.8-2.6-1.4-3.8-4.7-3.6-8.8h-9.5s-1.4 10.6-1.2 14.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#2B0849",
        d: "M101.5 290s2.4 1.4 6.8.7c3-.4 3.7.5 7.5 1 3.7.6 10.8 0 11.9-.8.4 1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.7-.5-1.8-1.4-5.2-2-5.7-.3-4 1-7.4-.3-7.4-.3l-.2-2.6z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A4AABA",
        d: "M108.8 276.2h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#CBD1D1",
        d: "M57.6 272.5s-2 7.5-4.5 12.4c-1.8 3.7-4.2 7.6 5.5 7.6 6.7 0 9-.5 7.5-6.7-1.5-6.1.3-13.3.3-13.3h-8.8z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#2B0849",
        d: "M51.5 290s2.2 1.2 6.7 1.2c6.1 0 8.3-1.6 8.3-1.6s.6 1-.6 2.1c-1 .9-3.6 1.6-7.4 1.6-4.2 0-6-.6-6.8-1.2-.9-.5-.7-1.6-.2-2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#A4AABA",
        d: "M58.5 274.4s0 1.6-.3 3-1 3.1-1.1 4.2c0 1.1 4.5 1.5 5.2 0 .6-1.6 1.3-6.5 1.9-7.3.6-.8-5-2.1-5.7.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#7BB2F9",
        d: "m100.9 277 13.3.1s1.3-54.2 1.8-64c.6-9.9 3.8-43.2 1-62.8l-12.4-.7-22.8.8-1.2 10c0 .4-.6.8-.7 1.3 0 .6.4 1.3.3 2-2.3 14-6.3 32.9-8.7 46.4-.1.6-1.2 1-1.4 2.6 0 .3.2 1.6 0 1.8-6.8 18.7-10.8 47.6-14.1 61.6h14.5s2.2-8.6 4-17a3984 3984 0 0 1 23-84.5l3-.5 1 46.1s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.7-1 11.9c-.4 4.6 0 39 0 39"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M77.4 220.4c1.2.1 4-2 7-4.9m23.1 8.4s2.8-1 6.1-3.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M108.5 221s2.7-1.2 6-4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M76.1 223.6s2.6-.6 6.5-3.4m4.7-69.4c-.2 3.1.3 8.5-4.3 9m21.8-10.7s.1 14-1.3 15c-2.2 1.6-3 1.9-3 1.9m.5-16.4s0 12.8-1.2 24.3m-4.9 1s7.2-1.6 9.4-1.6m-28.6 31.5-1 4.5s-1.5 1.8-1 3.7c.4 2-1 2-5 15.3-1.7 5.6-4.4 18.5-6.3 27.5l-4 18.4M77 196.7a313.3 313.3 0 0 1-.8 4.8m7.7-50-1.2 10.3s-1 .2-.5 2.3c.1 1.3-2.6 15.6-5.1 30.2M57.6 273h13.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#192064",
        d: "M117.4 147.4s-17-3-35.7.2v4.2s14.6-2.9 35.5-.4l.2-4"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#FFF",
        d: "M107.5 150.4v-5a.8.8 0 0 0-.8-.7H99a.8.8 0 0 0-.7.8v4.8c0 .5.3.9.8.8a140.8 140.8 0 0 1 7.7 0 .8.8 0 0 0 .8-.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: "#192064",
        d: "M106.4 149.4v-3a.6.6 0 0 0-.6-.7 94.1 94.1 0 0 0-5.8 0 .6.6 0 0 0-.7.7v3c0 .4.3.7.7.7h5.7c.4 0 .7-.3.7-.7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "#648BD8",
        d: "M101.5 274h12.3m-11.1-5v6.5m0-12.4v4.3m-.5-93.4.9 44.4s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.1 0 3.4-.6 1.5-1 21-1.1 35",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    })));
var $613dcb7464547760$export$2e2bcd8739ae039 = $613dcb7464547760$var$Unauthorized;


"use client";
const $327cc81a9ba2f000$export$e75cf43d5d0a9444 = {
    success: (0, $9149fdfb4424d1d9$export$2e2bcd8739ae039),
    error: (0, $81ff9dc68eb84eda$export$2e2bcd8739ae039),
    info: (0, $2444f6da62064575$export$2e2bcd8739ae039),
    warning: (0, $3f0d8fd9f57ea6fb$export$2e2bcd8739ae039)
};
const $327cc81a9ba2f000$export$14ba5e3dd65c935a = {
    '404': (0, $30eb2e921dbc382e$export$2e2bcd8739ae039),
    '500': (0, $52cda3972f7a928b$export$2e2bcd8739ae039),
    '403': (0, $613dcb7464547760$export$2e2bcd8739ae039)
};
// ExceptionImageMap keys
const $327cc81a9ba2f000$var$ExceptionStatus = Object.keys($327cc81a9ba2f000$export$14ba5e3dd65c935a);
const $327cc81a9ba2f000$var$Icon = ({ icon: icon, status: status, className: className, style: style })=>{
    if ($327cc81a9ba2f000$var$ExceptionStatus.includes(`${status}`)) {
        const SVGComponent = $327cc81a9ba2f000$export$14ba5e3dd65c935a[status];
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: className,
            style: style
        }, /*#__PURE__*/ $acw62.createElement(SVGComponent, null));
    }
    const iconNode = /*#__PURE__*/ $acw62.createElement($327cc81a9ba2f000$export$e75cf43d5d0a9444[status]);
    if (icon === null || icon === false) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, icon || iconNode);
};
const $327cc81a9ba2f000$var$Extra = ({ className: className, extra: extra, style: style })=>{
    if (!extra) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, extra);
};
const $327cc81a9ba2f000$var$Result = (props)=>{
    const { prefixCls: customizePrefixCls, className: customizeClassName, rootClassName: rootClassName, subTitle: subTitle, title: title, style: style, children: children, status: status = 'info', icon: icon, extra: extra, styles: styles, classNames: classNames, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('result');
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        status: status
    };
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('result', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $d9a6d68df32f1249$export$2e2bcd8739ae039)(prefixCls);
    const rootClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${status}`, customizeClassName, contextClassName, rootClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, cssVarCls, mergedClassNames.root);
    const titleClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title);
    const subTitleClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-subtitle`, mergedClassNames.subTitle);
    const extraClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra);
    const bodyClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body);
    const iconClassNames = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, {
        [`${prefixCls}-image`]: $327cc81a9ba2f000$var$ExceptionStatus.includes(`${status}`)
    }, mergedClassNames.icon);
    const rootStyles = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const restProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(rest, {
        aria: true,
        data: true
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        ...restProps,
        className: rootClassNames,
        style: rootStyles
    }, /*#__PURE__*/ $acw62.createElement($327cc81a9ba2f000$var$Icon, {
        className: iconClassNames,
        style: mergedStyles.icon,
        status: status,
        icon: icon
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: titleClassNames,
        style: mergedStyles.title
    }, title), subTitle && /*#__PURE__*/ $acw62.createElement("div", {
        className: subTitleClassNames,
        style: mergedStyles.subTitle
    }, subTitle), /*#__PURE__*/ $acw62.createElement($327cc81a9ba2f000$var$Extra, {
        className: extraClassNames,
        extra: extra,
        style: mergedStyles.extra
    }), children && /*#__PURE__*/ $acw62.createElement("div", {
        className: bodyClassNames,
        style: mergedStyles.body
    }, children));
};
$327cc81a9ba2f000$var$Result.PRESENTED_IMAGE_403 = $327cc81a9ba2f000$export$14ba5e3dd65c935a['403'];
$327cc81a9ba2f000$var$Result.PRESENTED_IMAGE_404 = $327cc81a9ba2f000$export$14ba5e3dd65c935a['404'];
$327cc81a9ba2f000$var$Result.PRESENTED_IMAGE_500 = $327cc81a9ba2f000$export$14ba5e3dd65c935a['500'];
var $327cc81a9ba2f000$export$2e2bcd8739ae039 = $327cc81a9ba2f000$var$Result;


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $20d973f7249e2921$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $20d973f7249e2921$export$2e2bcd8739ae039 = $20d973f7249e2921$var$EditOutlined;



function $498b707c3c04dc0a$var$_extends() {
    $498b707c3c04dc0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $498b707c3c04dc0a$var$_extends.apply(this, arguments);
}
const $498b707c3c04dc0a$var$EditOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $498b707c3c04dc0a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $20d973f7249e2921$export$2e2bcd8739ae039)
    }));
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ const $498b707c3c04dc0a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($498b707c3c04dc0a$var$EditOutlined);
var $498b707c3c04dc0a$export$2e2bcd8739ae039 = $498b707c3c04dc0a$var$RefIcon;









const $fc429b640022d4cc$var$isStyleNameSupport = (styleName)=>{
    if ((0, $3c4e22d7f3adf1ca$export$2e2bcd8739ae039)() && window.document.documentElement) {
        const styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        const { documentElement: documentElement } = window.document;
        return styleNameList.some((name)=>name in documentElement.style);
    }
    return false;
};
const $fc429b640022d4cc$var$isStyleValueSupport = (styleName, value)=>{
    if (!$fc429b640022d4cc$var$isStyleNameSupport(styleName)) return false;
    const ele = document.createElement('div');
    const origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $fc429b640022d4cc$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $fc429b640022d4cc$var$isStyleValueSupport(styleName, styleValue);
    return $fc429b640022d4cc$var$isStyleNameSupport(styleName);
}






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $579f6109eaa96326$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $579f6109eaa96326$export$2e2bcd8739ae039 = $579f6109eaa96326$var$EnterOutlined;



function $ac0f9536ca737b46$var$_extends() {
    $ac0f9536ca737b46$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac0f9536ca737b46$var$_extends.apply(this, arguments);
}
const $ac0f9536ca737b46$var$EnterOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $ac0f9536ca737b46$var$_extends({}, props, {
        ref: ref,
        icon: (0, $579f6109eaa96326$export$2e2bcd8739ae039)
    }));
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $ac0f9536ca737b46$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ac0f9536ca737b46$var$EnterOutlined);
var $ac0f9536ca737b46$export$2e2bcd8739ae039 = $ac0f9536ca737b46$var$RefIcon;








/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ 

const $950f24b0c690e3c4$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $950f24b0c690e3c4$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $950f24b0c690e3c4$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $950f24b0c690e3c4$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    const linkCls = `${componentCls}-link`;
    return {
        [`&${linkCls}`]: {
            ...(0, $4733a3b3eb18f80d$export$9a16e7694a707ab4)(token),
            userSelect: 'text',
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:active, &:hover': {
                    color: token.colorTextDisabled
                },
                '&:active': {
                    pointerEvents: 'none',
                    // Action buttons (copy, edit, expand) must remain interactive even when
                    // the disabled link is being clicked, otherwise their click events get
                    // swallowed by the parent's pointer-events: none during :active.
                    [`${componentCls}-actions`]: {
                        pointerEvents: 'auto'
                    }
                }
            }
        }
    };
};
const $950f24b0c690e3c4$export$977383a86f45014b = (token)=>({
        code: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.2em 0.1em',
            fontSize: '85%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3
        },
        kbd: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.15em 0.1em',
            fontSize: '90%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.06)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $0b4842326956570d$export$c24201f7fe3571d8)[2]
        },
        'u, ins': {
            textDecoration: 'underline',
            textDecorationSkipInk: 'auto'
        },
        's, del': {
            textDecoration: 'line-through'
        },
        strong: {
            fontWeight: token.fontWeightStrong
        },
        // list
        'ul, ol': {
            marginInline: 0,
            marginBlock: '0 1em',
            padding: 0,
            li: {
                marginInline: '20px 0',
                marginBlock: 0,
                paddingInline: '4px 0',
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: 'circle',
            ul: {
                listStyleType: 'disc'
            }
        },
        ol: {
            listStyleType: 'decimal'
        },
        // pre & block
        'pre, blockquote': {
            margin: '1em 0'
        },
        pre: {
            padding: '0.4em 0.6em',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: 'inline',
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit',
                background: 'transparent',
                border: 0
            }
        },
        blockquote: {
            paddingInline: '0.6em 0',
            paddingBlock: 0,
            borderInlineStart: '4px solid rgba(100, 100, 100, 0.2)',
            opacity: 0.85
        }
    });
const $950f24b0c690e3c4$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        '&-edit-content': {
            position: 'relative',
            'div&': {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                insetBlockStart: token.calc(inputShift).div(-2).add(1).equal(),
                marginBottom: token.calc(inputShift).div(2).sub(2).equal()
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: 'absolute',
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorIcon,
                // default style
                fontWeight: 'normal',
                fontSize: token.fontSize,
                fontStyle: 'normal',
                pointerEvents: 'none'
            },
            textarea: {
                margin: '0!important',
                // Fix Editable Textarea flash in Firefox
                MozTransition: 'none',
                height: '1em'
            }
        }
    };
};
const $950f24b0c690e3c4$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            '&, &:hover, &:focus': {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $950f24b0c690e3c4$export$d9556a50eba3003b = ()=>({
        'a&-ellipsis, span&-ellipsis': {
            display: 'inline-block',
            maxWidth: '100%'
        },
        '&-ellipsis-single-line': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // https://blog.csdn.net/iefreer/article/details/50421025
            'a&, span&': {
                verticalAlign: 'bottom'
            },
            '> code': {
                paddingBlock: 0,
                maxWidth: 'calc(100% - 1.2em)',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: 'content-box'
            }
        },
        '&-ellipsis-multiple-line': {
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
        }
    });


const $29a5bb3c87e057f0$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: {
            color: token.colorText,
            wordBreak: 'break-word',
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary, &${componentCls}-link${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success, &${componentCls}-link${componentCls}-success`]: {
                color: token.colorSuccessText
            },
            [`&${componentCls}-warning, &${componentCls}-link${componentCls}-warning`]: {
                color: token.colorWarningText
            },
            [`&${componentCls}-danger, &${componentCls}-link${componentCls}-danger`]: {
                color: token.colorErrorText,
                [`&${componentCls}-link:active, &${componentCls}-link:focus`]: {
                    color: token.colorErrorTextActive
                },
                [`&${componentCls}-link:hover`]: {
                    color: token.colorErrorTextHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                userSelect: 'none'
            },
            'div&, p': {
                marginBottom: '1em'
            },
            ...(0, $950f24b0c690e3c4$export$83146cf7d1bec659)(token),
            [`& + h1${componentCls}, & + h2${componentCls}, & + h3${componentCls}, & + h4${componentCls}, & + h5${componentCls}`]: {
                marginTop: titleMarginTop
            },
            'div, ul, li, p, h1, h2, h3, h4, h5': {
                '+ h1, + h2, + h3, + h4, + h5': {
                    marginTop: titleMarginTop
                }
            },
            ...(0, $950f24b0c690e3c4$export$977383a86f45014b)(token),
            ...(0, $950f24b0c690e3c4$export$566f4066c7caac18)(token),
            // Operation
            [`${componentCls}-actions`]: {
                display: 'inline'
            },
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: {
                ...(0, $4733a3b3eb18f80d$export$9a16e7694a707ab4)(token),
                marginInlineStart: token.marginXXS
            },
            ...(0, $950f24b0c690e3c4$export$2667badb03518972)(token),
            ...(0, $950f24b0c690e3c4$export$34755446404037a5)(token),
            ...(0, $950f24b0c690e3c4$export$d9556a50eba3003b)(),
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
const $29a5bb3c87e057f0$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: '1.2em',
        titleMarginBottom: '0.5em'
    });
var // ============================== Export ==============================
$29a5bb3c87e057f0$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Typography', $29a5bb3c87e057f0$var$genTypographyStyle, $29a5bb3c87e057f0$export$9ca1be8807fe0675);


"use client";
const $8a5b8988dc6b65c3$var$Editable = (props)=>{
    const { prefixCls: prefixCls, 'aria-label': ariaLabel, className: className, style: style, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $acw62.createElement((0, $ac0f9536ca737b46$export$2e2bcd8739ae039), null) } = props;
    const ref = $acw62.useRef(null);
    const inCompositionRef = $acw62.useRef(false);
    const lastKeyCodeRef = $acw62.useRef(null);
    const [current, setCurrent] = $acw62.useState(value);
    $acw62.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $acw62.useEffect(()=>{
        if (ref.current?.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = ({ target: target })=>{
        setCurrent(target.value.replace(/[\n\r]/g, ''));
    };
    const onCompositionStart = ()=>{
        inCompositionRef.current = true;
    };
    const onCompositionEnd = ()=>{
        inCompositionRef.current = false;
    };
    const onKeyDown = ({ keyCode: keyCode })=>{
        // We don't record keyCode when IME is using
        if (inCompositionRef.current) return;
        lastKeyCodeRef.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = ({ keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        // Check if it's a real key
        if (lastKeyCodeRef.current !== keyCode || inCompositionRef.current || ctrlKey || altKey || metaKey || shiftKey) return;
        if (keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) {
            confirmChange();
            onEnd?.();
        } else if (keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ESC) onCancel();
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const [hashId, cssVarCls] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${component}`]: !!component
    }, className, hashId, cssVarCls);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $fc29eec8796e8593$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $30796c32f374b477$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null);
};
var $8a5b8988dc6b65c3$export$2e2bcd8739ae039 = $8a5b8988dc6b65c3$var$Editable;



var $acw62 = parcelRequire("acw62");


const $c21e25046bb64b97$var$execCopy = (text, isHtmlFormat)=>{
    let copySuccess = false;
    const onCopy = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        event.clipboardData?.clearData();
        event.clipboardData?.setData('text/plain', text);
        if (isHtmlFormat) event.clipboardData?.setData('text/html', text);
        copySuccess = true;
    };
    try {
        document.addEventListener('copy', onCopy, {
            capture: true
        });
        document.execCommand('copy');
        return copySuccess;
    } catch  {
        return false;
    } finally{
        document.removeEventListener('copy', onCopy, {
            capture: true
        });
    }
};
const $c21e25046bb64b97$var$asyncCopy = async (text, isHtmlFormat)=>{
    try {
        if (isHtmlFormat) await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([
                    text
                ], {
                    type: 'text/html'
                }),
                'text/plain': new Blob([
                    text
                ], {
                    type: 'text/plain'
                })
            })
        ]);
        else await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        return false;
    }
};
async function $c21e25046bb64b97$var$copy(text, config) {
    if (typeof text !== 'string') return false;
    const isHtmlFormat = config?.format === 'text/html';
    if (await $c21e25046bb64b97$var$asyncCopy(text, isHtmlFormat)) return true;
    if ($c21e25046bb64b97$var$execCopy(text, isHtmlFormat)) return true;
    return false;
}
var $c21e25046bb64b97$export$2e2bcd8739ae039 = $c21e25046bb64b97$var$copy;



const $c668f727bdc41d13$var$toList = (val, config = {})=>{
    if (!(0, $b956dab96d0e505b$export$826fff653a329e83)(val) && config?.skipEmpty) return [];
    return Array.isArray(val) ? val : [
        val
    ];
};
var $c668f727bdc41d13$export$2e2bcd8739ae039 = $c668f727bdc41d13$var$toList;


const $03d6c4dc81f23be0$var$useCopyClick = ({ copyConfig: copyConfig, children: children })=>{
    const [copied, setCopied] = $acw62.useState(false);
    const [copyLoading, setCopyLoading] = $acw62.useState(false);
    const copyIdRef = $acw62.useRef(null);
    const cleanCopyId = ()=>{
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    $acw62.useEffect(()=>cleanCopyId, []);
    // Keep copy action up to date
    const onClick = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)(async (e)=>{
        e?.preventDefault();
        e?.stopPropagation();
        setCopyLoading(true);
        try {
            const text = typeof copyConfig.text === 'function' ? await copyConfig.text() : copyConfig.text;
            await (0, $c21e25046bb64b97$export$2e2bcd8739ae039)(text || (0, $c668f727bdc41d13$export$2e2bcd8739ae039)(children, {
                skipEmpty: true
            }).join('') || '', copyOptions);
            setCopyLoading(false);
            setCopied(true);
            // Trigger tips update
            cleanCopyId();
            copyIdRef.current = setTimeout(()=>{
                setCopied(false);
            }, 3000);
            copyConfig.onCopy?.(e);
        } catch (error) {
            setCopyLoading(false);
            throw error;
        }
    });
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $03d6c4dc81f23be0$export$2e2bcd8739ae039 = $03d6c4dc81f23be0$var$useCopyClick;



var $acw62 = parcelRequire("acw62");
function $4f54d14ab15fca01$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $acw62.useMemo(()=>{
        const support = !!propConfig;
        return [
            support,
            {
                ...templateConfig,
                ...support && typeof propConfig === 'object' ? propConfig : null
            }
        ];
    }, [
        propConfig
    ]);
}



var $acw62 = parcelRequire("acw62");
const $4564445e53d0f3b9$var$usePrevious = (value)=>{
    const ref = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $4564445e53d0f3b9$export$2e2bcd8739ae039 = $4564445e53d0f3b9$var$usePrevious;



var $acw62 = parcelRequire("acw62");

const $ccc30a03cba8168b$var$useTooltipProps = (tooltip, editConfigText, children)=>(0, $acw62.useMemo)(()=>{
        if (tooltip === true) return {
            title: editConfigText ?? children
        };
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(tooltip)) return {
            title: tooltip
        };
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(tooltip)) return {
            title: editConfigText ?? children,
            ...tooltip
        };
        return {
            title: tooltip
        };
    }, [
        tooltip,
        editConfigText,
        children
    ]);
var $ccc30a03cba8168b$export$2e2bcd8739ae039 = $ccc30a03cba8168b$var$useTooltipProps;



var $acw62 = parcelRequire("acw62");



"use client";
const $a3673f44358dd6b6$var$Typography = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, component: Component = 'article', className: className, rootClassName: rootClassName, children: children, direction: typographyDirection, style: style, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('typography');
    const direction = typographyDirection ?? contextDirection;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    return /*#__PURE__*/ $acw62.createElement(Component, {
        className: componentClassName,
        style: mergedStyle,
        ref: ref,
        ...restProps
    }, children);
});
var $a3673f44358dd6b6$export$2e2bcd8739ae039 = $a3673f44358dd6b6$var$Typography;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4da90ab6d25f30a4$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $4da90ab6d25f30a4$export$2e2bcd8739ae039 = $4da90ab6d25f30a4$var$CopyOutlined;



function $cf161c40cf97635f$var$_extends() {
    $cf161c40cf97635f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf161c40cf97635f$var$_extends.apply(this, arguments);
}
const $cf161c40cf97635f$var$CopyOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $cf161c40cf97635f$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4da90ab6d25f30a4$export$2e2bcd8739ae039)
    }));
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ const $cf161c40cf97635f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($cf161c40cf97635f$var$CopyOutlined);
var $cf161c40cf97635f$export$2e2bcd8739ae039 = $cf161c40cf97635f$var$RefIcon;






const $670def8f8d6657a1$export$54c946ade31abb75 = (val)=>{
    if (val === false) return [
        false,
        false
    ];
    return (0, $c668f727bdc41d13$export$2e2bcd8739ae039)(val);
};
function $670def8f8d6657a1$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $670def8f8d6657a1$export$5714fcf57d9d6988(ele) {
    // Create a new div to get the size
    const childDiv = document.createElement('em');
    ele.appendChild(childDiv);
    const rect = ele.getBoundingClientRect();
    const childRect = childDiv.getBoundingClientRect();
    // Reset
    ele.removeChild(childDiv);
    // Range checker
    return(// Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom);
}
const $670def8f8d6657a1$export$a748c1acb7702f51 = (val)=>[
        'string',
        'number'
    ].includes(typeof val);


"use client";
const $f52e626a12e29853$var$CopyBtn = (props)=>{
    const { prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, tabIndex: tabIndex, onCopy: onCopy, loading: btnLoading } = props;
    const tooltipNodes = (0, $670def8f8d6657a1$export$54c946ade31abb75)(tooltips);
    const iconNodes = (0, $670def8f8d6657a1$export$54c946ade31abb75)(icon);
    const { copied: copiedText, copy: copyText } = locale ?? {};
    const systemStr = copied ? copiedText : copyText;
    const copyTitle = (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(tooltipNodes[copied ? 1 : 0], systemStr);
    const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        title: copyTitle
    }, /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-copy`, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null), true) : (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $cf161c40cf97635f$export$2e2bcd8739ae039), null), true)));
};
var $f52e626a12e29853$export$2e2bcd8739ae039 = $f52e626a12e29853$var$CopyBtn;




var $acw62 = parcelRequire("acw62");



"use client";
const $89c852553f755dc1$var$MeasureText = /*#__PURE__*/ $acw62.forwardRef(({ style: style, children: children }, ref)=>{
    const spanRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: {
            position: 'fixed',
            display: 'block',
            left: 0,
            top: 0,
            pointerEvents: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0.65)',
            ...style
        }
    }, children);
});
const $89c852553f755dc1$var$getNodesLen = (nodeList)=>nodeList.reduce((totalLen, node)=>totalLen + ((0, $670def8f8d6657a1$export$a748c1acb7702f51)(node) ? String(node).length : 1), 0);
function $89c852553f755dc1$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = (0, $670def8f8d6657a1$export$a748c1acb7702f51)(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $89c852553f755dc1$var$STATUS_MEASURE_NONE = 0;
const $89c852553f755dc1$var$STATUS_MEASURE_PREPARE = 1;
const $89c852553f755dc1$var$STATUS_MEASURE_START = 2;
const $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $89c852553f755dc1$var$lineClipStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
};
function $89c852553f755dc1$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $acw62.useMemo(()=>(0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(text), [
        text
    ]);
    const nodeLen = $acw62.useMemo(()=>$89c852553f755dc1$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $acw62.useMemo(()=>children(nodeList, false), [
        text
    ]);
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $acw62.useState(null);
    const cutMidRef = $acw62.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $acw62.useRef(null);
    const needEllipsisRef = $acw62.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $acw62.useRef(null);
    const symbolRowEllipsisRef = $acw62.useRef(null);
    const [canEllipsis, setCanEllipsis] = $acw62.useState(false);
    const [needEllipsis, setNeedEllipsis] = $acw62.useState($89c852553f755dc1$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $acw62.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $acw62.useState(null);
    // Trigger start measure
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ]);
    // Measure process
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_START) {
            const isOverflow = !!needEllipsisRef.current?.isExceed();
            setNeedEllipsis(isOverflow ? $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS : $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = needEllipsisRef.current?.getHeight() || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : descRowsEllipsisRef.current?.getHeight() || 0;
            const symbolRowEllipsisHeight = symbolRowEllipsisRef.current?.getHeight() || 0;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, // height of rows with ellipsis
            descRowsEllipsisHeight + symbolRowEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = cutMidRef.current?.getHeight() || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            setEllipsisCutIndex(isOverflow ? [
                minIndex,
                targetMidIndex
            ] : [
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $acw62.useMemo(()=>{
        // Skip everything if `enableMeasure` is disabled
        if (!enableMeasure) return children(nodeList, false);
        if (needEllipsis !== $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink unless no need ellipsis
            // https://github.com/ant-design/ant-design/issues/42958
            if ([
                $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS,
                $89c852553f755dc1$var$STATUS_MEASURE_NONE
            ].includes(needEllipsis)) return content;
            return /*#__PURE__*/ $acw62.createElement("span", {
                style: {
                    ...$89c852553f755dc1$var$lineClipStyle,
                    WebkitLineClamp: rows
                }
            }, content);
        }
        return children(expanded ? nodeList : $89c852553f755dc1$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === 'nowrap' ? 'normal' : 'inherit'
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, finalContent, needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_START && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$89c852553f755dc1$var$lineClipStyle,
            WebkitLineClamp: rows
        },
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$89c852553f755dc1$var$lineClipStyle,
            WebkitLineClamp: rows - 1
        },
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$89c852553f755dc1$var$lineClipStyle,
            WebkitLineClamp: 1
        },
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: {
            ...measureStyle,
            top: 400
        },
        ref: cutMidRef
    }, children($89c852553f755dc1$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            whiteSpace: 'inherit'
        },
        ref: measureWhiteSpaceRef
    }));
}



var $acw62 = parcelRequire("acw62");

"use client";
const $2c5f09c9102f607d$var$EllipsisTooltip = ({ enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, open: open, children: children, tooltipProps: tooltipProps })=>{
    if (!tooltipProps?.title || !enableEllipsis) return children;
    const mergedOpen = open && isEllipsis;
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        open: mergedOpen,
        ...tooltipProps
    }, children);
};
var $2c5f09c9102f607d$export$2e2bcd8739ae039 = $2c5f09c9102f607d$var$EllipsisTooltip;



"use client";
function $c756fe581e322b8b$var$wrapperDecorations({ mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic }, content) {
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $acw62.createElement(tag, {}, currentContent);
    }
    wrap('strong', strong);
    wrap('u', underline);
    wrap('del', del);
    wrap('code', code);
    wrap('mark', mark);
    wrap('kbd', keyboard);
    wrap('i', italic);
    return currentContent;
}
const $c756fe581e322b8b$var$ELLIPSIS_STR = '...';
const $c756fe581e322b8b$var$DECORATION_PROPS = [
    'delete',
    'mark',
    'code',
    'underline',
    'strong',
    'keyboard',
    'italic'
];
const $c756fe581e322b8b$var$Base = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, style: style, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, component: component, title: title, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [textLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Text');
    const typographyRef = $acw62.useRef(null);
    const editIconRef = $acw62.useRef(null);
    // ============================ MISC ============================
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const textProps = (0, $cdfb578fac308710$export$2e2bcd8739ae039)(restProps, $c756fe581e322b8b$var$DECORATION_PROPS);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(false, editConfig.editing);
    const { triggerType: triggerType = [
        'icon'
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        if (edit) editConfig.onStart?.();
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $4564445e53d0f3b9$export$2e2bcd8739ae039)(editing);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (!editing && prevEditing) editIconRef.current?.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e?.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        editConfig.onChange?.(value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        editConfig.onCancel?.();
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(copyable);
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $03d6c4dc81f23be0$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $acw62.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $acw62.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $acw62.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $acw62.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $acw62.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale?.collapse : textLocale?.expand
    });
    const [expanded, setExpanded] = (0, $fd8de6f917b208f4$export$2e2bcd8739ae039)(ellipsisConfig.defaultExpanded || false, ellipsisConfig.expanded);
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === 'collapsible');
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $acw62.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $fc429b640022d4cc$export$d616d7831008e86c)('webkitLineClamp'));
            setIsTextOverflowSupport((0, $fc429b640022d4cc$export$d616d7831008e86c)('textOverflow'));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $acw62.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $acw62.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $a55cdd4bafb2a6e7$export$2e2bcd8739ae039)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const tooltipProps = (0, $ccc30a03cba8168b$export$2e2bcd8739ae039)(ellipsisConfig.tooltip, editConfig.text, children);
    const needNativeEllipsisMeasure = cssEllipsis && !!tooltipProps.title;
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? needNativeEllipsisMeasure && isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        setExpanded(info.expanded);
        ellipsisConfig.onExpand?.(e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $acw62.useState(0);
    const [isHoveringOperations, setIsHoveringOperations] = $acw62.useState(false);
    const [isHoveringTypography, setIsHoveringTypography] = $acw62.useState(false);
    const onResize = ({ offsetWidth: offsetWidth })=>{
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) ellipsisConfig.onEllipsis?.(jsEllipsis);
    };
    // >>>>> Native ellipsis
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && needNativeEllipsisMeasure && textEle) {
            const currentEllipsis = (0, $670def8f8d6657a1$export$5714fcf57d9d6988)(textEle);
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        needNativeEllipsisMeasure,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === 'undefined' || !textEle || !needNativeEllipsisMeasure || !mergedEnableEllipsis) return;
        const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        needNativeEllipsisMeasure,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    const topAriaLabel = $acw62.useMemo(()=>{
        if (!enableEllipsis || cssEllipsis) return undefined;
        return [
            editConfig.text,
            children,
            title,
            tooltipProps.title
        ].find((0, $670def8f8d6657a1$export$a748c1acb7702f51));
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $acw62.createElement((0, $8a5b8988dc6b65c3$export$2e2bcd8739ae039), {
        value: editConfig.text ?? (typeof children === 'string' ? children : ''),
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        return expandable ? /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            key: "expand",
            className: `${prefixCls}-${expanded ? 'collapse' : 'expand'}`,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale?.expand
        }, typeof symbol === 'function' ? symbol(expanded) : symbol) : null;
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $cab716a99a2efd5f$export$2e2bcd8739ae039)(tooltip)[0] || textLocale?.edit;
        const ariaLabel = typeof editTitle === 'string' ? editTitle : '';
        return triggerType.includes('icon') ? /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? '' : editTitle
        }, /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            ref: editIconRef,
            className: `${prefixCls}-edit`,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $acw62.createElement((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $acw62.createElement((0, $f52e626a12e29853$export$2e2bcd8739ae039), {
            key: "copy",
            ...copyConfig,
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: !(0, $b956dab96d0e505b$export$826fff653a329e83)(children)
        });
    };
    const renderOperations = (canEllipsis)=>{
        const expandNode = canEllipsis && renderExpand();
        const editNode = renderEdit();
        const copyNode = renderCopy();
        if (!expandNode && !editNode && !copyNode) return null;
        return /*#__PURE__*/ $acw62.createElement("span", {
            key: "operations",
            className: `${prefixCls}-actions`,
            onMouseEnter: ()=>setIsHoveringOperations(true),
            onMouseLeave: ()=>setIsHoveringOperations(false)
        }, expandNode, editNode, copyNode);
    };
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $acw62.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $c756fe581e322b8b$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(canEllipsis)
        ];
    return /*#__PURE__*/ $acw62.createElement((0, $f9ee8e1a19f1de53$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $acw62.createElement((0, $2c5f09c9102f607d$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis,
            open: isHoveringTypography && !isHoveringOperations
        }, /*#__PURE__*/ $acw62.createElement((0, $a3673f44358dd6b6$export$2e2bcd8739ae039), {
            onMouseEnter: (e)=>{
                setIsHoveringTypography(true);
                onMouseEnter?.(e);
            },
            onMouseLeave: (e)=>{
                setIsHoveringTypography(false);
                onMouseLeave?.(e);
            },
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp,
                [`${prefixCls}-link`]: component === 'a'
            }, className),
            prefixCls: customizePrefixCls,
            style: {
                ...style,
                WebkitLineClamp: cssLineClamp ? rows : undefined
            },
            component: component,
            ref: (0, $6c628207f5089a39$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes('text') ? onEditClick : undefined,
            "aria-label": topAriaLabel?.toString(),
            title: title,
            ...textProps
        }, /*#__PURE__*/ $acw62.createElement((0, $89c852553f755dc1$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy,
                textLocale
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($c756fe581e322b8b$var$DECORATION_PROPS.map((key)=>props[key])))
        }, (node, canEllipsis)=>$c756fe581e322b8b$var$wrapperDecorations(props, /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $acw62.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis)))))));
});
var $c756fe581e322b8b$export$2e2bcd8739ae039 = $c756fe581e322b8b$var$Base;


"use client";
const $e59afc5fcefd918d$var$Link = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, rel: rel, children: children, // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    navigate: _navigate, ...restProps } = props;
    const mergedProps = {
        ...restProps,
        rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
    };
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), {
        ...mergedProps,
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }, children);
});
var $e59afc5fcefd918d$export$2e2bcd8739ae039 = $e59afc5fcefd918d$var$Link;



var $acw62 = parcelRequire("acw62");

"use client";
const $32838ac41e3e19d1$var$Paragraph = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: "div"
    }, children);
});
var $32838ac41e3e19d1$export$2e2bcd8739ae039 = $32838ac41e3e19d1$var$Paragraph;



var $acw62 = parcelRequire("acw62");




"use client";
const $3704098f38e9f562$var$Text = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, children: children, ...restProps } = props;
    const mergedEllipsis = $acw62.useMemo(()=>{
        if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(ellipsis)) return (0, $cdfb578fac308710$export$2e2bcd8739ae039)(ellipsis, [
            'expandable',
            'rows'
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        ellipsis: mergedEllipsis,
        component: "span"
    }, children);
});
var $3704098f38e9f562$export$2e2bcd8739ae039 = $3704098f38e9f562$var$Text;



var $acw62 = parcelRequire("acw62");


"use client";
const $af44bdd0e8458ef3$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $af44bdd0e8458ef3$var$Title = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { level: level = 1, children: children, ...restProps } = props;
    const component = $af44bdd0e8458ef3$var$TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: component
    }, children);
});
var $af44bdd0e8458ef3$export$2e2bcd8739ae039 = $af44bdd0e8458ef3$var$Title;



"use client";
const $69754065fe3b4b60$var$Typography = (0, $a3673f44358dd6b6$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Text = (0, $3704098f38e9f562$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Link = (0, $e59afc5fcefd918d$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Title = (0, $af44bdd0e8458ef3$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Paragraph = (0, $32838ac41e3e19d1$export$2e2bcd8739ae039);
var $69754065fe3b4b60$export$2e2bcd8739ae039 = $69754065fe3b4b60$var$Typography;


var $8ed4735639b40546$export$89afe9f6cb4c91c0;
var $8ed4735639b40546$export$934ca160d41cc227;
var $8ed4735639b40546$export$fa0831f497706bad;
$8ed4735639b40546$export$89afe9f6cb4c91c0 = `-78wLa_bodyText`;
$8ed4735639b40546$export$934ca160d41cc227 = `-78wLa_headerValue`;
$8ed4735639b40546$export$fa0831f497706bad = `-78wLa_logs`;


const $847b541c620f2967$var$labelStyle = {
    width: "30%",
    "text-align": "right"
};
const $847b541c620f2967$var$Headers = ({ headers: headers, title: title })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d93e861837558e71$export$2e2bcd8739ae039), {
        title: title,
        column: 1,
        size: "small",
        bordered: true,
        children: Object.entries(headers).map(([headerName, headerValue])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d93e861837558e71$export$2e2bcd8739ae039).Item, {
                label: headerName,
                labelStyle: $847b541c620f2967$var$labelStyle,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $8ed4735639b40546$export$934ca160d41cc227,
                    children: Array.isArray(headerValue) ? headerValue.join(",") : headerValue
                })
            }))
    });
const $847b541c620f2967$var$RequestDetailsBody = ({ requestDetails: requestDetails, loading: loading })=>{
    if (!requestDetails) {
        if (!loading) return(// @ts-ignore
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $327cc81a9ba2f000$export$2e2bcd8739ae039), {
            status: "error",
            title: "Error happened! Probably record details has been already cleaned."
        }));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {});
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
        direction: "vertical",
        children: [
            requestDetails.logMessages && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Title, {
                            level: 5,
                            children: "Log messages"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $8ed4735639b40546$export$fa0831f497706bad,
                        children: requestDetails.logMessages.map((message)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    message,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                                ]
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($847b541c620f2967$var$Headers, {
                headers: requestDetails.requestHeaders ?? {},
                title: "Request headers"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($847b541c620f2967$var$Headers, {
                headers: requestDetails.responseHeaders ?? {},
                title: "Response headers"
            }),
            requestDetails.request && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Title, {
                            level: 5,
                            children: "Request body"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        direction: "vertical",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: $8ed4735639b40546$export$89afe9f6cb4c91c0,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Paragraph, {
                                code: true,
                                children: typeof requestDetails.request === "string" ? requestDetails.request : JSON.stringify(requestDetails.request, null, 4)
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Title, {
                    level: 5,
                    children: "Response body"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                direction: "vertical",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $8ed4735639b40546$export$89afe9f6cb4c91c0,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Paragraph, {
                        code: true,
                        children: typeof requestDetails.response === "string" ? requestDetails.response : JSON.stringify(requestDetails.response, null, 4)
                    })
                })
            })
        ]
    });
};
const $847b541c620f2967$export$1ec22ccbfe26843b = ({ isVisible: isVisible, loading: loading, onClose: onClose, requestDetails: requestDetails })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2824be14bd3234d$export$2e2bcd8739ae039), {
        title: "Request details",
        placement: "right",
        width: "50%",
        onClose: onClose,
        open: isVisible,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($847b541c620f2967$var$RequestDetailsBody, {
            loading: loading,
            requestDetails: requestDetails
        })
    });



var $acw62 = parcelRequire("acw62");

const $11193f6dfb7dcb2c$export$871738f270a673da = ()=>{
    const [isVisible, setVisible] = (0, $acw62.useState)(false);
    const [requestDetails, setRequestDetails] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const loadData = async (id)=>{
        setLoading(true);
        let data = null;
        try {
            data = await (0, $7fe116ddba5bf8b9$export$52e83573e7782585)({
                url: `logs/${id}`
            });
        } finally{
            setLoading(false);
        }
        setRequestDetails(data);
    };
    const onOpen = (id)=>{
        setVisible(true);
        setRequestDetails(null);
        loadData(id);
    };
    const onClose = ()=>setVisible(false);
    return {
        isVisible: isVisible,
        onOpen: onOpen,
        onClose: onClose,
        requestDetails: requestDetails,
        loading: loading
    };
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $ec30be32576c1d45$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const $ec30be32576c1d45$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $ec30be32576c1d45$export$2e2bcd8739ae039 = $ec30be32576c1d45$var$AppContext;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $57a9c466662aed09$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $57a9c466662aed09$export$2e2bcd8739ae039 = $57a9c466662aed09$var$InfoCircleFilled;



function $b5d5d018bfa4ba6e$var$_extends() {
    $b5d5d018bfa4ba6e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5d5d018bfa4ba6e$var$_extends.apply(this, arguments);
}
const $b5d5d018bfa4ba6e$var$InfoCircleFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $b5d5d018bfa4ba6e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $b5d5d018bfa4ba6e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($b5d5d018bfa4ba6e$var$InfoCircleFilled);
var $b5d5d018bfa4ba6e$export$2e2bcd8739ae039 = $b5d5d018bfa4ba6e$var$RefIcon;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $8d51c96aeca0c570$var$_extends() {
    $8d51c96aeca0c570$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d51c96aeca0c570$var$_extends.apply(this, arguments);
}
const $8d51c96aeca0c570$var$Notify = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, style: style, className: className, duration: duration = 4.5, showProgress: showProgress, pauseOnHover: pauseOnHover = true, eventKey: eventKey, content: content, closable: closable, props: divProps, onClick: onClick, onNoticeClose: onNoticeClose, times: times, hovering: forcedHovering } = props;
    const [hovering, setHovering] = $acw62.useState(false);
    const [percent, setPercent] = $acw62.useState(0);
    const [spentTime, setSpentTime] = $acw62.useState(0);
    const mergedHovering = forcedHovering || hovering;
    const mergedDuration = typeof duration === 'number' ? duration : 0;
    const mergedShowProgress = mergedDuration > 0 && showProgress;
    // ======================== Close =========================
    const onInternalClose = ()=>{
        onNoticeClose(eventKey);
    };
    const onCloseKeyDown = (e)=>{
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, $d5b4e9a9adce0110$export$2e2bcd8739ae039).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $acw62.useEffect(()=>{
        if (!mergedHovering && mergedDuration > 0) {
            const start = Date.now() - spentTime;
            const timeout = setTimeout(()=>{
                onInternalClose();
            }, mergedDuration * 1000 - spentTime);
            return ()=>{
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        mergedHovering,
        times
    ]);
    $acw62.useEffect(()=>{
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            const start = performance.now();
            let animationFrame;
            const calculate = ()=>{
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame((timestamp)=>{
                    const runtime = timestamp + spentTime - start;
                    const progress = Math.min(runtime / (mergedDuration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return ()=>{
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    const closableObj = $acw62.useMemo(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        return {};
    }, [
        closable
    ]);
    const ariaProps = (0, $613e269121c63c71$export$2e2bcd8739ae039)(closableObj, true);
    // ======================== Progress ========================
    const validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    const noticePrefixCls = `${prefixCls}-notice`;
    return /*#__PURE__*/ $acw62.createElement("div", $8d51c96aeca0c570$var$_extends({}, divProps, {
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(noticePrefixCls, className, {
            [`${noticePrefixCls}-closable`]: closable
        }),
        style: style,
        onMouseEnter: (e)=>{
            setHovering(true);
            divProps?.onMouseEnter?.(e);
        },
        onMouseLeave: (e)=>{
            setHovering(false);
            divProps?.onMouseLeave?.(e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${noticePrefixCls}-content`
    }, content), closable && /*#__PURE__*/ $acw62.createElement("button", $8d51c96aeca0c570$var$_extends({
        className: `${noticePrefixCls}-close`,
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon ?? 'x'), mergedShowProgress && /*#__PURE__*/ $acw62.createElement("progress", {
        className: `${noticePrefixCls}-progress`,
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
var $8d51c96aeca0c570$export$2e2bcd8739ae039 = $8d51c96aeca0c570$var$Notify;



var $acw62 = parcelRequire("acw62");
const $3d5f470362a7e0cc$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const $3d5f470362a7e0cc$var$NotificationProvider = ({ children: children, classNames: classNames })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5f470362a7e0cc$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $3d5f470362a7e0cc$export$2e2bcd8739ae039 = $3d5f470362a7e0cc$var$NotificationProvider;


const $b59850f3d16d1215$var$DEFAULT_OFFSET = 8;
const $b59850f3d16d1215$var$DEFAULT_THRESHOLD = 3;
const $b59850f3d16d1215$var$DEFAULT_GAP = 16;
const $b59850f3d16d1215$var$useStack = (config)=>{
    const result = {
        offset: $b59850f3d16d1215$var$DEFAULT_OFFSET,
        threshold: $b59850f3d16d1215$var$DEFAULT_THRESHOLD,
        gap: $b59850f3d16d1215$var$DEFAULT_GAP
    };
    if (config && typeof config === 'object') {
        result.offset = config.offset ?? $b59850f3d16d1215$var$DEFAULT_OFFSET;
        result.threshold = config.threshold ?? $b59850f3d16d1215$var$DEFAULT_THRESHOLD;
        result.gap = config.gap ?? $b59850f3d16d1215$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $b59850f3d16d1215$export$2e2bcd8739ae039 = $b59850f3d16d1215$var$useStack;


function $1cec24eff63cf47e$var$_extends() {
    $1cec24eff63cf47e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1cec24eff63cf47e$var$_extends.apply(this, arguments);
}
const $1cec24eff63cf47e$var$NoticeList = (props)=>{
    const { configList: configList, placement: placement, prefixCls: prefixCls, className: className, style: style, motion: motion, onAllNoticeRemoved: onAllNoticeRemoved, onNoticeClose: onNoticeClose, stack: stackConfig } = props;
    const { classNames: ctxCls } = (0, $acw62.useContext)((0, $3d5f470362a7e0cc$export$a6e93d8cb5d50678));
    const dictRef = (0, $acw62.useRef)({});
    const [latestNotice, setLatestNotice] = (0, $acw62.useState)(null);
    const [hoverKeys, setHoverKeys] = (0, $acw62.useState)([]);
    const keys = configList.map((config)=>({
            config: config,
            key: String(config.key)
        }));
    const [stack, { offset: offset, threshold: threshold, gap: gap }] = (0, $b59850f3d16d1215$export$2e2bcd8739ae039)(stackConfig);
    const expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    const placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, $acw62.useEffect)(()=>{
        if (stack && hoverKeys.length > 1) setHoverKeys((prev)=>prev.filter((key)=>keys.some(({ key: dataKey })=>key === dataKey)));
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $acw62.useEffect)(()=>{
        if (stack && dictRef.current[keys[keys.length - 1]?.key]) setLatestNotice(dictRef.current[keys[keys.length - 1]?.key]);
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $71116570e73e7990$export$2e2bcd8739ae039), $1cec24eff63cf47e$var$_extends({
        key: placement,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${placement}`, ctxCls?.list, className, {
            [`${prefixCls}-stack`]: !!stack,
            [`${prefixCls}-stack-expanded`]: expanded
        }),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: ()=>{
            onAllNoticeRemoved(placement);
        }
    }), ({ config: config, className: motionClassName, style: motionStyle, index: motionIndex }, nodeRef)=>{
        const { key: key, times: times } = config;
        const strKey = String(key);
        const { className: configClassName, style: configStyle, classNames: configClassNames, styles: configStyles, ...restConfig } = config;
        const dataIndex = keys.findIndex((item)=>item.key === strKey);
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        const stackStyle = {};
        if (stack) {
            const index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            const transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                stackStyle.height = expanded ? dictRef.current[strKey]?.offsetHeight : latestNotice?.offsetHeight;
                // Transform
                let verticalOffset = 0;
                for(let i = 0; i < index; i++)verticalOffset += dictRef.current[keys[keys.length - 1 - i].key]?.offsetHeight + gap;
                const transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                const scaleX = !expanded && latestNotice?.offsetWidth && dictRef.current[strKey]?.offsetWidth ? (latestNotice?.offsetWidth - offset * 2 * (index < 3 ? index : 3)) / dictRef.current[strKey]?.offsetWidth : 1;
                stackStyle.transform = `translate3d(${transformX}, ${transformY}px, 0) scaleX(${scaleX})`;
            } else stackStyle.transform = `translate3d(${transformX}, 0, 0)`;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: nodeRef,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-notice-wrapper`, motionClassName, configClassNames?.wrapper),
            style: {
                ...motionStyle,
                ...stackStyle,
                ...configStyles?.wrapper
            },
            onMouseEnter: ()=>setHoverKeys((prev)=>prev.includes(strKey) ? prev : [
                        ...prev,
                        strKey
                    ]),
            onMouseLeave: ()=>setHoverKeys((prev)=>prev.filter((k)=>k !== strKey))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8d51c96aeca0c570$export$2e2bcd8739ae039), $1cec24eff63cf47e$var$_extends({}, restConfig, {
            ref: (node)=>{
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(configClassName, ctxCls?.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
var $1cec24eff63cf47e$export$2e2bcd8739ae039 = $1cec24eff63cf47e$var$NoticeList;


// ant-notification ant-notification-topRight
const $f50a81cc327ea826$var$Notifications = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-notification', container: container, motion: motion, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications } = props;
    const [configList, setConfigList] = $acw62.useState([]);
    // ======================== Close =========================
    const onNoticeClose = (key)=>{
        // Trigger close event
        const config = configList.find((item)=>item.key === key);
        const closable = config?.closable;
        const closableObj = closable && typeof closable === 'object' ? closable : {};
        const { onClose: closableOnClose } = closableObj;
        closableOnClose?.();
        config?.onClose?.();
        setConfigList((list)=>list.filter((item)=>item.key !== key));
    };
    // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, ()=>({
            open: (config)=>{
                setConfigList((list)=>{
                    let clone = [
                        ...list
                    ];
                    // Replace if exist
                    const index = clone.findIndex((item)=>item.key === config.key);
                    const innerConfig = {
                        ...config
                    };
                    if (index >= 0) {
                        innerConfig.times = (list[index]?.times || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: (key)=>{
                onNoticeClose(key);
            },
            destroy: ()=>{
                setConfigList([]);
            }
        }));
    // ====================== Placements ======================
    const [placements, setPlacements] = $acw62.useState({});
    $acw62.useEffect(()=>{
        const nextPlacements = {};
        configList.forEach((config)=>{
            const { placement: placement = 'topRight' } = config;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach((placement)=>{
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    const onAllNoticeRemoved = (placement)=>{
        setPlacements((originPlacements)=>{
            const clone = {
                ...originPlacements
            };
            const list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    const emptyRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved?.();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    const placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, placementList.map((placement)=>{
        const placementConfigList = placements[placement];
        const list = /*#__PURE__*/ $acw62.createElement((0, $1cec24eff63cf47e$export$2e2bcd8739ae039), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className?.(placement),
            style: style?.(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
var $f50a81cc327ea826$export$2e2bcd8739ae039 = $f50a81cc327ea826$var$Notifications;



const $7f13bf832da92e54$var$defaultGetContainer = ()=>document.body;
let $7f13bf832da92e54$var$uniqueKey = 0;
function $7f13bf832da92e54$var$mergeConfig(...objList) {
    const clone = {};
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            const val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $7f13bf832da92e54$export$2e2bcd8739ae039(rootConfig = {}) {
    const { getContainer: getContainer = $7f13bf832da92e54$var$defaultGetContainer, motion: motion, prefixCls: prefixCls, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications, ...shareConfig } = rootConfig;
    const [container, setContainer] = $acw62.useState();
    const notificationsRef = $acw62.useRef();
    const contextHolder = /*#__PURE__*/ $acw62.createElement((0, $f50a81cc327ea826$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    const [taskQueue, setTaskQueue] = $acw62.useState([]);
    const open = (0, $f0adbefb2a0719e1$export$2e2bcd8739ae039)((config)=>{
        const mergedConfig = $7f13bf832da92e54$var$mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = `rc-notification-${$7f13bf832da92e54$var$uniqueKey}`;
            $7f13bf832da92e54$var$uniqueKey += 1;
        }
        setTaskQueue((queue)=>[
                ...queue,
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
    });
    // ========================= Refs =========================
    const api = $acw62.useMemo(()=>({
            open: open,
            close: (key)=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
            },
            destroy: ()=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'destroy'
                        }
                    ]);
            }
        }), []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $acw62.useEffect(()=>{
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $acw62.useEffect(()=>{
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach((task)=>{
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // https://github.com/ant-design/ant-design/issues/52590
            // React `startTransition` will run once `useEffect` but many times `setState`,
            // So `setTaskQueue` with filtered array will cause infinite loop.
            // We cache the first match queue instead.
            let oriTaskQueue;
            let tgtTaskQueue;
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue((oriQueue)=>{
                if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
                    oriTaskQueue = oriQueue;
                    tgtTaskQueue = oriQueue.filter((task)=>!taskQueue.includes(task));
                }
                return tgtTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}















const $3bac234c47ba2af8$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: {
                ...(0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token),
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            }
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: {
                    ...noticeStyle
                }
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: {
                ...noticeStyle,
                padding: 0,
                textAlign: 'start'
            }
        }
    ];
};
const $3bac234c47ba2af8$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $8552b358f1d5b0a4$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$3bac234c47ba2af8$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        height: 150
    });
    return $3bac234c47ba2af8$var$genMessageStyle(combinedToken);
}, $3bac234c47ba2af8$export$9ca1be8807fe0675);


"use client";
const $c9808e733d97ff6c$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $acw62.createElement((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $acw62.createElement((0, $2444f6da62064575$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null)
};
const $c9808e733d97ff6c$export$429c001938db3a78 = (props)=>{
    const { prefixCls: prefixCls, type: type, icon: icon, children: children, classNames: pureContentClassNames, styles: styles } = props;
    const iconElement = icon || type && $c9808e733d97ff6c$export$ad8f8fc3bcd61b4a[type];
    const iconNode = (0, $30796c32f374b477$export$e530037191fcd5d7)(iconElement, (currentProps)=>{
        const mergedStyle = {
            ...currentProps?.style,
            ...styles?.icon
        };
        return {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(currentProps.className, pureContentClassNames?.icon),
            style: mergedStyle
        };
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, iconNode, /*#__PURE__*/ $acw62.createElement("span", {
        className: pureContentClassNames?.content,
        style: styles?.content
    }, children));
};
/** @private Internal Component. Do not use in your production. */ const $c9808e733d97ff6c$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, style: style, type: type, icon: icon, content: content, classNames: messageClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('message');
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3bac234c47ba2af8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        contextClassNames,
        messageClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    return /*#__PURE__*/ $acw62.createElement((0, $8d51c96aeca0c570$export$2e2bcd8739ae039), {
        ...restProps,
        prefixCls: prefixCls,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(contextClassName, mergedClassNames.root, className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $acw62.createElement($c9808e733d97ff6c$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon,
            classNames: mergedClassNames,
            styles: mergedStyles
        }, content)
    });
};
var $c9808e733d97ff6c$export$2e2bcd8739ae039 = $c9808e733d97ff6c$var$PurePanel;



var $acw62 = parcelRequire("acw62");










function $c93f159ca3fa0be1$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName ?? `${prefixCls}-move-up`
    };
}
function $c93f159ca3fa0be1$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn?.();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
const $279f9cad32c830f7$var$DEFAULT_OFFSET = 8;
const $279f9cad32c830f7$var$DEFAULT_DURATION = 3;
const $279f9cad32c830f7$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3bac234c47ba2af8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return /*#__PURE__*/ $acw62.createElement((0, $3d5f470362a7e0cc$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const $279f9cad32c830f7$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ $acw62.createElement($279f9cad32c830f7$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $279f9cad32c830f7$var$Holder = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $279f9cad32c830f7$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved, pauseOnHover: pauseOnHover = true } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('message');
    const { message: message } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top ?? $279f9cad32c830f7$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $c93f159ca3fa0be1$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // Use useMergeSemantic to merge classNames and styles
    const [mergedClassNames, mergedStyles] = (0, $f5b1737011872d72$export$648566b068f28737)([
        props?.classNames,
        message?.classNames
    ], [
        props?.styles,
        message?.styles
    ], {
        props: props
    });
    // ============================== Origin ===============================
    const [api, holder] = (0, $7f13bf832da92e54$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        // closable=false requires-no closeIcon
        closable: false,
        duration: duration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $279f9cad32c830f7$var$renderNotifications,
        pauseOnHover: pauseOnHover
    });
    // ================================ Ref ================================
    $acw62.useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls: prefixCls,
            message: message,
            classNames: mergedClassNames,
            styles: mergedStyles
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $279f9cad32c830f7$var$keyIndex = 0;
function $279f9cad32c830f7$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $acw62.useRef(null);
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Message');
    // ================================ API ================================
    const wrapAPI = $acw62.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            holderRef.current?.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message, classNames: originClassNames, styles: originStyles } = holderRef.current;
            const contextClassName = message?.className || {};
            const contextStyle = message?.style || {};
            const rawContextClassNames = message?.classNames || {};
            const rawContextStyles = message?.styles || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose, classNames: configClassNames = {}, styles: styles = {}, ...restConfig } = config;
            let mergedKey = key;
            if (!(0, $b956dab96d0e505b$export$826fff653a329e83)(mergedKey)) {
                $279f9cad32c830f7$var$keyIndex += 1;
                mergedKey = `antd-message-${$279f9cad32c830f7$var$keyIndex}`;
            }
            const contextConfig = {
                ...messageConfig,
                ...config
            };
            const contextClassNames = (0, $f5b1737011872d72$export$ccd424010a24474f)(rawContextClassNames, {
                props: contextConfig
            });
            const semanticClassNames = (0, $f5b1737011872d72$export$ccd424010a24474f)(configClassNames, {
                props: contextConfig
            });
            const contextStyles = (0, $f5b1737011872d72$export$ccd424010a24474f)(rawContextStyles, {
                props: contextConfig
            });
            const semanticStyles = (0, $f5b1737011872d72$export$ccd424010a24474f)(styles, {
                props: contextConfig
            });
            const mergedClassNames = (0, $f5b1737011872d72$export$8bf64cd1c29a1310)(undefined, contextClassNames, semanticClassNames, originClassNames);
            const mergedStyles = (0, $f5b1737011872d72$export$e618dc39ac9ad607)(contextStyles, semanticStyles, originStyles);
            return (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
                originOpen({
                    ...restConfig,
                    key: mergedKey,
                    content: /*#__PURE__*/ $acw62.createElement((0, $c9808e733d97ff6c$export$429c001938db3a78), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon,
                        classNames: mergedClassNames,
                        styles: mergedStyles
                    }, content),
                    placement: 'top',
                    className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
                        [`${noticePrefixCls}-${type}`]: type
                    }, className, contextClassName, mergedClassNames.root),
                    style: {
                        ...mergedStyles.root,
                        ...contextStyle,
                        ...style
                    },
                    onClose: ()=>{
                        onClose?.();
                        resolve();
                    }
                });
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if ((0, $b956dab96d0e505b$export$53b83ca8eaab0383)(jointContent) && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = {
                    onClose: mergedOnClose,
                    duration: mergedDuration,
                    ...config,
                    type: type
                };
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $acw62.createElement($279f9cad32c830f7$var$Holder, {
            key: "message-holder",
            ...messageConfig,
            ref: holderRef
        })
    ];
}
function $279f9cad32c830f7$export$2e2bcd8739ae039(messageConfig) {
    return $279f9cad32c830f7$export$1689db33b6c27d9e(messageConfig);
}



"use client";
let $dc31f36873c2f472$var$message = null;
let $dc31f36873c2f472$var$act = (callback)=>callback();
let $dc31f36873c2f472$var$taskQueue = [];
let $dc31f36873c2f472$var$defaultGlobalConfig = {};
function $dc31f36873c2f472$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $dc31f36873c2f472$var$defaultGlobalConfig;
    const mergedContainer = getContainer?.() || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $dc31f36873c2f472$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = $dc31f36873c2f472$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $acw62.useContext)((0, $ec30be32576c1d45$export$264c6064649f9206));
    const [api, holder] = (0, $279f9cad32c830f7$export$1689db33b6c27d9e)({
        ...messageConfig,
        prefixCls: prefixCls,
        ...appConfig.message
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>{
        const instance = {
            ...api
        };
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $dc31f36873c2f472$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($dc31f36873c2f472$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($dc31f36873c2f472$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(sync, []);
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc31f36873c2f472$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
const $dc31f36873c2f472$var$flushMessageQueue = ()=>{
    if (!$dc31f36873c2f472$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $dc31f36873c2f472$var$message = newMessage;
        // Delay render to avoid sync issue
        $dc31f36873c2f472$var$act(()=>{
            (0, $1960195940222379$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc31f36873c2f472$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $dc31f36873c2f472$var$flushMessageQueue();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$dc31f36873c2f472$var$message.instance) return;
    // >>> Execute task
    $dc31f36873c2f472$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $dc31f36873c2f472$var$act(()=>{
                    const closeFn = $dc31f36873c2f472$var$message.instance.open({
                        ...$dc31f36873c2f472$var$defaultGlobalConfig,
                        ...task.config
                    });
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $dc31f36873c2f472$var$act(()=>{
                    $dc31f36873c2f472$var$message?.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $dc31f36873c2f472$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $dc31f36873c2f472$var$message.instance)[type].apply(_message$instance, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(task.args));
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $dc31f36873c2f472$var$taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $dc31f36873c2f472$var$setMessageGlobalConfig(config) {
    $dc31f36873c2f472$var$defaultGlobalConfig = {
        ...$dc31f36873c2f472$var$defaultGlobalConfig,
        ...config
    };
    // Trigger sync for it
    $dc31f36873c2f472$var$act(()=>{
        $dc31f36873c2f472$var$message?.sync?.();
    });
}
function $dc31f36873c2f472$var$open(config) {
    const result = (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $dc31f36873c2f472$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $dc31f36873c2f472$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $dc31f36873c2f472$var$flushMessageQueue();
    return result;
}
function $dc31f36873c2f472$var$typeOpen(type, args) {
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const result = (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $dc31f36873c2f472$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $dc31f36873c2f472$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $dc31f36873c2f472$var$flushMessageQueue();
    return result;
}
const $dc31f36873c2f472$var$destroy = (key)=>{
    $dc31f36873c2f472$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $dc31f36873c2f472$var$flushMessageQueue();
};
const $dc31f36873c2f472$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $dc31f36873c2f472$var$baseStaticMethods = {
    open: $dc31f36873c2f472$var$open,
    destroy: $dc31f36873c2f472$var$destroy,
    config: $dc31f36873c2f472$var$setMessageGlobalConfig,
    useMessage: $279f9cad32c830f7$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $c9808e733d97ff6c$export$2e2bcd8739ae039)
};
const $dc31f36873c2f472$var$staticMethods = $dc31f36873c2f472$var$baseStaticMethods;
$dc31f36873c2f472$var$methods.forEach((type)=>{
    $dc31f36873c2f472$var$staticMethods[type] = (...args)=>$dc31f36873c2f472$var$typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $dc31f36873c2f472$var$noop = ()=>{};
let $dc31f36873c2f472$var$_actWrapper = $dc31f36873c2f472$var$noop;
var $dc31f36873c2f472$var$wrapper;
const $dc31f36873c2f472$export$71ceb3dabb09f455 = $dc31f36873c2f472$var$_actWrapper;
let $dc31f36873c2f472$var$_actDestroy = $dc31f36873c2f472$var$noop;
const $dc31f36873c2f472$export$43de32c50edff050 = $dc31f36873c2f472$var$_actDestroy;
var $dc31f36873c2f472$export$2e2bcd8739ae039 = $dc31f36873c2f472$var$staticMethods;



const $84e1b8326c7436ef$export$b38e76a98d8f246b = (logIds, onRecordSuccess)=>{
    const [isRecording, setIsRecording] = (0, $acw62.useState)(false);
    const recordMocks = async ()=>{
        setIsRecording(true);
        try {
            const { successCount: successCount, errors: errors } = await (0, $7fe116ddba5bf8b9$export$52e83573e7782585)({
                url: "mocks/",
                method: "POST",
                params: {
                    logIds: logIds
                }
            });
            if (successCount > 0) (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success(`${successCount} mock(s) has been written!`);
            if (errors.length > 0) errors.forEach((error)=>{
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Error: ${error}`);
            });
            onRecordSuccess && onRecordSuccess();
        } finally{
            setIsRecording(false);
        }
    };
    return {
        recordMocks: recordMocks,
        isRecording: isRecording
    };
};


const $b77a0514cbd10772$var$getStatusColor = (status)=>{
    if (status >= 400) return "error";
    if (status >= 200 && status <= 299) return "success";
    return "default";
};
const $b77a0514cbd10772$var$columns = [
    {
        title: "Response time",
        dataIndex: "responseTimestamp",
        key: "responseTimestamp",
        render: (timestamp)=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(timestamp).format("DD.MM.YYYY HH:mm:ss.SSS")
    },
    {
        title: "Status code",
        dataIndex: "status",
        key: "status",
        render: (status)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91f0876852f6510f$export$2e2bcd8739ae039), {
                color: $b77a0514cbd10772$var$getStatusColor(status),
                children: status
            })
    },
    {
        title: "Method",
        dataIndex: "method",
        key: "method"
    },
    {
        title: "Url",
        dataIndex: "url",
        key: "url",
        width: 500,
        render: (url)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    wordBreak: "break-all"
                },
                children: url
            })
    },
    {
        title: "Content-type",
        dataIndex: "contentType",
        key: "contentType"
    },
    {
        title: "Mode / Response source",
        dataIndex: "responseSource",
        key: "responseSource",
        render: (responseSource, { mode: mode })=>[
                mode,
                responseSource ?? "-"
            ].filter(Boolean).join(" / ")
    }
];
const $b77a0514cbd10772$export$1b055425e2a058ac = ()=>{
    const { requests: requests, onChangeSearch: onChangeSearch } = (0, $bdf8720a025ab42f$export$b8bc32887f2499dc)();
    const { isVisible: isVisible, onOpen: onOpen, onClose: onClose, requestDetails: requestDetails, loading: loading } = (0, $11193f6dfb7dcb2c$export$871738f270a673da)();
    const [selectedRowKeys, setSelectedRowKeys] = (0, $acw62.useState)([]);
    const hasSelected = selectedRowKeys.length > 0;
    const { recordMocks: recordMocks } = (0, $84e1b8326c7436ef$export$b38e76a98d8f246b)(selectedRowKeys, ()=>setSelectedRowKeys([]));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                    size: "small",
                    placeholder: "Search",
                    prefix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {}),
                    onChange: (e)=>{
                        onChangeSearch(e.target.value);
                    }
                })
            }),
            hasSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: 8,
                    marginBottom: 8
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    type: "primary",
                    onClick: recordMocks,
                    children: [
                        "Write mocks (",
                        selectedRowKeys.length,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                dataSource: requests,
                columns: $b77a0514cbd10772$var$columns,
                size: "small",
                rowSelection: {
                    type: "checkbox",
                    selectedRowKeys: selectedRowKeys,
                    onChange: setSelectedRowKeys
                },
                onRow: (record)=>{
                    return {
                        onClick: (event)=>{
                            // prevent open panel on text selection
                            if (!getSelection().toString() || !event.target.contains(getSelection().anchorNode)) onOpen(record.id);
                        }
                    };
                },
                pagination: false,
                rowKey: "id"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $847b541c620f2967$export$1ec22ccbfe26843b), {
                isVisible: isVisible,
                loading: loading,
                onClose: onClose,
                requestDetails: requestDetails
            })
        ]
    });
};



parcelRequire("acw62");
var $1776b37f98adf636$export$27bf1871c58e315;
$1776b37f98adf636$export$27bf1871c58e315 = `FdMyra_scenarioPage`;




var $acw62 = parcelRequire("acw62");

const $bac87fa2dc0c4433$export$3c4215773d304f18 = ()=>{
    const [scenarios, setScenarios] = (0, $acw62.useState)([]);
    const loadScenarios = async ()=>{
        const data = await (0, $7fe116ddba5bf8b9$export$52e83573e7782585)({
            url: "scenarios"
        });
        setScenarios(data.scenarios);
    };
    const saveScenarios = async (nextActiveScenarios)=>{
        try {
            await (0, $7fe116ddba5bf8b9$export$52e83573e7782585)({
                url: "scenarios",
                method: "PUT",
                params: nextActiveScenarios
            });
        } finally{
            loadScenarios();
        }
    };
    (0, $acw62.useEffect)(()=>{
        loadScenarios();
    }, []);
    const changeActiveScenarios = (nextActiveScenarios)=>{
        saveScenarios(nextActiveScenarios);
    };
    return {
        scenarios: scenarios,
        activeScenarios: scenarios.filter((scenario)=>scenario.active).map((scenario)=>scenario.id),
        changeActiveScenarios: changeActiveScenarios
    };
};


const $73ac090907c4318b$export$6c092d56b9e625a = ()=>{
    const { scenarios: scenarios, changeActiveScenarios: changeActiveScenarios, activeScenarios: activeScenarios } = (0, $bac87fa2dc0c4433$export$3c4215773d304f18)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $1776b37f98adf636$export$27bf1871c58e315,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Title, {
                level: 2,
                children: "Active scenarios"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039).Group, {
                value: activeScenarios,
                onChange: changeActiveScenarios,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    children: scenarios.map((scenario)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                            value: scenario.id,
                            children: scenario.id
                        }))
                })
            })
        ]
    });
};



const $a6e161b26238d317$var$items = [
    {
        label: "Requests",
        key: "requests"
    },
    {
        label: "Scenarios",
        key: "scenarios"
    }
];
const $a6e161b26238d317$var$pages = {
    requests: (0, $b77a0514cbd10772$export$1b055425e2a058ac),
    scenarios: (0, $73ac090907c4318b$export$6c092d56b9e625a)
};
const $a6e161b26238d317$export$86fbec116b87613f = ()=>{
    const [selectedPage, selectPage] = (0, $acw62.useState)("requests");
    const PageComponent = $a6e161b26238d317$var$pages[selectedPage];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49639f13efb591ba$export$2e2bcd8739ae039), {
        style: {
            minHeight: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49639f13efb591ba$export$2e2bcd8739ae039).Sider, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $47077f34c49bbd52$export$2e2bcd8739ae039), {
                    items: $a6e161b26238d317$var$items,
                    theme: "dark",
                    onClick: (event)=>selectPage(event.key),
                    selectedKeys: [
                        selectedPage
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49639f13efb591ba$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49639f13efb591ba$export$2e2bcd8739ae039).Content, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PageComponent, {})
                })
            })
        ]
    });
};


const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)(document.getElementById("root"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6e161b26238d317$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=client.5454e9a3.js.map
